import type { PartnerAddressV2, PartnerContact, PartnerTenant } from '@shipium-corp/shipium-ts-types';
import type { FulfillmentContext } from './types';

// Address/contact assets surfaced for the carrier-account asset pickers in mock mode.
export const addresses: PartnerAddressV2[] = [
  {
    active: true,
    addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
    archived: false,
    description: ' ',
    location: {
      address1: '297 State Street',
      address2: 'Building 1',
      city: 'North Haven',
      companyName: 'Stord BDL1',
      country: 'US',
      postalCode: '06473',
      region: 'CT',
    },
    name: 'Stord BDL1',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    tagIds: [],
  } as unknown as PartnerAddressV2,
];

export const contacts: PartnerContact[] = [
  {
    active: true,
    archived: false,
    contactId: '900ae450-da15-4588-8655-b427e62ccfb1',
    contactName: 'Shipping Department',
    description: '',
    email: 'sales@stord.com',
    name: 'Shipping Department',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    phoneNumber: '8337002025',
    tagIds: [],
  } as unknown as PartnerContact,
];

export const tenants: PartnerTenant[] = [
  {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      creationTimeStamp: '2022-10-07T15:35:42.503Z',
      lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      lastUpdatedTimeStamp: '2023-03-01T21:24:46.603Z',
      version: 7,
    },
    description: 'n/a',
    links: {
      fulfillmentContexts: [
        {
          shipiumId: '588cd660-e340-4946-a770-19e6a9533055',
        },
        {
          shipiumId: '1b28d2ad-c572-4715-93bd-c3e98578b64f',
        },
      ],
    },
    name: 'Fur',
    originInfoMap: {},
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    partnerProvidedId: '7c2bedc6-d011-47a3-a3bd-ddd434a284e2',
    tagIds: [],
    taxIdentificationNumber: '46-5356866',
    tenantId: '11c7cb50-5b4f-4920-8821-a82883573ea6',
    unitedStatesPrincipalPartyInInterestAddressId: 'a2c7663d-fe3e-488f-8847-fd6f9489b46a',
    unitedStatesPrincipalPartyInInterestContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
    urn: 'urn:tenant:11c7cb50-5b4f-4920-8821-a82883573ea6:7',
  },
  {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      creationTimeStamp: '2022-09-14T23:59:28.106Z',
      lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      lastUpdatedTimeStamp: '2023-01-18T18:56:09.641Z',
      version: 4,
    },
    description: 'n/a',
    links: {
      labelAugmentations: [
        {
          shipiumId: 'c562fd7e-9e25-45ee-8c6a-fe48945847b4',
        },
      ],
    },
    name: 'Swag Store',
    originInfoMap: {},
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    partnerProvidedId: '6928e582-fc67-4829-82eb-3272598d4818',
    tagIds: [],
    tenantId: '8180e3b8-63c8-4ae4-9065-68b95d1e68ba',
    unitedStatesPrincipalPartyInInterestAddressId: 'a17db11f-bd32-46b7-80aa-3d593a154700',
    unitedStatesPrincipalPartyInInterestContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
    urn: 'urn:tenant:8180e3b8-63c8-4ae4-9065-68b95d1e68ba:4',
  },
  {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      creationTimeStamp: '2023-01-02T23:10:27.083Z',
      lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      lastUpdatedTimeStamp: '2023-01-10T20:41:21.786Z',
      version: 9,
    },
    description: 'n/a',
    links: {},
    name: 'Goodr (B2B)',
    originInfoMap: {
      'e6f7def5-a833-4bff-ab27-971b681a9c85': {
        originId: 'e6f7def5-a833-4bff-ab27-971b681a9c85',
        returnToAddressId: '65c6ecb2-eee6-4cb7-ab67-59fdb2355c9b',
        returnToContactId: '770a8034-28af-4382-827c-0cee7268cdcb',
      },
    },
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    partnerProvidedId: ' a2be3711-f5f0-4a4e-ad81-b64721ca37b8',
    tagIds: [],
    tenantId: 'af25a45b-4916-4a68-a8a6-c1070ec51026',
    unitedStatesPrincipalPartyInInterestAddressId: 'a17db11f-bd32-46b7-80aa-3d593a154700',
    unitedStatesPrincipalPartyInInterestContactId: '770a8034-28af-4382-827c-0cee7268cdcb',
    urn: 'urn:tenant:af25a45b-4916-4a68-a8a6-c1070ec51026:9',
  },
];

export const fulfillmentContexts: FulfillmentContext[] = [
  {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      creationTimeStamp: '2022-12-08T22:11:23.767Z',
      lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      lastUpdatedTimeStamp: '2022-12-08T22:11:24.611Z',
      version: 6,
    },
    contractIds: ['58fdd6a4-6fbc-4686-9b88-5d46b91e10e0', '4c7e9267-d371-48c7-a661-c83e4a9881bf'],
    description: '',
    fulfillmentContextId: '940aaa31-70b8-4b58-950b-86de58a7658d',
    fulfillmentType: 'customer',
    injectionProfileIds: [],
    labelPropertiesId: '6d83783b-093c-450b-afb9-1371c16bbdbe',
    name: 'Fifty Foods',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    tagIds: ['1f6c846e-2be5-4bb9-8b34-9b60f247db63'],
    urn: 'urn:fulfillmentContext:940aaa31-70b8-4b58-950b-86de58a7658d:6',
  },
  {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '235c0c84-172b-4dec-a1d5-074221c6e798',
      creationTimeStamp: '2022-12-20T18:57:05.582Z',
      lastUpdatedBy: '235c0c84-172b-4dec-a1d5-074221c6e798',
      lastUpdatedTimeStamp: '2022-12-22T17:49:07.985Z',
      version: 12,
    },
    contractIds: ['0777f3a1-2def-405e-bf2f-2fdb157a99e0', '4c3fdad1-c00b-4f99-8d57-48c25c9ff321'],
    description: '',
    fulfillmentContextId: '5c19b1c5-a044-4914-b6e5-7ce253d303df',
    fulfillmentType: 'customer',
    injectionProfileIds: [],
    labelPropertiesId: '6d83783b-093c-450b-afb9-1371c16bbdbe',
    name: 'PillowTalk Derm',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    tagIds: ['db0a308a-1aac-4676-8c6e-c3054373cf62'],
    urn: 'urn:fulfillmentContext:5c19b1c5-a044-4914-b6e5-7ce253d303df:12',
  },
  {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '235c0c84-172b-4dec-a1d5-074221c6e798',
      creationTimeStamp: '2022-12-22T16:33:44.464Z',
      lastUpdatedBy: '235c0c84-172b-4dec-a1d5-074221c6e798',
      lastUpdatedTimeStamp: '2022-12-22T16:33:44.891Z',
      version: 5,
    },
    contractIds: ['0ddfbc46-4bc9-48ae-a227-d0571ba043d7'],
    description: '',
    fulfillmentContextId: '27ddc965-4d93-4cd9-9553-c2c2056130be',
    fulfillmentType: 'customer',
    injectionProfileIds: [],
    labelPropertiesId: '6d83783b-093c-450b-afb9-1371c16bbdbe',
    name: 'Believe Diapers Network',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    tagIds: ['ef35c6f0-c1a5-4f46-8f94-6682e1c0ef73'],
    urn: 'urn:fulfillmentContext:27ddc965-4d93-4cd9-9553-c2c2056130be:5',
  },
  {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      creationTimeStamp: '2022-10-25T21:49:14.039Z',
      lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      lastUpdatedTimeStamp: '2023-03-01T21:23:58.012Z',
      version: 15,
    },
    contractIds: [
      '9b3c05e1-f6c1-488c-9e41-4a27011f4789',
      '5e3ea3e5-fe7c-46ed-9734-c8bfb7d4cfdc',
      'eed81b0d-99cc-4db9-8695-dac2c8a45bf6',
      '7287c628-b240-4ac7-ae03-3e9410c9a529',
      '9879fda6-5ab2-486e-809e-c963e11f7d1f',
      '493ae0c8-6fa7-4398-ac1b-22d4ea16e0c6',
    ],
    description: '',
    fulfillmentContextId: '1b28d2ad-c572-4715-93bd-c3e98578b64f',
    fulfillmentType: 'customer',
    injectionProfileIds: [],
    labelPropertiesId: '6d83783b-093c-450b-afb9-1371c16bbdbe',
    name: 'Fur (BDL1)',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    tagIds: ['8eb4d3d1-c295-4011-9e03-de948ddfa6a4'],
    urn: 'urn:fulfillmentContext:1b28d2ad-c572-4715-93bd-c3e98578b64f:15',
  },
];

export const fulfillmentContextDetail: any = {
  augmentations: [],
  contracts: [
    {
      carrierAccount: {
        carrierAccount: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-07-27T20:51:03.59Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2022-07-27T20:52:50.816Z',
            version: 5,
          },
          carrierAccountId: '3eb292e7-2997-44e3-91e8-09cb20d1726b',
          carrierId: 'ups',
          credentials: {
            credentialStructureId: 'ups-standard-credentials',
            credentials: {
              'ups-account-number': 'V6143V',
            },
          },
          description: '',
          name: 'UPS Account (CT)',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          returnToAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          returnToContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
          unitedStatesPrincipalPartyInInterestAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          unitedStatesPrincipalPartyInInterestContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
          serviceMethodCredentials: [],
          tagIds: [],
          urn: 'urn:carrierAccount:3eb292e7-2997-44e3-91e8-09cb20d1726b:5',
        },
        returnToAddress: {
          address: {
            active: true,
            addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-06-09T16:52:57.568Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
              version: 1,
            },
            description: ' ',
            location: {
              address1: '297 State Street',
              address2: 'Building 1',
              city: 'North Haven',
              companyName: 'Stord BDL1',
              country: 'US',
              postalCode: '06473',
              region: 'CT',
              validatedAddressMetadata: {
                latitude: 41.38069,
                longitude: -72.85601,
                timeZoneId: 'America/New_York',
              },
            },
            name: 'Stord BDL1',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            tagIds: [],
            urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
          },
          tags: [],
        },
        returnToContact: {
          contact: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              creationTimeStamp: '2022-05-10T01:13:39.191Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-09-14T23:44:14.372Z',
              version: 7,
            },
            contactId: '900ae450-da15-4588-8655-b427e62ccfb1',
            contactName: 'Shipping Department ',
            description: '',
            email: 'sales@stord.com',
            name: 'Shipping Department ',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            phoneNumber: '8337002025',
            tagIds: [],
            urn: 'urn:contact:900ae450-da15-4588-8655-b427e62ccfb1:7',
          },
          tags: [],
        },
        tags: [],
      },
      carrierRates: [
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '1e49a039-5266-499e-bb23-b8dd97dc07be',
              creationTimeStamp: '2022-07-26T14:38:02.149Z',
              lastUpdatedBy: 'd6bf88b3-3748-48c7-85f5-4a55ac15c54f',
              lastUpdatedTimeStamp: '2023-01-25T22:44:46.419Z',
              version: 8,
            },
            carrier: 'ups',
            carrierRateId: 'fccececb-ff36-4f9b-be7f-9e0bb12440c7',
            carrierServiceMethodId: 'ups-surepost-service-method',
            description: '',
            destinationType: 'residential',
            dimWeightOverride: {},
            name: 'UPS SurePost',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2023-07-31T13:36:30.084Z',
                negotiatedSurcharges: [
                  {
                    modifierType: 'replacement',
                    modifierValue: 2.55,
                    name: 'DAS',
                    surchargeId: 'extended_delivery_residential_ground',
                  },
                ],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'ups-zone-2': 5.45,
                      'ups-zone-3': 5.45,
                      'ups-zone-4': 5.45,
                      'ups-zone-5': 5.58,
                      'ups-zone-6': 5.76,
                      'ups-zone-7': 5.83,
                      'ups-zone-8': 5.92,
                      'ups-zone-9': 10.14,
                      'ups-zone-10': 10.14,
                      'ups-zone-11': 10.14,
                      'ups-zone-12': 10.14,
                      'ups-zone-13': 8.62,
                    },
                    '2': {
                      'ups-zone-2': 5.45,
                      'ups-zone-3': 5.65,
                      'ups-zone-4': 6.09,
                      'ups-zone-5': 6.22,
                      'ups-zone-6': 6.48,
                      'ups-zone-7': 6.71,
                      'ups-zone-8': 6.83,
                      'ups-zone-9': 11.99,
                      'ups-zone-10': 11.99,
                      'ups-zone-11': 11.99,
                      'ups-zone-12': 11.99,
                      'ups-zone-13': 10.19,
                    },
                    '3': {
                      'ups-zone-2': 5.45,
                      'ups-zone-3': 5.94,
                      'ups-zone-4': 6.41,
                      'ups-zone-5': 6.66,
                      'ups-zone-6': 6.92,
                      'ups-zone-7': 7.15,
                      'ups-zone-8': 7.49,
                      'ups-zone-9': 13.57,
                      'ups-zone-10': 13.57,
                      'ups-zone-11': 13.57,
                      'ups-zone-12': 13.57,
                      'ups-zone-13': 11.53,
                    },
                    '4': {
                      'ups-zone-2': 5.49,
                      'ups-zone-3': 5.97,
                      'ups-zone-4': 6.6,
                      'ups-zone-5': 7.01,
                      'ups-zone-6': 7.2,
                      'ups-zone-7': 7.66,
                      'ups-zone-8': 8.01,
                      'ups-zone-9': 14.56,
                      'ups-zone-10': 14.56,
                      'ups-zone-11': 14.56,
                      'ups-zone-12': 14.56,
                      'ups-zone-13': 12.37,
                    },
                    '5': {
                      'ups-zone-2': 5.63,
                      'ups-zone-3': 6.24,
                      'ups-zone-4': 6.82,
                      'ups-zone-5': 7.32,
                      'ups-zone-6': 7.61,
                      'ups-zone-7': 8.0,
                      'ups-zone-8': 8.47,
                      'ups-zone-9': 15.34,
                      'ups-zone-10': 15.34,
                      'ups-zone-11': 15.34,
                      'ups-zone-12': 15.34,
                      'ups-zone-13': 13.04,
                    },
                    '6': {
                      'ups-zone-2': 5.68,
                      'ups-zone-3': 6.26,
                      'ups-zone-4': 6.83,
                      'ups-zone-5': 7.35,
                      'ups-zone-6': 7.62,
                      'ups-zone-7': 8.02,
                      'ups-zone-8': 8.48,
                      'ups-zone-9': 16.4,
                      'ups-zone-10': 16.4,
                      'ups-zone-11': 16.4,
                      'ups-zone-12': 16.4,
                      'ups-zone-13': 13.94,
                    },
                    '7': {
                      'ups-zone-2': 5.99,
                      'ups-zone-3': 6.4,
                      'ups-zone-4': 7.0,
                      'ups-zone-5': 7.58,
                      'ups-zone-6': 7.75,
                      'ups-zone-7': 8.22,
                      'ups-zone-8': 8.79,
                      'ups-zone-9': 18.78,
                      'ups-zone-10': 18.78,
                      'ups-zone-11': 18.78,
                      'ups-zone-12': 18.78,
                      'ups-zone-13': 15.96,
                    },
                    '8': {
                      'ups-zone-2': 6.16,
                      'ups-zone-3': 6.63,
                      'ups-zone-4': 7.24,
                      'ups-zone-5': 7.79,
                      'ups-zone-6': 8.05,
                      'ups-zone-7': 8.55,
                      'ups-zone-8': 9.16,
                      'ups-zone-9': 20.05,
                      'ups-zone-10': 20.05,
                      'ups-zone-11': 20.05,
                      'ups-zone-12': 20.05,
                      'ups-zone-13': 17.04,
                    },
                    '9': {
                      'ups-zone-2': 6.25,
                      'ups-zone-3': 6.71,
                      'ups-zone-4': 7.33,
                      'ups-zone-5': 7.86,
                      'ups-zone-6': 8.22,
                      'ups-zone-7': 8.89,
                      'ups-zone-8': 9.64,
                      'ups-zone-9': 21.14,
                      'ups-zone-10': 21.14,
                      'ups-zone-11': 21.14,
                      'ups-zone-12': 21.14,
                      'ups-zone-13': 17.96,
                    },
                    '10': {
                      'ups-zone-2': 14.57,
                      'ups-zone-3': 15.63,
                      'ups-zone-4': 17.12,
                      'ups-zone-5': 18.63,
                      'ups-zone-6': 19.29,
                      'ups-zone-7': 21.65,
                      'ups-zone-8': 23.92,
                      'ups-zone-9': 40.61,
                      'ups-zone-10': 40.61,
                      'ups-zone-11': 40.61,
                      'ups-zone-12': 40.61,
                      'ups-zone-13': 34.52,
                    },
                    '11': {
                      'ups-zone-2': 15.22,
                      'ups-zone-3': 15.85,
                      'ups-zone-4': 17.37,
                      'ups-zone-5': 18.66,
                      'ups-zone-6': 19.8,
                      'ups-zone-7': 23.3,
                      'ups-zone-8': 25.32,
                      'ups-zone-9': 43.43,
                      'ups-zone-10': 43.43,
                      'ups-zone-11': 43.43,
                      'ups-zone-12': 43.43,
                      'ups-zone-13': 36.92,
                    },
                    '12': {
                      'ups-zone-2': 15.49,
                      'ups-zone-3': 16.53,
                      'ups-zone-4': 17.54,
                      'ups-zone-5': 18.93,
                      'ups-zone-6': 20.49,
                      'ups-zone-7': 24.23,
                      'ups-zone-8': 26.5,
                      'ups-zone-9': 46.61,
                      'ups-zone-10': 46.61,
                      'ups-zone-11': 46.61,
                      'ups-zone-12': 46.61,
                      'ups-zone-13': 39.62,
                    },
                    '13': {
                      'ups-zone-2': 15.55,
                      'ups-zone-3': 16.6,
                      'ups-zone-4': 17.75,
                      'ups-zone-5': 19.29,
                      'ups-zone-6': 21.13,
                      'ups-zone-7': 25.82,
                      'ups-zone-8': 27.8,
                      'ups-zone-9': 49.8,
                      'ups-zone-10': 49.8,
                      'ups-zone-11': 49.8,
                      'ups-zone-12': 49.8,
                      'ups-zone-13': 42.33,
                    },
                    '14': {
                      'ups-zone-2': 16.11,
                      'ups-zone-3': 17.05,
                      'ups-zone-4': 17.92,
                      'ups-zone-5': 19.77,
                      'ups-zone-6': 22.36,
                      'ups-zone-7': 27.55,
                      'ups-zone-8': 30.07,
                      'ups-zone-9': 53.0,
                      'ups-zone-10': 53.0,
                      'ups-zone-11': 53.0,
                      'ups-zone-12': 53.0,
                      'ups-zone-13': 45.05,
                    },
                    '15': {
                      'ups-zone-2': 16.13,
                      'ups-zone-3': 17.41,
                      'ups-zone-4': 18.18,
                      'ups-zone-5': 20.47,
                      'ups-zone-6': 23.6,
                      'ups-zone-7': 28.42,
                      'ups-zone-8': 31.47,
                      'ups-zone-9': 56.15,
                      'ups-zone-10': 56.15,
                      'ups-zone-11': 56.15,
                      'ups-zone-12': 56.15,
                      'ups-zone-13': 47.73,
                    },
                    '16': {
                      'ups-zone-2': 16.54,
                      'ups-zone-3': 17.91,
                      'ups-zone-4': 18.5,
                      'ups-zone-5': 20.82,
                      'ups-zone-6': 24.37,
                      'ups-zone-7': 29.9,
                      'ups-zone-8': 32.85,
                      'ups-zone-9': 58.82,
                      'ups-zone-10': 58.82,
                      'ups-zone-11': 58.82,
                      'ups-zone-12': 58.82,
                      'ups-zone-13': 50.0,
                    },
                    '17': {
                      'ups-zone-2': 16.65,
                      'ups-zone-3': 18.27,
                      'ups-zone-4': 18.71,
                      'ups-zone-5': 21.4,
                      'ups-zone-6': 25.39,
                      'ups-zone-7': 31.43,
                      'ups-zone-8': 33.33,
                      'ups-zone-9': 61.73,
                      'ups-zone-10': 61.73,
                      'ups-zone-11': 61.73,
                      'ups-zone-12': 61.73,
                      'ups-zone-13': 52.47,
                    },
                    '18': {
                      'ups-zone-2': 16.83,
                      'ups-zone-3': 18.56,
                      'ups-zone-4': 18.91,
                      'ups-zone-5': 22.43,
                      'ups-zone-6': 26.72,
                      'ups-zone-7': 32.37,
                      'ups-zone-8': 35.62,
                      'ups-zone-9': 64.86,
                      'ups-zone-10': 64.86,
                      'ups-zone-11': 64.86,
                      'ups-zone-12': 64.86,
                      'ups-zone-13': 55.13,
                    },
                    '19': {
                      'ups-zone-2': 17.25,
                      'ups-zone-3': 19.39,
                      'ups-zone-4': 19.86,
                      'ups-zone-5': 23.41,
                      'ups-zone-6': 27.41,
                      'ups-zone-7': 33.26,
                      'ups-zone-8': 37.08,
                      'ups-zone-9': 67.97,
                      'ups-zone-10': 67.97,
                      'ups-zone-11': 67.97,
                      'ups-zone-12': 67.97,
                      'ups-zone-13': 57.77,
                    },
                    '20': {
                      'ups-zone-2': 17.38,
                      'ups-zone-3': 19.55,
                      'ups-zone-4': 19.97,
                      'ups-zone-5': 24.33,
                      'ups-zone-6': 28.35,
                      'ups-zone-7': 34.49,
                      'ups-zone-8': 38.7,
                      'ups-zone-9': 71.17,
                      'ups-zone-10': 71.17,
                      'ups-zone-11': 71.17,
                      'ups-zone-12': 71.17,
                      'ups-zone-13': 60.49,
                    },
                    '21': {
                      'ups-zone-2': 18.01,
                      'ups-zone-3': 20.32,
                      'ups-zone-4': 21.03,
                      'ups-zone-5': 24.62,
                      'ups-zone-6': 29.44,
                      'ups-zone-7': 35.71,
                      'ups-zone-8': 39.88,
                      'ups-zone-9': 74.15,
                      'ups-zone-10': 74.15,
                      'ups-zone-11': 74.15,
                      'ups-zone-12': 74.15,
                      'ups-zone-13': 63.03,
                    },
                    '22': {
                      'ups-zone-2': 18.07,
                      'ups-zone-3': 20.51,
                      'ups-zone-4': 21.61,
                      'ups-zone-5': 25.47,
                      'ups-zone-6': 30.64,
                      'ups-zone-7': 37.03,
                      'ups-zone-8': 41.62,
                      'ups-zone-9': 77.36,
                      'ups-zone-10': 77.36,
                      'ups-zone-11': 77.36,
                      'ups-zone-12': 77.36,
                      'ups-zone-13': 65.76,
                    },
                    '23': {
                      'ups-zone-2': 18.14,
                      'ups-zone-3': 20.91,
                      'ups-zone-4': 22.23,
                      'ups-zone-5': 26.2,
                      'ups-zone-6': 32.11,
                      'ups-zone-7': 38.27,
                      'ups-zone-8': 43.27,
                      'ups-zone-9': 80.53,
                      'ups-zone-10': 80.53,
                      'ups-zone-11': 80.53,
                      'ups-zone-12': 80.53,
                      'ups-zone-13': 68.46,
                    },
                    '24': {
                      'ups-zone-2': 18.63,
                      'ups-zone-3': 21.75,
                      'ups-zone-4': 23.22,
                      'ups-zone-5': 27.33,
                      'ups-zone-6': 33.31,
                      'ups-zone-7': 39.19,
                      'ups-zone-8': 45.75,
                      'ups-zone-9': 83.66,
                      'ups-zone-10': 83.66,
                      'ups-zone-11': 83.66,
                      'ups-zone-12': 83.66,
                      'ups-zone-13': 71.11,
                    },
                    '25': {
                      'ups-zone-2': 18.84,
                      'ups-zone-3': 21.99,
                      'ups-zone-4': 23.51,
                      'ups-zone-5': 27.88,
                      'ups-zone-6': 33.9,
                      'ups-zone-7': 40.88,
                      'ups-zone-8': 46.65,
                      'ups-zone-9': 86.75,
                      'ups-zone-10': 86.75,
                      'ups-zone-11': 86.75,
                      'ups-zone-12': 86.75,
                      'ups-zone-13': 73.74,
                    },
                    '26': {
                      'ups-zone-2': 19.74,
                      'ups-zone-3': 22.75,
                      'ups-zone-4': 24.48,
                      'ups-zone-5': 29.02,
                      'ups-zone-6': 35.14,
                      'ups-zone-7': 42.56,
                      'ups-zone-8': 48.56,
                      'ups-zone-9': 89.88,
                      'ups-zone-10': 89.88,
                      'ups-zone-11': 89.88,
                      'ups-zone-12': 89.88,
                      'ups-zone-13': 76.4,
                    },
                    '27': {
                      'ups-zone-2': 20.22,
                      'ups-zone-3': 23.3,
                      'ups-zone-4': 24.74,
                      'ups-zone-5': 29.5,
                      'ups-zone-6': 36.55,
                      'ups-zone-7': 43.34,
                      'ups-zone-8': 49.38,
                      'ups-zone-9': 93.03,
                      'ups-zone-10': 93.03,
                      'ups-zone-11': 93.03,
                      'ups-zone-12': 93.03,
                      'ups-zone-13': 79.07,
                    },
                    '28': {
                      'ups-zone-2': 20.76,
                      'ups-zone-3': 23.85,
                      'ups-zone-4': 26.12,
                      'ups-zone-5': 31.41,
                      'ups-zone-6': 38.33,
                      'ups-zone-7': 45.3,
                      'ups-zone-8': 51.75,
                      'ups-zone-9': 96.28,
                      'ups-zone-10': 96.28,
                      'ups-zone-11': 96.28,
                      'ups-zone-12': 96.28,
                      'ups-zone-13': 81.84,
                    },
                    '29': {
                      'ups-zone-2': 20.82,
                      'ups-zone-3': 24.31,
                      'ups-zone-4': 26.55,
                      'ups-zone-5': 31.46,
                      'ups-zone-6': 39.43,
                      'ups-zone-7': 46.75,
                      'ups-zone-8': 52.64,
                      'ups-zone-9': 99.54,
                      'ups-zone-10': 99.54,
                      'ups-zone-11': 99.54,
                      'ups-zone-12': 99.54,
                      'ups-zone-13': 84.61,
                    },
                    '30': {
                      'ups-zone-2': 21.17,
                      'ups-zone-3': 24.9,
                      'ups-zone-4': 27.56,
                      'ups-zone-5': 32.71,
                      'ups-zone-6': 40.06,
                      'ups-zone-7': 46.98,
                      'ups-zone-8': 54.83,
                      'ups-zone-9': 102.71,
                      'ups-zone-10': 102.71,
                      'ups-zone-11': 102.71,
                      'ups-zone-12': 102.71,
                      'ups-zone-13': 87.31,
                    },
                    '31': {
                      'ups-zone-2': 21.96,
                      'ups-zone-3': 25.48,
                      'ups-zone-4': 27.96,
                      'ups-zone-5': 32.93,
                      'ups-zone-6': 41.03,
                      'ups-zone-7': 48.28,
                      'ups-zone-8': 56.57,
                      'ups-zone-9': 105.81,
                      'ups-zone-10': 105.81,
                      'ups-zone-11': 105.81,
                      'ups-zone-12': 105.81,
                      'ups-zone-13': 89.94,
                    },
                    '32': {
                      'ups-zone-2': 21.97,
                      'ups-zone-3': 25.5,
                      'ups-zone-4': 27.97,
                      'ups-zone-5': 32.94,
                      'ups-zone-6': 41.24,
                      'ups-zone-7': 48.29,
                      'ups-zone-8': 57.74,
                      'ups-zone-9': 109.02,
                      'ups-zone-10': 109.02,
                      'ups-zone-11': 109.02,
                      'ups-zone-12': 109.02,
                      'ups-zone-13': 92.66,
                    },
                    '33': {
                      'ups-zone-2': 22.1,
                      'ups-zone-3': 25.87,
                      'ups-zone-4': 29.23,
                      'ups-zone-5': 34.5,
                      'ups-zone-6': 43.59,
                      'ups-zone-7': 49.89,
                      'ups-zone-8': 58.74,
                      'ups-zone-9': 112.09,
                      'ups-zone-10': 112.09,
                      'ups-zone-11': 112.09,
                      'ups-zone-12': 112.09,
                      'ups-zone-13': 95.28,
                    },
                    '34': {
                      'ups-zone-2': 22.23,
                      'ups-zone-3': 26.46,
                      'ups-zone-4': 30.16,
                      'ups-zone-5': 35.71,
                      'ups-zone-6': 43.94,
                      'ups-zone-7': 51.37,
                      'ups-zone-8': 61.56,
                      'ups-zone-9': 115.23,
                      'ups-zone-10': 115.23,
                      'ups-zone-11': 115.23,
                      'ups-zone-12': 115.23,
                      'ups-zone-13': 97.95,
                    },
                    '35': {
                      'ups-zone-2': 22.64,
                      'ups-zone-3': 27.86,
                      'ups-zone-4': 30.86,
                      'ups-zone-5': 36.57,
                      'ups-zone-6': 44.6,
                      'ups-zone-7': 52.7,
                      'ups-zone-8': 62.58,
                      'ups-zone-9': 118.23,
                      'ups-zone-10': 118.23,
                      'ups-zone-11': 118.23,
                      'ups-zone-12': 118.23,
                      'ups-zone-13': 100.5,
                    },
                    '36': {
                      'ups-zone-2': 22.99,
                      'ups-zone-3': 27.87,
                      'ups-zone-4': 31.41,
                      'ups-zone-5': 37.68,
                      'ups-zone-6': 46.46,
                      'ups-zone-7': 54.49,
                      'ups-zone-8': 64.44,
                      'ups-zone-9': 121.03,
                      'ups-zone-10': 121.03,
                      'ups-zone-11': 121.03,
                      'ups-zone-12': 121.03,
                      'ups-zone-13': 102.88,
                    },
                    '37': {
                      'ups-zone-2': 23.33,
                      'ups-zone-3': 28.22,
                      'ups-zone-4': 31.89,
                      'ups-zone-5': 38.49,
                      'ups-zone-6': 46.67,
                      'ups-zone-7': 56.24,
                      'ups-zone-8': 65.06,
                      'ups-zone-9': 123.35,
                      'ups-zone-10': 123.35,
                      'ups-zone-11': 123.35,
                      'ups-zone-12': 123.35,
                      'ups-zone-13': 104.85,
                    },
                    '38': {
                      'ups-zone-2': 23.68,
                      'ups-zone-3': 28.67,
                      'ups-zone-4': 32.74,
                      'ups-zone-5': 39.43,
                      'ups-zone-6': 47.73,
                      'ups-zone-7': 57.0,
                      'ups-zone-8': 66.28,
                      'ups-zone-9': 125.71,
                      'ups-zone-10': 125.71,
                      'ups-zone-11': 125.71,
                      'ups-zone-12': 125.71,
                      'ups-zone-13': 106.86,
                    },
                    '39': {
                      'ups-zone-2': 24.48,
                      'ups-zone-3': 29.78,
                      'ups-zone-4': 33.82,
                      'ups-zone-5': 40.43,
                      'ups-zone-6': 49.62,
                      'ups-zone-7': 58.69,
                      'ups-zone-8': 67.64,
                      'ups-zone-9': 127.99,
                      'ups-zone-10': 127.99,
                      'ups-zone-11': 127.99,
                      'ups-zone-12': 127.99,
                      'ups-zone-13': 108.79,
                    },
                    '40': {
                      'ups-zone-2': 24.49,
                      'ups-zone-3': 29.91,
                      'ups-zone-4': 33.92,
                      'ups-zone-5': 40.5,
                      'ups-zone-6': 49.96,
                      'ups-zone-7': 58.7,
                      'ups-zone-8': 68.11,
                      'ups-zone-9': 130.3,
                      'ups-zone-10': 130.3,
                      'ups-zone-11': 130.3,
                      'ups-zone-12': 130.3,
                      'ups-zone-13': 110.75,
                    },
                    '41': {
                      'ups-zone-2': 24.81,
                      'ups-zone-3': 30.89,
                      'ups-zone-4': 34.82,
                      'ups-zone-5': 41.89,
                      'ups-zone-6': 51.75,
                      'ups-zone-7': 60.51,
                      'ups-zone-8': 70.21,
                      'ups-zone-9': 132.65,
                      'ups-zone-10': 132.65,
                      'ups-zone-11': 132.65,
                      'ups-zone-12': 132.65,
                      'ups-zone-13': 112.75,
                    },
                    '42': {
                      'ups-zone-2': 24.97,
                      'ups-zone-3': 31.29,
                      'ups-zone-4': 36.17,
                      'ups-zone-5': 42.01,
                      'ups-zone-6': 52.27,
                      'ups-zone-7': 61.54,
                      'ups-zone-8': 70.57,
                      'ups-zone-9': 134.96,
                      'ups-zone-10': 134.96,
                      'ups-zone-11': 134.96,
                      'ups-zone-12': 134.96,
                      'ups-zone-13': 114.72,
                    },
                    '43': {
                      'ups-zone-2': 25.53,
                      'ups-zone-3': 31.75,
                      'ups-zone-4': 36.22,
                      'ups-zone-5': 44.15,
                      'ups-zone-6': 54.8,
                      'ups-zone-7': 63.77,
                      'ups-zone-8': 72.48,
                      'ups-zone-9': 137.31,
                      'ups-zone-10': 137.31,
                      'ups-zone-11': 137.31,
                      'ups-zone-12': 137.31,
                      'ups-zone-13': 116.72,
                    },
                    '44': {
                      'ups-zone-2': 25.89,
                      'ups-zone-3': 32.23,
                      'ups-zone-4': 37.14,
                      'ups-zone-5': 44.93,
                      'ups-zone-6': 55.28,
                      'ups-zone-7': 65.39,
                      'ups-zone-8': 73.24,
                      'ups-zone-9': 139.6,
                      'ups-zone-10': 139.6,
                      'ups-zone-11': 139.6,
                      'ups-zone-12': 139.6,
                      'ups-zone-13': 118.66,
                    },
                    '45': {
                      'ups-zone-2': 25.92,
                      'ups-zone-3': 32.24,
                      'ups-zone-4': 37.15,
                      'ups-zone-5': 44.95,
                      'ups-zone-6': 55.44,
                      'ups-zone-7': 67.05,
                      'ups-zone-8': 73.76,
                      'ups-zone-9': 141.89,
                      'ups-zone-10': 141.89,
                      'ups-zone-11': 141.89,
                      'ups-zone-12': 141.89,
                      'ups-zone-13': 120.61,
                    },
                    '46': {
                      'ups-zone-2': 26.49,
                      'ups-zone-3': 32.58,
                      'ups-zone-4': 38.35,
                      'ups-zone-5': 46.04,
                      'ups-zone-6': 56.91,
                      'ups-zone-7': 67.76,
                      'ups-zone-8': 75.72,
                      'ups-zone-9': 144.21,
                      'ups-zone-10': 144.21,
                      'ups-zone-11': 144.21,
                      'ups-zone-12': 144.21,
                      'ups-zone-13': 122.57,
                    },
                    '47': {
                      'ups-zone-2': 26.6,
                      'ups-zone-3': 33.0,
                      'ups-zone-4': 38.97,
                      'ups-zone-5': 46.37,
                      'ups-zone-6': 57.68,
                      'ups-zone-7': 69.07,
                      'ups-zone-8': 76.93,
                      'ups-zone-9': 146.56,
                      'ups-zone-10': 146.56,
                      'ups-zone-11': 146.56,
                      'ups-zone-12': 146.56,
                      'ups-zone-13': 124.57,
                    },
                    '48': {
                      'ups-zone-2': 26.62,
                      'ups-zone-3': 33.23,
                      'ups-zone-4': 39.35,
                      'ups-zone-5': 47.8,
                      'ups-zone-6': 58.54,
                      'ups-zone-7': 69.71,
                      'ups-zone-8': 78.15,
                      'ups-zone-9': 148.88,
                      'ups-zone-10': 148.88,
                      'ups-zone-11': 148.88,
                      'ups-zone-12': 148.88,
                      'ups-zone-13': 126.55,
                    },
                    '49': {
                      'ups-zone-2': 26.63,
                      'ups-zone-3': 33.25,
                      'ups-zone-4': 39.44,
                      'ups-zone-5': 47.82,
                      'ups-zone-6': 58.98,
                      'ups-zone-7': 71.11,
                      'ups-zone-8': 78.62,
                      'ups-zone-9': 151.19,
                      'ups-zone-10': 151.19,
                      'ups-zone-11': 151.19,
                      'ups-zone-12': 151.19,
                      'ups-zone-13': 128.52,
                    },
                    '50': {
                      'ups-zone-2': 26.65,
                      'ups-zone-3': 33.25,
                      'ups-zone-4': 39.45,
                      'ups-zone-5': 47.88,
                      'ups-zone-6': 58.99,
                      'ups-zone-7': 71.12,
                      'ups-zone-8': 79.05,
                      'ups-zone-9': 153.53,
                      'ups-zone-10': 153.53,
                      'ups-zone-11': 153.53,
                      'ups-zone-12': 153.53,
                      'ups-zone-13': 130.5,
                    },
                    '51': {
                      'ups-zone-2': 26.71,
                      'ups-zone-3': 33.26,
                      'ups-zone-4': 39.54,
                      'ups-zone-5': 47.96,
                      'ups-zone-6': 59.28,
                      'ups-zone-7': 71.48,
                      'ups-zone-8': 80.28,
                      'ups-zone-9': 155.87,
                      'ups-zone-10': 155.87,
                      'ups-zone-11': 155.87,
                      'ups-zone-12': 155.87,
                      'ups-zone-13': 132.49,
                    },
                    '52': {
                      'ups-zone-2': 26.72,
                      'ups-zone-3': 33.3,
                      'ups-zone-4': 39.58,
                      'ups-zone-5': 47.96,
                      'ups-zone-6': 59.3,
                      'ups-zone-7': 71.49,
                      'ups-zone-8': 80.29,
                      'ups-zone-9': 158.18,
                      'ups-zone-10': 158.18,
                      'ups-zone-11': 158.18,
                      'ups-zone-12': 158.18,
                      'ups-zone-13': 134.46,
                    },
                    '53': {
                      'ups-zone-2': 26.73,
                      'ups-zone-3': 33.35,
                      'ups-zone-4': 39.59,
                      'ups-zone-5': 48.27,
                      'ups-zone-6': 59.31,
                      'ups-zone-7': 71.51,
                      'ups-zone-8': 81.07,
                      'ups-zone-9': 160.53,
                      'ups-zone-10': 160.53,
                      'ups-zone-11': 160.53,
                      'ups-zone-12': 160.53,
                      'ups-zone-13': 136.45,
                    },
                    '54': {
                      'ups-zone-2': 26.75,
                      'ups-zone-3': 33.42,
                      'ups-zone-4': 39.66,
                      'ups-zone-5': 48.34,
                      'ups-zone-6': 59.32,
                      'ups-zone-7': 71.52,
                      'ups-zone-8': 81.13,
                      'ups-zone-9': 162.81,
                      'ups-zone-10': 162.81,
                      'ups-zone-11': 162.81,
                      'ups-zone-12': 162.81,
                      'ups-zone-13': 138.39,
                    },
                    '55': {
                      'ups-zone-2': 26.75,
                      'ups-zone-3': 33.47,
                      'ups-zone-4': 39.67,
                      'ups-zone-5': 48.58,
                      'ups-zone-6': 59.39,
                      'ups-zone-7': 71.54,
                      'ups-zone-8': 81.2,
                      'ups-zone-9': 165.09,
                      'ups-zone-10': 165.09,
                      'ups-zone-11': 165.09,
                      'ups-zone-12': 165.09,
                      'ups-zone-13': 140.33,
                    },
                    '56': {
                      'ups-zone-2': 26.77,
                      'ups-zone-3': 33.53,
                      'ups-zone-4': 39.73,
                      'ups-zone-5': 48.59,
                      'ups-zone-6': 59.4,
                      'ups-zone-7': 71.59,
                      'ups-zone-8': 82.1,
                      'ups-zone-9': 167.46,
                      'ups-zone-10': 167.46,
                      'ups-zone-11': 167.46,
                      'ups-zone-12': 167.46,
                      'ups-zone-13': 142.34,
                    },
                    '57': {
                      'ups-zone-2': 27.25,
                      'ups-zone-3': 33.64,
                      'ups-zone-4': 39.79,
                      'ups-zone-5': 50.05,
                      'ups-zone-6': 59.46,
                      'ups-zone-7': 71.65,
                      'ups-zone-8': 82.94,
                      'ups-zone-9': 169.55,
                      'ups-zone-10': 169.55,
                      'ups-zone-11': 169.55,
                      'ups-zone-12': 169.55,
                      'ups-zone-13': 144.12,
                    },
                    '58': {
                      'ups-zone-2': 27.26,
                      'ups-zone-3': 33.66,
                      'ups-zone-4': 39.8,
                      'ups-zone-5': 50.1,
                      'ups-zone-6': 59.47,
                      'ups-zone-7': 71.71,
                      'ups-zone-8': 84.43,
                      'ups-zone-9': 171.25,
                      'ups-zone-10': 171.25,
                      'ups-zone-11': 171.25,
                      'ups-zone-12': 171.25,
                      'ups-zone-13': 145.56,
                    },
                    '59': {
                      'ups-zone-2': 27.35,
                      'ups-zone-3': 33.68,
                      'ups-zone-4': 40.08,
                      'ups-zone-5': 50.12,
                      'ups-zone-6': 60.35,
                      'ups-zone-7': 71.77,
                      'ups-zone-8': 85.04,
                      'ups-zone-9': 172.52,
                      'ups-zone-10': 172.52,
                      'ups-zone-11': 172.52,
                      'ups-zone-12': 172.52,
                      'ups-zone-13': 146.65,
                    },
                    '60': {
                      'ups-zone-2': 28.04,
                      'ups-zone-3': 34.98,
                      'ups-zone-4': 40.76,
                      'ups-zone-5': 51.86,
                      'ups-zone-6': 60.9,
                      'ups-zone-7': 72.09,
                      'ups-zone-8': 85.58,
                      'ups-zone-9': 173.56,
                      'ups-zone-10': 173.56,
                      'ups-zone-11': 173.56,
                      'ups-zone-12': 173.56,
                      'ups-zone-13': 147.52,
                    },
                    '61': {
                      'ups-zone-2': 28.05,
                      'ups-zone-3': 35.09,
                      'ups-zone-4': 41.09,
                      'ups-zone-5': 52.02,
                      'ups-zone-6': 61.45,
                      'ups-zone-7': 72.51,
                      'ups-zone-8': 86.1,
                      'ups-zone-9': 174.59,
                      'ups-zone-10': 174.59,
                      'ups-zone-11': 174.59,
                      'ups-zone-12': 174.59,
                      'ups-zone-13': 148.4,
                    },
                    '62': {
                      'ups-zone-2': 29.2,
                      'ups-zone-3': 37.57,
                      'ups-zone-4': 41.84,
                      'ups-zone-5': 53.5,
                      'ups-zone-6': 61.86,
                      'ups-zone-7': 73.63,
                      'ups-zone-8': 86.64,
                      'ups-zone-9': 175.71,
                      'ups-zone-10': 175.71,
                      'ups-zone-11': 175.71,
                      'ups-zone-12': 175.71,
                      'ups-zone-13': 149.35,
                    },
                    '63': {
                      'ups-zone-2': 29.21,
                      'ups-zone-3': 37.58,
                      'ups-zone-4': 42.24,
                      'ups-zone-5': 53.51,
                      'ups-zone-6': 62.28,
                      'ups-zone-7': 73.77,
                      'ups-zone-8': 87.17,
                      'ups-zone-9': 176.73,
                      'ups-zone-10': 176.73,
                      'ups-zone-11': 176.73,
                      'ups-zone-12': 176.73,
                      'ups-zone-13': 150.22,
                    },
                    '64': {
                      'ups-zone-2': 30.0,
                      'ups-zone-3': 37.96,
                      'ups-zone-4': 42.93,
                      'ups-zone-5': 53.58,
                      'ups-zone-6': 63.3,
                      'ups-zone-7': 74.26,
                      'ups-zone-8': 88.5,
                      'ups-zone-9': 177.75,
                      'ups-zone-10': 177.75,
                      'ups-zone-11': 177.75,
                      'ups-zone-12': 177.75,
                      'ups-zone-13': 151.09,
                    },
                    '65': {
                      'ups-zone-2': 30.32,
                      'ups-zone-3': 38.98,
                      'ups-zone-4': 42.94,
                      'ups-zone-5': 53.64,
                      'ups-zone-6': 63.84,
                      'ups-zone-7': 74.42,
                      'ups-zone-8': 88.66,
                      'ups-zone-9': 178.84,
                      'ups-zone-10': 178.84,
                      'ups-zone-11': 178.84,
                      'ups-zone-12': 178.84,
                      'ups-zone-13': 152.01,
                    },
                    '66': {
                      'ups-zone-2': 30.75,
                      'ups-zone-3': 38.99,
                      'ups-zone-4': 42.95,
                      'ups-zone-5': 53.66,
                      'ups-zone-6': 63.89,
                      'ups-zone-7': 74.65,
                      'ups-zone-8': 89.04,
                      'ups-zone-9': 180.14,
                      'ups-zone-10': 180.14,
                      'ups-zone-11': 180.14,
                      'ups-zone-12': 180.14,
                      'ups-zone-13': 153.12,
                    },
                    '67': {
                      'ups-zone-2': 30.76,
                      'ups-zone-3': 39.05,
                      'ups-zone-4': 42.96,
                      'ups-zone-5': 53.72,
                      'ups-zone-6': 64.4,
                      'ups-zone-7': 75.02,
                      'ups-zone-8': 89.09,
                      'ups-zone-9': 180.62,
                      'ups-zone-10': 180.62,
                      'ups-zone-11': 180.62,
                      'ups-zone-12': 180.62,
                      'ups-zone-13': 153.52,
                    },
                    '68': {
                      'ups-zone-2': 31.11,
                      'ups-zone-3': 40.09,
                      'ups-zone-4': 45.56,
                      'ups-zone-5': 54.83,
                      'ups-zone-6': 64.73,
                      'ups-zone-7': 75.46,
                      'ups-zone-8': 89.15,
                      'ups-zone-9': 181.0,
                      'ups-zone-10': 181.0,
                      'ups-zone-11': 181.0,
                      'ups-zone-12': 181.0,
                      'ups-zone-13': 153.85,
                    },
                    '69': {
                      'ups-zone-2': 31.45,
                      'ups-zone-3': 40.11,
                      'ups-zone-4': 45.88,
                      'ups-zone-5': 55.27,
                      'ups-zone-6': 65.08,
                      'ups-zone-7': 75.51,
                      'ups-zone-8': 89.52,
                      'ups-zone-9': 181.5,
                      'ups-zone-10': 181.5,
                      'ups-zone-11': 181.5,
                      'ups-zone-12': 181.5,
                      'ups-zone-13': 154.27,
                    },
                    '70': {
                      'ups-zone-2': 31.61,
                      'ups-zone-3': 40.66,
                      'ups-zone-4': 46.88,
                      'ups-zone-5': 57.62,
                      'ups-zone-6': 66.39,
                      'ups-zone-7': 75.57,
                      'ups-zone-8': 90.29,
                      'ups-zone-9': 181.94,
                      'ups-zone-10': 181.94,
                      'ups-zone-11': 181.94,
                      'ups-zone-12': 181.94,
                      'ups-zone-13': 154.65,
                    },
                  },
                },
                startDateTime: '2022-07-26T13:36:30.084Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:fccececb-ff36-4f9b-be7f-9e0bb12440c7:8',
          },
          tags: [],
        },
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-11-07T14:55:31.316Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-11-07T14:55:31.316Z',
              version: 1,
            },
            carrier: 'ups',
            carrierRateId: '4179670e-3d14-440f-8442-47248b06da6c',
            carrierServiceMethodId: 'ups-ground-service-method',
            description: '',
            destinationType: 'commercial',
            dimWeightOverride: {},
            name: 'UPS Ground (Commericial)',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2023-11-07T14:51:40.092Z',
                negotiatedSurcharges: [],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.36,
                      'ups-zone-7': 9.36,
                      'ups-zone-8': 9.36,
                      'ups-zone-44': 20.27,
                      'ups-zone-45': 21.33,
                      'ups-zone-46': 26.7,
                    },
                    '2': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.36,
                      'ups-zone-7': 9.36,
                      'ups-zone-8': 9.36,
                      'ups-zone-44': 22.54,
                      'ups-zone-45': 23.88,
                      'ups-zone-46': 28.97,
                    },
                    '3': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.36,
                      'ups-zone-7': 9.36,
                      'ups-zone-8': 9.36,
                      'ups-zone-44': 24.5,
                      'ups-zone-45': 27.21,
                      'ups-zone-46': 30.85,
                    },
                    '4': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.36,
                      'ups-zone-7': 9.36,
                      'ups-zone-8': 9.53,
                      'ups-zone-44': 26.9,
                      'ups-zone-45': 29.0,
                      'ups-zone-46': 33.46,
                    },
                    '5': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.36,
                      'ups-zone-7': 9.53,
                      'ups-zone-8': 10.11,
                      'ups-zone-44': 29.16,
                      'ups-zone-45': 31.49,
                      'ups-zone-46': 35.59,
                    },
                    '6': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.36,
                      'ups-zone-7': 9.55,
                      'ups-zone-8': 10.11,
                      'ups-zone-44': 31.46,
                      'ups-zone-45': 33.51,
                      'ups-zone-46': 36.96,
                    },
                    '7': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.36,
                      'ups-zone-7': 9.8,
                      'ups-zone-8': 10.5,
                      'ups-zone-44': 33.59,
                      'ups-zone-45': 36.11,
                      'ups-zone-46': 38.85,
                    },
                    '8': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.59,
                      'ups-zone-7': 10.2,
                      'ups-zone-8': 10.95,
                      'ups-zone-44': 34.81,
                      'ups-zone-45': 37.98,
                      'ups-zone-46': 40.86,
                    },
                    '9': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.79,
                      'ups-zone-7': 10.62,
                      'ups-zone-8': 11.53,
                      'ups-zone-44': 37.26,
                      'ups-zone-45': 40.62,
                      'ups-zone-46': 43.31,
                    },
                    '10': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.58,
                      'ups-zone-6': 9.91,
                      'ups-zone-7': 11.13,
                      'ups-zone-8': 12.3,
                      'ups-zone-44': 39.59,
                      'ups-zone-45': 44.11,
                      'ups-zone-46': 45.63,
                    },
                    '11': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 9.66,
                      'ups-zone-7': 11.37,
                      'ups-zone-8': 12.35,
                      'ups-zone-44': 39.58,
                      'ups-zone-45': 44.32,
                      'ups-zone-46': 45.34,
                    },
                    '12': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.36,
                      'ups-zone-6': 10.0,
                      'ups-zone-7': 11.82,
                      'ups-zone-8': 12.93,
                      'ups-zone-44': 41.27,
                      'ups-zone-45': 45.94,
                      'ups-zone-46': 47.01,
                    },
                    '13': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.41,
                      'ups-zone-6': 10.31,
                      'ups-zone-7': 12.59,
                      'ups-zone-8': 13.56,
                      'ups-zone-44': 42.98,
                      'ups-zone-45': 47.61,
                      'ups-zone-46': 48.69,
                    },
                    '14': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.64,
                      'ups-zone-6': 10.91,
                      'ups-zone-7': 13.44,
                      'ups-zone-8': 14.67,
                      'ups-zone-44': 44.76,
                      'ups-zone-45': 49.46,
                      'ups-zone-46': 50.46,
                    },
                    '15': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 9.98,
                      'ups-zone-6': 11.51,
                      'ups-zone-7': 13.87,
                      'ups-zone-8': 15.36,
                      'ups-zone-44': 46.41,
                      'ups-zone-45': 51.71,
                      'ups-zone-46': 52.07,
                    },
                    '16': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 10.16,
                      'ups-zone-6': 11.89,
                      'ups-zone-7': 14.59,
                      'ups-zone-8': 16.03,
                      'ups-zone-44': 48.48,
                      'ups-zone-45': 53.87,
                      'ups-zone-46': 54.15,
                    },
                    '17': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 10.44,
                      'ups-zone-6': 12.39,
                      'ups-zone-7': 15.33,
                      'ups-zone-8': 16.26,
                      'ups-zone-44': 50.55,
                      'ups-zone-45': 56.44,
                      'ups-zone-46': 55.86,
                    },
                    '18': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 10.94,
                      'ups-zone-6': 13.04,
                      'ups-zone-7': 15.79,
                      'ups-zone-8': 17.38,
                      'ups-zone-44': 52.64,
                      'ups-zone-45': 59.8,
                      'ups-zone-46': 57.93,
                    },
                    '19': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.46,
                      'ups-zone-4': 9.69,
                      'ups-zone-5': 11.42,
                      'ups-zone-6': 13.37,
                      'ups-zone-7': 16.23,
                      'ups-zone-8': 18.09,
                      'ups-zone-44': 54.72,
                      'ups-zone-45': 61.73,
                      'ups-zone-46': 59.99,
                    },
                    '20': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.54,
                      'ups-zone-4': 9.74,
                      'ups-zone-5': 11.87,
                      'ups-zone-6': 13.83,
                      'ups-zone-7': 16.83,
                      'ups-zone-8': 18.88,
                      'ups-zone-44': 56.55,
                      'ups-zone-45': 63.98,
                      'ups-zone-46': 61.8,
                    },
                    '21': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.53,
                      'ups-zone-5': 11.15,
                      'ups-zone-6': 13.34,
                      'ups-zone-7': 16.18,
                      'ups-zone-8': 18.06,
                      'ups-zone-44': 53.71,
                      'ups-zone-45': 62.13,
                      'ups-zone-46': 58.58,
                    },
                    '22': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.36,
                      'ups-zone-4': 9.79,
                      'ups-zone-5': 11.54,
                      'ups-zone-6': 13.88,
                      'ups-zone-7': 16.78,
                      'ups-zone-8': 18.86,
                      'ups-zone-44': 55.4,
                      'ups-zone-45': 64.5,
                      'ups-zone-46': 60.26,
                    },
                    '23': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.47,
                      'ups-zone-4': 10.07,
                      'ups-zone-5': 11.87,
                      'ups-zone-6': 14.54,
                      'ups-zone-7': 17.34,
                      'ups-zone-8': 19.6,
                      'ups-zone-44': 57.06,
                      'ups-zone-45': 66.87,
                      'ups-zone-46': 61.93,
                    },
                    '24': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.85,
                      'ups-zone-4': 10.52,
                      'ups-zone-5': 12.38,
                      'ups-zone-6': 15.09,
                      'ups-zone-7': 17.75,
                      'ups-zone-8': 20.73,
                      'ups-zone-44': 58.94,
                      'ups-zone-45': 69.31,
                      'ups-zone-46': 63.79,
                    },
                    '25': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 9.96,
                      'ups-zone-4': 10.65,
                      'ups-zone-5': 12.63,
                      'ups-zone-6': 15.36,
                      'ups-zone-7': 18.52,
                      'ups-zone-8': 21.13,
                      'ups-zone-44': 60.76,
                      'ups-zone-45': 71.72,
                      'ups-zone-46': 65.63,
                    },
                    '26': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 10.31,
                      'ups-zone-4': 11.09,
                      'ups-zone-5': 13.15,
                      'ups-zone-6': 15.92,
                      'ups-zone-7': 19.28,
                      'ups-zone-8': 22.0,
                      'ups-zone-44': 62.69,
                      'ups-zone-45': 73.56,
                      'ups-zone-46': 67.69,
                    },
                    '27': {
                      'ups-zone-2': 9.36,
                      'ups-zone-3': 10.56,
                      'ups-zone-4': 11.21,
                      'ups-zone-5': 13.36,
                      'ups-zone-6': 16.56,
                      'ups-zone-7': 19.64,
                      'ups-zone-8': 22.37,
                      'ups-zone-44': 64.42,
                      'ups-zone-45': 75.98,
                      'ups-zone-46': 69.47,
                    },
                    '28': {
                      'ups-zone-2': 9.41,
                      'ups-zone-3': 10.81,
                      'ups-zone-4': 11.84,
                      'ups-zone-5': 14.23,
                      'ups-zone-6': 17.36,
                      'ups-zone-7': 20.52,
                      'ups-zone-8': 23.45,
                      'ups-zone-44': 66.15,
                      'ups-zone-45': 78.46,
                      'ups-zone-46': 71.21,
                    },
                    '29': {
                      'ups-zone-2': 9.43,
                      'ups-zone-3': 11.01,
                      'ups-zone-4': 12.03,
                      'ups-zone-5': 14.25,
                      'ups-zone-6': 17.86,
                      'ups-zone-7': 21.18,
                      'ups-zone-8': 23.85,
                      'ups-zone-44': 67.78,
                      'ups-zone-45': 80.4,
                      'ups-zone-46': 72.65,
                    },
                    '30': {
                      'ups-zone-2': 9.59,
                      'ups-zone-3': 11.28,
                      'ups-zone-4': 12.49,
                      'ups-zone-5': 14.81,
                      'ups-zone-6': 18.15,
                      'ups-zone-7': 21.28,
                      'ups-zone-8': 24.84,
                      'ups-zone-44': 69.4,
                      'ups-zone-45': 82.93,
                      'ups-zone-46': 74.3,
                    },
                    '31': {
                      'ups-zone-2': 9.37,
                      'ups-zone-3': 10.88,
                      'ups-zone-4': 11.94,
                      'ups-zone-5': 14.06,
                      'ups-zone-6': 17.51,
                      'ups-zone-7': 20.61,
                      'ups-zone-8': 24.15,
                      'ups-zone-44': 65.41,
                      'ups-zone-45': 80.08,
                      'ups-zone-46': 70.05,
                    },
                    '32': {
                      'ups-zone-2': 9.38,
                      'ups-zone-3': 10.88,
                      'ups-zone-4': 11.94,
                      'ups-zone-5': 14.06,
                      'ups-zone-6': 17.61,
                      'ups-zone-7': 20.61,
                      'ups-zone-8': 24.65,
                      'ups-zone-44': 65.69,
                      'ups-zone-45': 82.63,
                      'ups-zone-46': 70.27,
                    },
                    '33': {
                      'ups-zone-2': 9.44,
                      'ups-zone-3': 11.04,
                      'ups-zone-4': 12.48,
                      'ups-zone-5': 14.73,
                      'ups-zone-6': 18.61,
                      'ups-zone-7': 21.3,
                      'ups-zone-8': 25.08,
                      'ups-zone-44': 67.07,
                      'ups-zone-45': 84.82,
                      'ups-zone-46': 71.66,
                    },
                    '34': {
                      'ups-zone-2': 9.49,
                      'ups-zone-3': 11.29,
                      'ups-zone-4': 12.88,
                      'ups-zone-5': 15.24,
                      'ups-zone-6': 18.76,
                      'ups-zone-7': 21.93,
                      'ups-zone-8': 26.28,
                      'ups-zone-44': 68.57,
                      'ups-zone-45': 87.09,
                      'ups-zone-46': 73.14,
                    },
                    '35': {
                      'ups-zone-2': 9.67,
                      'ups-zone-3': 11.89,
                      'ups-zone-4': 13.17,
                      'ups-zone-5': 15.61,
                      'ups-zone-6': 19.04,
                      'ups-zone-7': 22.5,
                      'ups-zone-8': 26.71,
                      'ups-zone-44': 70.27,
                      'ups-zone-45': 89.42,
                      'ups-zone-46': 74.83,
                    },
                    '36': {
                      'ups-zone-2': 9.81,
                      'ups-zone-3': 11.9,
                      'ups-zone-4': 13.41,
                      'ups-zone-5': 16.08,
                      'ups-zone-6': 19.84,
                      'ups-zone-7': 23.26,
                      'ups-zone-8': 27.51,
                      'ups-zone-44': 71.77,
                      'ups-zone-45': 91.54,
                      'ups-zone-46': 76.48,
                    },
                    '37': {
                      'ups-zone-2': 9.96,
                      'ups-zone-3': 12.05,
                      'ups-zone-4': 13.62,
                      'ups-zone-5': 16.43,
                      'ups-zone-6': 19.92,
                      'ups-zone-7': 24.01,
                      'ups-zone-8': 27.77,
                      'ups-zone-44': 73.42,
                      'ups-zone-45': 93.85,
                      'ups-zone-46': 78.16,
                    },
                    '38': {
                      'ups-zone-2': 10.11,
                      'ups-zone-3': 12.24,
                      'ups-zone-4': 13.97,
                      'ups-zone-5': 16.83,
                      'ups-zone-6': 20.37,
                      'ups-zone-7': 24.33,
                      'ups-zone-8': 28.29,
                      'ups-zone-44': 75.18,
                      'ups-zone-45': 96.05,
                      'ups-zone-46': 79.92,
                    },
                    '39': {
                      'ups-zone-2': 10.45,
                      'ups-zone-3': 12.72,
                      'ups-zone-4': 14.44,
                      'ups-zone-5': 17.26,
                      'ups-zone-6': 21.18,
                      'ups-zone-7': 25.05,
                      'ups-zone-8': 28.88,
                      'ups-zone-44': 76.79,
                      'ups-zone-45': 98.3,
                      'ups-zone-46': 81.41,
                    },
                    '40': {
                      'ups-zone-2': 10.46,
                      'ups-zone-3': 12.77,
                      'ups-zone-4': 14.48,
                      'ups-zone-5': 17.29,
                      'ups-zone-6': 21.33,
                      'ups-zone-7': 25.06,
                      'ups-zone-8': 29.08,
                      'ups-zone-44': 78.44,
                      'ups-zone-45': 100.3,
                      'ups-zone-46': 83.01,
                    },
                    '41': {
                      'ups-zone-2': 10.59,
                      'ups-zone-3': 13.19,
                      'ups-zone-4': 14.86,
                      'ups-zone-5': 17.88,
                      'ups-zone-6': 22.09,
                      'ups-zone-7': 25.83,
                      'ups-zone-8': 29.97,
                      'ups-zone-44': 79.79,
                      'ups-zone-45': 102.46,
                      'ups-zone-46': 84.53,
                    },
                    '42': {
                      'ups-zone-2': 10.66,
                      'ups-zone-3': 13.36,
                      'ups-zone-4': 15.44,
                      'ups-zone-5': 17.93,
                      'ups-zone-6': 22.31,
                      'ups-zone-7': 26.27,
                      'ups-zone-8': 30.13,
                      'ups-zone-44': 81.3,
                      'ups-zone-45': 104.79,
                      'ups-zone-46': 86.03,
                    },
                    '43': {
                      'ups-zone-2': 10.9,
                      'ups-zone-3': 13.55,
                      'ups-zone-4': 15.46,
                      'ups-zone-5': 18.85,
                      'ups-zone-6': 23.39,
                      'ups-zone-7': 27.22,
                      'ups-zone-8': 30.94,
                      'ups-zone-44': 82.95,
                      'ups-zone-45': 106.81,
                      'ups-zone-46': 87.69,
                    },
                    '44': {
                      'ups-zone-2': 11.05,
                      'ups-zone-3': 13.76,
                      'ups-zone-4': 15.86,
                      'ups-zone-5': 19.18,
                      'ups-zone-6': 23.6,
                      'ups-zone-7': 27.92,
                      'ups-zone-8': 31.27,
                      'ups-zone-44': 84.14,
                      'ups-zone-45': 108.88,
                      'ups-zone-46': 89.37,
                    },
                    '45': {
                      'ups-zone-2': 11.06,
                      'ups-zone-3': 13.76,
                      'ups-zone-4': 15.86,
                      'ups-zone-5': 19.19,
                      'ups-zone-6': 23.67,
                      'ups-zone-7': 28.62,
                      'ups-zone-8': 31.49,
                      'ups-zone-44': 85.76,
                      'ups-zone-45': 110.5,
                      'ups-zone-46': 91.01,
                    },
                    '46': {
                      'ups-zone-2': 11.31,
                      'ups-zone-3': 13.91,
                      'ups-zone-4': 16.37,
                      'ups-zone-5': 19.65,
                      'ups-zone-6': 24.29,
                      'ups-zone-7': 28.92,
                      'ups-zone-8': 32.32,
                      'ups-zone-44': 87.42,
                      'ups-zone-45': 113.17,
                      'ups-zone-46': 92.67,
                    },
                    '47': {
                      'ups-zone-2': 11.36,
                      'ups-zone-3': 14.09,
                      'ups-zone-4': 16.64,
                      'ups-zone-5': 19.8,
                      'ups-zone-6': 24.62,
                      'ups-zone-7': 29.49,
                      'ups-zone-8': 32.84,
                      'ups-zone-44': 89.09,
                      'ups-zone-45': 115.33,
                      'ups-zone-46': 94.34,
                    },
                    '48': {
                      'ups-zone-2': 11.36,
                      'ups-zone-3': 14.19,
                      'ups-zone-4': 16.8,
                      'ups-zone-5': 20.4,
                      'ups-zone-6': 24.99,
                      'ups-zone-7': 29.76,
                      'ups-zone-8': 33.36,
                      'ups-zone-44': 90.62,
                      'ups-zone-45': 117.3,
                      'ups-zone-46': 95.89,
                    },
                    '49': {
                      'ups-zone-2': 11.37,
                      'ups-zone-3': 14.19,
                      'ups-zone-4': 16.84,
                      'ups-zone-5': 20.41,
                      'ups-zone-6': 25.18,
                      'ups-zone-7': 30.36,
                      'ups-zone-8': 33.56,
                      'ups-zone-44': 92.17,
                      'ups-zone-45': 119.49,
                      'ups-zone-46': 97.47,
                    },
                    '50': {
                      'ups-zone-2': 11.37,
                      'ups-zone-3': 14.2,
                      'ups-zone-4': 16.84,
                      'ups-zone-5': 20.44,
                      'ups-zone-6': 25.18,
                      'ups-zone-7': 30.36,
                      'ups-zone-8': 33.75,
                      'ups-zone-44': 93.72,
                      'ups-zone-45': 119.54,
                      'ups-zone-46': 99.03,
                    },
                    '51': {
                      'ups-zone-2': 11.4,
                      'ups-zone-3': 14.2,
                      'ups-zone-4': 16.88,
                      'ups-zone-5': 20.47,
                      'ups-zone-6': 25.31,
                      'ups-zone-7': 30.51,
                      'ups-zone-8': 34.27,
                      'ups-zone-44': 95.62,
                      'ups-zone-45': 123.56,
                      'ups-zone-46': 101.91,
                    },
                    '52': {
                      'ups-zone-2': 11.41,
                      'ups-zone-3': 14.21,
                      'ups-zone-4': 16.9,
                      'ups-zone-5': 20.48,
                      'ups-zone-6': 25.31,
                      'ups-zone-7': 30.52,
                      'ups-zone-8': 34.28,
                      'ups-zone-44': 95.82,
                      'ups-zone-45': 123.83,
                      'ups-zone-46': 102.09,
                    },
                    '53': {
                      'ups-zone-2': 11.41,
                      'ups-zone-3': 14.24,
                      'ups-zone-4': 16.9,
                      'ups-zone-5': 20.6,
                      'ups-zone-6': 25.32,
                      'ups-zone-7': 30.53,
                      'ups-zone-8': 34.61,
                      'ups-zone-44': 97.27,
                      'ups-zone-45': 125.67,
                      'ups-zone-46': 103.55,
                    },
                    '54': {
                      'ups-zone-2': 11.42,
                      'ups-zone-3': 14.27,
                      'ups-zone-4': 16.93,
                      'ups-zone-5': 20.64,
                      'ups-zone-6': 25.32,
                      'ups-zone-7': 30.53,
                      'ups-zone-8': 34.63,
                      'ups-zone-44': 98.64,
                      'ups-zone-45': 127.22,
                      'ups-zone-46': 105.11,
                    },
                    '55': {
                      'ups-zone-2': 11.42,
                      'ups-zone-3': 14.29,
                      'ups-zone-4': 16.93,
                      'ups-zone-5': 20.74,
                      'ups-zone-6': 25.35,
                      'ups-zone-7': 30.54,
                      'ups-zone-8': 34.66,
                      'ups-zone-44': 99.97,
                      'ups-zone-45': 131.07,
                      'ups-zone-46': 106.7,
                    },
                    '56': {
                      'ups-zone-2': 11.43,
                      'ups-zone-3': 14.31,
                      'ups-zone-4': 16.96,
                      'ups-zone-5': 20.74,
                      'ups-zone-6': 25.36,
                      'ups-zone-7': 30.56,
                      'ups-zone-8': 35.05,
                      'ups-zone-44': 101.32,
                      'ups-zone-45': 131.46,
                      'ups-zone-46': 108.25,
                    },
                    '57': {
                      'ups-zone-2': 11.63,
                      'ups-zone-3': 14.36,
                      'ups-zone-4': 16.99,
                      'ups-zone-5': 21.36,
                      'ups-zone-6': 25.38,
                      'ups-zone-7': 30.59,
                      'ups-zone-8': 35.41,
                      'ups-zone-44': 102.71,
                      'ups-zone-45': 133.84,
                      'ups-zone-46': 109.92,
                    },
                    '58': {
                      'ups-zone-2': 11.64,
                      'ups-zone-3': 14.37,
                      'ups-zone-4': 16.99,
                      'ups-zone-5': 21.39,
                      'ups-zone-6': 25.39,
                      'ups-zone-7': 30.62,
                      'ups-zone-8': 36.04,
                      'ups-zone-44': 104.06,
                      'ups-zone-45': 136.07,
                      'ups-zone-46': 111.48,
                    },
                    '59': {
                      'ups-zone-2': 11.67,
                      'ups-zone-3': 14.38,
                      'ups-zone-4': 17.11,
                      'ups-zone-5': 21.39,
                      'ups-zone-6': 25.76,
                      'ups-zone-7': 30.64,
                      'ups-zone-8': 36.3,
                      'ups-zone-44': 105.64,
                      'ups-zone-45': 137.92,
                      'ups-zone-46': 113.14,
                    },
                    '60': {
                      'ups-zone-2': 11.97,
                      'ups-zone-3': 14.93,
                      'ups-zone-4': 17.4,
                      'ups-zone-5': 22.14,
                      'ups-zone-6': 26.0,
                      'ups-zone-7': 30.78,
                      'ups-zone-8': 36.53,
                      'ups-zone-44': 107.29,
                      'ups-zone-45': 139.61,
                      'ups-zone-46': 114.8,
                    },
                    '61': {
                      'ups-zone-2': 11.98,
                      'ups-zone-3': 14.98,
                      'ups-zone-4': 17.54,
                      'ups-zone-5': 22.21,
                      'ups-zone-6': 26.23,
                      'ups-zone-7': 30.95,
                      'ups-zone-8': 36.75,
                      'ups-zone-44': 108.61,
                      'ups-zone-45': 142.1,
                      'ups-zone-46': 116.17,
                    },
                    '62': {
                      'ups-zone-2': 12.47,
                      'ups-zone-3': 16.04,
                      'ups-zone-4': 17.86,
                      'ups-zone-5': 22.84,
                      'ups-zone-6': 26.41,
                      'ups-zone-7': 31.43,
                      'ups-zone-8': 36.99,
                      'ups-zone-44': 110.4,
                      'ups-zone-45': 145.07,
                      'ups-zone-46': 117.99,
                    },
                    '63': {
                      'ups-zone-2': 12.47,
                      'ups-zone-3': 16.04,
                      'ups-zone-4': 18.03,
                      'ups-zone-5': 22.84,
                      'ups-zone-6': 26.59,
                      'ups-zone-7': 31.49,
                      'ups-zone-8': 37.21,
                      'ups-zone-44': 112.21,
                      'ups-zone-45': 147.44,
                      'ups-zone-46': 119.84,
                    },
                    '64': {
                      'ups-zone-2': 12.8,
                      'ups-zone-3': 16.2,
                      'ups-zone-4': 18.33,
                      'ups-zone-5': 22.87,
                      'ups-zone-6': 27.02,
                      'ups-zone-7': 31.7,
                      'ups-zone-8': 37.78,
                      'ups-zone-44': 114.07,
                      'ups-zone-45': 149.31,
                      'ups-zone-46': 121.77,
                    },
                    '65': {
                      'ups-zone-2': 12.95,
                      'ups-zone-3': 16.64,
                      'ups-zone-4': 18.33,
                      'ups-zone-5': 22.9,
                      'ups-zone-6': 27.25,
                      'ups-zone-7': 31.77,
                      'ups-zone-8': 37.85,
                      'ups-zone-44': 115.93,
                      'ups-zone-45': 151.9,
                      'ups-zone-46': 123.7,
                    },
                    '66': {
                      'ups-zone-2': 13.13,
                      'ups-zone-3': 16.65,
                      'ups-zone-4': 18.34,
                      'ups-zone-5': 22.91,
                      'ups-zone-6': 27.27,
                      'ups-zone-7': 31.87,
                      'ups-zone-8': 38.01,
                      'ups-zone-44': 117.73,
                      'ups-zone-45': 154.51,
                      'ups-zone-46': 125.52,
                    },
                    '67': {
                      'ups-zone-2': 13.13,
                      'ups-zone-3': 16.67,
                      'ups-zone-4': 18.34,
                      'ups-zone-5': 22.93,
                      'ups-zone-6': 27.49,
                      'ups-zone-7': 32.03,
                      'ups-zone-8': 38.03,
                      'ups-zone-44': 119.52,
                      'ups-zone-45': 155.05,
                      'ups-zone-46': 127.38,
                    },
                    '68': {
                      'ups-zone-2': 13.28,
                      'ups-zone-3': 17.12,
                      'ups-zone-4': 19.45,
                      'ups-zone-5': 23.41,
                      'ups-zone-6': 27.64,
                      'ups-zone-7': 32.21,
                      'ups-zone-8': 38.06,
                      'ups-zone-44': 121.24,
                      'ups-zone-45': 159.14,
                      'ups-zone-46': 129.13,
                    },
                    '69': {
                      'ups-zone-2': 13.43,
                      'ups-zone-3': 17.12,
                      'ups-zone-4': 19.59,
                      'ups-zone-5': 23.59,
                      'ups-zone-6': 27.78,
                      'ups-zone-7': 32.24,
                      'ups-zone-8': 38.22,
                      'ups-zone-44': 123.0,
                      'ups-zone-45': 161.42,
                      'ups-zone-46': 130.94,
                    },
                    '70': {
                      'ups-zone-2': 13.49,
                      'ups-zone-3': 17.36,
                      'ups-zone-4': 20.01,
                      'ups-zone-5': 24.6,
                      'ups-zone-6': 28.34,
                      'ups-zone-7': 32.26,
                      'ups-zone-8': 38.54,
                      'ups-zone-44': 125.59,
                      'ups-zone-45': 163.37,
                      'ups-zone-46': 132.55,
                    },
                    '71': {
                      'ups-zone-2': 13.52,
                      'ups-zone-3': 17.39,
                      'ups-zone-4': 20.36,
                      'ups-zone-5': 24.73,
                      'ups-zone-6': 28.84,
                      'ups-zone-7': 33.1,
                      'ups-zone-8': 38.62,
                      'ups-zone-44': 127.52,
                      'ups-zone-45': 163.83,
                      'ups-zone-46': 134.91,
                    },
                    '72': {
                      'ups-zone-2': 13.91,
                      'ups-zone-3': 17.4,
                      'ups-zone-4': 20.79,
                      'ups-zone-5': 24.73,
                      'ups-zone-6': 29.05,
                      'ups-zone-7': 34.2,
                      'ups-zone-8': 38.89,
                      'ups-zone-44': 129.41,
                      'ups-zone-45': 164.21,
                      'ups-zone-46': 136.84,
                    },
                    '73': {
                      'ups-zone-2': 14.0,
                      'ups-zone-3': 17.57,
                      'ups-zone-4': 20.8,
                      'ups-zone-5': 25.1,
                      'ups-zone-6': 29.33,
                      'ups-zone-7': 34.49,
                      'ups-zone-8': 38.96,
                      'ups-zone-44': 131.31,
                      'ups-zone-45': 165.94,
                      'ups-zone-46': 138.78,
                    },
                    '74': {
                      'ups-zone-2': 14.5,
                      'ups-zone-3': 17.57,
                      'ups-zone-4': 20.8,
                      'ups-zone-5': 25.1,
                      'ups-zone-6': 29.81,
                      'ups-zone-7': 34.58,
                      'ups-zone-8': 39.04,
                      'ups-zone-44': 132.57,
                      'ups-zone-45': 174.2,
                      'ups-zone-46': 139.22,
                    },
                    '75': {
                      'ups-zone-2': 15.05,
                      'ups-zone-3': 17.6,
                      'ups-zone-4': 20.81,
                      'ups-zone-5': 25.33,
                      'ups-zone-6': 30.1,
                      'ups-zone-7': 34.93,
                      'ups-zone-8': 39.06,
                      'ups-zone-44': 134.07,
                      'ups-zone-45': 174.71,
                      'ups-zone-46': 140.21,
                    },
                    '76': {
                      'ups-zone-2': 16.06,
                      'ups-zone-3': 18.58,
                      'ups-zone-4': 20.94,
                      'ups-zone-5': 25.72,
                      'ups-zone-6': 30.48,
                      'ups-zone-7': 35.5,
                      'ups-zone-8': 39.08,
                      'ups-zone-44': 135.73,
                      'ups-zone-45': 174.78,
                      'ups-zone-46': 141.89,
                    },
                    '77': {
                      'ups-zone-2': 16.69,
                      'ups-zone-3': 18.85,
                      'ups-zone-4': 21.19,
                      'ups-zone-5': 25.83,
                      'ups-zone-6': 30.65,
                      'ups-zone-7': 36.18,
                      'ups-zone-8': 39.1,
                      'ups-zone-44': 136.85,
                      'ups-zone-45': 175.35,
                      'ups-zone-46': 142.71,
                    },
                    '78': {
                      'ups-zone-2': 16.71,
                      'ups-zone-3': 19.56,
                      'ups-zone-4': 21.82,
                      'ups-zone-5': 26.11,
                      'ups-zone-6': 30.84,
                      'ups-zone-7': 36.78,
                      'ups-zone-8': 39.11,
                      'ups-zone-44': 137.58,
                      'ups-zone-45': 175.91,
                      'ups-zone-46': 143.75,
                    },
                    '79': {
                      'ups-zone-2': 17.63,
                      'ups-zone-3': 20.35,
                      'ups-zone-4': 22.34,
                      'ups-zone-5': 26.52,
                      'ups-zone-6': 31.48,
                      'ups-zone-7': 37.35,
                      'ups-zone-8': 39.71,
                      'ups-zone-44': 137.61,
                      'ups-zone-45': 180.81,
                      'ups-zone-46': 144.15,
                    },
                    '80': {
                      'ups-zone-2': 17.94,
                      'ups-zone-3': 20.76,
                      'ups-zone-4': 22.46,
                      'ups-zone-5': 27.15,
                      'ups-zone-6': 32.01,
                      'ups-zone-7': 37.51,
                      'ups-zone-8': 40.01,
                      'ups-zone-44': 139.04,
                      'ups-zone-45': 182.6,
                      'ups-zone-46': 144.89,
                    },
                    '81': {
                      'ups-zone-2': 18.38,
                      'ups-zone-3': 20.92,
                      'ups-zone-4': 23.01,
                      'ups-zone-5': 27.33,
                      'ups-zone-6': 32.43,
                      'ups-zone-7': 38.09,
                      'ups-zone-8': 40.52,
                      'ups-zone-44': 140.2,
                      'ups-zone-45': 182.86,
                      'ups-zone-46': 145.64,
                    },
                    '82': {
                      'ups-zone-2': 19.13,
                      'ups-zone-3': 21.63,
                      'ups-zone-4': 24.04,
                      'ups-zone-5': 28.0,
                      'ups-zone-6': 32.51,
                      'ups-zone-7': 39.07,
                      'ups-zone-8': 40.52,
                      'ups-zone-44': 140.9,
                      'ups-zone-45': 185.16,
                      'ups-zone-46': 146.3,
                    },
                    '83': {
                      'ups-zone-2': 19.16,
                      'ups-zone-3': 21.64,
                      'ups-zone-4': 24.05,
                      'ups-zone-5': 28.04,
                      'ups-zone-6': 32.91,
                      'ups-zone-7': 39.08,
                      'ups-zone-8': 40.53,
                      'ups-zone-44': 142.45,
                      'ups-zone-45': 187.18,
                      'ups-zone-46': 146.87,
                    },
                    '84': {
                      'ups-zone-2': 19.92,
                      'ups-zone-3': 22.35,
                      'ups-zone-4': 24.75,
                      'ups-zone-5': 28.31,
                      'ups-zone-6': 33.41,
                      'ups-zone-7': 39.55,
                      'ups-zone-8': 40.84,
                      'ups-zone-44': 144.09,
                      'ups-zone-45': 189.34,
                      'ups-zone-46': 148.51,
                    },
                    '85': {
                      'ups-zone-2': 20.26,
                      'ups-zone-3': 22.5,
                      'ups-zone-4': 24.76,
                      'ups-zone-5': 28.76,
                      'ups-zone-6': 33.92,
                      'ups-zone-7': 39.98,
                      'ups-zone-8': 41.29,
                      'ups-zone-44': 145.77,
                      'ups-zone-45': 191.54,
                      'ups-zone-46': 150.18,
                    },
                    '86': {
                      'ups-zone-2': 21.2,
                      'ups-zone-3': 23.53,
                      'ups-zone-4': 25.73,
                      'ups-zone-5': 29.31,
                      'ups-zone-6': 34.33,
                      'ups-zone-7': 40.72,
                      'ups-zone-8': 42.15,
                      'ups-zone-44': 147.3,
                      'ups-zone-45': 193.56,
                      'ups-zone-46': 151.73,
                    },
                    '87': {
                      'ups-zone-2': 21.43,
                      'ups-zone-3': 23.54,
                      'ups-zone-4': 25.74,
                      'ups-zone-5': 29.31,
                      'ups-zone-6': 34.79,
                      'ups-zone-7': 40.76,
                      'ups-zone-8': 42.22,
                      'ups-zone-44': 148.96,
                      'ups-zone-45': 195.73,
                      'ups-zone-46': 153.37,
                    },
                    '88': {
                      'ups-zone-2': 22.54,
                      'ups-zone-3': 24.29,
                      'ups-zone-4': 26.8,
                      'ups-zone-5': 30.25,
                      'ups-zone-6': 35.24,
                      'ups-zone-7': 41.18,
                      'ups-zone-8': 43.09,
                      'ups-zone-44': 150.6,
                      'ups-zone-45': 197.89,
                      'ups-zone-46': 155.04,
                    },
                    '89': {
                      'ups-zone-2': 23.32,
                      'ups-zone-3': 24.74,
                      'ups-zone-4': 27.07,
                      'ups-zone-5': 30.36,
                      'ups-zone-6': 35.67,
                      'ups-zone-7': 41.61,
                      'ups-zone-8': 43.99,
                      'ups-zone-44': 152.17,
                      'ups-zone-45': 199.94,
                      'ups-zone-46': 156.6,
                    },
                    '90': {
                      'ups-zone-2': 24.73,
                      'ups-zone-3': 25.81,
                      'ups-zone-4': 28.21,
                      'ups-zone-5': 31.25,
                      'ups-zone-6': 36.18,
                      'ups-zone-7': 42.17,
                      'ups-zone-8': 44.44,
                      'ups-zone-44': 153.71,
                      'ups-zone-45': 201.98,
                      'ups-zone-46': 158.74,
                    },
                    '91': {
                      'ups-zone-2': 24.74,
                      'ups-zone-3': 25.82,
                      'ups-zone-4': 28.22,
                      'ups-zone-5': 31.28,
                      'ups-zone-6': 36.25,
                      'ups-zone-7': 42.18,
                      'ups-zone-8': 44.44,
                      'ups-zone-44': 155.36,
                      'ups-zone-45': 203.11,
                      'ups-zone-46': 159.75,
                    },
                    '92': {
                      'ups-zone-2': 25.52,
                      'ups-zone-3': 26.28,
                      'ups-zone-4': 28.37,
                      'ups-zone-5': 31.51,
                      'ups-zone-6': 36.92,
                      'ups-zone-7': 42.18,
                      'ups-zone-8': 44.91,
                      'ups-zone-44': 156.84,
                      'ups-zone-45': 204.89,
                      'ups-zone-46': 161.24,
                    },
                    '93': {
                      'ups-zone-2': 25.63,
                      'ups-zone-3': 26.56,
                      'ups-zone-4': 28.93,
                      'ups-zone-5': 31.58,
                      'ups-zone-6': 37.0,
                      'ups-zone-7': 42.19,
                      'ups-zone-8': 45.0,
                      'ups-zone-44': 158.36,
                      'ups-zone-45': 204.95,
                      'ups-zone-46': 162.78,
                    },
                    '94': {
                      'ups-zone-2': 25.76,
                      'ups-zone-3': 27.0,
                      'ups-zone-4': 29.07,
                      'ups-zone-5': 31.99,
                      'ups-zone-6': 37.44,
                      'ups-zone-7': 42.19,
                      'ups-zone-8': 45.46,
                      'ups-zone-44': 159.86,
                      'ups-zone-45': 210.07,
                      'ups-zone-46': 164.3,
                    },
                    '95': {
                      'ups-zone-2': 26.36,
                      'ups-zone-3': 27.5,
                      'ups-zone-4': 29.27,
                      'ups-zone-5': 32.42,
                      'ups-zone-6': 37.69,
                      'ups-zone-7': 42.35,
                      'ups-zone-8': 45.95,
                      'ups-zone-44': 161.42,
                      'ups-zone-45': 211.92,
                      'ups-zone-46': 165.84,
                    },
                    '96': {
                      'ups-zone-2': 27.2,
                      'ups-zone-3': 27.68,
                      'ups-zone-4': 30.34,
                      'ups-zone-5': 33.09,
                      'ups-zone-6': 37.9,
                      'ups-zone-7': 42.63,
                      'ups-zone-8': 46.83,
                      'ups-zone-44': 162.89,
                      'ups-zone-45': 212.91,
                      'ups-zone-46': 167.29,
                    },
                    '97': {
                      'ups-zone-2': 27.84,
                      'ups-zone-3': 28.49,
                      'ups-zone-4': 30.78,
                      'ups-zone-5': 33.28,
                      'ups-zone-6': 38.32,
                      'ups-zone-7': 42.95,
                      'ups-zone-8': 47.32,
                      'ups-zone-44': 164.44,
                      'ups-zone-45': 213.09,
                      'ups-zone-46': 168.84,
                    },
                    '98': {
                      'ups-zone-2': 28.2,
                      'ups-zone-3': 28.68,
                      'ups-zone-4': 30.79,
                      'ups-zone-5': 33.67,
                      'ups-zone-6': 38.75,
                      'ups-zone-7': 42.96,
                      'ups-zone-8': 47.34,
                      'ups-zone-44': 165.9,
                      'ups-zone-45': 213.21,
                      'ups-zone-46': 170.34,
                    },
                    '99': {
                      'ups-zone-2': 28.82,
                      'ups-zone-3': 29.13,
                      'ups-zone-4': 31.94,
                      'ups-zone-5': 34.09,
                      'ups-zone-6': 39.2,
                      'ups-zone-7': 43.39,
                      'ups-zone-8': 47.8,
                      'ups-zone-44': 167.46,
                      'ups-zone-45': 213.37,
                      'ups-zone-46': 171.87,
                    },
                    '100': {
                      'ups-zone-2': 29.32,
                      'ups-zone-3': 29.62,
                      'ups-zone-4': 31.95,
                      'ups-zone-5': 34.63,
                      'ups-zone-6': 39.67,
                      'ups-zone-7': 43.83,
                      'ups-zone-8': 48.27,
                      'ups-zone-44': 169.01,
                      'ups-zone-45': 222.09,
                      'ups-zone-46': 173.43,
                    },
                    '101': {
                      'ups-zone-2': 29.55,
                      'ups-zone-3': 29.62,
                      'ups-zone-4': 31.96,
                      'ups-zone-5': 34.63,
                      'ups-zone-6': 39.68,
                      'ups-zone-7': 43.83,
                      'ups-zone-8': 48.3,
                      'ups-zone-44': 169.02,
                      'ups-zone-45': 224.13,
                      'ups-zone-46': 173.43,
                    },
                    '102': {
                      'ups-zone-2': 29.56,
                      'ups-zone-3': 29.63,
                      'ups-zone-4': 31.96,
                      'ups-zone-5': 34.64,
                      'ups-zone-6': 39.68,
                      'ups-zone-7': 43.84,
                      'ups-zone-8': 48.33,
                      'ups-zone-44': 169.02,
                      'ups-zone-45': 226.2,
                      'ups-zone-46': 173.46,
                    },
                    '103': {
                      'ups-zone-2': 30.23,
                      'ups-zone-3': 30.36,
                      'ups-zone-4': 32.62,
                      'ups-zone-5': 34.84,
                      'ups-zone-6': 40.03,
                      'ups-zone-7': 44.09,
                      'ups-zone-8': 48.33,
                      'ups-zone-44': 169.03,
                      'ups-zone-45': 228.24,
                      'ups-zone-46': 173.48,
                    },
                    '104': {
                      'ups-zone-2': 30.23,
                      'ups-zone-3': 30.5,
                      'ups-zone-4': 32.7,
                      'ups-zone-5': 35.21,
                      'ups-zone-6': 40.16,
                      'ups-zone-7': 44.22,
                      'ups-zone-8': 48.63,
                      'ups-zone-44': 169.2,
                      'ups-zone-45': 230.4,
                      'ups-zone-46': 173.51,
                    },
                    '105': {
                      'ups-zone-2': 31.02,
                      'ups-zone-3': 31.26,
                      'ups-zone-4': 33.39,
                      'ups-zone-5': 35.94,
                      'ups-zone-6': 40.77,
                      'ups-zone-7': 44.9,
                      'ups-zone-8': 49.52,
                      'ups-zone-44': 170.71,
                      'ups-zone-45': 232.45,
                      'ups-zone-46': 174.14,
                    },
                    '106': {
                      'ups-zone-2': 31.23,
                      'ups-zone-3': 31.42,
                      'ups-zone-4': 33.45,
                      'ups-zone-5': 35.94,
                      'ups-zone-6': 40.78,
                      'ups-zone-7': 44.91,
                      'ups-zone-8': 49.52,
                      'ups-zone-44': 172.29,
                      'ups-zone-45': 234.58,
                      'ups-zone-46': 175.72,
                    },
                    '107': {
                      'ups-zone-2': 31.69,
                      'ups-zone-3': 31.89,
                      'ups-zone-4': 34.17,
                      'ups-zone-5': 36.65,
                      'ups-zone-6': 41.14,
                      'ups-zone-7': 45.27,
                      'ups-zone-8': 50.38,
                      'ups-zone-44': 173.88,
                      'ups-zone-45': 236.76,
                      'ups-zone-46': 177.31,
                    },
                    '108': {
                      'ups-zone-2': 32.14,
                      'ups-zone-3': 32.35,
                      'ups-zone-4': 34.22,
                      'ups-zone-5': 36.68,
                      'ups-zone-6': 41.52,
                      'ups-zone-7': 45.67,
                      'ups-zone-8': 50.39,
                      'ups-zone-44': 175.46,
                      'ups-zone-45': 238.91,
                      'ups-zone-46': 179.3,
                    },
                    '109': {
                      'ups-zone-2': 32.77,
                      'ups-zone-3': 32.82,
                      'ups-zone-4': 34.59,
                      'ups-zone-5': 37.03,
                      'ups-zone-6': 41.89,
                      'ups-zone-7': 46.06,
                      'ups-zone-8': 50.83,
                      'ups-zone-44': 176.97,
                      'ups-zone-45': 240.97,
                      'ups-zone-46': 180.81,
                    },
                    '110': {
                      'ups-zone-2': 33.37,
                      'ups-zone-3': 33.6,
                      'ups-zone-4': 35.32,
                      'ups-zone-5': 37.67,
                      'ups-zone-6': 42.65,
                      'ups-zone-7': 46.92,
                      'ups-zone-8': 51.77,
                      'ups-zone-44': 178.46,
                      'ups-zone-45': 243.0,
                      'ups-zone-46': 181.85,
                    },
                    '111': {
                      'ups-zone-2': 33.37,
                      'ups-zone-3': 33.65,
                      'ups-zone-4': 36.1,
                      'ups-zone-5': 38.11,
                      'ups-zone-6': 42.65,
                      'ups-zone-7': 47.25,
                      'ups-zone-8': 52.38,
                      'ups-zone-44': 180.49,
                      'ups-zone-45': 245.76,
                      'ups-zone-46': 184.34,
                    },
                    '112': {
                      'ups-zone-2': 34.06,
                      'ups-zone-3': 34.34,
                      'ups-zone-4': 36.11,
                      'ups-zone-5': 38.12,
                      'ups-zone-6': 43.02,
                      'ups-zone-7': 47.26,
                      'ups-zone-8': 52.39,
                      'ups-zone-44': 182.53,
                      'ups-zone-45': 248.54,
                      'ups-zone-46': 186.85,
                    },
                    '113': {
                      'ups-zone-2': 34.09,
                      'ups-zone-3': 34.37,
                      'ups-zone-4': 36.51,
                      'ups-zone-5': 38.47,
                      'ups-zone-6': 43.4,
                      'ups-zone-7': 47.64,
                      'ups-zone-8': 53.34,
                      'ups-zone-44': 184.11,
                      'ups-zone-45': 250.69,
                      'ups-zone-46': 188.42,
                    },
                    '114': {
                      'ups-zone-2': 34.45,
                      'ups-zone-3': 35.09,
                      'ups-zone-4': 37.27,
                      'ups-zone-5': 39.22,
                      'ups-zone-6': 44.13,
                      'ups-zone-7': 48.45,
                      'ups-zone-8': 53.68,
                      'ups-zone-44': 185.71,
                      'ups-zone-45': 252.87,
                      'ups-zone-46': 190.03,
                    },
                    '115': {
                      'ups-zone-2': 35.13,
                      'ups-zone-3': 35.81,
                      'ups-zone-4': 37.6,
                      'ups-zone-5': 39.62,
                      'ups-zone-6': 44.47,
                      'ups-zone-7': 48.81,
                      'ups-zone-8': 54.09,
                      'ups-zone-44': 187.29,
                      'ups-zone-45': 255.03,
                      'ups-zone-46': 191.62,
                    },
                    '116': {
                      'ups-zone-2': 35.5,
                      'ups-zone-3': 35.93,
                      'ups-zone-4': 38.09,
                      'ups-zone-5': 39.8,
                      'ups-zone-6': 44.7,
                      'ups-zone-7': 49.51,
                      'ups-zone-8': 54.43,
                      'ups-zone-44': 188.46,
                      'ups-zone-45': 256.62,
                      'ups-zone-46': 193.15,
                    },
                    '117': {
                      'ups-zone-2': 35.54,
                      'ups-zone-3': 36.0,
                      'ups-zone-4': 38.1,
                      'ups-zone-5': 40.23,
                      'ups-zone-6': 44.79,
                      'ups-zone-7': 49.52,
                      'ups-zone-8': 54.89,
                      'ups-zone-44': 189.96,
                      'ups-zone-45': 258.67,
                      'ups-zone-46': 195.11,
                    },
                    '118': {
                      'ups-zone-2': 35.92,
                      'ups-zone-3': 36.73,
                      'ups-zone-4': 38.14,
                      'ups-zone-5': 40.35,
                      'ups-zone-6': 45.16,
                      'ups-zone-7': 49.52,
                      'ups-zone-8': 55.79,
                      'ups-zone-44': 191.46,
                      'ups-zone-45': 260.7,
                      'ups-zone-46': 196.15,
                    },
                    '119': {
                      'ups-zone-2': 36.91,
                      'ups-zone-3': 37.09,
                      'ups-zone-4': 39.27,
                      'ups-zone-5': 40.88,
                      'ups-zone-6': 45.55,
                      'ups-zone-7': 49.92,
                      'ups-zone-8': 56.28,
                      'ups-zone-44': 194.23,
                      'ups-zone-45': 264.49,
                      'ups-zone-46': 199.94,
                    },
                    '120': {
                      'ups-zone-2': 37.61,
                      'ups-zone-3': 37.66,
                      'ups-zone-4': 39.32,
                      'ups-zone-5': 41.24,
                      'ups-zone-6': 45.91,
                      'ups-zone-7': 50.57,
                      'ups-zone-8': 56.36,
                      'ups-zone-44': 195.83,
                      'ups-zone-45': 266.66,
                      'ups-zone-46': 202.03,
                    },
                    '121': {
                      'ups-zone-2': 37.63,
                      'ups-zone-3': 37.67,
                      'ups-zone-4': 39.33,
                      'ups-zone-5': 41.25,
                      'ups-zone-6': 46.21,
                      'ups-zone-7': 50.58,
                      'ups-zone-8': 56.36,
                      'ups-zone-44': 197.14,
                      'ups-zone-45': 268.43,
                      'ups-zone-46': 203.27,
                    },
                    '122': {
                      'ups-zone-2': 37.64,
                      'ups-zone-3': 38.39,
                      'ups-zone-4': 39.71,
                      'ups-zone-5': 41.62,
                      'ups-zone-6': 46.56,
                      'ups-zone-7': 51.37,
                      'ups-zone-8': 56.83,
                      'ups-zone-44': 198.81,
                      'ups-zone-45': 270.71,
                      'ups-zone-46': 204.94,
                    },
                    '123': {
                      'ups-zone-2': 38.61,
                      'ups-zone-3': 38.76,
                      'ups-zone-4': 41.29,
                      'ups-zone-5': 42.67,
                      'ups-zone-6': 46.93,
                      'ups-zone-7': 52.39,
                      'ups-zone-8': 58.02,
                      'ups-zone-44': 200.5,
                      'ups-zone-45': 273.01,
                      'ups-zone-46': 206.64,
                    },
                    '124': {
                      'ups-zone-2': 38.66,
                      'ups-zone-3': 38.81,
                      'ups-zone-4': 41.33,
                      'ups-zone-5': 42.67,
                      'ups-zone-6': 47.58,
                      'ups-zone-7': 52.39,
                      'ups-zone-8': 58.14,
                      'ups-zone-44': 202.17,
                      'ups-zone-45': 275.3,
                      'ups-zone-46': 208.34,
                    },
                    '125': {
                      'ups-zone-2': 38.71,
                      'ups-zone-3': 38.81,
                      'ups-zone-4': 41.34,
                      'ups-zone-5': 42.76,
                      'ups-zone-6': 47.68,
                      'ups-zone-7': 52.4,
                      'ups-zone-8': 58.14,
                      'ups-zone-44': 203.86,
                      'ups-zone-45': 277.58,
                      'ups-zone-46': 210.04,
                    },
                    '126': {
                      'ups-zone-2': 39.49,
                      'ups-zone-3': 39.57,
                      'ups-zone-4': 42.15,
                      'ups-zone-5': 43.01,
                      'ups-zone-6': 47.97,
                      'ups-zone-7': 52.82,
                      'ups-zone-8': 60.07,
                      'ups-zone-44': 205.12,
                      'ups-zone-45': 279.3,
                      'ups-zone-46': 212.22,
                    },
                    '127': {
                      'ups-zone-2': 39.49,
                      'ups-zone-3': 39.87,
                      'ups-zone-4': 42.57,
                      'ups-zone-5': 43.65,
                      'ups-zone-6': 48.68,
                      'ups-zone-7': 53.21,
                      'ups-zone-8': 60.07,
                      'ups-zone-44': 206.79,
                      'ups-zone-45': 281.58,
                      'ups-zone-46': 213.41,
                    },
                    '128': {
                      'ups-zone-2': 39.84,
                      'ups-zone-3': 39.88,
                      'ups-zone-4': 42.58,
                      'ups-zone-5': 43.75,
                      'ups-zone-6': 49.06,
                      'ups-zone-7': 53.77,
                      'ups-zone-8': 60.52,
                      'ups-zone-44': 208.47,
                      'ups-zone-45': 283.88,
                      'ups-zone-46': 215.61,
                    },
                    '129': {
                      'ups-zone-2': 40.62,
                      'ups-zone-3': 40.77,
                      'ups-zone-4': 42.99,
                      'ups-zone-5': 44.37,
                      'ups-zone-6': 49.07,
                      'ups-zone-7': 53.78,
                      'ups-zone-8': 60.98,
                      'ups-zone-44': 210.16,
                      'ups-zone-45': 286.16,
                      'ups-zone-46': 217.34,
                    },
                    '130': {
                      'ups-zone-2': 40.73,
                      'ups-zone-3': 40.78,
                      'ups-zone-4': 43.38,
                      'ups-zone-5': 44.47,
                      'ups-zone-6': 49.42,
                      'ups-zone-7': 54.48,
                      'ups-zone-8': 61.93,
                      'ups-zone-44': 215.91,
                      'ups-zone-45': 288.44,
                      'ups-zone-46': 223.24,
                    },
                    '131': {
                      'ups-zone-2': 40.97,
                      'ups-zone-3': 41.03,
                      'ups-zone-4': 43.92,
                      'ups-zone-5': 44.77,
                      'ups-zone-6': 49.69,
                      'ups-zone-7': 54.88,
                      'ups-zone-8': 62.4,
                      'ups-zone-44': 215.92,
                      'ups-zone-45': 291.54,
                      'ups-zone-46': 224.21,
                    },
                    '132': {
                      'ups-zone-2': 41.4,
                      'ups-zone-3': 41.83,
                      'ups-zone-4': 44.21,
                      'ups-zone-5': 45.13,
                      'ups-zone-6': 50.06,
                      'ups-zone-7': 54.89,
                      'ups-zone-8': 62.4,
                      'ups-zone-44': 217.85,
                      'ups-zone-45': 293.84,
                      'ups-zone-46': 226.74,
                    },
                    '133': {
                      'ups-zone-2': 41.78,
                      'ups-zone-3': 41.9,
                      'ups-zone-4': 44.21,
                      'ups-zone-5': 45.5,
                      'ups-zone-6': 50.41,
                      'ups-zone-7': 55.0,
                      'ups-zone-8': 62.41,
                      'ups-zone-44': 219.16,
                      'ups-zone-45': 296.13,
                      'ups-zone-46': 227.51,
                    },
                    '134': {
                      'ups-zone-2': 42.48,
                      'ups-zone-3': 42.58,
                      'ups-zone-4': 45.05,
                      'ups-zone-5': 46.22,
                      'ups-zone-6': 51.18,
                      'ups-zone-7': 55.79,
                      'ups-zone-8': 62.68,
                      'ups-zone-44': 219.17,
                      'ups-zone-45': 298.43,
                      'ups-zone-46': 227.53,
                    },
                    '135': {
                      'ups-zone-2': 42.89,
                      'ups-zone-3': 43.05,
                      'ups-zone-4': 45.48,
                      'ups-zone-5': 46.6,
                      'ups-zone-6': 51.62,
                      'ups-zone-7': 56.2,
                      'ups-zone-8': 63.11,
                      'ups-zone-44': 220.83,
                      'ups-zone-45': 300.7,
                      'ups-zone-46': 229.72,
                    },
                    '136': {
                      'ups-zone-2': 42.89,
                      'ups-zone-3': 43.56,
                      'ups-zone-4': 46.21,
                      'ups-zone-5': 47.01,
                      'ups-zone-6': 51.85,
                      'ups-zone-7': 56.45,
                      'ups-zone-8': 63.42,
                      'ups-zone-44': 222.51,
                      'ups-zone-45': 302.99,
                      'ups-zone-46': 231.44,
                    },
                    '137': {
                      'ups-zone-2': 43.21,
                      'ups-zone-3': 43.57,
                      'ups-zone-4': 47.0,
                      'ups-zone-5': 47.45,
                      'ups-zone-6': 51.92,
                      'ups-zone-7': 56.55,
                      'ups-zone-8': 63.55,
                      'ups-zone-44': 226.35,
                      'ups-zone-45': 305.3,
                      'ups-zone-46': 235.4,
                    },
                    '138': {
                      'ups-zone-2': 43.6,
                      'ups-zone-3': 44.25,
                      'ups-zone-4': 47.23,
                      'ups-zone-5': 47.83,
                      'ups-zone-6': 52.84,
                      'ups-zone-7': 57.56,
                      'ups-zone-8': 64.69,
                      'ups-zone-44': 227.56,
                      'ups-zone-45': 307.57,
                      'ups-zone-46': 236.63,
                    },
                    '139': {
                      'ups-zone-2': 44.37,
                      'ups-zone-3': 44.7,
                      'ups-zone-4': 47.23,
                      'ups-zone-5': 47.84,
                      'ups-zone-6': 52.99,
                      'ups-zone-7': 57.97,
                      'ups-zone-8': 65.18,
                      'ups-zone-44': 227.56,
                      'ups-zone-45': 309.88,
                      'ups-zone-46': 236.66,
                    },
                    '140': {
                      'ups-zone-2': 44.78,
                      'ups-zone-3': 45.12,
                      'ups-zone-4': 47.7,
                      'ups-zone-5': 48.5,
                      'ups-zone-6': 53.45,
                      'ups-zone-7': 57.98,
                      'ups-zone-8': 65.69,
                      'ups-zone-44': 229.16,
                      'ups-zone-45': 312.03,
                      'ups-zone-46': 238.22,
                    },
                    '141': {
                      'ups-zone-2': 44.78,
                      'ups-zone-3': 45.12,
                      'ups-zone-4': 48.12,
                      'ups-zone-5': 48.6,
                      'ups-zone-6': 53.56,
                      'ups-zone-7': 58.1,
                      'ups-zone-8': 65.7,
                      'ups-zone-44': 230.3,
                      'ups-zone-45': 313.6,
                      'ups-zone-46': 239.27,
                    },
                    '142': {
                      'ups-zone-2': 45.35,
                      'ups-zone-3': 45.96,
                      'ups-zone-4': 48.54,
                      'ups-zone-5': 49.35,
                      'ups-zone-6': 54.26,
                      'ups-zone-7': 58.91,
                      'ups-zone-8': 66.04,
                      'ups-zone-44': 234.14,
                      'ups-zone-45': 315.81,
                      'ups-zone-46': 243.8,
                    },
                    '143': {
                      'ups-zone-2': 45.36,
                      'ups-zone-3': 45.96,
                      'ups-zone-4': 48.55,
                      'ups-zone-5': 49.38,
                      'ups-zone-6': 54.37,
                      'ups-zone-7': 58.91,
                      'ups-zone-8': 66.09,
                      'ups-zone-44': 235.72,
                      'ups-zone-45': 317.94,
                      'ups-zone-46': 245.43,
                    },
                    '144': {
                      'ups-zone-2': 46.59,
                      'ups-zone-3': 47.27,
                      'ups-zone-4': 50.34,
                      'ups-zone-5': 50.82,
                      'ups-zone-6': 55.19,
                      'ups-zone-7': 60.32,
                      'ups-zone-8': 67.47,
                      'ups-zone-44': 237.34,
                      'ups-zone-45': 320.12,
                      'ups-zone-46': 247.08,
                    },
                    '145': {
                      'ups-zone-2': 46.75,
                      'ups-zone-3': 48.15,
                      'ups-zone-4': 50.34,
                      'ups-zone-5': 50.93,
                      'ups-zone-6': 56.01,
                      'ups-zone-7': 60.95,
                      'ups-zone-8': 67.9,
                      'ups-zone-44': 237.35,
                      'ups-zone-45': 322.38,
                      'ups-zone-46': 247.1,
                    },
                    '146': {
                      'ups-zone-2': 46.76,
                      'ups-zone-3': 48.18,
                      'ups-zone-4': 50.41,
                      'ups-zone-5': 50.94,
                      'ups-zone-6': 56.02,
                      'ups-zone-7': 60.96,
                      'ups-zone-8': 67.91,
                      'ups-zone-44': 238.45,
                      'ups-zone-45': 324.68,
                      'ups-zone-46': 248.19,
                    },
                    '147': {
                      'ups-zone-2': 47.4,
                      'ups-zone-3': 48.21,
                      'ups-zone-4': 50.81,
                      'ups-zone-5': 51.35,
                      'ups-zone-6': 56.42,
                      'ups-zone-7': 60.97,
                      'ups-zone-8': 68.37,
                      'ups-zone-44': 242.4,
                      'ups-zone-45': 326.95,
                      'ups-zone-46': 252.27,
                    },
                    '148': {
                      'ups-zone-2': 47.66,
                      'ups-zone-3': 48.52,
                      'ups-zone-4': 51.29,
                      'ups-zone-5': 51.78,
                      'ups-zone-6': 57.13,
                      'ups-zone-7': 61.37,
                      'ups-zone-8': 69.39,
                      'ups-zone-44': 244.13,
                      'ups-zone-45': 329.25,
                      'ups-zone-46': 253.43,
                    },
                    '149': {
                      'ups-zone-2': 47.67,
                      'ups-zone-3': 48.95,
                      'ups-zone-4': 51.66,
                      'ups-zone-5': 52.16,
                      'ups-zone-6': 57.14,
                      'ups-zone-7': 61.6,
                      'ups-zone-8': 69.4,
                      'ups-zone-44': 244.65,
                      'ups-zone-45': 333.12,
                      'ups-zone-46': 255.16,
                    },
                    '150': {
                      'ups-zone-2': 47.67,
                      'ups-zone-3': 48.97,
                      'ups-zone-4': 52.11,
                      'ups-zone-5': 53.5,
                      'ups-zone-6': 57.26,
                      'ups-zone-7': 61.73,
                      'ups-zone-8': 69.54,
                      'ups-zone-44': 246.33,
                      'ups-zone-45': 335.42,
                      'ups-zone-46': 259.32,
                    },
                  },
                },
                startDateTime: '2022-11-07T14:51:40.092Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:4179670e-3d14-440f-8442-47248b06da6c:1',
          },
          tags: [],
        },
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              creationTimeStamp: '2022-05-10T01:36:30.909Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-11-07T14:50:36.32Z',
              version: 4,
            },
            carrier: 'ups',
            carrierRateId: '14a84e96-8edf-45c8-8820-35c01270c9cd',
            carrierServiceMethodId: 'ups-ground-service-method',
            description: '',
            destinationType: 'residential',
            dimWeightOverride: {},
            name: 'UPS Ground (Residential)',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2050-05-10T01:33:35.53Z',
                negotiatedSurcharges: [],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.52,
                      'ups-zone-5': 8.52,
                      'ups-zone-6': 8.52,
                      'ups-zone-7': 8.52,
                      'ups-zone-8': 8.52,
                      'ups-zone-44': 21.43,
                      'ups-zone-45': 22.56,
                      'ups-zone-46': 28.24,
                    },
                    '2': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.52,
                      'ups-zone-5': 8.52,
                      'ups-zone-6': 8.52,
                      'ups-zone-7': 8.52,
                      'ups-zone-8': 8.56,
                      'ups-zone-44': 23.84,
                      'ups-zone-45': 25.26,
                      'ups-zone-46': 30.64,
                    },
                    '3': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.52,
                      'ups-zone-5': 8.52,
                      'ups-zone-6': 8.68,
                      'ups-zone-7': 8.97,
                      'ups-zone-8': 9.41,
                      'ups-zone-44': 25.91,
                      'ups-zone-45': 28.78,
                      'ups-zone-46': 32.62,
                    },
                    '4': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.52,
                      'ups-zone-5': 8.8,
                      'ups-zone-6': 9.04,
                      'ups-zone-7': 9.63,
                      'ups-zone-8': 10.08,
                      'ups-zone-44': 28.45,
                      'ups-zone-45': 30.68,
                      'ups-zone-46': 35.39,
                    },
                    '5': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.55,
                      'ups-zone-5': 9.19,
                      'ups-zone-6': 9.57,
                      'ups-zone-7': 10.08,
                      'ups-zone-8': 10.69,
                      'ups-zone-44': 30.84,
                      'ups-zone-45': 33.3,
                      'ups-zone-46': 37.64,
                    },
                    '6': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.56,
                      'ups-zone-5': 9.24,
                      'ups-zone-6': 9.58,
                      'ups-zone-7': 10.1,
                      'ups-zone-8': 10.7,
                      'ups-zone-44': 33.28,
                      'ups-zone-45': 35.44,
                      'ups-zone-46': 39.09,
                    },
                    '7': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.78,
                      'ups-zone-5': 9.53,
                      'ups-zone-6': 9.75,
                      'ups-zone-7': 10.36,
                      'ups-zone-8': 11.1,
                      'ups-zone-44': 35.53,
                      'ups-zone-45': 38.2,
                      'ups-zone-46': 41.08,
                    },
                    '8': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 9.09,
                      'ups-zone-5': 9.8,
                      'ups-zone-6': 10.15,
                      'ups-zone-7': 10.78,
                      'ups-zone-8': 11.58,
                      'ups-zone-44': 36.82,
                      'ups-zone-45': 40.17,
                      'ups-zone-46': 43.22,
                    },
                    '9': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 9.21,
                      'ups-zone-5': 9.89,
                      'ups-zone-6': 10.36,
                      'ups-zone-7': 11.23,
                      'ups-zone-8': 12.2,
                      'ups-zone-44': 39.41,
                      'ups-zone-45': 42.96,
                      'ups-zone-46': 45.8,
                    },
                    '10': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 9.3,
                      'ups-zone-5': 10.13,
                      'ups-zone-6': 10.48,
                      'ups-zone-7': 11.77,
                      'ups-zone-8': 13.0,
                      'ups-zone-44': 41.87,
                      'ups-zone-45': 46.65,
                      'ups-zone-46': 48.26,
                    },
                    '11': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.68,
                      'ups-zone-5': 9.33,
                      'ups-zone-6': 9.9,
                      'ups-zone-7': 11.65,
                      'ups-zone-8': 12.66,
                      'ups-zone-44': 40.56,
                      'ups-zone-45': 45.43,
                      'ups-zone-46': 46.47,
                    },
                    '12': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.77,
                      'ups-zone-5': 9.47,
                      'ups-zone-6': 10.25,
                      'ups-zone-7': 12.12,
                      'ups-zone-8': 13.25,
                      'ups-zone-44': 42.3,
                      'ups-zone-45': 47.09,
                      'ups-zone-46': 48.19,
                    },
                    '13': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.87,
                      'ups-zone-5': 9.65,
                      'ups-zone-6': 10.57,
                      'ups-zone-7': 12.91,
                      'ups-zone-8': 13.9,
                      'ups-zone-44': 44.05,
                      'ups-zone-45': 48.8,
                      'ups-zone-46': 49.91,
                    },
                    '14': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.52,
                      'ups-zone-4': 8.96,
                      'ups-zone-5': 9.88,
                      'ups-zone-6': 11.18,
                      'ups-zone-7': 13.78,
                      'ups-zone-8': 15.04,
                      'ups-zone-44': 45.88,
                      'ups-zone-45': 50.7,
                      'ups-zone-46': 51.72,
                    },
                    '15': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.71,
                      'ups-zone-4': 9.09,
                      'ups-zone-5': 10.23,
                      'ups-zone-6': 11.8,
                      'ups-zone-7': 14.21,
                      'ups-zone-8': 15.74,
                      'ups-zone-44': 47.57,
                      'ups-zone-45': 53.0,
                      'ups-zone-46': 53.38,
                    },
                    '16': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 8.95,
                      'ups-zone-4': 9.25,
                      'ups-zone-5': 10.41,
                      'ups-zone-6': 12.19,
                      'ups-zone-7': 14.95,
                      'ups-zone-8': 16.43,
                      'ups-zone-44': 49.7,
                      'ups-zone-45': 55.21,
                      'ups-zone-46': 55.51,
                    },
                    '17': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 9.14,
                      'ups-zone-4': 9.36,
                      'ups-zone-5': 10.7,
                      'ups-zone-6': 12.7,
                      'ups-zone-7': 15.72,
                      'ups-zone-8': 16.67,
                      'ups-zone-44': 51.81,
                      'ups-zone-45': 57.85,
                      'ups-zone-46': 57.26,
                    },
                    '18': {
                      'ups-zone-2': 8.52,
                      'ups-zone-3': 9.28,
                      'ups-zone-4': 9.45,
                      'ups-zone-5': 11.22,
                      'ups-zone-6': 13.36,
                      'ups-zone-7': 16.19,
                      'ups-zone-8': 17.81,
                      'ups-zone-44': 53.96,
                      'ups-zone-45': 61.3,
                      'ups-zone-46': 59.37,
                    },
                    '19': {
                      'ups-zone-2': 8.63,
                      'ups-zone-3': 9.69,
                      'ups-zone-4': 9.93,
                      'ups-zone-5': 11.71,
                      'ups-zone-6': 13.71,
                      'ups-zone-7': 16.63,
                      'ups-zone-8': 18.54,
                      'ups-zone-44': 56.09,
                      'ups-zone-45': 63.27,
                      'ups-zone-46': 61.49,
                    },
                    '20': {
                      'ups-zone-2': 8.69,
                      'ups-zone-3': 9.78,
                      'ups-zone-4': 9.99,
                      'ups-zone-5': 12.17,
                      'ups-zone-6': 14.18,
                      'ups-zone-7': 17.25,
                      'ups-zone-8': 19.35,
                      'ups-zone-44': 57.96,
                      'ups-zone-45': 65.58,
                      'ups-zone-46': 63.34,
                    },
                    '21': {
                      'ups-zone-2': 9.01,
                      'ups-zone-3': 10.16,
                      'ups-zone-4': 10.52,
                      'ups-zone-5': 12.31,
                      'ups-zone-6': 14.72,
                      'ups-zone-7': 17.86,
                      'ups-zone-8': 19.94,
                      'ups-zone-44': 59.29,
                      'ups-zone-45': 68.59,
                      'ups-zone-46': 64.67,
                    },
                    '22': {
                      'ups-zone-2': 9.03,
                      'ups-zone-3': 10.26,
                      'ups-zone-4': 10.8,
                      'ups-zone-5': 12.74,
                      'ups-zone-6': 15.32,
                      'ups-zone-7': 18.52,
                      'ups-zone-8': 20.81,
                      'ups-zone-44': 61.15,
                      'ups-zone-45': 71.19,
                      'ups-zone-46': 66.52,
                    },
                    '23': {
                      'ups-zone-2': 9.07,
                      'ups-zone-3': 10.45,
                      'ups-zone-4': 11.12,
                      'ups-zone-5': 13.1,
                      'ups-zone-6': 16.05,
                      'ups-zone-7': 19.14,
                      'ups-zone-8': 21.64,
                      'ups-zone-44': 62.99,
                      'ups-zone-45': 73.81,
                      'ups-zone-46': 68.36,
                    },
                    '24': {
                      'ups-zone-2': 9.32,
                      'ups-zone-3': 10.88,
                      'ups-zone-4': 11.61,
                      'ups-zone-5': 13.67,
                      'ups-zone-6': 16.66,
                      'ups-zone-7': 19.6,
                      'ups-zone-8': 22.88,
                      'ups-zone-44': 65.06,
                      'ups-zone-45': 76.5,
                      'ups-zone-46': 70.42,
                    },
                    '25': {
                      'ups-zone-2': 9.42,
                      'ups-zone-3': 11.0,
                      'ups-zone-4': 11.76,
                      'ups-zone-5': 13.94,
                      'ups-zone-6': 16.95,
                      'ups-zone-7': 20.45,
                      'ups-zone-8': 23.33,
                      'ups-zone-44': 67.07,
                      'ups-zone-45': 79.17,
                      'ups-zone-46': 72.44,
                    },
                    '26': {
                      'ups-zone-2': 9.87,
                      'ups-zone-3': 11.38,
                      'ups-zone-4': 12.24,
                      'ups-zone-5': 14.51,
                      'ups-zone-6': 17.57,
                      'ups-zone-7': 21.28,
                      'ups-zone-8': 24.29,
                      'ups-zone-44': 69.2,
                      'ups-zone-45': 81.2,
                      'ups-zone-46': 74.72,
                    },
                    '27': {
                      'ups-zone-2': 10.11,
                      'ups-zone-3': 11.65,
                      'ups-zone-4': 12.37,
                      'ups-zone-5': 14.75,
                      'ups-zone-6': 18.28,
                      'ups-zone-7': 21.67,
                      'ups-zone-8': 24.69,
                      'ups-zone-44': 71.11,
                      'ups-zone-45': 83.87,
                      'ups-zone-46': 76.69,
                    },
                    '28': {
                      'ups-zone-2': 10.38,
                      'ups-zone-3': 11.93,
                      'ups-zone-4': 13.06,
                      'ups-zone-5': 15.7,
                      'ups-zone-6': 19.17,
                      'ups-zone-7': 22.65,
                      'ups-zone-8': 25.88,
                      'ups-zone-44': 73.02,
                      'ups-zone-45': 86.61,
                      'ups-zone-46': 78.6,
                    },
                    '29': {
                      'ups-zone-2': 10.41,
                      'ups-zone-3': 12.16,
                      'ups-zone-4': 13.28,
                      'ups-zone-5': 15.73,
                      'ups-zone-6': 19.72,
                      'ups-zone-7': 23.38,
                      'ups-zone-8': 26.32,
                      'ups-zone-44': 74.82,
                      'ups-zone-45': 88.75,
                      'ups-zone-46': 80.19,
                    },
                    '30': {
                      'ups-zone-2': 10.58,
                      'ups-zone-3': 12.45,
                      'ups-zone-4': 13.78,
                      'ups-zone-5': 16.35,
                      'ups-zone-6': 20.03,
                      'ups-zone-7': 23.49,
                      'ups-zone-8': 27.42,
                      'ups-zone-44': 76.61,
                      'ups-zone-45': 91.54,
                      'ups-zone-46': 82.01,
                    },
                    '31': {
                      'ups-zone-2': 10.98,
                      'ups-zone-3': 12.74,
                      'ups-zone-4': 13.98,
                      'ups-zone-5': 16.47,
                      'ups-zone-6': 20.51,
                      'ups-zone-7': 24.14,
                      'ups-zone-8': 28.29,
                      'ups-zone-44': 76.62,
                      'ups-zone-45': 93.8,
                      'ups-zone-46': 82.05,
                    },
                    '32': {
                      'ups-zone-2': 10.99,
                      'ups-zone-3': 12.75,
                      'ups-zone-4': 13.99,
                      'ups-zone-5': 16.47,
                      'ups-zone-6': 20.62,
                      'ups-zone-7': 24.15,
                      'ups-zone-8': 28.87,
                      'ups-zone-44': 76.96,
                      'ups-zone-45': 96.8,
                      'ups-zone-46': 82.31,
                    },
                    '33': {
                      'ups-zone-2': 11.06,
                      'ups-zone-3': 12.94,
                      'ups-zone-4': 14.61,
                      'ups-zone-5': 17.25,
                      'ups-zone-6': 21.8,
                      'ups-zone-7': 24.95,
                      'ups-zone-8': 29.38,
                      'ups-zone-44': 78.56,
                      'ups-zone-45': 99.36,
                      'ups-zone-46': 83.95,
                    },
                    '34': {
                      'ups-zone-2': 11.12,
                      'ups-zone-3': 13.23,
                      'ups-zone-4': 15.08,
                      'ups-zone-5': 17.86,
                      'ups-zone-6': 21.97,
                      'ups-zone-7': 25.69,
                      'ups-zone-8': 30.78,
                      'ups-zone-44': 80.33,
                      'ups-zone-45': 102.02,
                      'ups-zone-46': 85.68,
                    },
                    '35': {
                      'ups-zone-2': 11.33,
                      'ups-zone-3': 13.93,
                      'ups-zone-4': 15.43,
                      'ups-zone-5': 18.29,
                      'ups-zone-6': 22.3,
                      'ups-zone-7': 26.35,
                      'ups-zone-8': 31.29,
                      'ups-zone-44': 82.32,
                      'ups-zone-45': 104.74,
                      'ups-zone-46': 87.66,
                    },
                    '36': {
                      'ups-zone-2': 11.5,
                      'ups-zone-3': 13.94,
                      'ups-zone-4': 15.7,
                      'ups-zone-5': 18.84,
                      'ups-zone-6': 23.24,
                      'ups-zone-7': 27.25,
                      'ups-zone-8': 32.22,
                      'ups-zone-44': 84.07,
                      'ups-zone-45': 107.23,
                      'ups-zone-46': 89.6,
                    },
                    '37': {
                      'ups-zone-2': 11.66,
                      'ups-zone-3': 14.11,
                      'ups-zone-4': 15.95,
                      'ups-zone-5': 19.25,
                      'ups-zone-6': 23.34,
                      'ups-zone-7': 28.13,
                      'ups-zone-8': 32.53,
                      'ups-zone-44': 86.0,
                      'ups-zone-45': 109.94,
                      'ups-zone-46': 91.56,
                    },
                    '38': {
                      'ups-zone-2': 11.84,
                      'ups-zone-3': 14.34,
                      'ups-zone-4': 16.37,
                      'ups-zone-5': 19.72,
                      'ups-zone-6': 23.87,
                      'ups-zone-7': 28.5,
                      'ups-zone-8': 33.14,
                      'ups-zone-44': 88.06,
                      'ups-zone-45': 112.52,
                      'ups-zone-46': 93.62,
                    },
                    '39': {
                      'ups-zone-2': 12.24,
                      'ups-zone-3': 14.9,
                      'ups-zone-4': 16.91,
                      'ups-zone-5': 20.22,
                      'ups-zone-6': 24.81,
                      'ups-zone-7': 29.35,
                      'ups-zone-8': 33.83,
                      'ups-zone-44': 89.96,
                      'ups-zone-45': 115.16,
                      'ups-zone-46': 95.36,
                    },
                    '40': {
                      'ups-zone-2': 12.25,
                      'ups-zone-3': 14.96,
                      'ups-zone-4': 16.96,
                      'ups-zone-5': 20.25,
                      'ups-zone-6': 24.99,
                      'ups-zone-7': 29.35,
                      'ups-zone-8': 34.06,
                      'ups-zone-44': 91.89,
                      'ups-zone-45': 117.49,
                      'ups-zone-46': 97.24,
                    },
                    '41': {
                      'ups-zone-2': 12.41,
                      'ups-zone-3': 15.45,
                      'ups-zone-4': 17.41,
                      'ups-zone-5': 20.95,
                      'ups-zone-6': 25.88,
                      'ups-zone-7': 30.26,
                      'ups-zone-8': 35.11,
                      'ups-zone-44': 93.47,
                      'ups-zone-45': 120.03,
                      'ups-zone-46': 99.02,
                    },
                    '42': {
                      'ups-zone-2': 12.48,
                      'ups-zone-3': 15.65,
                      'ups-zone-4': 18.09,
                      'ups-zone-5': 21.01,
                      'ups-zone-6': 26.14,
                      'ups-zone-7': 30.77,
                      'ups-zone-8': 35.29,
                      'ups-zone-44': 95.23,
                      'ups-zone-45': 122.75,
                      'ups-zone-46': 100.78,
                    },
                    '43': {
                      'ups-zone-2': 12.77,
                      'ups-zone-3': 15.88,
                      'ups-zone-4': 18.12,
                      'ups-zone-5': 22.08,
                      'ups-zone-6': 27.4,
                      'ups-zone-7': 31.89,
                      'ups-zone-8': 36.25,
                      'ups-zone-44': 97.17,
                      'ups-zone-45': 125.12,
                      'ups-zone-46': 102.72,
                    },
                    '44': {
                      'ups-zone-2': 12.95,
                      'ups-zone-3': 16.12,
                      'ups-zone-4': 18.57,
                      'ups-zone-5': 22.47,
                      'ups-zone-6': 27.64,
                      'ups-zone-7': 32.7,
                      'ups-zone-8': 36.63,
                      'ups-zone-44': 98.57,
                      'ups-zone-45': 127.54,
                      'ups-zone-46': 104.69,
                    },
                    '45': {
                      'ups-zone-2': 12.96,
                      'ups-zone-3': 16.12,
                      'ups-zone-4': 18.58,
                      'ups-zone-5': 22.48,
                      'ups-zone-6': 27.72,
                      'ups-zone-7': 33.53,
                      'ups-zone-8': 36.89,
                      'ups-zone-44': 100.47,
                      'ups-zone-45': 129.44,
                      'ups-zone-46': 106.61,
                    },
                    '46': {
                      'ups-zone-2': 13.25,
                      'ups-zone-3': 16.29,
                      'ups-zone-4': 19.18,
                      'ups-zone-5': 23.02,
                      'ups-zone-6': 28.46,
                      'ups-zone-7': 33.88,
                      'ups-zone-8': 37.86,
                      'ups-zone-44': 102.4,
                      'ups-zone-45': 132.57,
                      'ups-zone-46': 108.56,
                    },
                    '47': {
                      'ups-zone-2': 13.31,
                      'ups-zone-3': 16.5,
                      'ups-zone-4': 19.49,
                      'ups-zone-5': 23.19,
                      'ups-zone-6': 28.84,
                      'ups-zone-7': 34.54,
                      'ups-zone-8': 38.47,
                      'ups-zone-44': 104.36,
                      'ups-zone-45': 135.1,
                      'ups-zone-46': 110.51,
                    },
                    '48': {
                      'ups-zone-2': 13.31,
                      'ups-zone-3': 16.62,
                      'ups-zone-4': 19.68,
                      'ups-zone-5': 23.9,
                      'ups-zone-6': 29.27,
                      'ups-zone-7': 34.86,
                      'ups-zone-8': 39.08,
                      'ups-zone-44': 106.15,
                      'ups-zone-45': 137.4,
                      'ups-zone-46': 112.33,
                    },
                    '49': {
                      'ups-zone-2': 13.32,
                      'ups-zone-3': 16.62,
                      'ups-zone-4': 19.72,
                      'ups-zone-5': 23.91,
                      'ups-zone-6': 29.49,
                      'ups-zone-7': 35.56,
                      'ups-zone-8': 39.31,
                      'ups-zone-44': 107.97,
                      'ups-zone-45': 139.98,
                      'ups-zone-46': 114.18,
                    },
                    '50': {
                      'ups-zone-2': 13.32,
                      'ups-zone-3': 16.63,
                      'ups-zone-4': 19.73,
                      'ups-zone-5': 23.94,
                      'ups-zone-6': 29.5,
                      'ups-zone-7': 35.57,
                      'ups-zone-8': 39.53,
                      'ups-zone-44': 109.78,
                      'ups-zone-45': 140.03,
                      'ups-zone-46': 116.01,
                    },
                    '51': {
                      'ups-zone-2': 13.36,
                      'ups-zone-3': 16.63,
                      'ups-zone-4': 19.77,
                      'ups-zone-5': 23.98,
                      'ups-zone-6': 29.65,
                      'ups-zone-7': 35.74,
                      'ups-zone-8': 40.15,
                      'ups-zone-44': 112.02,
                      'ups-zone-45': 144.75,
                      'ups-zone-46': 119.37,
                    },
                    '52': {
                      'ups-zone-2': 13.36,
                      'ups-zone-3': 16.65,
                      'ups-zone-4': 19.79,
                      'ups-zone-5': 23.99,
                      'ups-zone-6': 29.65,
                      'ups-zone-7': 35.75,
                      'ups-zone-8': 40.15,
                      'ups-zone-44': 112.25,
                      'ups-zone-45': 145.06,
                      'ups-zone-46': 119.59,
                    },
                    '53': {
                      'ups-zone-2': 13.37,
                      'ups-zone-3': 16.68,
                      'ups-zone-4': 19.8,
                      'ups-zone-5': 24.14,
                      'ups-zone-6': 29.66,
                      'ups-zone-7': 35.76,
                      'ups-zone-8': 40.54,
                      'ups-zone-44': 113.94,
                      'ups-zone-45': 147.21,
                      'ups-zone-46': 121.3,
                    },
                    '54': {
                      'ups-zone-2': 13.37,
                      'ups-zone-3': 16.71,
                      'ups-zone-4': 19.83,
                      'ups-zone-5': 24.18,
                      'ups-zone-6': 29.66,
                      'ups-zone-7': 35.77,
                      'ups-zone-8': 40.57,
                      'ups-zone-44': 115.55,
                      'ups-zone-45': 149.03,
                      'ups-zone-46': 123.13,
                    },
                    '55': {
                      'ups-zone-2': 13.38,
                      'ups-zone-3': 16.74,
                      'ups-zone-4': 19.84,
                      'ups-zone-5': 24.29,
                      'ups-zone-6': 29.7,
                      'ups-zone-7': 35.77,
                      'ups-zone-8': 40.6,
                      'ups-zone-44': 117.11,
                      'ups-zone-45': 153.53,
                      'ups-zone-46': 124.99,
                    },
                    '56': {
                      'ups-zone-2': 13.39,
                      'ups-zone-3': 16.77,
                      'ups-zone-4': 19.87,
                      'ups-zone-5': 24.3,
                      'ups-zone-6': 29.7,
                      'ups-zone-7': 35.8,
                      'ups-zone-8': 41.06,
                      'ups-zone-44': 118.69,
                      'ups-zone-45': 153.99,
                      'ups-zone-46': 126.8,
                    },
                    '57': {
                      'ups-zone-2': 13.63,
                      'ups-zone-3': 16.82,
                      'ups-zone-4': 19.9,
                      'ups-zone-5': 25.03,
                      'ups-zone-6': 29.73,
                      'ups-zone-7': 35.83,
                      'ups-zone-8': 41.48,
                      'ups-zone-44': 120.32,
                      'ups-zone-45': 156.78,
                      'ups-zone-46': 128.77,
                    },
                    '58': {
                      'ups-zone-2': 13.63,
                      'ups-zone-3': 16.83,
                      'ups-zone-4': 19.91,
                      'ups-zone-5': 25.06,
                      'ups-zone-6': 29.74,
                      'ups-zone-7': 35.86,
                      'ups-zone-8': 42.22,
                      'ups-zone-44': 121.9,
                      'ups-zone-45': 159.4,
                      'ups-zone-46': 130.59,
                    },
                    '59': {
                      'ups-zone-2': 13.67,
                      'ups-zone-3': 16.84,
                      'ups-zone-4': 20.04,
                      'ups-zone-5': 25.06,
                      'ups-zone-6': 30.18,
                      'ups-zone-7': 35.89,
                      'ups-zone-8': 42.53,
                      'ups-zone-44': 123.75,
                      'ups-zone-45': 161.56,
                      'ups-zone-46': 132.53,
                    },
                    '60': {
                      'ups-zone-2': 14.02,
                      'ups-zone-3': 17.49,
                      'ups-zone-4': 20.38,
                      'ups-zone-5': 25.93,
                      'ups-zone-6': 30.46,
                      'ups-zone-7': 36.05,
                      'ups-zone-8': 42.8,
                      'ups-zone-44': 125.68,
                      'ups-zone-45': 163.54,
                      'ups-zone-46': 134.48,
                    },
                    '61': {
                      'ups-zone-2': 14.03,
                      'ups-zone-3': 17.55,
                      'ups-zone-4': 20.55,
                      'ups-zone-5': 26.01,
                      'ups-zone-6': 30.73,
                      'ups-zone-7': 36.26,
                      'ups-zone-8': 43.06,
                      'ups-zone-44': 127.23,
                      'ups-zone-45': 166.47,
                      'ups-zone-46': 136.09,
                    },
                    '62': {
                      'ups-zone-2': 14.6,
                      'ups-zone-3': 18.79,
                      'ups-zone-4': 20.92,
                      'ups-zone-5': 26.75,
                      'ups-zone-6': 30.93,
                      'ups-zone-7': 36.82,
                      'ups-zone-8': 43.33,
                      'ups-zone-44': 129.32,
                      'ups-zone-45': 169.94,
                      'ups-zone-46': 138.21,
                    },
                    '63': {
                      'ups-zone-2': 14.61,
                      'ups-zone-3': 18.79,
                      'ups-zone-4': 21.12,
                      'ups-zone-5': 26.76,
                      'ups-zone-6': 31.15,
                      'ups-zone-7': 36.89,
                      'ups-zone-8': 43.59,
                      'ups-zone-44': 131.44,
                      'ups-zone-45': 172.71,
                      'ups-zone-46': 140.38,
                    },
                    '64': {
                      'ups-zone-2': 15.0,
                      'ups-zone-3': 18.98,
                      'ups-zone-4': 21.47,
                      'ups-zone-5': 26.79,
                      'ups-zone-6': 31.66,
                      'ups-zone-7': 37.13,
                      'ups-zone-8': 44.26,
                      'ups-zone-44': 133.63,
                      'ups-zone-45': 174.9,
                      'ups-zone-46': 142.64,
                    },
                    '65': {
                      'ups-zone-2': 15.17,
                      'ups-zone-3': 19.49,
                      'ups-zone-4': 21.47,
                      'ups-zone-5': 26.82,
                      'ups-zone-6': 31.93,
                      'ups-zone-7': 37.22,
                      'ups-zone-8': 44.34,
                      'ups-zone-44': 135.81,
                      'ups-zone-45': 177.95,
                      'ups-zone-46': 144.9,
                    },
                    '66': {
                      'ups-zone-2': 15.38,
                      'ups-zone-3': 19.5,
                      'ups-zone-4': 21.48,
                      'ups-zone-5': 26.83,
                      'ups-zone-6': 31.95,
                      'ups-zone-7': 37.33,
                      'ups-zone-8': 44.53,
                      'ups-zone-44': 137.91,
                      'ups-zone-45': 180.99,
                      'ups-zone-46': 147.04,
                    },
                    '67': {
                      'ups-zone-2': 15.38,
                      'ups-zone-3': 19.53,
                      'ups-zone-4': 21.48,
                      'ups-zone-5': 26.86,
                      'ups-zone-6': 32.2,
                      'ups-zone-7': 37.52,
                      'ups-zone-8': 44.55,
                      'ups-zone-44': 140.0,
                      'ups-zone-45': 181.63,
                      'ups-zone-46': 149.22,
                    },
                    '68': {
                      'ups-zone-2': 15.56,
                      'ups-zone-3': 20.05,
                      'ups-zone-4': 22.78,
                      'ups-zone-5': 27.42,
                      'ups-zone-6': 32.37,
                      'ups-zone-7': 37.73,
                      'ups-zone-8': 44.58,
                      'ups-zone-44': 142.02,
                      'ups-zone-45': 186.42,
                      'ups-zone-46': 151.27,
                    },
                    '69': {
                      'ups-zone-2': 15.73,
                      'ups-zone-3': 20.06,
                      'ups-zone-4': 22.94,
                      'ups-zone-5': 27.64,
                      'ups-zone-6': 32.55,
                      'ups-zone-7': 37.76,
                      'ups-zone-8': 44.77,
                      'ups-zone-44': 144.09,
                      'ups-zone-45': 189.09,
                      'ups-zone-46': 153.39,
                    },
                    '70': {
                      'ups-zone-2': 15.81,
                      'ups-zone-3': 20.33,
                      'ups-zone-4': 23.44,
                      'ups-zone-5': 28.81,
                      'ups-zone-6': 33.2,
                      'ups-zone-7': 37.79,
                      'ups-zone-8': 45.15,
                      'ups-zone-44': 147.12,
                      'ups-zone-45': 191.38,
                      'ups-zone-46': 155.28,
                    },
                    '71': {
                      'ups-zone-2': 15.84,
                      'ups-zone-3': 20.37,
                      'ups-zone-4': 23.86,
                      'ups-zone-5': 28.96,
                      'ups-zone-6': 33.79,
                      'ups-zone-7': 38.78,
                      'ups-zone-8': 45.24,
                      'ups-zone-44': 149.38,
                      'ups-zone-45': 191.92,
                      'ups-zone-46': 158.04,
                    },
                    '72': {
                      'ups-zone-2': 16.3,
                      'ups-zone-3': 20.38,
                      'ups-zone-4': 24.35,
                      'ups-zone-5': 28.97,
                      'ups-zone-6': 34.03,
                      'ups-zone-7': 40.06,
                      'ups-zone-8': 45.56,
                      'ups-zone-44': 151.6,
                      'ups-zone-45': 192.36,
                      'ups-zone-46': 160.3,
                    },
                    '73': {
                      'ups-zone-2': 16.4,
                      'ups-zone-3': 20.58,
                      'ups-zone-4': 24.36,
                      'ups-zone-5': 29.4,
                      'ups-zone-6': 34.35,
                      'ups-zone-7': 40.4,
                      'ups-zone-8': 45.64,
                      'ups-zone-44': 153.82,
                      'ups-zone-45': 194.39,
                      'ups-zone-46': 162.57,
                    },
                    '74': {
                      'ups-zone-2': 16.99,
                      'ups-zone-3': 20.58,
                      'ups-zone-4': 24.37,
                      'ups-zone-5': 29.41,
                      'ups-zone-6': 34.92,
                      'ups-zone-7': 40.51,
                      'ups-zone-8': 45.74,
                      'ups-zone-44': 155.3,
                      'ups-zone-45': 204.06,
                      'ups-zone-46': 163.08,
                    },
                    '75': {
                      'ups-zone-2': 17.63,
                      'ups-zone-3': 20.61,
                      'ups-zone-4': 24.37,
                      'ups-zone-5': 29.67,
                      'ups-zone-6': 35.26,
                      'ups-zone-7': 40.92,
                      'ups-zone-8': 45.75,
                      'ups-zone-44': 157.06,
                      'ups-zone-45': 204.67,
                      'ups-zone-46': 164.25,
                    },
                    '76': {
                      'ups-zone-2': 18.82,
                      'ups-zone-3': 21.76,
                      'ups-zone-4': 24.53,
                      'ups-zone-5': 30.13,
                      'ups-zone-6': 35.7,
                      'ups-zone-7': 41.59,
                      'ups-zone-8': 45.78,
                      'ups-zone-44': 159.0,
                      'ups-zone-45': 204.75,
                      'ups-zone-46': 166.21,
                    },
                    '77': {
                      'ups-zone-2': 19.56,
                      'ups-zone-3': 22.08,
                      'ups-zone-4': 24.83,
                      'ups-zone-5': 30.26,
                      'ups-zone-6': 35.91,
                      'ups-zone-7': 42.38,
                      'ups-zone-8': 45.81,
                      'ups-zone-44': 160.31,
                      'ups-zone-45': 205.41,
                      'ups-zone-46': 167.18,
                    },
                    '78': {
                      'ups-zone-2': 19.57,
                      'ups-zone-3': 22.91,
                      'ups-zone-4': 25.56,
                      'ups-zone-5': 30.58,
                      'ups-zone-6': 36.13,
                      'ups-zone-7': 43.09,
                      'ups-zone-8': 45.81,
                      'ups-zone-44': 161.17,
                      'ups-zone-45': 206.07,
                      'ups-zone-46': 168.39,
                    },
                    '79': {
                      'ups-zone-2': 20.65,
                      'ups-zone-3': 23.84,
                      'ups-zone-4': 26.17,
                      'ups-zone-5': 31.06,
                      'ups-zone-6': 36.88,
                      'ups-zone-7': 43.76,
                      'ups-zone-8': 46.52,
                      'ups-zone-44': 161.2,
                      'ups-zone-45': 211.81,
                      'ups-zone-46': 168.87,
                    },
                    '80': {
                      'ups-zone-2': 21.01,
                      'ups-zone-3': 24.31,
                      'ups-zone-4': 26.31,
                      'ups-zone-5': 31.81,
                      'ups-zone-6': 37.5,
                      'ups-zone-7': 43.95,
                      'ups-zone-8': 46.87,
                      'ups-zone-44': 162.88,
                      'ups-zone-45': 213.91,
                      'ups-zone-46': 169.73,
                    },
                    '81': {
                      'ups-zone-2': 21.53,
                      'ups-zone-3': 24.51,
                      'ups-zone-4': 26.95,
                      'ups-zone-5': 32.02,
                      'ups-zone-6': 37.99,
                      'ups-zone-7': 44.62,
                      'ups-zone-8': 47.46,
                      'ups-zone-44': 164.24,
                      'ups-zone-45': 214.21,
                      'ups-zone-46': 170.6,
                    },
                    '82': {
                      'ups-zone-2': 22.41,
                      'ups-zone-3': 25.34,
                      'ups-zone-4': 28.17,
                      'ups-zone-5': 32.8,
                      'ups-zone-6': 38.08,
                      'ups-zone-7': 45.77,
                      'ups-zone-8': 47.47,
                      'ups-zone-44': 165.06,
                      'ups-zone-45': 216.9,
                      'ups-zone-46': 171.38,
                    },
                    '83': {
                      'ups-zone-2': 22.44,
                      'ups-zone-3': 25.35,
                      'ups-zone-4': 28.17,
                      'ups-zone-5': 32.84,
                      'ups-zone-6': 38.56,
                      'ups-zone-7': 45.78,
                      'ups-zone-8': 47.48,
                      'ups-zone-44': 166.87,
                      'ups-zone-45': 219.27,
                      'ups-zone-46': 172.05,
                    },
                    '84': {
                      'ups-zone-2': 23.33,
                      'ups-zone-3': 26.18,
                      'ups-zone-4': 28.99,
                      'ups-zone-5': 33.16,
                      'ups-zone-6': 39.14,
                      'ups-zone-7': 46.33,
                      'ups-zone-8': 47.84,
                      'ups-zone-44': 168.79,
                      'ups-zone-45': 221.8,
                      'ups-zone-46': 173.97,
                    },
                    '85': {
                      'ups-zone-2': 23.73,
                      'ups-zone-3': 26.36,
                      'ups-zone-4': 29.01,
                      'ups-zone-5': 33.69,
                      'ups-zone-6': 39.74,
                      'ups-zone-7': 46.83,
                      'ups-zone-8': 48.37,
                      'ups-zone-44': 170.75,
                      'ups-zone-45': 224.37,
                      'ups-zone-46': 175.93,
                    },
                    '86': {
                      'ups-zone-2': 24.84,
                      'ups-zone-3': 27.56,
                      'ups-zone-4': 30.15,
                      'ups-zone-5': 34.33,
                      'ups-zone-6': 40.22,
                      'ups-zone-7': 47.7,
                      'ups-zone-8': 49.38,
                      'ups-zone-44': 172.55,
                      'ups-zone-45': 226.74,
                      'ups-zone-46': 177.74,
                    },
                    '87': {
                      'ups-zone-2': 25.11,
                      'ups-zone-3': 27.57,
                      'ups-zone-4': 30.15,
                      'ups-zone-5': 34.34,
                      'ups-zone-6': 40.75,
                      'ups-zone-7': 47.75,
                      'ups-zone-8': 49.46,
                      'ups-zone-44': 174.49,
                      'ups-zone-45': 229.28,
                      'ups-zone-46': 179.66,
                    },
                    '88': {
                      'ups-zone-2': 26.4,
                      'ups-zone-3': 28.46,
                      'ups-zone-4': 31.39,
                      'ups-zone-5': 35.44,
                      'ups-zone-6': 41.28,
                      'ups-zone-7': 48.24,
                      'ups-zone-8': 50.47,
                      'ups-zone-44': 176.42,
                      'ups-zone-45': 231.81,
                      'ups-zone-46': 181.61,
                    },
                    '89': {
                      'ups-zone-2': 27.32,
                      'ups-zone-3': 28.98,
                      'ups-zone-4': 31.71,
                      'ups-zone-5': 35.56,
                      'ups-zone-6': 41.79,
                      'ups-zone-7': 48.74,
                      'ups-zone-8': 51.53,
                      'ups-zone-44': 178.26,
                      'ups-zone-45': 234.22,
                      'ups-zone-46': 183.44,
                    },
                    '90': {
                      'ups-zone-2': 28.97,
                      'ups-zone-3': 30.24,
                      'ups-zone-4': 33.05,
                      'ups-zone-5': 36.6,
                      'ups-zone-6': 42.38,
                      'ups-zone-7': 49.4,
                      'ups-zone-8': 52.06,
                      'ups-zone-44': 180.06,
                      'ups-zone-45': 236.61,
                      'ups-zone-46': 185.95,
                    },
                    '91': {
                      'ups-zone-2': 28.98,
                      'ups-zone-3': 30.24,
                      'ups-zone-4': 33.06,
                      'ups-zone-5': 36.64,
                      'ups-zone-6': 42.46,
                      'ups-zone-7': 49.41,
                      'ups-zone-8': 52.06,
                      'ups-zone-44': 181.99,
                      'ups-zone-45': 237.92,
                      'ups-zone-46': 187.14,
                    },
                    '92': {
                      'ups-zone-2': 29.9,
                      'ups-zone-3': 30.78,
                      'ups-zone-4': 33.23,
                      'ups-zone-5': 36.91,
                      'ups-zone-6': 43.25,
                      'ups-zone-7': 49.42,
                      'ups-zone-8': 52.61,
                      'ups-zone-44': 183.73,
                      'ups-zone-45': 240.01,
                      'ups-zone-46': 188.88,
                    },
                    '93': {
                      'ups-zone-2': 30.03,
                      'ups-zone-3': 31.11,
                      'ups-zone-4': 33.89,
                      'ups-zone-5': 36.99,
                      'ups-zone-6': 43.34,
                      'ups-zone-7': 49.42,
                      'ups-zone-8': 52.71,
                      'ups-zone-44': 185.51,
                      'ups-zone-45': 240.09,
                      'ups-zone-46': 190.68,
                    },
                    '94': {
                      'ups-zone-2': 30.18,
                      'ups-zone-3': 31.63,
                      'ups-zone-4': 34.06,
                      'ups-zone-5': 37.48,
                      'ups-zone-6': 43.85,
                      'ups-zone-7': 49.43,
                      'ups-zone-8': 53.26,
                      'ups-zone-44': 187.27,
                      'ups-zone-45': 246.08,
                      'ups-zone-46': 192.46,
                    },
                    '95': {
                      'ups-zone-2': 30.88,
                      'ups-zone-3': 32.21,
                      'ups-zone-4': 34.29,
                      'ups-zone-5': 37.98,
                      'ups-zone-6': 44.15,
                      'ups-zone-7': 49.61,
                      'ups-zone-8': 53.83,
                      'ups-zone-44': 189.09,
                      'ups-zone-45': 248.24,
                      'ups-zone-46': 194.26,
                    },
                    '96': {
                      'ups-zone-2': 31.87,
                      'ups-zone-3': 32.43,
                      'ups-zone-4': 35.54,
                      'ups-zone-5': 38.77,
                      'ups-zone-6': 44.4,
                      'ups-zone-7': 49.94,
                      'ups-zone-8': 54.86,
                      'ups-zone-44': 190.81,
                      'ups-zone-45': 249.41,
                      'ups-zone-46': 195.97,
                    },
                    '97': {
                      'ups-zone-2': 32.61,
                      'ups-zone-3': 33.38,
                      'ups-zone-4': 36.06,
                      'ups-zone-5': 38.98,
                      'ups-zone-6': 44.89,
                      'ups-zone-7': 50.32,
                      'ups-zone-8': 55.44,
                      'ups-zone-44': 192.63,
                      'ups-zone-45': 249.62,
                      'ups-zone-46': 197.78,
                    },
                    '98': {
                      'ups-zone-2': 33.04,
                      'ups-zone-3': 33.6,
                      'ups-zone-4': 36.06,
                      'ups-zone-5': 39.44,
                      'ups-zone-6': 45.4,
                      'ups-zone-7': 50.32,
                      'ups-zone-8': 55.46,
                      'ups-zone-44': 194.34,
                      'ups-zone-45': 249.76,
                      'ups-zone-46': 199.55,
                    },
                    '99': {
                      'ups-zone-2': 33.76,
                      'ups-zone-3': 34.12,
                      'ups-zone-4': 37.42,
                      'ups-zone-5': 39.93,
                      'ups-zone-6': 45.93,
                      'ups-zone-7': 50.83,
                      'ups-zone-8': 56.0,
                      'ups-zone-44': 196.16,
                      'ups-zone-45': 249.94,
                      'ups-zone-46': 201.33,
                    },
                    '100': {
                      'ups-zone-2': 34.35,
                      'ups-zone-3': 34.69,
                      'ups-zone-4': 37.43,
                      'ups-zone-5': 40.56,
                      'ups-zone-6': 46.47,
                      'ups-zone-7': 51.34,
                      'ups-zone-8': 56.55,
                      'ups-zone-44': 197.98,
                      'ups-zone-45': 260.16,
                      'ups-zone-46': 203.16,
                    },
                    '101': {
                      'ups-zone-2': 34.62,
                      'ups-zone-3': 34.7,
                      'ups-zone-4': 37.44,
                      'ups-zone-5': 40.57,
                      'ups-zone-6': 46.48,
                      'ups-zone-7': 51.34,
                      'ups-zone-8': 56.58,
                      'ups-zone-44': 197.99,
                      'ups-zone-45': 262.55,
                      'ups-zone-46': 203.16,
                    },
                    '102': {
                      'ups-zone-2': 34.62,
                      'ups-zone-3': 34.7,
                      'ups-zone-4': 37.44,
                      'ups-zone-5': 40.58,
                      'ups-zone-6': 46.48,
                      'ups-zone-7': 51.35,
                      'ups-zone-8': 56.61,
                      'ups-zone-44': 198.0,
                      'ups-zone-45': 264.98,
                      'ups-zone-46': 203.2,
                    },
                    '103': {
                      'ups-zone-2': 35.41,
                      'ups-zone-3': 35.56,
                      'ups-zone-4': 38.21,
                      'ups-zone-5': 40.81,
                      'ups-zone-6': 46.89,
                      'ups-zone-7': 51.65,
                      'ups-zone-8': 56.62,
                      'ups-zone-44': 198.0,
                      'ups-zone-45': 267.36,
                      'ups-zone-46': 203.22,
                    },
                    '104': {
                      'ups-zone-2': 35.42,
                      'ups-zone-3': 35.73,
                      'ups-zone-4': 38.31,
                      'ups-zone-5': 41.25,
                      'ups-zone-6': 47.04,
                      'ups-zone-7': 51.8,
                      'ups-zone-8': 56.96,
                      'ups-zone-44': 198.2,
                      'ups-zone-45': 269.9,
                      'ups-zone-46': 203.25,
                    },
                    '105': {
                      'ups-zone-2': 36.33,
                      'ups-zone-3': 36.62,
                      'ups-zone-4': 39.12,
                      'ups-zone-5': 42.1,
                      'ups-zone-6': 47.76,
                      'ups-zone-7': 52.6,
                      'ups-zone-8': 58.01,
                      'ups-zone-44': 199.97,
                      'ups-zone-45': 272.29,
                      'ups-zone-46': 203.99,
                    },
                    '106': {
                      'ups-zone-2': 36.59,
                      'ups-zone-3': 36.81,
                      'ups-zone-4': 39.18,
                      'ups-zone-5': 42.1,
                      'ups-zone-6': 47.77,
                      'ups-zone-7': 52.61,
                      'ups-zone-8': 58.01,
                      'ups-zone-44': 201.82,
                      'ups-zone-45': 274.8,
                      'ups-zone-46': 205.85,
                    },
                    '107': {
                      'ups-zone-2': 37.13,
                      'ups-zone-3': 37.36,
                      'ups-zone-4': 40.03,
                      'ups-zone-5': 42.94,
                      'ups-zone-6': 48.19,
                      'ups-zone-7': 53.03,
                      'ups-zone-8': 59.02,
                      'ups-zone-44': 203.69,
                      'ups-zone-45': 277.35,
                      'ups-zone-46': 207.7,
                    },
                    '108': {
                      'ups-zone-2': 37.65,
                      'ups-zone-3': 37.9,
                      'ups-zone-4': 40.09,
                      'ups-zone-5': 42.96,
                      'ups-zone-6': 48.64,
                      'ups-zone-7': 53.5,
                      'ups-zone-8': 59.02,
                      'ups-zone-44': 205.54,
                      'ups-zone-45': 279.87,
                      'ups-zone-46': 210.03,
                    },
                    '109': {
                      'ups-zone-2': 38.38,
                      'ups-zone-3': 38.44,
                      'ups-zone-4': 40.52,
                      'ups-zone-5': 43.38,
                      'ups-zone-6': 49.07,
                      'ups-zone-7': 53.95,
                      'ups-zone-8': 59.54,
                      'ups-zone-44': 207.31,
                      'ups-zone-45': 282.28,
                      'ups-zone-46': 211.81,
                    },
                    '110': {
                      'ups-zone-2': 39.09,
                      'ups-zone-3': 39.36,
                      'ups-zone-4': 41.38,
                      'ups-zone-5': 44.13,
                      'ups-zone-6': 49.96,
                      'ups-zone-7': 54.96,
                      'ups-zone-8': 60.64,
                      'ups-zone-44': 209.05,
                      'ups-zone-45': 284.65,
                      'ups-zone-46': 213.03,
                    },
                    '111': {
                      'ups-zone-2': 39.1,
                      'ups-zone-3': 39.42,
                      'ups-zone-4': 42.29,
                      'ups-zone-5': 44.65,
                      'ups-zone-6': 49.97,
                      'ups-zone-7': 55.35,
                      'ups-zone-8': 61.36,
                      'ups-zone-44': 211.43,
                      'ups-zone-45': 287.9,
                      'ups-zone-46': 215.94,
                    },
                    '112': {
                      'ups-zone-2': 39.9,
                      'ups-zone-3': 40.23,
                      'ups-zone-4': 42.3,
                      'ups-zone-5': 44.65,
                      'ups-zone-6': 50.39,
                      'ups-zone-7': 55.36,
                      'ups-zone-8': 61.37,
                      'ups-zone-44': 213.82,
                      'ups-zone-45': 291.14,
                      'ups-zone-46': 218.88,
                    },
                    '113': {
                      'ups-zone-2': 39.93,
                      'ups-zone-3': 40.27,
                      'ups-zone-4': 42.77,
                      'ups-zone-5': 45.06,
                      'ups-zone-6': 50.84,
                      'ups-zone-7': 55.81,
                      'ups-zone-8': 62.48,
                      'ups-zone-44': 215.67,
                      'ups-zone-45': 293.67,
                      'ups-zone-46': 220.73,
                    },
                    '114': {
                      'ups-zone-2': 40.36,
                      'ups-zone-3': 41.1,
                      'ups-zone-4': 43.66,
                      'ups-zone-5': 45.94,
                      'ups-zone-6': 51.7,
                      'ups-zone-7': 56.75,
                      'ups-zone-8': 62.89,
                      'ups-zone-44': 217.55,
                      'ups-zone-45': 296.22,
                      'ups-zone-46': 222.6,
                    },
                    '115': {
                      'ups-zone-2': 41.16,
                      'ups-zone-3': 41.95,
                      'ups-zone-4': 44.04,
                      'ups-zone-5': 46.41,
                      'ups-zone-6': 52.09,
                      'ups-zone-7': 57.18,
                      'ups-zone-8': 63.36,
                      'ups-zone-44': 219.4,
                      'ups-zone-45': 298.75,
                      'ups-zone-46': 224.47,
                    },
                    '116': {
                      'ups-zone-2': 41.58,
                      'ups-zone-3': 42.09,
                      'ups-zone-4': 44.62,
                      'ups-zone-5': 46.62,
                      'ups-zone-6': 52.36,
                      'ups-zone-7': 58.0,
                      'ups-zone-8': 63.76,
                      'ups-zone-44': 220.77,
                      'ups-zone-45': 300.61,
                      'ups-zone-46': 226.26,
                    },
                    '117': {
                      'ups-zone-2': 41.63,
                      'ups-zone-3': 42.17,
                      'ups-zone-4': 44.63,
                      'ups-zone-5': 47.13,
                      'ups-zone-6': 52.47,
                      'ups-zone-7': 58.01,
                      'ups-zone-8': 64.31,
                      'ups-zone-44': 222.53,
                      'ups-zone-45': 303.01,
                      'ups-zone-46': 228.56,
                    },
                    '118': {
                      'ups-zone-2': 42.07,
                      'ups-zone-3': 43.03,
                      'ups-zone-4': 44.67,
                      'ups-zone-5': 47.27,
                      'ups-zone-6': 52.9,
                      'ups-zone-7': 58.01,
                      'ups-zone-8': 65.36,
                      'ups-zone-44': 224.28,
                      'ups-zone-45': 305.4,
                      'ups-zone-46': 229.78,
                    },
                    '119': {
                      'ups-zone-2': 43.24,
                      'ups-zone-3': 43.45,
                      'ups-zone-4': 46.0,
                      'ups-zone-5': 47.89,
                      'ups-zone-6': 53.35,
                      'ups-zone-7': 58.47,
                      'ups-zone-8': 65.92,
                      'ups-zone-44': 227.53,
                      'ups-zone-45': 309.83,
                      'ups-zone-46': 234.21,
                    },
                    '120': {
                      'ups-zone-2': 44.05,
                      'ups-zone-3': 44.12,
                      'ups-zone-4': 46.06,
                      'ups-zone-5': 48.31,
                      'ups-zone-6': 53.78,
                      'ups-zone-7': 59.24,
                      'ups-zone-8': 66.02,
                      'ups-zone-44': 229.4,
                      'ups-zone-45': 312.37,
                      'ups-zone-46': 236.67,
                    },
                    '121': {
                      'ups-zone-2': 44.08,
                      'ups-zone-3': 44.12,
                      'ups-zone-4': 46.07,
                      'ups-zone-5': 48.33,
                      'ups-zone-6': 54.13,
                      'ups-zone-7': 59.25,
                      'ups-zone-8': 66.03,
                      'ups-zone-44': 230.93,
                      'ups-zone-45': 314.44,
                      'ups-zone-46': 238.11,
                    },
                    '122': {
                      'ups-zone-2': 44.09,
                      'ups-zone-3': 44.97,
                      'ups-zone-4': 46.52,
                      'ups-zone-5': 48.76,
                      'ups-zone-6': 54.55,
                      'ups-zone-7': 60.18,
                      'ups-zone-8': 66.57,
                      'ups-zone-44': 232.89,
                      'ups-zone-45': 317.12,
                      'ups-zone-46': 240.08,
                    },
                    '123': {
                      'ups-zone-2': 45.23,
                      'ups-zone-3': 45.4,
                      'ups-zone-4': 48.37,
                      'ups-zone-5': 49.98,
                      'ups-zone-6': 54.98,
                      'ups-zone-7': 61.37,
                      'ups-zone-8': 67.96,
                      'ups-zone-44': 234.87,
                      'ups-zone-45': 319.82,
                      'ups-zone-46': 242.07,
                    },
                    '124': {
                      'ups-zone-2': 45.28,
                      'ups-zone-3': 45.46,
                      'ups-zone-4': 48.42,
                      'ups-zone-5': 49.99,
                      'ups-zone-6': 55.74,
                      'ups-zone-7': 61.37,
                      'ups-zone-8': 68.11,
                      'ups-zone-44': 236.83,
                      'ups-zone-45': 322.49,
                      'ups-zone-46': 244.05,
                    },
                    '125': {
                      'ups-zone-2': 45.35,
                      'ups-zone-3': 45.47,
                      'ups-zone-4': 48.42,
                      'ups-zone-5': 50.09,
                      'ups-zone-6': 55.86,
                      'ups-zone-7': 61.38,
                      'ups-zone-8': 68.11,
                      'ups-zone-44': 238.81,
                      'ups-zone-45': 325.17,
                      'ups-zone-46': 246.05,
                    },
                    '126': {
                      'ups-zone-2': 46.26,
                      'ups-zone-3': 46.35,
                      'ups-zone-4': 49.38,
                      'ups-zone-5': 50.38,
                      'ups-zone-6': 56.19,
                      'ups-zone-7': 61.87,
                      'ups-zone-8': 70.37,
                      'ups-zone-44': 240.29,
                      'ups-zone-45': 327.18,
                      'ups-zone-46': 248.61,
                    },
                    '127': {
                      'ups-zone-2': 46.26,
                      'ups-zone-3': 46.71,
                      'ups-zone-4': 49.86,
                      'ups-zone-5': 51.14,
                      'ups-zone-6': 57.03,
                      'ups-zone-7': 62.34,
                      'ups-zone-8': 70.37,
                      'ups-zone-44': 242.24,
                      'ups-zone-45': 329.85,
                      'ups-zone-46': 249.99,
                    },
                    '128': {
                      'ups-zone-2': 46.67,
                      'ups-zone-3': 46.71,
                      'ups-zone-4': 49.87,
                      'ups-zone-5': 51.25,
                      'ups-zone-6': 57.47,
                      'ups-zone-7': 62.99,
                      'ups-zone-8': 70.9,
                      'ups-zone-44': 244.21,
                      'ups-zone-45': 332.55,
                      'ups-zone-46': 252.58,
                    },
                    '129': {
                      'ups-zone-2': 47.58,
                      'ups-zone-3': 47.76,
                      'ups-zone-4': 50.36,
                      'ups-zone-5': 51.98,
                      'ups-zone-6': 57.48,
                      'ups-zone-7': 63.0,
                      'ups-zone-8': 71.43,
                      'ups-zone-44': 246.18,
                      'ups-zone-45': 335.21,
                      'ups-zone-46': 254.6,
                    },
                    '130': {
                      'ups-zone-2': 47.71,
                      'ups-zone-3': 47.77,
                      'ups-zone-4': 50.82,
                      'ups-zone-5': 52.09,
                      'ups-zone-6': 57.89,
                      'ups-zone-7': 63.82,
                      'ups-zone-8': 72.55,
                      'ups-zone-44': 252.93,
                      'ups-zone-45': 337.89,
                      'ups-zone-46': 261.51,
                    },
                    '131': {
                      'ups-zone-2': 47.99,
                      'ups-zone-3': 48.07,
                      'ups-zone-4': 51.45,
                      'ups-zone-5': 52.44,
                      'ups-zone-6': 58.2,
                      'ups-zone-7': 64.29,
                      'ups-zone-8': 73.09,
                      'ups-zone-44': 252.93,
                      'ups-zone-45': 341.52,
                      'ups-zone-46': 262.65,
                    },
                    '132': {
                      'ups-zone-2': 48.5,
                      'ups-zone-3': 49.0,
                      'ups-zone-4': 51.79,
                      'ups-zone-5': 52.87,
                      'ups-zone-6': 58.64,
                      'ups-zone-7': 64.3,
                      'ups-zone-8': 73.1,
                      'ups-zone-44': 255.2,
                      'ups-zone-45': 344.22,
                      'ups-zone-46': 265.61,
                    },
                    '133': {
                      'ups-zone-2': 48.94,
                      'ups-zone-3': 49.08,
                      'ups-zone-4': 51.79,
                      'ups-zone-5': 53.3,
                      'ups-zone-6': 59.05,
                      'ups-zone-7': 64.43,
                      'ups-zone-8': 73.1,
                      'ups-zone-44': 256.73,
                      'ups-zone-45': 346.89,
                      'ups-zone-46': 266.51,
                    },
                    '134': {
                      'ups-zone-2': 49.76,
                      'ups-zone-3': 49.88,
                      'ups-zone-4': 52.77,
                      'ups-zone-5': 54.15,
                      'ups-zone-6': 59.95,
                      'ups-zone-7': 65.36,
                      'ups-zone-8': 73.43,
                      'ups-zone-44': 256.74,
                      'ups-zone-45': 349.59,
                      'ups-zone-46': 266.54,
                    },
                    '135': {
                      'ups-zone-2': 50.24,
                      'ups-zone-3': 50.43,
                      'ups-zone-4': 53.27,
                      'ups-zone-5': 54.59,
                      'ups-zone-6': 60.47,
                      'ups-zone-7': 65.83,
                      'ups-zone-8': 73.93,
                      'ups-zone-44': 258.69,
                      'ups-zone-45': 352.25,
                      'ups-zone-46': 269.1,
                    },
                    '136': {
                      'ups-zone-2': 50.25,
                      'ups-zone-3': 51.03,
                      'ups-zone-4': 54.13,
                      'ups-zone-5': 55.06,
                      'ups-zone-6': 60.74,
                      'ups-zone-7': 66.13,
                      'ups-zone-8': 74.29,
                      'ups-zone-44': 260.66,
                      'ups-zone-45': 354.93,
                      'ups-zone-46': 271.11,
                    },
                    '137': {
                      'ups-zone-2': 50.62,
                      'ups-zone-3': 51.03,
                      'ups-zone-4': 55.05,
                      'ups-zone-5': 55.58,
                      'ups-zone-6': 60.82,
                      'ups-zone-7': 66.25,
                      'ups-zone-8': 74.44,
                      'ups-zone-44': 265.15,
                      'ups-zone-45': 357.64,
                      'ups-zone-46': 275.75,
                    },
                    '138': {
                      'ups-zone-2': 51.07,
                      'ups-zone-3': 51.84,
                      'ups-zone-4': 55.32,
                      'ups-zone-5': 56.03,
                      'ups-zone-6': 61.89,
                      'ups-zone-7': 67.43,
                      'ups-zone-8': 75.79,
                      'ups-zone-44': 266.57,
                      'ups-zone-45': 360.3,
                      'ups-zone-46': 277.2,
                    },
                    '139': {
                      'ups-zone-2': 51.98,
                      'ups-zone-3': 52.36,
                      'ups-zone-4': 55.33,
                      'ups-zone-5': 56.05,
                      'ups-zone-6': 62.08,
                      'ups-zone-7': 67.91,
                      'ups-zone-8': 76.35,
                      'ups-zone-44': 266.57,
                      'ups-zone-45': 363.0,
                      'ups-zone-46': 277.22,
                    },
                    '140': {
                      'ups-zone-2': 52.45,
                      'ups-zone-3': 52.85,
                      'ups-zone-4': 55.87,
                      'ups-zone-5': 56.81,
                      'ups-zone-6': 62.61,
                      'ups-zone-7': 67.92,
                      'ups-zone-8': 76.96,
                      'ups-zone-44': 268.44,
                      'ups-zone-45': 365.52,
                      'ups-zone-46': 279.06,
                    },
                    '141': {
                      'ups-zone-2': 52.46,
                      'ups-zone-3': 52.86,
                      'ups-zone-4': 56.37,
                      'ups-zone-5': 56.93,
                      'ups-zone-6': 62.74,
                      'ups-zone-7': 68.06,
                      'ups-zone-8': 76.96,
                      'ups-zone-44': 269.77,
                      'ups-zone-45': 367.35,
                      'ups-zone-46': 280.28,
                    },
                    '142': {
                      'ups-zone-2': 53.13,
                      'ups-zone-3': 53.84,
                      'ups-zone-4': 56.87,
                      'ups-zone-5': 57.81,
                      'ups-zone-6': 63.56,
                      'ups-zone-7': 69.01,
                      'ups-zone-8': 77.36,
                      'ups-zone-44': 274.27,
                      'ups-zone-45': 369.95,
                      'ups-zone-46': 285.59,
                    },
                    '143': {
                      'ups-zone-2': 53.14,
                      'ups-zone-3': 53.84,
                      'ups-zone-4': 56.87,
                      'ups-zone-5': 57.85,
                      'ups-zone-6': 63.69,
                      'ups-zone-7': 69.01,
                      'ups-zone-8': 77.42,
                      'ups-zone-44': 276.13,
                      'ups-zone-45': 372.44,
                      'ups-zone-46': 287.5,
                    },
                    '144': {
                      'ups-zone-2': 54.58,
                      'ups-zone-3': 55.37,
                      'ups-zone-4': 58.97,
                      'ups-zone-5': 59.54,
                      'ups-zone-6': 64.65,
                      'ups-zone-7': 70.66,
                      'ups-zone-8': 79.04,
                      'ups-zone-44': 278.03,
                      'ups-zone-45': 374.99,
                      'ups-zone-46': 289.43,
                    },
                    '145': {
                      'ups-zone-2': 54.77,
                      'ups-zone-3': 56.41,
                      'ups-zone-4': 58.97,
                      'ups-zone-5': 59.66,
                      'ups-zone-6': 65.61,
                      'ups-zone-7': 71.4,
                      'ups-zone-8': 79.54,
                      'ups-zone-44': 278.03,
                      'ups-zone-45': 377.65,
                      'ups-zone-46': 289.46,
                    },
                    '146': {
                      'ups-zone-2': 54.77,
                      'ups-zone-3': 56.44,
                      'ups-zone-4': 59.05,
                      'ups-zone-5': 59.67,
                      'ups-zone-6': 65.62,
                      'ups-zone-7': 71.41,
                      'ups-zone-8': 79.55,
                      'ups-zone-44': 279.33,
                      'ups-zone-45': 380.34,
                      'ups-zone-46': 290.73,
                    },
                    '147': {
                      'ups-zone-2': 55.53,
                      'ups-zone-3': 56.47,
                      'ups-zone-4': 59.52,
                      'ups-zone-5': 60.15,
                      'ups-zone-6': 66.09,
                      'ups-zone-7': 71.42,
                      'ups-zone-8': 80.1,
                      'ups-zone-44': 283.96,
                      'ups-zone-45': 383.0,
                      'ups-zone-46': 295.51,
                    },
                    '148': {
                      'ups-zone-2': 55.83,
                      'ups-zone-3': 56.84,
                      'ups-zone-4': 60.09,
                      'ups-zone-5': 60.66,
                      'ups-zone-6': 66.93,
                      'ups-zone-7': 71.89,
                      'ups-zone-8': 81.29,
                      'ups-zone-44': 285.98,
                      'ups-zone-45': 385.69,
                      'ups-zone-46': 296.88,
                    },
                    '149': {
                      'ups-zone-2': 55.84,
                      'ups-zone-3': 57.34,
                      'ups-zone-4': 60.52,
                      'ups-zone-5': 61.1,
                      'ups-zone-6': 66.93,
                      'ups-zone-7': 72.16,
                      'ups-zone-8': 81.3,
                      'ups-zone-44': 286.59,
                      'ups-zone-45': 390.22,
                      'ups-zone-46': 298.9,
                    },
                    '150': {
                      'ups-zone-2': 55.84,
                      'ups-zone-3': 57.37,
                      'ups-zone-4': 61.04,
                      'ups-zone-5': 62.68,
                      'ups-zone-6': 67.07,
                      'ups-zone-7': 72.31,
                      'ups-zone-8': 81.46,
                      'ups-zone-44': 288.56,
                      'ups-zone-45': 392.92,
                      'ups-zone-46': 303.77,
                    },
                  },
                },
                startDateTime: '2022-05-10T01:33:35.53Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:14a84e96-8edf-45c8-8820-35c01270c9cd:4',
          },
          tags: [],
        },
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '1e49a039-5266-499e-bb23-b8dd97dc07be',
              creationTimeStamp: '2022-07-26T15:31:17.139Z',
              lastUpdatedBy: '1e49a039-5266-499e-bb23-b8dd97dc07be',
              lastUpdatedTimeStamp: '2022-07-26T15:31:17.139Z',
              version: 1,
            },
            carrier: 'ups',
            carrierRateId: '37aa3f18-fdd7-4988-8d95-ccc02a502222',
            carrierServiceMethodId: 'ups-2nd-day-air-service-method',
            description: '',
            destinationType: 'residential',
            dimWeightOverride: {},
            name: 'UPS 2nd Day Air',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2024-07-23T15:26:39.966Z',
                negotiatedSurcharges: [
                  {
                    modifierType: 'replacement',
                    modifierValue: 2.81,
                    name: 'Extended Delivery ',
                    surchargeId: 'delivery_residential_air',
                  },
                  {
                    modifierType: 'replacement',
                    modifierValue: 2.66,
                    name: 'Residential Delivery',
                    surchargeId: 'residential_air',
                  },
                ],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'ups-zone-202': 10.4,
                      'ups-zone-203': 10.4,
                      'ups-zone-204': 10.4,
                      'ups-zone-205': 10.79,
                      'ups-zone-206': 13.15,
                      'ups-zone-207': 14.02,
                      'ups-zone-208': 14.3,
                      'ups-zone-224': 20.71,
                      'ups-zone-225': 19.11,
                      'ups-zone-226': 25.19,
                    },
                    '2': {
                      'ups-zone-202': 10.4,
                      'ups-zone-203': 10.4,
                      'ups-zone-204': 10.4,
                      'ups-zone-205': 11.63,
                      'ups-zone-206': 14.79,
                      'ups-zone-207': 16.41,
                      'ups-zone-208': 17.26,
                      'ups-zone-224': 23.13,
                      'ups-zone-225': 21.4,
                      'ups-zone-226': 30.8,
                    },
                    '3': {
                      'ups-zone-202': 10.4,
                      'ups-zone-203': 10.4,
                      'ups-zone-204': 10.4,
                      'ups-zone-205': 12.83,
                      'ups-zone-206': 17.0,
                      'ups-zone-207': 19.02,
                      'ups-zone-208': 19.8,
                      'ups-zone-224': 26.39,
                      'ups-zone-225': 24.39,
                      'ups-zone-226': 32.18,
                    },
                    '4': {
                      'ups-zone-202': 10.4,
                      'ups-zone-203': 10.4,
                      'ups-zone-204': 11.13,
                      'ups-zone-205': 14.95,
                      'ups-zone-206': 19.6,
                      'ups-zone-207': 21.67,
                      'ups-zone-208': 22.49,
                      'ups-zone-224': 28.11,
                      'ups-zone-225': 26.01,
                      'ups-zone-226': 33.63,
                    },
                    '5': {
                      'ups-zone-202': 10.4,
                      'ups-zone-203': 10.4,
                      'ups-zone-204': 12.1,
                      'ups-zone-205': 16.58,
                      'ups-zone-206': 21.89,
                      'ups-zone-207': 24.09,
                      'ups-zone-208': 25.54,
                      'ups-zone-224': 30.5,
                      'ups-zone-225': 28.22,
                      'ups-zone-226': 34.94,
                    },
                    '6': {
                      'ups-zone-202': 10.4,
                      'ups-zone-203': 10.72,
                      'ups-zone-204': 13.18,
                      'ups-zone-205': 18.1,
                      'ups-zone-206': 24.29,
                      'ups-zone-207': 26.77,
                      'ups-zone-208': 27.96,
                      'ups-zone-224': 34.29,
                      'ups-zone-225': 30.06,
                      'ups-zone-226': 36.98,
                    },
                    '7': {
                      'ups-zone-202': 10.4,
                      'ups-zone-203': 11.7,
                      'ups-zone-204': 14.3,
                      'ups-zone-205': 19.78,
                      'ups-zone-206': 27.32,
                      'ups-zone-207': 29.61,
                      'ups-zone-208': 30.74,
                      'ups-zone-224': 34.89,
                      'ups-zone-225': 32.37,
                      'ups-zone-226': 38.77,
                    },
                    '8': {
                      'ups-zone-202': 10.81,
                      'ups-zone-203': 12.76,
                      'ups-zone-204': 15.29,
                      'ups-zone-205': 21.58,
                      'ups-zone-206': 30.18,
                      'ups-zone-207': 32.61,
                      'ups-zone-208': 33.83,
                      'ups-zone-224': 38.87,
                      'ups-zone-225': 34.05,
                      'ups-zone-226': 40.82,
                    },
                    '9': {
                      'ups-zone-202': 11.36,
                      'ups-zone-203': 13.32,
                      'ups-zone-204': 16.52,
                      'ups-zone-205': 23.17,
                      'ups-zone-206': 32.76,
                      'ups-zone-207': 35.76,
                      'ups-zone-208': 37.09,
                      'ups-zone-224': 39.52,
                      'ups-zone-225': 36.4,
                      'ups-zone-226': 43.2,
                    },
                    '10': {
                      'ups-zone-202': 11.45,
                      'ups-zone-203': 14.2,
                      'ups-zone-204': 17.79,
                      'ups-zone-205': 24.75,
                      'ups-zone-206': 35.11,
                      'ups-zone-207': 38.9,
                      'ups-zone-208': 40.16,
                      'ups-zone-224': 45.13,
                      'ups-zone-225': 39.55,
                      'ups-zone-226': 46.09,
                    },
                    '11': {
                      'ups-zone-202': 12.46,
                      'ups-zone-203': 14.98,
                      'ups-zone-204': 18.61,
                      'ups-zone-205': 26.47,
                      'ups-zone-206': 37.82,
                      'ups-zone-207': 41.76,
                      'ups-zone-208': 43.48,
                      'ups-zone-224': 45.97,
                      'ups-zone-225': 41.84,
                      'ups-zone-226': 47.94,
                    },
                    '12': {
                      'ups-zone-202': 13.12,
                      'ups-zone-203': 15.86,
                      'ups-zone-204': 19.63,
                      'ups-zone-205': 27.96,
                      'ups-zone-206': 40.75,
                      'ups-zone-207': 44.79,
                      'ups-zone-208': 46.02,
                      'ups-zone-224': 46.94,
                      'ups-zone-225': 43.39,
                      'ups-zone-226': 48.17,
                    },
                    '13': {
                      'ups-zone-202': 14.04,
                      'ups-zone-203': 16.68,
                      'ups-zone-204': 20.39,
                      'ups-zone-205': 29.63,
                      'ups-zone-206': 43.41,
                      'ups-zone-207': 46.97,
                      'ups-zone-208': 49.21,
                      'ups-zone-224': 51.33,
                      'ups-zone-225': 44.97,
                      'ups-zone-226': 52.29,
                    },
                    '14': {
                      'ups-zone-202': 14.75,
                      'ups-zone-203': 17.54,
                      'ups-zone-204': 21.72,
                      'ups-zone-205': 31.34,
                      'ups-zone-206': 46.06,
                      'ups-zone-207': 49.35,
                      'ups-zone-208': 51.39,
                      'ups-zone-224': 53.34,
                      'ups-zone-225': 46.72,
                      'ups-zone-226': 54.3,
                    },
                    '15': {
                      'ups-zone-202': 15.3,
                      'ups-zone-203': 17.95,
                      'ups-zone-204': 22.77,
                      'ups-zone-205': 32.55,
                      'ups-zone-206': 48.5,
                      'ups-zone-207': 51.53,
                      'ups-zone-208': 53.73,
                      'ups-zone-224': 55.8,
                      'ups-zone-225': 48.83,
                      'ups-zone-226': 56.75,
                    },
                    '16': {
                      'ups-zone-202': 15.66,
                      'ups-zone-203': 18.54,
                      'ups-zone-204': 23.72,
                      'ups-zone-205': 33.61,
                      'ups-zone-206': 50.54,
                      'ups-zone-207': 54.17,
                      'ups-zone-208': 56.0,
                      'ups-zone-224': 58.09,
                      'ups-zone-225': 50.86,
                      'ups-zone-226': 59.05,
                    },
                    '17': {
                      'ups-zone-202': 16.14,
                      'ups-zone-203': 19.09,
                      'ups-zone-204': 24.68,
                      'ups-zone-205': 35.22,
                      'ups-zone-206': 52.81,
                      'ups-zone-207': 57.07,
                      'ups-zone-208': 58.61,
                      'ups-zone-224': 60.86,
                      'ups-zone-225': 53.31,
                      'ups-zone-226': 61.82,
                    },
                    '18': {
                      'ups-zone-202': 16.69,
                      'ups-zone-203': 19.72,
                      'ups-zone-204': 25.64,
                      'ups-zone-205': 36.44,
                      'ups-zone-206': 55.0,
                      'ups-zone-207': 59.59,
                      'ups-zone-208': 61.44,
                      'ups-zone-224': 62.67,
                      'ups-zone-225': 56.47,
                      'ups-zone-226': 63.5,
                    },
                    '19': {
                      'ups-zone-202': 17.35,
                      'ups-zone-203': 20.26,
                      'ups-zone-204': 26.34,
                      'ups-zone-205': 37.93,
                      'ups-zone-206': 56.98,
                      'ups-zone-207': 62.33,
                      'ups-zone-208': 64.1,
                      'ups-zone-224': 66.59,
                      'ups-zone-225': 58.28,
                      'ups-zone-226': 67.55,
                    },
                    '20': {
                      'ups-zone-202': 17.94,
                      'ups-zone-203': 21.14,
                      'ups-zone-204': 27.36,
                      'ups-zone-205': 39.7,
                      'ups-zone-206': 59.01,
                      'ups-zone-207': 64.47,
                      'ups-zone-208': 66.49,
                      'ups-zone-224': 68.95,
                      'ups-zone-225': 60.4,
                      'ups-zone-226': 69.9,
                    },
                    '21': {
                      'ups-zone-202': 18.78,
                      'ups-zone-203': 21.96,
                      'ups-zone-204': 28.39,
                      'ups-zone-205': 41.04,
                      'ups-zone-206': 59.24,
                      'ups-zone-207': 66.68,
                      'ups-zone-208': 68.77,
                      'ups-zone-224': 70.15,
                      'ups-zone-225': 63.17,
                      'ups-zone-226': 70.21,
                    },
                    '22': {
                      'ups-zone-202': 19.36,
                      'ups-zone-203': 23.02,
                      'ups-zone-204': 29.17,
                      'ups-zone-205': 42.19,
                      'ups-zone-206': 63.09,
                      'ups-zone-207': 69.23,
                      'ups-zone-208': 71.43,
                      'ups-zone-224': 72.86,
                      'ups-zone-225': 65.59,
                      'ups-zone-226': 74.87,
                    },
                    '23': {
                      'ups-zone-202': 19.83,
                      'ups-zone-203': 23.53,
                      'ups-zone-204': 30.22,
                      'ups-zone-205': 43.4,
                      'ups-zone-206': 65.38,
                      'ups-zone-207': 71.5,
                      'ups-zone-208': 73.88,
                      'ups-zone-224': 75.36,
                      'ups-zone-225': 67.99,
                      'ups-zone-226': 75.42,
                    },
                    '24': {
                      'ups-zone-202': 20.29,
                      'ups-zone-203': 24.46,
                      'ups-zone-204': 31.18,
                      'ups-zone-205': 45.08,
                      'ups-zone-206': 67.76,
                      'ups-zone-207': 73.19,
                      'ups-zone-208': 74.66,
                      'ups-zone-224': 76.16,
                      'ups-zone-225': 70.47,
                      'ups-zone-226': 78.01,
                    },
                    '25': {
                      'ups-zone-202': 20.95,
                      'ups-zone-203': 25.16,
                      'ups-zone-204': 31.77,
                      'ups-zone-205': 46.63,
                      'ups-zone-206': 69.96,
                      'ups-zone-207': 76.92,
                      'ups-zone-208': 80.13,
                      'ups-zone-224': 83.29,
                      'ups-zone-225': 72.94,
                      'ups-zone-226': 84.25,
                    },
                    '26': {
                      'ups-zone-202': 21.57,
                      'ups-zone-203': 25.85,
                      'ups-zone-204': 32.95,
                      'ups-zone-205': 48.16,
                      'ups-zone-206': 72.34,
                      'ups-zone-207': 79.56,
                      'ups-zone-208': 82.34,
                      'ups-zone-224': 85.46,
                      'ups-zone-225': 74.82,
                      'ups-zone-226': 86.64,
                    },
                    '27': {
                      'ups-zone-202': 22.26,
                      'ups-zone-203': 26.6,
                      'ups-zone-204': 33.79,
                      'ups-zone-205': 49.86,
                      'ups-zone-206': 74.79,
                      'ups-zone-207': 82.24,
                      'ups-zone-208': 84.92,
                      'ups-zone-224': 88.23,
                      'ups-zone-225': 77.29,
                      'ups-zone-226': 89.2,
                    },
                    '28': {
                      'ups-zone-202': 22.98,
                      'ups-zone-203': 27.48,
                      'ups-zone-204': 34.57,
                      'ups-zone-205': 51.05,
                      'ups-zone-206': 76.71,
                      'ups-zone-207': 84.35,
                      'ups-zone-208': 86.98,
                      'ups-zone-224': 91.06,
                      'ups-zone-225': 79.79,
                      'ups-zone-226': 92.49,
                    },
                    '29': {
                      'ups-zone-202': 23.57,
                      'ups-zone-203': 27.99,
                      'ups-zone-204': 35.59,
                      'ups-zone-205': 52.26,
                      'ups-zone-206': 78.76,
                      'ups-zone-207': 86.47,
                      'ups-zone-208': 89.57,
                      'ups-zone-224': 93.35,
                      'ups-zone-225': 81.75,
                      'ups-zone-226': 95.2,
                    },
                    '30': {
                      'ups-zone-202': 23.66,
                      'ups-zone-203': 28.75,
                      'ups-zone-204': 36.82,
                      'ups-zone-205': 53.97,
                      'ups-zone-206': 80.93,
                      'ups-zone-207': 88.8,
                      'ups-zone-208': 91.84,
                      'ups-zone-224': 96.32,
                      'ups-zone-225': 84.33,
                      'ups-zone-226': 97.73,
                    },
                    '31': {
                      'ups-zone-202': 23.76,
                      'ups-zone-203': 29.71,
                      'ups-zone-204': 37.81,
                      'ups-zone-205': 55.18,
                      'ups-zone-206': 82.77,
                      'ups-zone-207': 90.73,
                      'ups-zone-208': 94.3,
                      'ups-zone-224': 98.68,
                      'ups-zone-225': 86.43,
                      'ups-zone-226': 100.79,
                    },
                    '32': {
                      'ups-zone-202': 23.86,
                      'ups-zone-203': 30.37,
                      'ups-zone-204': 38.89,
                      'ups-zone-205': 56.52,
                      'ups-zone-206': 85.2,
                      'ups-zone-207': 93.25,
                      'ups-zone-208': 96.57,
                      'ups-zone-224': 101.78,
                      'ups-zone-225': 89.19,
                      'ups-zone-226': 103.39,
                    },
                    '33': {
                      'ups-zone-202': 25.83,
                      'ups-zone-203': 31.16,
                      'ups-zone-204': 39.97,
                      'ups-zone-205': 57.72,
                      'ups-zone-206': 87.49,
                      'ups-zone-207': 95.39,
                      'ups-zone-208': 99.03,
                      'ups-zone-224': 102.37,
                      'ups-zone-225': 91.52,
                      'ups-zone-226': 106.27,
                    },
                    '34': {
                      'ups-zone-202': 26.64,
                      'ups-zone-203': 31.74,
                      'ups-zone-204': 40.81,
                      'ups-zone-205': 59.75,
                      'ups-zone-206': 90.13,
                      'ups-zone-207': 97.76,
                      'ups-zone-208': 101.47,
                      'ups-zone-224': 104.06,
                      'ups-zone-225': 93.97,
                      'ups-zone-226': 106.85,
                    },
                    '35': {
                      'ups-zone-202': 27.18,
                      'ups-zone-203': 32.7,
                      'ups-zone-204': 41.69,
                      'ups-zone-205': 60.92,
                      'ups-zone-206': 92.84,
                      'ups-zone-207': 100.22,
                      'ups-zone-208': 102.93,
                      'ups-zone-224': 104.28,
                      'ups-zone-225': 96.5,
                      'ups-zone-226': 106.97,
                    },
                    '36': {
                      'ups-zone-202': 27.6,
                      'ups-zone-203': 33.42,
                      'ups-zone-204': 42.55,
                      'ups-zone-205': 62.18,
                      'ups-zone-206': 95.34,
                      'ups-zone-207': 103.38,
                      'ups-zone-208': 105.59,
                      'ups-zone-224': 106.94,
                      'ups-zone-225': 98.79,
                      'ups-zone-226': 109.28,
                    },
                    '37': {
                      'ups-zone-202': 28.12,
                      'ups-zone-203': 33.9,
                      'ups-zone-204': 43.58,
                      'ups-zone-205': 63.78,
                      'ups-zone-206': 97.92,
                      'ups-zone-207': 106.13,
                      'ups-zone-208': 109.44,
                      'ups-zone-224': 115.66,
                      'ups-zone-225': 101.3,
                      'ups-zone-226': 116.43,
                    },
                    '38': {
                      'ups-zone-202': 28.58,
                      'ups-zone-203': 34.42,
                      'ups-zone-204': 44.69,
                      'ups-zone-205': 65.07,
                      'ups-zone-206': 100.42,
                      'ups-zone-207': 108.88,
                      'ups-zone-208': 112.42,
                      'ups-zone-224': 117.16,
                      'ups-zone-225': 103.68,
                      'ups-zone-226': 117.27,
                    },
                    '39': {
                      'ups-zone-202': 29.49,
                      'ups-zone-203': 35.32,
                      'ups-zone-204': 45.44,
                      'ups-zone-205': 66.37,
                      'ups-zone-206': 102.85,
                      'ups-zone-207': 111.79,
                      'ups-zone-208': 115.35,
                      'ups-zone-224': 121.17,
                      'ups-zone-225': 106.09,
                      'ups-zone-226': 123.6,
                    },
                    '40': {
                      'ups-zone-202': 29.59,
                      'ups-zone-203': 36.26,
                      'ups-zone-204': 46.53,
                      'ups-zone-205': 67.86,
                      'ups-zone-206': 105.19,
                      'ups-zone-207': 114.52,
                      'ups-zone-208': 117.9,
                      'ups-zone-224': 123.59,
                      'ups-zone-225': 108.24,
                      'ups-zone-226': 126.63,
                    },
                    '41': {
                      'ups-zone-202': 31.02,
                      'ups-zone-203': 37.14,
                      'ups-zone-204': 47.07,
                      'ups-zone-205': 69.11,
                      'ups-zone-206': 107.56,
                      'ups-zone-207': 117.51,
                      'ups-zone-208': 121.08,
                      'ups-zone-224': 126.3,
                      'ups-zone-225': 110.57,
                      'ups-zone-226': 127.8,
                    },
                    '42': {
                      'ups-zone-202': 31.53,
                      'ups-zone-203': 38.04,
                      'ups-zone-204': 48.03,
                      'ups-zone-205': 70.57,
                      'ups-zone-206': 109.87,
                      'ups-zone-207': 120.41,
                      'ups-zone-208': 124.12,
                      'ups-zone-224': 129.19,
                      'ups-zone-225': 113.1,
                      'ups-zone-226': 130.66,
                    },
                    '43': {
                      'ups-zone-202': 32.19,
                      'ups-zone-203': 38.83,
                      'ups-zone-204': 48.76,
                      'ups-zone-205': 71.74,
                      'ups-zone-206': 112.45,
                      'ups-zone-207': 122.65,
                      'ups-zone-208': 126.71,
                      'ups-zone-224': 131.58,
                      'ups-zone-225': 115.29,
                      'ups-zone-226': 133.95,
                    },
                    '44': {
                      'ups-zone-202': 32.73,
                      'ups-zone-203': 39.31,
                      'ups-zone-204': 49.86,
                      'ups-zone-205': 73.02,
                      'ups-zone-206': 114.64,
                      'ups-zone-207': 124.73,
                      'ups-zone-208': 129.21,
                      'ups-zone-224': 134.2,
                      'ups-zone-225': 117.48,
                      'ups-zone-226': 136.27,
                    },
                    '45': {
                      'ups-zone-202': 32.88,
                      'ups-zone-203': 40.27,
                      'ups-zone-204': 50.59,
                      'ups-zone-205': 74.04,
                      'ups-zone-206': 116.73,
                      'ups-zone-207': 127.06,
                      'ups-zone-208': 131.13,
                      'ups-zone-224': 136.15,
                      'ups-zone-225': 119.27,
                      'ups-zone-226': 138.92,
                    },
                    '46': {
                      'ups-zone-202': 33.89,
                      'ups-zone-203': 40.72,
                      'ups-zone-204': 51.61,
                      'ups-zone-205': 74.79,
                      'ups-zone-206': 118.71,
                      'ups-zone-207': 129.11,
                      'ups-zone-208': 134.31,
                      'ups-zone-224': 137.17,
                      'ups-zone-225': 122.13,
                      'ups-zone-226': 139.23,
                    },
                    '47': {
                      'ups-zone-202': 34.0,
                      'ups-zone-203': 40.82,
                      'ups-zone-204': 52.46,
                      'ups-zone-205': 75.01,
                      'ups-zone-206': 118.92,
                      'ups-zone-207': 129.32,
                      'ups-zone-208': 135.59,
                      'ups-zone-224': 137.3,
                      'ups-zone-225': 124.45,
                      'ups-zone-226': 139.33,
                    },
                    '48': {
                      'ups-zone-202': 34.71,
                      'ups-zone-203': 42.46,
                      'ups-zone-204': 53.4,
                      'ups-zone-205': 75.23,
                      'ups-zone-206': 123.17,
                      'ups-zone-207': 133.34,
                      'ups-zone-208': 136.69,
                      'ups-zone-224': 139.37,
                      'ups-zone-225': 126.59,
                      'ups-zone-226': 139.43,
                    },
                    '49': {
                      'ups-zone-202': 34.8,
                      'ups-zone-203': 42.63,
                      'ups-zone-204': 53.5,
                      'ups-zone-205': 75.27,
                      'ups-zone-206': 125.27,
                      'ups-zone-207': 133.76,
                      'ups-zone-208': 136.8,
                      'ups-zone-224': 139.54,
                      'ups-zone-225': 128.97,
                      'ups-zone-226': 139.66,
                    },
                    '50': {
                      'ups-zone-202': 34.89,
                      'ups-zone-203': 42.72,
                      'ups-zone-204': 55.18,
                      'ups-zone-205': 75.33,
                      'ups-zone-206': 127.41,
                      'ups-zone-207': 134.31,
                      'ups-zone-208': 137.0,
                      'ups-zone-224': 139.74,
                      'ups-zone-225': 129.02,
                      'ups-zone-226': 139.86,
                    },
                    '51': {
                      'ups-zone-202': 35.21,
                      'ups-zone-203': 42.91,
                      'ups-zone-204': 56.4,
                      'ups-zone-205': 77.76,
                      'ups-zone-206': 133.54,
                      'ups-zone-207': 138.08,
                      'ups-zone-208': 140.85,
                      'ups-zone-224': 143.65,
                      'ups-zone-225': 133.36,
                      'ups-zone-226': 144.61,
                    },
                    '52': {
                      'ups-zone-202': 37.7,
                      'ups-zone-203': 45.21,
                      'ups-zone-204': 58.21,
                      'ups-zone-205': 82.03,
                      'ups-zone-206': 135.57,
                      'ups-zone-207': 146.46,
                      'ups-zone-208': 151.37,
                      'ups-zone-224': 153.01,
                      'ups-zone-225': 133.64,
                      'ups-zone-226': 153.97,
                    },
                    '53': {
                      'ups-zone-202': 38.45,
                      'ups-zone-203': 46.12,
                      'ups-zone-204': 59.03,
                      'ups-zone-205': 82.64,
                      'ups-zone-206': 135.78,
                      'ups-zone-207': 149.02,
                      'ups-zone-208': 152.41,
                      'ups-zone-224': 153.94,
                      'ups-zone-225': 135.63,
                      'ups-zone-226': 154.9,
                    },
                    '54': {
                      'ups-zone-202': 39.0,
                      'ups-zone-203': 46.68,
                      'ups-zone-204': 59.95,
                      'ups-zone-205': 82.83,
                      'ups-zone-206': 136.08,
                      'ups-zone-207': 149.63,
                      'ups-zone-208': 152.6,
                      'ups-zone-224': 154.13,
                      'ups-zone-225': 137.31,
                      'ups-zone-226': 156.44,
                    },
                    '55': {
                      'ups-zone-202': 39.72,
                      'ups-zone-203': 46.87,
                      'ups-zone-204': 60.47,
                      'ups-zone-205': 83.02,
                      'ups-zone-206': 141.9,
                      'ups-zone-207': 149.81,
                      'ups-zone-208': 152.79,
                      'ups-zone-224': 154.33,
                      'ups-zone-225': 141.47,
                      'ups-zone-226': 157.77,
                    },
                    '56': {
                      'ups-zone-202': 40.04,
                      'ups-zone-203': 47.05,
                      'ups-zone-204': 60.67,
                      'ups-zone-205': 83.26,
                      'ups-zone-206': 142.49,
                      'ups-zone-207': 150.0,
                      'ups-zone-208': 152.99,
                      'ups-zone-224': 154.52,
                      'ups-zone-225': 141.88,
                      'ups-zone-226': 157.8,
                    },
                    '57': {
                      'ups-zone-202': 40.22,
                      'ups-zone-203': 49.08,
                      'ups-zone-204': 62.53,
                      'ups-zone-205': 87.96,
                      'ups-zone-206': 147.13,
                      'ups-zone-207': 153.03,
                      'ups-zone-208': 156.07,
                      'ups-zone-224': 157.64,
                      'ups-zone-225': 144.44,
                      'ups-zone-226': 160.72,
                    },
                    '58': {
                      'ups-zone-202': 40.41,
                      'ups-zone-203': 49.29,
                      'ups-zone-204': 62.71,
                      'ups-zone-205': 88.43,
                      'ups-zone-206': 149.92,
                      'ups-zone-207': 153.34,
                      'ups-zone-208': 156.39,
                      'ups-zone-224': 157.95,
                      'ups-zone-225': 146.87,
                      'ups-zone-226': 160.77,
                    },
                    '59': {
                      'ups-zone-202': 40.6,
                      'ups-zone-203': 49.58,
                      'ups-zone-204': 64.89,
                      'ups-zone-205': 88.63,
                      'ups-zone-206': 152.19,
                      'ups-zone-207': 155.24,
                      'ups-zone-208': 158.35,
                      'ups-zone-224': 161.5,
                      'ups-zone-225': 148.85,
                      'ups-zone-226': 162.46,
                    },
                    '60': {
                      'ups-zone-202': 40.79,
                      'ups-zone-203': 49.77,
                      'ups-zone-204': 65.25,
                      'ups-zone-205': 91.1,
                      'ups-zone-206': 153.0,
                      'ups-zone-207': 158.69,
                      'ups-zone-208': 161.87,
                      'ups-zone-224': 165.08,
                      'ups-zone-225': 150.67,
                      'ups-zone-226': 166.05,
                    },
                    '61': {
                      'ups-zone-202': 40.97,
                      'ups-zone-203': 49.96,
                      'ups-zone-204': 65.44,
                      'ups-zone-205': 91.35,
                      'ups-zone-206': 155.18,
                      'ups-zone-207': 159.99,
                      'ups-zone-208': 163.19,
                      'ups-zone-224': 166.19,
                      'ups-zone-225': 153.36,
                      'ups-zone-226': 167.15,
                    },
                    '62': {
                      'ups-zone-202': 41.16,
                      'ups-zone-203': 50.14,
                      'ups-zone-204': 65.63,
                      'ups-zone-205': 91.54,
                      'ups-zone-206': 155.52,
                      'ups-zone-207': 160.28,
                      'ups-zone-208': 163.49,
                      'ups-zone-224': 166.58,
                      'ups-zone-225': 158.35,
                      'ups-zone-226': 167.54,
                    },
                    '63': {
                      'ups-zone-202': 41.34,
                      'ups-zone-203': 50.33,
                      'ups-zone-204': 65.82,
                      'ups-zone-205': 93.43,
                      'ups-zone-206': 162.24,
                      'ups-zone-207': 166.0,
                      'ups-zone-208': 169.32,
                      'ups-zone-224': 172.68,
                      'ups-zone-225': 161.03,
                      'ups-zone-226': 173.64,
                    },
                    '64': {
                      'ups-zone-202': 43.94,
                      'ups-zone-203': 51.31,
                      'ups-zone-204': 66.01,
                      'ups-zone-205': 93.62,
                      'ups-zone-206': 163.3,
                      'ups-zone-207': 166.58,
                      'ups-zone-208': 169.91,
                      'ups-zone-224': 173.29,
                      'ups-zone-225': 161.14,
                      'ups-zone-226': 174.25,
                    },
                    '65': {
                      'ups-zone-202': 45.59,
                      'ups-zone-203': 52.67,
                      'ups-zone-204': 66.19,
                      'ups-zone-205': 96.11,
                      'ups-zone-206': 163.48,
                      'ups-zone-207': 166.75,
                      'ups-zone-208': 170.09,
                      'ups-zone-224': 173.48,
                      'ups-zone-225': 163.95,
                      'ups-zone-226': 174.44,
                    },
                    '66': {
                      'ups-zone-202': 45.77,
                      'ups-zone-203': 52.86,
                      'ups-zone-204': 66.93,
                      'ups-zone-205': 96.36,
                      'ups-zone-206': 163.77,
                      'ups-zone-207': 167.04,
                      'ups-zone-208': 170.38,
                      'ups-zone-224': 173.77,
                      'ups-zone-225': 166.73,
                      'ups-zone-226': 174.74,
                    },
                    '67': {
                      'ups-zone-202': 45.96,
                      'ups-zone-203': 53.91,
                      'ups-zone-204': 67.1,
                      'ups-zone-205': 96.56,
                      'ups-zone-206': 163.95,
                      'ups-zone-207': 167.22,
                      'ups-zone-208': 170.57,
                      'ups-zone-224': 173.97,
                      'ups-zone-225': 167.34,
                      'ups-zone-226': 175.34,
                    },
                    '68': {
                      'ups-zone-202': 46.15,
                      'ups-zone-203': 54.35,
                      'ups-zone-204': 68.97,
                      'ups-zone-205': 96.74,
                      'ups-zone-206': 164.13,
                      'ups-zone-207': 167.41,
                      'ups-zone-208': 170.76,
                      'ups-zone-224': 174.17,
                      'ups-zone-225': 171.72,
                      'ups-zone-226': 175.36,
                    },
                    '69': {
                      'ups-zone-202': 46.34,
                      'ups-zone-203': 55.55,
                      'ups-zone-204': 69.16,
                      'ups-zone-205': 97.16,
                      'ups-zone-206': 164.68,
                      'ups-zone-207': 167.98,
                      'ups-zone-208': 171.34,
                      'ups-zone-224': 174.77,
                      'ups-zone-225': 174.21,
                      'ups-zone-226': 175.38,
                    },
                    '70': {
                      'ups-zone-202': 46.52,
                      'ups-zone-203': 60.55,
                      'ups-zone-204': 71.58,
                      'ups-zone-205': 105.41,
                      'ups-zone-206': 171.92,
                      'ups-zone-207': 178.86,
                      'ups-zone-208': 182.44,
                      'ups-zone-224': 186.08,
                      'ups-zone-225': 176.33,
                      'ups-zone-226': 187.03,
                    },
                    '71': {
                      'ups-zone-202': 49.35,
                      'ups-zone-203': 61.37,
                      'ups-zone-204': 71.63,
                      'ups-zone-205': 106.24,
                      'ups-zone-206': 172.47,
                      'ups-zone-207': 180.64,
                      'ups-zone-208': 184.26,
                      'ups-zone-224': 187.92,
                      'ups-zone-225': 176.81,
                      'ups-zone-226': 188.88,
                    },
                    '72': {
                      'ups-zone-202': 49.63,
                      'ups-zone-203': 61.55,
                      'ups-zone-204': 71.67,
                      'ups-zone-205': 106.42,
                      'ups-zone-206': 177.16,
                      'ups-zone-207': 180.83,
                      'ups-zone-208': 184.45,
                      'ups-zone-224': 188.11,
                      'ups-zone-225': 177.22,
                      'ups-zone-226': 189.07,
                    },
                    '73': {
                      'ups-zone-202': 49.8,
                      'ups-zone-203': 61.74,
                      'ups-zone-204': 72.0,
                      'ups-zone-205': 108.17,
                      'ups-zone-206': 177.46,
                      'ups-zone-207': 181.01,
                      'ups-zone-208': 184.64,
                      'ups-zone-224': 188.31,
                      'ups-zone-225': 179.08,
                      'ups-zone-226': 189.26,
                    },
                    '74': {
                      'ups-zone-202': 49.97,
                      'ups-zone-203': 61.93,
                      'ups-zone-204': 72.19,
                      'ups-zone-205': 108.36,
                      'ups-zone-206': 177.71,
                      'ups-zone-207': 181.27,
                      'ups-zone-208': 184.89,
                      'ups-zone-224': 188.59,
                      'ups-zone-225': 190.32,
                      'ups-zone-226': 189.28,
                    },
                    '75': {
                      'ups-zone-202': 50.31,
                      'ups-zone-203': 62.31,
                      'ups-zone-204': 72.56,
                      'ups-zone-205': 110.54,
                      'ups-zone-206': 182.63,
                      'ups-zone-207': 186.28,
                      'ups-zone-208': 190.01,
                      'ups-zone-224': 193.8,
                      'ups-zone-225': 190.34,
                      'ups-zone-226': 194.76,
                    },
                    '76': {
                      'ups-zone-202': 51.27,
                      'ups-zone-203': 62.68,
                      'ups-zone-204': 72.93,
                      'ups-zone-205': 111.34,
                      'ups-zone-206': 185.48,
                      'ups-zone-207': 189.19,
                      'ups-zone-208': 192.98,
                      'ups-zone-224': 196.82,
                      'ups-zone-225': 190.36,
                      'ups-zone-226': 197.78,
                    },
                    '77': {
                      'ups-zone-202': 51.64,
                      'ups-zone-203': 63.05,
                      'ups-zone-204': 74.42,
                      'ups-zone-205': 111.72,
                      'ups-zone-206': 189.31,
                      'ups-zone-207': 195.02,
                      'ups-zone-208': 198.92,
                      'ups-zone-224': 202.78,
                      'ups-zone-225': 190.38,
                      'ups-zone-226': 203.73,
                    },
                    '78': {
                      'ups-zone-202': 52.01,
                      'ups-zone-203': 63.43,
                      'ups-zone-204': 75.85,
                      'ups-zone-205': 117.08,
                      'ups-zone-206': 189.83,
                      'ups-zone-207': 196.55,
                      'ups-zone-208': 213.08,
                      'ups-zone-224': 216.57,
                      'ups-zone-225': 190.4,
                      'ups-zone-226': 217.54,
                    },
                    '79': {
                      'ups-zone-202': 52.39,
                      'ups-zone-203': 63.8,
                      'ups-zone-204': 76.23,
                      'ups-zone-205': 117.62,
                      'ups-zone-206': 190.84,
                      'ups-zone-207': 210.3,
                      'ups-zone-208': 214.5,
                      'ups-zone-224': 218.78,
                      'ups-zone-225': 197.59,
                      'ups-zone-226': 219.74,
                    },
                    '80': {
                      'ups-zone-202': 52.77,
                      'ups-zone-203': 64.18,
                      'ups-zone-204': 76.6,
                      'ups-zone-205': 118.0,
                      'ups-zone-206': 201.22,
                      'ups-zone-207': 211.75,
                      'ups-zone-208': 215.99,
                      'ups-zone-224': 220.26,
                      'ups-zone-225': 197.63,
                      'ups-zone-226': 222.22,
                    },
                    '81': {
                      'ups-zone-202': 54.59,
                      'ups-zone-203': 64.52,
                      'ups-zone-204': 76.97,
                      'ups-zone-205': 118.38,
                      'ups-zone-206': 202.27,
                      'ups-zone-207': 212.11,
                      'ups-zone-208': 216.36,
                      'ups-zone-224': 220.66,
                      'ups-zone-225': 197.91,
                      'ups-zone-226': 222.96,
                    },
                    '82': {
                      'ups-zone-202': 55.13,
                      'ups-zone-203': 64.85,
                      'ups-zone-204': 78.12,
                      'ups-zone-205': 118.76,
                      'ups-zone-206': 202.65,
                      'ups-zone-207': 212.48,
                      'ups-zone-208': 216.73,
                      'ups-zone-224': 221.04,
                      'ups-zone-225': 206.62,
                      'ups-zone-226': 223.03,
                    },
                    '83': {
                      'ups-zone-202': 55.87,
                      'ups-zone-203': 65.87,
                      'ups-zone-204': 78.5,
                      'ups-zone-205': 119.14,
                      'ups-zone-206': 205.85,
                      'ups-zone-207': 212.84,
                      'ups-zone-208': 217.1,
                      'ups-zone-224': 221.42,
                      'ups-zone-225': 208.17,
                      'ups-zone-226': 223.42,
                    },
                    '84': {
                      'ups-zone-202': 56.25,
                      'ups-zone-203': 66.24,
                      'ups-zone-204': 79.67,
                      'ups-zone-205': 119.52,
                      'ups-zone-206': 208.05,
                      'ups-zone-207': 216.44,
                      'ups-zone-208': 220.77,
                      'ups-zone-224': 225.16,
                      'ups-zone-225': 208.25,
                      'ups-zone-226': 226.13,
                    },
                    '85': {
                      'ups-zone-202': 58.84,
                      'ups-zone-203': 67.75,
                      'ups-zone-204': 82.92,
                      'ups-zone-205': 124.41,
                      'ups-zone-206': 208.44,
                      'ups-zone-207': 216.8,
                      'ups-zone-208': 221.14,
                      'ups-zone-224': 225.55,
                      'ups-zone-225': 209.24,
                      'ups-zone-226': 226.65,
                    },
                    '86': {
                      'ups-zone-202': 59.22,
                      'ups-zone-203': 69.84,
                      'ups-zone-204': 83.32,
                      'ups-zone-205': 124.9,
                      'ups-zone-206': 208.82,
                      'ups-zone-207': 217.14,
                      'ups-zone-208': 221.49,
                      'ups-zone-224': 226.03,
                      'ups-zone-225': 209.34,
                      'ups-zone-226': 226.98,
                    },
                    '87': {
                      'ups-zone-202': 59.6,
                      'ups-zone-203': 70.69,
                      'ups-zone-204': 83.7,
                      'ups-zone-205': 125.28,
                      'ups-zone-206': 209.2,
                      'ups-zone-207': 218.61,
                      'ups-zone-208': 222.98,
                      'ups-zone-224': 227.43,
                      'ups-zone-225': 212.29,
                      'ups-zone-226': 228.39,
                    },
                    '88': {
                      'ups-zone-202': 59.97,
                      'ups-zone-203': 71.28,
                      'ups-zone-204': 84.07,
                      'ups-zone-205': 125.66,
                      'ups-zone-206': 209.58,
                      'ups-zone-207': 220.3,
                      'ups-zone-208': 224.71,
                      'ups-zone-224': 229.16,
                      'ups-zone-225': 215.59,
                      'ups-zone-226': 230.12,
                    },
                    '89': {
                      'ups-zone-202': 60.34,
                      'ups-zone-203': 71.35,
                      'ups-zone-204': 84.44,
                      'ups-zone-205': 126.04,
                      'ups-zone-206': 212.17,
                      'ups-zone-207': 220.66,
                      'ups-zone-208': 225.08,
                      'ups-zone-224': 229.54,
                      'ups-zone-225': 215.78,
                      'ups-zone-226': 230.51,
                    },
                    '90': {
                      'ups-zone-202': 60.71,
                      'ups-zone-203': 71.37,
                      'ups-zone-204': 84.82,
                      'ups-zone-205': 126.43,
                      'ups-zone-206': 214.37,
                      'ups-zone-207': 221.04,
                      'ups-zone-208': 225.46,
                      'ups-zone-224': 229.93,
                      'ups-zone-225': 219.0,
                      'ups-zone-226': 230.89,
                    },
                    '91': {
                      'ups-zone-202': 61.09,
                      'ups-zone-203': 71.71,
                      'ups-zone-204': 85.19,
                      'ups-zone-205': 126.81,
                      'ups-zone-206': 214.75,
                      'ups-zone-207': 221.4,
                      'ups-zone-208': 225.83,
                      'ups-zone-224': 230.31,
                      'ups-zone-225': 219.19,
                      'ups-zone-226': 231.28,
                    },
                    '92': {
                      'ups-zone-202': 61.46,
                      'ups-zone-203': 72.08,
                      'ups-zone-204': 85.56,
                      'ups-zone-205': 127.19,
                      'ups-zone-206': 215.13,
                      'ups-zone-207': 221.77,
                      'ups-zone-208': 226.21,
                      'ups-zone-224': 230.73,
                      'ups-zone-225': 221.12,
                      'ups-zone-226': 231.3,
                    },
                    '93': {
                      'ups-zone-202': 61.84,
                      'ups-zone-203': 72.45,
                      'ups-zone-204': 86.56,
                      'ups-zone-205': 127.57,
                      'ups-zone-206': 215.51,
                      'ups-zone-207': 222.13,
                      'ups-zone-208': 226.58,
                      'ups-zone-224': 231.11,
                      'ups-zone-225': 221.18,
                      'ups-zone-226': 231.32,
                    },
                    '94': {
                      'ups-zone-202': 62.21,
                      'ups-zone-203': 72.83,
                      'ups-zone-204': 86.63,
                      'ups-zone-205': 127.95,
                      'ups-zone-206': 215.89,
                      'ups-zone-207': 222.5,
                      'ups-zone-208': 226.95,
                      'ups-zone-224': 231.49,
                      'ups-zone-225': 228.66,
                      'ups-zone-226': 231.68,
                    },
                    '95': {
                      'ups-zone-202': 62.58,
                      'ups-zone-203': 73.2,
                      'ups-zone-204': 86.94,
                      'ups-zone-205': 128.33,
                      'ups-zone-206': 216.55,
                      'ups-zone-207': 224.48,
                      'ups-zone-208': 228.97,
                      'ups-zone-224': 233.56,
                      'ups-zone-225': 228.71,
                      'ups-zone-226': 233.75,
                    },
                    '96': {
                      'ups-zone-202': 63.5,
                      'ups-zone-203': 73.54,
                      'ups-zone-204': 89.16,
                      'ups-zone-205': 130.6,
                      'ups-zone-206': 220.43,
                      'ups-zone-207': 224.84,
                      'ups-zone-208': 229.34,
                      'ups-zone-224': 233.94,
                      'ups-zone-225': 229.79,
                      'ups-zone-226': 234.13,
                    },
                    '97': {
                      'ups-zone-202': 63.83,
                      'ups-zone-203': 73.95,
                      'ups-zone-204': 91.32,
                      'ups-zone-205': 130.98,
                      'ups-zone-206': 225.07,
                      'ups-zone-207': 229.57,
                      'ups-zone-208': 234.17,
                      'ups-zone-224': 238.85,
                      'ups-zone-225': 229.98,
                      'ups-zone-226': 239.05,
                    },
                    '98': {
                      'ups-zone-202': 64.15,
                      'ups-zone-203': 74.33,
                      'ups-zone-204': 91.69,
                      'ups-zone-205': 131.37,
                      'ups-zone-206': 230.33,
                      'ups-zone-207': 234.94,
                      'ups-zone-208': 239.62,
                      'ups-zone-224': 242.02,
                      'ups-zone-225': 230.08,
                      'ups-zone-226': 247.6,
                    },
                    '99': {
                      'ups-zone-202': 64.48,
                      'ups-zone-203': 74.7,
                      'ups-zone-204': 93.85,
                      'ups-zone-205': 139.01,
                      'ups-zone-206': 231.98,
                      'ups-zone-207': 243.08,
                      'ups-zone-208': 253.22,
                      'ups-zone-224': 258.26,
                      'ups-zone-225': 230.26,
                      'ups-zone-226': 260.35,
                    },
                    '100': {
                      'ups-zone-202': 64.8,
                      'ups-zone-203': 81.0,
                      'ups-zone-204': 104.09,
                      'ups-zone-205': 146.61,
                      'ups-zone-206': 235.96,
                      'ups-zone-207': 267.24,
                      'ups-zone-208': 278.51,
                      'ups-zone-224': 283.85,
                      'ups-zone-225': 247.52,
                      'ups-zone-226': 287.15,
                    },
                    '101': {
                      'ups-zone-202': 65.45,
                      'ups-zone-203': 81.81,
                      'ups-zone-204': 105.13,
                      'ups-zone-205': 148.08,
                      'ups-zone-206': 239.26,
                      'ups-zone-207': 272.02,
                      'ups-zone-208': 280.61,
                      'ups-zone-224': 286.34,
                      'ups-zone-225': 249.99,
                      'ups-zone-226': 290.02,
                    },
                    '102': {
                      'ups-zone-202': 66.1,
                      'ups-zone-203': 82.62,
                      'ups-zone-204': 106.17,
                      'ups-zone-205': 149.54,
                      'ups-zone-206': 240.95,
                      'ups-zone-207': 274.71,
                      'ups-zone-208': 283.39,
                      'ups-zone-224': 289.17,
                      'ups-zone-225': 252.46,
                      'ups-zone-226': 292.88,
                    },
                    '103': {
                      'ups-zone-202': 66.74,
                      'ups-zone-203': 83.43,
                      'ups-zone-204': 107.21,
                      'ups-zone-205': 151.01,
                      'ups-zone-206': 243.31,
                      'ups-zone-207': 277.4,
                      'ups-zone-208': 286.16,
                      'ups-zone-224': 292.01,
                      'ups-zone-225': 254.94,
                      'ups-zone-226': 295.74,
                    },
                    '104': {
                      'ups-zone-202': 67.39,
                      'ups-zone-203': 84.24,
                      'ups-zone-204': 108.25,
                      'ups-zone-205': 152.47,
                      'ups-zone-206': 245.14,
                      'ups-zone-207': 280.1,
                      'ups-zone-208': 288.94,
                      'ups-zone-224': 294.84,
                      'ups-zone-225': 257.42,
                      'ups-zone-226': 298.6,
                    },
                    '105': {
                      'ups-zone-202': 68.04,
                      'ups-zone-203': 85.05,
                      'ups-zone-204': 109.29,
                      'ups-zone-205': 153.94,
                      'ups-zone-206': 248.04,
                      'ups-zone-207': 282.79,
                      'ups-zone-208': 291.72,
                      'ups-zone-224': 297.68,
                      'ups-zone-225': 259.89,
                      'ups-zone-226': 301.46,
                    },
                    '106': {
                      'ups-zone-202': 68.69,
                      'ups-zone-203': 85.86,
                      'ups-zone-204': 110.33,
                      'ups-zone-205': 155.41,
                      'ups-zone-206': 250.4,
                      'ups-zone-207': 285.48,
                      'ups-zone-208': 294.5,
                      'ups-zone-224': 300.51,
                      'ups-zone-225': 262.36,
                      'ups-zone-226': 304.33,
                    },
                    '107': {
                      'ups-zone-202': 69.34,
                      'ups-zone-203': 86.67,
                      'ups-zone-204': 111.37,
                      'ups-zone-205': 156.87,
                      'ups-zone-206': 252.21,
                      'ups-zone-207': 288.18,
                      'ups-zone-208': 297.28,
                      'ups-zone-224': 303.35,
                      'ups-zone-225': 264.85,
                      'ups-zone-226': 307.19,
                    },
                    '108': {
                      'ups-zone-202': 69.98,
                      'ups-zone-203': 87.48,
                      'ups-zone-204': 112.41,
                      'ups-zone-205': 158.34,
                      'ups-zone-206': 254.57,
                      'ups-zone-207': 290.87,
                      'ups-zone-208': 300.06,
                      'ups-zone-224': 306.18,
                      'ups-zone-225': 267.32,
                      'ups-zone-226': 310.05,
                    },
                    '109': {
                      'ups-zone-202': 70.63,
                      'ups-zone-203': 88.29,
                      'ups-zone-204': 113.45,
                      'ups-zone-205': 159.8,
                      'ups-zone-206': 256.92,
                      'ups-zone-207': 293.56,
                      'ups-zone-208': 302.83,
                      'ups-zone-224': 309.02,
                      'ups-zone-225': 269.79,
                      'ups-zone-226': 312.91,
                    },
                    '110': {
                      'ups-zone-202': 71.28,
                      'ups-zone-203': 89.1,
                      'ups-zone-204': 114.49,
                      'ups-zone-205': 161.27,
                      'ups-zone-206': 259.84,
                      'ups-zone-207': 296.26,
                      'ups-zone-208': 305.61,
                      'ups-zone-224': 311.85,
                      'ups-zone-225': 272.27,
                      'ups-zone-226': 315.77,
                    },
                    '111': {
                      'ups-zone-202': 71.93,
                      'ups-zone-203': 89.91,
                      'ups-zone-204': 115.53,
                      'ups-zone-205': 162.74,
                      'ups-zone-206': 261.64,
                      'ups-zone-207': 298.95,
                      'ups-zone-208': 308.39,
                      'ups-zone-224': 314.69,
                      'ups-zone-225': 274.74,
                      'ups-zone-226': 318.63,
                    },
                    '112': {
                      'ups-zone-202': 72.58,
                      'ups-zone-203': 90.72,
                      'ups-zone-204': 116.58,
                      'ups-zone-205': 164.2,
                      'ups-zone-206': 264.57,
                      'ups-zone-207': 301.64,
                      'ups-zone-208': 311.17,
                      'ups-zone-224': 317.52,
                      'ups-zone-225': 277.22,
                      'ups-zone-226': 321.5,
                    },
                    '113': {
                      'ups-zone-202': 73.22,
                      'ups-zone-203': 91.53,
                      'ups-zone-204': 117.62,
                      'ups-zone-205': 165.67,
                      'ups-zone-206': 266.35,
                      'ups-zone-207': 304.34,
                      'ups-zone-208': 313.95,
                      'ups-zone-224': 320.36,
                      'ups-zone-225': 279.69,
                      'ups-zone-226': 324.36,
                    },
                    '114': {
                      'ups-zone-202': 73.87,
                      'ups-zone-203': 92.34,
                      'ups-zone-204': 118.66,
                      'ups-zone-205': 167.14,
                      'ups-zone-206': 268.71,
                      'ups-zone-207': 307.03,
                      'ups-zone-208': 316.73,
                      'ups-zone-224': 323.19,
                      'ups-zone-225': 282.16,
                      'ups-zone-226': 327.22,
                    },
                    '115': {
                      'ups-zone-202': 74.52,
                      'ups-zone-203': 93.15,
                      'ups-zone-204': 119.7,
                      'ups-zone-205': 168.6,
                      'ups-zone-206': 271.07,
                      'ups-zone-207': 309.72,
                      'ups-zone-208': 319.5,
                      'ups-zone-224': 326.03,
                      'ups-zone-225': 284.65,
                      'ups-zone-226': 330.08,
                    },
                    '116': {
                      'ups-zone-202': 75.17,
                      'ups-zone-203': 93.96,
                      'ups-zone-204': 120.74,
                      'ups-zone-205': 170.07,
                      'ups-zone-206': 274.02,
                      'ups-zone-207': 312.42,
                      'ups-zone-208': 322.28,
                      'ups-zone-224': 328.86,
                      'ups-zone-225': 287.13,
                      'ups-zone-226': 332.94,
                    },
                    '117': {
                      'ups-zone-202': 75.82,
                      'ups-zone-203': 94.77,
                      'ups-zone-204': 121.78,
                      'ups-zone-205': 171.53,
                      'ups-zone-206': 275.78,
                      'ups-zone-207': 315.11,
                      'ups-zone-208': 325.06,
                      'ups-zone-224': 331.7,
                      'ups-zone-225': 289.59,
                      'ups-zone-226': 335.81,
                    },
                    '118': {
                      'ups-zone-202': 76.46,
                      'ups-zone-203': 95.58,
                      'ups-zone-204': 122.82,
                      'ups-zone-205': 173.0,
                      'ups-zone-206': 278.14,
                      'ups-zone-207': 317.8,
                      'ups-zone-208': 327.84,
                      'ups-zone-224': 334.53,
                      'ups-zone-225': 292.07,
                      'ups-zone-226': 338.67,
                    },
                    '119': {
                      'ups-zone-202': 77.11,
                      'ups-zone-203': 96.39,
                      'ups-zone-204': 123.86,
                      'ups-zone-205': 174.47,
                      'ups-zone-206': 280.49,
                      'ups-zone-207': 320.5,
                      'ups-zone-208': 330.62,
                      'ups-zone-224': 337.37,
                      'ups-zone-225': 294.55,
                      'ups-zone-226': 341.53,
                    },
                    '120': {
                      'ups-zone-202': 77.76,
                      'ups-zone-203': 97.2,
                      'ups-zone-204': 124.9,
                      'ups-zone-205': 175.93,
                      'ups-zone-206': 282.85,
                      'ups-zone-207': 323.19,
                      'ups-zone-208': 333.4,
                      'ups-zone-224': 340.2,
                      'ups-zone-225': 297.01,
                      'ups-zone-226': 344.39,
                    },
                    '121': {
                      'ups-zone-202': 78.41,
                      'ups-zone-203': 98.01,
                      'ups-zone-204': 125.94,
                      'ups-zone-205': 177.4,
                      'ups-zone-206': 285.21,
                      'ups-zone-207': 325.88,
                      'ups-zone-208': 336.17,
                      'ups-zone-224': 343.04,
                      'ups-zone-225': 299.49,
                      'ups-zone-226': 347.25,
                    },
                    '122': {
                      'ups-zone-202': 79.06,
                      'ups-zone-203': 98.82,
                      'ups-zone-204': 126.98,
                      'ups-zone-205': 178.86,
                      'ups-zone-206': 287.57,
                      'ups-zone-207': 328.58,
                      'ups-zone-208': 338.95,
                      'ups-zone-224': 345.87,
                      'ups-zone-225': 301.98,
                      'ups-zone-226': 350.11,
                    },
                    '123': {
                      'ups-zone-202': 79.7,
                      'ups-zone-203': 99.63,
                      'ups-zone-204': 128.02,
                      'ups-zone-205': 180.33,
                      'ups-zone-206': 289.92,
                      'ups-zone-207': 331.27,
                      'ups-zone-208': 341.73,
                      'ups-zone-224': 348.71,
                      'ups-zone-225': 304.45,
                      'ups-zone-226': 352.98,
                    },
                    '124': {
                      'ups-zone-202': 80.35,
                      'ups-zone-203': 100.44,
                      'ups-zone-204': 129.07,
                      'ups-zone-205': 181.8,
                      'ups-zone-206': 292.92,
                      'ups-zone-207': 333.96,
                      'ups-zone-208': 344.51,
                      'ups-zone-224': 351.54,
                      'ups-zone-225': 306.92,
                      'ups-zone-226': 355.84,
                    },
                    '125': {
                      'ups-zone-202': 81.0,
                      'ups-zone-203': 101.25,
                      'ups-zone-204': 130.11,
                      'ups-zone-205': 183.26,
                      'ups-zone-206': 294.64,
                      'ups-zone-207': 336.66,
                      'ups-zone-208': 347.29,
                      'ups-zone-224': 354.38,
                      'ups-zone-225': 309.4,
                      'ups-zone-226': 358.7,
                    },
                    '126': {
                      'ups-zone-202': 81.65,
                      'ups-zone-203': 102.06,
                      'ups-zone-204': 131.15,
                      'ups-zone-205': 184.73,
                      'ups-zone-206': 297.64,
                      'ups-zone-207': 339.35,
                      'ups-zone-208': 350.07,
                      'ups-zone-224': 357.21,
                      'ups-zone-225': 311.87,
                      'ups-zone-226': 361.56,
                    },
                    '127': {
                      'ups-zone-202': 82.3,
                      'ups-zone-203': 102.87,
                      'ups-zone-204': 132.19,
                      'ups-zone-205': 186.19,
                      'ups-zone-206': 299.35,
                      'ups-zone-207': 342.04,
                      'ups-zone-208': 352.84,
                      'ups-zone-224': 360.05,
                      'ups-zone-225': 314.35,
                      'ups-zone-226': 364.42,
                    },
                    '128': {
                      'ups-zone-202': 82.94,
                      'ups-zone-203': 103.68,
                      'ups-zone-204': 133.23,
                      'ups-zone-205': 187.66,
                      'ups-zone-206': 301.71,
                      'ups-zone-207': 344.74,
                      'ups-zone-208': 355.62,
                      'ups-zone-224': 362.88,
                      'ups-zone-225': 316.82,
                      'ups-zone-226': 367.29,
                    },
                    '129': {
                      'ups-zone-202': 83.59,
                      'ups-zone-203': 104.49,
                      'ups-zone-204': 134.27,
                      'ups-zone-205': 189.13,
                      'ups-zone-206': 304.07,
                      'ups-zone-207': 347.43,
                      'ups-zone-208': 358.4,
                      'ups-zone-224': 365.72,
                      'ups-zone-225': 319.29,
                      'ups-zone-226': 370.15,
                    },
                    '130': {
                      'ups-zone-202': 84.24,
                      'ups-zone-203': 105.3,
                      'ups-zone-204': 135.31,
                      'ups-zone-205': 190.59,
                      'ups-zone-206': 306.42,
                      'ups-zone-207': 350.12,
                      'ups-zone-208': 361.18,
                      'ups-zone-224': 368.55,
                      'ups-zone-225': 321.77,
                      'ups-zone-226': 373.01,
                    },
                    '131': {
                      'ups-zone-202': 84.89,
                      'ups-zone-203': 106.11,
                      'ups-zone-204': 136.35,
                      'ups-zone-205': 192.06,
                      'ups-zone-206': 310.33,
                      'ups-zone-207': 352.82,
                      'ups-zone-208': 363.96,
                      'ups-zone-224': 371.39,
                      'ups-zone-225': 324.25,
                      'ups-zone-226': 375.87,
                    },
                    '132': {
                      'ups-zone-202': 85.54,
                      'ups-zone-203': 106.92,
                      'ups-zone-204': 137.39,
                      'ups-zone-205': 193.53,
                      'ups-zone-206': 311.81,
                      'ups-zone-207': 355.51,
                      'ups-zone-208': 366.74,
                      'ups-zone-224': 374.22,
                      'ups-zone-225': 326.72,
                      'ups-zone-226': 378.73,
                    },
                    '133': {
                      'ups-zone-202': 86.18,
                      'ups-zone-203': 107.73,
                      'ups-zone-204': 138.43,
                      'ups-zone-205': 194.99,
                      'ups-zone-206': 313.49,
                      'ups-zone-207': 358.2,
                      'ups-zone-208': 369.51,
                      'ups-zone-224': 377.06,
                      'ups-zone-225': 329.2,
                      'ups-zone-226': 381.6,
                    },
                    '134': {
                      'ups-zone-202': 86.83,
                      'ups-zone-203': 108.54,
                      'ups-zone-204': 139.47,
                      'ups-zone-205': 196.46,
                      'ups-zone-206': 315.85,
                      'ups-zone-207': 360.9,
                      'ups-zone-208': 372.29,
                      'ups-zone-224': 379.89,
                      'ups-zone-225': 331.67,
                      'ups-zone-226': 384.45,
                    },
                    '135': {
                      'ups-zone-202': 87.48,
                      'ups-zone-203': 109.35,
                      'ups-zone-204': 140.51,
                      'ups-zone-205': 197.92,
                      'ups-zone-206': 318.21,
                      'ups-zone-207': 363.59,
                      'ups-zone-208': 375.07,
                      'ups-zone-224': 382.73,
                      'ups-zone-225': 334.15,
                      'ups-zone-226': 387.32,
                    },
                    '136': {
                      'ups-zone-202': 88.13,
                      'ups-zone-203': 110.16,
                      'ups-zone-204': 141.56,
                      'ups-zone-205': 199.39,
                      'ups-zone-206': 320.57,
                      'ups-zone-207': 366.28,
                      'ups-zone-208': 377.85,
                      'ups-zone-224': 385.56,
                      'ups-zone-225': 336.63,
                      'ups-zone-226': 390.18,
                    },
                    '137': {
                      'ups-zone-202': 88.78,
                      'ups-zone-203': 110.97,
                      'ups-zone-204': 142.6,
                      'ups-zone-205': 200.86,
                      'ups-zone-206': 322.92,
                      'ups-zone-207': 368.98,
                      'ups-zone-208': 380.63,
                      'ups-zone-224': 388.4,
                      'ups-zone-225': 339.1,
                      'ups-zone-226': 393.04,
                    },
                    '138': {
                      'ups-zone-202': 89.42,
                      'ups-zone-203': 111.78,
                      'ups-zone-204': 143.64,
                      'ups-zone-205': 202.32,
                      'ups-zone-206': 325.98,
                      'ups-zone-207': 371.67,
                      'ups-zone-208': 383.41,
                      'ups-zone-224': 391.23,
                      'ups-zone-225': 341.57,
                      'ups-zone-226': 395.9,
                    },
                    '139': {
                      'ups-zone-202': 90.07,
                      'ups-zone-203': 112.59,
                      'ups-zone-204': 144.68,
                      'ups-zone-205': 203.79,
                      'ups-zone-206': 327.64,
                      'ups-zone-207': 374.36,
                      'ups-zone-208': 386.18,
                      'ups-zone-224': 394.07,
                      'ups-zone-225': 344.04,
                      'ups-zone-226': 398.77,
                    },
                    '140': {
                      'ups-zone-202': 90.72,
                      'ups-zone-203': 113.4,
                      'ups-zone-204': 145.72,
                      'ups-zone-205': 205.25,
                      'ups-zone-206': 329.99,
                      'ups-zone-207': 377.06,
                      'ups-zone-208': 388.96,
                      'ups-zone-224': 396.9,
                      'ups-zone-225': 346.53,
                      'ups-zone-226': 401.63,
                    },
                    '141': {
                      'ups-zone-202': 91.37,
                      'ups-zone-203': 114.21,
                      'ups-zone-204': 146.76,
                      'ups-zone-205': 206.72,
                      'ups-zone-206': 332.35,
                      'ups-zone-207': 379.75,
                      'ups-zone-208': 391.74,
                      'ups-zone-224': 399.74,
                      'ups-zone-225': 349.0,
                      'ups-zone-226': 404.49,
                    },
                    '142': {
                      'ups-zone-202': 92.02,
                      'ups-zone-203': 115.02,
                      'ups-zone-204': 147.8,
                      'ups-zone-205': 208.19,
                      'ups-zone-206': 334.71,
                      'ups-zone-207': 382.44,
                      'ups-zone-208': 394.52,
                      'ups-zone-224': 402.57,
                      'ups-zone-225': 351.48,
                      'ups-zone-226': 407.35,
                    },
                    '143': {
                      'ups-zone-202': 92.66,
                      'ups-zone-203': 115.83,
                      'ups-zone-204': 148.84,
                      'ups-zone-205': 209.65,
                      'ups-zone-206': 337.07,
                      'ups-zone-207': 385.13,
                      'ups-zone-208': 397.3,
                      'ups-zone-224': 405.41,
                      'ups-zone-225': 353.95,
                      'ups-zone-226': 410.21,
                    },
                    '144': {
                      'ups-zone-202': 93.31,
                      'ups-zone-203': 116.64,
                      'ups-zone-204': 149.88,
                      'ups-zone-205': 211.12,
                      'ups-zone-206': 339.42,
                      'ups-zone-207': 387.83,
                      'ups-zone-208': 400.08,
                      'ups-zone-224': 408.24,
                      'ups-zone-225': 356.43,
                      'ups-zone-226': 413.08,
                    },
                    '145': {
                      'ups-zone-202': 93.96,
                      'ups-zone-203': 117.45,
                      'ups-zone-204': 150.92,
                      'ups-zone-205': 212.58,
                      'ups-zone-206': 341.78,
                      'ups-zone-207': 390.52,
                      'ups-zone-208': 402.85,
                      'ups-zone-224': 411.08,
                      'ups-zone-225': 358.9,
                      'ups-zone-226': 415.94,
                    },
                    '146': {
                      'ups-zone-202': 94.61,
                      'ups-zone-203': 118.26,
                      'ups-zone-204': 151.96,
                      'ups-zone-205': 214.05,
                      'ups-zone-206': 344.14,
                      'ups-zone-207': 393.21,
                      'ups-zone-208': 405.63,
                      'ups-zone-224': 413.91,
                      'ups-zone-225': 361.37,
                      'ups-zone-226': 418.8,
                    },
                    '147': {
                      'ups-zone-202': 95.26,
                      'ups-zone-203': 119.07,
                      'ups-zone-204': 153.0,
                      'ups-zone-205': 215.52,
                      'ups-zone-206': 346.49,
                      'ups-zone-207': 395.91,
                      'ups-zone-208': 408.41,
                      'ups-zone-224': 416.75,
                      'ups-zone-225': 363.85,
                      'ups-zone-226': 421.66,
                    },
                    '148': {
                      'ups-zone-202': 95.9,
                      'ups-zone-203': 119.88,
                      'ups-zone-204': 154.05,
                      'ups-zone-205': 216.98,
                      'ups-zone-206': 349.6,
                      'ups-zone-207': 398.6,
                      'ups-zone-208': 411.19,
                      'ups-zone-224': 419.58,
                      'ups-zone-225': 366.33,
                      'ups-zone-226': 424.53,
                    },
                    '149': {
                      'ups-zone-202': 96.55,
                      'ups-zone-203': 120.69,
                      'ups-zone-204': 155.09,
                      'ups-zone-205': 218.45,
                      'ups-zone-206': 351.97,
                      'ups-zone-207': 401.29,
                      'ups-zone-208': 413.97,
                      'ups-zone-224': 422.42,
                      'ups-zone-225': 368.81,
                      'ups-zone-226': 427.38,
                    },
                    '150': {
                      'ups-zone-202': 97.2,
                      'ups-zone-203': 121.5,
                      'ups-zone-204': 156.13,
                      'ups-zone-205': 219.92,
                      'ups-zone-206': 353.57,
                      'ups-zone-207': 403.99,
                      'ups-zone-208': 416.75,
                      'ups-zone-224': 425.25,
                      'ups-zone-225': 371.28,
                      'ups-zone-226': 430.25,
                    },
                  },
                },
                startDateTime: '2022-07-26T15:26:39.966Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:37aa3f18-fdd7-4988-8d95-ccc02a502222:1',
          },
          tags: [],
        },
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-09-13T15:07:29.356Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-09-13T15:07:29.356Z',
              version: 1,
            },
            carrier: 'ups',
            carrierRateId: '524c1103-c476-49b2-b9f2-cfe5d1fc7c35',
            carrierServiceMethodId: 'ups-worldwide-expedited-service-method',
            description: '',
            destinationType: 'all',
            dimWeightOverride: {},
            name: 'Stord - UPS Worldwide Expedited',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2023-09-05T15:05:14.087Z',
                negotiatedSurcharges: [
                  {
                    modifierType: 'percentage',
                    modifierValue: 0.0,
                    name: 'placeholder',
                    surchargeId: 'residential_air',
                  },
                  {
                    modifierType: 'percentage',
                    modifierValue: 0.0,
                    name: '',
                    surchargeId: 'ups-handling-intl',
                  },
                ],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'ups-zone-71': 15.37,
                      'ups-zone-72': 16.43,
                      'ups-zone-74': 17.96,
                      'ups-zone-601': 18.4,
                      'ups-zone-602': 19.47,
                      'ups-zone-603': 20.65,
                      'ups-zone-604': 21.37,
                      'ups-zone-605': 20.35,
                      'ups-zone-606': 29.57,
                      'ups-zone-607': 27.53,
                      'ups-zone-608': 24.87,
                      'ups-zone-609': 21.09,
                      'ups-zone-611': 24.83,
                      'ups-zone-612': 24.29,
                      'ups-zone-613': 21.28,
                      'ups-zone-620': 34.98,
                      'ups-zone-621': 38.41,
                    },
                    '2': {
                      'ups-zone-71': 15.95,
                      'ups-zone-72': 17.56,
                      'ups-zone-74': 19.41,
                      'ups-zone-601': 20.74,
                      'ups-zone-602': 21.73,
                      'ups-zone-603': 23.27,
                      'ups-zone-604': 25.4,
                      'ups-zone-605': 22.99,
                      'ups-zone-606': 34.34,
                      'ups-zone-607': 33.47,
                      'ups-zone-608': 31.27,
                      'ups-zone-609': 23.29,
                      'ups-zone-611': 26.88,
                      'ups-zone-612': 27.42,
                      'ups-zone-613': 24.5,
                      'ups-zone-620': 34.98,
                      'ups-zone-621': 38.41,
                    },
                    '3': {
                      'ups-zone-71': 17.19,
                      'ups-zone-72': 19.16,
                      'ups-zone-74': 22.2,
                      'ups-zone-601': 24.25,
                      'ups-zone-602': 24.26,
                      'ups-zone-603': 26.18,
                      'ups-zone-604': 28.69,
                      'ups-zone-605': 26.06,
                      'ups-zone-606': 38.77,
                      'ups-zone-607': 40.09,
                      'ups-zone-608': 35.42,
                      'ups-zone-609': 27.87,
                      'ups-zone-611': 31.86,
                      'ups-zone-612': 31.0,
                      'ups-zone-613': 27.92,
                      'ups-zone-620': 34.98,
                      'ups-zone-621': 38.41,
                    },
                    '4': {
                      'ups-zone-71': 18.36,
                      'ups-zone-72': 20.87,
                      'ups-zone-74': 23.42,
                      'ups-zone-601': 27.41,
                      'ups-zone-602': 26.77,
                      'ups-zone-603': 28.88,
                      'ups-zone-604': 31.63,
                      'ups-zone-605': 29.53,
                      'ups-zone-606': 45.26,
                      'ups-zone-607': 49.97,
                      'ups-zone-608': 45.52,
                      'ups-zone-609': 31.31,
                      'ups-zone-611': 33.75,
                      'ups-zone-612': 34.11,
                      'ups-zone-613': 31.51,
                      'ups-zone-620': 34.98,
                      'ups-zone-621': 38.41,
                    },
                    '5': {
                      'ups-zone-71': 20.93,
                      'ups-zone-72': 24.16,
                      'ups-zone-74': 27.21,
                      'ups-zone-601': 32.5,
                      'ups-zone-602': 29.25,
                      'ups-zone-603': 34.24,
                      'ups-zone-604': 36.17,
                      'ups-zone-605': 34.05,
                      'ups-zone-606': 49.77,
                      'ups-zone-607': 56.34,
                      'ups-zone-608': 51.46,
                      'ups-zone-609': 37.7,
                      'ups-zone-611': 38.2,
                      'ups-zone-612': 38.46,
                      'ups-zone-613': 37.13,
                      'ups-zone-620': 34.98,
                      'ups-zone-621': 38.41,
                    },
                    '6': {
                      'ups-zone-71': 21.68,
                      'ups-zone-72': 24.77,
                      'ups-zone-74': 28.58,
                      'ups-zone-601': 34.62,
                      'ups-zone-602': 32.67,
                      'ups-zone-603': 36.39,
                      'ups-zone-604': 39.22,
                      'ups-zone-605': 37.25,
                      'ups-zone-606': 58.2,
                      'ups-zone-607': 63.36,
                      'ups-zone-608': 59.76,
                      'ups-zone-609': 40.66,
                      'ups-zone-611': 42.01,
                      'ups-zone-612': 41.91,
                      'ups-zone-613': 40.06,
                      'ups-zone-620': 34.98,
                      'ups-zone-621': 40.14,
                    },
                    '7': {
                      'ups-zone-71': 22.53,
                      'ups-zone-72': 25.72,
                      'ups-zone-74': 31.83,
                      'ups-zone-601': 36.45,
                      'ups-zone-602': 34.98,
                      'ups-zone-603': 39.14,
                      'ups-zone-604': 43.15,
                      'ups-zone-605': 40.52,
                      'ups-zone-606': 62.95,
                      'ups-zone-607': 70.34,
                      'ups-zone-608': 62.57,
                      'ups-zone-609': 41.59,
                      'ups-zone-611': 46.47,
                      'ups-zone-612': 46.96,
                      'ups-zone-613': 40.72,
                      'ups-zone-620': 34.98,
                      'ups-zone-621': 41.75,
                    },
                    '8': {
                      'ups-zone-71': 23.56,
                      'ups-zone-72': 26.59,
                      'ups-zone-74': 34.45,
                      'ups-zone-601': 37.33,
                      'ups-zone-602': 35.88,
                      'ups-zone-603': 42.61,
                      'ups-zone-604': 46.18,
                      'ups-zone-605': 43.64,
                      'ups-zone-606': 71.64,
                      'ups-zone-607': 72.37,
                      'ups-zone-608': 69.92,
                      'ups-zone-609': 43.3,
                      'ups-zone-611': 50.89,
                      'ups-zone-612': 48.75,
                      'ups-zone-613': 41.84,
                      'ups-zone-620': 35.24,
                      'ups-zone-621': 47.77,
                    },
                    '9': {
                      'ups-zone-71': 23.78,
                      'ups-zone-72': 27.89,
                      'ups-zone-74': 34.61,
                      'ups-zone-601': 38.59,
                      'ups-zone-602': 37.6,
                      'ups-zone-603': 43.7,
                      'ups-zone-604': 48.99,
                      'ups-zone-605': 46.08,
                      'ups-zone-606': 77.38,
                      'ups-zone-607': 79.28,
                      'ups-zone-608': 80.28,
                      'ups-zone-609': 44.03,
                      'ups-zone-611': 54.87,
                      'ups-zone-612': 51.44,
                      'ups-zone-613': 47.42,
                      'ups-zone-620': 36.96,
                      'ups-zone-621': 50.88,
                    },
                    '10': {
                      'ups-zone-71': 24.5,
                      'ups-zone-72': 28.36,
                      'ups-zone-74': 35.16,
                      'ups-zone-601': 38.76,
                      'ups-zone-602': 38.32,
                      'ups-zone-603': 44.24,
                      'ups-zone-604': 49.14,
                      'ups-zone-605': 46.22,
                      'ups-zone-606': 78.49,
                      'ups-zone-607': 79.44,
                      'ups-zone-608': 80.51,
                      'ups-zone-609': 46.99,
                      'ups-zone-611': 56.69,
                      'ups-zone-612': 55.16,
                      'ups-zone-613': 47.72,
                      'ups-zone-620': 37.68,
                      'ups-zone-621': 54.1,
                    },
                    '11': {
                      'ups-zone-71': 24.85,
                      'ups-zone-72': 28.6,
                      'ups-zone-74': 39.37,
                      'ups-zone-601': 39.0,
                      'ups-zone-602': 39.75,
                      'ups-zone-603': 44.41,
                      'ups-zone-604': 49.86,
                      'ups-zone-605': 46.69,
                      'ups-zone-606': 81.47,
                      'ups-zone-607': 79.6,
                      'ups-zone-608': 82.5,
                      'ups-zone-609': 47.71,
                      'ups-zone-611': 58.34,
                      'ups-zone-612': 56.27,
                      'ups-zone-613': 48.46,
                      'ups-zone-620': 39.13,
                      'ups-zone-621': 55.08,
                    },
                    '12': {
                      'ups-zone-71': 25.31,
                      'ups-zone-72': 29.22,
                      'ups-zone-74': 39.53,
                      'ups-zone-601': 39.61,
                      'ups-zone-602': 40.9,
                      'ups-zone-603': 45.28,
                      'ups-zone-604': 50.97,
                      'ups-zone-605': 47.13,
                      'ups-zone-606': 82.94,
                      'ups-zone-607': 81.29,
                      'ups-zone-608': 83.36,
                      'ups-zone-609': 47.87,
                      'ups-zone-611': 59.72,
                      'ups-zone-612': 56.43,
                      'ups-zone-613': 49.31,
                      'ups-zone-620': 40.28,
                      'ups-zone-621': 58.1,
                    },
                    '13': {
                      'ups-zone-71': 27.3,
                      'ups-zone-72': 33.54,
                      'ups-zone-74': 41.68,
                      'ups-zone-601': 44.68,
                      'ups-zone-602': 43.29,
                      'ups-zone-603': 51.14,
                      'ups-zone-604': 63.61,
                      'ups-zone-605': 55.46,
                      'ups-zone-606': 96.65,
                      'ups-zone-607': 88.68,
                      'ups-zone-608': 90.82,
                      'ups-zone-609': 53.19,
                      'ups-zone-611': 63.38,
                      'ups-zone-612': 66.74,
                      'ups-zone-613': 58.23,
                      'ups-zone-620': 42.67,
                      'ups-zone-621': 63.33,
                    },
                    '14': {
                      'ups-zone-71': 28.24,
                      'ups-zone-72': 34.58,
                      'ups-zone-74': 41.85,
                      'ups-zone-601': 47.8,
                      'ups-zone-602': 44.75,
                      'ups-zone-603': 56.24,
                      'ups-zone-604': 67.52,
                      'ups-zone-605': 60.47,
                      'ups-zone-606': 103.18,
                      'ups-zone-607': 101.76,
                      'ups-zone-608': 108.19,
                      'ups-zone-609': 53.66,
                      'ups-zone-611': 72.96,
                      'ups-zone-612': 69.17,
                      'ups-zone-613': 59.0,
                      'ups-zone-620': 44.14,
                      'ups-zone-621': 66.26,
                    },
                    '15': {
                      'ups-zone-71': 29.17,
                      'ups-zone-72': 36.4,
                      'ups-zone-74': 43.15,
                      'ups-zone-601': 48.91,
                      'ups-zone-602': 47.81,
                      'ups-zone-603': 57.09,
                      'ups-zone-604': 70.39,
                      'ups-zone-605': 64.16,
                      'ups-zone-606': 105.7,
                      'ups-zone-607': 114.9,
                      'ups-zone-608': 108.35,
                      'ups-zone-609': 57.18,
                      'ups-zone-611': 83.19,
                      'ups-zone-612': 70.75,
                      'ups-zone-613': 59.8,
                      'ups-zone-620': 47.21,
                      'ups-zone-621': 66.74,
                    },
                    '16': {
                      'ups-zone-71': 30.53,
                      'ups-zone-72': 37.18,
                      'ups-zone-74': 43.68,
                      'ups-zone-601': 53.32,
                      'ups-zone-602': 50.12,
                      'ups-zone-603': 59.73,
                      'ups-zone-604': 74.84,
                      'ups-zone-605': 69.51,
                      'ups-zone-606': 109.97,
                      'ups-zone-607': 117.91,
                      'ups-zone-608': 108.5,
                      'ups-zone-609': 61.02,
                      'ups-zone-611': 85.19,
                      'ups-zone-612': 76.27,
                      'ups-zone-613': 60.58,
                      'ups-zone-620': 49.52,
                      'ups-zone-621': 71.02,
                    },
                    '17': {
                      'ups-zone-71': 30.77,
                      'ups-zone-72': 37.31,
                      'ups-zone-74': 45.9,
                      'ups-zone-601': 53.56,
                      'ups-zone-602': 51.34,
                      'ups-zone-603': 61.01,
                      'ups-zone-604': 76.97,
                      'ups-zone-605': 70.44,
                      'ups-zone-606': 115.17,
                      'ups-zone-607': 120.62,
                      'ups-zone-608': 108.66,
                      'ups-zone-609': 64.09,
                      'ups-zone-611': 86.54,
                      'ups-zone-612': 79.4,
                      'ups-zone-613': 62.02,
                      'ups-zone-620': 50.75,
                      'ups-zone-621': 75.64,
                    },
                    '18': {
                      'ups-zone-71': 31.58,
                      'ups-zone-72': 38.13,
                      'ups-zone-74': 46.67,
                      'ups-zone-601': 54.38,
                      'ups-zone-602': 53.42,
                      'ups-zone-603': 62.06,
                      'ups-zone-604': 77.58,
                      'ups-zone-605': 72.41,
                      'ups-zone-606': 122.88,
                      'ups-zone-607': 125.59,
                      'ups-zone-608': 118.9,
                      'ups-zone-609': 64.51,
                      'ups-zone-611': 89.43,
                      'ups-zone-612': 80.57,
                      'ups-zone-613': 67.14,
                      'ups-zone-620': 52.83,
                      'ups-zone-621': 77.97,
                    },
                    '19': {
                      'ups-zone-71': 32.36,
                      'ups-zone-72': 39.04,
                      'ups-zone-74': 51.19,
                      'ups-zone-601': 54.57,
                      'ups-zone-602': 55.2,
                      'ups-zone-603': 64.87,
                      'ups-zone-604': 81.9,
                      'ups-zone-605': 76.44,
                      'ups-zone-606': 127.37,
                      'ups-zone-607': 131.44,
                      'ups-zone-608': 120.92,
                      'ups-zone-609': 67.92,
                      'ups-zone-611': 90.95,
                      'ups-zone-612': 83.2,
                      'ups-zone-613': 69.81,
                      'ups-zone-620': 54.61,
                      'ups-zone-621': 80.46,
                    },
                    '20': {
                      'ups-zone-71': 33.15,
                      'ups-zone-72': 39.93,
                      'ups-zone-74': 53.0,
                      'ups-zone-601': 55.48,
                      'ups-zone-602': 56.99,
                      'ups-zone-603': 65.22,
                      'ups-zone-604': 82.26,
                      'ups-zone-605': 76.69,
                      'ups-zone-606': 127.79,
                      'ups-zone-607': 138.95,
                      'ups-zone-608': 128.71,
                      'ups-zone-609': 70.3,
                      'ups-zone-611': 91.11,
                      'ups-zone-612': 89.2,
                      'ups-zone-613': 69.87,
                      'ups-zone-620': 56.41,
                      'ups-zone-621': 83.09,
                    },
                    '21': {
                      'ups-zone-71': 36.6,
                      'ups-zone-72': 43.23,
                      'ups-zone-74': 53.15,
                      'ups-zone-601': 57.95,
                      'ups-zone-602': 59.06,
                      'ups-zone-603': 65.54,
                      'ups-zone-604': 83.17,
                      'ups-zone-605': 76.99,
                      'ups-zone-606': 133.05,
                      'ups-zone-607': 147.6,
                      'ups-zone-608': 144.55,
                      'ups-zone-609': 72.24,
                      'ups-zone-611': 91.28,
                      'ups-zone-612': 89.79,
                      'ups-zone-613': 70.14,
                      'ups-zone-620': 58.49,
                      'ups-zone-621': 85.77,
                    },
                    '22': {
                      'ups-zone-71': 37.46,
                      'ups-zone-72': 43.36,
                      'ups-zone-74': 53.31,
                      'ups-zone-601': 58.08,
                      'ups-zone-602': 60.88,
                      'ups-zone-603': 65.67,
                      'ups-zone-604': 83.49,
                      'ups-zone-605': 77.13,
                      'ups-zone-606': 135.62,
                      'ups-zone-607': 148.37,
                      'ups-zone-608': 146.37,
                      'ups-zone-609': 72.4,
                      'ups-zone-611': 91.44,
                      'ups-zone-612': 90.2,
                      'ups-zone-613': 74.34,
                      'ups-zone-620': 60.32,
                      'ups-zone-621': 88.22,
                    },
                    '23': {
                      'ups-zone-71': 38.19,
                      'ups-zone-72': 43.76,
                      'ups-zone-74': 54.59,
                      'ups-zone-601': 58.21,
                      'ups-zone-602': 62.09,
                      'ups-zone-603': 65.81,
                      'ups-zone-604': 84.2,
                      'ups-zone-605': 77.27,
                      'ups-zone-606': 135.78,
                      'ups-zone-607': 151.58,
                      'ups-zone-608': 148.1,
                      'ups-zone-609': 72.57,
                      'ups-zone-611': 91.61,
                      'ups-zone-612': 90.39,
                      'ups-zone-613': 75.45,
                      'ups-zone-620': 61.53,
                      'ups-zone-621': 89.16,
                    },
                    '24': {
                      'ups-zone-71': 39.67,
                      'ups-zone-72': 43.9,
                      'ups-zone-74': 56.37,
                      'ups-zone-601': 58.9,
                      'ups-zone-602': 62.71,
                      'ups-zone-603': 66.97,
                      'ups-zone-604': 84.4,
                      'ups-zone-605': 77.41,
                      'ups-zone-606': 136.97,
                      'ups-zone-607': 151.74,
                      'ups-zone-608': 148.27,
                      'ups-zone-609': 72.72,
                      'ups-zone-611': 93.07,
                      'ups-zone-612': 91.29,
                      'ups-zone-613': 75.97,
                      'ups-zone-620': 62.15,
                      'ups-zone-621': 90.69,
                    },
                    '25': {
                      'ups-zone-71': 39.79,
                      'ups-zone-72': 44.67,
                      'ups-zone-74': 56.53,
                      'ups-zone-601': 59.18,
                      'ups-zone-602': 63.5,
                      'ups-zone-603': 68.7,
                      'ups-zone-604': 85.14,
                      'ups-zone-605': 78.28,
                      'ups-zone-606': 137.76,
                      'ups-zone-607': 153.66,
                      'ups-zone-608': 152.99,
                      'ups-zone-609': 74.45,
                      'ups-zone-611': 93.97,
                      'ups-zone-612': 92.55,
                      'ups-zone-613': 76.24,
                      'ups-zone-620': 62.94,
                      'ups-zone-621': 94.43,
                    },
                    '26': {
                      'ups-zone-71': 43.95,
                      'ups-zone-72': 49.23,
                      'ups-zone-74': 58.76,
                      'ups-zone-601': 76.51,
                      'ups-zone-602': 67.69,
                      'ups-zone-603': 88.64,
                      'ups-zone-604': 104.79,
                      'ups-zone-605': 94.17,
                      'ups-zone-606': 150.78,
                      'ups-zone-607': 169.04,
                      'ups-zone-608': 158.51,
                      'ups-zone-609': 91.29,
                      'ups-zone-611': 116.98,
                      'ups-zone-612': 110.99,
                      'ups-zone-613': 87.29,
                      'ups-zone-620': 67.15,
                      'ups-zone-621': 98.06,
                    },
                    '27': {
                      'ups-zone-71': 45.0,
                      'ups-zone-72': 53.81,
                      'ups-zone-74': 58.95,
                      'ups-zone-601': 78.29,
                      'ups-zone-602': 70.53,
                      'ups-zone-603': 91.95,
                      'ups-zone-604': 110.25,
                      'ups-zone-605': 96.02,
                      'ups-zone-606': 154.76,
                      'ups-zone-607': 172.04,
                      'ups-zone-608': 174.31,
                      'ups-zone-609': 97.26,
                      'ups-zone-611': 126.46,
                      'ups-zone-612': 117.35,
                      'ups-zone-613': 88.79,
                      'ups-zone-620': 69.99,
                      'ups-zone-621': 98.09,
                    },
                    '28': {
                      'ups-zone-71': 46.69,
                      'ups-zone-72': 54.21,
                      'ups-zone-74': 60.56,
                      'ups-zone-601': 80.32,
                      'ups-zone-602': 70.71,
                      'ups-zone-603': 93.81,
                      'ups-zone-604': 114.8,
                      'ups-zone-605': 105.36,
                      'ups-zone-606': 157.32,
                      'ups-zone-607': 181.65,
                      'ups-zone-608': 174.47,
                      'ups-zone-609': 97.42,
                      'ups-zone-611': 130.98,
                      'ups-zone-612': 118.1,
                      'ups-zone-613': 89.22,
                      'ups-zone-620': 70.18,
                      'ups-zone-621': 101.64,
                    },
                    '29': {
                      'ups-zone-71': 47.4,
                      'ups-zone-72': 54.38,
                      'ups-zone-74': 62.23,
                      'ups-zone-601': 82.03,
                      'ups-zone-602': 71.58,
                      'ups-zone-603': 96.26,
                      'ups-zone-604': 120.38,
                      'ups-zone-605': 109.09,
                      'ups-zone-606': 165.46,
                      'ups-zone-607': 194.13,
                      'ups-zone-608': 178.26,
                      'ups-zone-609': 98.83,
                      'ups-zone-611': 131.51,
                      'ups-zone-612': 131.73,
                      'ups-zone-613': 95.36,
                      'ups-zone-620': 71.04,
                      'ups-zone-621': 105.16,
                    },
                    '30': {
                      'ups-zone-71': 47.55,
                      'ups-zone-72': 56.43,
                      'ups-zone-74': 64.34,
                      'ups-zone-601': 82.42,
                      'ups-zone-602': 72.71,
                      'ups-zone-603': 98.51,
                      'ups-zone-604': 121.38,
                      'ups-zone-605': 109.39,
                      'ups-zone-606': 166.77,
                      'ups-zone-607': 195.08,
                      'ups-zone-608': 178.46,
                      'ups-zone-609': 99.0,
                      'ups-zone-611': 131.69,
                      'ups-zone-612': 131.95,
                      'ups-zone-613': 101.32,
                      'ups-zone-620': 72.18,
                      'ups-zone-621': 107.72,
                    },
                    '31': {
                      'ups-zone-71': 48.48,
                      'ups-zone-72': 56.64,
                      'ups-zone-74': 65.16,
                      'ups-zone-601': 84.16,
                      'ups-zone-602': 75.12,
                      'ups-zone-603': 101.66,
                      'ups-zone-604': 127.4,
                      'ups-zone-605': 112.11,
                      'ups-zone-606': 177.48,
                      'ups-zone-607': 195.26,
                      'ups-zone-608': 181.74,
                      'ups-zone-609': 100.49,
                      'ups-zone-611': 134.63,
                      'ups-zone-612': 134.64,
                      'ups-zone-613': 103.34,
                      'ups-zone-620': 74.6,
                      'ups-zone-621': 111.05,
                    },
                    '32': {
                      'ups-zone-71': 49.53,
                      'ups-zone-72': 58.9,
                      'ups-zone-74': 65.32,
                      'ups-zone-601': 84.3,
                      'ups-zone-602': 77.92,
                      'ups-zone-603': 101.8,
                      'ups-zone-604': 127.85,
                      'ups-zone-605': 113.21,
                      'ups-zone-606': 181.08,
                      'ups-zone-607': 195.45,
                      'ups-zone-608': 181.91,
                      'ups-zone-609': 104.11,
                      'ups-zone-611': 135.26,
                      'ups-zone-612': 134.83,
                      'ups-zone-613': 108.93,
                      'ups-zone-620': 77.41,
                      'ups-zone-621': 114.1,
                    },
                    '33': {
                      'ups-zone-71': 50.58,
                      'ups-zone-72': 59.96,
                      'ups-zone-74': 65.48,
                      'ups-zone-601': 84.43,
                      'ups-zone-602': 79.39,
                      'ups-zone-603': 103.09,
                      'ups-zone-604': 130.1,
                      'ups-zone-605': 114.56,
                      'ups-zone-606': 182.64,
                      'ups-zone-607': 199.64,
                      'ups-zone-608': 182.09,
                      'ups-zone-609': 104.45,
                      'ups-zone-611': 142.58,
                      'ups-zone-612': 138.92,
                      'ups-zone-613': 110.71,
                      'ups-zone-620': 78.88,
                      'ups-zone-621': 115.52,
                    },
                    '34': {
                      'ups-zone-71': 51.63,
                      'ups-zone-72': 60.11,
                      'ups-zone-74': 66.11,
                      'ups-zone-601': 84.65,
                      'ups-zone-602': 80.65,
                      'ups-zone-603': 103.39,
                      'ups-zone-604': 132.58,
                      'ups-zone-605': 114.84,
                      'ups-zone-606': 182.98,
                      'ups-zone-607': 202.41,
                      'ups-zone-608': 182.27,
                      'ups-zone-609': 113.59,
                      'ups-zone-611': 147.64,
                      'ups-zone-612': 139.33,
                      'ups-zone-613': 110.81,
                      'ups-zone-620': 80.14,
                      'ups-zone-621': 117.03,
                    },
                    '35': {
                      'ups-zone-71': 52.68,
                      'ups-zone-72': 61.04,
                      'ups-zone-74': 66.28,
                      'ups-zone-601': 84.8,
                      'ups-zone-602': 82.11,
                      'ups-zone-603': 104.59,
                      'ups-zone-604': 136.14,
                      'ups-zone-605': 115.03,
                      'ups-zone-606': 183.45,
                      'ups-zone-607': 203.09,
                      'ups-zone-608': 182.44,
                      'ups-zone-609': 115.7,
                      'ups-zone-611': 150.43,
                      'ups-zone-612': 139.81,
                      'ups-zone-613': 111.44,
                      'ups-zone-620': 81.61,
                      'ups-zone-621': 120.07,
                    },
                    '36': {
                      'ups-zone-71': 53.73,
                      'ups-zone-72': 62.12,
                      'ups-zone-74': 66.64,
                      'ups-zone-601': 84.95,
                      'ups-zone-602': 83.38,
                      'ups-zone-603': 106.7,
                      'ups-zone-604': 140.12,
                      'ups-zone-605': 115.18,
                      'ups-zone-606': 183.67,
                      'ups-zone-607': 206.02,
                      'ups-zone-608': 182.62,
                      'ups-zone-609': 115.91,
                      'ups-zone-611': 153.04,
                      'ups-zone-612': 149.29,
                      'ups-zone-613': 118.86,
                      'ups-zone-620': 82.89,
                      'ups-zone-621': 120.86,
                    },
                    '37': {
                      'ups-zone-71': 54.76,
                      'ups-zone-72': 63.3,
                      'ups-zone-74': 67.88,
                      'ups-zone-601': 85.1,
                      'ups-zone-602': 84.64,
                      'ups-zone-603': 107.37,
                      'ups-zone-604': 140.51,
                      'ups-zone-605': 115.33,
                      'ups-zone-606': 185.22,
                      'ups-zone-607': 212.3,
                      'ups-zone-608': 182.79,
                      'ups-zone-609': 117.83,
                      'ups-zone-611': 153.27,
                      'ups-zone-612': 156.97,
                      'ups-zone-613': 119.31,
                      'ups-zone-620': 84.15,
                      'ups-zone-621': 123.79,
                    },
                    '38': {
                      'ups-zone-71': 55.82,
                      'ups-zone-72': 64.48,
                      'ups-zone-74': 68.06,
                      'ups-zone-601': 87.19,
                      'ups-zone-602': 86.09,
                      'ups-zone-603': 109.91,
                      'ups-zone-604': 145.15,
                      'ups-zone-605': 117.39,
                      'ups-zone-606': 197.05,
                      'ups-zone-607': 217.67,
                      'ups-zone-608': 195.12,
                      'ups-zone-609': 122.83,
                      'ups-zone-611': 154.75,
                      'ups-zone-612': 159.93,
                      'ups-zone-613': 123.63,
                      'ups-zone-620': 85.6,
                      'ups-zone-621': 126.89,
                    },
                    '39': {
                      'ups-zone-71': 56.87,
                      'ups-zone-72': 65.65,
                      'ups-zone-74': 68.7,
                      'ups-zone-601': 92.91,
                      'ups-zone-602': 87.63,
                      'ups-zone-603': 111.97,
                      'ups-zone-604': 149.22,
                      'ups-zone-605': 125.82,
                      'ups-zone-606': 201.24,
                      'ups-zone-607': 217.83,
                      'ups-zone-608': 196.49,
                      'ups-zone-609': 123.32,
                      'ups-zone-611': 154.97,
                      'ups-zone-612': 160.56,
                      'ups-zone-613': 124.52,
                      'ups-zone-620': 87.15,
                      'ups-zone-621': 128.87,
                    },
                    '40': {
                      'ups-zone-71': 57.92,
                      'ups-zone-72': 67.43,
                      'ups-zone-74': 68.88,
                      'ups-zone-601': 93.31,
                      'ups-zone-602': 89.16,
                      'ups-zone-603': 117.26,
                      'ups-zone-604': 149.77,
                      'ups-zone-605': 132.79,
                      'ups-zone-606': 203.09,
                      'ups-zone-607': 224.6,
                      'ups-zone-608': 196.87,
                      'ups-zone-609': 123.51,
                      'ups-zone-611': 155.54,
                      'ups-zone-612': 161.09,
                      'ups-zone-613': 124.84,
                      'ups-zone-620': 88.68,
                      'ups-zone-621': 129.96,
                    },
                    '41': {
                      'ups-zone-71': 58.97,
                      'ups-zone-72': 67.61,
                      'ups-zone-74': 69.06,
                      'ups-zone-601': 95.15,
                      'ups-zone-602': 90.34,
                      'ups-zone-603': 117.61,
                      'ups-zone-604': 153.57,
                      'ups-zone-605': 134.07,
                      'ups-zone-606': 203.29,
                      'ups-zone-607': 227.86,
                      'ups-zone-608': 199.47,
                      'ups-zone-609': 126.69,
                      'ups-zone-611': 163.74,
                      'ups-zone-612': 165.46,
                      'ups-zone-613': 127.94,
                      'ups-zone-620': 89.25,
                      'ups-zone-621': 131.97,
                    },
                    '42': {
                      'ups-zone-71': 60.03,
                      'ups-zone-72': 68.59,
                      'ups-zone-74': 69.26,
                      'ups-zone-601': 95.42,
                      'ups-zone-602': 91.25,
                      'ups-zone-603': 117.9,
                      'ups-zone-604': 153.95,
                      'ups-zone-605': 135.64,
                      'ups-zone-606': 204.64,
                      'ups-zone-607': 247.77,
                      'ups-zone-608': 214.72,
                      'ups-zone-609': 127.04,
                      'ups-zone-611': 166.8,
                      'ups-zone-612': 165.91,
                      'ups-zone-613': 128.59,
                      'ups-zone-620': 90.15,
                      'ups-zone-621': 134.43,
                    },
                    '43': {
                      'ups-zone-71': 61.09,
                      'ups-zone-72': 69.86,
                      'ups-zone-74': 69.76,
                      'ups-zone-601': 96.82,
                      'ups-zone-602': 92.5,
                      'ups-zone-603': 124.62,
                      'ups-zone-604': 158.96,
                      'ups-zone-605': 137.62,
                      'ups-zone-606': 206.27,
                      'ups-zone-607': 254.29,
                      'ups-zone-608': 230.66,
                      'ups-zone-609': 130.24,
                      'ups-zone-611': 179.2,
                      'ups-zone-612': 166.34,
                      'ups-zone-613': 130.92,
                      'ups-zone-620': 91.39,
                      'ups-zone-621': 137.23,
                    },
                    '44': {
                      'ups-zone-71': 62.15,
                      'ups-zone-72': 70.84,
                      'ups-zone-74': 70.26,
                      'ups-zone-601': 100.78,
                      'ups-zone-602': 93.67,
                      'ups-zone-603': 130.71,
                      'ups-zone-604': 161.13,
                      'ups-zone-605': 139.59,
                      'ups-zone-606': 211.56,
                      'ups-zone-607': 257.75,
                      'ups-zone-608': 232.36,
                      'ups-zone-609': 130.4,
                      'ups-zone-611': 179.36,
                      'ups-zone-612': 174.84,
                      'ups-zone-613': 131.43,
                      'ups-zone-620': 92.54,
                      'ups-zone-621': 139.68,
                    },
                    '45': {
                      'ups-zone-71': 63.21,
                      'ups-zone-72': 71.82,
                      'ups-zone-74': 73.04,
                      'ups-zone-601': 101.18,
                      'ups-zone-602': 94.83,
                      'ups-zone-603': 131.04,
                      'ups-zone-604': 164.26,
                      'ups-zone-605': 144.61,
                      'ups-zone-606': 212.36,
                      'ups-zone-607': 258.26,
                      'ups-zone-608': 239.49,
                      'ups-zone-609': 130.56,
                      'ups-zone-611': 179.52,
                      'ups-zone-612': 178.82,
                      'ups-zone-613': 136.14,
                      'ups-zone-620': 93.69,
                      'ups-zone-621': 142.61,
                    },
                    '46': {
                      'ups-zone-71': 64.27,
                      'ups-zone-72': 72.71,
                      'ups-zone-74': 74.06,
                      'ups-zone-601': 101.66,
                      'ups-zone-602': 96.19,
                      'ups-zone-603': 131.2,
                      'ups-zone-604': 164.58,
                      'ups-zone-605': 146.37,
                      'ups-zone-606': 212.79,
                      'ups-zone-607': 258.69,
                      'ups-zone-608': 245.27,
                      'ups-zone-609': 130.73,
                      'ups-zone-611': 179.69,
                      'ups-zone-612': 179.23,
                      'ups-zone-613': 136.91,
                      'ups-zone-620': 95.03,
                      'ups-zone-621': 145.42,
                    },
                    '47': {
                      'ups-zone-71': 66.02,
                      'ups-zone-72': 73.78,
                      'ups-zone-74': 74.23,
                      'ups-zone-601': 101.81,
                      'ups-zone-602': 99.31,
                      'ups-zone-603': 134.3,
                      'ups-zone-604': 164.74,
                      'ups-zone-605': 146.52,
                      'ups-zone-606': 215.71,
                      'ups-zone-607': 269.45,
                      'ups-zone-608': 245.69,
                      'ups-zone-609': 131.55,
                      'ups-zone-611': 186.87,
                      'ups-zone-612': 179.46,
                      'ups-zone-613': 138.5,
                      'ups-zone-620': 98.11,
                      'ups-zone-621': 148.36,
                    },
                    '48': {
                      'ups-zone-71': 66.2,
                      'ups-zone-72': 75.48,
                      'ups-zone-74': 74.39,
                      'ups-zone-601': 101.94,
                      'ups-zone-602': 100.08,
                      'ups-zone-603': 136.64,
                      'ups-zone-604': 166.82,
                      'ups-zone-605': 147.66,
                      'ups-zone-606': 226.89,
                      'ups-zone-607': 281.59,
                      'ups-zone-608': 246.13,
                      'ups-zone-609': 131.71,
                      'ups-zone-611': 187.44,
                      'ups-zone-612': 181.08,
                      'ups-zone-613': 139.29,
                      'ups-zone-620': 98.87,
                      'ups-zone-621': 151.44,
                    },
                    '49': {
                      'ups-zone-71': 66.97,
                      'ups-zone-72': 75.65,
                      'ups-zone-74': 74.9,
                      'ups-zone-601': 102.49,
                      'ups-zone-602': 100.25,
                      'ups-zone-603': 136.79,
                      'ups-zone-604': 171.9,
                      'ups-zone-605': 154.1,
                      'ups-zone-606': 233.8,
                      'ups-zone-607': 283.85,
                      'ups-zone-608': 254.93,
                      'ups-zone-609': 137.35,
                      'ups-zone-611': 193.02,
                      'ups-zone-612': 181.27,
                      'ups-zone-613': 139.77,
                      'ups-zone-620': 99.04,
                      'ups-zone-621': 154.35,
                    },
                    '50': {
                      'ups-zone-71': 67.84,
                      'ups-zone-72': 76.63,
                      'ups-zone-74': 75.07,
                      'ups-zone-601': 104.0,
                      'ups-zone-602': 101.06,
                      'ups-zone-603': 137.04,
                      'ups-zone-604': 172.41,
                      'ups-zone-605': 154.83,
                      'ups-zone-606': 234.01,
                      'ups-zone-607': 285.08,
                      'ups-zone-608': 255.81,
                      'ups-zone-609': 138.18,
                      'ups-zone-611': 193.67,
                      'ups-zone-612': 181.46,
                      'ups-zone-613': 139.96,
                      'ups-zone-620': 99.84,
                      'ups-zone-621': 157.49,
                    },
                    '51': {
                      'ups-zone-71': 67.84,
                      'ups-zone-72': 76.63,
                      'ups-zone-74': 75.07,
                      'ups-zone-601': 104.0,
                      'ups-zone-602': 101.06,
                      'ups-zone-603': 137.04,
                      'ups-zone-604': 172.41,
                      'ups-zone-605': 154.83,
                      'ups-zone-606': 234.01,
                      'ups-zone-607': 285.08,
                      'ups-zone-608': 255.81,
                      'ups-zone-609': 138.18,
                      'ups-zone-611': 193.67,
                      'ups-zone-612': 181.46,
                      'ups-zone-613': 139.96,
                      'ups-zone-620': 99.84,
                      'ups-zone-621': 157.49,
                    },
                    '52': {
                      'ups-zone-71': 70.9,
                      'ups-zone-72': 79.37,
                      'ups-zone-74': 76.74,
                      'ups-zone-601': 105.76,
                      'ups-zone-602': 104.85,
                      'ups-zone-603': 139.67,
                      'ups-zone-604': 176.7,
                      'ups-zone-605': 159.87,
                      'ups-zone-606': 242.35,
                      'ups-zone-607': 285.69,
                      'ups-zone-608': 272.39,
                      'ups-zone-609': 140.55,
                      'ups-zone-611': 193.94,
                      'ups-zone-612': 184.31,
                      'ups-zone-613': 145.26,
                      'ups-zone-620': 103.59,
                      'ups-zone-621': 160.74,
                    },
                    '53': {
                      'ups-zone-71': 70.9,
                      'ups-zone-72': 79.37,
                      'ups-zone-74': 76.74,
                      'ups-zone-601': 105.76,
                      'ups-zone-602': 104.85,
                      'ups-zone-603': 139.67,
                      'ups-zone-604': 176.7,
                      'ups-zone-605': 159.87,
                      'ups-zone-606': 242.35,
                      'ups-zone-607': 285.69,
                      'ups-zone-608': 272.39,
                      'ups-zone-609': 140.55,
                      'ups-zone-611': 193.94,
                      'ups-zone-612': 184.31,
                      'ups-zone-613': 145.26,
                      'ups-zone-620': 103.59,
                      'ups-zone-621': 160.74,
                    },
                    '54': {
                      'ups-zone-71': 71.55,
                      'ups-zone-72': 80.34,
                      'ups-zone-74': 77.41,
                      'ups-zone-601': 109.26,
                      'ups-zone-602': 106.14,
                      'ups-zone-603': 141.79,
                      'ups-zone-604': 180.61,
                      'ups-zone-605': 160.1,
                      'ups-zone-606': 245.39,
                      'ups-zone-607': 297.73,
                      'ups-zone-608': 272.67,
                      'ups-zone-609': 140.82,
                      'ups-zone-611': 202.5,
                      'ups-zone-612': 184.58,
                      'ups-zone-613': 147.07,
                      'ups-zone-620': 104.86,
                      'ups-zone-621': 166.55,
                    },
                    '55': {
                      'ups-zone-71': 71.55,
                      'ups-zone-72': 80.34,
                      'ups-zone-74': 77.41,
                      'ups-zone-601': 109.26,
                      'ups-zone-602': 106.14,
                      'ups-zone-603': 141.79,
                      'ups-zone-604': 180.61,
                      'ups-zone-605': 160.1,
                      'ups-zone-606': 245.39,
                      'ups-zone-607': 297.73,
                      'ups-zone-608': 272.67,
                      'ups-zone-609': 140.82,
                      'ups-zone-611': 202.5,
                      'ups-zone-612': 184.58,
                      'ups-zone-613': 147.07,
                      'ups-zone-620': 104.86,
                      'ups-zone-621': 166.55,
                    },
                    '56': {
                      'ups-zone-71': 73.21,
                      'ups-zone-72': 82.15,
                      'ups-zone-74': 80.05,
                      'ups-zone-601': 112.06,
                      'ups-zone-602': 108.58,
                      'ups-zone-603': 143.48,
                      'ups-zone-604': 185.28,
                      'ups-zone-605': 174.84,
                      'ups-zone-606': 245.68,
                      'ups-zone-607': 299.34,
                      'ups-zone-608': 272.94,
                      'ups-zone-609': 148.92,
                      'ups-zone-611': 202.8,
                      'ups-zone-612': 185.8,
                      'ups-zone-613': 150.58,
                      'ups-zone-620': 107.27,
                      'ups-zone-621': 172.55,
                    },
                    '57': {
                      'ups-zone-71': 73.21,
                      'ups-zone-72': 82.15,
                      'ups-zone-74': 80.05,
                      'ups-zone-601': 112.06,
                      'ups-zone-602': 108.58,
                      'ups-zone-603': 143.48,
                      'ups-zone-604': 185.28,
                      'ups-zone-605': 174.84,
                      'ups-zone-606': 245.68,
                      'ups-zone-607': 299.34,
                      'ups-zone-608': 272.94,
                      'ups-zone-609': 148.92,
                      'ups-zone-611': 202.8,
                      'ups-zone-612': 185.8,
                      'ups-zone-613': 150.58,
                      'ups-zone-620': 107.27,
                      'ups-zone-621': 172.55,
                    },
                    '58': {
                      'ups-zone-71': 74.56,
                      'ups-zone-72': 83.95,
                      'ups-zone-74': 80.63,
                      'ups-zone-601': 116.38,
                      'ups-zone-602': 110.93,
                      'ups-zone-603': 145.27,
                      'ups-zone-604': 189.97,
                      'ups-zone-605': 177.44,
                      'ups-zone-606': 245.97,
                      'ups-zone-607': 299.65,
                      'ups-zone-608': 273.21,
                      'ups-zone-609': 152.48,
                      'ups-zone-611': 204.46,
                      'ups-zone-612': 186.33,
                      'ups-zone-613': 154.49,
                      'ups-zone-620': 109.6,
                      'ups-zone-621': 178.6,
                    },
                    '59': {
                      'ups-zone-71': 74.56,
                      'ups-zone-72': 83.95,
                      'ups-zone-74': 80.63,
                      'ups-zone-601': 116.38,
                      'ups-zone-602': 110.93,
                      'ups-zone-603': 145.27,
                      'ups-zone-604': 189.97,
                      'ups-zone-605': 177.44,
                      'ups-zone-606': 245.97,
                      'ups-zone-607': 299.65,
                      'ups-zone-608': 273.21,
                      'ups-zone-609': 152.48,
                      'ups-zone-611': 204.46,
                      'ups-zone-612': 186.33,
                      'ups-zone-613': 154.49,
                      'ups-zone-620': 109.6,
                      'ups-zone-621': 178.6,
                    },
                    '60': {
                      'ups-zone-71': 76.23,
                      'ups-zone-72': 88.01,
                      'ups-zone-74': 80.93,
                      'ups-zone-601': 120.18,
                      'ups-zone-602': 112.99,
                      'ups-zone-603': 147.14,
                      'ups-zone-604': 190.36,
                      'ups-zone-605': 179.63,
                      'ups-zone-606': 246.26,
                      'ups-zone-607': 299.97,
                      'ups-zone-608': 273.49,
                      'ups-zone-609': 154.92,
                      'ups-zone-611': 208.83,
                      'ups-zone-612': 189.1,
                      'ups-zone-613': 159.72,
                      'ups-zone-620': 111.62,
                      'ups-zone-621': 184.64,
                    },
                    '61': {
                      'ups-zone-71': 76.23,
                      'ups-zone-72': 88.01,
                      'ups-zone-74': 80.93,
                      'ups-zone-601': 120.18,
                      'ups-zone-602': 112.99,
                      'ups-zone-603': 147.14,
                      'ups-zone-604': 190.36,
                      'ups-zone-605': 179.63,
                      'ups-zone-606': 246.26,
                      'ups-zone-607': 299.97,
                      'ups-zone-608': 273.49,
                      'ups-zone-609': 154.92,
                      'ups-zone-611': 208.83,
                      'ups-zone-612': 189.1,
                      'ups-zone-613': 159.72,
                      'ups-zone-620': 111.62,
                      'ups-zone-621': 184.64,
                    },
                    '62': {
                      'ups-zone-71': 77.96,
                      'ups-zone-72': 89.62,
                      'ups-zone-74': 83.44,
                      'ups-zone-601': 120.43,
                      'ups-zone-602': 115.42,
                      'ups-zone-603': 150.53,
                      'ups-zone-604': 193.7,
                      'ups-zone-605': 181.92,
                      'ups-zone-606': 248.21,
                      'ups-zone-607': 300.27,
                      'ups-zone-608': 273.76,
                      'ups-zone-609': 158.72,
                      'ups-zone-611': 209.11,
                      'ups-zone-612': 189.46,
                      'ups-zone-613': 164.05,
                      'ups-zone-620': 114.02,
                      'ups-zone-621': 190.71,
                    },
                    '63': {
                      'ups-zone-71': 77.96,
                      'ups-zone-72': 89.62,
                      'ups-zone-74': 83.44,
                      'ups-zone-601': 120.43,
                      'ups-zone-602': 115.42,
                      'ups-zone-603': 150.53,
                      'ups-zone-604': 193.7,
                      'ups-zone-605': 181.92,
                      'ups-zone-606': 248.21,
                      'ups-zone-607': 300.27,
                      'ups-zone-608': 273.76,
                      'ups-zone-609': 158.72,
                      'ups-zone-611': 209.11,
                      'ups-zone-612': 189.46,
                      'ups-zone-613': 164.05,
                      'ups-zone-620': 114.02,
                      'ups-zone-621': 190.71,
                    },
                    '64': {
                      'ups-zone-71': 81.2,
                      'ups-zone-72': 90.54,
                      'ups-zone-74': 84.3,
                      'ups-zone-601': 120.68,
                      'ups-zone-602': 119.11,
                      'ups-zone-603': 151.66,
                      'ups-zone-604': 195.01,
                      'ups-zone-605': 182.16,
                      'ups-zone-606': 248.5,
                      'ups-zone-607': 314.86,
                      'ups-zone-608': 277.93,
                      'ups-zone-609': 158.99,
                      'ups-zone-611': 217.93,
                      'ups-zone-612': 190.35,
                      'ups-zone-613': 165.39,
                      'ups-zone-620': 117.67,
                      'ups-zone-621': 196.59,
                    },
                    '65': {
                      'ups-zone-71': 81.2,
                      'ups-zone-72': 90.54,
                      'ups-zone-74': 84.3,
                      'ups-zone-601': 120.68,
                      'ups-zone-602': 119.11,
                      'ups-zone-603': 151.66,
                      'ups-zone-604': 195.01,
                      'ups-zone-605': 182.16,
                      'ups-zone-606': 248.5,
                      'ups-zone-607': 314.86,
                      'ups-zone-608': 277.93,
                      'ups-zone-609': 158.99,
                      'ups-zone-611': 217.93,
                      'ups-zone-612': 190.35,
                      'ups-zone-613': 165.39,
                      'ups-zone-620': 117.67,
                      'ups-zone-621': 196.59,
                    },
                    '66': {
                      'ups-zone-71': 82.19,
                      'ups-zone-72': 91.42,
                      'ups-zone-74': 85.74,
                      'ups-zone-601': 121.24,
                      'ups-zone-602': 120.43,
                      'ups-zone-603': 165.52,
                      'ups-zone-604': 196.36,
                      'ups-zone-605': 182.4,
                      'ups-zone-606': 248.79,
                      'ups-zone-607': 316.99,
                      'ups-zone-608': 278.21,
                      'ups-zone-609': 165.6,
                      'ups-zone-611': 220.94,
                      'ups-zone-612': 191.25,
                      'ups-zone-613': 168.95,
                      'ups-zone-620': 118.97,
                      'ups-zone-621': 202.46,
                    },
                    '67': {
                      'ups-zone-71': 82.19,
                      'ups-zone-72': 91.42,
                      'ups-zone-74': 85.74,
                      'ups-zone-601': 121.24,
                      'ups-zone-602': 120.43,
                      'ups-zone-603': 165.52,
                      'ups-zone-604': 196.36,
                      'ups-zone-605': 182.4,
                      'ups-zone-606': 248.79,
                      'ups-zone-607': 316.99,
                      'ups-zone-608': 278.21,
                      'ups-zone-609': 165.6,
                      'ups-zone-611': 220.94,
                      'ups-zone-612': 191.25,
                      'ups-zone-613': 168.95,
                      'ups-zone-620': 118.97,
                      'ups-zone-621': 202.46,
                    },
                    '68': {
                      'ups-zone-71': 83.13,
                      'ups-zone-72': 93.09,
                      'ups-zone-74': 87.18,
                      'ups-zone-601': 125.57,
                      'ups-zone-602': 122.84,
                      'ups-zone-603': 165.77,
                      'ups-zone-604': 197.71,
                      'ups-zone-605': 182.63,
                      'ups-zone-606': 253.1,
                      'ups-zone-607': 317.28,
                      'ups-zone-608': 284.8,
                      'ups-zone-609': 165.88,
                      'ups-zone-611': 223.13,
                      'ups-zone-612': 192.15,
                      'ups-zone-613': 171.46,
                      'ups-zone-620': 121.36,
                      'ups-zone-621': 208.5,
                    },
                    '69': {
                      'ups-zone-71': 83.13,
                      'ups-zone-72': 93.09,
                      'ups-zone-74': 87.18,
                      'ups-zone-601': 125.57,
                      'ups-zone-602': 122.84,
                      'ups-zone-603': 165.77,
                      'ups-zone-604': 197.71,
                      'ups-zone-605': 182.63,
                      'ups-zone-606': 253.1,
                      'ups-zone-607': 317.28,
                      'ups-zone-608': 284.8,
                      'ups-zone-609': 165.88,
                      'ups-zone-611': 223.13,
                      'ups-zone-612': 192.15,
                      'ups-zone-613': 171.46,
                      'ups-zone-620': 121.36,
                      'ups-zone-621': 208.5,
                    },
                    '70': {
                      'ups-zone-71': 83.35,
                      'ups-zone-72': 94.8,
                      'ups-zone-74': 88.6,
                      'ups-zone-601': 129.06,
                      'ups-zone-602': 125.3,
                      'ups-zone-603': 166.02,
                      'ups-zone-604': 199.07,
                      'ups-zone-605': 189.52,
                      'ups-zone-606': 261.84,
                      'ups-zone-607': 317.57,
                      'ups-zone-608': 291.06,
                      'ups-zone-609': 167.1,
                      'ups-zone-611': 223.8,
                      'ups-zone-612': 193.05,
                      'ups-zone-613': 173.95,
                      'ups-zone-620': 123.79,
                      'ups-zone-621': 214.44,
                    },
                    '71': {
                      'ups-zone-71': 83.35,
                      'ups-zone-72': 94.8,
                      'ups-zone-74': 88.6,
                      'ups-zone-601': 129.06,
                      'ups-zone-602': 125.3,
                      'ups-zone-603': 166.02,
                      'ups-zone-604': 199.07,
                      'ups-zone-605': 189.52,
                      'ups-zone-606': 261.84,
                      'ups-zone-607': 317.57,
                      'ups-zone-608': 291.06,
                      'ups-zone-609': 167.1,
                      'ups-zone-611': 223.8,
                      'ups-zone-612': 193.05,
                      'ups-zone-613': 173.95,
                      'ups-zone-620': 123.79,
                      'ups-zone-621': 214.44,
                    },
                    '72': {
                      'ups-zone-71': 85.82,
                      'ups-zone-72': 96.49,
                      'ups-zone-74': 90.05,
                      'ups-zone-601': 134.0,
                      'ups-zone-602': 127.89,
                      'ups-zone-603': 166.3,
                      'ups-zone-604': 200.42,
                      'ups-zone-605': 191.22,
                      'ups-zone-606': 272.0,
                      'ups-zone-607': 317.86,
                      'ups-zone-608': 291.33,
                      'ups-zone-609': 169.9,
                      'ups-zone-611': 245.66,
                      'ups-zone-612': 193.55,
                      'ups-zone-613': 176.42,
                      'ups-zone-620': 126.35,
                      'ups-zone-621': 220.36,
                    },
                    '73': {
                      'ups-zone-71': 85.82,
                      'ups-zone-72': 96.49,
                      'ups-zone-74': 90.05,
                      'ups-zone-601': 134.0,
                      'ups-zone-602': 127.89,
                      'ups-zone-603': 166.3,
                      'ups-zone-604': 200.42,
                      'ups-zone-605': 191.22,
                      'ups-zone-606': 272.0,
                      'ups-zone-607': 317.86,
                      'ups-zone-608': 291.33,
                      'ups-zone-609': 169.9,
                      'ups-zone-611': 245.66,
                      'ups-zone-612': 193.55,
                      'ups-zone-613': 176.42,
                      'ups-zone-620': 126.35,
                      'ups-zone-621': 220.36,
                    },
                    '74': {
                      'ups-zone-71': 89.47,
                      'ups-zone-72': 98.85,
                      'ups-zone-74': 91.49,
                      'ups-zone-601': 134.27,
                      'ups-zone-602': 130.18,
                      'ups-zone-603': 166.56,
                      'ups-zone-604': 201.77,
                      'ups-zone-605': 191.45,
                      'ups-zone-606': 272.28,
                      'ups-zone-607': 318.16,
                      'ups-zone-608': 301.97,
                      'ups-zone-609': 173.6,
                      'ups-zone-611': 245.93,
                      'ups-zone-612': 194.85,
                      'ups-zone-613': 178.9,
                      'ups-zone-620': 128.61,
                      'ups-zone-621': 226.29,
                    },
                    '75': {
                      'ups-zone-71': 89.47,
                      'ups-zone-72': 98.85,
                      'ups-zone-74': 91.49,
                      'ups-zone-601': 134.27,
                      'ups-zone-602': 130.18,
                      'ups-zone-603': 166.56,
                      'ups-zone-604': 201.77,
                      'ups-zone-605': 191.45,
                      'ups-zone-606': 272.28,
                      'ups-zone-607': 318.16,
                      'ups-zone-608': 301.97,
                      'ups-zone-609': 173.6,
                      'ups-zone-611': 245.93,
                      'ups-zone-612': 194.85,
                      'ups-zone-613': 178.9,
                      'ups-zone-620': 128.61,
                      'ups-zone-621': 226.29,
                    },
                    '76': {
                      'ups-zone-71': 90.55,
                      'ups-zone-72': 99.18,
                      'ups-zone-74': 92.91,
                      'ups-zone-601': 134.53,
                      'ups-zone-602': 132.62,
                      'ups-zone-603': 166.81,
                      'ups-zone-604': 203.12,
                      'ups-zone-605': 191.69,
                      'ups-zone-606': 272.55,
                      'ups-zone-607': 318.45,
                      'ups-zone-608': 312.95,
                      'ups-zone-609': 184.71,
                      'ups-zone-611': 247.45,
                      'ups-zone-612': 195.76,
                      'ups-zone-613': 181.38,
                      'ups-zone-620': 131.01,
                      'ups-zone-621': 232.27,
                    },
                    '77': {
                      'ups-zone-71': 90.55,
                      'ups-zone-72': 99.18,
                      'ups-zone-74': 92.91,
                      'ups-zone-601': 134.53,
                      'ups-zone-602': 132.62,
                      'ups-zone-603': 166.81,
                      'ups-zone-604': 203.12,
                      'ups-zone-605': 191.69,
                      'ups-zone-606': 272.55,
                      'ups-zone-607': 318.45,
                      'ups-zone-608': 312.95,
                      'ups-zone-609': 184.71,
                      'ups-zone-611': 247.45,
                      'ups-zone-612': 195.76,
                      'ups-zone-613': 181.38,
                      'ups-zone-620': 131.01,
                      'ups-zone-621': 232.27,
                    },
                    '78': {
                      'ups-zone-71': 91.29,
                      'ups-zone-72': 99.41,
                      'ups-zone-74': 94.36,
                      'ups-zone-601': 134.75,
                      'ups-zone-602': 134.86,
                      'ups-zone-603': 174.54,
                      'ups-zone-604': 204.47,
                      'ups-zone-605': 197.08,
                      'ups-zone-606': 272.82,
                      'ups-zone-607': 318.74,
                      'ups-zone-608': 314.09,
                      'ups-zone-609': 187.66,
                      'ups-zone-611': 247.77,
                      'ups-zone-612': 196.03,
                      'ups-zone-613': 183.85,
                      'ups-zone-620': 133.23,
                      'ups-zone-621': 238.19,
                    },
                    '79': {
                      'ups-zone-71': 91.29,
                      'ups-zone-72': 99.41,
                      'ups-zone-74': 94.36,
                      'ups-zone-601': 134.75,
                      'ups-zone-602': 134.86,
                      'ups-zone-603': 174.54,
                      'ups-zone-604': 204.47,
                      'ups-zone-605': 197.08,
                      'ups-zone-606': 272.82,
                      'ups-zone-607': 318.74,
                      'ups-zone-608': 314.09,
                      'ups-zone-609': 187.66,
                      'ups-zone-611': 247.77,
                      'ups-zone-612': 196.03,
                      'ups-zone-613': 183.85,
                      'ups-zone-620': 133.23,
                      'ups-zone-621': 238.19,
                    },
                    '80': {
                      'ups-zone-71': 92.03,
                      'ups-zone-72': 99.64,
                      'ups-zone-74': 96.59,
                      'ups-zone-601': 135.34,
                      'ups-zone-602': 136.85,
                      'ups-zone-603': 174.76,
                      'ups-zone-604': 205.82,
                      'ups-zone-605': 197.32,
                      'ups-zone-606': 292.79,
                      'ups-zone-607': 320.13,
                      'ups-zone-608': 314.41,
                      'ups-zone-609': 190.61,
                      'ups-zone-611': 248.09,
                      'ups-zone-612': 197.07,
                      'ups-zone-613': 186.32,
                      'ups-zone-620': 135.19,
                      'ups-zone-621': 243.97,
                    },
                    '81': {
                      'ups-zone-71': 92.03,
                      'ups-zone-72': 99.64,
                      'ups-zone-74': 96.59,
                      'ups-zone-601': 135.34,
                      'ups-zone-602': 136.85,
                      'ups-zone-603': 174.76,
                      'ups-zone-604': 205.82,
                      'ups-zone-605': 197.32,
                      'ups-zone-606': 292.79,
                      'ups-zone-607': 320.13,
                      'ups-zone-608': 314.41,
                      'ups-zone-609': 190.61,
                      'ups-zone-611': 248.09,
                      'ups-zone-612': 197.07,
                      'ups-zone-613': 186.32,
                      'ups-zone-620': 135.19,
                      'ups-zone-621': 243.97,
                    },
                    '82': {
                      'ups-zone-71': 92.76,
                      'ups-zone-72': 99.87,
                      'ups-zone-74': 98.52,
                      'ups-zone-601': 135.7,
                      'ups-zone-602': 140.46,
                      'ups-zone-603': 174.98,
                      'ups-zone-604': 207.18,
                      'ups-zone-605': 200.03,
                      'ups-zone-606': 293.07,
                      'ups-zone-607': 322.6,
                      'ups-zone-608': 314.71,
                      'ups-zone-609': 191.12,
                      'ups-zone-611': 248.95,
                      'ups-zone-612': 197.34,
                      'ups-zone-613': 188.8,
                      'ups-zone-620': 138.77,
                      'ups-zone-621': 248.71,
                    },
                    '83': {
                      'ups-zone-71': 92.76,
                      'ups-zone-72': 99.87,
                      'ups-zone-74': 98.52,
                      'ups-zone-601': 135.7,
                      'ups-zone-602': 140.46,
                      'ups-zone-603': 174.98,
                      'ups-zone-604': 207.18,
                      'ups-zone-605': 200.03,
                      'ups-zone-606': 293.07,
                      'ups-zone-607': 322.6,
                      'ups-zone-608': 314.71,
                      'ups-zone-609': 191.12,
                      'ups-zone-611': 248.95,
                      'ups-zone-612': 197.34,
                      'ups-zone-613': 188.8,
                      'ups-zone-620': 138.77,
                      'ups-zone-621': 248.71,
                    },
                    '84': {
                      'ups-zone-71': 93.51,
                      'ups-zone-72': 100.1,
                      'ups-zone-74': 98.82,
                      'ups-zone-601': 135.92,
                      'ups-zone-602': 140.82,
                      'ups-zone-603': 175.2,
                      'ups-zone-604': 208.53,
                      'ups-zone-605': 200.27,
                      'ups-zone-606': 293.34,
                      'ups-zone-607': 345.49,
                      'ups-zone-608': 314.98,
                      'ups-zone-609': 191.4,
                      'ups-zone-611': 249.27,
                      'ups-zone-612': 197.61,
                      'ups-zone-613': 191.28,
                      'ups-zone-620': 139.12,
                      'ups-zone-621': 253.37,
                    },
                    '85': {
                      'ups-zone-71': 93.51,
                      'ups-zone-72': 100.1,
                      'ups-zone-74': 98.82,
                      'ups-zone-601': 135.92,
                      'ups-zone-602': 140.82,
                      'ups-zone-603': 175.2,
                      'ups-zone-604': 208.53,
                      'ups-zone-605': 200.27,
                      'ups-zone-606': 293.34,
                      'ups-zone-607': 345.49,
                      'ups-zone-608': 314.98,
                      'ups-zone-609': 191.4,
                      'ups-zone-611': 249.27,
                      'ups-zone-612': 197.61,
                      'ups-zone-613': 191.28,
                      'ups-zone-620': 139.12,
                      'ups-zone-621': 253.37,
                    },
                    '86': {
                      'ups-zone-71': 94.22,
                      'ups-zone-72': 100.33,
                      'ups-zone-74': 102.72,
                      'ups-zone-601': 138.06,
                      'ups-zone-602': 142.81,
                      'ups-zone-603': 175.42,
                      'ups-zone-604': 209.88,
                      'ups-zone-605': 202.73,
                      'ups-zone-606': 293.61,
                      'ups-zone-607': 345.76,
                      'ups-zone-608': 315.99,
                      'ups-zone-609': 199.45,
                      'ups-zone-611': 249.59,
                      'ups-zone-612': 197.89,
                      'ups-zone-613': 193.75,
                      'ups-zone-620': 141.08,
                      'ups-zone-621': 255.48,
                    },
                    '87': {
                      'ups-zone-71': 94.22,
                      'ups-zone-72': 100.33,
                      'ups-zone-74': 102.72,
                      'ups-zone-601': 138.06,
                      'ups-zone-602': 142.81,
                      'ups-zone-603': 175.42,
                      'ups-zone-604': 209.88,
                      'ups-zone-605': 202.73,
                      'ups-zone-606': 293.61,
                      'ups-zone-607': 345.76,
                      'ups-zone-608': 315.99,
                      'ups-zone-609': 199.45,
                      'ups-zone-611': 249.59,
                      'ups-zone-612': 197.89,
                      'ups-zone-613': 193.75,
                      'ups-zone-620': 141.08,
                      'ups-zone-621': 255.48,
                    },
                    '88': {
                      'ups-zone-71': 94.83,
                      'ups-zone-72': 100.56,
                      'ups-zone-74': 105.13,
                      'ups-zone-601': 141.52,
                      'ups-zone-602': 144.81,
                      'ups-zone-603': 175.64,
                      'ups-zone-604': 210.7,
                      'ups-zone-605': 202.97,
                      'ups-zone-606': 293.88,
                      'ups-zone-607': 346.04,
                      'ups-zone-608': 316.29,
                      'ups-zone-609': 200.76,
                      'ups-zone-611': 262.28,
                      'ups-zone-612': 198.16,
                      'ups-zone-613': 196.23,
                      'ups-zone-620': 143.06,
                      'ups-zone-621': 261.81,
                    },
                    '89': {
                      'ups-zone-71': 94.83,
                      'ups-zone-72': 100.56,
                      'ups-zone-74': 105.13,
                      'ups-zone-601': 141.52,
                      'ups-zone-602': 144.81,
                      'ups-zone-603': 175.64,
                      'ups-zone-604': 210.7,
                      'ups-zone-605': 202.97,
                      'ups-zone-606': 293.88,
                      'ups-zone-607': 346.04,
                      'ups-zone-608': 316.29,
                      'ups-zone-609': 200.76,
                      'ups-zone-611': 262.28,
                      'ups-zone-612': 198.16,
                      'ups-zone-613': 196.23,
                      'ups-zone-620': 143.06,
                      'ups-zone-621': 261.81,
                    },
                    '90': {
                      'ups-zone-71': 95.06,
                      'ups-zone-72': 100.79,
                      'ups-zone-74': 105.44,
                      'ups-zone-601': 143.27,
                      'ups-zone-602': 148.33,
                      'ups-zone-603': 175.86,
                      'ups-zone-604': 210.93,
                      'ups-zone-605': 203.27,
                      'ups-zone-606': 294.16,
                      'ups-zone-607': 348.71,
                      'ups-zone-608': 317.12,
                      'ups-zone-609': 201.03,
                      'ups-zone-611': 265.5,
                      'ups-zone-612': 198.44,
                      'ups-zone-613': 196.8,
                      'ups-zone-620': 146.54,
                      'ups-zone-621': 267.58,
                    },
                    '91': {
                      'ups-zone-71': 95.06,
                      'ups-zone-72': 100.79,
                      'ups-zone-74': 105.44,
                      'ups-zone-601': 143.27,
                      'ups-zone-602': 148.33,
                      'ups-zone-603': 175.86,
                      'ups-zone-604': 210.93,
                      'ups-zone-605': 203.27,
                      'ups-zone-606': 294.16,
                      'ups-zone-607': 348.71,
                      'ups-zone-608': 317.12,
                      'ups-zone-609': 201.03,
                      'ups-zone-611': 265.5,
                      'ups-zone-612': 198.44,
                      'ups-zone-613': 196.8,
                      'ups-zone-620': 146.54,
                      'ups-zone-621': 267.58,
                    },
                    '92': {
                      'ups-zone-71': 96.03,
                      'ups-zone-72': 101.01,
                      'ups-zone-74': 106.46,
                      'ups-zone-601': 145.39,
                      'ups-zone-602': 148.78,
                      'ups-zone-603': 176.08,
                      'ups-zone-604': 211.16,
                      'ups-zone-605': 205.62,
                      'ups-zone-606': 294.43,
                      'ups-zone-607': 351.26,
                      'ups-zone-608': 334.99,
                      'ups-zone-609': 201.31,
                      'ups-zone-611': 266.83,
                      'ups-zone-612': 198.71,
                      'ups-zone-613': 198.75,
                      'ups-zone-620': 146.98,
                      'ups-zone-621': 273.33,
                    },
                    '93': {
                      'ups-zone-71': 96.03,
                      'ups-zone-72': 101.01,
                      'ups-zone-74': 106.46,
                      'ups-zone-601': 145.39,
                      'ups-zone-602': 148.78,
                      'ups-zone-603': 176.08,
                      'ups-zone-604': 211.16,
                      'ups-zone-605': 205.62,
                      'ups-zone-606': 294.43,
                      'ups-zone-607': 351.26,
                      'ups-zone-608': 334.99,
                      'ups-zone-609': 201.31,
                      'ups-zone-611': 266.83,
                      'ups-zone-612': 198.71,
                      'ups-zone-613': 198.75,
                      'ups-zone-620': 146.98,
                      'ups-zone-621': 273.33,
                    },
                    '94': {
                      'ups-zone-71': 96.61,
                      'ups-zone-72': 101.25,
                      'ups-zone-74': 106.79,
                      'ups-zone-601': 147.61,
                      'ups-zone-602': 151.53,
                      'ups-zone-603': 176.3,
                      'ups-zone-604': 211.39,
                      'ups-zone-605': 205.85,
                      'ups-zone-606': 294.7,
                      'ups-zone-607': 351.55,
                      'ups-zone-608': 337.58,
                      'ups-zone-609': 201.58,
                      'ups-zone-611': 267.12,
                      'ups-zone-612': 198.98,
                      'ups-zone-613': 198.92,
                      'ups-zone-620': 149.71,
                      'ups-zone-621': 279.05,
                    },
                    '95': {
                      'ups-zone-71': 96.61,
                      'ups-zone-72': 101.25,
                      'ups-zone-74': 106.79,
                      'ups-zone-601': 147.61,
                      'ups-zone-602': 151.53,
                      'ups-zone-603': 176.3,
                      'ups-zone-604': 211.39,
                      'ups-zone-605': 205.85,
                      'ups-zone-606': 294.7,
                      'ups-zone-607': 351.55,
                      'ups-zone-608': 337.58,
                      'ups-zone-609': 201.58,
                      'ups-zone-611': 267.12,
                      'ups-zone-612': 198.98,
                      'ups-zone-613': 198.92,
                      'ups-zone-620': 149.71,
                      'ups-zone-621': 279.05,
                    },
                    '96': {
                      'ups-zone-71': 96.91,
                      'ups-zone-72': 101.48,
                      'ups-zone-74': 109.11,
                      'ups-zone-601': 148.78,
                      'ups-zone-602': 152.76,
                      'ups-zone-603': 176.52,
                      'ups-zone-604': 211.63,
                      'ups-zone-605': 206.12,
                      'ups-zone-606': 294.98,
                      'ups-zone-607': 351.88,
                      'ups-zone-608': 338.12,
                      'ups-zone-609': 202.92,
                      'ups-zone-611': 267.4,
                      'ups-zone-612': 199.26,
                      'ups-zone-613': 199.82,
                      'ups-zone-620': 150.92,
                      'ups-zone-621': 282.16,
                    },
                    '97': {
                      'ups-zone-71': 96.91,
                      'ups-zone-72': 101.48,
                      'ups-zone-74': 109.11,
                      'ups-zone-601': 148.78,
                      'ups-zone-602': 152.76,
                      'ups-zone-603': 176.52,
                      'ups-zone-604': 211.63,
                      'ups-zone-605': 206.12,
                      'ups-zone-606': 294.98,
                      'ups-zone-607': 351.88,
                      'ups-zone-608': 338.12,
                      'ups-zone-609': 202.92,
                      'ups-zone-611': 267.4,
                      'ups-zone-612': 199.26,
                      'ups-zone-613': 199.82,
                      'ups-zone-620': 150.92,
                      'ups-zone-621': 282.16,
                    },
                    '98': {
                      'ups-zone-71': 97.16,
                      'ups-zone-72': 101.7,
                      'ups-zone-74': 112.75,
                      'ups-zone-601': 149.02,
                      'ups-zone-602': 154.76,
                      'ups-zone-603': 176.74,
                      'ups-zone-604': 212.76,
                      'ups-zone-605': 206.63,
                      'ups-zone-606': 295.25,
                      'ups-zone-607': 352.18,
                      'ups-zone-608': 338.39,
                      'ups-zone-609': 203.19,
                      'ups-zone-611': 267.69,
                      'ups-zone-612': 199.53,
                      'ups-zone-613': 200.34,
                      'ups-zone-620': 152.9,
                      'ups-zone-621': 282.54,
                    },
                    '99': {
                      'ups-zone-71': 97.16,
                      'ups-zone-72': 101.7,
                      'ups-zone-74': 112.75,
                      'ups-zone-601': 149.02,
                      'ups-zone-602': 154.76,
                      'ups-zone-603': 176.74,
                      'ups-zone-604': 212.76,
                      'ups-zone-605': 206.63,
                      'ups-zone-606': 295.25,
                      'ups-zone-607': 352.18,
                      'ups-zone-608': 338.39,
                      'ups-zone-609': 203.19,
                      'ups-zone-611': 267.69,
                      'ups-zone-612': 199.53,
                      'ups-zone-613': 200.34,
                      'ups-zone-620': 152.9,
                      'ups-zone-621': 282.54,
                    },
                    '100': {
                      'ups-zone-71': 97.39,
                      'ups-zone-72': 101.93,
                      'ups-zone-74': 122.19,
                      'ups-zone-601': 150.0,
                      'ups-zone-602': 171.2,
                      'ups-zone-603': 176.96,
                      'ups-zone-604': 213.01,
                      'ups-zone-605': 209.33,
                      'ups-zone-606': 300.28,
                      'ups-zone-607': 370.26,
                      'ups-zone-608': 352.37,
                      'ups-zone-609': 203.47,
                      'ups-zone-611': 289.35,
                      'ups-zone-612': 199.81,
                      'ups-zone-613': 204.39,
                      'ups-zone-620': 169.8,
                      'ups-zone-621': 295.43,
                    },
                    '101': {
                      'ups-zone-71': 97.39,
                      'ups-zone-72': 101.93,
                      'ups-zone-74': 122.19,
                      'ups-zone-601': 150.0,
                      'ups-zone-602': 171.2,
                      'ups-zone-603': 176.96,
                      'ups-zone-604': 213.01,
                      'ups-zone-605': 209.33,
                      'ups-zone-606': 300.28,
                      'ups-zone-607': 370.26,
                      'ups-zone-608': 352.37,
                      'ups-zone-609': 203.47,
                      'ups-zone-611': 289.35,
                      'ups-zone-612': 199.81,
                      'ups-zone-613': 204.39,
                      'ups-zone-620': 169.8,
                      'ups-zone-621': 295.43,
                    },
                    '102': {
                      'ups-zone-71': 97.39,
                      'ups-zone-72': 101.93,
                      'ups-zone-74': 122.19,
                      'ups-zone-601': 150.0,
                      'ups-zone-602': 171.2,
                      'ups-zone-603': 176.96,
                      'ups-zone-604': 213.01,
                      'ups-zone-605': 209.33,
                      'ups-zone-606': 300.28,
                      'ups-zone-607': 370.26,
                      'ups-zone-608': 352.37,
                      'ups-zone-609': 203.47,
                      'ups-zone-611': 289.35,
                      'ups-zone-612': 199.81,
                      'ups-zone-613': 204.39,
                      'ups-zone-620': 169.8,
                      'ups-zone-621': 295.43,
                    },
                    '103': {
                      'ups-zone-71': 97.39,
                      'ups-zone-72': 101.93,
                      'ups-zone-74': 122.19,
                      'ups-zone-601': 150.0,
                      'ups-zone-602': 171.2,
                      'ups-zone-603': 176.96,
                      'ups-zone-604': 213.01,
                      'ups-zone-605': 209.33,
                      'ups-zone-606': 300.28,
                      'ups-zone-607': 370.26,
                      'ups-zone-608': 352.37,
                      'ups-zone-609': 203.47,
                      'ups-zone-611': 289.35,
                      'ups-zone-612': 199.81,
                      'ups-zone-613': 204.39,
                      'ups-zone-620': 169.8,
                      'ups-zone-621': 295.43,
                    },
                    '104': {
                      'ups-zone-71': 97.39,
                      'ups-zone-72': 101.93,
                      'ups-zone-74': 122.19,
                      'ups-zone-601': 150.0,
                      'ups-zone-602': 171.2,
                      'ups-zone-603': 176.96,
                      'ups-zone-604': 213.01,
                      'ups-zone-605': 209.33,
                      'ups-zone-606': 300.28,
                      'ups-zone-607': 370.26,
                      'ups-zone-608': 352.37,
                      'ups-zone-609': 203.47,
                      'ups-zone-611': 289.35,
                      'ups-zone-612': 199.81,
                      'ups-zone-613': 204.39,
                      'ups-zone-620': 169.8,
                      'ups-zone-621': 295.43,
                    },
                    '105': {
                      'ups-zone-71': 101.93,
                      'ups-zone-72': 104.39,
                      'ups-zone-74': 125.5,
                      'ups-zone-601': 155.62,
                      'ups-zone-602': 176.07,
                      'ups-zone-603': 183.93,
                      'ups-zone-604': 223.48,
                      'ups-zone-605': 219.79,
                      'ups-zone-606': 324.39,
                      'ups-zone-607': 385.09,
                      'ups-zone-608': 368.56,
                      'ups-zone-609': 222.26,
                      'ups-zone-611': 300.34,
                      'ups-zone-612': 206.87,
                      'ups-zone-613': 207.64,
                      'ups-zone-620': 174.1,
                      'ups-zone-621': 305.34,
                    },
                    '106': {
                      'ups-zone-71': 101.93,
                      'ups-zone-72': 104.39,
                      'ups-zone-74': 125.5,
                      'ups-zone-601': 155.62,
                      'ups-zone-602': 176.07,
                      'ups-zone-603': 183.93,
                      'ups-zone-604': 223.48,
                      'ups-zone-605': 219.79,
                      'ups-zone-606': 324.39,
                      'ups-zone-607': 385.09,
                      'ups-zone-608': 368.56,
                      'ups-zone-609': 222.26,
                      'ups-zone-611': 300.34,
                      'ups-zone-612': 206.87,
                      'ups-zone-613': 207.64,
                      'ups-zone-620': 174.1,
                      'ups-zone-621': 305.34,
                    },
                    '107': {
                      'ups-zone-71': 101.93,
                      'ups-zone-72': 104.39,
                      'ups-zone-74': 125.5,
                      'ups-zone-601': 155.62,
                      'ups-zone-602': 176.07,
                      'ups-zone-603': 183.93,
                      'ups-zone-604': 223.48,
                      'ups-zone-605': 219.79,
                      'ups-zone-606': 324.39,
                      'ups-zone-607': 385.09,
                      'ups-zone-608': 368.56,
                      'ups-zone-609': 222.26,
                      'ups-zone-611': 300.34,
                      'ups-zone-612': 206.87,
                      'ups-zone-613': 207.64,
                      'ups-zone-620': 174.1,
                      'ups-zone-621': 305.34,
                    },
                    '108': {
                      'ups-zone-71': 101.93,
                      'ups-zone-72': 104.39,
                      'ups-zone-74': 125.5,
                      'ups-zone-601': 155.62,
                      'ups-zone-602': 176.07,
                      'ups-zone-603': 183.93,
                      'ups-zone-604': 223.48,
                      'ups-zone-605': 219.79,
                      'ups-zone-606': 324.39,
                      'ups-zone-607': 385.09,
                      'ups-zone-608': 368.56,
                      'ups-zone-609': 222.26,
                      'ups-zone-611': 300.34,
                      'ups-zone-612': 206.87,
                      'ups-zone-613': 207.64,
                      'ups-zone-620': 174.1,
                      'ups-zone-621': 305.34,
                    },
                    '109': {
                      'ups-zone-71': 101.93,
                      'ups-zone-72': 104.39,
                      'ups-zone-74': 125.5,
                      'ups-zone-601': 155.62,
                      'ups-zone-602': 176.07,
                      'ups-zone-603': 183.93,
                      'ups-zone-604': 223.48,
                      'ups-zone-605': 219.79,
                      'ups-zone-606': 324.39,
                      'ups-zone-607': 385.09,
                      'ups-zone-608': 368.56,
                      'ups-zone-609': 222.26,
                      'ups-zone-611': 300.34,
                      'ups-zone-612': 206.87,
                      'ups-zone-613': 207.64,
                      'ups-zone-620': 174.1,
                      'ups-zone-621': 305.34,
                    },
                    '110': {
                      'ups-zone-71': 106.79,
                      'ups-zone-72': 109.37,
                      'ups-zone-74': 131.47,
                      'ups-zone-601': 163.01,
                      'ups-zone-602': 184.45,
                      'ups-zone-603': 192.69,
                      'ups-zone-604': 234.12,
                      'ups-zone-605': 230.22,
                      'ups-zone-606': 339.84,
                      'ups-zone-607': 403.43,
                      'ups-zone-608': 386.11,
                      'ups-zone-609': 232.85,
                      'ups-zone-611': 314.64,
                      'ups-zone-612': 216.72,
                      'ups-zone-613': 217.55,
                      'ups-zone-620': 182.39,
                      'ups-zone-621': 307.56,
                    },
                    '111': {
                      'ups-zone-71': 106.79,
                      'ups-zone-72': 109.37,
                      'ups-zone-74': 131.47,
                      'ups-zone-601': 163.01,
                      'ups-zone-602': 184.45,
                      'ups-zone-603': 192.69,
                      'ups-zone-604': 234.12,
                      'ups-zone-605': 230.22,
                      'ups-zone-606': 339.84,
                      'ups-zone-607': 403.43,
                      'ups-zone-608': 386.11,
                      'ups-zone-609': 232.85,
                      'ups-zone-611': 314.64,
                      'ups-zone-612': 216.72,
                      'ups-zone-613': 217.55,
                      'ups-zone-620': 182.39,
                      'ups-zone-621': 307.56,
                    },
                    '112': {
                      'ups-zone-71': 106.79,
                      'ups-zone-72': 109.37,
                      'ups-zone-74': 131.47,
                      'ups-zone-601': 163.01,
                      'ups-zone-602': 184.45,
                      'ups-zone-603': 192.69,
                      'ups-zone-604': 234.12,
                      'ups-zone-605': 230.22,
                      'ups-zone-606': 339.84,
                      'ups-zone-607': 403.43,
                      'ups-zone-608': 386.11,
                      'ups-zone-609': 232.85,
                      'ups-zone-611': 314.64,
                      'ups-zone-612': 216.72,
                      'ups-zone-613': 217.55,
                      'ups-zone-620': 182.39,
                      'ups-zone-621': 307.56,
                    },
                    '113': {
                      'ups-zone-71': 106.79,
                      'ups-zone-72': 109.37,
                      'ups-zone-74': 131.47,
                      'ups-zone-601': 163.01,
                      'ups-zone-602': 184.45,
                      'ups-zone-603': 192.69,
                      'ups-zone-604': 234.12,
                      'ups-zone-605': 230.22,
                      'ups-zone-606': 339.84,
                      'ups-zone-607': 403.43,
                      'ups-zone-608': 386.11,
                      'ups-zone-609': 232.85,
                      'ups-zone-611': 314.64,
                      'ups-zone-612': 216.72,
                      'ups-zone-613': 217.55,
                      'ups-zone-620': 182.39,
                      'ups-zone-621': 307.56,
                    },
                    '114': {
                      'ups-zone-71': 106.79,
                      'ups-zone-72': 109.37,
                      'ups-zone-74': 131.47,
                      'ups-zone-601': 163.01,
                      'ups-zone-602': 184.45,
                      'ups-zone-603': 192.69,
                      'ups-zone-604': 234.12,
                      'ups-zone-605': 230.22,
                      'ups-zone-606': 339.84,
                      'ups-zone-607': 403.43,
                      'ups-zone-608': 386.11,
                      'ups-zone-609': 232.85,
                      'ups-zone-611': 314.64,
                      'ups-zone-612': 216.72,
                      'ups-zone-613': 217.55,
                      'ups-zone-620': 182.39,
                      'ups-zone-621': 307.56,
                    },
                    '115': {
                      'ups-zone-71': 111.64,
                      'ups-zone-72': 114.34,
                      'ups-zone-74': 137.45,
                      'ups-zone-601': 170.44,
                      'ups-zone-602': 192.84,
                      'ups-zone-603': 201.44,
                      'ups-zone-604': 244.76,
                      'ups-zone-605': 238.95,
                      'ups-zone-606': 355.29,
                      'ups-zone-607': 421.77,
                      'ups-zone-608': 403.66,
                      'ups-zone-609': 243.43,
                      'ups-zone-611': 328.95,
                      'ups-zone-612': 226.57,
                      'ups-zone-613': 227.83,
                      'ups-zone-620': 190.68,
                      'ups-zone-621': 320.61,
                    },
                    '116': {
                      'ups-zone-71': 111.64,
                      'ups-zone-72': 114.34,
                      'ups-zone-74': 137.45,
                      'ups-zone-601': 170.44,
                      'ups-zone-602': 192.84,
                      'ups-zone-603': 201.44,
                      'ups-zone-604': 244.76,
                      'ups-zone-605': 238.95,
                      'ups-zone-606': 355.29,
                      'ups-zone-607': 421.77,
                      'ups-zone-608': 403.66,
                      'ups-zone-609': 243.43,
                      'ups-zone-611': 328.95,
                      'ups-zone-612': 226.57,
                      'ups-zone-613': 227.83,
                      'ups-zone-620': 190.68,
                      'ups-zone-621': 320.61,
                    },
                    '117': {
                      'ups-zone-71': 111.64,
                      'ups-zone-72': 114.34,
                      'ups-zone-74': 137.45,
                      'ups-zone-601': 170.44,
                      'ups-zone-602': 192.84,
                      'ups-zone-603': 201.44,
                      'ups-zone-604': 244.76,
                      'ups-zone-605': 238.95,
                      'ups-zone-606': 355.29,
                      'ups-zone-607': 421.77,
                      'ups-zone-608': 403.66,
                      'ups-zone-609': 243.43,
                      'ups-zone-611': 328.95,
                      'ups-zone-612': 226.57,
                      'ups-zone-613': 227.83,
                      'ups-zone-620': 190.68,
                      'ups-zone-621': 320.61,
                    },
                    '118': {
                      'ups-zone-71': 111.64,
                      'ups-zone-72': 114.34,
                      'ups-zone-74': 137.45,
                      'ups-zone-601': 170.44,
                      'ups-zone-602': 192.84,
                      'ups-zone-603': 201.44,
                      'ups-zone-604': 244.76,
                      'ups-zone-605': 238.95,
                      'ups-zone-606': 355.29,
                      'ups-zone-607': 421.77,
                      'ups-zone-608': 403.66,
                      'ups-zone-609': 243.43,
                      'ups-zone-611': 328.95,
                      'ups-zone-612': 226.57,
                      'ups-zone-613': 227.83,
                      'ups-zone-620': 190.68,
                      'ups-zone-621': 320.61,
                    },
                    '119': {
                      'ups-zone-71': 111.64,
                      'ups-zone-72': 114.34,
                      'ups-zone-74': 137.45,
                      'ups-zone-601': 170.44,
                      'ups-zone-602': 192.84,
                      'ups-zone-603': 201.44,
                      'ups-zone-604': 244.76,
                      'ups-zone-605': 238.95,
                      'ups-zone-606': 355.29,
                      'ups-zone-607': 421.77,
                      'ups-zone-608': 403.66,
                      'ups-zone-609': 243.43,
                      'ups-zone-611': 328.95,
                      'ups-zone-612': 226.57,
                      'ups-zone-613': 227.83,
                      'ups-zone-620': 190.68,
                      'ups-zone-621': 320.61,
                    },
                    '120': {
                      'ups-zone-71': 116.49,
                      'ups-zone-72': 119.31,
                      'ups-zone-74': 143.42,
                      'ups-zone-601': 177.83,
                      'ups-zone-602': 201.22,
                      'ups-zone-603': 210.2,
                      'ups-zone-604': 255.4,
                      'ups-zone-605': 248.91,
                      'ups-zone-606': 370.74,
                      'ups-zone-607': 440.1,
                      'ups-zone-608': 421.21,
                      'ups-zone-609': 254.01,
                      'ups-zone-611': 343.25,
                      'ups-zone-612': 236.42,
                      'ups-zone-613': 237.48,
                      'ups-zone-620': 198.97,
                      'ups-zone-621': 333.5,
                    },
                    '121': {
                      'ups-zone-71': 116.49,
                      'ups-zone-72': 119.31,
                      'ups-zone-74': 143.42,
                      'ups-zone-601': 177.83,
                      'ups-zone-602': 201.22,
                      'ups-zone-603': 210.2,
                      'ups-zone-604': 255.4,
                      'ups-zone-605': 248.91,
                      'ups-zone-606': 370.74,
                      'ups-zone-607': 440.1,
                      'ups-zone-608': 421.21,
                      'ups-zone-609': 254.01,
                      'ups-zone-611': 343.25,
                      'ups-zone-612': 236.42,
                      'ups-zone-613': 237.48,
                      'ups-zone-620': 198.97,
                      'ups-zone-621': 333.5,
                    },
                    '122': {
                      'ups-zone-71': 116.49,
                      'ups-zone-72': 119.31,
                      'ups-zone-74': 143.42,
                      'ups-zone-601': 177.83,
                      'ups-zone-602': 201.22,
                      'ups-zone-603': 210.2,
                      'ups-zone-604': 255.4,
                      'ups-zone-605': 248.91,
                      'ups-zone-606': 370.74,
                      'ups-zone-607': 440.1,
                      'ups-zone-608': 421.21,
                      'ups-zone-609': 254.01,
                      'ups-zone-611': 343.25,
                      'ups-zone-612': 236.42,
                      'ups-zone-613': 237.48,
                      'ups-zone-620': 198.97,
                      'ups-zone-621': 333.5,
                    },
                    '123': {
                      'ups-zone-71': 116.49,
                      'ups-zone-72': 119.31,
                      'ups-zone-74': 143.42,
                      'ups-zone-601': 177.83,
                      'ups-zone-602': 201.22,
                      'ups-zone-603': 210.2,
                      'ups-zone-604': 255.4,
                      'ups-zone-605': 248.91,
                      'ups-zone-606': 370.74,
                      'ups-zone-607': 440.1,
                      'ups-zone-608': 421.21,
                      'ups-zone-609': 254.01,
                      'ups-zone-611': 343.25,
                      'ups-zone-612': 236.42,
                      'ups-zone-613': 237.48,
                      'ups-zone-620': 198.97,
                      'ups-zone-621': 333.5,
                    },
                    '124': {
                      'ups-zone-71': 116.49,
                      'ups-zone-72': 119.31,
                      'ups-zone-74': 143.42,
                      'ups-zone-601': 177.83,
                      'ups-zone-602': 201.22,
                      'ups-zone-603': 210.2,
                      'ups-zone-604': 255.4,
                      'ups-zone-605': 248.91,
                      'ups-zone-606': 370.74,
                      'ups-zone-607': 440.1,
                      'ups-zone-608': 421.21,
                      'ups-zone-609': 254.01,
                      'ups-zone-611': 343.25,
                      'ups-zone-612': 236.42,
                      'ups-zone-613': 237.48,
                      'ups-zone-620': 198.97,
                      'ups-zone-621': 333.5,
                    },
                    '125': {
                      'ups-zone-71': 121.35,
                      'ups-zone-72': 124.28,
                      'ups-zone-74': 149.4,
                      'ups-zone-601': 185.25,
                      'ups-zone-602': 209.61,
                      'ups-zone-603': 218.96,
                      'ups-zone-604': 266.05,
                      'ups-zone-605': 261.65,
                      'ups-zone-606': 386.18,
                      'ups-zone-607': 458.44,
                      'ups-zone-608': 438.76,
                      'ups-zone-609': 264.59,
                      'ups-zone-611': 357.55,
                      'ups-zone-612': 246.27,
                      'ups-zone-613': 246.97,
                      'ups-zone-620': 207.26,
                      'ups-zone-621': 343.86,
                    },
                    '126': {
                      'ups-zone-71': 121.35,
                      'ups-zone-72': 124.28,
                      'ups-zone-74': 149.4,
                      'ups-zone-601': 185.25,
                      'ups-zone-602': 209.61,
                      'ups-zone-603': 218.96,
                      'ups-zone-604': 266.05,
                      'ups-zone-605': 261.65,
                      'ups-zone-606': 386.18,
                      'ups-zone-607': 458.44,
                      'ups-zone-608': 438.76,
                      'ups-zone-609': 264.59,
                      'ups-zone-611': 357.55,
                      'ups-zone-612': 246.27,
                      'ups-zone-613': 246.97,
                      'ups-zone-620': 207.26,
                      'ups-zone-621': 343.86,
                    },
                    '127': {
                      'ups-zone-71': 121.35,
                      'ups-zone-72': 124.28,
                      'ups-zone-74': 149.4,
                      'ups-zone-601': 185.25,
                      'ups-zone-602': 209.61,
                      'ups-zone-603': 218.96,
                      'ups-zone-604': 266.05,
                      'ups-zone-605': 261.65,
                      'ups-zone-606': 386.18,
                      'ups-zone-607': 458.44,
                      'ups-zone-608': 438.76,
                      'ups-zone-609': 264.59,
                      'ups-zone-611': 357.55,
                      'ups-zone-612': 246.27,
                      'ups-zone-613': 246.97,
                      'ups-zone-620': 207.26,
                      'ups-zone-621': 343.86,
                    },
                    '128': {
                      'ups-zone-71': 121.35,
                      'ups-zone-72': 124.28,
                      'ups-zone-74': 149.4,
                      'ups-zone-601': 185.25,
                      'ups-zone-602': 209.61,
                      'ups-zone-603': 218.96,
                      'ups-zone-604': 266.05,
                      'ups-zone-605': 261.65,
                      'ups-zone-606': 386.18,
                      'ups-zone-607': 458.44,
                      'ups-zone-608': 438.76,
                      'ups-zone-609': 264.59,
                      'ups-zone-611': 357.55,
                      'ups-zone-612': 246.27,
                      'ups-zone-613': 246.97,
                      'ups-zone-620': 207.26,
                      'ups-zone-621': 343.86,
                    },
                    '129': {
                      'ups-zone-71': 121.35,
                      'ups-zone-72': 124.28,
                      'ups-zone-74': 149.4,
                      'ups-zone-601': 185.25,
                      'ups-zone-602': 209.61,
                      'ups-zone-603': 218.96,
                      'ups-zone-604': 266.05,
                      'ups-zone-605': 261.65,
                      'ups-zone-606': 386.18,
                      'ups-zone-607': 458.44,
                      'ups-zone-608': 438.76,
                      'ups-zone-609': 264.59,
                      'ups-zone-611': 357.55,
                      'ups-zone-612': 246.27,
                      'ups-zone-613': 246.97,
                      'ups-zone-620': 207.26,
                      'ups-zone-621': 343.86,
                    },
                    '130': {
                      'ups-zone-71': 126.2,
                      'ups-zone-72': 129.25,
                      'ups-zone-74': 155.38,
                      'ups-zone-601': 192.64,
                      'ups-zone-602': 217.99,
                      'ups-zone-603': 227.72,
                      'ups-zone-604': 276.69,
                      'ups-zone-605': 266.01,
                      'ups-zone-606': 401.63,
                      'ups-zone-607': 476.78,
                      'ups-zone-608': 456.31,
                      'ups-zone-609': 275.18,
                      'ups-zone-611': 371.85,
                      'ups-zone-612': 256.12,
                      'ups-zone-613': 257.36,
                      'ups-zone-620': 215.55,
                      'ups-zone-621': 354.24,
                    },
                    '131': {
                      'ups-zone-71': 126.2,
                      'ups-zone-72': 129.25,
                      'ups-zone-74': 155.38,
                      'ups-zone-601': 192.64,
                      'ups-zone-602': 217.99,
                      'ups-zone-603': 227.72,
                      'ups-zone-604': 276.69,
                      'ups-zone-605': 266.01,
                      'ups-zone-606': 401.63,
                      'ups-zone-607': 476.78,
                      'ups-zone-608': 456.31,
                      'ups-zone-609': 275.18,
                      'ups-zone-611': 371.85,
                      'ups-zone-612': 256.12,
                      'ups-zone-613': 257.36,
                      'ups-zone-620': 215.55,
                      'ups-zone-621': 354.24,
                    },
                    '132': {
                      'ups-zone-71': 126.2,
                      'ups-zone-72': 129.25,
                      'ups-zone-74': 155.38,
                      'ups-zone-601': 192.64,
                      'ups-zone-602': 217.99,
                      'ups-zone-603': 227.72,
                      'ups-zone-604': 276.69,
                      'ups-zone-605': 266.01,
                      'ups-zone-606': 401.63,
                      'ups-zone-607': 476.78,
                      'ups-zone-608': 456.31,
                      'ups-zone-609': 275.18,
                      'ups-zone-611': 371.85,
                      'ups-zone-612': 256.12,
                      'ups-zone-613': 257.36,
                      'ups-zone-620': 215.55,
                      'ups-zone-621': 354.24,
                    },
                    '133': {
                      'ups-zone-71': 126.2,
                      'ups-zone-72': 129.25,
                      'ups-zone-74': 155.38,
                      'ups-zone-601': 192.64,
                      'ups-zone-602': 217.99,
                      'ups-zone-603': 227.72,
                      'ups-zone-604': 276.69,
                      'ups-zone-605': 266.01,
                      'ups-zone-606': 401.63,
                      'ups-zone-607': 476.78,
                      'ups-zone-608': 456.31,
                      'ups-zone-609': 275.18,
                      'ups-zone-611': 371.85,
                      'ups-zone-612': 256.12,
                      'ups-zone-613': 257.36,
                      'ups-zone-620': 215.55,
                      'ups-zone-621': 354.24,
                    },
                    '134': {
                      'ups-zone-71': 126.2,
                      'ups-zone-72': 129.25,
                      'ups-zone-74': 155.38,
                      'ups-zone-601': 192.64,
                      'ups-zone-602': 217.99,
                      'ups-zone-603': 227.72,
                      'ups-zone-604': 276.69,
                      'ups-zone-605': 266.01,
                      'ups-zone-606': 401.63,
                      'ups-zone-607': 476.78,
                      'ups-zone-608': 456.31,
                      'ups-zone-609': 275.18,
                      'ups-zone-611': 371.85,
                      'ups-zone-612': 256.12,
                      'ups-zone-613': 257.36,
                      'ups-zone-620': 215.55,
                      'ups-zone-621': 354.24,
                    },
                    '135': {
                      'ups-zone-71': 131.05,
                      'ups-zone-72': 134.22,
                      'ups-zone-74': 161.35,
                      'ups-zone-601': 200.06,
                      'ups-zone-602': 226.38,
                      'ups-zone-603': 236.48,
                      'ups-zone-604': 287.33,
                      'ups-zone-605': 273.31,
                      'ups-zone-606': 417.08,
                      'ups-zone-607': 495.12,
                      'ups-zone-608': 473.86,
                      'ups-zone-609': 285.76,
                      'ups-zone-611': 374.81,
                      'ups-zone-612': 265.98,
                      'ups-zone-613': 266.86,
                      'ups-zone-620': 223.84,
                      'ups-zone-621': 363.99,
                    },
                    '136': {
                      'ups-zone-71': 131.05,
                      'ups-zone-72': 134.22,
                      'ups-zone-74': 161.35,
                      'ups-zone-601': 200.06,
                      'ups-zone-602': 226.38,
                      'ups-zone-603': 236.48,
                      'ups-zone-604': 287.33,
                      'ups-zone-605': 273.31,
                      'ups-zone-606': 417.08,
                      'ups-zone-607': 495.12,
                      'ups-zone-608': 473.86,
                      'ups-zone-609': 285.76,
                      'ups-zone-611': 374.81,
                      'ups-zone-612': 265.98,
                      'ups-zone-613': 266.86,
                      'ups-zone-620': 223.84,
                      'ups-zone-621': 363.99,
                    },
                    '137': {
                      'ups-zone-71': 131.05,
                      'ups-zone-72': 134.22,
                      'ups-zone-74': 161.35,
                      'ups-zone-601': 200.06,
                      'ups-zone-602': 226.38,
                      'ups-zone-603': 236.48,
                      'ups-zone-604': 287.33,
                      'ups-zone-605': 273.31,
                      'ups-zone-606': 417.08,
                      'ups-zone-607': 495.12,
                      'ups-zone-608': 473.86,
                      'ups-zone-609': 285.76,
                      'ups-zone-611': 374.81,
                      'ups-zone-612': 265.98,
                      'ups-zone-613': 266.86,
                      'ups-zone-620': 223.84,
                      'ups-zone-621': 363.99,
                    },
                    '138': {
                      'ups-zone-71': 131.05,
                      'ups-zone-72': 134.22,
                      'ups-zone-74': 161.35,
                      'ups-zone-601': 200.06,
                      'ups-zone-602': 226.38,
                      'ups-zone-603': 236.48,
                      'ups-zone-604': 287.33,
                      'ups-zone-605': 273.31,
                      'ups-zone-606': 417.08,
                      'ups-zone-607': 495.12,
                      'ups-zone-608': 473.86,
                      'ups-zone-609': 285.76,
                      'ups-zone-611': 374.81,
                      'ups-zone-612': 265.98,
                      'ups-zone-613': 266.86,
                      'ups-zone-620': 223.84,
                      'ups-zone-621': 363.99,
                    },
                    '139': {
                      'ups-zone-71': 131.05,
                      'ups-zone-72': 134.22,
                      'ups-zone-74': 161.35,
                      'ups-zone-601': 200.06,
                      'ups-zone-602': 226.38,
                      'ups-zone-603': 236.48,
                      'ups-zone-604': 287.33,
                      'ups-zone-605': 273.31,
                      'ups-zone-606': 417.08,
                      'ups-zone-607': 495.12,
                      'ups-zone-608': 473.86,
                      'ups-zone-609': 285.76,
                      'ups-zone-611': 374.81,
                      'ups-zone-612': 265.98,
                      'ups-zone-613': 266.86,
                      'ups-zone-620': 223.84,
                      'ups-zone-621': 363.99,
                    },
                    '140': {
                      'ups-zone-71': 135.91,
                      'ups-zone-72': 139.19,
                      'ups-zone-74': 167.33,
                      'ups-zone-601': 207.45,
                      'ups-zone-602': 234.76,
                      'ups-zone-603': 245.24,
                      'ups-zone-604': 297.97,
                      'ups-zone-605': 281.54,
                      'ups-zone-606': 432.52,
                      'ups-zone-607': 513.46,
                      'ups-zone-608': 491.41,
                      'ups-zone-609': 296.34,
                      'ups-zone-611': 386.79,
                      'ups-zone-612': 275.82,
                      'ups-zone-613': 276.5,
                      'ups-zone-620': 232.13,
                      'ups-zone-621': 376.43,
                    },
                    '141': {
                      'ups-zone-71': 135.91,
                      'ups-zone-72': 139.19,
                      'ups-zone-74': 167.33,
                      'ups-zone-601': 207.45,
                      'ups-zone-602': 234.76,
                      'ups-zone-603': 245.24,
                      'ups-zone-604': 297.97,
                      'ups-zone-605': 281.54,
                      'ups-zone-606': 432.52,
                      'ups-zone-607': 513.46,
                      'ups-zone-608': 491.41,
                      'ups-zone-609': 296.34,
                      'ups-zone-611': 386.79,
                      'ups-zone-612': 275.82,
                      'ups-zone-613': 276.5,
                      'ups-zone-620': 232.13,
                      'ups-zone-621': 376.43,
                    },
                    '142': {
                      'ups-zone-71': 135.91,
                      'ups-zone-72': 139.19,
                      'ups-zone-74': 167.33,
                      'ups-zone-601': 207.45,
                      'ups-zone-602': 234.76,
                      'ups-zone-603': 245.24,
                      'ups-zone-604': 297.97,
                      'ups-zone-605': 281.54,
                      'ups-zone-606': 432.52,
                      'ups-zone-607': 513.46,
                      'ups-zone-608': 491.41,
                      'ups-zone-609': 296.34,
                      'ups-zone-611': 386.79,
                      'ups-zone-612': 275.82,
                      'ups-zone-613': 276.5,
                      'ups-zone-620': 232.13,
                      'ups-zone-621': 376.43,
                    },
                    '143': {
                      'ups-zone-71': 135.91,
                      'ups-zone-72': 139.19,
                      'ups-zone-74': 167.33,
                      'ups-zone-601': 207.45,
                      'ups-zone-602': 234.76,
                      'ups-zone-603': 245.24,
                      'ups-zone-604': 297.97,
                      'ups-zone-605': 281.54,
                      'ups-zone-606': 432.52,
                      'ups-zone-607': 513.46,
                      'ups-zone-608': 491.41,
                      'ups-zone-609': 296.34,
                      'ups-zone-611': 386.79,
                      'ups-zone-612': 275.82,
                      'ups-zone-613': 276.5,
                      'ups-zone-620': 232.13,
                      'ups-zone-621': 376.43,
                    },
                    '144': {
                      'ups-zone-71': 135.91,
                      'ups-zone-72': 139.19,
                      'ups-zone-74': 167.33,
                      'ups-zone-601': 207.45,
                      'ups-zone-602': 234.76,
                      'ups-zone-603': 245.24,
                      'ups-zone-604': 297.97,
                      'ups-zone-605': 281.54,
                      'ups-zone-606': 432.52,
                      'ups-zone-607': 513.46,
                      'ups-zone-608': 491.41,
                      'ups-zone-609': 296.34,
                      'ups-zone-611': 386.79,
                      'ups-zone-612': 275.82,
                      'ups-zone-613': 276.5,
                      'ups-zone-620': 232.13,
                      'ups-zone-621': 376.43,
                    },
                    '145': {
                      'ups-zone-71': 140.76,
                      'ups-zone-72': 144.16,
                      'ups-zone-74': 173.31,
                      'ups-zone-601': 214.81,
                      'ups-zone-602': 243.14,
                      'ups-zone-603': 253.63,
                      'ups-zone-604': 308.62,
                      'ups-zone-605': 283.67,
                      'ups-zone-606': 447.97,
                      'ups-zone-607': 531.79,
                      'ups-zone-608': 508.96,
                      'ups-zone-609': 306.93,
                      'ups-zone-611': 399.91,
                      'ups-zone-612': 285.68,
                      'ups-zone-613': 286.94,
                      'ups-zone-620': 240.42,
                      'ups-zone-621': 388.66,
                    },
                    '146': {
                      'ups-zone-71': 140.76,
                      'ups-zone-72': 144.16,
                      'ups-zone-74': 173.31,
                      'ups-zone-601': 214.81,
                      'ups-zone-602': 243.14,
                      'ups-zone-603': 253.63,
                      'ups-zone-604': 308.62,
                      'ups-zone-605': 283.67,
                      'ups-zone-606': 447.97,
                      'ups-zone-607': 531.79,
                      'ups-zone-608': 508.96,
                      'ups-zone-609': 306.93,
                      'ups-zone-611': 399.91,
                      'ups-zone-612': 285.68,
                      'ups-zone-613': 286.94,
                      'ups-zone-620': 240.42,
                      'ups-zone-621': 388.66,
                    },
                    '147': {
                      'ups-zone-71': 140.76,
                      'ups-zone-72': 144.16,
                      'ups-zone-74': 173.31,
                      'ups-zone-601': 214.81,
                      'ups-zone-602': 243.14,
                      'ups-zone-603': 253.63,
                      'ups-zone-604': 308.62,
                      'ups-zone-605': 283.67,
                      'ups-zone-606': 447.97,
                      'ups-zone-607': 531.79,
                      'ups-zone-608': 508.96,
                      'ups-zone-609': 306.93,
                      'ups-zone-611': 399.91,
                      'ups-zone-612': 285.68,
                      'ups-zone-613': 286.94,
                      'ups-zone-620': 240.42,
                      'ups-zone-621': 388.66,
                    },
                    '148': {
                      'ups-zone-71': 140.76,
                      'ups-zone-72': 144.16,
                      'ups-zone-74': 173.31,
                      'ups-zone-601': 214.81,
                      'ups-zone-602': 243.14,
                      'ups-zone-603': 253.63,
                      'ups-zone-604': 308.62,
                      'ups-zone-605': 283.67,
                      'ups-zone-606': 447.97,
                      'ups-zone-607': 531.79,
                      'ups-zone-608': 508.96,
                      'ups-zone-609': 306.93,
                      'ups-zone-611': 399.91,
                      'ups-zone-612': 285.68,
                      'ups-zone-613': 286.94,
                      'ups-zone-620': 240.42,
                      'ups-zone-621': 388.66,
                    },
                    '149': {
                      'ups-zone-71': 140.76,
                      'ups-zone-72': 144.16,
                      'ups-zone-74': 173.31,
                      'ups-zone-601': 214.81,
                      'ups-zone-602': 243.14,
                      'ups-zone-603': 253.63,
                      'ups-zone-604': 308.62,
                      'ups-zone-605': 283.67,
                      'ups-zone-606': 447.97,
                      'ups-zone-607': 531.79,
                      'ups-zone-608': 508.96,
                      'ups-zone-609': 306.93,
                      'ups-zone-611': 399.91,
                      'ups-zone-612': 285.68,
                      'ups-zone-613': 286.94,
                      'ups-zone-620': 240.42,
                      'ups-zone-621': 388.66,
                    },
                    '150': {
                      'ups-zone-71': 145.61,
                      'ups-zone-72': 149.13,
                      'ups-zone-74': 179.28,
                      'ups-zone-601': 221.84,
                      'ups-zone-602': 251.53,
                      'ups-zone-603': 262.75,
                      'ups-zone-604': 319.25,
                      'ups-zone-605': 285.41,
                      'ups-zone-606': 463.42,
                      'ups-zone-607': 550.13,
                      'ups-zone-608': 526.51,
                      'ups-zone-609': 317.51,
                      'ups-zone-611': 412.99,
                      'ups-zone-612': 295.53,
                      'ups-zone-613': 296.35,
                      'ups-zone-620': 248.71,
                      'ups-zone-621': 400.73,
                    },
                  },
                },
                startDateTime: '2022-09-13T15:05:14.087Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:524c1103-c476-49b2-b9f2-cfe5d1fc7c35:1',
          },
          tags: [],
        },
      ],
      carrierSettings: {
        carrierSettings: {
          active: true,
          allowLabelGenerationFailover: false,
          archived: false,
          auditInfo: {
            createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
            creationTimeStamp: '2022-05-06T20:50:53.897Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2023-01-05T15:32:13.648Z',
            version: 5,
          },
          carrierId: 'ups',
          carrierSettingsId: '4a6fa806-5214-4491-b5ce-779b8f76d356',
          description: '',
          expectedShippingVolumeOveragePercentage: 0.0,
          hazmatLimitedQuantityExempt: true,
          name: 'UPS Settings',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          peakSurchargeEligible: true,
          tagIds: [],
          urn: 'urn:carrierSettings:4a6fa806-5214-4491-b5ce-779b8f76d356:5',
        },
        tags: [],
      },
      contract: {
        active: true,
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2022-11-15T19:10:14.365Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-11-15T19:10:14.855Z',
          version: 4,
        },
        carrierAccountId: '3eb292e7-2997-44e3-91e8-09cb20d1726b',
        carrierId: 'ups',
        carrierRateSetId: '8fbcd286-1bb7-470e-8d00-fad9ef483bae',
        carrierSettingsId: '4a6fa806-5214-4491-b5ce-779b8f76d356',
        contractId: 'eed81b0d-99cc-4db9-8695-dac2c8a45bf6',
        description: '',
        name: 'Stord/FUR - UPS Contract (BDL1)',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        tagIds: [],
        urn: 'urn:contract:eed81b0d-99cc-4db9-8695-dac2c8a45bf6:4',
      },
      tags: [],
    },
    {
      carrierAccount: {
        carrierAccount: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-11-14T17:32:42.739Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2022-11-14T17:32:43.39Z',
            version: 5,
          },
          carrierAccountId: '61b4ee8d-2aa3-4263-9fad-2af6047ac17a',
          carrierId: 'dhl',
          credentials: {
            credentialStructureId: 'dhl-standard-credentials',
            credentials: {
              'dhl-client-id': 'wngMiiVoQAIUTR0AYssDfDCXb6kyYUMC',
              'dhl-client-secret': 'fxFCIAOPiMRbzb7s',
              'dhl-client-pickup-account-number': '5376266',
              'dhl-client-secret-test-mode': 'fxFCIAOPiMRbzb7s',
              'dhl-client-distribution-center': 'USBOS1',
            },
          },
          description: '',
          name: 'Stord - DHL Account (BDL1)',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          returnToAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          returnToContactId: 'd13e3ebb-aa48-41a0-9980-b0cc2dca23d7',
          serviceMethodCredentials: [],
          sortFacilityAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          sortFacilityContactId: 'd13e3ebb-aa48-41a0-9980-b0cc2dca23d7',
          tagIds: [],
          urn: 'urn:carrierAccount:61b4ee8d-2aa3-4263-9fad-2af6047ac17a:5',
        },
        returnToAddress: {
          address: {
            active: true,
            addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-06-09T16:52:57.568Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
              version: 1,
            },
            description: ' ',
            location: {
              address1: '297 State Street',
              address2: 'Building 1',
              city: 'North Haven',
              companyName: 'Stord BDL1',
              country: 'US',
              postalCode: '06473',
              region: 'CT',
              validatedAddressMetadata: {
                latitude: 41.38069,
                longitude: -72.85601,
                timeZoneId: 'America/New_York',
              },
            },
            name: 'Stord BDL1',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            tagIds: [],
            urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
          },
          tags: [],
        },
        returnToContact: {
          contact: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-08-18T21:27:15.945Z',
              lastUpdatedBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              lastUpdatedTimeStamp: '2022-09-14T22:42:38.857Z',
              version: 2,
            },
            contactId: 'd13e3ebb-aa48-41a0-9980-b0cc2dca23d7',
            contactName: 'Shipping Department',
            description: 'configured for the return address',
            email: 'operations@stord.com',
            name: 'Shipping Department',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            phoneNumber: '8337002025',
            tagIds: [],
            urn: 'urn:contact:d13e3ebb-aa48-41a0-9980-b0cc2dca23d7:2',
          },
          tags: [],
        },
        sortFacilityAddress: {
          address: {
            active: true,
            addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-06-09T16:52:57.568Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
              version: 1,
            },
            description: ' ',
            location: {
              address1: '297 State Street',
              address2: 'Building 1',
              city: 'North Haven',
              companyName: 'Stord BDL1',
              country: 'US',
              postalCode: '06473',
              region: 'CT',
              validatedAddressMetadata: {
                latitude: 41.38069,
                longitude: -72.85601,
                timeZoneId: 'America/New_York',
              },
            },
            name: 'Stord BDL1',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            tagIds: [],
            urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
          },
          tags: [],
        },
        sortFacilityContact: {
          contact: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-08-18T21:27:15.945Z',
              lastUpdatedBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              lastUpdatedTimeStamp: '2022-09-14T22:42:38.857Z',
              version: 2,
            },
            contactId: 'd13e3ebb-aa48-41a0-9980-b0cc2dca23d7',
            contactName: 'Shipping Department',
            description: 'configured for the return address',
            email: 'operations@stord.com',
            name: 'Shipping Department',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            phoneNumber: '8337002025',
            tagIds: [],
            urn: 'urn:contact:d13e3ebb-aa48-41a0-9980-b0cc2dca23d7:2',
          },
          tags: [],
        },
        tags: [],
      },
      carrierRates: [
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-10-13T12:40:30.652Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-10-13T12:40:30.652Z',
              version: 1,
            },
            carrier: 'dhl',
            carrierRateId: '9e7d5ede-bb86-4673-8aa0-96cb1a09cae3',
            carrierServiceMethodId: 'dhl-expedited-max-service-method',
            description: '',
            destinationType: 'all',
            dimWeightOverride: {},
            name: 'Stord - DHL Parcel Expedited Max, Parcel Plus Expedited Max',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2023-10-13T12:38:10.966Z',
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'dhl-zone-1': 5.25,
                      'dhl-zone-2': 5.25,
                      'dhl-zone-3': 5.42,
                      'dhl-zone-4': 5.65,
                      'dhl-zone-5': 5.84,
                      'dhl-zone-6': 6.41,
                      'dhl-zone-7': 7.08,
                      'dhl-zone-8': 7.16,
                    },
                    '2': {
                      'dhl-zone-1': 7.05,
                      'dhl-zone-2': 7.05,
                      'dhl-zone-3': 7.39,
                      'dhl-zone-4': 7.85,
                      'dhl-zone-5': 8.23,
                      'dhl-zone-6': 9.38,
                      'dhl-zone-7': 10.72,
                      'dhl-zone-8': 10.87,
                    },
                    '3': {
                      'dhl-zone-1': 8.67,
                      'dhl-zone-2': 8.67,
                      'dhl-zone-3': 9.18,
                      'dhl-zone-4': 9.87,
                      'dhl-zone-5': 10.44,
                      'dhl-zone-6': 12.15,
                      'dhl-zone-7': 14.17,
                      'dhl-zone-8': 14.4,
                    },
                    '4': {
                      'dhl-zone-1': 10.06,
                      'dhl-zone-2': 10.06,
                      'dhl-zone-3': 10.74,
                      'dhl-zone-4': 11.66,
                      'dhl-zone-5': 12.42,
                      'dhl-zone-6': 14.71,
                      'dhl-zone-7': 17.39,
                      'dhl-zone-8': 17.7,
                    },
                    '5': {
                      'dhl-zone-1': 11.45,
                      'dhl-zone-2': 11.45,
                      'dhl-zone-3': 12.3,
                      'dhl-zone-4': 13.45,
                      'dhl-zone-5': 14.4,
                      'dhl-zone-6': 17.26,
                      'dhl-zone-7': 20.62,
                      'dhl-zone-8': 21.0,
                    },
                    '6': {
                      'dhl-zone-1': 12.84,
                      'dhl-zone-2': 12.84,
                      'dhl-zone-3': 13.86,
                      'dhl-zone-4': 15.24,
                      'dhl-zone-5': 16.38,
                      'dhl-zone-6': 19.81,
                      'dhl-zone-7': 23.84,
                      'dhl-zone-8': 24.3,
                    },
                    '7': {
                      'dhl-zone-1': 14.23,
                      'dhl-zone-2': 14.23,
                      'dhl-zone-3': 15.42,
                      'dhl-zone-4': 17.03,
                      'dhl-zone-5': 18.36,
                      'dhl-zone-6': 22.36,
                      'dhl-zone-7': 27.07,
                      'dhl-zone-8': 27.6,
                    },
                    '8': {
                      'dhl-zone-1': 15.64,
                      'dhl-zone-2': 15.64,
                      'dhl-zone-3': 17.0,
                      'dhl-zone-4': 18.84,
                      'dhl-zone-5': 20.36,
                      'dhl-zone-6': 24.94,
                      'dhl-zone-7': 30.32,
                      'dhl-zone-8': 30.93,
                    },
                    '9': {
                      'dhl-zone-1': 17.03,
                      'dhl-zone-2': 17.03,
                      'dhl-zone-3': 18.56,
                      'dhl-zone-4': 20.63,
                      'dhl-zone-5': 22.34,
                      'dhl-zone-6': 27.49,
                      'dhl-zone-7': 33.54,
                      'dhl-zone-8': 34.22,
                    },
                    '10': {
                      'dhl-zone-1': 18.44,
                      'dhl-zone-2': 18.44,
                      'dhl-zone-3': 20.14,
                      'dhl-zone-4': 22.45,
                      'dhl-zone-5': 24.35,
                      'dhl-zone-6': 30.07,
                      'dhl-zone-7': 36.79,
                      'dhl-zone-8': 37.55,
                    },
                    '11': {
                      'dhl-zone-1': 19.86,
                      'dhl-zone-2': 19.86,
                      'dhl-zone-3': 21.73,
                      'dhl-zone-4': 24.27,
                      'dhl-zone-5': 26.36,
                      'dhl-zone-6': 32.65,
                      'dhl-zone-7': 40.04,
                      'dhl-zone-8': 40.88,
                    },
                    '12': {
                      'dhl-zone-1': 21.27,
                      'dhl-zone-2': 21.27,
                      'dhl-zone-3': 23.31,
                      'dhl-zone-4': 26.08,
                      'dhl-zone-5': 28.36,
                      'dhl-zone-6': 35.22,
                      'dhl-zone-7': 43.29,
                      'dhl-zone-8': 44.2,
                    },
                    '13': {
                      'dhl-zone-1': 22.67,
                      'dhl-zone-2': 22.67,
                      'dhl-zone-3': 24.88,
                      'dhl-zone-4': 27.87,
                      'dhl-zone-5': 30.34,
                      'dhl-zone-6': 37.78,
                      'dhl-zone-7': 46.52,
                      'dhl-zone-8': 47.51,
                    },
                    '14': {
                      'dhl-zone-1': 24.07,
                      'dhl-zone-2': 24.07,
                      'dhl-zone-3': 26.45,
                      'dhl-zone-4': 29.67,
                      'dhl-zone-5': 32.33,
                      'dhl-zone-6': 40.34,
                      'dhl-zone-7': 49.75,
                      'dhl-zone-8': 50.82,
                    },
                    '15': {
                      'dhl-zone-1': 25.46,
                      'dhl-zone-2': 25.46,
                      'dhl-zone-3': 28.01,
                      'dhl-zone-4': 31.47,
                      'dhl-zone-5': 34.32,
                      'dhl-zone-6': 42.9,
                      'dhl-zone-7': 52.98,
                      'dhl-zone-8': 54.12,
                    },
                    '16': {
                      'dhl-zone-1': 26.87,
                      'dhl-zone-2': 26.87,
                      'dhl-zone-3': 29.59,
                      'dhl-zone-4': 33.28,
                      'dhl-zone-5': 36.32,
                      'dhl-zone-6': 45.47,
                      'dhl-zone-7': 56.22,
                      'dhl-zone-8': 57.44,
                    },
                    '17': {
                      'dhl-zone-1': 28.29,
                      'dhl-zone-2': 28.29,
                      'dhl-zone-3': 31.18,
                      'dhl-zone-4': 35.1,
                      'dhl-zone-5': 38.33,
                      'dhl-zone-6': 48.05,
                      'dhl-zone-7': 59.48,
                      'dhl-zone-8': 60.77,
                    },
                    '18': {
                      'dhl-zone-1': 29.75,
                      'dhl-zone-2': 29.75,
                      'dhl-zone-3': 32.81,
                      'dhl-zone-4': 36.96,
                      'dhl-zone-5': 40.37,
                      'dhl-zone-6': 50.67,
                      'dhl-zone-7': 62.77,
                      'dhl-zone-8': 64.14,
                    },
                    '19': {
                      'dhl-zone-1': 31.15,
                      'dhl-zone-2': 31.15,
                      'dhl-zone-3': 34.38,
                      'dhl-zone-4': 38.76,
                      'dhl-zone-5': 42.36,
                      'dhl-zone-6': 53.24,
                      'dhl-zone-7': 66.0,
                      'dhl-zone-8': 67.45,
                    },
                    '20': {
                      'dhl-zone-1': 32.56,
                      'dhl-zone-2': 32.56,
                      'dhl-zone-3': 35.96,
                      'dhl-zone-4': 40.57,
                      'dhl-zone-5': 44.37,
                      'dhl-zone-6': 55.81,
                      'dhl-zone-7': 69.25,
                      'dhl-zone-8': 70.77,
                    },
                    '21': {
                      'dhl-zone-1': 33.96,
                      'dhl-zone-2': 33.96,
                      'dhl-zone-3': 37.53,
                      'dhl-zone-4': 42.37,
                      'dhl-zone-5': 46.36,
                      'dhl-zone-6': 58.37,
                      'dhl-zone-7': 72.48,
                      'dhl-zone-8': 74.08,
                    },
                    '22': {
                      'dhl-zone-1': 35.46,
                      'dhl-zone-2': 35.46,
                      'dhl-zone-3': 39.2,
                      'dhl-zone-4': 44.27,
                      'dhl-zone-5': 48.44,
                      'dhl-zone-6': 61.03,
                      'dhl-zone-7': 75.81,
                      'dhl-zone-8': 77.49,
                    },
                    '23': {
                      'dhl-zone-1': 36.87,
                      'dhl-zone-2': 36.87,
                      'dhl-zone-3': 40.78,
                      'dhl-zone-4': 46.08,
                      'dhl-zone-5': 50.44,
                      'dhl-zone-6': 63.6,
                      'dhl-zone-7': 79.06,
                      'dhl-zone-8': 80.81,
                    },
                    '24': {
                      'dhl-zone-1': 38.27,
                      'dhl-zone-2': 38.27,
                      'dhl-zone-3': 42.34,
                      'dhl-zone-4': 47.87,
                      'dhl-zone-5': 52.43,
                      'dhl-zone-6': 66.16,
                      'dhl-zone-7': 82.29,
                      'dhl-zone-8': 84.12,
                    },
                    '25': {
                      'dhl-zone-1': 39.69,
                      'dhl-zone-2': 39.69,
                      'dhl-zone-3': 43.94,
                      'dhl-zone-4': 49.7,
                      'dhl-zone-5': 54.45,
                      'dhl-zone-6': 68.75,
                      'dhl-zone-7': 85.55,
                      'dhl-zone-8': 87.45,
                    },
                    '0.0625': {
                      'dhl-zone-1': 3.48,
                      'dhl-zone-2': 3.48,
                      'dhl-zone-3': 3.52,
                      'dhl-zone-4': 3.58,
                      'dhl-zone-5': 3.63,
                      'dhl-zone-6': 3.77,
                      'dhl-zone-7': 3.94,
                      'dhl-zone-8': 3.96,
                    },
                    '0.125': {
                      'dhl-zone-1': 3.48,
                      'dhl-zone-2': 3.48,
                      'dhl-zone-3': 3.52,
                      'dhl-zone-4': 3.58,
                      'dhl-zone-5': 3.63,
                      'dhl-zone-6': 3.77,
                      'dhl-zone-7': 3.94,
                      'dhl-zone-8': 3.96,
                    },
                    '0.1875': {
                      'dhl-zone-1': 3.48,
                      'dhl-zone-2': 3.48,
                      'dhl-zone-3': 3.52,
                      'dhl-zone-4': 3.58,
                      'dhl-zone-5': 3.63,
                      'dhl-zone-6': 3.77,
                      'dhl-zone-7': 3.94,
                      'dhl-zone-8': 3.96,
                    },
                    '0.25': {
                      'dhl-zone-1': 3.48,
                      'dhl-zone-2': 3.48,
                      'dhl-zone-3': 3.52,
                      'dhl-zone-4': 3.58,
                      'dhl-zone-5': 3.63,
                      'dhl-zone-6': 3.77,
                      'dhl-zone-7': 3.94,
                      'dhl-zone-8': 3.96,
                    },
                    '0.3125': {
                      'dhl-zone-1': 3.71,
                      'dhl-zone-2': 3.71,
                      'dhl-zone-3': 3.76,
                      'dhl-zone-4': 3.83,
                      'dhl-zone-5': 3.89,
                      'dhl-zone-6': 4.07,
                      'dhl-zone-7': 4.28,
                      'dhl-zone-8': 4.31,
                    },
                    '0.375': {
                      'dhl-zone-1': 3.79,
                      'dhl-zone-2': 3.79,
                      'dhl-zone-3': 3.86,
                      'dhl-zone-4': 3.94,
                      'dhl-zone-5': 4.01,
                      'dhl-zone-6': 4.23,
                      'dhl-zone-7': 4.48,
                      'dhl-zone-8': 4.51,
                    },
                    '0.4375': {
                      'dhl-zone-1': 3.88,
                      'dhl-zone-2': 3.88,
                      'dhl-zone-3': 3.95,
                      'dhl-zone-4': 4.05,
                      'dhl-zone-5': 4.14,
                      'dhl-zone-6': 4.39,
                      'dhl-zone-7': 4.68,
                      'dhl-zone-8': 4.71,
                    },
                    '0.5': {
                      'dhl-zone-1': 3.96,
                      'dhl-zone-2': 3.96,
                      'dhl-zone-3': 4.05,
                      'dhl-zone-4': 4.16,
                      'dhl-zone-5': 4.26,
                      'dhl-zone-6': 4.54,
                      'dhl-zone-7': 4.88,
                      'dhl-zone-8': 4.92,
                    },
                    '0.5625': {
                      'dhl-zone-1': 4.34,
                      'dhl-zone-2': 4.34,
                      'dhl-zone-3': 4.43,
                      'dhl-zone-4': 4.56,
                      'dhl-zone-5': 4.67,
                      'dhl-zone-6': 4.99,
                      'dhl-zone-7': 5.37,
                      'dhl-zone-8': 5.41,
                    },
                    '0.625': {
                      'dhl-zone-1': 4.42,
                      'dhl-zone-2': 4.42,
                      'dhl-zone-3': 4.53,
                      'dhl-zone-4': 4.67,
                      'dhl-zone-5': 4.79,
                      'dhl-zone-6': 5.15,
                      'dhl-zone-7': 5.57,
                      'dhl-zone-8': 5.62,
                    },
                    '0.6875': {
                      'dhl-zone-1': 4.5,
                      'dhl-zone-2': 4.5,
                      'dhl-zone-3': 4.62,
                      'dhl-zone-4': 4.78,
                      'dhl-zone-5': 4.91,
                      'dhl-zone-6': 5.3,
                      'dhl-zone-7': 5.77,
                      'dhl-zone-8': 5.82,
                    },
                    '0.75': {
                      'dhl-zone-1': 4.59,
                      'dhl-zone-2': 4.59,
                      'dhl-zone-3': 4.72,
                      'dhl-zone-4': 4.89,
                      'dhl-zone-5': 5.03,
                      'dhl-zone-6': 5.46,
                      'dhl-zone-7': 5.96,
                      'dhl-zone-8': 6.02,
                    },
                    '0.8125': {
                      'dhl-zone-1': 4.99,
                      'dhl-zone-2': 4.99,
                      'dhl-zone-3': 5.13,
                      'dhl-zone-4': 5.32,
                      'dhl-zone-5': 5.47,
                      'dhl-zone-6': 5.94,
                      'dhl-zone-7': 6.49,
                      'dhl-zone-8': 6.55,
                    },
                    '0.875': {
                      'dhl-zone-1': 5.08,
                      'dhl-zone-2': 5.08,
                      'dhl-zone-3': 5.23,
                      'dhl-zone-4': 5.43,
                      'dhl-zone-5': 5.6,
                      'dhl-zone-6': 6.1,
                      'dhl-zone-7': 6.68,
                      'dhl-zone-8': 6.75,
                    },
                    '0.9375': {
                      'dhl-zone-1': 5.16,
                      'dhl-zone-2': 5.16,
                      'dhl-zone-3': 5.32,
                      'dhl-zone-4': 5.54,
                      'dhl-zone-5': 5.72,
                      'dhl-zone-6': 6.25,
                      'dhl-zone-7': 6.88,
                      'dhl-zone-8': 6.95,
                    },
                  },
                },
                startDateTime: '2022-10-13T12:38:10.966Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:9e7d5ede-bb86-4673-8aa0-96cb1a09cae3:1',
          },
          tags: [],
        },
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-12-05T18:25:31.581Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-12-05T18:25:31.581Z',
              version: 1,
            },
            carrier: 'dhl',
            carrierRateId: '5235b6c7-99ea-41e9-81fd-5fd48f8d1303',
            carrierServiceMethodId: 'dhl-expedited-service-method',
            description: '',
            destinationType: 'all',
            dimWeightOverride: {},
            name: 'Stord - DHL Expedited',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2023-12-05T18:23:31.285Z',
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'dhl-zone-1': 3.79,
                      'dhl-zone-2': 3.79,
                      'dhl-zone-3': 3.96,
                      'dhl-zone-4': 4.08,
                      'dhl-zone-5': 4.16,
                      'dhl-zone-6': 4.27,
                      'dhl-zone-7': 4.64,
                      'dhl-zone-8': 5.19,
                      'dhl-zone-11': 7.48,
                      'dhl-zone-12': 7.48,
                      'dhl-zone-13': 7.48,
                    },
                    '2': {},
                    '3': {},
                    '4': {},
                    '5': {},
                    '6': {},
                    '7': {},
                    '8': {},
                    '9': {},
                    '10': {},
                    '11': {},
                    '12': {},
                    '13': {},
                    '14': {},
                    '15': {},
                    '16': {},
                    '17': {},
                    '18': {},
                    '19': {},
                    '20': {},
                    '21': {},
                    '22': {},
                    '23': {},
                    '24': {},
                    '25': {},
                    '0.0625': {
                      'dhl-zone-1': 2.88,
                      'dhl-zone-2': 2.88,
                      'dhl-zone-3': 2.89,
                      'dhl-zone-4': 2.9,
                      'dhl-zone-5': 2.9,
                      'dhl-zone-6': 2.91,
                      'dhl-zone-7': 2.93,
                      'dhl-zone-8': 2.97,
                      'dhl-zone-11': 5.06,
                      'dhl-zone-12': 5.06,
                      'dhl-zone-13': 5.06,
                    },
                    '0.125': {
                      'dhl-zone-1': 2.9,
                      'dhl-zone-2': 2.9,
                      'dhl-zone-3': 2.92,
                      'dhl-zone-4': 2.94,
                      'dhl-zone-5': 2.95,
                      'dhl-zone-6': 2.96,
                      'dhl-zone-7': 3.01,
                      'dhl-zone-8': 3.08,
                      'dhl-zone-11': 5.06,
                      'dhl-zone-12': 5.06,
                      'dhl-zone-13': 5.06,
                    },
                    '0.1875': {
                      'dhl-zone-1': 2.93,
                      'dhl-zone-2': 2.93,
                      'dhl-zone-3': 2.96,
                      'dhl-zone-4': 2.98,
                      'dhl-zone-5': 3.0,
                      'dhl-zone-6': 3.02,
                      'dhl-zone-7': 3.09,
                      'dhl-zone-8': 3.19,
                      'dhl-zone-11': 5.06,
                      'dhl-zone-12': 5.06,
                      'dhl-zone-13': 5.06,
                    },
                    '0.25': {
                      'dhl-zone-1': 2.95,
                      'dhl-zone-2': 2.95,
                      'dhl-zone-3': 2.99,
                      'dhl-zone-4': 3.02,
                      'dhl-zone-5': 3.04,
                      'dhl-zone-6': 3.07,
                      'dhl-zone-7': 3.16,
                      'dhl-zone-8': 3.3,
                      'dhl-zone-11': 5.06,
                      'dhl-zone-12': 5.06,
                      'dhl-zone-13': 5.06,
                    },
                    '0.3125': {
                      'dhl-zone-1': 3.09,
                      'dhl-zone-2': 3.09,
                      'dhl-zone-3': 3.14,
                      'dhl-zone-4': 3.18,
                      'dhl-zone-5': 3.2,
                      'dhl-zone-6': 3.24,
                      'dhl-zone-7': 3.35,
                      'dhl-zone-8': 3.52,
                      'dhl-zone-11': 5.35,
                      'dhl-zone-12': 5.35,
                      'dhl-zone-13': 5.35,
                    },
                    '0.375': {
                      'dhl-zone-1': 3.11,
                      'dhl-zone-2': 3.11,
                      'dhl-zone-3': 3.17,
                      'dhl-zone-4': 3.22,
                      'dhl-zone-5': 3.25,
                      'dhl-zone-6': 3.29,
                      'dhl-zone-7': 3.43,
                      'dhl-zone-8': 3.64,
                      'dhl-zone-11': 5.35,
                      'dhl-zone-12': 5.35,
                      'dhl-zone-13': 5.35,
                    },
                    '0.4375': {
                      'dhl-zone-1': 3.14,
                      'dhl-zone-2': 3.14,
                      'dhl-zone-3': 3.21,
                      'dhl-zone-4': 3.26,
                      'dhl-zone-5': 3.3,
                      'dhl-zone-6': 3.35,
                      'dhl-zone-7': 3.51,
                      'dhl-zone-8': 3.75,
                      'dhl-zone-11': 5.35,
                      'dhl-zone-12': 5.35,
                      'dhl-zone-13': 5.35,
                    },
                    '0.5': {
                      'dhl-zone-1': 3.16,
                      'dhl-zone-2': 3.16,
                      'dhl-zone-3': 3.24,
                      'dhl-zone-4': 3.31,
                      'dhl-zone-5': 3.35,
                      'dhl-zone-6': 3.4,
                      'dhl-zone-7': 3.59,
                      'dhl-zone-8': 3.86,
                      'dhl-zone-11': 5.35,
                      'dhl-zone-12': 5.35,
                      'dhl-zone-13': 5.35,
                    },
                    '0.5625': {
                      'dhl-zone-1': 3.37,
                      'dhl-zone-2': 3.37,
                      'dhl-zone-3': 3.47,
                      'dhl-zone-4': 3.54,
                      'dhl-zone-5': 3.58,
                      'dhl-zone-6': 3.65,
                      'dhl-zone-7': 3.85,
                      'dhl-zone-8': 4.16,
                      'dhl-zone-11': 6.18,
                      'dhl-zone-12': 6.18,
                      'dhl-zone-13': 6.18,
                    },
                    '0.625': {
                      'dhl-zone-1': 3.4,
                      'dhl-zone-2': 3.4,
                      'dhl-zone-3': 3.5,
                      'dhl-zone-4': 3.58,
                      'dhl-zone-5': 3.63,
                      'dhl-zone-6': 3.7,
                      'dhl-zone-7': 3.93,
                      'dhl-zone-8': 4.27,
                      'dhl-zone-11': 6.18,
                      'dhl-zone-12': 6.18,
                      'dhl-zone-13': 6.18,
                    },
                    '0.6875': {
                      'dhl-zone-1': 3.42,
                      'dhl-zone-2': 3.42,
                      'dhl-zone-3': 3.54,
                      'dhl-zone-4': 3.62,
                      'dhl-zone-5': 3.68,
                      'dhl-zone-6': 3.75,
                      'dhl-zone-7': 4.01,
                      'dhl-zone-8': 4.38,
                      'dhl-zone-11': 6.18,
                      'dhl-zone-12': 6.18,
                      'dhl-zone-13': 6.18,
                    },
                    '0.75': {
                      'dhl-zone-1': 3.45,
                      'dhl-zone-2': 3.45,
                      'dhl-zone-3': 3.57,
                      'dhl-zone-4': 3.66,
                      'dhl-zone-5': 3.72,
                      'dhl-zone-6': 3.81,
                      'dhl-zone-7': 4.09,
                      'dhl-zone-8': 4.5,
                      'dhl-zone-11': 6.18,
                      'dhl-zone-12': 6.18,
                      'dhl-zone-13': 6.18,
                    },
                    '0.8125': {
                      'dhl-zone-1': 3.72,
                      'dhl-zone-2': 3.72,
                      'dhl-zone-3': 3.85,
                      'dhl-zone-4': 3.95,
                      'dhl-zone-5': 4.02,
                      'dhl-zone-6': 4.11,
                      'dhl-zone-7': 4.41,
                      'dhl-zone-8': 4.85,
                      'dhl-zone-11': 7.48,
                      'dhl-zone-12': 7.48,
                      'dhl-zone-13': 7.48,
                    },
                    '0.875': {
                      'dhl-zone-1': 3.74,
                      'dhl-zone-2': 3.74,
                      'dhl-zone-3': 3.89,
                      'dhl-zone-4': 3.99,
                      'dhl-zone-5': 4.07,
                      'dhl-zone-6': 4.16,
                      'dhl-zone-7': 4.49,
                      'dhl-zone-8': 4.97,
                      'dhl-zone-11': 7.48,
                      'dhl-zone-12': 7.48,
                      'dhl-zone-13': 7.48,
                    },
                    '0.9375': {
                      'dhl-zone-1': 3.77,
                      'dhl-zone-2': 3.77,
                      'dhl-zone-3': 3.92,
                      'dhl-zone-4': 4.04,
                      'dhl-zone-5': 4.11,
                      'dhl-zone-6': 4.22,
                      'dhl-zone-7': 4.56,
                      'dhl-zone-8': 5.08,
                      'dhl-zone-11': 7.48,
                      'dhl-zone-12': 7.48,
                      'dhl-zone-13': 7.48,
                    },
                  },
                },
                startDateTime: '2022-12-05T18:23:31.285Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:5235b6c7-99ea-41e9-81fd-5fd48f8d1303:1',
          },
          tags: [],
        },
      ],
      carrierSettings: {
        carrierSettings: {
          active: true,
          allowLabelGenerationFailover: false,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-08-10T01:31:59.115Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2023-01-04T15:23:57.935Z',
            version: 3,
          },
          carrierId: 'dhl',
          carrierSettingsId: '6d1b3bb1-aa03-4527-a643-24b3f411f78f',
          description: '',
          expectedShippingVolumeOveragePercentage: 0.0,
          hazmatLimitedQuantityExempt: true,
          name: 'DHL Settings',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          peakSurchargeEligible: false,
          tagIds: [],
          urn: 'urn:carrierSettings:6d1b3bb1-aa03-4527-a643-24b3f411f78f:3',
        },
        tags: [],
      },
      contract: {
        active: true,
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2022-11-14T17:35:42.982Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-11-14T17:35:43.487Z',
          version: 4,
        },
        carrierAccountId: '61b4ee8d-2aa3-4263-9fad-2af6047ac17a',
        carrierId: 'dhl',
        carrierRateSetId: '9f599969-ff84-425c-a363-981edcdccbfa',
        carrierSettingsId: '6d1b3bb1-aa03-4527-a643-24b3f411f78f',
        contractId: '9879fda6-5ab2-486e-809e-c963e11f7d1f',
        description: '',
        name: 'Stord - DHL Contract (BDL1)',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        tagIds: [],
        urn: 'urn:contract:9879fda6-5ab2-486e-809e-c963e11f7d1f:4',
      },
      tags: [],
    },
    {
      carrierAccount: {
        carrierAccount: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-08-11T16:19:32.154Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2023-02-24T18:34:09.105Z',
            version: 4,
          },
          carrierAccountId: '286b8784-5968-49f8-94c2-d5d6454021bd',
          carrierId: 'passport',
          credentials: {
            credentialStructureId: 'passport-standard-credentials',
            credentials: {
              'passport-client-name': 'Stord',
              'passport-api-key': '6cd5aaec3316726c4a9a570e527158dd1669161480231',
              'passport-api-key-test-mode': 'a756945d0df31c0be348740ecddee34b1647891248447',
            },
          },
          description: '',
          name: 'Stord - Passport Account',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          serviceMethodCredentials: [],
          tagIds: [],
          urn: 'urn:carrierAccount:286b8784-5968-49f8-94c2-d5d6454021bd:4',
        },
        tags: [],
      },
      carrierRates: [
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-08-10T01:48:52.698Z',
              lastUpdatedBy: '2f8f288d-bb47-45a1-88c4-9aec384de964',
              lastUpdatedTimeStamp: '2023-01-28T03:31:59.104Z',
              version: 3,
            },
            carrier: 'passport',
            carrierRateId: '44fbabea-64b1-453b-99b7-942da4aa20e1',
            carrierServiceMethodId: 'passport-priorityddp-heavy-service-method',
            description: '',
            destinationType: 'all',
            dimWeightOverride: {},
            name: 'Stord - Passport Priority DDP More Than 64oz',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2027-08-10T01:44:38.422Z',
                negotiatedSurcharges: [],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '5': {
                      'passport-priority-ddp-zone-CA': 20.8,
                      'passport-priority-ddp-zone-GB': 28.09,
                      'passport-priority-ddp-zone-AU': 40.93,
                      'passport-priority-ddp-zone-BE': 36.05,
                      'passport-priority-ddp-zone-DK': 36.05,
                      'passport-priority-ddp-zone-FR': 36.05,
                      'passport-priority-ddp-zone-DE': 36.05,
                      'passport-priority-ddp-zone-IT': 36.05,
                      'passport-priority-ddp-zone-NL': 36.05,
                      'passport-priority-ddp-zone-ES': 36.05,
                      'passport-priority-ddp-zone-MX': 34.5,
                      'passport-priority-ddp-zone-AM': 70.07,
                      'passport-priority-ddp-zone-AT': 44.51,
                      'passport-priority-ddp-zone-BG': 44.51,
                      'passport-priority-ddp-zone-HR': 44.51,
                      'passport-priority-ddp-zone-CY': 44.51,
                      'passport-priority-ddp-zone-CZ': 44.51,
                      'passport-priority-ddp-zone-EE': 44.51,
                      'passport-priority-ddp-zone-FI': 44.51,
                      'passport-priority-ddp-zone-GR': 44.51,
                      'passport-priority-ddp-zone-HU': 44.51,
                      'passport-priority-ddp-zone-IE': 44.51,
                      'passport-priority-ddp-zone-LV': 44.51,
                      'passport-priority-ddp-zone-LT': 44.51,
                      'passport-priority-ddp-zone-LU': 44.51,
                      'passport-priority-ddp-zone-MT': 44.51,
                      'passport-priority-ddp-zone-PL': 44.51,
                      'passport-priority-ddp-zone-PT': 44.51,
                      'passport-priority-ddp-zone-RO': 44.51,
                      'passport-priority-ddp-zone-SK': 44.51,
                      'passport-priority-ddp-zone-SI': 44.51,
                      'passport-priority-ddp-zone-SE': 44.51,
                      'passport-priority-ddp-zone-IL': 70.44,
                      'passport-priority-ddp-zone-OM': 77.95,
                      'passport-priority-ddp-zone-QA': 69.98,
                      'passport-priority-ddp-zone-SA': 70.02,
                      'passport-priority-ddp-zone-AE': 70.34,
                      'passport-priority-ddp-zone-CN': 68.46,
                      'passport-priority-ddp-zone-HK': 43.81,
                      'passport-priority-ddp-zone-IN': 66.31,
                      'passport-priority-ddp-zone-JP': 60.54,
                      'passport-priority-ddp-zone-KR': 51.77,
                      'passport-priority-ddp-zone-NZ': 43.81,
                      'passport-priority-ddp-zone-SG': 43.81,
                      'passport-priority-ddp-zone-TH': 45.56,
                      'passport-priority-ddp-zone-GG': 73.43,
                      'passport-priority-ddp-zone-JE': 73.43,
                      'passport-priority-ddp-zone-NO': 62.44,
                      'passport-priority-ddp-zone-CH': 62.44,
                      'passport-priority-ddp-zone-IS': 62.44,
                      'passport-priority-ddp-zone-AI': 47.69,
                      'passport-priority-ddp-zone-AG': 47.69,
                      'passport-priority-ddp-zone-AR': 73.29,
                      'passport-priority-ddp-zone-AW': 47.69,
                      'passport-priority-ddp-zone-BS': 47.69,
                      'passport-priority-ddp-zone-BB': 55.91,
                      'passport-priority-ddp-zone-BZ': 69.79,
                      'passport-priority-ddp-zone-BM': 47.69,
                      'passport-priority-ddp-zone-BO': 75.44,
                      'passport-priority-ddp-zone-BR': 47.69,
                      'passport-priority-ddp-zone-KY': 47.69,
                      'passport-priority-ddp-zone-CL': 48.08,
                      'passport-priority-ddp-zone-CO': 47.69,
                      'passport-priority-ddp-zone-CR': 73.78,
                      'passport-priority-ddp-zone-DM': 47.69,
                      'passport-priority-ddp-zone-DO': 47.69,
                      'passport-priority-ddp-zone-EC': 74.03,
                      'passport-priority-ddp-zone-SV': 69.79,
                      'passport-priority-ddp-zone-GP': 67.77,
                      'passport-priority-ddp-zone-GT': 69.89,
                      'passport-priority-ddp-zone-GY': 69.79,
                      'passport-priority-ddp-zone-HT': 47.69,
                      'passport-priority-ddp-zone-JM': 59.22,
                      'passport-priority-ddp-zone-MQ': 53.53,
                      'passport-priority-ddp-zone-AN': 47.69,
                      'passport-priority-ddp-zone-NI': 73.18,
                      'passport-priority-ddp-zone-PA': 70.08,
                      'passport-priority-ddp-zone-PY': 69.79,
                      'passport-priority-ddp-zone-PE': 72.13,
                      'passport-priority-ddp-zone-SR': 69.79,
                      'passport-priority-ddp-zone-TT': 49.98,
                      'passport-priority-ddp-zone-UY': 69.79,
                      'passport-priority-ddp-zone-AF': 107.4,
                      'passport-priority-ddp-zone-DZ': 107.4,
                      'passport-priority-ddp-zone-BH': 98.43,
                      'passport-priority-ddp-zone-BD': 89.75,
                      'passport-priority-ddp-zone-BT': 89.75,
                      'passport-priority-ddp-zone-BA': 107.4,
                      'passport-priority-ddp-zone-BW': 107.4,
                      'passport-priority-ddp-zone-BN': 98.43,
                      'passport-priority-ddp-zone-BF': 107.4,
                      'passport-priority-ddp-zone-BI': 107.4,
                      'passport-priority-ddp-zone-KH': 107.4,
                      'passport-priority-ddp-zone-CM': 107.4,
                      'passport-priority-ddp-zone-CV': 107.4,
                      'passport-priority-ddp-zone-TD': 107.4,
                      'passport-priority-ddp-zone-CG': 107.4,
                      'passport-priority-ddp-zone-CI': 107.4,
                      'passport-priority-ddp-zone-EG': 98.43,
                      'passport-priority-ddp-zone-ET': 107.4,
                      'passport-priority-ddp-zone-GA': 107.4,
                      'passport-priority-ddp-zone-GM': 107.4,
                      'passport-priority-ddp-zone-GH': 107.4,
                      'passport-priority-ddp-zone-GN': 107.4,
                      'passport-priority-ddp-zone-ID': 93.48,
                      'passport-priority-ddp-zone-JO': 98.43,
                      'passport-priority-ddp-zone-KE': 107.4,
                      'passport-priority-ddp-zone-KW': 98.77,
                      'passport-priority-ddp-zone-LB': 98.43,
                      'passport-priority-ddp-zone-LI': 87.26,
                      'passport-priority-ddp-zone-MO': 92.32,
                      'passport-priority-ddp-zone-MG': 107.4,
                      'passport-priority-ddp-zone-MW': 107.4,
                      'passport-priority-ddp-zone-MY': 87.26,
                      'passport-priority-ddp-zone-MV': 89.75,
                      'passport-priority-ddp-zone-ML': 107.4,
                      'passport-priority-ddp-zone-MR': 107.4,
                      'passport-priority-ddp-zone-MU': 107.4,
                      'passport-priority-ddp-zone-MD': 107.4,
                      'passport-priority-ddp-zone-MA': 107.75,
                      'passport-priority-ddp-zone-MZ': 107.4,
                      'passport-priority-ddp-zone-NA': 107.4,
                      'passport-priority-ddp-zone-NP': 89.75,
                      'passport-priority-ddp-zone-NE': 107.4,
                      'passport-priority-ddp-zone-NG': 107.4,
                      'passport-priority-ddp-zone-PK': 89.75,
                      'passport-priority-ddp-zone-PH': 87.3,
                      'passport-priority-ddp-zone-RE': 107.4,
                      'passport-priority-ddp-zone-RW': 107.4,
                      'passport-priority-ddp-zone-SN': 107.4,
                      'passport-priority-ddp-zone-SC': 107.4,
                      'passport-priority-ddp-zone-ZA': 88.46,
                      'passport-priority-ddp-zone-LK': 89.75,
                      'passport-priority-ddp-zone-SZ': 107.4,
                      'passport-priority-ddp-zone-TW': 87.3,
                      'passport-priority-ddp-zone-TJ': 107.4,
                      'passport-priority-ddp-zone-TZ': 107.4,
                      'passport-priority-ddp-zone-TG': 107.4,
                      'passport-priority-ddp-zone-TN': 107.4,
                      'passport-priority-ddp-zone-TR': 98.46,
                      'passport-priority-ddp-zone-TM': 107.4,
                      'passport-priority-ddp-zone-UG': 107.4,
                      'passport-priority-ddp-zone-UA': 107.4,
                      'passport-priority-ddp-zone-VN': 87.41,
                      'passport-priority-ddp-zone-YE': 98.43,
                      'passport-priority-ddp-zone-ZM': 107.4,
                      'passport-priority-ddp-zone-ZW': 107.4,
                      'passport-priority-ddp-zone-MC': 36.05,
                      'passport-priority-ddp-zone-IM': 28.09,
                      'passport-priority-ddp-zone-SM': 36.05,
                    },
                    '6': {
                      'passport-priority-ddp-zone-CA': 22.51,
                      'passport-priority-ddp-zone-GB': 32.29,
                      'passport-priority-ddp-zone-AU': 46.89,
                      'passport-priority-ddp-zone-BE': 39.53,
                      'passport-priority-ddp-zone-DK': 39.53,
                      'passport-priority-ddp-zone-FR': 39.53,
                      'passport-priority-ddp-zone-DE': 39.53,
                      'passport-priority-ddp-zone-IT': 39.53,
                      'passport-priority-ddp-zone-NL': 39.53,
                      'passport-priority-ddp-zone-ES': 39.53,
                      'passport-priority-ddp-zone-MX': 40.02,
                      'passport-priority-ddp-zone-AM': 80.6,
                      'passport-priority-ddp-zone-AT': 47.99,
                      'passport-priority-ddp-zone-BG': 47.99,
                      'passport-priority-ddp-zone-HR': 47.99,
                      'passport-priority-ddp-zone-CY': 47.99,
                      'passport-priority-ddp-zone-CZ': 47.99,
                      'passport-priority-ddp-zone-EE': 47.99,
                      'passport-priority-ddp-zone-FI': 47.99,
                      'passport-priority-ddp-zone-GR': 47.99,
                      'passport-priority-ddp-zone-HU': 47.99,
                      'passport-priority-ddp-zone-IE': 47.99,
                      'passport-priority-ddp-zone-LV': 47.99,
                      'passport-priority-ddp-zone-LT': 47.99,
                      'passport-priority-ddp-zone-LU': 47.99,
                      'passport-priority-ddp-zone-MT': 47.99,
                      'passport-priority-ddp-zone-PL': 47.99,
                      'passport-priority-ddp-zone-PT': 47.99,
                      'passport-priority-ddp-zone-RO': 47.99,
                      'passport-priority-ddp-zone-SK': 47.99,
                      'passport-priority-ddp-zone-SI': 47.99,
                      'passport-priority-ddp-zone-SE': 47.99,
                      'passport-priority-ddp-zone-IL': 70.67,
                      'passport-priority-ddp-zone-OM': 78.21,
                      'passport-priority-ddp-zone-QA': 70.21,
                      'passport-priority-ddp-zone-SA': 70.25,
                      'passport-priority-ddp-zone-AE': 70.57,
                      'passport-priority-ddp-zone-CN': 80.31,
                      'passport-priority-ddp-zone-HK': 54.32,
                      'passport-priority-ddp-zone-IN': 72.91,
                      'passport-priority-ddp-zone-JP': 70.14,
                      'passport-priority-ddp-zone-KR': 59.99,
                      'passport-priority-ddp-zone-NZ': 49.74,
                      'passport-priority-ddp-zone-SG': 54.32,
                      'passport-priority-ddp-zone-TH': 52.67,
                      'passport-priority-ddp-zone-GG': 80.24,
                      'passport-priority-ddp-zone-JE': 80.24,
                      'passport-priority-ddp-zone-NO': 68.97,
                      'passport-priority-ddp-zone-CH': 69.35,
                      'passport-priority-ddp-zone-IS': 66.14,
                      'passport-priority-ddp-zone-AI': 57.5,
                      'passport-priority-ddp-zone-AG': 57.5,
                      'passport-priority-ddp-zone-AR': 89.49,
                      'passport-priority-ddp-zone-AW': 57.5,
                      'passport-priority-ddp-zone-BS': 57.5,
                      'passport-priority-ddp-zone-BB': 68.05,
                      'passport-priority-ddp-zone-BZ': 85.99,
                      'passport-priority-ddp-zone-BM': 57.72,
                      'passport-priority-ddp-zone-BO': 91.64,
                      'passport-priority-ddp-zone-BR': 53.3,
                      'passport-priority-ddp-zone-KY': 57.5,
                      'passport-priority-ddp-zone-CL': 55.21,
                      'passport-priority-ddp-zone-CO': 53.3,
                      'passport-priority-ddp-zone-CR': 89.98,
                      'passport-priority-ddp-zone-DM': 57.5,
                      'passport-priority-ddp-zone-DO': 58.05,
                      'passport-priority-ddp-zone-EC': 90.23,
                      'passport-priority-ddp-zone-SV': 85.99,
                      'passport-priority-ddp-zone-GP': 81.27,
                      'passport-priority-ddp-zone-GT': 86.09,
                      'passport-priority-ddp-zone-GY': 85.99,
                      'passport-priority-ddp-zone-HT': 57.5,
                      'passport-priority-ddp-zone-JM': 71.76,
                      'passport-priority-ddp-zone-MQ': 65.43,
                      'passport-priority-ddp-zone-AN': 57.5,
                      'passport-priority-ddp-zone-NI': 89.39,
                      'passport-priority-ddp-zone-PA': 86.29,
                      'passport-priority-ddp-zone-PY': 85.99,
                      'passport-priority-ddp-zone-PE': 88.33,
                      'passport-priority-ddp-zone-SR': 85.99,
                      'passport-priority-ddp-zone-TT': 61.46,
                      'passport-priority-ddp-zone-UY': 85.99,
                      'passport-priority-ddp-zone-AF': 121.39,
                      'passport-priority-ddp-zone-DZ': 121.39,
                      'passport-priority-ddp-zone-BH': 99.2,
                      'passport-priority-ddp-zone-BD': 101.66,
                      'passport-priority-ddp-zone-BT': 101.66,
                      'passport-priority-ddp-zone-BA': 121.39,
                      'passport-priority-ddp-zone-BW': 121.39,
                      'passport-priority-ddp-zone-BN': 99.2,
                      'passport-priority-ddp-zone-BF': 121.39,
                      'passport-priority-ddp-zone-BI': 121.39,
                      'passport-priority-ddp-zone-KH': 121.39,
                      'passport-priority-ddp-zone-CM': 121.39,
                      'passport-priority-ddp-zone-CV': 121.39,
                      'passport-priority-ddp-zone-TD': 121.39,
                      'passport-priority-ddp-zone-CG': 121.39,
                      'passport-priority-ddp-zone-CI': 121.39,
                      'passport-priority-ddp-zone-EG': 99.2,
                      'passport-priority-ddp-zone-ET': 121.39,
                      'passport-priority-ddp-zone-GA': 121.39,
                      'passport-priority-ddp-zone-GM': 121.39,
                      'passport-priority-ddp-zone-GH': 121.39,
                      'passport-priority-ddp-zone-GN': 121.39,
                      'passport-priority-ddp-zone-ID': 111.26,
                      'passport-priority-ddp-zone-JO': 99.2,
                      'passport-priority-ddp-zone-KE': 121.39,
                      'passport-priority-ddp-zone-KW': 99.2,
                      'passport-priority-ddp-zone-LB': 99.2,
                      'passport-priority-ddp-zone-LI': 102.63,
                      'passport-priority-ddp-zone-MO': 109.97,
                      'passport-priority-ddp-zone-MG': 121.39,
                      'passport-priority-ddp-zone-MW': 121.39,
                      'passport-priority-ddp-zone-MY': 99.2,
                      'passport-priority-ddp-zone-MV': 101.66,
                      'passport-priority-ddp-zone-ML': 121.39,
                      'passport-priority-ddp-zone-MR': 121.39,
                      'passport-priority-ddp-zone-MU': 121.39,
                      'passport-priority-ddp-zone-MD': 121.39,
                      'passport-priority-ddp-zone-MA': 121.71,
                      'passport-priority-ddp-zone-MZ': 121.39,
                      'passport-priority-ddp-zone-NA': 121.39,
                      'passport-priority-ddp-zone-NP': 101.66,
                      'passport-priority-ddp-zone-NE': 121.39,
                      'passport-priority-ddp-zone-NG': 121.39,
                      'passport-priority-ddp-zone-PK': 101.66,
                      'passport-priority-ddp-zone-PH': 99.3,
                      'passport-priority-ddp-zone-RE': 121.39,
                      'passport-priority-ddp-zone-RW': 121.39,
                      'passport-priority-ddp-zone-SN': 121.39,
                      'passport-priority-ddp-zone-SC': 121.39,
                      'passport-priority-ddp-zone-ZA': 99.2,
                      'passport-priority-ddp-zone-LK': 101.66,
                      'passport-priority-ddp-zone-SZ': 121.39,
                      'passport-priority-ddp-zone-TW': 99.3,
                      'passport-priority-ddp-zone-TJ': 121.39,
                      'passport-priority-ddp-zone-TZ': 121.39,
                      'passport-priority-ddp-zone-TG': 121.39,
                      'passport-priority-ddp-zone-TN': 121.39,
                      'passport-priority-ddp-zone-TR': 99.2,
                      'passport-priority-ddp-zone-TM': 121.39,
                      'passport-priority-ddp-zone-UG': 121.39,
                      'passport-priority-ddp-zone-UA': 121.39,
                      'passport-priority-ddp-zone-VN': 99.43,
                      'passport-priority-ddp-zone-YE': 99.2,
                      'passport-priority-ddp-zone-ZM': 121.39,
                      'passport-priority-ddp-zone-ZW': 121.39,
                      'passport-priority-ddp-zone-MC': 39.53,
                      'passport-priority-ddp-zone-IM': 32.29,
                      'passport-priority-ddp-zone-SM': 39.53,
                    },
                    '7': {
                      'passport-priority-ddp-zone-CA': 24.21,
                      'passport-priority-ddp-zone-GB': 36.47,
                      'passport-priority-ddp-zone-AU': 52.88,
                      'passport-priority-ddp-zone-BE': 44.6,
                      'passport-priority-ddp-zone-DK': 44.6,
                      'passport-priority-ddp-zone-FR': 44.6,
                      'passport-priority-ddp-zone-DE': 44.6,
                      'passport-priority-ddp-zone-IT': 44.6,
                      'passport-priority-ddp-zone-NL': 44.6,
                      'passport-priority-ddp-zone-ES': 44.6,
                      'passport-priority-ddp-zone-MX': 45.55,
                      'passport-priority-ddp-zone-AM': 85.13,
                      'passport-priority-ddp-zone-AT': 52.02,
                      'passport-priority-ddp-zone-BG': 52.02,
                      'passport-priority-ddp-zone-HR': 52.02,
                      'passport-priority-ddp-zone-CY': 52.97,
                      'passport-priority-ddp-zone-CZ': 52.02,
                      'passport-priority-ddp-zone-EE': 52.02,
                      'passport-priority-ddp-zone-FI': 52.02,
                      'passport-priority-ddp-zone-GR': 52.02,
                      'passport-priority-ddp-zone-HU': 52.02,
                      'passport-priority-ddp-zone-IE': 52.02,
                      'passport-priority-ddp-zone-LV': 52.02,
                      'passport-priority-ddp-zone-LT': 52.02,
                      'passport-priority-ddp-zone-LU': 52.02,
                      'passport-priority-ddp-zone-MT': 52.97,
                      'passport-priority-ddp-zone-PL': 52.02,
                      'passport-priority-ddp-zone-PT': 52.02,
                      'passport-priority-ddp-zone-RO': 52.02,
                      'passport-priority-ddp-zone-SK': 52.02,
                      'passport-priority-ddp-zone-SI': 52.02,
                      'passport-priority-ddp-zone-SE': 52.02,
                      'passport-priority-ddp-zone-IL': 78.18,
                      'passport-priority-ddp-zone-OM': 85.04,
                      'passport-priority-ddp-zone-QA': 77.76,
                      'passport-priority-ddp-zone-SA': 77.81,
                      'passport-priority-ddp-zone-AE': 78.1,
                      'passport-priority-ddp-zone-CN': 92.16,
                      'passport-priority-ddp-zone-HK': 60.77,
                      'passport-priority-ddp-zone-IN': 80.41,
                      'passport-priority-ddp-zone-JP': 79.73,
                      'passport-priority-ddp-zone-KR': 68.2,
                      'passport-priority-ddp-zone-NZ': 55.56,
                      'passport-priority-ddp-zone-SG': 60.77,
                      'passport-priority-ddp-zone-TH': 59.79,
                      'passport-priority-ddp-zone-GG': 89.58,
                      'passport-priority-ddp-zone-JE': 89.58,
                      'passport-priority-ddp-zone-NO': 72.41,
                      'passport-priority-ddp-zone-CH': 72.82,
                      'passport-priority-ddp-zone-IS': 70.6,
                      'passport-priority-ddp-zone-AI': 68.03,
                      'passport-priority-ddp-zone-AG': 68.03,
                      'passport-priority-ddp-zone-AR': 92.16,
                      'passport-priority-ddp-zone-AW': 68.03,
                      'passport-priority-ddp-zone-BS': 68.03,
                      'passport-priority-ddp-zone-BB': 79.55,
                      'passport-priority-ddp-zone-BZ': 88.66,
                      'passport-priority-ddp-zone-BM': 68.27,
                      'passport-priority-ddp-zone-BO': 94.31,
                      'passport-priority-ddp-zone-BR': 60.42,
                      'passport-priority-ddp-zone-KY': 68.03,
                      'passport-priority-ddp-zone-CL': 62.32,
                      'passport-priority-ddp-zone-CO': 60.42,
                      'passport-priority-ddp-zone-CR': 92.64,
                      'passport-priority-ddp-zone-DM': 68.03,
                      'passport-priority-ddp-zone-DO': 68.64,
                      'passport-priority-ddp-zone-EC': 92.89,
                      'passport-priority-ddp-zone-SV': 88.66,
                      'passport-priority-ddp-zone-GP': 93.94,
                      'passport-priority-ddp-zone-GT': 88.76,
                      'passport-priority-ddp-zone-GY': 88.66,
                      'passport-priority-ddp-zone-HT': 68.03,
                      'passport-priority-ddp-zone-JM': 83.59,
                      'passport-priority-ddp-zone-MQ': 76.66,
                      'passport-priority-ddp-zone-AN': 68.03,
                      'passport-priority-ddp-zone-NI': 92.04,
                      'passport-priority-ddp-zone-PA': 88.94,
                      'passport-priority-ddp-zone-PY': 88.66,
                      'passport-priority-ddp-zone-PE': 91.0,
                      'passport-priority-ddp-zone-SR': 88.66,
                      'passport-priority-ddp-zone-TT': 72.35,
                      'passport-priority-ddp-zone-UY': 88.66,
                      'passport-priority-ddp-zone-AF': 134.34,
                      'passport-priority-ddp-zone-DZ': 134.34,
                      'passport-priority-ddp-zone-BH': 117.88,
                      'passport-priority-ddp-zone-BD': 112.36,
                      'passport-priority-ddp-zone-BT': 112.36,
                      'passport-priority-ddp-zone-BA': 134.34,
                      'passport-priority-ddp-zone-BW': 134.34,
                      'passport-priority-ddp-zone-BN': 117.88,
                      'passport-priority-ddp-zone-BF': 134.34,
                      'passport-priority-ddp-zone-BI': 134.34,
                      'passport-priority-ddp-zone-KH': 134.34,
                      'passport-priority-ddp-zone-CM': 134.34,
                      'passport-priority-ddp-zone-CV': 134.34,
                      'passport-priority-ddp-zone-TD': 134.34,
                      'passport-priority-ddp-zone-CG': 134.34,
                      'passport-priority-ddp-zone-CI': 134.34,
                      'passport-priority-ddp-zone-EG': 117.88,
                      'passport-priority-ddp-zone-ET': 134.34,
                      'passport-priority-ddp-zone-GA': 134.34,
                      'passport-priority-ddp-zone-GM': 134.34,
                      'passport-priority-ddp-zone-GH': 134.34,
                      'passport-priority-ddp-zone-GN': 134.34,
                      'passport-priority-ddp-zone-ID': 111.63,
                      'passport-priority-ddp-zone-JO': 117.88,
                      'passport-priority-ddp-zone-KE': 134.34,
                      'passport-priority-ddp-zone-KW': 118.23,
                      'passport-priority-ddp-zone-LB': 117.88,
                      'passport-priority-ddp-zone-LI': 112.01,
                      'passport-priority-ddp-zone-MO': 110.03,
                      'passport-priority-ddp-zone-MG': 134.34,
                      'passport-priority-ddp-zone-MW': 134.34,
                      'passport-priority-ddp-zone-MY': 110.05,
                      'passport-priority-ddp-zone-MV': 112.36,
                      'passport-priority-ddp-zone-ML': 134.34,
                      'passport-priority-ddp-zone-MR': 134.34,
                      'passport-priority-ddp-zone-MU': 134.34,
                      'passport-priority-ddp-zone-MD': 134.34,
                      'passport-priority-ddp-zone-MA': 134.68,
                      'passport-priority-ddp-zone-MZ': 134.34,
                      'passport-priority-ddp-zone-NA': 134.34,
                      'passport-priority-ddp-zone-NP': 112.36,
                      'passport-priority-ddp-zone-NE': 134.34,
                      'passport-priority-ddp-zone-NG': 134.34,
                      'passport-priority-ddp-zone-PK': 112.36,
                      'passport-priority-ddp-zone-PH': 110.22,
                      'passport-priority-ddp-zone-RE': 134.34,
                      'passport-priority-ddp-zone-RW': 134.34,
                      'passport-priority-ddp-zone-SN': 134.34,
                      'passport-priority-ddp-zone-SC': 134.34,
                      'passport-priority-ddp-zone-ZA': 116.56,
                      'passport-priority-ddp-zone-LK': 112.36,
                      'passport-priority-ddp-zone-SZ': 134.34,
                      'passport-priority-ddp-zone-TW': 110.22,
                      'passport-priority-ddp-zone-TJ': 134.34,
                      'passport-priority-ddp-zone-TZ': 134.34,
                      'passport-priority-ddp-zone-TG': 134.34,
                      'passport-priority-ddp-zone-TN': 134.34,
                      'passport-priority-ddp-zone-TR': 117.92,
                      'passport-priority-ddp-zone-TM': 134.34,
                      'passport-priority-ddp-zone-UG': 134.34,
                      'passport-priority-ddp-zone-UA': 134.34,
                      'passport-priority-ddp-zone-VN': 110.33,
                      'passport-priority-ddp-zone-YE': 117.88,
                      'passport-priority-ddp-zone-ZM': 134.34,
                      'passport-priority-ddp-zone-ZW': 134.34,
                      'passport-priority-ddp-zone-MC': 44.6,
                      'passport-priority-ddp-zone-IM': 36.47,
                      'passport-priority-ddp-zone-SM': 44.6,
                    },
                    '8': {
                      'passport-priority-ddp-zone-CA': 25.89,
                      'passport-priority-ddp-zone-GB': 40.68,
                      'passport-priority-ddp-zone-AU': 58.84,
                      'passport-priority-ddp-zone-BE': 48.08,
                      'passport-priority-ddp-zone-DK': 48.08,
                      'passport-priority-ddp-zone-FR': 48.08,
                      'passport-priority-ddp-zone-DE': 48.08,
                      'passport-priority-ddp-zone-IT': 48.08,
                      'passport-priority-ddp-zone-NL': 48.08,
                      'passport-priority-ddp-zone-ES': 48.08,
                      'passport-priority-ddp-zone-MX': 51.07,
                      'passport-priority-ddp-zone-AM': 95.12,
                      'passport-priority-ddp-zone-AT': 55.5,
                      'passport-priority-ddp-zone-BG': 55.5,
                      'passport-priority-ddp-zone-HR': 55.5,
                      'passport-priority-ddp-zone-CY': 56.73,
                      'passport-priority-ddp-zone-CZ': 55.5,
                      'passport-priority-ddp-zone-EE': 55.5,
                      'passport-priority-ddp-zone-FI': 55.5,
                      'passport-priority-ddp-zone-GR': 55.78,
                      'passport-priority-ddp-zone-HU': 55.5,
                      'passport-priority-ddp-zone-IE': 55.5,
                      'passport-priority-ddp-zone-LV': 55.5,
                      'passport-priority-ddp-zone-LT': 55.5,
                      'passport-priority-ddp-zone-LU': 55.5,
                      'passport-priority-ddp-zone-MT': 56.73,
                      'passport-priority-ddp-zone-PL': 55.5,
                      'passport-priority-ddp-zone-PT': 55.5,
                      'passport-priority-ddp-zone-RO': 55.5,
                      'passport-priority-ddp-zone-SK': 55.5,
                      'passport-priority-ddp-zone-SI': 55.5,
                      'passport-priority-ddp-zone-SE': 55.5,
                      'passport-priority-ddp-zone-IL': 84.44,
                      'passport-priority-ddp-zone-OM': 91.65,
                      'passport-priority-ddp-zone-QA': 84.0,
                      'passport-priority-ddp-zone-SA': 84.03,
                      'passport-priority-ddp-zone-AE': 84.34,
                      'passport-priority-ddp-zone-CN': 104.0,
                      'passport-priority-ddp-zone-HK': 69.28,
                      'passport-priority-ddp-zone-IN': 87.54,
                      'passport-priority-ddp-zone-JP': 89.32,
                      'passport-priority-ddp-zone-KR': 76.42,
                      'passport-priority-ddp-zone-NZ': 61.25,
                      'passport-priority-ddp-zone-SG': 69.28,
                      'passport-priority-ddp-zone-TH': 66.9,
                      'passport-priority-ddp-zone-GG': 91.54,
                      'passport-priority-ddp-zone-JE': 91.54,
                      'passport-priority-ddp-zone-NO': 78.38,
                      'passport-priority-ddp-zone-CH': 78.78,
                      'passport-priority-ddp-zone-IS': 76.43,
                      'passport-priority-ddp-zone-AI': 68.25,
                      'passport-priority-ddp-zone-AG': 68.25,
                      'passport-priority-ddp-zone-AR': 103.7,
                      'passport-priority-ddp-zone-AW': 68.25,
                      'passport-priority-ddp-zone-BS': 68.25,
                      'passport-priority-ddp-zone-BB': 79.81,
                      'passport-priority-ddp-zone-BZ': 100.2,
                      'passport-priority-ddp-zone-BM': 68.5,
                      'passport-priority-ddp-zone-BO': 105.86,
                      'passport-priority-ddp-zone-BR': 66.06,
                      'passport-priority-ddp-zone-KY': 68.25,
                      'passport-priority-ddp-zone-CL': 69.53,
                      'passport-priority-ddp-zone-CO': 66.06,
                      'passport-priority-ddp-zone-CR': 104.19,
                      'passport-priority-ddp-zone-DM': 68.25,
                      'passport-priority-ddp-zone-DO': 68.87,
                      'passport-priority-ddp-zone-EC': 104.43,
                      'passport-priority-ddp-zone-SV': 100.2,
                      'passport-priority-ddp-zone-GP': 94.25,
                      'passport-priority-ddp-zone-GT': 100.3,
                      'passport-priority-ddp-zone-GY': 100.2,
                      'passport-priority-ddp-zone-HT': 68.25,
                      'passport-priority-ddp-zone-JM': 83.87,
                      'passport-priority-ddp-zone-MQ': 76.91,
                      'passport-priority-ddp-zone-AN': 68.25,
                      'passport-priority-ddp-zone-NI': 103.59,
                      'passport-priority-ddp-zone-PA': 100.49,
                      'passport-priority-ddp-zone-PY': 100.2,
                      'passport-priority-ddp-zone-PE': 102.53,
                      'passport-priority-ddp-zone-SR': 100.2,
                      'passport-priority-ddp-zone-TT': 72.59,
                      'passport-priority-ddp-zone-UY': 100.2,
                      'passport-priority-ddp-zone-AF': 136.51,
                      'passport-priority-ddp-zone-DZ': 136.51,
                      'passport-priority-ddp-zone-BH': 122.56,
                      'passport-priority-ddp-zone-BD': 114.31,
                      'passport-priority-ddp-zone-BT': 114.31,
                      'passport-priority-ddp-zone-BA': 136.51,
                      'passport-priority-ddp-zone-BW': 136.51,
                      'passport-priority-ddp-zone-BN': 122.56,
                      'passport-priority-ddp-zone-BF': 136.51,
                      'passport-priority-ddp-zone-BI': 136.51,
                      'passport-priority-ddp-zone-KH': 136.51,
                      'passport-priority-ddp-zone-CM': 136.51,
                      'passport-priority-ddp-zone-CV': 136.51,
                      'passport-priority-ddp-zone-TD': 136.51,
                      'passport-priority-ddp-zone-CG': 136.51,
                      'passport-priority-ddp-zone-CI': 136.51,
                      'passport-priority-ddp-zone-EG': 122.56,
                      'passport-priority-ddp-zone-ET': 136.51,
                      'passport-priority-ddp-zone-GA': 136.51,
                      'passport-priority-ddp-zone-GM': 136.51,
                      'passport-priority-ddp-zone-GH': 136.51,
                      'passport-priority-ddp-zone-GN': 136.51,
                      'passport-priority-ddp-zone-ID': 111.77,
                      'passport-priority-ddp-zone-JO': 122.56,
                      'passport-priority-ddp-zone-KE': 136.51,
                      'passport-priority-ddp-zone-KW': 122.91,
                      'passport-priority-ddp-zone-LB': 122.56,
                      'passport-priority-ddp-zone-LI': 113.81,
                      'passport-priority-ddp-zone-MO': 111.77,
                      'passport-priority-ddp-zone-MG': 136.51,
                      'passport-priority-ddp-zone-MW': 136.51,
                      'passport-priority-ddp-zone-MY': 111.86,
                      'passport-priority-ddp-zone-MV': 114.31,
                      'passport-priority-ddp-zone-ML': 136.51,
                      'passport-priority-ddp-zone-MR': 136.51,
                      'passport-priority-ddp-zone-MU': 136.51,
                      'passport-priority-ddp-zone-MD': 136.51,
                      'passport-priority-ddp-zone-MA': 136.82,
                      'passport-priority-ddp-zone-MZ': 136.51,
                      'passport-priority-ddp-zone-NA': 136.51,
                      'passport-priority-ddp-zone-NP': 114.31,
                      'passport-priority-ddp-zone-NE': 136.51,
                      'passport-priority-ddp-zone-NG': 136.51,
                      'passport-priority-ddp-zone-PK': 114.31,
                      'passport-priority-ddp-zone-PH': 112.0,
                      'passport-priority-ddp-zone-RE': 136.51,
                      'passport-priority-ddp-zone-RW': 136.51,
                      'passport-priority-ddp-zone-SN': 136.51,
                      'passport-priority-ddp-zone-SC': 136.51,
                      'passport-priority-ddp-zone-ZA': 119.27,
                      'passport-priority-ddp-zone-LK': 114.31,
                      'passport-priority-ddp-zone-SZ': 136.51,
                      'passport-priority-ddp-zone-TW': 112.0,
                      'passport-priority-ddp-zone-TJ': 136.51,
                      'passport-priority-ddp-zone-TZ': 136.51,
                      'passport-priority-ddp-zone-TG': 136.51,
                      'passport-priority-ddp-zone-TN': 136.51,
                      'passport-priority-ddp-zone-TR': 122.58,
                      'passport-priority-ddp-zone-TM': 136.51,
                      'passport-priority-ddp-zone-UG': 136.51,
                      'passport-priority-ddp-zone-UA': 136.51,
                      'passport-priority-ddp-zone-VN': 112.14,
                      'passport-priority-ddp-zone-YE': 122.56,
                      'passport-priority-ddp-zone-ZM': 136.51,
                      'passport-priority-ddp-zone-ZW': 136.51,
                      'passport-priority-ddp-zone-MC': 48.08,
                      'passport-priority-ddp-zone-IM': 40.68,
                      'passport-priority-ddp-zone-SM': 48.08,
                    },
                    '9': {
                      'passport-priority-ddp-zone-CA': 27.59,
                      'passport-priority-ddp-zone-GB': 44.88,
                      'passport-priority-ddp-zone-AU': 64.83,
                      'passport-priority-ddp-zone-BE': 53.19,
                      'passport-priority-ddp-zone-DK': 53.19,
                      'passport-priority-ddp-zone-FR': 53.19,
                      'passport-priority-ddp-zone-DE': 53.19,
                      'passport-priority-ddp-zone-IT': 53.19,
                      'passport-priority-ddp-zone-NL': 53.19,
                      'passport-priority-ddp-zone-ES': 53.19,
                      'passport-priority-ddp-zone-MX': 56.61,
                      'passport-priority-ddp-zone-AM': 109.58,
                      'passport-priority-ddp-zone-AT': 61.66,
                      'passport-priority-ddp-zone-BG': 61.66,
                      'passport-priority-ddp-zone-HR': 61.66,
                      'passport-priority-ddp-zone-CY': 61.93,
                      'passport-priority-ddp-zone-CZ': 61.66,
                      'passport-priority-ddp-zone-EE': 61.66,
                      'passport-priority-ddp-zone-FI': 61.66,
                      'passport-priority-ddp-zone-GR': 61.66,
                      'passport-priority-ddp-zone-HU': 61.66,
                      'passport-priority-ddp-zone-IE': 61.66,
                      'passport-priority-ddp-zone-LV': 61.66,
                      'passport-priority-ddp-zone-LT': 61.66,
                      'passport-priority-ddp-zone-LU': 61.66,
                      'passport-priority-ddp-zone-MT': 61.93,
                      'passport-priority-ddp-zone-PL': 61.66,
                      'passport-priority-ddp-zone-PT': 61.66,
                      'passport-priority-ddp-zone-RO': 61.66,
                      'passport-priority-ddp-zone-SK': 61.66,
                      'passport-priority-ddp-zone-SI': 61.66,
                      'passport-priority-ddp-zone-SE': 61.66,
                      'passport-priority-ddp-zone-IL': 95.18,
                      'passport-priority-ddp-zone-OM': 102.45,
                      'passport-priority-ddp-zone-QA': 94.74,
                      'passport-priority-ddp-zone-SA': 94.77,
                      'passport-priority-ddp-zone-AE': 95.08,
                      'passport-priority-ddp-zone-CN': 115.84,
                      'passport-priority-ddp-zone-HK': 75.79,
                      'passport-priority-ddp-zone-IN': 94.87,
                      'passport-priority-ddp-zone-JP': 98.92,
                      'passport-priority-ddp-zone-KR': 84.63,
                      'passport-priority-ddp-zone-NZ': 66.95,
                      'passport-priority-ddp-zone-SG': 75.79,
                      'passport-priority-ddp-zone-TH': 74.02,
                      'passport-priority-ddp-zone-GG': 101.69,
                      'passport-priority-ddp-zone-JE': 101.69,
                      'passport-priority-ddp-zone-NO': 79.09,
                      'passport-priority-ddp-zone-CH': 79.48,
                      'passport-priority-ddp-zone-IS': 78.38,
                      'passport-priority-ddp-zone-AI': 68.48,
                      'passport-priority-ddp-zone-AG': 68.48,
                      'passport-priority-ddp-zone-AR': 115.98,
                      'passport-priority-ddp-zone-AW': 68.48,
                      'passport-priority-ddp-zone-BS': 68.48,
                      'passport-priority-ddp-zone-BB': 80.07,
                      'passport-priority-ddp-zone-BZ': 112.47,
                      'passport-priority-ddp-zone-BM': 68.73,
                      'passport-priority-ddp-zone-BO': 118.12,
                      'passport-priority-ddp-zone-BR': 67.85,
                      'passport-priority-ddp-zone-KY': 68.48,
                      'passport-priority-ddp-zone-CL': 71.56,
                      'passport-priority-ddp-zone-CO': 67.85,
                      'passport-priority-ddp-zone-CR': 116.47,
                      'passport-priority-ddp-zone-DM': 68.48,
                      'passport-priority-ddp-zone-DO': 69.1,
                      'passport-priority-ddp-zone-EC': 116.71,
                      'passport-priority-ddp-zone-SV': 112.47,
                      'passport-priority-ddp-zone-GP': 94.56,
                      'passport-priority-ddp-zone-GT': 112.57,
                      'passport-priority-ddp-zone-GY': 112.47,
                      'passport-priority-ddp-zone-HT': 68.48,
                      'passport-priority-ddp-zone-JM': 84.15,
                      'passport-priority-ddp-zone-MQ': 77.16,
                      'passport-priority-ddp-zone-AN': 68.48,
                      'passport-priority-ddp-zone-NI': 115.87,
                      'passport-priority-ddp-zone-PA': 112.77,
                      'passport-priority-ddp-zone-PY': 112.47,
                      'passport-priority-ddp-zone-PE': 114.81,
                      'passport-priority-ddp-zone-SR': 112.47,
                      'passport-priority-ddp-zone-TT': 72.83,
                      'passport-priority-ddp-zone-UY': 112.47,
                      'passport-priority-ddp-zone-AF': 156.05,
                      'passport-priority-ddp-zone-DZ': 156.05,
                      'passport-priority-ddp-zone-BH': 146.87,
                      'passport-priority-ddp-zone-BD': 131.04,
                      'passport-priority-ddp-zone-BT': 131.04,
                      'passport-priority-ddp-zone-BA': 156.05,
                      'passport-priority-ddp-zone-BW': 156.05,
                      'passport-priority-ddp-zone-BN': 146.87,
                      'passport-priority-ddp-zone-BF': 156.05,
                      'passport-priority-ddp-zone-BI': 156.05,
                      'passport-priority-ddp-zone-KH': 156.05,
                      'passport-priority-ddp-zone-CM': 156.05,
                      'passport-priority-ddp-zone-CV': 156.05,
                      'passport-priority-ddp-zone-TD': 156.05,
                      'passport-priority-ddp-zone-CG': 156.05,
                      'passport-priority-ddp-zone-CI': 156.05,
                      'passport-priority-ddp-zone-EG': 146.87,
                      'passport-priority-ddp-zone-ET': 156.05,
                      'passport-priority-ddp-zone-GA': 156.05,
                      'passport-priority-ddp-zone-GM': 156.05,
                      'passport-priority-ddp-zone-GH': 156.05,
                      'passport-priority-ddp-zone-GN': 156.05,
                      'passport-priority-ddp-zone-ID': 128.07,
                      'passport-priority-ddp-zone-JO': 146.87,
                      'passport-priority-ddp-zone-KE': 156.05,
                      'passport-priority-ddp-zone-KW': 147.23,
                      'passport-priority-ddp-zone-LB': 146.87,
                      'passport-priority-ddp-zone-LI': 128.4,
                      'passport-priority-ddp-zone-MO': 128.07,
                      'passport-priority-ddp-zone-MG': 156.05,
                      'passport-priority-ddp-zone-MW': 156.05,
                      'passport-priority-ddp-zone-MY': 128.2,
                      'passport-priority-ddp-zone-MV': 131.04,
                      'passport-priority-ddp-zone-ML': 156.05,
                      'passport-priority-ddp-zone-MR': 156.05,
                      'passport-priority-ddp-zone-MU': 156.05,
                      'passport-priority-ddp-zone-MD': 156.05,
                      'passport-priority-ddp-zone-MA': 156.36,
                      'passport-priority-ddp-zone-MZ': 156.05,
                      'passport-priority-ddp-zone-NA': 156.05,
                      'passport-priority-ddp-zone-NP': 131.04,
                      'passport-priority-ddp-zone-NE': 156.05,
                      'passport-priority-ddp-zone-NG': 156.05,
                      'passport-priority-ddp-zone-PK': 131.04,
                      'passport-priority-ddp-zone-PH': 128.38,
                      'passport-priority-ddp-zone-RE': 156.05,
                      'passport-priority-ddp-zone-RW': 156.05,
                      'passport-priority-ddp-zone-SN': 156.05,
                      'passport-priority-ddp-zone-SC': 156.05,
                      'passport-priority-ddp-zone-ZA': 128.07,
                      'passport-priority-ddp-zone-LK': 131.04,
                      'passport-priority-ddp-zone-SZ': 156.05,
                      'passport-priority-ddp-zone-TW': 128.38,
                      'passport-priority-ddp-zone-TJ': 156.05,
                      'passport-priority-ddp-zone-TZ': 156.05,
                      'passport-priority-ddp-zone-TG': 156.05,
                      'passport-priority-ddp-zone-TN': 156.05,
                      'passport-priority-ddp-zone-TR': 146.89,
                      'passport-priority-ddp-zone-TM': 156.05,
                      'passport-priority-ddp-zone-UG': 156.05,
                      'passport-priority-ddp-zone-UA': 156.05,
                      'passport-priority-ddp-zone-VN': 128.52,
                      'passport-priority-ddp-zone-YE': 146.87,
                      'passport-priority-ddp-zone-ZM': 156.05,
                      'passport-priority-ddp-zone-ZW': 156.05,
                      'passport-priority-ddp-zone-MC': 53.19,
                      'passport-priority-ddp-zone-IM': 44.88,
                      'passport-priority-ddp-zone-SM': 53.19,
                    },
                    '10': {
                      'passport-priority-ddp-zone-CA': 29.46,
                      'passport-priority-ddp-zone-GB': 49.08,
                      'passport-priority-ddp-zone-AU': 70.8,
                      'passport-priority-ddp-zone-BE': 56.67,
                      'passport-priority-ddp-zone-DK': 56.67,
                      'passport-priority-ddp-zone-FR': 56.67,
                      'passport-priority-ddp-zone-DE': 56.67,
                      'passport-priority-ddp-zone-IT': 56.67,
                      'passport-priority-ddp-zone-NL': 56.67,
                      'passport-priority-ddp-zone-ES': 56.67,
                      'passport-priority-ddp-zone-MX': 62.12,
                      'passport-priority-ddp-zone-AM': 112.8,
                      'passport-priority-ddp-zone-AT': 65.14,
                      'passport-priority-ddp-zone-BG': 65.14,
                      'passport-priority-ddp-zone-HR': 65.14,
                      'passport-priority-ddp-zone-CY': 65.7,
                      'passport-priority-ddp-zone-CZ': 65.14,
                      'passport-priority-ddp-zone-EE': 65.14,
                      'passport-priority-ddp-zone-FI': 65.14,
                      'passport-priority-ddp-zone-GR': 65.14,
                      'passport-priority-ddp-zone-HU': 65.14,
                      'passport-priority-ddp-zone-IE': 65.14,
                      'passport-priority-ddp-zone-LV': 65.14,
                      'passport-priority-ddp-zone-LT': 65.14,
                      'passport-priority-ddp-zone-LU': 65.14,
                      'passport-priority-ddp-zone-MT': 65.7,
                      'passport-priority-ddp-zone-PL': 65.14,
                      'passport-priority-ddp-zone-PT': 65.14,
                      'passport-priority-ddp-zone-RO': 65.14,
                      'passport-priority-ddp-zone-SK': 65.14,
                      'passport-priority-ddp-zone-SI': 65.14,
                      'passport-priority-ddp-zone-SE': 65.14,
                      'passport-priority-ddp-zone-IL': 98.11,
                      'passport-priority-ddp-zone-OM': 105.53,
                      'passport-priority-ddp-zone-QA': 97.67,
                      'passport-priority-ddp-zone-SA': 97.7,
                      'passport-priority-ddp-zone-AE': 98.03,
                      'passport-priority-ddp-zone-CN': 127.7,
                      'passport-priority-ddp-zone-HK': 77.7,
                      'passport-priority-ddp-zone-IN': 97.27,
                      'passport-priority-ddp-zone-JP': 108.51,
                      'passport-priority-ddp-zone-KR': 92.86,
                      'passport-priority-ddp-zone-NZ': 72.64,
                      'passport-priority-ddp-zone-SG': 77.7,
                      'passport-priority-ddp-zone-TH': 81.13,
                      'passport-priority-ddp-zone-GG': 104.37,
                      'passport-priority-ddp-zone-JE': 104.37,
                      'passport-priority-ddp-zone-NO': 85.21,
                      'passport-priority-ddp-zone-CH': 85.62,
                      'passport-priority-ddp-zone-IS': 83.97,
                      'passport-priority-ddp-zone-AI': 74.81,
                      'passport-priority-ddp-zone-AG': 74.81,
                      'passport-priority-ddp-zone-AR': 118.24,
                      'passport-priority-ddp-zone-AW': 74.81,
                      'passport-priority-ddp-zone-BS': 74.81,
                      'passport-priority-ddp-zone-BB': 86.19,
                      'passport-priority-ddp-zone-BZ': 114.74,
                      'passport-priority-ddp-zone-BM': 75.04,
                      'passport-priority-ddp-zone-BO': 120.4,
                      'passport-priority-ddp-zone-BR': 74.42,
                      'passport-priority-ddp-zone-KY': 74.81,
                      'passport-priority-ddp-zone-CL': 78.69,
                      'passport-priority-ddp-zone-CO': 74.42,
                      'passport-priority-ddp-zone-CR': 118.73,
                      'passport-priority-ddp-zone-DM': 74.81,
                      'passport-priority-ddp-zone-DO': 75.41,
                      'passport-priority-ddp-zone-EC': 118.99,
                      'passport-priority-ddp-zone-SV': 114.74,
                      'passport-priority-ddp-zone-GP': 100.41,
                      'passport-priority-ddp-zone-GT': 114.84,
                      'passport-priority-ddp-zone-GY': 114.74,
                      'passport-priority-ddp-zone-HT': 74.81,
                      'passport-priority-ddp-zone-JM': 90.17,
                      'passport-priority-ddp-zone-MQ': 83.34,
                      'passport-priority-ddp-zone-AN': 74.81,
                      'passport-priority-ddp-zone-NI': 118.13,
                      'passport-priority-ddp-zone-PA': 115.03,
                      'passport-priority-ddp-zone-PY': 114.74,
                      'passport-priority-ddp-zone-PE': 117.09,
                      'passport-priority-ddp-zone-SR': 114.74,
                      'passport-priority-ddp-zone-TT': 79.08,
                      'passport-priority-ddp-zone-UY': 114.74,
                      'passport-priority-ddp-zone-AF': 161.39,
                      'passport-priority-ddp-zone-DZ': 161.39,
                      'passport-priority-ddp-zone-BH': 149.85,
                      'passport-priority-ddp-zone-BD': 134.62,
                      'passport-priority-ddp-zone-BT': 134.62,
                      'passport-priority-ddp-zone-BA': 161.39,
                      'passport-priority-ddp-zone-BW': 161.39,
                      'passport-priority-ddp-zone-BN': 149.85,
                      'passport-priority-ddp-zone-BF': 161.39,
                      'passport-priority-ddp-zone-BI': 161.39,
                      'passport-priority-ddp-zone-KH': 161.39,
                      'passport-priority-ddp-zone-CM': 161.39,
                      'passport-priority-ddp-zone-CV': 161.39,
                      'passport-priority-ddp-zone-TD': 161.39,
                      'passport-priority-ddp-zone-CG': 161.39,
                      'passport-priority-ddp-zone-CI': 161.39,
                      'passport-priority-ddp-zone-EG': 149.85,
                      'passport-priority-ddp-zone-ET': 161.39,
                      'passport-priority-ddp-zone-GA': 161.39,
                      'passport-priority-ddp-zone-GM': 161.39,
                      'passport-priority-ddp-zone-GH': 161.39,
                      'passport-priority-ddp-zone-GN': 161.39,
                      'passport-priority-ddp-zone-ID': 131.27,
                      'passport-priority-ddp-zone-JO': 149.85,
                      'passport-priority-ddp-zone-KE': 161.39,
                      'passport-priority-ddp-zone-KW': 150.24,
                      'passport-priority-ddp-zone-LB': 149.85,
                      'passport-priority-ddp-zone-LI': 132.32,
                      'passport-priority-ddp-zone-MO': 131.27,
                      'passport-priority-ddp-zone-MG': 161.39,
                      'passport-priority-ddp-zone-MW': 161.39,
                      'passport-priority-ddp-zone-MY': 131.46,
                      'passport-priority-ddp-zone-MV': 134.62,
                      'passport-priority-ddp-zone-ML': 161.39,
                      'passport-priority-ddp-zone-MR': 161.39,
                      'passport-priority-ddp-zone-MU': 161.39,
                      'passport-priority-ddp-zone-MD': 161.39,
                      'passport-priority-ddp-zone-MA': 161.7,
                      'passport-priority-ddp-zone-MZ': 161.39,
                      'passport-priority-ddp-zone-NA': 161.39,
                      'passport-priority-ddp-zone-NP': 134.62,
                      'passport-priority-ddp-zone-NE': 161.39,
                      'passport-priority-ddp-zone-NG': 161.39,
                      'passport-priority-ddp-zone-PK': 134.62,
                      'passport-priority-ddp-zone-PH': 131.65,
                      'passport-priority-ddp-zone-RE': 161.39,
                      'passport-priority-ddp-zone-RW': 161.39,
                      'passport-priority-ddp-zone-SN': 161.39,
                      'passport-priority-ddp-zone-SC': 161.39,
                      'passport-priority-ddp-zone-ZA': 131.27,
                      'passport-priority-ddp-zone-LK': 134.62,
                      'passport-priority-ddp-zone-SZ': 161.39,
                      'passport-priority-ddp-zone-TW': 131.65,
                      'passport-priority-ddp-zone-TJ': 161.39,
                      'passport-priority-ddp-zone-TZ': 161.39,
                      'passport-priority-ddp-zone-TG': 161.39,
                      'passport-priority-ddp-zone-TN': 161.39,
                      'passport-priority-ddp-zone-TR': 149.89,
                      'passport-priority-ddp-zone-TM': 161.39,
                      'passport-priority-ddp-zone-UG': 161.39,
                      'passport-priority-ddp-zone-UA': 161.39,
                      'passport-priority-ddp-zone-VN': 131.76,
                      'passport-priority-ddp-zone-YE': 149.85,
                      'passport-priority-ddp-zone-ZM': 161.39,
                      'passport-priority-ddp-zone-ZW': 161.39,
                      'passport-priority-ddp-zone-MC': 56.67,
                      'passport-priority-ddp-zone-IM': 49.08,
                      'passport-priority-ddp-zone-SM': 56.67,
                    },
                    '11': {
                      'passport-priority-ddp-zone-CA': 31.09,
                      'passport-priority-ddp-zone-GB': 53.29,
                      'passport-priority-ddp-zone-AU': 76.78,
                      'passport-priority-ddp-zone-BE': 60.15,
                      'passport-priority-ddp-zone-DK': 60.15,
                      'passport-priority-ddp-zone-FR': 60.15,
                      'passport-priority-ddp-zone-DE': 60.15,
                      'passport-priority-ddp-zone-IT': 60.15,
                      'passport-priority-ddp-zone-NL': 60.15,
                      'passport-priority-ddp-zone-ES': 60.15,
                      'passport-priority-ddp-zone-MX': 67.66,
                      'passport-priority-ddp-zone-AM': 114.16,
                      'passport-priority-ddp-zone-AT': 68.62,
                      'passport-priority-ddp-zone-BG': 68.62,
                      'passport-priority-ddp-zone-HR': 68.62,
                      'passport-priority-ddp-zone-CY': 69.47,
                      'passport-priority-ddp-zone-CZ': 68.62,
                      'passport-priority-ddp-zone-EE': 68.62,
                      'passport-priority-ddp-zone-FI': 68.62,
                      'passport-priority-ddp-zone-GR': 68.62,
                      'passport-priority-ddp-zone-HU': 68.62,
                      'passport-priority-ddp-zone-IE': 68.62,
                      'passport-priority-ddp-zone-LV': 68.62,
                      'passport-priority-ddp-zone-LT': 68.62,
                      'passport-priority-ddp-zone-LU': 68.62,
                      'passport-priority-ddp-zone-MT': 69.47,
                      'passport-priority-ddp-zone-PL': 68.62,
                      'passport-priority-ddp-zone-PT': 68.62,
                      'passport-priority-ddp-zone-RO': 68.62,
                      'passport-priority-ddp-zone-SK': 68.62,
                      'passport-priority-ddp-zone-SI': 68.62,
                      'passport-priority-ddp-zone-SE': 68.62,
                      'passport-priority-ddp-zone-IL': 102.29,
                      'passport-priority-ddp-zone-OM': 110.0,
                      'passport-priority-ddp-zone-QA': 101.82,
                      'passport-priority-ddp-zone-SA': 101.86,
                      'passport-priority-ddp-zone-AE': 102.19,
                      'passport-priority-ddp-zone-CN': 129.0,
                      'passport-priority-ddp-zone-HK': 82.9,
                      'passport-priority-ddp-zone-IN': 101.14,
                      'passport-priority-ddp-zone-JP': 109.81,
                      'passport-priority-ddp-zone-KR': 94.16,
                      'passport-priority-ddp-zone-NZ': 78.33,
                      'passport-priority-ddp-zone-SG': 82.9,
                      'passport-priority-ddp-zone-TH': 82.43,
                      'passport-priority-ddp-zone-GG': 105.7,
                      'passport-priority-ddp-zone-JE': 105.7,
                      'passport-priority-ddp-zone-NO': 85.49,
                      'passport-priority-ddp-zone-CH': 85.9,
                      'passport-priority-ddp-zone-IS': 84.72,
                      'passport-priority-ddp-zone-AI': 86.52,
                      'passport-priority-ddp-zone-AG': 86.52,
                      'passport-priority-ddp-zone-AR': 123.9,
                      'passport-priority-ddp-zone-AW': 86.52,
                      'passport-priority-ddp-zone-BS': 86.52,
                      'passport-priority-ddp-zone-BB': 98.73,
                      'passport-priority-ddp-zone-BZ': 120.4,
                      'passport-priority-ddp-zone-BM': 86.77,
                      'passport-priority-ddp-zone-BO': 126.06,
                      'passport-priority-ddp-zone-BR': 80.1,
                      'passport-priority-ddp-zone-KY': 86.52,
                      'passport-priority-ddp-zone-CL': 85.81,
                      'passport-priority-ddp-zone-CO': 80.1,
                      'passport-priority-ddp-zone-CR': 124.39,
                      'passport-priority-ddp-zone-DM': 86.52,
                      'passport-priority-ddp-zone-DO': 87.17,
                      'passport-priority-ddp-zone-EC': 124.64,
                      'passport-priority-ddp-zone-SV': 120.4,
                      'passport-priority-ddp-zone-GP': 113.98,
                      'passport-priority-ddp-zone-GT': 120.5,
                      'passport-priority-ddp-zone-GY': 120.4,
                      'passport-priority-ddp-zone-HT': 86.52,
                      'passport-priority-ddp-zone-JM': 102.99,
                      'passport-priority-ddp-zone-MQ': 95.67,
                      'passport-priority-ddp-zone-AN': 86.52,
                      'passport-priority-ddp-zone-NI': 123.79,
                      'passport-priority-ddp-zone-PA': 120.69,
                      'passport-priority-ddp-zone-PY': 120.4,
                      'passport-priority-ddp-zone-PE': 122.74,
                      'passport-priority-ddp-zone-SR': 120.4,
                      'passport-priority-ddp-zone-TT': 91.1,
                      'passport-priority-ddp-zone-UY': 120.4,
                      'passport-priority-ddp-zone-AF': 161.92,
                      'passport-priority-ddp-zone-DZ': 161.92,
                      'passport-priority-ddp-zone-BH': 150.34,
                      'passport-priority-ddp-zone-BD': 137.76,
                      'passport-priority-ddp-zone-BT': 137.76,
                      'passport-priority-ddp-zone-BA': 161.92,
                      'passport-priority-ddp-zone-BW': 161.92,
                      'passport-priority-ddp-zone-BN': 150.34,
                      'passport-priority-ddp-zone-BF': 161.92,
                      'passport-priority-ddp-zone-BI': 161.92,
                      'passport-priority-ddp-zone-KH': 161.92,
                      'passport-priority-ddp-zone-CM': 161.92,
                      'passport-priority-ddp-zone-CV': 161.92,
                      'passport-priority-ddp-zone-TD': 161.92,
                      'passport-priority-ddp-zone-CG': 161.92,
                      'passport-priority-ddp-zone-CI': 161.92,
                      'passport-priority-ddp-zone-EG': 150.34,
                      'passport-priority-ddp-zone-ET': 161.92,
                      'passport-priority-ddp-zone-GA': 161.92,
                      'passport-priority-ddp-zone-GM': 161.92,
                      'passport-priority-ddp-zone-GH': 161.92,
                      'passport-priority-ddp-zone-GN': 161.92,
                      'passport-priority-ddp-zone-ID': 131.77,
                      'passport-priority-ddp-zone-JO': 150.34,
                      'passport-priority-ddp-zone-KE': 161.92,
                      'passport-priority-ddp-zone-KW': 150.74,
                      'passport-priority-ddp-zone-LB': 150.34,
                      'passport-priority-ddp-zone-LI': 132.76,
                      'passport-priority-ddp-zone-MO': 131.77,
                      'passport-priority-ddp-zone-MG': 161.92,
                      'passport-priority-ddp-zone-MW': 161.92,
                      'passport-priority-ddp-zone-MY': 131.95,
                      'passport-priority-ddp-zone-MV': 137.76,
                      'passport-priority-ddp-zone-ML': 161.92,
                      'passport-priority-ddp-zone-MR': 161.92,
                      'passport-priority-ddp-zone-MU': 161.92,
                      'passport-priority-ddp-zone-MD': 161.92,
                      'passport-priority-ddp-zone-MA': 162.23,
                      'passport-priority-ddp-zone-MZ': 161.92,
                      'passport-priority-ddp-zone-NA': 161.92,
                      'passport-priority-ddp-zone-NP': 137.76,
                      'passport-priority-ddp-zone-NE': 161.92,
                      'passport-priority-ddp-zone-NG': 161.92,
                      'passport-priority-ddp-zone-PK': 137.76,
                      'passport-priority-ddp-zone-PH': 132.11,
                      'passport-priority-ddp-zone-RE': 161.92,
                      'passport-priority-ddp-zone-RW': 161.92,
                      'passport-priority-ddp-zone-SN': 161.92,
                      'passport-priority-ddp-zone-SC': 161.92,
                      'passport-priority-ddp-zone-ZA': 131.92,
                      'passport-priority-ddp-zone-LK': 137.76,
                      'passport-priority-ddp-zone-SZ': 161.92,
                      'passport-priority-ddp-zone-TW': 132.11,
                      'passport-priority-ddp-zone-TJ': 161.92,
                      'passport-priority-ddp-zone-TZ': 161.92,
                      'passport-priority-ddp-zone-TG': 161.92,
                      'passport-priority-ddp-zone-TN': 161.92,
                      'passport-priority-ddp-zone-TR': 150.38,
                      'passport-priority-ddp-zone-TM': 161.92,
                      'passport-priority-ddp-zone-UG': 161.92,
                      'passport-priority-ddp-zone-UA': 161.92,
                      'passport-priority-ddp-zone-VN': 132.23,
                      'passport-priority-ddp-zone-YE': 150.34,
                      'passport-priority-ddp-zone-ZM': 161.92,
                      'passport-priority-ddp-zone-ZW': 161.92,
                      'passport-priority-ddp-zone-MC': 60.15,
                      'passport-priority-ddp-zone-IM': 53.29,
                      'passport-priority-ddp-zone-SM': 60.15,
                    },
                    '12': {
                      'passport-priority-ddp-zone-CA': 32.9,
                      'passport-priority-ddp-zone-GB': 57.49,
                      'passport-priority-ddp-zone-AU': 82.75,
                      'passport-priority-ddp-zone-BE': 66.09,
                      'passport-priority-ddp-zone-DK': 66.09,
                      'passport-priority-ddp-zone-FR': 66.09,
                      'passport-priority-ddp-zone-DE': 66.09,
                      'passport-priority-ddp-zone-IT': 66.09,
                      'passport-priority-ddp-zone-NL': 66.09,
                      'passport-priority-ddp-zone-ES': 66.09,
                      'passport-priority-ddp-zone-MX': 73.19,
                      'passport-priority-ddp-zone-AM': 116.76,
                      'passport-priority-ddp-zone-AT': 74.19,
                      'passport-priority-ddp-zone-BG': 74.19,
                      'passport-priority-ddp-zone-HR': 74.19,
                      'passport-priority-ddp-zone-CY': 74.67,
                      'passport-priority-ddp-zone-CZ': 74.19,
                      'passport-priority-ddp-zone-EE': 74.19,
                      'passport-priority-ddp-zone-FI': 74.19,
                      'passport-priority-ddp-zone-GR': 74.19,
                      'passport-priority-ddp-zone-HU': 74.19,
                      'passport-priority-ddp-zone-IE': 74.19,
                      'passport-priority-ddp-zone-LV': 74.19,
                      'passport-priority-ddp-zone-LT': 74.19,
                      'passport-priority-ddp-zone-LU': 74.19,
                      'passport-priority-ddp-zone-MT': 74.67,
                      'passport-priority-ddp-zone-PL': 74.19,
                      'passport-priority-ddp-zone-PT': 74.19,
                      'passport-priority-ddp-zone-RO': 74.19,
                      'passport-priority-ddp-zone-SK': 74.19,
                      'passport-priority-ddp-zone-SI': 74.19,
                      'passport-priority-ddp-zone-SE': 74.19,
                      'passport-priority-ddp-zone-IL': 105.52,
                      'passport-priority-ddp-zone-OM': 113.34,
                      'passport-priority-ddp-zone-QA': 105.04,
                      'passport-priority-ddp-zone-SA': 105.08,
                      'passport-priority-ddp-zone-AE': 105.41,
                      'passport-priority-ddp-zone-CN': 138.42,
                      'passport-priority-ddp-zone-HK': 84.01,
                      'passport-priority-ddp-zone-IN': 104.07,
                      'passport-priority-ddp-zone-JP': 119.4,
                      'passport-priority-ddp-zone-KR': 101.31,
                      'passport-priority-ddp-zone-NZ': 84.01,
                      'passport-priority-ddp-zone-SG': 84.01,
                      'passport-priority-ddp-zone-TH': 88.54,
                      'passport-priority-ddp-zone-GG': 107.42,
                      'passport-priority-ddp-zone-JE': 107.42,
                      'passport-priority-ddp-zone-NO': 85.77,
                      'passport-priority-ddp-zone-CH': 86.18,
                      'passport-priority-ddp-zone-IS': 85.18,
                      'passport-priority-ddp-zone-AI': 93.25,
                      'passport-priority-ddp-zone-AG': 93.25,
                      'passport-priority-ddp-zone-AR': 126.21,
                      'passport-priority-ddp-zone-AW': 93.25,
                      'passport-priority-ddp-zone-BS': 93.25,
                      'passport-priority-ddp-zone-BB': 106.29,
                      'passport-priority-ddp-zone-BZ': 122.7,
                      'passport-priority-ddp-zone-BM': 93.52,
                      'passport-priority-ddp-zone-BO': 128.36,
                      'passport-priority-ddp-zone-BR': 87.55,
                      'passport-priority-ddp-zone-KY': 93.25,
                      'passport-priority-ddp-zone-CL': 92.94,
                      'passport-priority-ddp-zone-CO': 87.55,
                      'passport-priority-ddp-zone-CR': 126.7,
                      'passport-priority-ddp-zone-DM': 93.25,
                      'passport-priority-ddp-zone-DO': 93.94,
                      'passport-priority-ddp-zone-EC': 126.94,
                      'passport-priority-ddp-zone-SV': 122.7,
                      'passport-priority-ddp-zone-GP': 122.56,
                      'passport-priority-ddp-zone-GT': 122.8,
                      'passport-priority-ddp-zone-GY': 122.7,
                      'passport-priority-ddp-zone-HT': 93.25,
                      'passport-priority-ddp-zone-JM': 110.83,
                      'passport-priority-ddp-zone-MQ': 103.02,
                      'passport-priority-ddp-zone-AN': 93.25,
                      'passport-priority-ddp-zone-NI': 126.1,
                      'passport-priority-ddp-zone-PA': 123.0,
                      'passport-priority-ddp-zone-PY': 122.7,
                      'passport-priority-ddp-zone-PE': 125.04,
                      'passport-priority-ddp-zone-SR': 122.7,
                      'passport-priority-ddp-zone-TT': 98.15,
                      'passport-priority-ddp-zone-UY': 122.7,
                      'passport-priority-ddp-zone-AF': 162.45,
                      'passport-priority-ddp-zone-DZ': 162.45,
                      'passport-priority-ddp-zone-BH': 150.84,
                      'passport-priority-ddp-zone-BD': 138.21,
                      'passport-priority-ddp-zone-BT': 138.21,
                      'passport-priority-ddp-zone-BA': 162.45,
                      'passport-priority-ddp-zone-BW': 162.45,
                      'passport-priority-ddp-zone-BN': 150.84,
                      'passport-priority-ddp-zone-BF': 162.45,
                      'passport-priority-ddp-zone-BI': 162.45,
                      'passport-priority-ddp-zone-KH': 162.45,
                      'passport-priority-ddp-zone-CM': 162.45,
                      'passport-priority-ddp-zone-CV': 162.45,
                      'passport-priority-ddp-zone-TD': 162.45,
                      'passport-priority-ddp-zone-CG': 162.45,
                      'passport-priority-ddp-zone-CI': 162.45,
                      'passport-priority-ddp-zone-EG': 150.84,
                      'passport-priority-ddp-zone-ET': 162.45,
                      'passport-priority-ddp-zone-GA': 162.45,
                      'passport-priority-ddp-zone-GM': 162.45,
                      'passport-priority-ddp-zone-GH': 162.45,
                      'passport-priority-ddp-zone-GN': 162.45,
                      'passport-priority-ddp-zone-ID': 133.21,
                      'passport-priority-ddp-zone-JO': 150.84,
                      'passport-priority-ddp-zone-KE': 162.45,
                      'passport-priority-ddp-zone-KW': 151.24,
                      'passport-priority-ddp-zone-LB': 150.84,
                      'passport-priority-ddp-zone-LI': 133.21,
                      'passport-priority-ddp-zone-MO': 133.21,
                      'passport-priority-ddp-zone-MG': 162.45,
                      'passport-priority-ddp-zone-MW': 162.45,
                      'passport-priority-ddp-zone-MY': 133.41,
                      'passport-priority-ddp-zone-MV': 138.21,
                      'passport-priority-ddp-zone-ML': 162.45,
                      'passport-priority-ddp-zone-MR': 162.45,
                      'passport-priority-ddp-zone-MU': 162.45,
                      'passport-priority-ddp-zone-MD': 162.45,
                      'passport-priority-ddp-zone-MA': 162.77,
                      'passport-priority-ddp-zone-MZ': 162.45,
                      'passport-priority-ddp-zone-NA': 162.45,
                      'passport-priority-ddp-zone-NP': 138.21,
                      'passport-priority-ddp-zone-NE': 162.45,
                      'passport-priority-ddp-zone-NG': 162.45,
                      'passport-priority-ddp-zone-PK': 138.21,
                      'passport-priority-ddp-zone-PH': 133.57,
                      'passport-priority-ddp-zone-RE': 162.45,
                      'passport-priority-ddp-zone-RW': 162.45,
                      'passport-priority-ddp-zone-SN': 162.45,
                      'passport-priority-ddp-zone-SC': 162.45,
                      'passport-priority-ddp-zone-ZA': 133.3,
                      'passport-priority-ddp-zone-LK': 138.21,
                      'passport-priority-ddp-zone-SZ': 162.45,
                      'passport-priority-ddp-zone-TW': 133.57,
                      'passport-priority-ddp-zone-TJ': 162.45,
                      'passport-priority-ddp-zone-TZ': 162.45,
                      'passport-priority-ddp-zone-TG': 162.45,
                      'passport-priority-ddp-zone-TN': 162.45,
                      'passport-priority-ddp-zone-TR': 150.88,
                      'passport-priority-ddp-zone-TM': 162.45,
                      'passport-priority-ddp-zone-UG': 162.45,
                      'passport-priority-ddp-zone-UA': 162.45,
                      'passport-priority-ddp-zone-VN': 133.7,
                      'passport-priority-ddp-zone-YE': 150.84,
                      'passport-priority-ddp-zone-ZM': 162.45,
                      'passport-priority-ddp-zone-ZW': 162.45,
                      'passport-priority-ddp-zone-MC': 66.09,
                      'passport-priority-ddp-zone-IM': 57.49,
                      'passport-priority-ddp-zone-SM': 66.09,
                    },
                    '13': {
                      'passport-priority-ddp-zone-CA': 34.9,
                      'passport-priority-ddp-zone-GB': 61.69,
                      'passport-priority-ddp-zone-AU': 88.73,
                      'passport-priority-ddp-zone-BE': 69.57,
                      'passport-priority-ddp-zone-DK': 69.57,
                      'passport-priority-ddp-zone-FR': 69.57,
                      'passport-priority-ddp-zone-DE': 69.57,
                      'passport-priority-ddp-zone-IT': 69.57,
                      'passport-priority-ddp-zone-NL': 69.57,
                      'passport-priority-ddp-zone-ES': 69.57,
                      'passport-priority-ddp-zone-MX': 78.71,
                      'passport-priority-ddp-zone-AM': 125.63,
                      'passport-priority-ddp-zone-AT': 77.67,
                      'passport-priority-ddp-zone-BG': 77.67,
                      'passport-priority-ddp-zone-HR': 77.67,
                      'passport-priority-ddp-zone-CY': 78.43,
                      'passport-priority-ddp-zone-CZ': 77.67,
                      'passport-priority-ddp-zone-EE': 77.67,
                      'passport-priority-ddp-zone-FI': 77.67,
                      'passport-priority-ddp-zone-GR': 77.67,
                      'passport-priority-ddp-zone-HU': 77.67,
                      'passport-priority-ddp-zone-IE': 77.67,
                      'passport-priority-ddp-zone-LV': 77.67,
                      'passport-priority-ddp-zone-LT': 77.67,
                      'passport-priority-ddp-zone-LU': 77.67,
                      'passport-priority-ddp-zone-MT': 78.43,
                      'passport-priority-ddp-zone-PL': 77.67,
                      'passport-priority-ddp-zone-PT': 77.67,
                      'passport-priority-ddp-zone-RO': 77.67,
                      'passport-priority-ddp-zone-SK': 77.67,
                      'passport-priority-ddp-zone-SI': 77.67,
                      'passport-priority-ddp-zone-SE': 77.67,
                      'passport-priority-ddp-zone-IL': 105.87,
                      'passport-priority-ddp-zone-OM': 113.71,
                      'passport-priority-ddp-zone-QA': 105.39,
                      'passport-priority-ddp-zone-SA': 105.43,
                      'passport-priority-ddp-zone-AE': 105.76,
                      'passport-priority-ddp-zone-CN': 147.86,
                      'passport-priority-ddp-zone-HK': 92.85,
                      'passport-priority-ddp-zone-IN': 111.41,
                      'passport-priority-ddp-zone-JP': 129.0,
                      'passport-priority-ddp-zone-KR': 108.46,
                      'passport-priority-ddp-zone-NZ': 89.7,
                      'passport-priority-ddp-zone-SG': 92.85,
                      'passport-priority-ddp-zone-TH': 94.64,
                      'passport-priority-ddp-zone-GG': 119.82,
                      'passport-priority-ddp-zone-JE': 119.82,
                      'passport-priority-ddp-zone-NO': 97.8,
                      'passport-priority-ddp-zone-CH': 98.21,
                      'passport-priority-ddp-zone-IS': 90.22,
                      'passport-priority-ddp-zone-AI': 98.88,
                      'passport-priority-ddp-zone-AG': 98.88,
                      'passport-priority-ddp-zone-AR': 134.96,
                      'passport-priority-ddp-zone-AW': 98.88,
                      'passport-priority-ddp-zone-BS': 98.88,
                      'passport-priority-ddp-zone-BB': 112.31,
                      'passport-priority-ddp-zone-BZ': 131.46,
                      'passport-priority-ddp-zone-BM': 99.15,
                      'passport-priority-ddp-zone-BO': 137.11,
                      'passport-priority-ddp-zone-BR': 93.13,
                      'passport-priority-ddp-zone-KY': 98.88,
                      'passport-priority-ddp-zone-CL': 100.06,
                      'passport-priority-ddp-zone-CO': 93.13,
                      'passport-priority-ddp-zone-CR': 135.44,
                      'passport-priority-ddp-zone-DM': 98.88,
                      'passport-priority-ddp-zone-DO': 99.59,
                      'passport-priority-ddp-zone-EC': 135.7,
                      'passport-priority-ddp-zone-SV': 131.46,
                      'passport-priority-ddp-zone-GP': 129.09,
                      'passport-priority-ddp-zone-GT': 131.56,
                      'passport-priority-ddp-zone-GY': 131.46,
                      'passport-priority-ddp-zone-HT': 98.88,
                      'passport-priority-ddp-zone-JM': 117.0,
                      'passport-priority-ddp-zone-MQ': 108.95,
                      'passport-priority-ddp-zone-AN': 98.88,
                      'passport-priority-ddp-zone-NI': 134.84,
                      'passport-priority-ddp-zone-PA': 131.74,
                      'passport-priority-ddp-zone-PY': 131.46,
                      'passport-priority-ddp-zone-PE': 133.8,
                      'passport-priority-ddp-zone-SR': 131.46,
                      'passport-priority-ddp-zone-TT': 103.92,
                      'passport-priority-ddp-zone-UY': 131.46,
                      'passport-priority-ddp-zone-AF': 162.99,
                      'passport-priority-ddp-zone-DZ': 162.99,
                      'passport-priority-ddp-zone-BH': 151.34,
                      'passport-priority-ddp-zone-BD': 145.12,
                      'passport-priority-ddp-zone-BT': 145.12,
                      'passport-priority-ddp-zone-BA': 162.99,
                      'passport-priority-ddp-zone-BW': 162.99,
                      'passport-priority-ddp-zone-BN': 151.34,
                      'passport-priority-ddp-zone-BF': 162.99,
                      'passport-priority-ddp-zone-BI': 162.99,
                      'passport-priority-ddp-zone-KH': 162.99,
                      'passport-priority-ddp-zone-CM': 162.99,
                      'passport-priority-ddp-zone-CV': 162.99,
                      'passport-priority-ddp-zone-TD': 162.99,
                      'passport-priority-ddp-zone-CG': 162.99,
                      'passport-priority-ddp-zone-CI': 162.99,
                      'passport-priority-ddp-zone-EG': 151.34,
                      'passport-priority-ddp-zone-ET': 162.99,
                      'passport-priority-ddp-zone-GA': 162.99,
                      'passport-priority-ddp-zone-GM': 162.99,
                      'passport-priority-ddp-zone-GH': 162.99,
                      'passport-priority-ddp-zone-GN': 162.99,
                      'passport-priority-ddp-zone-ID': 145.38,
                      'passport-priority-ddp-zone-JO': 151.34,
                      'passport-priority-ddp-zone-KE': 162.99,
                      'passport-priority-ddp-zone-KW': 151.74,
                      'passport-priority-ddp-zone-LB': 151.34,
                      'passport-priority-ddp-zone-LI': 152.07,
                      'passport-priority-ddp-zone-MO': 144.35,
                      'passport-priority-ddp-zone-MG': 162.99,
                      'passport-priority-ddp-zone-MW': 162.99,
                      'passport-priority-ddp-zone-MY': 141.35,
                      'passport-priority-ddp-zone-MV': 145.12,
                      'passport-priority-ddp-zone-ML': 162.99,
                      'passport-priority-ddp-zone-MR': 162.99,
                      'passport-priority-ddp-zone-MU': 162.99,
                      'passport-priority-ddp-zone-MD': 162.99,
                      'passport-priority-ddp-zone-MA': 163.31,
                      'passport-priority-ddp-zone-MZ': 162.99,
                      'passport-priority-ddp-zone-NA': 162.99,
                      'passport-priority-ddp-zone-NP': 145.12,
                      'passport-priority-ddp-zone-NE': 162.99,
                      'passport-priority-ddp-zone-NG': 162.99,
                      'passport-priority-ddp-zone-PK': 145.12,
                      'passport-priority-ddp-zone-PH': 141.5,
                      'passport-priority-ddp-zone-RE': 162.99,
                      'passport-priority-ddp-zone-RW': 162.99,
                      'passport-priority-ddp-zone-SN': 162.99,
                      'passport-priority-ddp-zone-SC': 162.99,
                      'passport-priority-ddp-zone-ZA': 148.62,
                      'passport-priority-ddp-zone-LK': 145.12,
                      'passport-priority-ddp-zone-SZ': 162.99,
                      'passport-priority-ddp-zone-TW': 141.5,
                      'passport-priority-ddp-zone-TJ': 162.99,
                      'passport-priority-ddp-zone-TZ': 162.99,
                      'passport-priority-ddp-zone-TG': 162.99,
                      'passport-priority-ddp-zone-TN': 162.99,
                      'passport-priority-ddp-zone-TR': 151.38,
                      'passport-priority-ddp-zone-TM': 162.99,
                      'passport-priority-ddp-zone-UG': 162.99,
                      'passport-priority-ddp-zone-UA': 162.99,
                      'passport-priority-ddp-zone-VN': 141.63,
                      'passport-priority-ddp-zone-YE': 151.34,
                      'passport-priority-ddp-zone-ZM': 162.99,
                      'passport-priority-ddp-zone-ZW': 162.99,
                      'passport-priority-ddp-zone-MC': 69.57,
                      'passport-priority-ddp-zone-IM': 61.69,
                      'passport-priority-ddp-zone-SM': 69.57,
                    },
                    '14': {
                      'passport-priority-ddp-zone-CA': 36.89,
                      'passport-priority-ddp-zone-GB': 65.9,
                      'passport-priority-ddp-zone-AU': 94.7,
                      'passport-priority-ddp-zone-BE': 73.97,
                      'passport-priority-ddp-zone-DK': 73.97,
                      'passport-priority-ddp-zone-FR': 73.97,
                      'passport-priority-ddp-zone-DE': 73.97,
                      'passport-priority-ddp-zone-IT': 73.97,
                      'passport-priority-ddp-zone-NL': 73.97,
                      'passport-priority-ddp-zone-ES': 73.97,
                      'passport-priority-ddp-zone-MX': 84.24,
                      'passport-priority-ddp-zone-AM': 141.76,
                      'passport-priority-ddp-zone-AT': 81.86,
                      'passport-priority-ddp-zone-BG': 81.86,
                      'passport-priority-ddp-zone-HR': 81.86,
                      'passport-priority-ddp-zone-CY': 83.63,
                      'passport-priority-ddp-zone-CZ': 81.86,
                      'passport-priority-ddp-zone-EE': 81.86,
                      'passport-priority-ddp-zone-FI': 81.86,
                      'passport-priority-ddp-zone-GR': 82.01,
                      'passport-priority-ddp-zone-HU': 81.86,
                      'passport-priority-ddp-zone-IE': 81.86,
                      'passport-priority-ddp-zone-LV': 81.86,
                      'passport-priority-ddp-zone-LT': 81.86,
                      'passport-priority-ddp-zone-LU': 81.86,
                      'passport-priority-ddp-zone-MT': 83.63,
                      'passport-priority-ddp-zone-PL': 81.86,
                      'passport-priority-ddp-zone-PT': 81.86,
                      'passport-priority-ddp-zone-RO': 81.86,
                      'passport-priority-ddp-zone-SK': 81.86,
                      'passport-priority-ddp-zone-SI': 81.86,
                      'passport-priority-ddp-zone-SE': 81.86,
                      'passport-priority-ddp-zone-IL': 115.13,
                      'passport-priority-ddp-zone-OM': 122.25,
                      'passport-priority-ddp-zone-QA': 114.7,
                      'passport-priority-ddp-zone-SA': 114.72,
                      'passport-priority-ddp-zone-AE': 115.03,
                      'passport-priority-ddp-zone-CN': 157.28,
                      'passport-priority-ddp-zone-HK': 105.88,
                      'passport-priority-ddp-zone-IN': 121.91,
                      'passport-priority-ddp-zone-JP': 138.59,
                      'passport-priority-ddp-zone-KR': 115.61,
                      'passport-priority-ddp-zone-NZ': 95.39,
                      'passport-priority-ddp-zone-SG': 105.88,
                      'passport-priority-ddp-zone-TH': 100.74,
                      'passport-priority-ddp-zone-GG': 137.23,
                      'passport-priority-ddp-zone-JE': 137.23,
                      'passport-priority-ddp-zone-NO': 108.47,
                      'passport-priority-ddp-zone-CH': 108.89,
                      'passport-priority-ddp-zone-IS': 98.46,
                      'passport-priority-ddp-zone-AI': 106.65,
                      'passport-priority-ddp-zone-AG': 106.65,
                      'passport-priority-ddp-zone-AR': 154.94,
                      'passport-priority-ddp-zone-AW': 106.65,
                      'passport-priority-ddp-zone-BS': 106.65,
                      'passport-priority-ddp-zone-BB': 120.73,
                      'passport-priority-ddp-zone-BZ': 151.44,
                      'passport-priority-ddp-zone-BM': 106.94,
                      'passport-priority-ddp-zone-BO': 157.1,
                      'passport-priority-ddp-zone-BR': 100.31,
                      'passport-priority-ddp-zone-KY': 106.65,
                      'passport-priority-ddp-zone-CL': 107.27,
                      'passport-priority-ddp-zone-CO': 100.31,
                      'passport-priority-ddp-zone-CR': 155.43,
                      'passport-priority-ddp-zone-DM': 106.65,
                      'passport-priority-ddp-zone-DO': 107.39,
                      'passport-priority-ddp-zone-EC': 155.69,
                      'passport-priority-ddp-zone-SV': 151.44,
                      'passport-priority-ddp-zone-GP': 138.3,
                      'passport-priority-ddp-zone-GT': 151.54,
                      'passport-priority-ddp-zone-GY': 151.44,
                      'passport-priority-ddp-zone-HT': 106.65,
                      'passport-priority-ddp-zone-JM': 125.63,
                      'passport-priority-ddp-zone-MQ': 117.2,
                      'passport-priority-ddp-zone-AN': 106.65,
                      'passport-priority-ddp-zone-NI': 154.83,
                      'passport-priority-ddp-zone-PA': 151.73,
                      'passport-priority-ddp-zone-PY': 151.44,
                      'passport-priority-ddp-zone-PE': 153.79,
                      'passport-priority-ddp-zone-SR': 151.44,
                      'passport-priority-ddp-zone-TT': 111.93,
                      'passport-priority-ddp-zone-UY': 151.44,
                      'passport-priority-ddp-zone-AF': 179.12,
                      'passport-priority-ddp-zone-DZ': 179.12,
                      'passport-priority-ddp-zone-BH': 166.76,
                      'passport-priority-ddp-zone-BD': 166.42,
                      'passport-priority-ddp-zone-BT': 166.42,
                      'passport-priority-ddp-zone-BA': 179.12,
                      'passport-priority-ddp-zone-BW': 179.12,
                      'passport-priority-ddp-zone-BN': 166.76,
                      'passport-priority-ddp-zone-BF': 179.12,
                      'passport-priority-ddp-zone-BI': 179.12,
                      'passport-priority-ddp-zone-KH': 179.12,
                      'passport-priority-ddp-zone-CM': 179.12,
                      'passport-priority-ddp-zone-CV': 179.12,
                      'passport-priority-ddp-zone-TD': 179.12,
                      'passport-priority-ddp-zone-CG': 179.12,
                      'passport-priority-ddp-zone-CI': 179.12,
                      'passport-priority-ddp-zone-EG': 166.76,
                      'passport-priority-ddp-zone-ET': 179.12,
                      'passport-priority-ddp-zone-GA': 179.12,
                      'passport-priority-ddp-zone-GM': 179.12,
                      'passport-priority-ddp-zone-GH': 179.12,
                      'passport-priority-ddp-zone-GN': 179.12,
                      'passport-priority-ddp-zone-ID': 165.11,
                      'passport-priority-ddp-zone-JO': 166.76,
                      'passport-priority-ddp-zone-KE': 179.12,
                      'passport-priority-ddp-zone-KW': 167.09,
                      'passport-priority-ddp-zone-LB': 166.76,
                      'passport-priority-ddp-zone-LI': 168.3,
                      'passport-priority-ddp-zone-MO': 163.99,
                      'passport-priority-ddp-zone-MG': 179.12,
                      'passport-priority-ddp-zone-MW': 179.12,
                      'passport-priority-ddp-zone-MY': 153.89,
                      'passport-priority-ddp-zone-MV': 166.42,
                      'passport-priority-ddp-zone-ML': 179.12,
                      'passport-priority-ddp-zone-MR': 179.12,
                      'passport-priority-ddp-zone-MU': 179.12,
                      'passport-priority-ddp-zone-MD': 179.12,
                      'passport-priority-ddp-zone-MA': 179.39,
                      'passport-priority-ddp-zone-MZ': 179.12,
                      'passport-priority-ddp-zone-NA': 179.12,
                      'passport-priority-ddp-zone-NP': 166.42,
                      'passport-priority-ddp-zone-NE': 179.12,
                      'passport-priority-ddp-zone-NG': 179.12,
                      'passport-priority-ddp-zone-PK': 166.42,
                      'passport-priority-ddp-zone-PH': 154.01,
                      'passport-priority-ddp-zone-RE': 179.12,
                      'passport-priority-ddp-zone-RW': 179.12,
                      'passport-priority-ddp-zone-SN': 179.12,
                      'passport-priority-ddp-zone-SC': 179.12,
                      'passport-priority-ddp-zone-ZA': 172.09,
                      'passport-priority-ddp-zone-LK': 166.42,
                      'passport-priority-ddp-zone-SZ': 179.12,
                      'passport-priority-ddp-zone-TW': 154.01,
                      'passport-priority-ddp-zone-TJ': 179.12,
                      'passport-priority-ddp-zone-TZ': 179.12,
                      'passport-priority-ddp-zone-TG': 179.12,
                      'passport-priority-ddp-zone-TN': 179.12,
                      'passport-priority-ddp-zone-TR': 166.78,
                      'passport-priority-ddp-zone-TM': 179.12,
                      'passport-priority-ddp-zone-UG': 179.12,
                      'passport-priority-ddp-zone-UA': 179.12,
                      'passport-priority-ddp-zone-VN': 154.18,
                      'passport-priority-ddp-zone-YE': 166.76,
                      'passport-priority-ddp-zone-ZM': 179.12,
                      'passport-priority-ddp-zone-ZW': 179.12,
                      'passport-priority-ddp-zone-MC': 73.97,
                      'passport-priority-ddp-zone-IM': 65.9,
                      'passport-priority-ddp-zone-SM': 73.97,
                    },
                    '15': {
                      'passport-priority-ddp-zone-CA': 38.89,
                      'passport-priority-ddp-zone-GB': 70.1,
                      'passport-priority-ddp-zone-AU': 100.68,
                      'passport-priority-ddp-zone-BE': 77.44,
                      'passport-priority-ddp-zone-DK': 77.44,
                      'passport-priority-ddp-zone-FR': 77.44,
                      'passport-priority-ddp-zone-DE': 77.44,
                      'passport-priority-ddp-zone-IT': 77.44,
                      'passport-priority-ddp-zone-NL': 77.44,
                      'passport-priority-ddp-zone-ES': 77.44,
                      'passport-priority-ddp-zone-MX': 89.76,
                      'passport-priority-ddp-zone-AM': 144.41,
                      'passport-priority-ddp-zone-AT': 85.33,
                      'passport-priority-ddp-zone-BG': 85.33,
                      'passport-priority-ddp-zone-HR': 85.33,
                      'passport-priority-ddp-zone-CY': 87.4,
                      'passport-priority-ddp-zone-CZ': 85.33,
                      'passport-priority-ddp-zone-EE': 85.33,
                      'passport-priority-ddp-zone-FI': 85.33,
                      'passport-priority-ddp-zone-GR': 85.78,
                      'passport-priority-ddp-zone-HU': 85.33,
                      'passport-priority-ddp-zone-IE': 85.33,
                      'passport-priority-ddp-zone-LV': 85.33,
                      'passport-priority-ddp-zone-LT': 85.33,
                      'passport-priority-ddp-zone-LU': 85.33,
                      'passport-priority-ddp-zone-MT': 87.4,
                      'passport-priority-ddp-zone-PL': 85.33,
                      'passport-priority-ddp-zone-PT': 85.33,
                      'passport-priority-ddp-zone-RO': 85.33,
                      'passport-priority-ddp-zone-SK': 85.33,
                      'passport-priority-ddp-zone-SI': 85.33,
                      'passport-priority-ddp-zone-SE': 85.33,
                      'passport-priority-ddp-zone-IL': 119.8,
                      'passport-priority-ddp-zone-OM': 127.12,
                      'passport-priority-ddp-zone-QA': 119.35,
                      'passport-priority-ddp-zone-SA': 119.38,
                      'passport-priority-ddp-zone-AE': 119.71,
                      'passport-priority-ddp-zone-CN': 166.71,
                      'passport-priority-ddp-zone-HK': 106.23,
                      'passport-priority-ddp-zone-IN': 133.57,
                      'passport-priority-ddp-zone-JP': 148.18,
                      'passport-priority-ddp-zone-KR': 122.76,
                      'passport-priority-ddp-zone-NZ': 101.08,
                      'passport-priority-ddp-zone-SG': 106.23,
                      'passport-priority-ddp-zone-TH': 106.86,
                      'passport-priority-ddp-zone-GG': 150.88,
                      'passport-priority-ddp-zone-JE': 150.88,
                      'passport-priority-ddp-zone-NO': 113.57,
                      'passport-priority-ddp-zone-CH': 114.0,
                      'passport-priority-ddp-zone-IS': 99.47,
                      'passport-priority-ddp-zone-AI': 112.75,
                      'passport-priority-ddp-zone-AG': 112.75,
                      'passport-priority-ddp-zone-AR': 157.97,
                      'passport-priority-ddp-zone-AW': 112.75,
                      'passport-priority-ddp-zone-BS': 112.75,
                      'passport-priority-ddp-zone-BB': 127.08,
                      'passport-priority-ddp-zone-BZ': 154.47,
                      'passport-priority-ddp-zone-BM': 113.02,
                      'passport-priority-ddp-zone-BO': 160.12,
                      'passport-priority-ddp-zone-BR': 105.89,
                      'passport-priority-ddp-zone-KY': 112.75,
                      'passport-priority-ddp-zone-CL': 114.4,
                      'passport-priority-ddp-zone-CO': 105.89,
                      'passport-priority-ddp-zone-CR': 158.46,
                      'passport-priority-ddp-zone-DM': 112.75,
                      'passport-priority-ddp-zone-DO': 113.49,
                      'passport-priority-ddp-zone-EC': 158.71,
                      'passport-priority-ddp-zone-SV': 154.47,
                      'passport-priority-ddp-zone-GP': 145.0,
                      'passport-priority-ddp-zone-GT': 154.57,
                      'passport-priority-ddp-zone-GY': 154.47,
                      'passport-priority-ddp-zone-HT': 112.75,
                      'passport-priority-ddp-zone-JM': 132.11,
                      'passport-priority-ddp-zone-MQ': 123.51,
                      'passport-priority-ddp-zone-AN': 112.75,
                      'passport-priority-ddp-zone-NI': 157.86,
                      'passport-priority-ddp-zone-PA': 154.76,
                      'passport-priority-ddp-zone-PY': 154.47,
                      'passport-priority-ddp-zone-PE': 156.81,
                      'passport-priority-ddp-zone-SR': 154.47,
                      'passport-priority-ddp-zone-TT': 118.12,
                      'passport-priority-ddp-zone-UY': 154.47,
                      'passport-priority-ddp-zone-AF': 203.87,
                      'passport-priority-ddp-zone-DZ': 203.87,
                      'passport-priority-ddp-zone-BH': 189.72,
                      'passport-priority-ddp-zone-BD': 190.81,
                      'passport-priority-ddp-zone-BT': 190.81,
                      'passport-priority-ddp-zone-BA': 203.87,
                      'passport-priority-ddp-zone-BW': 203.87,
                      'passport-priority-ddp-zone-BN': 189.72,
                      'passport-priority-ddp-zone-BF': 203.87,
                      'passport-priority-ddp-zone-BI': 203.87,
                      'passport-priority-ddp-zone-KH': 203.87,
                      'passport-priority-ddp-zone-CM': 203.87,
                      'passport-priority-ddp-zone-CV': 203.87,
                      'passport-priority-ddp-zone-TD': 203.87,
                      'passport-priority-ddp-zone-CG': 203.87,
                      'passport-priority-ddp-zone-CI': 203.87,
                      'passport-priority-ddp-zone-EG': 189.72,
                      'passport-priority-ddp-zone-ET': 203.87,
                      'passport-priority-ddp-zone-GA': 203.87,
                      'passport-priority-ddp-zone-GM': 203.87,
                      'passport-priority-ddp-zone-GH': 203.87,
                      'passport-priority-ddp-zone-GN': 203.87,
                      'passport-priority-ddp-zone-ID': 177.35,
                      'passport-priority-ddp-zone-JO': 189.72,
                      'passport-priority-ddp-zone-KE': 203.87,
                      'passport-priority-ddp-zone-KW': 190.1,
                      'passport-priority-ddp-zone-LB': 189.72,
                      'passport-priority-ddp-zone-LI': 200.33,
                      'passport-priority-ddp-zone-MO': 176.31,
                      'passport-priority-ddp-zone-MG': 203.87,
                      'passport-priority-ddp-zone-MW': 203.87,
                      'passport-priority-ddp-zone-MY': 176.73,
                      'passport-priority-ddp-zone-MV': 190.81,
                      'passport-priority-ddp-zone-ML': 203.87,
                      'passport-priority-ddp-zone-MR': 203.87,
                      'passport-priority-ddp-zone-MU': 203.87,
                      'passport-priority-ddp-zone-MD': 203.87,
                      'passport-priority-ddp-zone-MA': 204.2,
                      'passport-priority-ddp-zone-MZ': 203.87,
                      'passport-priority-ddp-zone-NA': 203.87,
                      'passport-priority-ddp-zone-NP': 190.81,
                      'passport-priority-ddp-zone-NE': 203.87,
                      'passport-priority-ddp-zone-NG': 203.87,
                      'passport-priority-ddp-zone-PK': 190.81,
                      'passport-priority-ddp-zone-PH': 176.87,
                      'passport-priority-ddp-zone-RE': 203.87,
                      'passport-priority-ddp-zone-RW': 203.87,
                      'passport-priority-ddp-zone-SN': 203.87,
                      'passport-priority-ddp-zone-SC': 203.87,
                      'passport-priority-ddp-zone-ZA': 191.29,
                      'passport-priority-ddp-zone-LK': 190.81,
                      'passport-priority-ddp-zone-SZ': 203.87,
                      'passport-priority-ddp-zone-TW': 176.87,
                      'passport-priority-ddp-zone-TJ': 203.87,
                      'passport-priority-ddp-zone-TZ': 203.87,
                      'passport-priority-ddp-zone-TG': 203.87,
                      'passport-priority-ddp-zone-TN': 203.87,
                      'passport-priority-ddp-zone-TR': 189.76,
                      'passport-priority-ddp-zone-TM': 203.87,
                      'passport-priority-ddp-zone-UG': 203.87,
                      'passport-priority-ddp-zone-UA': 203.87,
                      'passport-priority-ddp-zone-VN': 177.02,
                      'passport-priority-ddp-zone-YE': 189.72,
                      'passport-priority-ddp-zone-ZM': 203.87,
                      'passport-priority-ddp-zone-ZW': 203.87,
                      'passport-priority-ddp-zone-MC': 77.44,
                      'passport-priority-ddp-zone-IM': 70.1,
                      'passport-priority-ddp-zone-SM': 77.44,
                    },
                    '16': {
                      'passport-priority-ddp-zone-CA': 40.88,
                      'passport-priority-ddp-zone-GB': 74.3,
                      'passport-priority-ddp-zone-AU': 106.65,
                      'passport-priority-ddp-zone-BE': 81.9,
                      'passport-priority-ddp-zone-DK': 81.9,
                      'passport-priority-ddp-zone-FR': 81.9,
                      'passport-priority-ddp-zone-DE': 81.9,
                      'passport-priority-ddp-zone-IT': 81.9,
                      'passport-priority-ddp-zone-NL': 81.9,
                      'passport-priority-ddp-zone-ES': 81.9,
                      'passport-priority-ddp-zone-MX': 95.34,
                      'passport-priority-ddp-zone-AM': 145.94,
                      'passport-priority-ddp-zone-AT': 90.14,
                      'passport-priority-ddp-zone-BG': 90.14,
                      'passport-priority-ddp-zone-HR': 90.14,
                      'passport-priority-ddp-zone-CY': 92.61,
                      'passport-priority-ddp-zone-CZ': 90.14,
                      'passport-priority-ddp-zone-EE': 90.14,
                      'passport-priority-ddp-zone-FI': 90.14,
                      'passport-priority-ddp-zone-GR': 91.07,
                      'passport-priority-ddp-zone-HU': 90.14,
                      'passport-priority-ddp-zone-IE': 90.14,
                      'passport-priority-ddp-zone-LV': 90.14,
                      'passport-priority-ddp-zone-LT': 90.14,
                      'passport-priority-ddp-zone-LU': 90.14,
                      'passport-priority-ddp-zone-MT': 92.61,
                      'passport-priority-ddp-zone-PL': 90.14,
                      'passport-priority-ddp-zone-PT': 90.14,
                      'passport-priority-ddp-zone-RO': 90.14,
                      'passport-priority-ddp-zone-SK': 90.14,
                      'passport-priority-ddp-zone-SI': 90.14,
                      'passport-priority-ddp-zone-SE': 90.14,
                      'passport-priority-ddp-zone-IL': 128.37,
                      'passport-priority-ddp-zone-OM': 135.24,
                      'passport-priority-ddp-zone-QA': 127.95,
                      'passport-priority-ddp-zone-SA': 127.98,
                      'passport-priority-ddp-zone-AE': 128.28,
                      'passport-priority-ddp-zone-CN': 176.13,
                      'passport-priority-ddp-zone-HK': 116.2,
                      'passport-priority-ddp-zone-IN': 143.31,
                      'passport-priority-ddp-zone-JP': 157.78,
                      'passport-priority-ddp-zone-KR': 129.91,
                      'passport-priority-ddp-zone-NZ': 106.76,
                      'passport-priority-ddp-zone-SG': 116.2,
                      'passport-priority-ddp-zone-TH': 112.96,
                      'passport-priority-ddp-zone-GG': 153.3,
                      'passport-priority-ddp-zone-JE': 153.3,
                      'passport-priority-ddp-zone-NO': 114.59,
                      'passport-priority-ddp-zone-CH': 115.01,
                      'passport-priority-ddp-zone-IS': 104.21,
                      'passport-priority-ddp-zone-AI': 130.6,
                      'passport-priority-ddp-zone-AG': 130.6,
                      'passport-priority-ddp-zone-AR': 164.42,
                      'passport-priority-ddp-zone-AW': 130.6,
                      'passport-priority-ddp-zone-BS': 130.6,
                      'passport-priority-ddp-zone-BB': 145.39,
                      'passport-priority-ddp-zone-BZ': 160.91,
                      'passport-priority-ddp-zone-BM': 130.91,
                      'passport-priority-ddp-zone-BO': 166.57,
                      'passport-priority-ddp-zone-BR': 113.94,
                      'passport-priority-ddp-zone-KY': 130.6,
                      'passport-priority-ddp-zone-CL': 121.51,
                      'passport-priority-ddp-zone-CO': 113.94,
                      'passport-priority-ddp-zone-CR': 164.91,
                      'passport-priority-ddp-zone-DM': 130.6,
                      'passport-priority-ddp-zone-DO': 131.39,
                      'passport-priority-ddp-zone-EC': 165.16,
                      'passport-priority-ddp-zone-SV': 160.91,
                      'passport-priority-ddp-zone-GP': 163.87,
                      'passport-priority-ddp-zone-GT': 161.01,
                      'passport-priority-ddp-zone-GY': 160.91,
                      'passport-priority-ddp-zone-HT': 130.6,
                      'passport-priority-ddp-zone-JM': 150.56,
                      'passport-priority-ddp-zone-MQ': 141.69,
                      'passport-priority-ddp-zone-AN': 130.6,
                      'passport-priority-ddp-zone-NI': 164.31,
                      'passport-priority-ddp-zone-PA': 161.21,
                      'passport-priority-ddp-zone-PY': 160.91,
                      'passport-priority-ddp-zone-PE': 163.26,
                      'passport-priority-ddp-zone-SR': 160.91,
                      'passport-priority-ddp-zone-TT': 136.15,
                      'passport-priority-ddp-zone-UY': 160.91,
                      'passport-priority-ddp-zone-AF': 210.4,
                      'passport-priority-ddp-zone-DZ': 210.4,
                      'passport-priority-ddp-zone-BH': 198.02,
                      'passport-priority-ddp-zone-BD': 191.44,
                      'passport-priority-ddp-zone-BT': 191.44,
                      'passport-priority-ddp-zone-BA': 210.4,
                      'passport-priority-ddp-zone-BW': 210.4,
                      'passport-priority-ddp-zone-BN': 198.02,
                      'passport-priority-ddp-zone-BF': 210.4,
                      'passport-priority-ddp-zone-BI': 210.4,
                      'passport-priority-ddp-zone-KH': 210.4,
                      'passport-priority-ddp-zone-CM': 210.4,
                      'passport-priority-ddp-zone-CV': 210.4,
                      'passport-priority-ddp-zone-TD': 210.4,
                      'passport-priority-ddp-zone-CG': 210.4,
                      'passport-priority-ddp-zone-CI': 210.4,
                      'passport-priority-ddp-zone-EG': 198.02,
                      'passport-priority-ddp-zone-ET': 210.4,
                      'passport-priority-ddp-zone-GA': 210.4,
                      'passport-priority-ddp-zone-GM': 210.4,
                      'passport-priority-ddp-zone-GH': 210.4,
                      'passport-priority-ddp-zone-GN': 210.4,
                      'passport-priority-ddp-zone-ID': 190.14,
                      'passport-priority-ddp-zone-JO': 198.02,
                      'passport-priority-ddp-zone-KE': 210.4,
                      'passport-priority-ddp-zone-KW': 198.38,
                      'passport-priority-ddp-zone-LB': 198.02,
                      'passport-priority-ddp-zone-LI': 200.99,
                      'passport-priority-ddp-zone-MO': 188.97,
                      'passport-priority-ddp-zone-MG': 210.4,
                      'passport-priority-ddp-zone-MW': 210.4,
                      'passport-priority-ddp-zone-MY': 181.99,
                      'passport-priority-ddp-zone-MV': 191.44,
                      'passport-priority-ddp-zone-ML': 210.4,
                      'passport-priority-ddp-zone-MR': 210.4,
                      'passport-priority-ddp-zone-MU': 210.4,
                      'passport-priority-ddp-zone-MD': 210.4,
                      'passport-priority-ddp-zone-MA': 210.72,
                      'passport-priority-ddp-zone-MZ': 210.4,
                      'passport-priority-ddp-zone-NA': 210.4,
                      'passport-priority-ddp-zone-NP': 191.44,
                      'passport-priority-ddp-zone-NE': 210.4,
                      'passport-priority-ddp-zone-NG': 210.4,
                      'passport-priority-ddp-zone-PK': 191.44,
                      'passport-priority-ddp-zone-PH': 182.13,
                      'passport-priority-ddp-zone-RE': 210.4,
                      'passport-priority-ddp-zone-RW': 210.4,
                      'passport-priority-ddp-zone-SN': 210.4,
                      'passport-priority-ddp-zone-SC': 210.4,
                      'passport-priority-ddp-zone-ZA': 193.88,
                      'passport-priority-ddp-zone-LK': 191.44,
                      'passport-priority-ddp-zone-SZ': 210.4,
                      'passport-priority-ddp-zone-TW': 182.13,
                      'passport-priority-ddp-zone-TJ': 210.4,
                      'passport-priority-ddp-zone-TZ': 210.4,
                      'passport-priority-ddp-zone-TG': 210.4,
                      'passport-priority-ddp-zone-TN': 210.4,
                      'passport-priority-ddp-zone-TR': 198.07,
                      'passport-priority-ddp-zone-TM': 210.4,
                      'passport-priority-ddp-zone-UG': 210.4,
                      'passport-priority-ddp-zone-UA': 210.4,
                      'passport-priority-ddp-zone-VN': 182.29,
                      'passport-priority-ddp-zone-YE': 198.02,
                      'passport-priority-ddp-zone-ZM': 210.4,
                      'passport-priority-ddp-zone-ZW': 210.4,
                      'passport-priority-ddp-zone-MC': 81.9,
                      'passport-priority-ddp-zone-IM': 74.3,
                      'passport-priority-ddp-zone-SM': 81.9,
                    },
                    '17': {
                      'passport-priority-ddp-zone-CA': 42.87,
                      'passport-priority-ddp-zone-GB': 78.51,
                      'passport-priority-ddp-zone-AU': 112.63,
                      'passport-priority-ddp-zone-BE': 85.38,
                      'passport-priority-ddp-zone-DK': 85.38,
                      'passport-priority-ddp-zone-FR': 85.38,
                      'passport-priority-ddp-zone-DE': 85.38,
                      'passport-priority-ddp-zone-IT': 85.38,
                      'passport-priority-ddp-zone-NL': 85.38,
                      'passport-priority-ddp-zone-ES': 85.38,
                      'passport-priority-ddp-zone-MX': 100.96,
                      'passport-priority-ddp-zone-AM': 147.94,
                      'passport-priority-ddp-zone-AT': 93.62,
                      'passport-priority-ddp-zone-BG': 93.62,
                      'passport-priority-ddp-zone-HR': 93.62,
                      'passport-priority-ddp-zone-CY': 96.38,
                      'passport-priority-ddp-zone-CZ': 93.62,
                      'passport-priority-ddp-zone-EE': 93.62,
                      'passport-priority-ddp-zone-FI': 93.62,
                      'passport-priority-ddp-zone-GR': 94.83,
                      'passport-priority-ddp-zone-HU': 93.62,
                      'passport-priority-ddp-zone-IE': 93.62,
                      'passport-priority-ddp-zone-LV': 93.62,
                      'passport-priority-ddp-zone-LT': 93.62,
                      'passport-priority-ddp-zone-LU': 93.62,
                      'passport-priority-ddp-zone-MT': 96.38,
                      'passport-priority-ddp-zone-PL': 93.62,
                      'passport-priority-ddp-zone-PT': 93.62,
                      'passport-priority-ddp-zone-RO': 93.62,
                      'passport-priority-ddp-zone-SK': 93.62,
                      'passport-priority-ddp-zone-SI': 93.62,
                      'passport-priority-ddp-zone-SE': 93.62,
                      'passport-priority-ddp-zone-IL': 133.95,
                      'passport-priority-ddp-zone-OM': 141.01,
                      'passport-priority-ddp-zone-QA': 133.51,
                      'passport-priority-ddp-zone-SA': 133.55,
                      'passport-priority-ddp-zone-AE': 133.86,
                      'passport-priority-ddp-zone-CN': 185.57,
                      'passport-priority-ddp-zone-HK': 122.56,
                      'passport-priority-ddp-zone-IN': 146.52,
                      'passport-priority-ddp-zone-JP': 167.37,
                      'passport-priority-ddp-zone-KR': 137.07,
                      'passport-priority-ddp-zone-NZ': 112.45,
                      'passport-priority-ddp-zone-SG': 122.56,
                      'passport-priority-ddp-zone-TH': 119.06,
                      'passport-priority-ddp-zone-GG': 154.86,
                      'passport-priority-ddp-zone-JE': 154.86,
                      'passport-priority-ddp-zone-NO': 123.0,
                      'passport-priority-ddp-zone-CH': 123.42,
                      'passport-priority-ddp-zone-IS': 106.71,
                      'passport-priority-ddp-zone-AI': 137.18,
                      'passport-priority-ddp-zone-AG': 137.18,
                      'passport-priority-ddp-zone-AR': 173.2,
                      'passport-priority-ddp-zone-AW': 137.18,
                      'passport-priority-ddp-zone-BS': 137.18,
                      'passport-priority-ddp-zone-BB': 152.2,
                      'passport-priority-ddp-zone-BZ': 169.7,
                      'passport-priority-ddp-zone-BM': 137.49,
                      'passport-priority-ddp-zone-BO': 175.36,
                      'passport-priority-ddp-zone-BR': 119.58,
                      'passport-priority-ddp-zone-KY': 137.18,
                      'passport-priority-ddp-zone-CL': 128.72,
                      'passport-priority-ddp-zone-CO': 119.58,
                      'passport-priority-ddp-zone-CR': 173.69,
                      'passport-priority-ddp-zone-DM': 137.18,
                      'passport-priority-ddp-zone-DO': 137.97,
                      'passport-priority-ddp-zone-EC': 173.94,
                      'passport-priority-ddp-zone-SV': 169.7,
                      'passport-priority-ddp-zone-GP': 170.96,
                      'passport-priority-ddp-zone-GT': 169.8,
                      'passport-priority-ddp-zone-GY': 169.7,
                      'passport-priority-ddp-zone-HT': 137.18,
                      'passport-priority-ddp-zone-JM': 157.45,
                      'passport-priority-ddp-zone-MQ': 148.44,
                      'passport-priority-ddp-zone-AN': 137.18,
                      'passport-priority-ddp-zone-NI': 173.09,
                      'passport-priority-ddp-zone-PA': 169.99,
                      'passport-priority-ddp-zone-PY': 169.7,
                      'passport-priority-ddp-zone-PE': 172.04,
                      'passport-priority-ddp-zone-SR': 169.7,
                      'passport-priority-ddp-zone-TT': 142.81,
                      'passport-priority-ddp-zone-UY': 169.7,
                      'passport-priority-ddp-zone-AF': 212.1,
                      'passport-priority-ddp-zone-DZ': 212.1,
                      'passport-priority-ddp-zone-BH': 199.12,
                      'passport-priority-ddp-zone-BD': 192.07,
                      'passport-priority-ddp-zone-BT': 192.07,
                      'passport-priority-ddp-zone-BA': 212.1,
                      'passport-priority-ddp-zone-BW': 212.1,
                      'passport-priority-ddp-zone-BN': 199.12,
                      'passport-priority-ddp-zone-BF': 212.1,
                      'passport-priority-ddp-zone-BI': 212.1,
                      'passport-priority-ddp-zone-KH': 212.1,
                      'passport-priority-ddp-zone-CM': 212.1,
                      'passport-priority-ddp-zone-CV': 212.1,
                      'passport-priority-ddp-zone-TD': 212.1,
                      'passport-priority-ddp-zone-CG': 212.1,
                      'passport-priority-ddp-zone-CI': 212.1,
                      'passport-priority-ddp-zone-EG': 199.12,
                      'passport-priority-ddp-zone-ET': 212.1,
                      'passport-priority-ddp-zone-GA': 212.1,
                      'passport-priority-ddp-zone-GM': 212.1,
                      'passport-priority-ddp-zone-GH': 212.1,
                      'passport-priority-ddp-zone-GN': 212.1,
                      'passport-priority-ddp-zone-ID': 191.21,
                      'passport-priority-ddp-zone-JO': 199.12,
                      'passport-priority-ddp-zone-KE': 212.1,
                      'passport-priority-ddp-zone-KW': 199.48,
                      'passport-priority-ddp-zone-LB': 199.12,
                      'passport-priority-ddp-zone-LI': 209.18,
                      'passport-priority-ddp-zone-MO': 190.05,
                      'passport-priority-ddp-zone-MG': 212.1,
                      'passport-priority-ddp-zone-MW': 212.1,
                      'passport-priority-ddp-zone-MY': 182.78,
                      'passport-priority-ddp-zone-MV': 192.07,
                      'passport-priority-ddp-zone-ML': 212.1,
                      'passport-priority-ddp-zone-MR': 212.1,
                      'passport-priority-ddp-zone-MU': 212.1,
                      'passport-priority-ddp-zone-MD': 212.1,
                      'passport-priority-ddp-zone-MA': 212.44,
                      'passport-priority-ddp-zone-MZ': 212.1,
                      'passport-priority-ddp-zone-NA': 212.1,
                      'passport-priority-ddp-zone-NP': 192.07,
                      'passport-priority-ddp-zone-NE': 212.1,
                      'passport-priority-ddp-zone-NG': 212.1,
                      'passport-priority-ddp-zone-PK': 192.07,
                      'passport-priority-ddp-zone-PH': 182.92,
                      'passport-priority-ddp-zone-RE': 212.1,
                      'passport-priority-ddp-zone-RW': 212.1,
                      'passport-priority-ddp-zone-SN': 212.1,
                      'passport-priority-ddp-zone-SC': 212.1,
                      'passport-priority-ddp-zone-ZA': 194.96,
                      'passport-priority-ddp-zone-LK': 192.07,
                      'passport-priority-ddp-zone-SZ': 212.1,
                      'passport-priority-ddp-zone-TW': 182.92,
                      'passport-priority-ddp-zone-TJ': 212.1,
                      'passport-priority-ddp-zone-TZ': 212.1,
                      'passport-priority-ddp-zone-TG': 212.1,
                      'passport-priority-ddp-zone-TN': 212.1,
                      'passport-priority-ddp-zone-TR': 199.17,
                      'passport-priority-ddp-zone-TM': 212.1,
                      'passport-priority-ddp-zone-UG': 212.1,
                      'passport-priority-ddp-zone-UA': 212.1,
                      'passport-priority-ddp-zone-VN': 183.09,
                      'passport-priority-ddp-zone-YE': 199.12,
                      'passport-priority-ddp-zone-ZM': 212.1,
                      'passport-priority-ddp-zone-ZW': 212.1,
                      'passport-priority-ddp-zone-MC': 85.38,
                      'passport-priority-ddp-zone-IM': 78.51,
                      'passport-priority-ddp-zone-SM': 85.38,
                    },
                    '18': {
                      'passport-priority-ddp-zone-CA': 44.87,
                      'passport-priority-ddp-zone-GB': 82.71,
                      'passport-priority-ddp-zone-AU': 118.6,
                      'passport-priority-ddp-zone-BE': 89.76,
                      'passport-priority-ddp-zone-DK': 89.76,
                      'passport-priority-ddp-zone-FR': 89.76,
                      'passport-priority-ddp-zone-DE': 89.76,
                      'passport-priority-ddp-zone-IT': 89.76,
                      'passport-priority-ddp-zone-NL': 89.76,
                      'passport-priority-ddp-zone-ES': 89.76,
                      'passport-priority-ddp-zone-MX': 106.56,
                      'passport-priority-ddp-zone-AM': 166.14,
                      'passport-priority-ddp-zone-AT': 97.94,
                      'passport-priority-ddp-zone-BG': 97.94,
                      'passport-priority-ddp-zone-HR': 97.94,
                      'passport-priority-ddp-zone-CY': 101.57,
                      'passport-priority-ddp-zone-CZ': 97.94,
                      'passport-priority-ddp-zone-EE': 97.94,
                      'passport-priority-ddp-zone-FI': 97.94,
                      'passport-priority-ddp-zone-GR': 99.97,
                      'passport-priority-ddp-zone-HU': 97.94,
                      'passport-priority-ddp-zone-IE': 97.94,
                      'passport-priority-ddp-zone-LV': 97.94,
                      'passport-priority-ddp-zone-LT': 97.94,
                      'passport-priority-ddp-zone-LU': 97.94,
                      'passport-priority-ddp-zone-MT': 101.58,
                      'passport-priority-ddp-zone-PL': 97.94,
                      'passport-priority-ddp-zone-PT': 97.94,
                      'passport-priority-ddp-zone-RO': 97.94,
                      'passport-priority-ddp-zone-SK': 97.94,
                      'passport-priority-ddp-zone-SI': 97.94,
                      'passport-priority-ddp-zone-SE': 97.94,
                      'passport-priority-ddp-zone-IL': 137.79,
                      'passport-priority-ddp-zone-OM': 144.85,
                      'passport-priority-ddp-zone-QA': 137.36,
                      'passport-priority-ddp-zone-SA': 137.39,
                      'passport-priority-ddp-zone-AE': 137.68,
                      'passport-priority-ddp-zone-CN': 194.99,
                      'passport-priority-ddp-zone-HK': 128.4,
                      'passport-priority-ddp-zone-IN': 152.13,
                      'passport-priority-ddp-zone-JP': 176.96,
                      'passport-priority-ddp-zone-KR': 144.21,
                      'passport-priority-ddp-zone-NZ': 117.46,
                      'passport-priority-ddp-zone-SG': 128.4,
                      'passport-priority-ddp-zone-TH': 125.17,
                      'passport-priority-ddp-zone-GG': 164.24,
                      'passport-priority-ddp-zone-JE': 164.24,
                      'passport-priority-ddp-zone-NO': 124.46,
                      'passport-priority-ddp-zone-CH': 124.89,
                      'passport-priority-ddp-zone-IS': 108.59,
                      'passport-priority-ddp-zone-AI': 137.63,
                      'passport-priority-ddp-zone-AG': 137.63,
                      'passport-priority-ddp-zone-AR': 186.29,
                      'passport-priority-ddp-zone-AW': 137.63,
                      'passport-priority-ddp-zone-BS': 137.63,
                      'passport-priority-ddp-zone-BB': 152.7,
                      'passport-priority-ddp-zone-BZ': 182.79,
                      'passport-priority-ddp-zone-BM': 137.94,
                      'passport-priority-ddp-zone-BO': 188.44,
                      'passport-priority-ddp-zone-BR': 121.37,
                      'passport-priority-ddp-zone-KY': 137.63,
                      'passport-priority-ddp-zone-CL': 130.74,
                      'passport-priority-ddp-zone-CO': 121.37,
                      'passport-priority-ddp-zone-CR': 186.78,
                      'passport-priority-ddp-zone-DM': 137.63,
                      'passport-priority-ddp-zone-DO': 138.43,
                      'passport-priority-ddp-zone-EC': 187.02,
                      'passport-priority-ddp-zone-SV': 182.79,
                      'passport-priority-ddp-zone-GP': 171.52,
                      'passport-priority-ddp-zone-GT': 182.89,
                      'passport-priority-ddp-zone-GY': 182.79,
                      'passport-priority-ddp-zone-HT': 137.63,
                      'passport-priority-ddp-zone-JM': 157.97,
                      'passport-priority-ddp-zone-MQ': 148.93,
                      'passport-priority-ddp-zone-AN': 137.63,
                      'passport-priority-ddp-zone-NI': 186.18,
                      'passport-priority-ddp-zone-PA': 183.08,
                      'passport-priority-ddp-zone-PY': 182.79,
                      'passport-priority-ddp-zone-PE': 185.12,
                      'passport-priority-ddp-zone-SR': 182.79,
                      'passport-priority-ddp-zone-TT': 143.28,
                      'passport-priority-ddp-zone-UY': 182.79,
                      'passport-priority-ddp-zone-AF': 235.37,
                      'passport-priority-ddp-zone-DZ': 235.37,
                      'passport-priority-ddp-zone-BH': 211.5,
                      'passport-priority-ddp-zone-BD': 198.65,
                      'passport-priority-ddp-zone-BT': 198.65,
                      'passport-priority-ddp-zone-BA': 235.37,
                      'passport-priority-ddp-zone-BW': 235.37,
                      'passport-priority-ddp-zone-BN': 211.5,
                      'passport-priority-ddp-zone-BF': 235.37,
                      'passport-priority-ddp-zone-BI': 235.37,
                      'passport-priority-ddp-zone-KH': 235.37,
                      'passport-priority-ddp-zone-CM': 235.37,
                      'passport-priority-ddp-zone-CV': 235.37,
                      'passport-priority-ddp-zone-TD': 235.37,
                      'passport-priority-ddp-zone-CG': 235.37,
                      'passport-priority-ddp-zone-CI': 235.37,
                      'passport-priority-ddp-zone-EG': 211.5,
                      'passport-priority-ddp-zone-ET': 235.37,
                      'passport-priority-ddp-zone-GA': 235.37,
                      'passport-priority-ddp-zone-GM': 235.37,
                      'passport-priority-ddp-zone-GH': 235.37,
                      'passport-priority-ddp-zone-GN': 235.37,
                      'passport-priority-ddp-zone-ID': 193.45,
                      'passport-priority-ddp-zone-JO': 211.5,
                      'passport-priority-ddp-zone-KE': 235.37,
                      'passport-priority-ddp-zone-KW': 211.86,
                      'passport-priority-ddp-zone-LB': 211.5,
                      'passport-priority-ddp-zone-LI': 220.74,
                      'passport-priority-ddp-zone-MO': 193.45,
                      'passport-priority-ddp-zone-MG': 235.37,
                      'passport-priority-ddp-zone-MW': 235.37,
                      'passport-priority-ddp-zone-MY': 193.98,
                      'passport-priority-ddp-zone-MV': 198.65,
                      'passport-priority-ddp-zone-ML': 235.37,
                      'passport-priority-ddp-zone-MR': 235.37,
                      'passport-priority-ddp-zone-MU': 235.37,
                      'passport-priority-ddp-zone-MD': 235.37,
                      'passport-priority-ddp-zone-MA': 235.67,
                      'passport-priority-ddp-zone-MZ': 235.37,
                      'passport-priority-ddp-zone-NA': 235.37,
                      'passport-priority-ddp-zone-NP': 198.65,
                      'passport-priority-ddp-zone-NE': 235.37,
                      'passport-priority-ddp-zone-NG': 235.37,
                      'passport-priority-ddp-zone-PK': 198.65,
                      'passport-priority-ddp-zone-PH': 194.12,
                      'passport-priority-ddp-zone-RE': 235.37,
                      'passport-priority-ddp-zone-RW': 235.37,
                      'passport-priority-ddp-zone-SN': 235.37,
                      'passport-priority-ddp-zone-SC': 235.37,
                      'passport-priority-ddp-zone-ZA': 207.46,
                      'passport-priority-ddp-zone-LK': 198.65,
                      'passport-priority-ddp-zone-SZ': 235.37,
                      'passport-priority-ddp-zone-TW': 194.12,
                      'passport-priority-ddp-zone-TJ': 235.37,
                      'passport-priority-ddp-zone-TZ': 235.37,
                      'passport-priority-ddp-zone-TG': 235.37,
                      'passport-priority-ddp-zone-TN': 235.37,
                      'passport-priority-ddp-zone-TR': 211.53,
                      'passport-priority-ddp-zone-TM': 235.37,
                      'passport-priority-ddp-zone-UG': 235.37,
                      'passport-priority-ddp-zone-UA': 235.37,
                      'passport-priority-ddp-zone-VN': 194.29,
                      'passport-priority-ddp-zone-YE': 211.5,
                      'passport-priority-ddp-zone-ZM': 235.37,
                      'passport-priority-ddp-zone-ZW': 235.37,
                      'passport-priority-ddp-zone-MC': 89.76,
                      'passport-priority-ddp-zone-IM': 82.71,
                      'passport-priority-ddp-zone-SM': 89.76,
                    },
                    '19': {
                      'passport-priority-ddp-zone-CA': 46.84,
                      'passport-priority-ddp-zone-GB': 86.91,
                      'passport-priority-ddp-zone-AU': 124.59,
                      'passport-priority-ddp-zone-BE': 93.24,
                      'passport-priority-ddp-zone-DK': 93.24,
                      'passport-priority-ddp-zone-FR': 93.24,
                      'passport-priority-ddp-zone-DE': 93.24,
                      'passport-priority-ddp-zone-IT': 93.24,
                      'passport-priority-ddp-zone-NL': 93.24,
                      'passport-priority-ddp-zone-ES': 93.24,
                      'passport-priority-ddp-zone-MX': 112.17,
                      'passport-priority-ddp-zone-AM': 177.14,
                      'passport-priority-ddp-zone-AT': 101.41,
                      'passport-priority-ddp-zone-BG': 101.41,
                      'passport-priority-ddp-zone-HR': 101.41,
                      'passport-priority-ddp-zone-CY': 105.33,
                      'passport-priority-ddp-zone-CZ': 101.41,
                      'passport-priority-ddp-zone-EE': 101.41,
                      'passport-priority-ddp-zone-FI': 101.41,
                      'passport-priority-ddp-zone-GR': 103.73,
                      'passport-priority-ddp-zone-HU': 101.41,
                      'passport-priority-ddp-zone-IE': 101.41,
                      'passport-priority-ddp-zone-LV': 101.41,
                      'passport-priority-ddp-zone-LT': 101.41,
                      'passport-priority-ddp-zone-LU': 101.41,
                      'passport-priority-ddp-zone-MT': 105.34,
                      'passport-priority-ddp-zone-PL': 101.41,
                      'passport-priority-ddp-zone-PT': 101.41,
                      'passport-priority-ddp-zone-RO': 101.41,
                      'passport-priority-ddp-zone-SK': 101.41,
                      'passport-priority-ddp-zone-SI': 101.41,
                      'passport-priority-ddp-zone-SE': 101.41,
                      'passport-priority-ddp-zone-IL': 144.79,
                      'passport-priority-ddp-zone-OM': 151.84,
                      'passport-priority-ddp-zone-QA': 144.36,
                      'passport-priority-ddp-zone-SA': 144.41,
                      'passport-priority-ddp-zone-AE': 144.71,
                      'passport-priority-ddp-zone-CN': 204.42,
                      'passport-priority-ddp-zone-HK': 134.94,
                      'passport-priority-ddp-zone-IN': 159.9,
                      'passport-priority-ddp-zone-JP': 186.54,
                      'passport-priority-ddp-zone-KR': 151.37,
                      'passport-priority-ddp-zone-NZ': 123.28,
                      'passport-priority-ddp-zone-SG': 134.94,
                      'passport-priority-ddp-zone-TH': 131.27,
                      'passport-priority-ddp-zone-GG': 172.0,
                      'passport-priority-ddp-zone-JE': 172.0,
                      'passport-priority-ddp-zone-NO': 124.87,
                      'passport-priority-ddp-zone-CH': 125.3,
                      'passport-priority-ddp-zone-IS': 113.29,
                      'passport-priority-ddp-zone-AI': 139.98,
                      'passport-priority-ddp-zone-AG': 139.98,
                      'passport-priority-ddp-zone-AR': 192.77,
                      'passport-priority-ddp-zone-AW': 139.98,
                      'passport-priority-ddp-zone-BS': 139.98,
                      'passport-priority-ddp-zone-BB': 154.91,
                      'passport-priority-ddp-zone-BZ': 189.27,
                      'passport-priority-ddp-zone-BM': 140.29,
                      'passport-priority-ddp-zone-BO': 194.92,
                      'passport-priority-ddp-zone-BR': 127.8,
                      'passport-priority-ddp-zone-KY': 139.98,
                      'passport-priority-ddp-zone-CL': 137.88,
                      'passport-priority-ddp-zone-CO': 127.8,
                      'passport-priority-ddp-zone-CR': 193.26,
                      'passport-priority-ddp-zone-DM': 139.98,
                      'passport-priority-ddp-zone-DO': 140.75,
                      'passport-priority-ddp-zone-EC': 193.51,
                      'passport-priority-ddp-zone-SV': 189.27,
                      'passport-priority-ddp-zone-GP': 173.59,
                      'passport-priority-ddp-zone-GT': 189.37,
                      'passport-priority-ddp-zone-GY': 189.27,
                      'passport-priority-ddp-zone-HT': 139.98,
                      'passport-priority-ddp-zone-JM': 160.16,
                      'passport-priority-ddp-zone-MQ': 151.19,
                      'passport-priority-ddp-zone-AN': 139.98,
                      'passport-priority-ddp-zone-NI': 192.66,
                      'passport-priority-ddp-zone-PA': 189.56,
                      'passport-priority-ddp-zone-PY': 189.27,
                      'passport-priority-ddp-zone-PE': 191.61,
                      'passport-priority-ddp-zone-SR': 189.27,
                      'passport-priority-ddp-zone-TT': 145.57,
                      'passport-priority-ddp-zone-UY': 189.27,
                      'passport-priority-ddp-zone-AF': 246.12,
                      'passport-priority-ddp-zone-DZ': 246.12,
                      'passport-priority-ddp-zone-BH': 221.16,
                      'passport-priority-ddp-zone-BD': 206.13,
                      'passport-priority-ddp-zone-BT': 206.13,
                      'passport-priority-ddp-zone-BA': 246.12,
                      'passport-priority-ddp-zone-BW': 246.12,
                      'passport-priority-ddp-zone-BN': 221.16,
                      'passport-priority-ddp-zone-BF': 246.12,
                      'passport-priority-ddp-zone-BI': 246.12,
                      'passport-priority-ddp-zone-KH': 246.12,
                      'passport-priority-ddp-zone-CM': 246.12,
                      'passport-priority-ddp-zone-CV': 246.12,
                      'passport-priority-ddp-zone-TD': 246.12,
                      'passport-priority-ddp-zone-CG': 246.12,
                      'passport-priority-ddp-zone-CI': 246.12,
                      'passport-priority-ddp-zone-EG': 221.16,
                      'passport-priority-ddp-zone-ET': 246.12,
                      'passport-priority-ddp-zone-GA': 246.12,
                      'passport-priority-ddp-zone-GM': 246.12,
                      'passport-priority-ddp-zone-GH': 246.12,
                      'passport-priority-ddp-zone-GN': 246.12,
                      'passport-priority-ddp-zone-ID': 202.78,
                      'passport-priority-ddp-zone-JO': 221.16,
                      'passport-priority-ddp-zone-KE': 246.12,
                      'passport-priority-ddp-zone-KW': 221.54,
                      'passport-priority-ddp-zone-LB': 221.16,
                      'passport-priority-ddp-zone-LI': 220.78,
                      'passport-priority-ddp-zone-MO': 202.43,
                      'passport-priority-ddp-zone-MG': 246.12,
                      'passport-priority-ddp-zone-MW': 246.12,
                      'passport-priority-ddp-zone-MY': 203.0,
                      'passport-priority-ddp-zone-MV': 206.13,
                      'passport-priority-ddp-zone-ML': 246.12,
                      'passport-priority-ddp-zone-MR': 246.12,
                      'passport-priority-ddp-zone-MU': 246.12,
                      'passport-priority-ddp-zone-MD': 246.12,
                      'passport-priority-ddp-zone-MA': 246.44,
                      'passport-priority-ddp-zone-MZ': 246.12,
                      'passport-priority-ddp-zone-NA': 246.12,
                      'passport-priority-ddp-zone-NP': 206.13,
                      'passport-priority-ddp-zone-NE': 246.12,
                      'passport-priority-ddp-zone-NG': 246.12,
                      'passport-priority-ddp-zone-PK': 206.13,
                      'passport-priority-ddp-zone-PH': 203.15,
                      'passport-priority-ddp-zone-RE': 246.12,
                      'passport-priority-ddp-zone-RW': 246.12,
                      'passport-priority-ddp-zone-SN': 246.12,
                      'passport-priority-ddp-zone-SC': 246.12,
                      'passport-priority-ddp-zone-ZA': 217.64,
                      'passport-priority-ddp-zone-LK': 206.13,
                      'passport-priority-ddp-zone-SZ': 246.12,
                      'passport-priority-ddp-zone-TW': 203.15,
                      'passport-priority-ddp-zone-TJ': 246.12,
                      'passport-priority-ddp-zone-TZ': 246.12,
                      'passport-priority-ddp-zone-TG': 246.12,
                      'passport-priority-ddp-zone-TN': 246.12,
                      'passport-priority-ddp-zone-TR': 221.22,
                      'passport-priority-ddp-zone-TM': 246.12,
                      'passport-priority-ddp-zone-UG': 246.12,
                      'passport-priority-ddp-zone-UA': 246.12,
                      'passport-priority-ddp-zone-VN': 203.34,
                      'passport-priority-ddp-zone-YE': 221.16,
                      'passport-priority-ddp-zone-ZM': 246.12,
                      'passport-priority-ddp-zone-ZW': 246.12,
                      'passport-priority-ddp-zone-MC': 93.24,
                      'passport-priority-ddp-zone-IM': 86.91,
                      'passport-priority-ddp-zone-SM': 93.24,
                    },
                    '20': {
                      'passport-priority-ddp-zone-CA': 48.83,
                      'passport-priority-ddp-zone-GB': 91.11,
                      'passport-priority-ddp-zone-AU': 130.55,
                      'passport-priority-ddp-zone-BE': 97.84,
                      'passport-priority-ddp-zone-DK': 97.84,
                      'passport-priority-ddp-zone-FR': 97.84,
                      'passport-priority-ddp-zone-DE': 97.84,
                      'passport-priority-ddp-zone-IT': 97.84,
                      'passport-priority-ddp-zone-NL': 97.84,
                      'passport-priority-ddp-zone-ES': 97.84,
                      'passport-priority-ddp-zone-MX': 117.77,
                      'passport-priority-ddp-zone-AM': 179.99,
                      'passport-priority-ddp-zone-AT': 105.4,
                      'passport-priority-ddp-zone-BG': 105.4,
                      'passport-priority-ddp-zone-HR': 105.4,
                      'passport-priority-ddp-zone-CY': 110.54,
                      'passport-priority-ddp-zone-CZ': 105.4,
                      'passport-priority-ddp-zone-EE': 105.4,
                      'passport-priority-ddp-zone-FI': 105.4,
                      'passport-priority-ddp-zone-GR': 109.01,
                      'passport-priority-ddp-zone-HU': 105.4,
                      'passport-priority-ddp-zone-IE': 105.4,
                      'passport-priority-ddp-zone-LV': 105.4,
                      'passport-priority-ddp-zone-LT': 105.4,
                      'passport-priority-ddp-zone-LU': 105.4,
                      'passport-priority-ddp-zone-MT': 110.54,
                      'passport-priority-ddp-zone-PL': 105.4,
                      'passport-priority-ddp-zone-PT': 105.4,
                      'passport-priority-ddp-zone-RO': 105.4,
                      'passport-priority-ddp-zone-SK': 105.4,
                      'passport-priority-ddp-zone-SI': 105.4,
                      'passport-priority-ddp-zone-SE': 105.4,
                      'passport-priority-ddp-zone-IL': 146.62,
                      'passport-priority-ddp-zone-OM': 153.71,
                      'passport-priority-ddp-zone-QA': 146.19,
                      'passport-priority-ddp-zone-SA': 146.22,
                      'passport-priority-ddp-zone-AE': 146.53,
                      'passport-priority-ddp-zone-CN': 213.84,
                      'passport-priority-ddp-zone-HK': 140.75,
                      'passport-priority-ddp-zone-IN': 161.48,
                      'passport-priority-ddp-zone-JP': 196.14,
                      'passport-priority-ddp-zone-KR': 158.52,
                      'passport-priority-ddp-zone-NZ': 129.17,
                      'passport-priority-ddp-zone-SG': 140.75,
                      'passport-priority-ddp-zone-TH': 137.38,
                      'passport-priority-ddp-zone-GG': 189.84,
                      'passport-priority-ddp-zone-JE': 189.84,
                      'passport-priority-ddp-zone-NO': 125.34,
                      'passport-priority-ddp-zone-CH': 125.73,
                      'passport-priority-ddp-zone-IS': 114.05,
                      'passport-priority-ddp-zone-AI': 142.55,
                      'passport-priority-ddp-zone-AG': 142.55,
                      'passport-priority-ddp-zone-AR': 194.47,
                      'passport-priority-ddp-zone-AW': 142.55,
                      'passport-priority-ddp-zone-BS': 142.55,
                      'passport-priority-ddp-zone-BB': 157.67,
                      'passport-priority-ddp-zone-BZ': 190.97,
                      'passport-priority-ddp-zone-BM': 142.86,
                      'passport-priority-ddp-zone-BO': 196.61,
                      'passport-priority-ddp-zone-BR': 133.5,
                      'passport-priority-ddp-zone-KY': 142.55,
                      'passport-priority-ddp-zone-CL': 145.0,
                      'passport-priority-ddp-zone-CO': 133.5,
                      'passport-priority-ddp-zone-CR': 194.96,
                      'passport-priority-ddp-zone-DM': 142.55,
                      'passport-priority-ddp-zone-DO': 143.34,
                      'passport-priority-ddp-zone-EC': 195.2,
                      'passport-priority-ddp-zone-SV': 190.97,
                      'passport-priority-ddp-zone-GP': 176.59,
                      'passport-priority-ddp-zone-GT': 191.06,
                      'passport-priority-ddp-zone-GY': 190.97,
                      'passport-priority-ddp-zone-HT': 142.55,
                      'passport-priority-ddp-zone-JM': 162.98,
                      'passport-priority-ddp-zone-MQ': 153.9,
                      'passport-priority-ddp-zone-AN': 142.55,
                      'passport-priority-ddp-zone-NI': 194.36,
                      'passport-priority-ddp-zone-PA': 191.26,
                      'passport-priority-ddp-zone-PY': 190.97,
                      'passport-priority-ddp-zone-PE': 193.3,
                      'passport-priority-ddp-zone-SR': 190.97,
                      'passport-priority-ddp-zone-TT': 148.22,
                      'passport-priority-ddp-zone-UY': 190.97,
                      'passport-priority-ddp-zone-AF': 261.54,
                      'passport-priority-ddp-zone-DZ': 261.54,
                      'passport-priority-ddp-zone-BH': 231.25,
                      'passport-priority-ddp-zone-BD': 218.0,
                      'passport-priority-ddp-zone-BT': 218.0,
                      'passport-priority-ddp-zone-BA': 261.54,
                      'passport-priority-ddp-zone-BW': 261.54,
                      'passport-priority-ddp-zone-BN': 231.25,
                      'passport-priority-ddp-zone-BF': 261.54,
                      'passport-priority-ddp-zone-BI': 261.54,
                      'passport-priority-ddp-zone-KH': 261.54,
                      'passport-priority-ddp-zone-CM': 261.54,
                      'passport-priority-ddp-zone-CV': 261.54,
                      'passport-priority-ddp-zone-TD': 261.54,
                      'passport-priority-ddp-zone-CG': 261.54,
                      'passport-priority-ddp-zone-CI': 261.54,
                      'passport-priority-ddp-zone-EG': 231.25,
                      'passport-priority-ddp-zone-ET': 261.54,
                      'passport-priority-ddp-zone-GA': 261.54,
                      'passport-priority-ddp-zone-GM': 261.54,
                      'passport-priority-ddp-zone-GH': 261.54,
                      'passport-priority-ddp-zone-GN': 261.54,
                      'passport-priority-ddp-zone-ID': 217.78,
                      'passport-priority-ddp-zone-JO': 231.25,
                      'passport-priority-ddp-zone-KE': 261.54,
                      'passport-priority-ddp-zone-KW': 231.61,
                      'passport-priority-ddp-zone-LB': 231.25,
                      'passport-priority-ddp-zone-LI': 233.99,
                      'passport-priority-ddp-zone-MO': 216.58,
                      'passport-priority-ddp-zone-MG': 261.54,
                      'passport-priority-ddp-zone-MW': 261.54,
                      'passport-priority-ddp-zone-MY': 214.54,
                      'passport-priority-ddp-zone-MV': 218.0,
                      'passport-priority-ddp-zone-ML': 261.54,
                      'passport-priority-ddp-zone-MR': 261.54,
                      'passport-priority-ddp-zone-MU': 261.54,
                      'passport-priority-ddp-zone-MD': 261.54,
                      'passport-priority-ddp-zone-MA': 261.9,
                      'passport-priority-ddp-zone-MZ': 261.54,
                      'passport-priority-ddp-zone-NA': 261.54,
                      'passport-priority-ddp-zone-NP': 218.0,
                      'passport-priority-ddp-zone-NE': 261.54,
                      'passport-priority-ddp-zone-NG': 261.54,
                      'passport-priority-ddp-zone-PK': 218.0,
                      'passport-priority-ddp-zone-PH': 214.68,
                      'passport-priority-ddp-zone-RE': 261.54,
                      'passport-priority-ddp-zone-RW': 261.54,
                      'passport-priority-ddp-zone-SN': 261.54,
                      'passport-priority-ddp-zone-SC': 261.54,
                      'passport-priority-ddp-zone-ZA': 241.97,
                      'passport-priority-ddp-zone-LK': 218.0,
                      'passport-priority-ddp-zone-SZ': 261.54,
                      'passport-priority-ddp-zone-TW': 214.68,
                      'passport-priority-ddp-zone-TJ': 261.54,
                      'passport-priority-ddp-zone-TZ': 261.54,
                      'passport-priority-ddp-zone-TG': 261.54,
                      'passport-priority-ddp-zone-TN': 261.54,
                      'passport-priority-ddp-zone-TR': 231.31,
                      'passport-priority-ddp-zone-TM': 261.54,
                      'passport-priority-ddp-zone-UG': 261.54,
                      'passport-priority-ddp-zone-UA': 261.54,
                      'passport-priority-ddp-zone-VN': 214.88,
                      'passport-priority-ddp-zone-YE': 231.25,
                      'passport-priority-ddp-zone-ZM': 261.54,
                      'passport-priority-ddp-zone-ZW': 261.54,
                      'passport-priority-ddp-zone-MC': 97.84,
                      'passport-priority-ddp-zone-IM': 91.11,
                      'passport-priority-ddp-zone-SM': 97.84,
                    },
                    '21': {
                      'passport-priority-ddp-zone-CA': 50.81,
                      'passport-priority-ddp-zone-GB': 95.32,
                      'passport-priority-ddp-zone-AU': 136.52,
                      'passport-priority-ddp-zone-BE': 101.32,
                      'passport-priority-ddp-zone-DK': 101.32,
                      'passport-priority-ddp-zone-FR': 101.32,
                      'passport-priority-ddp-zone-DE': 101.32,
                      'passport-priority-ddp-zone-IT': 101.32,
                      'passport-priority-ddp-zone-NL': 101.32,
                      'passport-priority-ddp-zone-ES': 101.32,
                      'passport-priority-ddp-zone-MX': 123.37,
                      'passport-priority-ddp-zone-AM': 192.1,
                      'passport-priority-ddp-zone-AT': 108.88,
                      'passport-priority-ddp-zone-BG': 108.88,
                      'passport-priority-ddp-zone-HR': 108.88,
                      'passport-priority-ddp-zone-CY': 114.31,
                      'passport-priority-ddp-zone-CZ': 108.88,
                      'passport-priority-ddp-zone-EE': 108.88,
                      'passport-priority-ddp-zone-FI': 108.88,
                      'passport-priority-ddp-zone-GR': 112.78,
                      'passport-priority-ddp-zone-HU': 108.88,
                      'passport-priority-ddp-zone-IE': 108.88,
                      'passport-priority-ddp-zone-LV': 108.88,
                      'passport-priority-ddp-zone-LT': 108.88,
                      'passport-priority-ddp-zone-LU': 108.88,
                      'passport-priority-ddp-zone-MT': 114.31,
                      'passport-priority-ddp-zone-PL': 108.88,
                      'passport-priority-ddp-zone-PT': 108.88,
                      'passport-priority-ddp-zone-RO': 108.88,
                      'passport-priority-ddp-zone-SK': 108.88,
                      'passport-priority-ddp-zone-SI': 108.88,
                      'passport-priority-ddp-zone-SE': 108.88,
                      'passport-priority-ddp-zone-IL': 152.54,
                      'passport-priority-ddp-zone-OM': 159.64,
                      'passport-priority-ddp-zone-QA': 152.12,
                      'passport-priority-ddp-zone-SA': 152.15,
                      'passport-priority-ddp-zone-AE': 152.46,
                      'passport-priority-ddp-zone-CN': 223.27,
                      'passport-priority-ddp-zone-HK': 141.21,
                      'passport-priority-ddp-zone-IN': 163.32,
                      'passport-priority-ddp-zone-JP': 205.73,
                      'passport-priority-ddp-zone-KR': 165.67,
                      'passport-priority-ddp-zone-NZ': 135.33,
                      'passport-priority-ddp-zone-SG': 141.21,
                      'passport-priority-ddp-zone-TH': 143.48,
                      'passport-priority-ddp-zone-GG': 202.77,
                      'passport-priority-ddp-zone-JE': 202.77,
                      'passport-priority-ddp-zone-NO': 128.76,
                      'passport-priority-ddp-zone-CH': 129.17,
                      'passport-priority-ddp-zone-IS': 122.43,
                      'passport-priority-ddp-zone-AI': 148.8,
                      'passport-priority-ddp-zone-AG': 148.8,
                      'passport-priority-ddp-zone-AR': 201.92,
                      'passport-priority-ddp-zone-AW': 148.8,
                      'passport-priority-ddp-zone-BS': 148.8,
                      'passport-priority-ddp-zone-BB': 163.6,
                      'passport-priority-ddp-zone-BZ': 198.42,
                      'passport-priority-ddp-zone-BM': 149.1,
                      'passport-priority-ddp-zone-BO': 204.08,
                      'passport-priority-ddp-zone-BR': 139.69,
                      'passport-priority-ddp-zone-KY': 148.8,
                      'passport-priority-ddp-zone-CL': 152.13,
                      'passport-priority-ddp-zone-CO': 139.69,
                      'passport-priority-ddp-zone-CR': 202.41,
                      'passport-priority-ddp-zone-DM': 148.8,
                      'passport-priority-ddp-zone-DO': 149.59,
                      'passport-priority-ddp-zone-EC': 202.67,
                      'passport-priority-ddp-zone-SV': 198.42,
                      'passport-priority-ddp-zone-GP': 182.06,
                      'passport-priority-ddp-zone-GT': 198.52,
                      'passport-priority-ddp-zone-GY': 198.42,
                      'passport-priority-ddp-zone-HT': 148.8,
                      'passport-priority-ddp-zone-JM': 168.76,
                      'passport-priority-ddp-zone-MQ': 159.88,
                      'passport-priority-ddp-zone-AN': 148.8,
                      'passport-priority-ddp-zone-NI': 201.81,
                      'passport-priority-ddp-zone-PA': 198.71,
                      'passport-priority-ddp-zone-PY': 198.42,
                      'passport-priority-ddp-zone-PE': 200.77,
                      'passport-priority-ddp-zone-SR': 198.42,
                      'passport-priority-ddp-zone-TT': 154.33,
                      'passport-priority-ddp-zone-UY': 198.42,
                      'passport-priority-ddp-zone-AF': 264.31,
                      'passport-priority-ddp-zone-DZ': 264.31,
                      'passport-priority-ddp-zone-BH': 244.81,
                      'passport-priority-ddp-zone-BD': 232.24,
                      'passport-priority-ddp-zone-BT': 232.24,
                      'passport-priority-ddp-zone-BA': 264.31,
                      'passport-priority-ddp-zone-BW': 264.31,
                      'passport-priority-ddp-zone-BN': 244.81,
                      'passport-priority-ddp-zone-BF': 264.31,
                      'passport-priority-ddp-zone-BI': 264.31,
                      'passport-priority-ddp-zone-KH': 264.31,
                      'passport-priority-ddp-zone-CM': 264.31,
                      'passport-priority-ddp-zone-CV': 264.31,
                      'passport-priority-ddp-zone-TD': 264.31,
                      'passport-priority-ddp-zone-CG': 264.31,
                      'passport-priority-ddp-zone-CI': 264.31,
                      'passport-priority-ddp-zone-EG': 244.81,
                      'passport-priority-ddp-zone-ET': 264.31,
                      'passport-priority-ddp-zone-GA': 264.31,
                      'passport-priority-ddp-zone-GM': 264.31,
                      'passport-priority-ddp-zone-GH': 264.31,
                      'passport-priority-ddp-zone-GN': 264.31,
                      'passport-priority-ddp-zone-ID': 230.3,
                      'passport-priority-ddp-zone-JO': 244.81,
                      'passport-priority-ddp-zone-KE': 264.31,
                      'passport-priority-ddp-zone-KW': 245.17,
                      'passport-priority-ddp-zone-LB': 244.81,
                      'passport-priority-ddp-zone-LI': 238.5,
                      'passport-priority-ddp-zone-MO': 229.04,
                      'passport-priority-ddp-zone-MG': 264.31,
                      'passport-priority-ddp-zone-MW': 264.31,
                      'passport-priority-ddp-zone-MY': 228.47,
                      'passport-priority-ddp-zone-MV': 232.24,
                      'passport-priority-ddp-zone-ML': 264.31,
                      'passport-priority-ddp-zone-MR': 264.31,
                      'passport-priority-ddp-zone-MU': 264.31,
                      'passport-priority-ddp-zone-MD': 264.31,
                      'passport-priority-ddp-zone-MA': 264.62,
                      'passport-priority-ddp-zone-MZ': 264.31,
                      'passport-priority-ddp-zone-NA': 264.31,
                      'passport-priority-ddp-zone-NP': 232.24,
                      'passport-priority-ddp-zone-NE': 264.31,
                      'passport-priority-ddp-zone-NG': 264.31,
                      'passport-priority-ddp-zone-PK': 232.24,
                      'passport-priority-ddp-zone-PH': 228.62,
                      'passport-priority-ddp-zone-RE': 264.31,
                      'passport-priority-ddp-zone-RW': 264.31,
                      'passport-priority-ddp-zone-SN': 264.31,
                      'passport-priority-ddp-zone-SC': 264.31,
                      'passport-priority-ddp-zone-ZA': 256.51,
                      'passport-priority-ddp-zone-LK': 232.24,
                      'passport-priority-ddp-zone-SZ': 264.31,
                      'passport-priority-ddp-zone-TW': 228.62,
                      'passport-priority-ddp-zone-TJ': 264.31,
                      'passport-priority-ddp-zone-TZ': 264.31,
                      'passport-priority-ddp-zone-TG': 264.31,
                      'passport-priority-ddp-zone-TN': 264.31,
                      'passport-priority-ddp-zone-TR': 244.85,
                      'passport-priority-ddp-zone-TM': 264.31,
                      'passport-priority-ddp-zone-UG': 264.31,
                      'passport-priority-ddp-zone-UA': 264.31,
                      'passport-priority-ddp-zone-VN': 228.81,
                      'passport-priority-ddp-zone-YE': 244.81,
                      'passport-priority-ddp-zone-ZM': 264.31,
                      'passport-priority-ddp-zone-ZW': 264.31,
                      'passport-priority-ddp-zone-MC': 101.32,
                      'passport-priority-ddp-zone-IM': 95.32,
                      'passport-priority-ddp-zone-SM': 101.32,
                    },
                    '22': {
                      'passport-priority-ddp-zone-CA': 52.44,
                      'passport-priority-ddp-zone-GB': 99.5,
                      'passport-priority-ddp-zone-AU': 142.5,
                      'passport-priority-ddp-zone-BE': 104.78,
                      'passport-priority-ddp-zone-DK': 104.78,
                      'passport-priority-ddp-zone-FR': 104.78,
                      'passport-priority-ddp-zone-DE': 104.78,
                      'passport-priority-ddp-zone-IT': 104.78,
                      'passport-priority-ddp-zone-NL': 104.78,
                      'passport-priority-ddp-zone-ES': 104.78,
                      'passport-priority-ddp-zone-MX': 128.99,
                      'passport-priority-ddp-zone-AM': 194.33,
                      'passport-priority-ddp-zone-AT': 112.36,
                      'passport-priority-ddp-zone-BG': 112.36,
                      'passport-priority-ddp-zone-HR': 112.36,
                      'passport-priority-ddp-zone-CY': 118.08,
                      'passport-priority-ddp-zone-CZ': 112.36,
                      'passport-priority-ddp-zone-EE': 112.36,
                      'passport-priority-ddp-zone-FI': 112.36,
                      'passport-priority-ddp-zone-GR': 116.54,
                      'passport-priority-ddp-zone-HU': 112.36,
                      'passport-priority-ddp-zone-IE': 112.36,
                      'passport-priority-ddp-zone-LV': 112.36,
                      'passport-priority-ddp-zone-LT': 112.36,
                      'passport-priority-ddp-zone-LU': 112.36,
                      'passport-priority-ddp-zone-MT': 118.08,
                      'passport-priority-ddp-zone-PL': 112.36,
                      'passport-priority-ddp-zone-PT': 112.36,
                      'passport-priority-ddp-zone-RO': 112.36,
                      'passport-priority-ddp-zone-SK': 112.36,
                      'passport-priority-ddp-zone-SI': 112.36,
                      'passport-priority-ddp-zone-SE': 112.36,
                      'passport-priority-ddp-zone-IL': 155.5,
                      'passport-priority-ddp-zone-OM': 162.7,
                      'passport-priority-ddp-zone-QA': 155.07,
                      'passport-priority-ddp-zone-SA': 155.1,
                      'passport-priority-ddp-zone-AE': 155.42,
                      'passport-priority-ddp-zone-CN': 224.58,
                      'passport-priority-ddp-zone-HK': 142.85,
                      'passport-priority-ddp-zone-IN': 169.02,
                      'passport-priority-ddp-zone-JP': 207.03,
                      'passport-priority-ddp-zone-KR': 166.97,
                      'passport-priority-ddp-zone-NZ': 141.49,
                      'passport-priority-ddp-zone-SG': 142.85,
                      'passport-priority-ddp-zone-TH': 144.78,
                      'passport-priority-ddp-zone-GG': 205.1,
                      'passport-priority-ddp-zone-JE': 205.1,
                      'passport-priority-ddp-zone-NO': 129.53,
                      'passport-priority-ddp-zone-CH': 129.95,
                      'passport-priority-ddp-zone-IS': 123.46,
                      'passport-priority-ddp-zone-AI': 158.41,
                      'passport-priority-ddp-zone-AG': 158.41,
                      'passport-priority-ddp-zone-AR': 208.36,
                      'passport-priority-ddp-zone-AW': 158.41,
                      'passport-priority-ddp-zone-BS': 158.41,
                      'passport-priority-ddp-zone-BB': 173.32,
                      'passport-priority-ddp-zone-BZ': 204.86,
                      'passport-priority-ddp-zone-BM': 158.69,
                      'passport-priority-ddp-zone-BO': 210.51,
                      'passport-priority-ddp-zone-BR': 145.36,
                      'passport-priority-ddp-zone-KY': 158.41,
                      'passport-priority-ddp-zone-CL': 159.24,
                      'passport-priority-ddp-zone-CO': 145.36,
                      'passport-priority-ddp-zone-CR': 208.84,
                      'passport-priority-ddp-zone-DM': 158.41,
                      'passport-priority-ddp-zone-DO': 159.17,
                      'passport-priority-ddp-zone-EC': 209.1,
                      'passport-priority-ddp-zone-SV': 204.86,
                      'passport-priority-ddp-zone-GP': 191.98,
                      'passport-priority-ddp-zone-GT': 204.96,
                      'passport-priority-ddp-zone-GY': 204.86,
                      'passport-priority-ddp-zone-HT': 158.41,
                      'passport-priority-ddp-zone-JM': 178.56,
                      'passport-priority-ddp-zone-MQ': 169.59,
                      'passport-priority-ddp-zone-AN': 158.41,
                      'passport-priority-ddp-zone-NI': 208.24,
                      'passport-priority-ddp-zone-PA': 205.14,
                      'passport-priority-ddp-zone-PY': 204.86,
                      'passport-priority-ddp-zone-PE': 207.2,
                      'passport-priority-ddp-zone-SR': 204.86,
                      'passport-priority-ddp-zone-TT': 164.0,
                      'passport-priority-ddp-zone-UY': 204.86,
                      'passport-priority-ddp-zone-AF': 265.15,
                      'passport-priority-ddp-zone-DZ': 265.15,
                      'passport-priority-ddp-zone-BH': 246.78,
                      'passport-priority-ddp-zone-BD': 233.93,
                      'passport-priority-ddp-zone-BT': 233.93,
                      'passport-priority-ddp-zone-BA': 265.15,
                      'passport-priority-ddp-zone-BW': 265.15,
                      'passport-priority-ddp-zone-BN': 246.78,
                      'passport-priority-ddp-zone-BF': 265.15,
                      'passport-priority-ddp-zone-BI': 265.15,
                      'passport-priority-ddp-zone-KH': 265.15,
                      'passport-priority-ddp-zone-CM': 265.15,
                      'passport-priority-ddp-zone-CV': 265.15,
                      'passport-priority-ddp-zone-TD': 265.15,
                      'passport-priority-ddp-zone-CG': 265.15,
                      'passport-priority-ddp-zone-CI': 265.15,
                      'passport-priority-ddp-zone-EG': 246.78,
                      'passport-priority-ddp-zone-ET': 265.15,
                      'passport-priority-ddp-zone-GA': 265.15,
                      'passport-priority-ddp-zone-GM': 265.15,
                      'passport-priority-ddp-zone-GH': 265.15,
                      'passport-priority-ddp-zone-GN': 265.15,
                      'passport-priority-ddp-zone-ID': 232.41,
                      'passport-priority-ddp-zone-JO': 246.78,
                      'passport-priority-ddp-zone-KE': 265.15,
                      'passport-priority-ddp-zone-KW': 247.19,
                      'passport-priority-ddp-zone-LB': 246.78,
                      'passport-priority-ddp-zone-LI': 239.62,
                      'passport-priority-ddp-zone-MO': 231.14,
                      'passport-priority-ddp-zone-MG': 265.15,
                      'passport-priority-ddp-zone-MW': 265.15,
                      'passport-priority-ddp-zone-MY': 230.03,
                      'passport-priority-ddp-zone-MV': 233.93,
                      'passport-priority-ddp-zone-ML': 265.15,
                      'passport-priority-ddp-zone-MR': 265.15,
                      'passport-priority-ddp-zone-MU': 265.15,
                      'passport-priority-ddp-zone-MD': 265.15,
                      'passport-priority-ddp-zone-MA': 265.47,
                      'passport-priority-ddp-zone-MZ': 265.15,
                      'passport-priority-ddp-zone-NA': 265.15,
                      'passport-priority-ddp-zone-NP': 233.93,
                      'passport-priority-ddp-zone-NE': 265.15,
                      'passport-priority-ddp-zone-NG': 265.15,
                      'passport-priority-ddp-zone-PK': 233.93,
                      'passport-priority-ddp-zone-PH': 230.18,
                      'passport-priority-ddp-zone-RE': 265.15,
                      'passport-priority-ddp-zone-RW': 265.15,
                      'passport-priority-ddp-zone-SN': 265.15,
                      'passport-priority-ddp-zone-SC': 265.15,
                      'passport-priority-ddp-zone-ZA': 258.48,
                      'passport-priority-ddp-zone-LK': 233.93,
                      'passport-priority-ddp-zone-SZ': 265.15,
                      'passport-priority-ddp-zone-TW': 230.18,
                      'passport-priority-ddp-zone-TJ': 265.15,
                      'passport-priority-ddp-zone-TZ': 265.15,
                      'passport-priority-ddp-zone-TG': 265.15,
                      'passport-priority-ddp-zone-TN': 265.15,
                      'passport-priority-ddp-zone-TR': 246.83,
                      'passport-priority-ddp-zone-TM': 265.15,
                      'passport-priority-ddp-zone-UG': 265.15,
                      'passport-priority-ddp-zone-UA': 265.15,
                      'passport-priority-ddp-zone-VN': 230.37,
                      'passport-priority-ddp-zone-YE': 246.78,
                      'passport-priority-ddp-zone-ZM': 265.15,
                      'passport-priority-ddp-zone-ZW': 265.15,
                      'passport-priority-ddp-zone-MC': 104.78,
                      'passport-priority-ddp-zone-IM': 99.5,
                      'passport-priority-ddp-zone-SM': 104.78,
                    },
                    '23': {
                      'passport-priority-ddp-zone-CA': 54.42,
                      'passport-priority-ddp-zone-GB': 103.71,
                      'passport-priority-ddp-zone-AU': 148.47,
                      'passport-priority-ddp-zone-BE': 114.68,
                      'passport-priority-ddp-zone-DK': 114.68,
                      'passport-priority-ddp-zone-FR': 114.68,
                      'passport-priority-ddp-zone-DE': 114.68,
                      'passport-priority-ddp-zone-IT': 114.68,
                      'passport-priority-ddp-zone-NL': 114.68,
                      'passport-priority-ddp-zone-ES': 114.68,
                      'passport-priority-ddp-zone-MX': 134.64,
                      'passport-priority-ddp-zone-AM': 195.6,
                      'passport-priority-ddp-zone-AT': 117.32,
                      'passport-priority-ddp-zone-BG': 117.32,
                      'passport-priority-ddp-zone-HR': 117.32,
                      'passport-priority-ddp-zone-CY': 129.02,
                      'passport-priority-ddp-zone-CZ': 117.32,
                      'passport-priority-ddp-zone-EE': 117.32,
                      'passport-priority-ddp-zone-FI': 117.32,
                      'passport-priority-ddp-zone-GR': 127.29,
                      'passport-priority-ddp-zone-HU': 117.32,
                      'passport-priority-ddp-zone-IE': 117.32,
                      'passport-priority-ddp-zone-LV': 117.32,
                      'passport-priority-ddp-zone-LT': 117.32,
                      'passport-priority-ddp-zone-LU': 117.32,
                      'passport-priority-ddp-zone-MT': 129.02,
                      'passport-priority-ddp-zone-PL': 117.32,
                      'passport-priority-ddp-zone-PT': 117.32,
                      'passport-priority-ddp-zone-RO': 117.32,
                      'passport-priority-ddp-zone-SK': 117.32,
                      'passport-priority-ddp-zone-SI': 117.32,
                      'passport-priority-ddp-zone-SE': 117.32,
                      'passport-priority-ddp-zone-IL': 160.38,
                      'passport-priority-ddp-zone-OM': 167.78,
                      'passport-priority-ddp-zone-QA': 159.93,
                      'passport-priority-ddp-zone-SA': 159.95,
                      'passport-priority-ddp-zone-AE': 160.29,
                      'passport-priority-ddp-zone-CN': 233.46,
                      'passport-priority-ddp-zone-HK': 147.58,
                      'passport-priority-ddp-zone-IN': 174.54,
                      'passport-priority-ddp-zone-JP': 214.41,
                      'passport-priority-ddp-zone-KR': 173.76,
                      'passport-priority-ddp-zone-NZ': 149.09,
                      'passport-priority-ddp-zone-SG': 147.58,
                      'passport-priority-ddp-zone-TH': 150.88,
                      'passport-priority-ddp-zone-GG': 206.37,
                      'passport-priority-ddp-zone-JE': 206.37,
                      'passport-priority-ddp-zone-NO': 129.86,
                      'passport-priority-ddp-zone-CH': 130.29,
                      'passport-priority-ddp-zone-IS': 123.74,
                      'passport-priority-ddp-zone-AI': 161.06,
                      'passport-priority-ddp-zone-AG': 161.06,
                      'passport-priority-ddp-zone-AR': 210.04,
                      'passport-priority-ddp-zone-AW': 161.06,
                      'passport-priority-ddp-zone-BS': 161.06,
                      'passport-priority-ddp-zone-BB': 176.15,
                      'passport-priority-ddp-zone-BZ': 206.53,
                      'passport-priority-ddp-zone-BM': 161.37,
                      'passport-priority-ddp-zone-BO': 212.19,
                      'passport-priority-ddp-zone-BR': 151.02,
                      'passport-priority-ddp-zone-KY': 161.06,
                      'passport-priority-ddp-zone-CL': 166.36,
                      'passport-priority-ddp-zone-CO': 151.02,
                      'passport-priority-ddp-zone-CR': 210.53,
                      'passport-priority-ddp-zone-DM': 161.06,
                      'passport-priority-ddp-zone-DO': 161.85,
                      'passport-priority-ddp-zone-EC': 210.78,
                      'passport-priority-ddp-zone-SV': 206.53,
                      'passport-priority-ddp-zone-GP': 194.99,
                      'passport-priority-ddp-zone-GT': 206.63,
                      'passport-priority-ddp-zone-GY': 206.53,
                      'passport-priority-ddp-zone-HT': 161.06,
                      'passport-priority-ddp-zone-JM': 181.42,
                      'passport-priority-ddp-zone-MQ': 172.38,
                      'passport-priority-ddp-zone-AN': 161.06,
                      'passport-priority-ddp-zone-NI': 209.93,
                      'passport-priority-ddp-zone-PA': 206.83,
                      'passport-priority-ddp-zone-PY': 206.53,
                      'passport-priority-ddp-zone-PE': 208.88,
                      'passport-priority-ddp-zone-SR': 206.53,
                      'passport-priority-ddp-zone-TT': 166.72,
                      'passport-priority-ddp-zone-UY': 206.53,
                      'passport-priority-ddp-zone-AF': 267.87,
                      'passport-priority-ddp-zone-DZ': 267.87,
                      'passport-priority-ddp-zone-BH': 255.12,
                      'passport-priority-ddp-zone-BD': 241.88,
                      'passport-priority-ddp-zone-BT': 241.88,
                      'passport-priority-ddp-zone-BA': 267.87,
                      'passport-priority-ddp-zone-BW': 267.87,
                      'passport-priority-ddp-zone-BN': 255.12,
                      'passport-priority-ddp-zone-BF': 267.87,
                      'passport-priority-ddp-zone-BI': 267.87,
                      'passport-priority-ddp-zone-KH': 267.87,
                      'passport-priority-ddp-zone-CM': 267.87,
                      'passport-priority-ddp-zone-CV': 267.87,
                      'passport-priority-ddp-zone-TD': 267.87,
                      'passport-priority-ddp-zone-CG': 267.87,
                      'passport-priority-ddp-zone-CI': 267.87,
                      'passport-priority-ddp-zone-EG': 255.12,
                      'passport-priority-ddp-zone-ET': 267.87,
                      'passport-priority-ddp-zone-GA': 267.87,
                      'passport-priority-ddp-zone-GM': 267.87,
                      'passport-priority-ddp-zone-GH': 267.87,
                      'passport-priority-ddp-zone-GN': 267.87,
                      'passport-priority-ddp-zone-ID': 240.26,
                      'passport-priority-ddp-zone-JO': 255.12,
                      'passport-priority-ddp-zone-KE': 267.87,
                      'passport-priority-ddp-zone-KW': 255.54,
                      'passport-priority-ddp-zone-LB': 255.12,
                      'passport-priority-ddp-zone-LI': 247.71,
                      'passport-priority-ddp-zone-MO': 238.98,
                      'passport-priority-ddp-zone-MG': 267.87,
                      'passport-priority-ddp-zone-MW': 267.87,
                      'passport-priority-ddp-zone-MY': 237.76,
                      'passport-priority-ddp-zone-MV': 241.88,
                      'passport-priority-ddp-zone-ML': 267.87,
                      'passport-priority-ddp-zone-MR': 267.87,
                      'passport-priority-ddp-zone-MU': 267.87,
                      'passport-priority-ddp-zone-MD': 267.87,
                      'passport-priority-ddp-zone-MA': 268.18,
                      'passport-priority-ddp-zone-MZ': 267.87,
                      'passport-priority-ddp-zone-NA': 267.87,
                      'passport-priority-ddp-zone-NP': 241.88,
                      'passport-priority-ddp-zone-NE': 267.87,
                      'passport-priority-ddp-zone-NG': 267.87,
                      'passport-priority-ddp-zone-PK': 241.88,
                      'passport-priority-ddp-zone-PH': 237.91,
                      'passport-priority-ddp-zone-RE': 267.87,
                      'passport-priority-ddp-zone-RW': 267.87,
                      'passport-priority-ddp-zone-SN': 267.87,
                      'passport-priority-ddp-zone-SC': 267.87,
                      'passport-priority-ddp-zone-ZA': 263.26,
                      'passport-priority-ddp-zone-LK': 241.88,
                      'passport-priority-ddp-zone-SZ': 267.87,
                      'passport-priority-ddp-zone-TW': 237.91,
                      'passport-priority-ddp-zone-TJ': 267.87,
                      'passport-priority-ddp-zone-TZ': 267.87,
                      'passport-priority-ddp-zone-TG': 267.87,
                      'passport-priority-ddp-zone-TN': 267.87,
                      'passport-priority-ddp-zone-TR': 255.16,
                      'passport-priority-ddp-zone-TM': 267.87,
                      'passport-priority-ddp-zone-UG': 267.87,
                      'passport-priority-ddp-zone-UA': 267.87,
                      'passport-priority-ddp-zone-VN': 238.11,
                      'passport-priority-ddp-zone-YE': 255.12,
                      'passport-priority-ddp-zone-ZM': 267.87,
                      'passport-priority-ddp-zone-ZW': 267.87,
                      'passport-priority-ddp-zone-MC': 114.68,
                      'passport-priority-ddp-zone-IM': 103.71,
                      'passport-priority-ddp-zone-SM': 114.68,
                    },
                    '24': {
                      'passport-priority-ddp-zone-CA': 56.4,
                      'passport-priority-ddp-zone-GB': 107.91,
                      'passport-priority-ddp-zone-AU': 154.46,
                      'passport-priority-ddp-zone-BE': 118.14,
                      'passport-priority-ddp-zone-DK': 118.14,
                      'passport-priority-ddp-zone-FR': 118.14,
                      'passport-priority-ddp-zone-DE': 118.14,
                      'passport-priority-ddp-zone-IT': 118.14,
                      'passport-priority-ddp-zone-NL': 118.14,
                      'passport-priority-ddp-zone-ES': 118.14,
                      'passport-priority-ddp-zone-MX': 140.22,
                      'passport-priority-ddp-zone-AM': 196.82,
                      'passport-priority-ddp-zone-AT': 120.28,
                      'passport-priority-ddp-zone-BG': 120.28,
                      'passport-priority-ddp-zone-HR': 120.28,
                      'passport-priority-ddp-zone-CY': 132.79,
                      'passport-priority-ddp-zone-CZ': 120.28,
                      'passport-priority-ddp-zone-EE': 120.28,
                      'passport-priority-ddp-zone-FI': 120.28,
                      'passport-priority-ddp-zone-GR': 131.06,
                      'passport-priority-ddp-zone-HU': 120.28,
                      'passport-priority-ddp-zone-IE': 120.28,
                      'passport-priority-ddp-zone-LV': 120.28,
                      'passport-priority-ddp-zone-LT': 120.28,
                      'passport-priority-ddp-zone-LU': 120.28,
                      'passport-priority-ddp-zone-MT': 132.79,
                      'passport-priority-ddp-zone-PL': 120.28,
                      'passport-priority-ddp-zone-PT': 120.28,
                      'passport-priority-ddp-zone-RO': 120.28,
                      'passport-priority-ddp-zone-SK': 120.28,
                      'passport-priority-ddp-zone-SI': 120.28,
                      'passport-priority-ddp-zone-SE': 120.28,
                      'passport-priority-ddp-zone-IL': 163.1,
                      'passport-priority-ddp-zone-OM': 170.61,
                      'passport-priority-ddp-zone-QA': 162.64,
                      'passport-priority-ddp-zone-SA': 162.67,
                      'passport-priority-ddp-zone-AE': 163.01,
                      'passport-priority-ddp-zone-CN': 242.32,
                      'passport-priority-ddp-zone-HK': 152.36,
                      'passport-priority-ddp-zone-IN': 180.04,
                      'passport-priority-ddp-zone-JP': 221.79,
                      'passport-priority-ddp-zone-KR': 180.54,
                      'passport-priority-ddp-zone-NZ': 155.26,
                      'passport-priority-ddp-zone-SG': 152.36,
                      'passport-priority-ddp-zone-TH': 156.99,
                      'passport-priority-ddp-zone-GG': 207.62,
                      'passport-priority-ddp-zone-JE': 207.62,
                      'passport-priority-ddp-zone-NO': 130.33,
                      'passport-priority-ddp-zone-CH': 130.72,
                      'passport-priority-ddp-zone-IS': 124.07,
                      'passport-priority-ddp-zone-AI': 165.38,
                      'passport-priority-ddp-zone-AG': 165.38,
                      'passport-priority-ddp-zone-AR': 215.53,
                      'passport-priority-ddp-zone-AW': 165.38,
                      'passport-priority-ddp-zone-BS': 165.38,
                      'passport-priority-ddp-zone-BB': 180.82,
                      'passport-priority-ddp-zone-BZ': 212.03,
                      'passport-priority-ddp-zone-BM': 165.7,
                      'passport-priority-ddp-zone-BO': 217.69,
                      'passport-priority-ddp-zone-BR': 156.68,
                      'passport-priority-ddp-zone-KY': 165.38,
                      'passport-priority-ddp-zone-CL': 173.48,
                      'passport-priority-ddp-zone-CO': 156.68,
                      'passport-priority-ddp-zone-CR': 216.02,
                      'passport-priority-ddp-zone-DM': 165.38,
                      'passport-priority-ddp-zone-DO': 166.2,
                      'passport-priority-ddp-zone-EC': 216.28,
                      'passport-priority-ddp-zone-SV': 212.03,
                      'passport-priority-ddp-zone-GP': 200.09,
                      'passport-priority-ddp-zone-GT': 212.13,
                      'passport-priority-ddp-zone-GY': 212.03,
                      'passport-priority-ddp-zone-HT': 165.38,
                      'passport-priority-ddp-zone-JM': 186.19,
                      'passport-priority-ddp-zone-MQ': 176.95,
                      'passport-priority-ddp-zone-AN': 165.38,
                      'passport-priority-ddp-zone-NI': 215.42,
                      'passport-priority-ddp-zone-PA': 212.32,
                      'passport-priority-ddp-zone-PY': 212.03,
                      'passport-priority-ddp-zone-PE': 214.38,
                      'passport-priority-ddp-zone-SR': 212.03,
                      'passport-priority-ddp-zone-TT': 171.16,
                      'passport-priority-ddp-zone-UY': 212.03,
                      'passport-priority-ddp-zone-AF': 268.63,
                      'passport-priority-ddp-zone-DZ': 268.63,
                      'passport-priority-ddp-zone-BH': 256.3,
                      'passport-priority-ddp-zone-BD': 243.05,
                      'passport-priority-ddp-zone-BT': 243.05,
                      'passport-priority-ddp-zone-BA': 268.63,
                      'passport-priority-ddp-zone-BW': 268.63,
                      'passport-priority-ddp-zone-BN': 256.3,
                      'passport-priority-ddp-zone-BF': 268.63,
                      'passport-priority-ddp-zone-BI': 268.63,
                      'passport-priority-ddp-zone-KH': 268.63,
                      'passport-priority-ddp-zone-CM': 268.63,
                      'passport-priority-ddp-zone-CV': 268.63,
                      'passport-priority-ddp-zone-TD': 268.63,
                      'passport-priority-ddp-zone-CG': 268.63,
                      'passport-priority-ddp-zone-CI': 268.63,
                      'passport-priority-ddp-zone-EG': 256.3,
                      'passport-priority-ddp-zone-ET': 268.63,
                      'passport-priority-ddp-zone-GA': 268.63,
                      'passport-priority-ddp-zone-GM': 268.63,
                      'passport-priority-ddp-zone-GH': 268.63,
                      'passport-priority-ddp-zone-GN': 268.63,
                      'passport-priority-ddp-zone-ID': 241.42,
                      'passport-priority-ddp-zone-JO': 256.3,
                      'passport-priority-ddp-zone-KE': 268.63,
                      'passport-priority-ddp-zone-KW': 256.67,
                      'passport-priority-ddp-zone-LB': 256.3,
                      'passport-priority-ddp-zone-LI': 248.88,
                      'passport-priority-ddp-zone-MO': 240.13,
                      'passport-priority-ddp-zone-MG': 268.63,
                      'passport-priority-ddp-zone-MW': 268.63,
                      'passport-priority-ddp-zone-MY': 238.73,
                      'passport-priority-ddp-zone-MV': 243.05,
                      'passport-priority-ddp-zone-ML': 268.63,
                      'passport-priority-ddp-zone-MR': 268.63,
                      'passport-priority-ddp-zone-MU': 268.63,
                      'passport-priority-ddp-zone-MD': 268.63,
                      'passport-priority-ddp-zone-MA': 268.96,
                      'passport-priority-ddp-zone-MZ': 268.63,
                      'passport-priority-ddp-zone-NA': 268.63,
                      'passport-priority-ddp-zone-NP': 243.05,
                      'passport-priority-ddp-zone-NE': 268.63,
                      'passport-priority-ddp-zone-NG': 268.63,
                      'passport-priority-ddp-zone-PK': 243.05,
                      'passport-priority-ddp-zone-PH': 238.86,
                      'passport-priority-ddp-zone-RE': 268.63,
                      'passport-priority-ddp-zone-RW': 268.63,
                      'passport-priority-ddp-zone-SN': 268.63,
                      'passport-priority-ddp-zone-SC': 268.63,
                      'passport-priority-ddp-zone-ZA': 264.35,
                      'passport-priority-ddp-zone-LK': 243.05,
                      'passport-priority-ddp-zone-SZ': 268.63,
                      'passport-priority-ddp-zone-TW': 238.86,
                      'passport-priority-ddp-zone-TJ': 268.63,
                      'passport-priority-ddp-zone-TZ': 268.63,
                      'passport-priority-ddp-zone-TG': 268.63,
                      'passport-priority-ddp-zone-TN': 268.63,
                      'passport-priority-ddp-zone-TR': 256.34,
                      'passport-priority-ddp-zone-TM': 268.63,
                      'passport-priority-ddp-zone-UG': 268.63,
                      'passport-priority-ddp-zone-UA': 268.63,
                      'passport-priority-ddp-zone-VN': 239.06,
                      'passport-priority-ddp-zone-YE': 256.3,
                      'passport-priority-ddp-zone-ZM': 268.63,
                      'passport-priority-ddp-zone-ZW': 268.63,
                      'passport-priority-ddp-zone-MC': 118.14,
                      'passport-priority-ddp-zone-IM': 107.91,
                      'passport-priority-ddp-zone-SM': 118.14,
                    },
                    '25': {
                      'passport-priority-ddp-zone-CA': 58.37,
                      'passport-priority-ddp-zone-GB': 112.11,
                      'passport-priority-ddp-zone-AU': 160.42,
                      'passport-priority-ddp-zone-BE': 121.62,
                      'passport-priority-ddp-zone-DK': 121.62,
                      'passport-priority-ddp-zone-FR': 121.62,
                      'passport-priority-ddp-zone-DE': 121.62,
                      'passport-priority-ddp-zone-IT': 121.62,
                      'passport-priority-ddp-zone-NL': 121.62,
                      'passport-priority-ddp-zone-ES': 121.62,
                      'passport-priority-ddp-zone-MX': 145.85,
                      'passport-priority-ddp-zone-AM': 199.32,
                      'passport-priority-ddp-zone-AT': 123.57,
                      'passport-priority-ddp-zone-BG': 123.57,
                      'passport-priority-ddp-zone-HR': 123.57,
                      'passport-priority-ddp-zone-CY': 136.56,
                      'passport-priority-ddp-zone-CZ': 123.57,
                      'passport-priority-ddp-zone-EE': 123.57,
                      'passport-priority-ddp-zone-FI': 123.57,
                      'passport-priority-ddp-zone-GR': 134.82,
                      'passport-priority-ddp-zone-HU': 123.57,
                      'passport-priority-ddp-zone-IE': 123.57,
                      'passport-priority-ddp-zone-LV': 123.57,
                      'passport-priority-ddp-zone-LT': 123.57,
                      'passport-priority-ddp-zone-LU': 123.57,
                      'passport-priority-ddp-zone-MT': 136.56,
                      'passport-priority-ddp-zone-PL': 123.57,
                      'passport-priority-ddp-zone-PT': 123.57,
                      'passport-priority-ddp-zone-RO': 123.57,
                      'passport-priority-ddp-zone-SK': 123.57,
                      'passport-priority-ddp-zone-SI': 123.57,
                      'passport-priority-ddp-zone-SE': 123.57,
                      'passport-priority-ddp-zone-IL': 169.13,
                      'passport-priority-ddp-zone-OM': 176.81,
                      'passport-priority-ddp-zone-QA': 168.67,
                      'passport-priority-ddp-zone-SA': 168.69,
                      'passport-priority-ddp-zone-AE': 169.02,
                      'passport-priority-ddp-zone-CN': 251.2,
                      'passport-priority-ddp-zone-HK': 158.49,
                      'passport-priority-ddp-zone-IN': 185.96,
                      'passport-priority-ddp-zone-JP': 229.17,
                      'passport-priority-ddp-zone-KR': 187.33,
                      'passport-priority-ddp-zone-NZ': 161.41,
                      'passport-priority-ddp-zone-SG': 158.49,
                      'passport-priority-ddp-zone-TH': 163.09,
                      'passport-priority-ddp-zone-GG': 210.68,
                      'passport-priority-ddp-zone-JE': 210.68,
                      'passport-priority-ddp-zone-NO': 133.58,
                      'passport-priority-ddp-zone-CH': 133.99,
                      'passport-priority-ddp-zone-IS': 126.22,
                      'passport-priority-ddp-zone-AI': 171.68,
                      'passport-priority-ddp-zone-AG': 171.68,
                      'passport-priority-ddp-zone-AR': 218.63,
                      'passport-priority-ddp-zone-AW': 171.68,
                      'passport-priority-ddp-zone-BS': 171.68,
                      'passport-priority-ddp-zone-BB': 187.58,
                      'passport-priority-ddp-zone-BZ': 215.13,
                      'passport-priority-ddp-zone-BM': 171.99,
                      'passport-priority-ddp-zone-BO': 220.79,
                      'passport-priority-ddp-zone-BR': 162.34,
                      'passport-priority-ddp-zone-KY': 171.68,
                      'passport-priority-ddp-zone-CL': 180.59,
                      'passport-priority-ddp-zone-CO': 162.34,
                      'passport-priority-ddp-zone-CR': 219.12,
                      'passport-priority-ddp-zone-DM': 171.68,
                      'passport-priority-ddp-zone-DO': 172.51,
                      'passport-priority-ddp-zone-EC': 219.38,
                      'passport-priority-ddp-zone-SV': 215.13,
                      'passport-priority-ddp-zone-GP': 207.42,
                      'passport-priority-ddp-zone-GT': 215.23,
                      'passport-priority-ddp-zone-GY': 215.13,
                      'passport-priority-ddp-zone-HT': 171.68,
                      'passport-priority-ddp-zone-JM': 193.12,
                      'passport-priority-ddp-zone-MQ': 183.6,
                      'passport-priority-ddp-zone-AN': 171.68,
                      'passport-priority-ddp-zone-NI': 218.52,
                      'passport-priority-ddp-zone-PA': 215.42,
                      'passport-priority-ddp-zone-PY': 215.13,
                      'passport-priority-ddp-zone-PE': 217.48,
                      'passport-priority-ddp-zone-SR': 215.13,
                      'passport-priority-ddp-zone-TT': 177.64,
                      'passport-priority-ddp-zone-UY': 215.13,
                      'passport-priority-ddp-zone-AF': 269.52,
                      'passport-priority-ddp-zone-DZ': 269.52,
                      'passport-priority-ddp-zone-BH': 258.72,
                      'passport-priority-ddp-zone-BD': 246.9,
                      'passport-priority-ddp-zone-BT': 246.9,
                      'passport-priority-ddp-zone-BA': 269.52,
                      'passport-priority-ddp-zone-BW': 269.52,
                      'passport-priority-ddp-zone-BN': 258.72,
                      'passport-priority-ddp-zone-BF': 269.52,
                      'passport-priority-ddp-zone-BI': 269.52,
                      'passport-priority-ddp-zone-KH': 269.52,
                      'passport-priority-ddp-zone-CM': 269.52,
                      'passport-priority-ddp-zone-CV': 269.52,
                      'passport-priority-ddp-zone-TD': 269.52,
                      'passport-priority-ddp-zone-CG': 269.52,
                      'passport-priority-ddp-zone-CI': 269.52,
                      'passport-priority-ddp-zone-EG': 258.72,
                      'passport-priority-ddp-zone-ET': 269.52,
                      'passport-priority-ddp-zone-GA': 269.52,
                      'passport-priority-ddp-zone-GM': 269.52,
                      'passport-priority-ddp-zone-GH': 269.52,
                      'passport-priority-ddp-zone-GN': 269.52,
                      'passport-priority-ddp-zone-ID': 246.9,
                      'passport-priority-ddp-zone-JO': 258.72,
                      'passport-priority-ddp-zone-KE': 269.52,
                      'passport-priority-ddp-zone-KW': 259.1,
                      'passport-priority-ddp-zone-LB': 258.72,
                      'passport-priority-ddp-zone-LI': 252.18,
                      'passport-priority-ddp-zone-MO': 245.6,
                      'passport-priority-ddp-zone-MG': 269.52,
                      'passport-priority-ddp-zone-MW': 269.52,
                      'passport-priority-ddp-zone-MY': 240.07,
                      'passport-priority-ddp-zone-MV': 246.9,
                      'passport-priority-ddp-zone-ML': 269.52,
                      'passport-priority-ddp-zone-MR': 269.52,
                      'passport-priority-ddp-zone-MU': 269.52,
                      'passport-priority-ddp-zone-MD': 269.52,
                      'passport-priority-ddp-zone-MA': 269.85,
                      'passport-priority-ddp-zone-MZ': 269.52,
                      'passport-priority-ddp-zone-NA': 269.52,
                      'passport-priority-ddp-zone-NP': 246.9,
                      'passport-priority-ddp-zone-NE': 269.52,
                      'passport-priority-ddp-zone-NG': 269.52,
                      'passport-priority-ddp-zone-PK': 246.9,
                      'passport-priority-ddp-zone-PH': 240.2,
                      'passport-priority-ddp-zone-RE': 269.52,
                      'passport-priority-ddp-zone-RW': 269.52,
                      'passport-priority-ddp-zone-SN': 269.52,
                      'passport-priority-ddp-zone-SC': 269.52,
                      'passport-priority-ddp-zone-ZA': 265.97,
                      'passport-priority-ddp-zone-LK': 246.9,
                      'passport-priority-ddp-zone-SZ': 269.52,
                      'passport-priority-ddp-zone-TW': 240.2,
                      'passport-priority-ddp-zone-TJ': 269.52,
                      'passport-priority-ddp-zone-TZ': 269.52,
                      'passport-priority-ddp-zone-TG': 269.52,
                      'passport-priority-ddp-zone-TN': 269.52,
                      'passport-priority-ddp-zone-TR': 258.74,
                      'passport-priority-ddp-zone-TM': 269.52,
                      'passport-priority-ddp-zone-UG': 269.52,
                      'passport-priority-ddp-zone-UA': 269.52,
                      'passport-priority-ddp-zone-VN': 240.4,
                      'passport-priority-ddp-zone-YE': 258.72,
                      'passport-priority-ddp-zone-ZM': 269.52,
                      'passport-priority-ddp-zone-ZW': 269.52,
                      'passport-priority-ddp-zone-MC': 121.62,
                      'passport-priority-ddp-zone-IM': 112.11,
                      'passport-priority-ddp-zone-SM': 121.62,
                    },
                    '26': {
                      'passport-priority-ddp-zone-CA': 60.34,
                      'passport-priority-ddp-zone-GB': 116.32,
                      'passport-priority-ddp-zone-AU': 166.41,
                      'passport-priority-ddp-zone-BE': 125.1,
                      'passport-priority-ddp-zone-DK': 125.1,
                      'passport-priority-ddp-zone-FR': 125.1,
                      'passport-priority-ddp-zone-DE': 125.1,
                      'passport-priority-ddp-zone-IT': 125.1,
                      'passport-priority-ddp-zone-NL': 125.1,
                      'passport-priority-ddp-zone-ES': 125.1,
                      'passport-priority-ddp-zone-MX': 151.49,
                      'passport-priority-ddp-zone-AM': 227.3,
                      'passport-priority-ddp-zone-AT': 128.22,
                      'passport-priority-ddp-zone-BG': 128.22,
                      'passport-priority-ddp-zone-HR': 128.22,
                      'passport-priority-ddp-zone-CY': 140.32,
                      'passport-priority-ddp-zone-CZ': 128.22,
                      'passport-priority-ddp-zone-EE': 128.22,
                      'passport-priority-ddp-zone-FI': 128.22,
                      'passport-priority-ddp-zone-GR': 138.59,
                      'passport-priority-ddp-zone-HU': 128.22,
                      'passport-priority-ddp-zone-IE': 128.22,
                      'passport-priority-ddp-zone-LV': 128.22,
                      'passport-priority-ddp-zone-LT': 128.22,
                      'passport-priority-ddp-zone-LU': 128.22,
                      'passport-priority-ddp-zone-MT': 140.32,
                      'passport-priority-ddp-zone-PL': 128.22,
                      'passport-priority-ddp-zone-PT': 128.22,
                      'passport-priority-ddp-zone-RO': 128.22,
                      'passport-priority-ddp-zone-SK': 128.22,
                      'passport-priority-ddp-zone-SI': 128.22,
                      'passport-priority-ddp-zone-SE': 128.22,
                      'passport-priority-ddp-zone-IL': 182.6,
                      'passport-priority-ddp-zone-OM': 189.66,
                      'passport-priority-ddp-zone-QA': 182.17,
                      'passport-priority-ddp-zone-SA': 182.2,
                      'passport-priority-ddp-zone-AE': 182.51,
                      'passport-priority-ddp-zone-CN': 260.08,
                      'passport-priority-ddp-zone-HK': 178.65,
                      'passport-priority-ddp-zone-IN': 204.83,
                      'passport-priority-ddp-zone-JP': 236.53,
                      'passport-priority-ddp-zone-KR': 194.11,
                      'passport-priority-ddp-zone-NZ': 167.57,
                      'passport-priority-ddp-zone-SG': 178.65,
                      'passport-priority-ddp-zone-TH': 169.19,
                      'passport-priority-ddp-zone-GG': 238.68,
                      'passport-priority-ddp-zone-JE': 238.68,
                      'passport-priority-ddp-zone-NO': 177.1,
                      'passport-priority-ddp-zone-CH': 177.52,
                      'passport-priority-ddp-zone-IS': 159.7,
                      'passport-priority-ddp-zone-AI': 184.29,
                      'passport-priority-ddp-zone-AG': 184.29,
                      'passport-priority-ddp-zone-AR': 234.58,
                      'passport-priority-ddp-zone-AW': 184.29,
                      'passport-priority-ddp-zone-BS': 184.29,
                      'passport-priority-ddp-zone-BB': 199.62,
                      'passport-priority-ddp-zone-BZ': 231.07,
                      'passport-priority-ddp-zone-BM': 184.61,
                      'passport-priority-ddp-zone-BO': 236.72,
                      'passport-priority-ddp-zone-BR': 168.0,
                      'passport-priority-ddp-zone-KY': 184.29,
                      'passport-priority-ddp-zone-CL': 187.7,
                      'passport-priority-ddp-zone-CO': 168.0,
                      'passport-priority-ddp-zone-CR': 235.07,
                      'passport-priority-ddp-zone-DM': 184.29,
                      'passport-priority-ddp-zone-DO': 185.1,
                      'passport-priority-ddp-zone-EC': 235.31,
                      'passport-priority-ddp-zone-SV': 231.07,
                      'passport-priority-ddp-zone-GP': 218.74,
                      'passport-priority-ddp-zone-GT': 231.17,
                      'passport-priority-ddp-zone-GY': 231.07,
                      'passport-priority-ddp-zone-HT': 184.29,
                      'passport-priority-ddp-zone-JM': 204.96,
                      'passport-priority-ddp-zone-MQ': 195.77,
                      'passport-priority-ddp-zone-AN': 184.29,
                      'passport-priority-ddp-zone-NI': 234.47,
                      'passport-priority-ddp-zone-PA': 231.37,
                      'passport-priority-ddp-zone-PY': 231.07,
                      'passport-priority-ddp-zone-PE': 233.41,
                      'passport-priority-ddp-zone-SR': 231.07,
                      'passport-priority-ddp-zone-TT': 190.05,
                      'passport-priority-ddp-zone-UY': 231.07,
                      'passport-priority-ddp-zone-AF': 296.42,
                      'passport-priority-ddp-zone-DZ': 296.42,
                      'passport-priority-ddp-zone-BH': 288.87,
                      'passport-priority-ddp-zone-BD': 272.2,
                      'passport-priority-ddp-zone-BT': 272.2,
                      'passport-priority-ddp-zone-BA': 296.42,
                      'passport-priority-ddp-zone-BW': 296.42,
                      'passport-priority-ddp-zone-BN': 288.87,
                      'passport-priority-ddp-zone-BF': 296.42,
                      'passport-priority-ddp-zone-BI': 296.42,
                      'passport-priority-ddp-zone-KH': 296.42,
                      'passport-priority-ddp-zone-CM': 296.42,
                      'passport-priority-ddp-zone-CV': 296.42,
                      'passport-priority-ddp-zone-TD': 296.42,
                      'passport-priority-ddp-zone-CG': 296.42,
                      'passport-priority-ddp-zone-CI': 296.42,
                      'passport-priority-ddp-zone-EG': 288.87,
                      'passport-priority-ddp-zone-ET': 296.42,
                      'passport-priority-ddp-zone-GA': 296.42,
                      'passport-priority-ddp-zone-GM': 296.42,
                      'passport-priority-ddp-zone-GH': 296.42,
                      'passport-priority-ddp-zone-GN': 296.42,
                      'passport-priority-ddp-zone-ID': 288.11,
                      'passport-priority-ddp-zone-JO': 288.87,
                      'passport-priority-ddp-zone-KE': 296.42,
                      'passport-priority-ddp-zone-KW': 289.26,
                      'passport-priority-ddp-zone-LB': 288.87,
                      'passport-priority-ddp-zone-LI': 288.85,
                      'passport-priority-ddp-zone-MO': 286.94,
                      'passport-priority-ddp-zone-MG': 296.42,
                      'passport-priority-ddp-zone-MW': 296.42,
                      'passport-priority-ddp-zone-MY': 262.08,
                      'passport-priority-ddp-zone-MV': 272.2,
                      'passport-priority-ddp-zone-ML': 296.42,
                      'passport-priority-ddp-zone-MR': 296.42,
                      'passport-priority-ddp-zone-MU': 296.42,
                      'passport-priority-ddp-zone-MD': 296.42,
                      'passport-priority-ddp-zone-MA': 296.71,
                      'passport-priority-ddp-zone-MZ': 296.42,
                      'passport-priority-ddp-zone-NA': 296.42,
                      'passport-priority-ddp-zone-NP': 272.2,
                      'passport-priority-ddp-zone-NE': 296.42,
                      'passport-priority-ddp-zone-NG': 296.42,
                      'passport-priority-ddp-zone-PK': 272.2,
                      'passport-priority-ddp-zone-PH': 262.23,
                      'passport-priority-ddp-zone-RE': 296.42,
                      'passport-priority-ddp-zone-RW': 296.42,
                      'passport-priority-ddp-zone-SN': 296.42,
                      'passport-priority-ddp-zone-SC': 296.42,
                      'passport-priority-ddp-zone-ZA': 306.12,
                      'passport-priority-ddp-zone-LK': 272.2,
                      'passport-priority-ddp-zone-SZ': 296.42,
                      'passport-priority-ddp-zone-TW': 262.23,
                      'passport-priority-ddp-zone-TJ': 296.42,
                      'passport-priority-ddp-zone-TZ': 296.42,
                      'passport-priority-ddp-zone-TG': 296.42,
                      'passport-priority-ddp-zone-TN': 296.42,
                      'passport-priority-ddp-zone-TR': 288.92,
                      'passport-priority-ddp-zone-TM': 296.42,
                      'passport-priority-ddp-zone-UG': 296.42,
                      'passport-priority-ddp-zone-UA': 296.42,
                      'passport-priority-ddp-zone-VN': 262.45,
                      'passport-priority-ddp-zone-YE': 288.87,
                      'passport-priority-ddp-zone-ZM': 296.42,
                      'passport-priority-ddp-zone-ZW': 296.42,
                      'passport-priority-ddp-zone-MC': 125.1,
                      'passport-priority-ddp-zone-IM': 116.32,
                      'passport-priority-ddp-zone-SM': 125.1,
                    },
                    '27': {
                      'passport-priority-ddp-zone-CA': 62.32,
                      'passport-priority-ddp-zone-GB': 120.52,
                      'passport-priority-ddp-zone-AU': 172.37,
                      'passport-priority-ddp-zone-BE': 128.58,
                      'passport-priority-ddp-zone-DK': 128.58,
                      'passport-priority-ddp-zone-FR': 128.58,
                      'passport-priority-ddp-zone-DE': 128.58,
                      'passport-priority-ddp-zone-IT': 128.58,
                      'passport-priority-ddp-zone-NL': 128.58,
                      'passport-priority-ddp-zone-ES': 128.58,
                      'passport-priority-ddp-zone-MX': 157.13,
                      'passport-priority-ddp-zone-AM': 252.56,
                      'passport-priority-ddp-zone-AT': 131.69,
                      'passport-priority-ddp-zone-BG': 131.69,
                      'passport-priority-ddp-zone-HR': 131.69,
                      'passport-priority-ddp-zone-CY': 144.09,
                      'passport-priority-ddp-zone-CZ': 131.69,
                      'passport-priority-ddp-zone-EE': 131.69,
                      'passport-priority-ddp-zone-FI': 131.69,
                      'passport-priority-ddp-zone-GR': 142.36,
                      'passport-priority-ddp-zone-HU': 131.69,
                      'passport-priority-ddp-zone-IE': 131.69,
                      'passport-priority-ddp-zone-LV': 131.69,
                      'passport-priority-ddp-zone-LT': 131.69,
                      'passport-priority-ddp-zone-LU': 131.69,
                      'passport-priority-ddp-zone-MT': 144.09,
                      'passport-priority-ddp-zone-PL': 131.69,
                      'passport-priority-ddp-zone-PT': 131.69,
                      'passport-priority-ddp-zone-RO': 131.69,
                      'passport-priority-ddp-zone-SK': 131.69,
                      'passport-priority-ddp-zone-SI': 131.69,
                      'passport-priority-ddp-zone-SE': 131.69,
                      'passport-priority-ddp-zone-IL': 190.01,
                      'passport-priority-ddp-zone-OM': 197.0,
                      'passport-priority-ddp-zone-QA': 189.58,
                      'passport-priority-ddp-zone-SA': 189.61,
                      'passport-priority-ddp-zone-AE': 189.92,
                      'passport-priority-ddp-zone-CN': 268.96,
                      'passport-priority-ddp-zone-HK': 183.5,
                      'passport-priority-ddp-zone-IN': 209.87,
                      'passport-priority-ddp-zone-JP': 243.91,
                      'passport-priority-ddp-zone-KR': 200.9,
                      'passport-priority-ddp-zone-NZ': 173.72,
                      'passport-priority-ddp-zone-SG': 183.5,
                      'passport-priority-ddp-zone-TH': 175.3,
                      'passport-priority-ddp-zone-GG': 242.52,
                      'passport-priority-ddp-zone-JE': 242.52,
                      'passport-priority-ddp-zone-NO': 182.0,
                      'passport-priority-ddp-zone-CH': 182.41,
                      'passport-priority-ddp-zone-IS': 163.22,
                      'passport-priority-ddp-zone-AI': 189.71,
                      'passport-priority-ddp-zone-AG': 189.71,
                      'passport-priority-ddp-zone-AR': 237.2,
                      'passport-priority-ddp-zone-AW': 189.71,
                      'passport-priority-ddp-zone-BS': 189.71,
                      'passport-priority-ddp-zone-BB': 205.16,
                      'passport-priority-ddp-zone-BZ': 233.7,
                      'passport-priority-ddp-zone-BM': 190.03,
                      'passport-priority-ddp-zone-BO': 239.36,
                      'passport-priority-ddp-zone-BR': 173.67,
                      'passport-priority-ddp-zone-KY': 189.71,
                      'passport-priority-ddp-zone-CL': 194.81,
                      'passport-priority-ddp-zone-CO': 173.67,
                      'passport-priority-ddp-zone-CR': 237.69,
                      'passport-priority-ddp-zone-DM': 189.71,
                      'passport-priority-ddp-zone-DO': 190.54,
                      'passport-priority-ddp-zone-EC': 237.94,
                      'passport-priority-ddp-zone-SV': 233.7,
                      'passport-priority-ddp-zone-GP': 224.44,
                      'passport-priority-ddp-zone-GT': 233.8,
                      'passport-priority-ddp-zone-GY': 233.7,
                      'passport-priority-ddp-zone-HT': 189.71,
                      'passport-priority-ddp-zone-JM': 210.55,
                      'passport-priority-ddp-zone-MQ': 201.29,
                      'passport-priority-ddp-zone-AN': 189.71,
                      'passport-priority-ddp-zone-NI': 237.09,
                      'passport-priority-ddp-zone-PA': 233.99,
                      'passport-priority-ddp-zone-PY': 233.7,
                      'passport-priority-ddp-zone-PE': 236.04,
                      'passport-priority-ddp-zone-SR': 233.7,
                      'passport-priority-ddp-zone-TT': 195.51,
                      'passport-priority-ddp-zone-UY': 233.7,
                      'passport-priority-ddp-zone-AF': 313.38,
                      'passport-priority-ddp-zone-DZ': 313.38,
                      'passport-priority-ddp-zone-BH': 295.99,
                      'passport-priority-ddp-zone-BD': 293.23,
                      'passport-priority-ddp-zone-BT': 293.23,
                      'passport-priority-ddp-zone-BA': 313.38,
                      'passport-priority-ddp-zone-BW': 313.38,
                      'passport-priority-ddp-zone-BN': 295.99,
                      'passport-priority-ddp-zone-BF': 313.38,
                      'passport-priority-ddp-zone-BI': 313.38,
                      'passport-priority-ddp-zone-KH': 313.38,
                      'passport-priority-ddp-zone-CM': 313.38,
                      'passport-priority-ddp-zone-CV': 313.38,
                      'passport-priority-ddp-zone-TD': 313.38,
                      'passport-priority-ddp-zone-CG': 313.38,
                      'passport-priority-ddp-zone-CI': 313.38,
                      'passport-priority-ddp-zone-EG': 295.99,
                      'passport-priority-ddp-zone-ET': 313.38,
                      'passport-priority-ddp-zone-GA': 313.38,
                      'passport-priority-ddp-zone-GM': 313.38,
                      'passport-priority-ddp-zone-GH': 313.38,
                      'passport-priority-ddp-zone-GN': 313.38,
                      'passport-priority-ddp-zone-ID': 298.82,
                      'passport-priority-ddp-zone-JO': 295.99,
                      'passport-priority-ddp-zone-KE': 313.38,
                      'passport-priority-ddp-zone-KW': 296.34,
                      'passport-priority-ddp-zone-LB': 295.99,
                      'passport-priority-ddp-zone-LI': 297.84,
                      'passport-priority-ddp-zone-MO': 297.62,
                      'passport-priority-ddp-zone-MG': 313.38,
                      'passport-priority-ddp-zone-MW': 313.38,
                      'passport-priority-ddp-zone-MY': 268.77,
                      'passport-priority-ddp-zone-MV': 293.23,
                      'passport-priority-ddp-zone-ML': 313.38,
                      'passport-priority-ddp-zone-MR': 313.38,
                      'passport-priority-ddp-zone-MU': 313.38,
                      'passport-priority-ddp-zone-MD': 313.38,
                      'passport-priority-ddp-zone-MA': 313.65,
                      'passport-priority-ddp-zone-MZ': 313.38,
                      'passport-priority-ddp-zone-NA': 313.38,
                      'passport-priority-ddp-zone-NP': 293.23,
                      'passport-priority-ddp-zone-NE': 313.38,
                      'passport-priority-ddp-zone-NG': 313.38,
                      'passport-priority-ddp-zone-PK': 293.23,
                      'passport-priority-ddp-zone-PH': 268.92,
                      'passport-priority-ddp-zone-RE': 313.38,
                      'passport-priority-ddp-zone-RW': 313.38,
                      'passport-priority-ddp-zone-SN': 313.38,
                      'passport-priority-ddp-zone-SC': 313.38,
                      'passport-priority-ddp-zone-ZA': 310.7,
                      'passport-priority-ddp-zone-LK': 293.23,
                      'passport-priority-ddp-zone-SZ': 313.38,
                      'passport-priority-ddp-zone-TW': 268.92,
                      'passport-priority-ddp-zone-TJ': 313.38,
                      'passport-priority-ddp-zone-TZ': 313.38,
                      'passport-priority-ddp-zone-TG': 313.38,
                      'passport-priority-ddp-zone-TN': 313.38,
                      'passport-priority-ddp-zone-TR': 296.01,
                      'passport-priority-ddp-zone-TM': 313.38,
                      'passport-priority-ddp-zone-UG': 313.38,
                      'passport-priority-ddp-zone-UA': 313.38,
                      'passport-priority-ddp-zone-VN': 269.12,
                      'passport-priority-ddp-zone-YE': 295.99,
                      'passport-priority-ddp-zone-ZM': 313.38,
                      'passport-priority-ddp-zone-ZW': 313.38,
                      'passport-priority-ddp-zone-MC': 128.58,
                      'passport-priority-ddp-zone-IM': 120.52,
                      'passport-priority-ddp-zone-SM': 128.58,
                    },
                    '28': {
                      'passport-priority-ddp-zone-CA': 64.29,
                      'passport-priority-ddp-zone-GB': 124.72,
                      'passport-priority-ddp-zone-AU': 178.36,
                      'passport-priority-ddp-zone-BE': 132.06,
                      'passport-priority-ddp-zone-DK': 132.06,
                      'passport-priority-ddp-zone-FR': 132.06,
                      'passport-priority-ddp-zone-DE': 132.06,
                      'passport-priority-ddp-zone-IT': 132.06,
                      'passport-priority-ddp-zone-NL': 132.06,
                      'passport-priority-ddp-zone-ES': 132.06,
                      'passport-priority-ddp-zone-MX': 162.71,
                      'passport-priority-ddp-zone-AM': 256.1,
                      'passport-priority-ddp-zone-AT': 135.17,
                      'passport-priority-ddp-zone-BG': 135.17,
                      'passport-priority-ddp-zone-HR': 135.17,
                      'passport-priority-ddp-zone-CY': 147.86,
                      'passport-priority-ddp-zone-CZ': 135.17,
                      'passport-priority-ddp-zone-EE': 135.17,
                      'passport-priority-ddp-zone-FI': 135.17,
                      'passport-priority-ddp-zone-GR': 146.12,
                      'passport-priority-ddp-zone-HU': 135.17,
                      'passport-priority-ddp-zone-IE': 135.17,
                      'passport-priority-ddp-zone-LV': 135.17,
                      'passport-priority-ddp-zone-LT': 135.17,
                      'passport-priority-ddp-zone-LU': 135.17,
                      'passport-priority-ddp-zone-MT': 147.86,
                      'passport-priority-ddp-zone-PL': 135.17,
                      'passport-priority-ddp-zone-PT': 135.17,
                      'passport-priority-ddp-zone-RO': 135.17,
                      'passport-priority-ddp-zone-SK': 135.17,
                      'passport-priority-ddp-zone-SI': 135.17,
                      'passport-priority-ddp-zone-SE': 135.17,
                      'passport-priority-ddp-zone-IL': 205.59,
                      'passport-priority-ddp-zone-OM': 212.41,
                      'passport-priority-ddp-zone-QA': 205.18,
                      'passport-priority-ddp-zone-SA': 205.23,
                      'passport-priority-ddp-zone-AE': 205.51,
                      'passport-priority-ddp-zone-CN': 277.83,
                      'passport-priority-ddp-zone-HK': 189.84,
                      'passport-priority-ddp-zone-IN': 223.72,
                      'passport-priority-ddp-zone-JP': 251.29,
                      'passport-priority-ddp-zone-KR': 208.6,
                      'passport-priority-ddp-zone-NZ': 179.88,
                      'passport-priority-ddp-zone-SG': 189.84,
                      'passport-priority-ddp-zone-TH': 181.4,
                      'passport-priority-ddp-zone-GG': 255.06,
                      'passport-priority-ddp-zone-JE': 255.06,
                      'passport-priority-ddp-zone-NO': 184.73,
                      'passport-priority-ddp-zone-CH': 185.15,
                      'passport-priority-ddp-zone-IS': 163.78,
                      'passport-priority-ddp-zone-AI': 193.24,
                      'passport-priority-ddp-zone-AG': 193.24,
                      'passport-priority-ddp-zone-AR': 239.6,
                      'passport-priority-ddp-zone-AW': 193.24,
                      'passport-priority-ddp-zone-BS': 193.24,
                      'passport-priority-ddp-zone-BB': 208.88,
                      'passport-priority-ddp-zone-BZ': 236.1,
                      'passport-priority-ddp-zone-BM': 193.58,
                      'passport-priority-ddp-zone-BO': 241.76,
                      'passport-priority-ddp-zone-BR': 179.33,
                      'passport-priority-ddp-zone-KY': 193.24,
                      'passport-priority-ddp-zone-CL': 201.93,
                      'passport-priority-ddp-zone-CO': 179.33,
                      'passport-priority-ddp-zone-CR': 240.09,
                      'passport-priority-ddp-zone-DM': 193.24,
                      'passport-priority-ddp-zone-DO': 194.06,
                      'passport-priority-ddp-zone-EC': 240.33,
                      'passport-priority-ddp-zone-SV': 236.1,
                      'passport-priority-ddp-zone-GP': 228.44,
                      'passport-priority-ddp-zone-GT': 236.2,
                      'passport-priority-ddp-zone-GY': 236.1,
                      'passport-priority-ddp-zone-HT': 193.24,
                      'passport-priority-ddp-zone-JM': 214.38,
                      'passport-priority-ddp-zone-MQ': 204.98,
                      'passport-priority-ddp-zone-AN': 193.24,
                      'passport-priority-ddp-zone-NI': 239.49,
                      'passport-priority-ddp-zone-PA': 236.39,
                      'passport-priority-ddp-zone-PY': 236.1,
                      'passport-priority-ddp-zone-PE': 238.44,
                      'passport-priority-ddp-zone-SR': 236.1,
                      'passport-priority-ddp-zone-TT': 199.11,
                      'passport-priority-ddp-zone-UY': 236.1,
                      'passport-priority-ddp-zone-AF': 334.01,
                      'passport-priority-ddp-zone-DZ': 334.01,
                      'passport-priority-ddp-zone-BH': 329.78,
                      'passport-priority-ddp-zone-BD': 296.19,
                      'passport-priority-ddp-zone-BT': 296.19,
                      'passport-priority-ddp-zone-BA': 334.01,
                      'passport-priority-ddp-zone-BW': 334.01,
                      'passport-priority-ddp-zone-BN': 329.78,
                      'passport-priority-ddp-zone-BF': 334.01,
                      'passport-priority-ddp-zone-BI': 334.01,
                      'passport-priority-ddp-zone-KH': 334.01,
                      'passport-priority-ddp-zone-CM': 334.01,
                      'passport-priority-ddp-zone-CV': 334.01,
                      'passport-priority-ddp-zone-TD': 334.01,
                      'passport-priority-ddp-zone-CG': 334.01,
                      'passport-priority-ddp-zone-CI': 334.01,
                      'passport-priority-ddp-zone-EG': 329.78,
                      'passport-priority-ddp-zone-ET': 334.01,
                      'passport-priority-ddp-zone-GA': 334.01,
                      'passport-priority-ddp-zone-GM': 334.01,
                      'passport-priority-ddp-zone-GH': 334.01,
                      'passport-priority-ddp-zone-GN': 334.01,
                      'passport-priority-ddp-zone-ID': 308.46,
                      'passport-priority-ddp-zone-JO': 329.78,
                      'passport-priority-ddp-zone-KE': 334.01,
                      'passport-priority-ddp-zone-KW': 330.15,
                      'passport-priority-ddp-zone-LB': 329.78,
                      'passport-priority-ddp-zone-LI': 320.01,
                      'passport-priority-ddp-zone-MO': 307.23,
                      'passport-priority-ddp-zone-MG': 334.01,
                      'passport-priority-ddp-zone-MW': 334.01,
                      'passport-priority-ddp-zone-MY': 285.46,
                      'passport-priority-ddp-zone-MV': 296.19,
                      'passport-priority-ddp-zone-ML': 334.01,
                      'passport-priority-ddp-zone-MR': 334.01,
                      'passport-priority-ddp-zone-MU': 334.01,
                      'passport-priority-ddp-zone-MD': 334.01,
                      'passport-priority-ddp-zone-MA': 334.3,
                      'passport-priority-ddp-zone-MZ': 334.01,
                      'passport-priority-ddp-zone-NA': 334.01,
                      'passport-priority-ddp-zone-NP': 296.19,
                      'passport-priority-ddp-zone-NE': 334.01,
                      'passport-priority-ddp-zone-NG': 334.01,
                      'passport-priority-ddp-zone-PK': 296.19,
                      'passport-priority-ddp-zone-PH': 285.62,
                      'passport-priority-ddp-zone-RE': 334.01,
                      'passport-priority-ddp-zone-RW': 334.01,
                      'passport-priority-ddp-zone-SN': 334.01,
                      'passport-priority-ddp-zone-SC': 334.01,
                      'passport-priority-ddp-zone-ZA': 327.94,
                      'passport-priority-ddp-zone-LK': 296.19,
                      'passport-priority-ddp-zone-SZ': 334.01,
                      'passport-priority-ddp-zone-TW': 285.62,
                      'passport-priority-ddp-zone-TJ': 334.01,
                      'passport-priority-ddp-zone-TZ': 334.01,
                      'passport-priority-ddp-zone-TG': 334.01,
                      'passport-priority-ddp-zone-TN': 334.01,
                      'passport-priority-ddp-zone-TR': 329.83,
                      'passport-priority-ddp-zone-TM': 334.01,
                      'passport-priority-ddp-zone-UG': 334.01,
                      'passport-priority-ddp-zone-UA': 334.01,
                      'passport-priority-ddp-zone-VN': 285.89,
                      'passport-priority-ddp-zone-YE': 329.78,
                      'passport-priority-ddp-zone-ZM': 334.01,
                      'passport-priority-ddp-zone-ZW': 334.01,
                      'passport-priority-ddp-zone-MC': 132.06,
                      'passport-priority-ddp-zone-IM': 124.72,
                      'passport-priority-ddp-zone-SM': 132.06,
                    },
                    '29': {
                      'passport-priority-ddp-zone-CA': 66.26,
                      'passport-priority-ddp-zone-GB': 128.92,
                      'passport-priority-ddp-zone-AU': 184.33,
                      'passport-priority-ddp-zone-BE': 135.54,
                      'passport-priority-ddp-zone-DK': 135.54,
                      'passport-priority-ddp-zone-FR': 135.54,
                      'passport-priority-ddp-zone-DE': 135.54,
                      'passport-priority-ddp-zone-IT': 135.54,
                      'passport-priority-ddp-zone-NL': 135.54,
                      'passport-priority-ddp-zone-ES': 135.54,
                      'passport-priority-ddp-zone-MX': 168.35,
                      'passport-priority-ddp-zone-AM': 257.5,
                      'passport-priority-ddp-zone-AT': 138.65,
                      'passport-priority-ddp-zone-BG': 138.65,
                      'passport-priority-ddp-zone-HR': 138.65,
                      'passport-priority-ddp-zone-CY': 151.62,
                      'passport-priority-ddp-zone-CZ': 138.65,
                      'passport-priority-ddp-zone-EE': 138.65,
                      'passport-priority-ddp-zone-FI': 138.65,
                      'passport-priority-ddp-zone-GR': 149.89,
                      'passport-priority-ddp-zone-HU': 138.65,
                      'passport-priority-ddp-zone-IE': 138.65,
                      'passport-priority-ddp-zone-LV': 138.65,
                      'passport-priority-ddp-zone-LT': 138.65,
                      'passport-priority-ddp-zone-LU': 138.65,
                      'passport-priority-ddp-zone-MT': 151.62,
                      'passport-priority-ddp-zone-PL': 138.65,
                      'passport-priority-ddp-zone-PT': 138.65,
                      'passport-priority-ddp-zone-RO': 138.65,
                      'passport-priority-ddp-zone-SK': 138.65,
                      'passport-priority-ddp-zone-SI': 138.65,
                      'passport-priority-ddp-zone-SE': 138.65,
                      'passport-priority-ddp-zone-IL': 209.42,
                      'passport-priority-ddp-zone-OM': 216.26,
                      'passport-priority-ddp-zone-QA': 209.0,
                      'passport-priority-ddp-zone-SA': 209.03,
                      'passport-priority-ddp-zone-AE': 209.32,
                      'passport-priority-ddp-zone-CN': 286.71,
                      'passport-priority-ddp-zone-HK': 189.96,
                      'passport-priority-ddp-zone-IN': 225.97,
                      'passport-priority-ddp-zone-JP': 258.67,
                      'passport-priority-ddp-zone-KR': 214.87,
                      'passport-priority-ddp-zone-NZ': 186.03,
                      'passport-priority-ddp-zone-SG': 189.96,
                      'passport-priority-ddp-zone-TH': 187.51,
                      'passport-priority-ddp-zone-GG': 257.37,
                      'passport-priority-ddp-zone-JE': 257.37,
                      'passport-priority-ddp-zone-NO': 185.25,
                      'passport-priority-ddp-zone-CH': 185.67,
                      'passport-priority-ddp-zone-IS': 164.06,
                      'passport-priority-ddp-zone-AI': 206.51,
                      'passport-priority-ddp-zone-AG': 206.51,
                      'passport-priority-ddp-zone-AR': 251.06,
                      'passport-priority-ddp-zone-AW': 206.51,
                      'passport-priority-ddp-zone-BS': 206.51,
                      'passport-priority-ddp-zone-BB': 222.32,
                      'passport-priority-ddp-zone-BZ': 247.54,
                      'passport-priority-ddp-zone-BM': 206.83,
                      'passport-priority-ddp-zone-BO': 253.2,
                      'passport-priority-ddp-zone-BR': 184.99,
                      'passport-priority-ddp-zone-KY': 206.51,
                      'passport-priority-ddp-zone-CL': 209.04,
                      'passport-priority-ddp-zone-CO': 184.99,
                      'passport-priority-ddp-zone-CR': 251.54,
                      'passport-priority-ddp-zone-DM': 206.51,
                      'passport-priority-ddp-zone-DO': 207.35,
                      'passport-priority-ddp-zone-EC': 251.79,
                      'passport-priority-ddp-zone-SV': 247.54,
                      'passport-priority-ddp-zone-GP': 242.1,
                      'passport-priority-ddp-zone-GT': 247.64,
                      'passport-priority-ddp-zone-GY': 247.54,
                      'passport-priority-ddp-zone-HT': 206.51,
                      'passport-priority-ddp-zone-JM': 227.86,
                      'passport-priority-ddp-zone-MQ': 218.38,
                      'passport-priority-ddp-zone-AN': 206.51,
                      'passport-priority-ddp-zone-NI': 250.94,
                      'passport-priority-ddp-zone-PA': 247.84,
                      'passport-priority-ddp-zone-PY': 247.54,
                      'passport-priority-ddp-zone-PE': 249.89,
                      'passport-priority-ddp-zone-SR': 247.54,
                      'passport-priority-ddp-zone-TT': 212.44,
                      'passport-priority-ddp-zone-UY': 247.54,
                      'passport-priority-ddp-zone-AF': 351.35,
                      'passport-priority-ddp-zone-DZ': 351.35,
                      'passport-priority-ddp-zone-BH': 341.81,
                      'passport-priority-ddp-zone-BD': 310.06,
                      'passport-priority-ddp-zone-BT': 310.06,
                      'passport-priority-ddp-zone-BA': 351.35,
                      'passport-priority-ddp-zone-BW': 351.35,
                      'passport-priority-ddp-zone-BN': 341.81,
                      'passport-priority-ddp-zone-BF': 351.35,
                      'passport-priority-ddp-zone-BI': 351.35,
                      'passport-priority-ddp-zone-KH': 351.35,
                      'passport-priority-ddp-zone-CM': 351.35,
                      'passport-priority-ddp-zone-CV': 351.35,
                      'passport-priority-ddp-zone-TD': 351.35,
                      'passport-priority-ddp-zone-CG': 351.35,
                      'passport-priority-ddp-zone-CI': 351.35,
                      'passport-priority-ddp-zone-EG': 341.81,
                      'passport-priority-ddp-zone-ET': 351.35,
                      'passport-priority-ddp-zone-GA': 351.35,
                      'passport-priority-ddp-zone-GM': 351.35,
                      'passport-priority-ddp-zone-GH': 351.35,
                      'passport-priority-ddp-zone-GN': 351.35,
                      'passport-priority-ddp-zone-ID': 312.97,
                      'passport-priority-ddp-zone-JO': 341.81,
                      'passport-priority-ddp-zone-KE': 351.35,
                      'passport-priority-ddp-zone-KW': 342.17,
                      'passport-priority-ddp-zone-LB': 341.81,
                      'passport-priority-ddp-zone-LI': 336.66,
                      'passport-priority-ddp-zone-MO': 311.74,
                      'passport-priority-ddp-zone-MG': 351.35,
                      'passport-priority-ddp-zone-MW': 351.35,
                      'passport-priority-ddp-zone-MY': 300.05,
                      'passport-priority-ddp-zone-MV': 310.06,
                      'passport-priority-ddp-zone-ML': 351.35,
                      'passport-priority-ddp-zone-MR': 351.35,
                      'passport-priority-ddp-zone-MU': 351.35,
                      'passport-priority-ddp-zone-MD': 351.35,
                      'passport-priority-ddp-zone-MA': 351.65,
                      'passport-priority-ddp-zone-MZ': 351.35,
                      'passport-priority-ddp-zone-NA': 351.35,
                      'passport-priority-ddp-zone-NP': 310.06,
                      'passport-priority-ddp-zone-NE': 351.35,
                      'passport-priority-ddp-zone-NG': 351.35,
                      'passport-priority-ddp-zone-PK': 310.06,
                      'passport-priority-ddp-zone-PH': 300.19,
                      'passport-priority-ddp-zone-RE': 351.35,
                      'passport-priority-ddp-zone-RW': 351.35,
                      'passport-priority-ddp-zone-SN': 351.35,
                      'passport-priority-ddp-zone-SC': 351.35,
                      'passport-priority-ddp-zone-ZA': 330.53,
                      'passport-priority-ddp-zone-LK': 310.06,
                      'passport-priority-ddp-zone-SZ': 351.35,
                      'passport-priority-ddp-zone-TW': 300.19,
                      'passport-priority-ddp-zone-TJ': 351.35,
                      'passport-priority-ddp-zone-TZ': 351.35,
                      'passport-priority-ddp-zone-TG': 351.35,
                      'passport-priority-ddp-zone-TN': 351.35,
                      'passport-priority-ddp-zone-TR': 341.84,
                      'passport-priority-ddp-zone-TM': 351.35,
                      'passport-priority-ddp-zone-UG': 351.35,
                      'passport-priority-ddp-zone-UA': 351.35,
                      'passport-priority-ddp-zone-VN': 300.41,
                      'passport-priority-ddp-zone-YE': 341.81,
                      'passport-priority-ddp-zone-ZM': 351.35,
                      'passport-priority-ddp-zone-ZW': 351.35,
                      'passport-priority-ddp-zone-MC': 135.54,
                      'passport-priority-ddp-zone-IM': 128.92,
                      'passport-priority-ddp-zone-SM': 135.54,
                    },
                    '30': {
                      'passport-priority-ddp-zone-CA': 68.23,
                      'passport-priority-ddp-zone-GB': 133.13,
                      'passport-priority-ddp-zone-AU': 190.31,
                      'passport-priority-ddp-zone-BE': 139.01,
                      'passport-priority-ddp-zone-DK': 139.01,
                      'passport-priority-ddp-zone-FR': 139.01,
                      'passport-priority-ddp-zone-DE': 139.01,
                      'passport-priority-ddp-zone-IT': 139.01,
                      'passport-priority-ddp-zone-NL': 139.01,
                      'passport-priority-ddp-zone-ES': 139.01,
                      'passport-priority-ddp-zone-MX': 174.0,
                      'passport-priority-ddp-zone-AM': 258.72,
                      'passport-priority-ddp-zone-AT': 142.13,
                      'passport-priority-ddp-zone-BG': 142.13,
                      'passport-priority-ddp-zone-HR': 142.13,
                      'passport-priority-ddp-zone-CY': 155.39,
                      'passport-priority-ddp-zone-CZ': 142.13,
                      'passport-priority-ddp-zone-EE': 142.13,
                      'passport-priority-ddp-zone-FI': 142.13,
                      'passport-priority-ddp-zone-GR': 153.66,
                      'passport-priority-ddp-zone-HU': 142.13,
                      'passport-priority-ddp-zone-IE': 142.13,
                      'passport-priority-ddp-zone-LV': 142.13,
                      'passport-priority-ddp-zone-LT': 142.13,
                      'passport-priority-ddp-zone-LU': 142.13,
                      'passport-priority-ddp-zone-MT': 155.39,
                      'passport-priority-ddp-zone-PL': 142.13,
                      'passport-priority-ddp-zone-PT': 142.13,
                      'passport-priority-ddp-zone-RO': 142.13,
                      'passport-priority-ddp-zone-SK': 142.13,
                      'passport-priority-ddp-zone-SI': 142.13,
                      'passport-priority-ddp-zone-SE': 142.13,
                      'passport-priority-ddp-zone-IL': 212.24,
                      'passport-priority-ddp-zone-OM': 219.17,
                      'passport-priority-ddp-zone-QA': 211.82,
                      'passport-priority-ddp-zone-SA': 211.85,
                      'passport-priority-ddp-zone-AE': 212.15,
                      'passport-priority-ddp-zone-CN': 295.59,
                      'passport-priority-ddp-zone-HK': 192.35,
                      'passport-priority-ddp-zone-IN': 227.11,
                      'passport-priority-ddp-zone-JP': 266.04,
                      'passport-priority-ddp-zone-KR': 221.14,
                      'passport-priority-ddp-zone-NZ': 192.2,
                      'passport-priority-ddp-zone-SG': 192.35,
                      'passport-priority-ddp-zone-TH': 193.62,
                      'passport-priority-ddp-zone-GG': 258.62,
                      'passport-priority-ddp-zone-JE': 258.62,
                      'passport-priority-ddp-zone-NO': 190.3,
                      'passport-priority-ddp-zone-CH': 190.72,
                      'passport-priority-ddp-zone-IS': 166.07,
                      'passport-priority-ddp-zone-AI': 209.26,
                      'passport-priority-ddp-zone-AG': 209.26,
                      'passport-priority-ddp-zone-AR': 253.23,
                      'passport-priority-ddp-zone-AW': 209.26,
                      'passport-priority-ddp-zone-BS': 209.26,
                      'passport-priority-ddp-zone-BB': 225.17,
                      'passport-priority-ddp-zone-BZ': 249.72,
                      'passport-priority-ddp-zone-BM': 209.58,
                      'passport-priority-ddp-zone-BO': 255.38,
                      'passport-priority-ddp-zone-BR': 190.66,
                      'passport-priority-ddp-zone-KY': 209.26,
                      'passport-priority-ddp-zone-CL': 216.16,
                      'passport-priority-ddp-zone-CO': 190.66,
                      'passport-priority-ddp-zone-CR': 253.72,
                      'passport-priority-ddp-zone-DM': 209.26,
                      'passport-priority-ddp-zone-DO': 210.08,
                      'passport-priority-ddp-zone-EC': 253.97,
                      'passport-priority-ddp-zone-SV': 249.72,
                      'passport-priority-ddp-zone-GP': 245.05,
                      'passport-priority-ddp-zone-GT': 249.82,
                      'passport-priority-ddp-zone-GY': 249.72,
                      'passport-priority-ddp-zone-HT': 209.26,
                      'passport-priority-ddp-zone-JM': 230.75,
                      'passport-priority-ddp-zone-MQ': 221.19,
                      'passport-priority-ddp-zone-AN': 209.26,
                      'passport-priority-ddp-zone-NI': 253.12,
                      'passport-priority-ddp-zone-PA': 250.02,
                      'passport-priority-ddp-zone-PY': 249.72,
                      'passport-priority-ddp-zone-PE': 252.07,
                      'passport-priority-ddp-zone-SR': 249.72,
                      'passport-priority-ddp-zone-TT': 215.21,
                      'passport-priority-ddp-zone-UY': 249.72,
                      'passport-priority-ddp-zone-AF': 353.31,
                      'passport-priority-ddp-zone-DZ': 353.31,
                      'passport-priority-ddp-zone-BH': 343.52,
                      'passport-priority-ddp-zone-BD': 311.96,
                      'passport-priority-ddp-zone-BT': 311.96,
                      'passport-priority-ddp-zone-BA': 353.31,
                      'passport-priority-ddp-zone-BW': 353.31,
                      'passport-priority-ddp-zone-BN': 343.52,
                      'passport-priority-ddp-zone-BF': 353.31,
                      'passport-priority-ddp-zone-BI': 353.31,
                      'passport-priority-ddp-zone-KH': 353.31,
                      'passport-priority-ddp-zone-CM': 353.31,
                      'passport-priority-ddp-zone-CV': 353.31,
                      'passport-priority-ddp-zone-TD': 353.31,
                      'passport-priority-ddp-zone-CG': 353.31,
                      'passport-priority-ddp-zone-CI': 353.31,
                      'passport-priority-ddp-zone-EG': 343.52,
                      'passport-priority-ddp-zone-ET': 353.31,
                      'passport-priority-ddp-zone-GA': 353.31,
                      'passport-priority-ddp-zone-GM': 353.31,
                      'passport-priority-ddp-zone-GH': 353.31,
                      'passport-priority-ddp-zone-GN': 353.31,
                      'passport-priority-ddp-zone-ID': 314.0,
                      'passport-priority-ddp-zone-JO': 343.52,
                      'passport-priority-ddp-zone-KE': 353.31,
                      'passport-priority-ddp-zone-KW': 343.88,
                      'passport-priority-ddp-zone-LB': 343.52,
                      'passport-priority-ddp-zone-LI': 343.55,
                      'passport-priority-ddp-zone-MO': 312.77,
                      'passport-priority-ddp-zone-MG': 353.31,
                      'passport-priority-ddp-zone-MW': 353.31,
                      'passport-priority-ddp-zone-MY': 301.7,
                      'passport-priority-ddp-zone-MV': 311.96,
                      'passport-priority-ddp-zone-ML': 353.31,
                      'passport-priority-ddp-zone-MR': 353.31,
                      'passport-priority-ddp-zone-MU': 353.31,
                      'passport-priority-ddp-zone-MD': 353.31,
                      'passport-priority-ddp-zone-MA': 353.61,
                      'passport-priority-ddp-zone-MZ': 353.31,
                      'passport-priority-ddp-zone-NA': 353.31,
                      'passport-priority-ddp-zone-NP': 311.96,
                      'passport-priority-ddp-zone-NE': 353.31,
                      'passport-priority-ddp-zone-NG': 353.31,
                      'passport-priority-ddp-zone-PK': 311.96,
                      'passport-priority-ddp-zone-PH': 301.87,
                      'passport-priority-ddp-zone-RE': 353.31,
                      'passport-priority-ddp-zone-RW': 353.31,
                      'passport-priority-ddp-zone-SN': 353.31,
                      'passport-priority-ddp-zone-SC': 353.31,
                      'passport-priority-ddp-zone-ZA': 331.26,
                      'passport-priority-ddp-zone-LK': 311.96,
                      'passport-priority-ddp-zone-SZ': 353.31,
                      'passport-priority-ddp-zone-TW': 301.87,
                      'passport-priority-ddp-zone-TJ': 353.31,
                      'passport-priority-ddp-zone-TZ': 353.31,
                      'passport-priority-ddp-zone-TG': 353.31,
                      'passport-priority-ddp-zone-TN': 353.31,
                      'passport-priority-ddp-zone-TR': 343.55,
                      'passport-priority-ddp-zone-TM': 353.31,
                      'passport-priority-ddp-zone-UG': 353.31,
                      'passport-priority-ddp-zone-UA': 353.31,
                      'passport-priority-ddp-zone-VN': 302.09,
                      'passport-priority-ddp-zone-YE': 343.52,
                      'passport-priority-ddp-zone-ZM': 353.31,
                      'passport-priority-ddp-zone-ZW': 353.31,
                      'passport-priority-ddp-zone-MC': 139.01,
                      'passport-priority-ddp-zone-IM': 133.13,
                      'passport-priority-ddp-zone-SM': 139.01,
                    },
                    '31': {
                      'passport-priority-ddp-zone-CA': 70.51,
                      'passport-priority-ddp-zone-GB': 137.56,
                      'passport-priority-ddp-zone-AU': 196.65,
                      'passport-priority-ddp-zone-BE': 143.64,
                      'passport-priority-ddp-zone-DK': 143.64,
                      'passport-priority-ddp-zone-FR': 143.64,
                      'passport-priority-ddp-zone-DE': 143.64,
                      'passport-priority-ddp-zone-IT': 143.64,
                      'passport-priority-ddp-zone-NL': 143.64,
                      'passport-priority-ddp-zone-ES': 143.64,
                      'passport-priority-ddp-zone-MX': 179.8,
                      'passport-priority-ddp-zone-AM': 267.34,
                      'passport-priority-ddp-zone-AT': 146.87,
                      'passport-priority-ddp-zone-BG': 146.87,
                      'passport-priority-ddp-zone-HR': 146.87,
                      'passport-priority-ddp-zone-CY': 160.57,
                      'passport-priority-ddp-zone-CZ': 146.87,
                      'passport-priority-ddp-zone-EE': 146.87,
                      'passport-priority-ddp-zone-FI': 146.87,
                      'passport-priority-ddp-zone-GR': 158.78,
                      'passport-priority-ddp-zone-HU': 146.87,
                      'passport-priority-ddp-zone-IE': 146.87,
                      'passport-priority-ddp-zone-LV': 146.87,
                      'passport-priority-ddp-zone-LT': 146.87,
                      'passport-priority-ddp-zone-LU': 146.87,
                      'passport-priority-ddp-zone-MT': 160.57,
                      'passport-priority-ddp-zone-PL': 146.87,
                      'passport-priority-ddp-zone-PT': 146.87,
                      'passport-priority-ddp-zone-RO': 146.87,
                      'passport-priority-ddp-zone-SK': 146.87,
                      'passport-priority-ddp-zone-SI': 146.87,
                      'passport-priority-ddp-zone-SE': 146.87,
                      'passport-priority-ddp-zone-IL': 219.31,
                      'passport-priority-ddp-zone-OM': 226.48,
                      'passport-priority-ddp-zone-QA': 218.88,
                      'passport-priority-ddp-zone-SA': 218.91,
                      'passport-priority-ddp-zone-AE': 219.22,
                      'passport-priority-ddp-zone-CN': 305.45,
                      'passport-priority-ddp-zone-HK': 198.77,
                      'passport-priority-ddp-zone-IN': 234.68,
                      'passport-priority-ddp-zone-JP': 274.91,
                      'passport-priority-ddp-zone-KR': 228.51,
                      'passport-priority-ddp-zone-NZ': 198.61,
                      'passport-priority-ddp-zone-SG': 198.77,
                      'passport-priority-ddp-zone-TH': 200.08,
                      'passport-priority-ddp-zone-GG': 267.24,
                      'passport-priority-ddp-zone-JE': 267.24,
                      'passport-priority-ddp-zone-NO': 196.63,
                      'passport-priority-ddp-zone-CH': 197.06,
                      'passport-priority-ddp-zone-IS': 171.6,
                      'passport-priority-ddp-zone-AI': 216.24,
                      'passport-priority-ddp-zone-AG': 216.24,
                      'passport-priority-ddp-zone-AR': 261.67,
                      'passport-priority-ddp-zone-AW': 216.24,
                      'passport-priority-ddp-zone-BS': 216.24,
                      'passport-priority-ddp-zone-BB': 232.69,
                      'passport-priority-ddp-zone-BZ': 258.04,
                      'passport-priority-ddp-zone-BM': 216.58,
                      'passport-priority-ddp-zone-BO': 263.89,
                      'passport-priority-ddp-zone-BR': 197.02,
                      'passport-priority-ddp-zone-KY': 216.24,
                      'passport-priority-ddp-zone-CL': 223.36,
                      'passport-priority-ddp-zone-CO': 197.02,
                      'passport-priority-ddp-zone-CR': 262.18,
                      'passport-priority-ddp-zone-DM': 216.24,
                      'passport-priority-ddp-zone-DO': 217.08,
                      'passport-priority-ddp-zone-EC': 262.44,
                      'passport-priority-ddp-zone-SV': 258.04,
                      'passport-priority-ddp-zone-GP': 253.23,
                      'passport-priority-ddp-zone-GT': 258.14,
                      'passport-priority-ddp-zone-GY': 258.04,
                      'passport-priority-ddp-zone-HT': 216.24,
                      'passport-priority-ddp-zone-JM': 238.46,
                      'passport-priority-ddp-zone-MQ': 228.57,
                      'passport-priority-ddp-zone-AN': 216.24,
                      'passport-priority-ddp-zone-NI': 261.55,
                      'passport-priority-ddp-zone-PA': 258.35,
                      'passport-priority-ddp-zone-PY': 258.04,
                      'passport-priority-ddp-zone-PE': 260.47,
                      'passport-priority-ddp-zone-SR': 258.04,
                      'passport-priority-ddp-zone-TT': 222.4,
                      'passport-priority-ddp-zone-UY': 258.04,
                      'passport-priority-ddp-zone-AF': 365.09,
                      'passport-priority-ddp-zone-DZ': 365.09,
                      'passport-priority-ddp-zone-BH': 354.96,
                      'passport-priority-ddp-zone-BD': 322.37,
                      'passport-priority-ddp-zone-BT': 322.37,
                      'passport-priority-ddp-zone-BA': 365.09,
                      'passport-priority-ddp-zone-BW': 365.09,
                      'passport-priority-ddp-zone-BN': 354.96,
                      'passport-priority-ddp-zone-BF': 365.09,
                      'passport-priority-ddp-zone-BI': 365.09,
                      'passport-priority-ddp-zone-KH': 365.09,
                      'passport-priority-ddp-zone-CM': 365.09,
                      'passport-priority-ddp-zone-CV': 365.09,
                      'passport-priority-ddp-zone-TD': 365.09,
                      'passport-priority-ddp-zone-CG': 365.09,
                      'passport-priority-ddp-zone-CI': 365.09,
                      'passport-priority-ddp-zone-EG': 354.96,
                      'passport-priority-ddp-zone-ET': 365.09,
                      'passport-priority-ddp-zone-GA': 365.09,
                      'passport-priority-ddp-zone-GM': 365.09,
                      'passport-priority-ddp-zone-GH': 365.09,
                      'passport-priority-ddp-zone-GN': 365.09,
                      'passport-priority-ddp-zone-ID': 324.35,
                      'passport-priority-ddp-zone-JO': 354.96,
                      'passport-priority-ddp-zone-KE': 365.09,
                      'passport-priority-ddp-zone-KW': 355.35,
                      'passport-priority-ddp-zone-LB': 354.96,
                      'passport-priority-ddp-zone-LI': 354.98,
                      'passport-priority-ddp-zone-MO': 323.2,
                      'passport-priority-ddp-zone-MG': 365.09,
                      'passport-priority-ddp-zone-MW': 365.09,
                      'passport-priority-ddp-zone-MY': 311.75,
                      'passport-priority-ddp-zone-MV': 322.37,
                      'passport-priority-ddp-zone-ML': 365.09,
                      'passport-priority-ddp-zone-MR': 365.09,
                      'passport-priority-ddp-zone-MU': 365.09,
                      'passport-priority-ddp-zone-MD': 365.09,
                      'passport-priority-ddp-zone-MA': 365.41,
                      'passport-priority-ddp-zone-MZ': 365.09,
                      'passport-priority-ddp-zone-NA': 365.09,
                      'passport-priority-ddp-zone-NP': 322.37,
                      'passport-priority-ddp-zone-NE': 365.09,
                      'passport-priority-ddp-zone-NG': 365.09,
                      'passport-priority-ddp-zone-PK': 322.37,
                      'passport-priority-ddp-zone-PH': 311.95,
                      'passport-priority-ddp-zone-RE': 365.09,
                      'passport-priority-ddp-zone-RW': 365.09,
                      'passport-priority-ddp-zone-SN': 365.09,
                      'passport-priority-ddp-zone-SC': 365.09,
                      'passport-priority-ddp-zone-ZA': 342.3,
                      'passport-priority-ddp-zone-LK': 322.37,
                      'passport-priority-ddp-zone-SZ': 365.09,
                      'passport-priority-ddp-zone-TW': 311.95,
                      'passport-priority-ddp-zone-TJ': 365.09,
                      'passport-priority-ddp-zone-TZ': 365.09,
                      'passport-priority-ddp-zone-TG': 365.09,
                      'passport-priority-ddp-zone-TN': 365.09,
                      'passport-priority-ddp-zone-TR': 354.99,
                      'passport-priority-ddp-zone-TM': 365.09,
                      'passport-priority-ddp-zone-UG': 365.09,
                      'passport-priority-ddp-zone-UA': 365.09,
                      'passport-priority-ddp-zone-VN': 312.15,
                      'passport-priority-ddp-zone-YE': 354.96,
                      'passport-priority-ddp-zone-ZM': 365.09,
                      'passport-priority-ddp-zone-ZW': 365.09,
                      'passport-priority-ddp-zone-MC': 143.64,
                      'passport-priority-ddp-zone-IM': 137.76,
                      'passport-priority-ddp-zone-SM': 143.64,
                    },
                    '32': {
                      'passport-priority-ddp-zone-CA': 72.79,
                      'passport-priority-ddp-zone-GB': 141.99,
                      'passport-priority-ddp-zone-AU': 202.99,
                      'passport-priority-ddp-zone-BE': 148.27,
                      'passport-priority-ddp-zone-DK': 148.27,
                      'passport-priority-ddp-zone-FR': 148.27,
                      'passport-priority-ddp-zone-DE': 148.27,
                      'passport-priority-ddp-zone-IT': 148.27,
                      'passport-priority-ddp-zone-NL': 148.27,
                      'passport-priority-ddp-zone-ES': 148.27,
                      'passport-priority-ddp-zone-MX': 185.6,
                      'passport-priority-ddp-zone-AM': 275.96,
                      'passport-priority-ddp-zone-AT': 151.61,
                      'passport-priority-ddp-zone-BG': 151.61,
                      'passport-priority-ddp-zone-HR': 151.61,
                      'passport-priority-ddp-zone-CY': 165.75,
                      'passport-priority-ddp-zone-CZ': 151.61,
                      'passport-priority-ddp-zone-EE': 151.61,
                      'passport-priority-ddp-zone-FI': 151.61,
                      'passport-priority-ddp-zone-GR': 163.9,
                      'passport-priority-ddp-zone-HU': 151.61,
                      'passport-priority-ddp-zone-IE': 151.61,
                      'passport-priority-ddp-zone-LV': 151.61,
                      'passport-priority-ddp-zone-LT': 151.61,
                      'passport-priority-ddp-zone-LU': 151.61,
                      'passport-priority-ddp-zone-MT': 165.75,
                      'passport-priority-ddp-zone-PL': 151.61,
                      'passport-priority-ddp-zone-PT': 151.61,
                      'passport-priority-ddp-zone-RO': 151.61,
                      'passport-priority-ddp-zone-SK': 151.61,
                      'passport-priority-ddp-zone-SI': 151.61,
                      'passport-priority-ddp-zone-SE': 151.61,
                      'passport-priority-ddp-zone-IL': 226.38,
                      'passport-priority-ddp-zone-OM': 233.79,
                      'passport-priority-ddp-zone-QA': 225.94,
                      'passport-priority-ddp-zone-SA': 225.97,
                      'passport-priority-ddp-zone-AE': 226.29,
                      'passport-priority-ddp-zone-CN': 315.31,
                      'passport-priority-ddp-zone-HK': 205.19,
                      'passport-priority-ddp-zone-IN': 242.25,
                      'passport-priority-ddp-zone-JP': 283.78,
                      'passport-priority-ddp-zone-KR': 235.88,
                      'passport-priority-ddp-zone-NZ': 205.02,
                      'passport-priority-ddp-zone-SG': 205.19,
                      'passport-priority-ddp-zone-TH': 206.54,
                      'passport-priority-ddp-zone-GG': 275.86,
                      'passport-priority-ddp-zone-JE': 275.86,
                      'passport-priority-ddp-zone-NO': 202.96,
                      'passport-priority-ddp-zone-CH': 203.4,
                      'passport-priority-ddp-zone-IS': 177.13,
                      'passport-priority-ddp-zone-AI': 223.22,
                      'passport-priority-ddp-zone-AG': 223.22,
                      'passport-priority-ddp-zone-AR': 270.11,
                      'passport-priority-ddp-zone-AW': 223.22,
                      'passport-priority-ddp-zone-BS': 223.22,
                      'passport-priority-ddp-zone-BB': 240.21,
                      'passport-priority-ddp-zone-BZ': 266.36,
                      'passport-priority-ddp-zone-BM': 223.58,
                      'passport-priority-ddp-zone-BO': 272.4,
                      'passport-priority-ddp-zone-BR': 203.38,
                      'passport-priority-ddp-zone-KY': 223.22,
                      'passport-priority-ddp-zone-CL': 230.56,
                      'passport-priority-ddp-zone-CO': 203.38,
                      'passport-priority-ddp-zone-CR': 270.64,
                      'passport-priority-ddp-zone-DM': 223.22,
                      'passport-priority-ddp-zone-DO': 224.08,
                      'passport-priority-ddp-zone-EC': 270.91,
                      'passport-priority-ddp-zone-SV': 266.36,
                      'passport-priority-ddp-zone-GP': 261.41,
                      'passport-priority-ddp-zone-GT': 266.46,
                      'passport-priority-ddp-zone-GY': 266.36,
                      'passport-priority-ddp-zone-HT': 223.22,
                      'passport-priority-ddp-zone-JM': 246.17,
                      'passport-priority-ddp-zone-MQ': 235.95,
                      'passport-priority-ddp-zone-AN': 223.22,
                      'passport-priority-ddp-zone-NI': 269.98,
                      'passport-priority-ddp-zone-PA': 266.68,
                      'passport-priority-ddp-zone-PY': 266.36,
                      'passport-priority-ddp-zone-PE': 268.87,
                      'passport-priority-ddp-zone-SR': 266.36,
                      'passport-priority-ddp-zone-TT': 229.59,
                      'passport-priority-ddp-zone-UY': 266.36,
                      'passport-priority-ddp-zone-AF': 376.87,
                      'passport-priority-ddp-zone-DZ': 376.87,
                      'passport-priority-ddp-zone-BH': 366.4,
                      'passport-priority-ddp-zone-BD': 332.78,
                      'passport-priority-ddp-zone-BT': 332.78,
                      'passport-priority-ddp-zone-BA': 376.87,
                      'passport-priority-ddp-zone-BW': 376.87,
                      'passport-priority-ddp-zone-BN': 366.4,
                      'passport-priority-ddp-zone-BF': 376.87,
                      'passport-priority-ddp-zone-BI': 376.87,
                      'passport-priority-ddp-zone-KH': 376.87,
                      'passport-priority-ddp-zone-CM': 376.87,
                      'passport-priority-ddp-zone-CV': 376.87,
                      'passport-priority-ddp-zone-TD': 376.87,
                      'passport-priority-ddp-zone-CG': 376.87,
                      'passport-priority-ddp-zone-CI': 376.87,
                      'passport-priority-ddp-zone-EG': 366.4,
                      'passport-priority-ddp-zone-ET': 376.87,
                      'passport-priority-ddp-zone-GA': 376.87,
                      'passport-priority-ddp-zone-GM': 376.87,
                      'passport-priority-ddp-zone-GH': 376.87,
                      'passport-priority-ddp-zone-GN': 376.87,
                      'passport-priority-ddp-zone-ID': 334.7,
                      'passport-priority-ddp-zone-JO': 366.4,
                      'passport-priority-ddp-zone-KE': 376.87,
                      'passport-priority-ddp-zone-KW': 366.82,
                      'passport-priority-ddp-zone-LB': 366.4,
                      'passport-priority-ddp-zone-LI': 366.41,
                      'passport-priority-ddp-zone-MO': 333.63,
                      'passport-priority-ddp-zone-MG': 376.87,
                      'passport-priority-ddp-zone-MW': 376.87,
                      'passport-priority-ddp-zone-MY': 321.8,
                      'passport-priority-ddp-zone-MV': 332.78,
                      'passport-priority-ddp-zone-ML': 376.87,
                      'passport-priority-ddp-zone-MR': 376.87,
                      'passport-priority-ddp-zone-MU': 376.87,
                      'passport-priority-ddp-zone-MD': 376.87,
                      'passport-priority-ddp-zone-MA': 377.21,
                      'passport-priority-ddp-zone-MZ': 376.87,
                      'passport-priority-ddp-zone-NA': 376.87,
                      'passport-priority-ddp-zone-NP': 332.78,
                      'passport-priority-ddp-zone-NE': 376.87,
                      'passport-priority-ddp-zone-NG': 376.87,
                      'passport-priority-ddp-zone-PK': 332.78,
                      'passport-priority-ddp-zone-PH': 322.03,
                      'passport-priority-ddp-zone-RE': 376.87,
                      'passport-priority-ddp-zone-RW': 376.87,
                      'passport-priority-ddp-zone-SN': 376.87,
                      'passport-priority-ddp-zone-SC': 376.87,
                      'passport-priority-ddp-zone-ZA': 353.34,
                      'passport-priority-ddp-zone-LK': 332.78,
                      'passport-priority-ddp-zone-SZ': 376.87,
                      'passport-priority-ddp-zone-TW': 322.03,
                      'passport-priority-ddp-zone-TJ': 376.87,
                      'passport-priority-ddp-zone-TZ': 376.87,
                      'passport-priority-ddp-zone-TG': 376.87,
                      'passport-priority-ddp-zone-TN': 376.87,
                      'passport-priority-ddp-zone-TR': 366.43,
                      'passport-priority-ddp-zone-TM': 376.87,
                      'passport-priority-ddp-zone-UG': 376.87,
                      'passport-priority-ddp-zone-UA': 376.87,
                      'passport-priority-ddp-zone-VN': 322.21,
                      'passport-priority-ddp-zone-YE': 366.4,
                      'passport-priority-ddp-zone-ZM': 376.87,
                      'passport-priority-ddp-zone-ZW': 376.87,
                      'passport-priority-ddp-zone-MC': 148.27,
                      'passport-priority-ddp-zone-IM': 142.39,
                      'passport-priority-ddp-zone-SM': 148.27,
                    },
                    '33': {
                      'passport-priority-ddp-zone-CA': 75.07,
                      'passport-priority-ddp-zone-GB': 146.42,
                      'passport-priority-ddp-zone-AU': 209.33,
                      'passport-priority-ddp-zone-BE': 152.9,
                      'passport-priority-ddp-zone-DK': 152.9,
                      'passport-priority-ddp-zone-FR': 152.9,
                      'passport-priority-ddp-zone-DE': 152.9,
                      'passport-priority-ddp-zone-IT': 152.9,
                      'passport-priority-ddp-zone-NL': 152.9,
                      'passport-priority-ddp-zone-ES': 152.9,
                      'passport-priority-ddp-zone-MX': 191.4,
                      'passport-priority-ddp-zone-AM': 284.58,
                      'passport-priority-ddp-zone-AT': 156.35,
                      'passport-priority-ddp-zone-BG': 156.35,
                      'passport-priority-ddp-zone-HR': 156.35,
                      'passport-priority-ddp-zone-CY': 170.93,
                      'passport-priority-ddp-zone-CZ': 156.35,
                      'passport-priority-ddp-zone-EE': 156.35,
                      'passport-priority-ddp-zone-FI': 156.35,
                      'passport-priority-ddp-zone-GR': 169.02,
                      'passport-priority-ddp-zone-HU': 156.35,
                      'passport-priority-ddp-zone-IE': 156.35,
                      'passport-priority-ddp-zone-LV': 156.35,
                      'passport-priority-ddp-zone-LT': 156.35,
                      'passport-priority-ddp-zone-LU': 156.35,
                      'passport-priority-ddp-zone-MT': 170.93,
                      'passport-priority-ddp-zone-PL': 156.35,
                      'passport-priority-ddp-zone-PT': 156.35,
                      'passport-priority-ddp-zone-RO': 156.35,
                      'passport-priority-ddp-zone-SK': 156.35,
                      'passport-priority-ddp-zone-SI': 156.35,
                      'passport-priority-ddp-zone-SE': 156.35,
                      'passport-priority-ddp-zone-IL': 233.45,
                      'passport-priority-ddp-zone-OM': 241.1,
                      'passport-priority-ddp-zone-QA': 233.0,
                      'passport-priority-ddp-zone-SA': 233.03,
                      'passport-priority-ddp-zone-AE': 233.36,
                      'passport-priority-ddp-zone-CN': 325.17,
                      'passport-priority-ddp-zone-HK': 211.61,
                      'passport-priority-ddp-zone-IN': 249.82,
                      'passport-priority-ddp-zone-JP': 292.65,
                      'passport-priority-ddp-zone-KR': 243.25,
                      'passport-priority-ddp-zone-NZ': 211.43,
                      'passport-priority-ddp-zone-SG': 211.61,
                      'passport-priority-ddp-zone-TH': 213.0,
                      'passport-priority-ddp-zone-GG': 284.48,
                      'passport-priority-ddp-zone-JE': 284.48,
                      'passport-priority-ddp-zone-NO': 209.29,
                      'passport-priority-ddp-zone-CH': 209.74,
                      'passport-priority-ddp-zone-IS': 182.66,
                      'passport-priority-ddp-zone-AI': 230.2,
                      'passport-priority-ddp-zone-AG': 230.2,
                      'passport-priority-ddp-zone-AR': 278.55,
                      'passport-priority-ddp-zone-AW': 230.2,
                      'passport-priority-ddp-zone-BS': 230.2,
                      'passport-priority-ddp-zone-BB': 247.73,
                      'passport-priority-ddp-zone-BZ': 274.68,
                      'passport-priority-ddp-zone-BM': 230.58,
                      'passport-priority-ddp-zone-BO': 280.91,
                      'passport-priority-ddp-zone-BR': 209.74,
                      'passport-priority-ddp-zone-KY': 230.2,
                      'passport-priority-ddp-zone-CL': 237.76,
                      'passport-priority-ddp-zone-CO': 209.74,
                      'passport-priority-ddp-zone-CR': 279.1,
                      'passport-priority-ddp-zone-DM': 230.2,
                      'passport-priority-ddp-zone-DO': 231.08,
                      'passport-priority-ddp-zone-EC': 279.38,
                      'passport-priority-ddp-zone-SV': 274.68,
                      'passport-priority-ddp-zone-GP': 269.59,
                      'passport-priority-ddp-zone-GT': 274.78,
                      'passport-priority-ddp-zone-GY': 274.68,
                      'passport-priority-ddp-zone-HT': 230.2,
                      'passport-priority-ddp-zone-JM': 253.88,
                      'passport-priority-ddp-zone-MQ': 243.33,
                      'passport-priority-ddp-zone-AN': 230.2,
                      'passport-priority-ddp-zone-NI': 278.41,
                      'passport-priority-ddp-zone-PA': 275.01,
                      'passport-priority-ddp-zone-PY': 274.68,
                      'passport-priority-ddp-zone-PE': 277.27,
                      'passport-priority-ddp-zone-SR': 274.68,
                      'passport-priority-ddp-zone-TT': 236.78,
                      'passport-priority-ddp-zone-UY': 274.68,
                      'passport-priority-ddp-zone-AF': 388.65,
                      'passport-priority-ddp-zone-DZ': 388.65,
                      'passport-priority-ddp-zone-BH': 377.84,
                      'passport-priority-ddp-zone-BD': 343.19,
                      'passport-priority-ddp-zone-BT': 343.19,
                      'passport-priority-ddp-zone-BA': 388.65,
                      'passport-priority-ddp-zone-BW': 388.65,
                      'passport-priority-ddp-zone-BN': 377.84,
                      'passport-priority-ddp-zone-BF': 388.65,
                      'passport-priority-ddp-zone-BI': 388.65,
                      'passport-priority-ddp-zone-KH': 388.65,
                      'passport-priority-ddp-zone-CM': 388.65,
                      'passport-priority-ddp-zone-CV': 388.65,
                      'passport-priority-ddp-zone-TD': 388.65,
                      'passport-priority-ddp-zone-CG': 388.65,
                      'passport-priority-ddp-zone-CI': 388.65,
                      'passport-priority-ddp-zone-EG': 377.84,
                      'passport-priority-ddp-zone-ET': 388.65,
                      'passport-priority-ddp-zone-GA': 388.65,
                      'passport-priority-ddp-zone-GM': 388.65,
                      'passport-priority-ddp-zone-GH': 388.65,
                      'passport-priority-ddp-zone-GN': 388.65,
                      'passport-priority-ddp-zone-ID': 345.05,
                      'passport-priority-ddp-zone-JO': 377.84,
                      'passport-priority-ddp-zone-KE': 388.65,
                      'passport-priority-ddp-zone-KW': 378.29,
                      'passport-priority-ddp-zone-LB': 377.84,
                      'passport-priority-ddp-zone-LI': 377.84,
                      'passport-priority-ddp-zone-MO': 344.06,
                      'passport-priority-ddp-zone-MG': 388.65,
                      'passport-priority-ddp-zone-MW': 388.65,
                      'passport-priority-ddp-zone-MY': 331.85,
                      'passport-priority-ddp-zone-MV': 343.19,
                      'passport-priority-ddp-zone-ML': 388.65,
                      'passport-priority-ddp-zone-MR': 388.65,
                      'passport-priority-ddp-zone-MU': 388.65,
                      'passport-priority-ddp-zone-MD': 388.65,
                      'passport-priority-ddp-zone-MA': 389.01,
                      'passport-priority-ddp-zone-MZ': 388.65,
                      'passport-priority-ddp-zone-NA': 388.65,
                      'passport-priority-ddp-zone-NP': 343.19,
                      'passport-priority-ddp-zone-NE': 388.65,
                      'passport-priority-ddp-zone-NG': 388.65,
                      'passport-priority-ddp-zone-PK': 343.19,
                      'passport-priority-ddp-zone-PH': 332.11,
                      'passport-priority-ddp-zone-RE': 388.65,
                      'passport-priority-ddp-zone-RW': 388.65,
                      'passport-priority-ddp-zone-SN': 388.65,
                      'passport-priority-ddp-zone-SC': 388.65,
                      'passport-priority-ddp-zone-ZA': 364.38,
                      'passport-priority-ddp-zone-LK': 343.19,
                      'passport-priority-ddp-zone-SZ': 388.65,
                      'passport-priority-ddp-zone-TW': 332.11,
                      'passport-priority-ddp-zone-TJ': 388.65,
                      'passport-priority-ddp-zone-TZ': 388.65,
                      'passport-priority-ddp-zone-TG': 388.65,
                      'passport-priority-ddp-zone-TN': 388.65,
                      'passport-priority-ddp-zone-TR': 377.87,
                      'passport-priority-ddp-zone-TM': 388.65,
                      'passport-priority-ddp-zone-UG': 388.65,
                      'passport-priority-ddp-zone-UA': 388.65,
                      'passport-priority-ddp-zone-VN': 332.27,
                      'passport-priority-ddp-zone-YE': 377.84,
                      'passport-priority-ddp-zone-ZM': 388.65,
                      'passport-priority-ddp-zone-ZW': 388.65,
                      'passport-priority-ddp-zone-MC': 152.9,
                      'passport-priority-ddp-zone-IM': 147.02,
                      'passport-priority-ddp-zone-SM': 152.9,
                    },
                    '34': {
                      'passport-priority-ddp-zone-CA': 77.35,
                      'passport-priority-ddp-zone-GB': 150.85,
                      'passport-priority-ddp-zone-AU': 215.67,
                      'passport-priority-ddp-zone-BE': 157.53,
                      'passport-priority-ddp-zone-DK': 157.53,
                      'passport-priority-ddp-zone-FR': 157.53,
                      'passport-priority-ddp-zone-DE': 157.53,
                      'passport-priority-ddp-zone-IT': 157.53,
                      'passport-priority-ddp-zone-NL': 157.53,
                      'passport-priority-ddp-zone-ES': 157.53,
                      'passport-priority-ddp-zone-MX': 197.2,
                      'passport-priority-ddp-zone-AM': 293.2,
                      'passport-priority-ddp-zone-AT': 161.09,
                      'passport-priority-ddp-zone-BG': 161.09,
                      'passport-priority-ddp-zone-HR': 161.09,
                      'passport-priority-ddp-zone-CY': 176.11,
                      'passport-priority-ddp-zone-CZ': 161.09,
                      'passport-priority-ddp-zone-EE': 161.09,
                      'passport-priority-ddp-zone-FI': 161.09,
                      'passport-priority-ddp-zone-GR': 174.14,
                      'passport-priority-ddp-zone-HU': 161.09,
                      'passport-priority-ddp-zone-IE': 161.09,
                      'passport-priority-ddp-zone-LV': 161.09,
                      'passport-priority-ddp-zone-LT': 161.09,
                      'passport-priority-ddp-zone-LU': 161.09,
                      'passport-priority-ddp-zone-MT': 176.11,
                      'passport-priority-ddp-zone-PL': 161.09,
                      'passport-priority-ddp-zone-PT': 161.09,
                      'passport-priority-ddp-zone-RO': 161.09,
                      'passport-priority-ddp-zone-SK': 161.09,
                      'passport-priority-ddp-zone-SI': 161.09,
                      'passport-priority-ddp-zone-SE': 161.09,
                      'passport-priority-ddp-zone-IL': 240.52,
                      'passport-priority-ddp-zone-OM': 248.41,
                      'passport-priority-ddp-zone-QA': 240.06,
                      'passport-priority-ddp-zone-SA': 240.09,
                      'passport-priority-ddp-zone-AE': 240.43,
                      'passport-priority-ddp-zone-CN': 335.03,
                      'passport-priority-ddp-zone-HK': 218.03,
                      'passport-priority-ddp-zone-IN': 257.39,
                      'passport-priority-ddp-zone-JP': 301.52,
                      'passport-priority-ddp-zone-KR': 250.62,
                      'passport-priority-ddp-zone-NZ': 217.84,
                      'passport-priority-ddp-zone-SG': 218.03,
                      'passport-priority-ddp-zone-TH': 219.46,
                      'passport-priority-ddp-zone-GG': 293.1,
                      'passport-priority-ddp-zone-JE': 293.1,
                      'passport-priority-ddp-zone-NO': 215.62,
                      'passport-priority-ddp-zone-CH': 216.08,
                      'passport-priority-ddp-zone-IS': 188.19,
                      'passport-priority-ddp-zone-AI': 237.18,
                      'passport-priority-ddp-zone-AG': 237.18,
                      'passport-priority-ddp-zone-AR': 286.99,
                      'passport-priority-ddp-zone-AW': 237.18,
                      'passport-priority-ddp-zone-BS': 237.18,
                      'passport-priority-ddp-zone-BB': 255.25,
                      'passport-priority-ddp-zone-BZ': 283.0,
                      'passport-priority-ddp-zone-BM': 237.58,
                      'passport-priority-ddp-zone-BO': 289.42,
                      'passport-priority-ddp-zone-BR': 216.1,
                      'passport-priority-ddp-zone-KY': 237.18,
                      'passport-priority-ddp-zone-CL': 244.96,
                      'passport-priority-ddp-zone-CO': 216.1,
                      'passport-priority-ddp-zone-CR': 287.56,
                      'passport-priority-ddp-zone-DM': 237.18,
                      'passport-priority-ddp-zone-DO': 238.08,
                      'passport-priority-ddp-zone-EC': 287.85,
                      'passport-priority-ddp-zone-SV': 283.0,
                      'passport-priority-ddp-zone-GP': 277.77,
                      'passport-priority-ddp-zone-GT': 283.1,
                      'passport-priority-ddp-zone-GY': 283.0,
                      'passport-priority-ddp-zone-HT': 237.18,
                      'passport-priority-ddp-zone-JM': 261.59,
                      'passport-priority-ddp-zone-MQ': 250.71,
                      'passport-priority-ddp-zone-AN': 237.18,
                      'passport-priority-ddp-zone-NI': 286.84,
                      'passport-priority-ddp-zone-PA': 283.34,
                      'passport-priority-ddp-zone-PY': 283.0,
                      'passport-priority-ddp-zone-PE': 285.67,
                      'passport-priority-ddp-zone-SR': 283.0,
                      'passport-priority-ddp-zone-TT': 243.97,
                      'passport-priority-ddp-zone-UY': 283.0,
                      'passport-priority-ddp-zone-AF': 400.43,
                      'passport-priority-ddp-zone-DZ': 400.43,
                      'passport-priority-ddp-zone-BH': 389.28,
                      'passport-priority-ddp-zone-BD': 353.6,
                      'passport-priority-ddp-zone-BT': 353.6,
                      'passport-priority-ddp-zone-BA': 400.43,
                      'passport-priority-ddp-zone-BW': 400.43,
                      'passport-priority-ddp-zone-BN': 389.28,
                      'passport-priority-ddp-zone-BF': 400.43,
                      'passport-priority-ddp-zone-BI': 400.43,
                      'passport-priority-ddp-zone-KH': 400.43,
                      'passport-priority-ddp-zone-CM': 400.43,
                      'passport-priority-ddp-zone-CV': 400.43,
                      'passport-priority-ddp-zone-TD': 400.43,
                      'passport-priority-ddp-zone-CG': 400.43,
                      'passport-priority-ddp-zone-CI': 400.43,
                      'passport-priority-ddp-zone-EG': 389.28,
                      'passport-priority-ddp-zone-ET': 400.43,
                      'passport-priority-ddp-zone-GA': 400.43,
                      'passport-priority-ddp-zone-GM': 400.43,
                      'passport-priority-ddp-zone-GH': 400.43,
                      'passport-priority-ddp-zone-GN': 400.43,
                      'passport-priority-ddp-zone-ID': 355.4,
                      'passport-priority-ddp-zone-JO': 389.28,
                      'passport-priority-ddp-zone-KE': 400.43,
                      'passport-priority-ddp-zone-KW': 389.76,
                      'passport-priority-ddp-zone-LB': 389.28,
                      'passport-priority-ddp-zone-LI': 389.27,
                      'passport-priority-ddp-zone-MO': 354.49,
                      'passport-priority-ddp-zone-MG': 400.43,
                      'passport-priority-ddp-zone-MW': 400.43,
                      'passport-priority-ddp-zone-MY': 341.9,
                      'passport-priority-ddp-zone-MV': 353.6,
                      'passport-priority-ddp-zone-ML': 400.43,
                      'passport-priority-ddp-zone-MR': 400.43,
                      'passport-priority-ddp-zone-MU': 400.43,
                      'passport-priority-ddp-zone-MD': 400.43,
                      'passport-priority-ddp-zone-MA': 400.81,
                      'passport-priority-ddp-zone-MZ': 400.43,
                      'passport-priority-ddp-zone-NA': 400.43,
                      'passport-priority-ddp-zone-NP': 353.6,
                      'passport-priority-ddp-zone-NE': 400.43,
                      'passport-priority-ddp-zone-NG': 400.43,
                      'passport-priority-ddp-zone-PK': 353.6,
                      'passport-priority-ddp-zone-PH': 342.19,
                      'passport-priority-ddp-zone-RE': 400.43,
                      'passport-priority-ddp-zone-RW': 400.43,
                      'passport-priority-ddp-zone-SN': 400.43,
                      'passport-priority-ddp-zone-SC': 400.43,
                      'passport-priority-ddp-zone-ZA': 375.42,
                      'passport-priority-ddp-zone-LK': 353.6,
                      'passport-priority-ddp-zone-SZ': 400.43,
                      'passport-priority-ddp-zone-TW': 342.19,
                      'passport-priority-ddp-zone-TJ': 400.43,
                      'passport-priority-ddp-zone-TZ': 400.43,
                      'passport-priority-ddp-zone-TG': 400.43,
                      'passport-priority-ddp-zone-TN': 400.43,
                      'passport-priority-ddp-zone-TR': 389.31,
                      'passport-priority-ddp-zone-TM': 400.43,
                      'passport-priority-ddp-zone-UG': 400.43,
                      'passport-priority-ddp-zone-UA': 400.43,
                      'passport-priority-ddp-zone-VN': 342.33,
                      'passport-priority-ddp-zone-YE': 389.28,
                      'passport-priority-ddp-zone-ZM': 400.43,
                      'passport-priority-ddp-zone-ZW': 400.43,
                      'passport-priority-ddp-zone-MC': 157.53,
                      'passport-priority-ddp-zone-IM': 151.65,
                      'passport-priority-ddp-zone-SM': 157.53,
                    },
                    '35': {
                      'passport-priority-ddp-zone-CA': 79.63,
                      'passport-priority-ddp-zone-GB': 155.28,
                      'passport-priority-ddp-zone-AU': 222.01,
                      'passport-priority-ddp-zone-BE': 162.16,
                      'passport-priority-ddp-zone-DK': 162.16,
                      'passport-priority-ddp-zone-FR': 162.16,
                      'passport-priority-ddp-zone-DE': 162.16,
                      'passport-priority-ddp-zone-IT': 162.16,
                      'passport-priority-ddp-zone-NL': 162.16,
                      'passport-priority-ddp-zone-ES': 162.16,
                      'passport-priority-ddp-zone-MX': 203.0,
                      'passport-priority-ddp-zone-AM': 301.82,
                      'passport-priority-ddp-zone-AT': 165.83,
                      'passport-priority-ddp-zone-BG': 165.83,
                      'passport-priority-ddp-zone-HR': 165.83,
                      'passport-priority-ddp-zone-CY': 181.29,
                      'passport-priority-ddp-zone-CZ': 165.83,
                      'passport-priority-ddp-zone-EE': 165.83,
                      'passport-priority-ddp-zone-FI': 165.83,
                      'passport-priority-ddp-zone-GR': 179.26,
                      'passport-priority-ddp-zone-HU': 165.83,
                      'passport-priority-ddp-zone-IE': 165.83,
                      'passport-priority-ddp-zone-LV': 165.83,
                      'passport-priority-ddp-zone-LT': 165.83,
                      'passport-priority-ddp-zone-LU': 165.83,
                      'passport-priority-ddp-zone-MT': 181.29,
                      'passport-priority-ddp-zone-PL': 165.83,
                      'passport-priority-ddp-zone-PT': 165.83,
                      'passport-priority-ddp-zone-RO': 165.83,
                      'passport-priority-ddp-zone-SK': 165.83,
                      'passport-priority-ddp-zone-SI': 165.83,
                      'passport-priority-ddp-zone-SE': 165.83,
                      'passport-priority-ddp-zone-IL': 247.59,
                      'passport-priority-ddp-zone-OM': 255.72,
                      'passport-priority-ddp-zone-QA': 247.12,
                      'passport-priority-ddp-zone-SA': 247.15,
                      'passport-priority-ddp-zone-AE': 247.5,
                      'passport-priority-ddp-zone-CN': 344.89,
                      'passport-priority-ddp-zone-HK': 224.45,
                      'passport-priority-ddp-zone-IN': 264.96,
                      'passport-priority-ddp-zone-JP': 310.39,
                      'passport-priority-ddp-zone-KR': 257.99,
                      'passport-priority-ddp-zone-NZ': 224.25,
                      'passport-priority-ddp-zone-SG': 224.45,
                      'passport-priority-ddp-zone-TH': 225.92,
                      'passport-priority-ddp-zone-GG': 301.72,
                      'passport-priority-ddp-zone-JE': 301.72,
                      'passport-priority-ddp-zone-NO': 221.95,
                      'passport-priority-ddp-zone-CH': 222.42,
                      'passport-priority-ddp-zone-IS': 193.72,
                      'passport-priority-ddp-zone-AI': 244.16,
                      'passport-priority-ddp-zone-AG': 244.16,
                      'passport-priority-ddp-zone-AR': 295.43,
                      'passport-priority-ddp-zone-AW': 244.16,
                      'passport-priority-ddp-zone-BS': 244.16,
                      'passport-priority-ddp-zone-BB': 262.77,
                      'passport-priority-ddp-zone-BZ': 291.32,
                      'passport-priority-ddp-zone-BM': 244.58,
                      'passport-priority-ddp-zone-BO': 297.93,
                      'passport-priority-ddp-zone-BR': 222.46,
                      'passport-priority-ddp-zone-KY': 244.16,
                      'passport-priority-ddp-zone-CL': 252.16,
                      'passport-priority-ddp-zone-CO': 222.46,
                      'passport-priority-ddp-zone-CR': 296.02,
                      'passport-priority-ddp-zone-DM': 244.16,
                      'passport-priority-ddp-zone-DO': 245.08,
                      'passport-priority-ddp-zone-EC': 296.32,
                      'passport-priority-ddp-zone-SV': 291.32,
                      'passport-priority-ddp-zone-GP': 285.95,
                      'passport-priority-ddp-zone-GT': 291.42,
                      'passport-priority-ddp-zone-GY': 291.32,
                      'passport-priority-ddp-zone-HT': 244.16,
                      'passport-priority-ddp-zone-JM': 269.3,
                      'passport-priority-ddp-zone-MQ': 258.09,
                      'passport-priority-ddp-zone-AN': 244.16,
                      'passport-priority-ddp-zone-NI': 295.27,
                      'passport-priority-ddp-zone-PA': 291.67,
                      'passport-priority-ddp-zone-PY': 291.32,
                      'passport-priority-ddp-zone-PE': 294.07,
                      'passport-priority-ddp-zone-SR': 291.32,
                      'passport-priority-ddp-zone-TT': 251.16,
                      'passport-priority-ddp-zone-UY': 291.32,
                      'passport-priority-ddp-zone-AF': 412.21,
                      'passport-priority-ddp-zone-DZ': 412.21,
                      'passport-priority-ddp-zone-BH': 400.72,
                      'passport-priority-ddp-zone-BD': 364.01,
                      'passport-priority-ddp-zone-BT': 364.01,
                      'passport-priority-ddp-zone-BA': 412.21,
                      'passport-priority-ddp-zone-BW': 412.21,
                      'passport-priority-ddp-zone-BN': 400.72,
                      'passport-priority-ddp-zone-BF': 412.21,
                      'passport-priority-ddp-zone-BI': 412.21,
                      'passport-priority-ddp-zone-KH': 412.21,
                      'passport-priority-ddp-zone-CM': 412.21,
                      'passport-priority-ddp-zone-CV': 412.21,
                      'passport-priority-ddp-zone-TD': 412.21,
                      'passport-priority-ddp-zone-CG': 412.21,
                      'passport-priority-ddp-zone-CI': 412.21,
                      'passport-priority-ddp-zone-EG': 400.72,
                      'passport-priority-ddp-zone-ET': 412.21,
                      'passport-priority-ddp-zone-GA': 412.21,
                      'passport-priority-ddp-zone-GM': 412.21,
                      'passport-priority-ddp-zone-GH': 412.21,
                      'passport-priority-ddp-zone-GN': 412.21,
                      'passport-priority-ddp-zone-ID': 365.75,
                      'passport-priority-ddp-zone-JO': 400.72,
                      'passport-priority-ddp-zone-KE': 412.21,
                      'passport-priority-ddp-zone-KW': 401.23,
                      'passport-priority-ddp-zone-LB': 400.72,
                      'passport-priority-ddp-zone-LI': 400.7,
                      'passport-priority-ddp-zone-MO': 364.92,
                      'passport-priority-ddp-zone-MG': 412.21,
                      'passport-priority-ddp-zone-MW': 412.21,
                      'passport-priority-ddp-zone-MY': 351.95,
                      'passport-priority-ddp-zone-MV': 364.01,
                      'passport-priority-ddp-zone-ML': 412.21,
                      'passport-priority-ddp-zone-MR': 412.21,
                      'passport-priority-ddp-zone-MU': 412.21,
                      'passport-priority-ddp-zone-MD': 412.21,
                      'passport-priority-ddp-zone-MA': 412.61,
                      'passport-priority-ddp-zone-MZ': 412.21,
                      'passport-priority-ddp-zone-NA': 412.21,
                      'passport-priority-ddp-zone-NP': 364.01,
                      'passport-priority-ddp-zone-NE': 412.21,
                      'passport-priority-ddp-zone-NG': 412.21,
                      'passport-priority-ddp-zone-PK': 364.01,
                      'passport-priority-ddp-zone-PH': 352.27,
                      'passport-priority-ddp-zone-RE': 412.21,
                      'passport-priority-ddp-zone-RW': 412.21,
                      'passport-priority-ddp-zone-SN': 412.21,
                      'passport-priority-ddp-zone-SC': 412.21,
                      'passport-priority-ddp-zone-ZA': 386.46,
                      'passport-priority-ddp-zone-LK': 364.01,
                      'passport-priority-ddp-zone-SZ': 412.21,
                      'passport-priority-ddp-zone-TW': 352.27,
                      'passport-priority-ddp-zone-TJ': 412.21,
                      'passport-priority-ddp-zone-TZ': 412.21,
                      'passport-priority-ddp-zone-TG': 412.21,
                      'passport-priority-ddp-zone-TN': 412.21,
                      'passport-priority-ddp-zone-TR': 400.75,
                      'passport-priority-ddp-zone-TM': 412.21,
                      'passport-priority-ddp-zone-UG': 412.21,
                      'passport-priority-ddp-zone-UA': 412.21,
                      'passport-priority-ddp-zone-VN': 352.39,
                      'passport-priority-ddp-zone-YE': 400.72,
                      'passport-priority-ddp-zone-ZM': 412.21,
                      'passport-priority-ddp-zone-ZW': 412.21,
                      'passport-priority-ddp-zone-MC': 162.16,
                      'passport-priority-ddp-zone-IM': 156.28,
                      'passport-priority-ddp-zone-SM': 162.16,
                    },
                    '36': {
                      'passport-priority-ddp-zone-CA': 81.91,
                      'passport-priority-ddp-zone-GB': 159.71,
                      'passport-priority-ddp-zone-AU': 228.35,
                      'passport-priority-ddp-zone-BE': 166.79,
                      'passport-priority-ddp-zone-DK': 166.79,
                      'passport-priority-ddp-zone-FR': 166.79,
                      'passport-priority-ddp-zone-DE': 166.79,
                      'passport-priority-ddp-zone-IT': 166.79,
                      'passport-priority-ddp-zone-NL': 166.79,
                      'passport-priority-ddp-zone-ES': 166.79,
                      'passport-priority-ddp-zone-MX': 208.8,
                      'passport-priority-ddp-zone-AM': 310.44,
                      'passport-priority-ddp-zone-AT': 170.57,
                      'passport-priority-ddp-zone-BG': 170.57,
                      'passport-priority-ddp-zone-HR': 170.57,
                      'passport-priority-ddp-zone-CY': 186.47,
                      'passport-priority-ddp-zone-CZ': 170.57,
                      'passport-priority-ddp-zone-EE': 170.57,
                      'passport-priority-ddp-zone-FI': 170.57,
                      'passport-priority-ddp-zone-GR': 184.38,
                      'passport-priority-ddp-zone-HU': 170.57,
                      'passport-priority-ddp-zone-IE': 170.57,
                      'passport-priority-ddp-zone-LV': 170.57,
                      'passport-priority-ddp-zone-LT': 170.57,
                      'passport-priority-ddp-zone-LU': 170.57,
                      'passport-priority-ddp-zone-MT': 186.47,
                      'passport-priority-ddp-zone-PL': 170.57,
                      'passport-priority-ddp-zone-PT': 170.57,
                      'passport-priority-ddp-zone-RO': 170.57,
                      'passport-priority-ddp-zone-SK': 170.57,
                      'passport-priority-ddp-zone-SI': 170.57,
                      'passport-priority-ddp-zone-SE': 170.57,
                      'passport-priority-ddp-zone-IL': 254.66,
                      'passport-priority-ddp-zone-OM': 263.03,
                      'passport-priority-ddp-zone-QA': 254.18,
                      'passport-priority-ddp-zone-SA': 254.21,
                      'passport-priority-ddp-zone-AE': 254.57,
                      'passport-priority-ddp-zone-CN': 354.75,
                      'passport-priority-ddp-zone-HK': 230.87,
                      'passport-priority-ddp-zone-IN': 272.53,
                      'passport-priority-ddp-zone-JP': 319.26,
                      'passport-priority-ddp-zone-KR': 265.36,
                      'passport-priority-ddp-zone-NZ': 230.66,
                      'passport-priority-ddp-zone-SG': 230.87,
                      'passport-priority-ddp-zone-TH': 232.38,
                      'passport-priority-ddp-zone-GG': 310.34,
                      'passport-priority-ddp-zone-JE': 310.34,
                      'passport-priority-ddp-zone-NO': 228.28,
                      'passport-priority-ddp-zone-CH': 228.76,
                      'passport-priority-ddp-zone-IS': 199.25,
                      'passport-priority-ddp-zone-AI': 251.14,
                      'passport-priority-ddp-zone-AG': 251.14,
                      'passport-priority-ddp-zone-AR': 303.87,
                      'passport-priority-ddp-zone-AW': 251.14,
                      'passport-priority-ddp-zone-BS': 251.14,
                      'passport-priority-ddp-zone-BB': 270.29,
                      'passport-priority-ddp-zone-BZ': 299.64,
                      'passport-priority-ddp-zone-BM': 251.58,
                      'passport-priority-ddp-zone-BO': 306.44,
                      'passport-priority-ddp-zone-BR': 228.82,
                      'passport-priority-ddp-zone-KY': 251.14,
                      'passport-priority-ddp-zone-CL': 259.36,
                      'passport-priority-ddp-zone-CO': 228.82,
                      'passport-priority-ddp-zone-CR': 304.48,
                      'passport-priority-ddp-zone-DM': 251.14,
                      'passport-priority-ddp-zone-DO': 252.08,
                      'passport-priority-ddp-zone-EC': 304.79,
                      'passport-priority-ddp-zone-SV': 299.64,
                      'passport-priority-ddp-zone-GP': 294.13,
                      'passport-priority-ddp-zone-GT': 299.74,
                      'passport-priority-ddp-zone-GY': 299.64,
                      'passport-priority-ddp-zone-HT': 251.14,
                      'passport-priority-ddp-zone-JM': 277.01,
                      'passport-priority-ddp-zone-MQ': 265.47,
                      'passport-priority-ddp-zone-AN': 251.14,
                      'passport-priority-ddp-zone-NI': 303.7,
                      'passport-priority-ddp-zone-PA': 300.0,
                      'passport-priority-ddp-zone-PY': 299.64,
                      'passport-priority-ddp-zone-PE': 302.47,
                      'passport-priority-ddp-zone-SR': 299.64,
                      'passport-priority-ddp-zone-TT': 258.35,
                      'passport-priority-ddp-zone-UY': 299.64,
                      'passport-priority-ddp-zone-AF': 423.99,
                      'passport-priority-ddp-zone-DZ': 423.99,
                      'passport-priority-ddp-zone-BH': 412.16,
                      'passport-priority-ddp-zone-BD': 374.42,
                      'passport-priority-ddp-zone-BT': 374.42,
                      'passport-priority-ddp-zone-BA': 423.99,
                      'passport-priority-ddp-zone-BW': 423.99,
                      'passport-priority-ddp-zone-BN': 412.16,
                      'passport-priority-ddp-zone-BF': 423.99,
                      'passport-priority-ddp-zone-BI': 423.99,
                      'passport-priority-ddp-zone-KH': 423.99,
                      'passport-priority-ddp-zone-CM': 423.99,
                      'passport-priority-ddp-zone-CV': 423.99,
                      'passport-priority-ddp-zone-TD': 423.99,
                      'passport-priority-ddp-zone-CG': 423.99,
                      'passport-priority-ddp-zone-CI': 423.99,
                      'passport-priority-ddp-zone-EG': 412.16,
                      'passport-priority-ddp-zone-ET': 423.99,
                      'passport-priority-ddp-zone-GA': 423.99,
                      'passport-priority-ddp-zone-GM': 423.99,
                      'passport-priority-ddp-zone-GH': 423.99,
                      'passport-priority-ddp-zone-GN': 423.99,
                      'passport-priority-ddp-zone-ID': 376.1,
                      'passport-priority-ddp-zone-JO': 412.16,
                      'passport-priority-ddp-zone-KE': 423.99,
                      'passport-priority-ddp-zone-KW': 412.7,
                      'passport-priority-ddp-zone-LB': 412.16,
                      'passport-priority-ddp-zone-LI': 412.13,
                      'passport-priority-ddp-zone-MO': 375.35,
                      'passport-priority-ddp-zone-MG': 423.99,
                      'passport-priority-ddp-zone-MW': 423.99,
                      'passport-priority-ddp-zone-MY': 362.0,
                      'passport-priority-ddp-zone-MV': 374.42,
                      'passport-priority-ddp-zone-ML': 423.99,
                      'passport-priority-ddp-zone-MR': 423.99,
                      'passport-priority-ddp-zone-MU': 423.99,
                      'passport-priority-ddp-zone-MD': 423.99,
                      'passport-priority-ddp-zone-MA': 424.41,
                      'passport-priority-ddp-zone-MZ': 423.99,
                      'passport-priority-ddp-zone-NA': 423.99,
                      'passport-priority-ddp-zone-NP': 374.42,
                      'passport-priority-ddp-zone-NE': 423.99,
                      'passport-priority-ddp-zone-NG': 423.99,
                      'passport-priority-ddp-zone-PK': 374.42,
                      'passport-priority-ddp-zone-PH': 362.35,
                      'passport-priority-ddp-zone-RE': 423.99,
                      'passport-priority-ddp-zone-RW': 423.99,
                      'passport-priority-ddp-zone-SN': 423.99,
                      'passport-priority-ddp-zone-SC': 423.99,
                      'passport-priority-ddp-zone-ZA': 397.5,
                      'passport-priority-ddp-zone-LK': 374.42,
                      'passport-priority-ddp-zone-SZ': 423.99,
                      'passport-priority-ddp-zone-TW': 362.35,
                      'passport-priority-ddp-zone-TJ': 423.99,
                      'passport-priority-ddp-zone-TZ': 423.99,
                      'passport-priority-ddp-zone-TG': 423.99,
                      'passport-priority-ddp-zone-TN': 423.99,
                      'passport-priority-ddp-zone-TR': 412.19,
                      'passport-priority-ddp-zone-TM': 423.99,
                      'passport-priority-ddp-zone-UG': 423.99,
                      'passport-priority-ddp-zone-UA': 423.99,
                      'passport-priority-ddp-zone-VN': 362.45,
                      'passport-priority-ddp-zone-YE': 412.16,
                      'passport-priority-ddp-zone-ZM': 423.99,
                      'passport-priority-ddp-zone-ZW': 423.99,
                      'passport-priority-ddp-zone-MC': 166.79,
                      'passport-priority-ddp-zone-IM': 160.91,
                      'passport-priority-ddp-zone-SM': 166.79,
                    },
                    '37': {
                      'passport-priority-ddp-zone-CA': 84.19,
                      'passport-priority-ddp-zone-GB': 164.14,
                      'passport-priority-ddp-zone-AU': 234.69,
                      'passport-priority-ddp-zone-BE': 171.42,
                      'passport-priority-ddp-zone-DK': 171.42,
                      'passport-priority-ddp-zone-FR': 171.42,
                      'passport-priority-ddp-zone-DE': 171.42,
                      'passport-priority-ddp-zone-IT': 171.42,
                      'passport-priority-ddp-zone-NL': 171.42,
                      'passport-priority-ddp-zone-ES': 171.42,
                      'passport-priority-ddp-zone-MX': 214.6,
                      'passport-priority-ddp-zone-AM': 319.06,
                      'passport-priority-ddp-zone-AT': 175.31,
                      'passport-priority-ddp-zone-BG': 175.31,
                      'passport-priority-ddp-zone-HR': 175.31,
                      'passport-priority-ddp-zone-CY': 191.65,
                      'passport-priority-ddp-zone-CZ': 175.31,
                      'passport-priority-ddp-zone-EE': 175.31,
                      'passport-priority-ddp-zone-FI': 175.31,
                      'passport-priority-ddp-zone-GR': 189.5,
                      'passport-priority-ddp-zone-HU': 175.31,
                      'passport-priority-ddp-zone-IE': 175.31,
                      'passport-priority-ddp-zone-LV': 175.31,
                      'passport-priority-ddp-zone-LT': 175.31,
                      'passport-priority-ddp-zone-LU': 175.31,
                      'passport-priority-ddp-zone-MT': 191.65,
                      'passport-priority-ddp-zone-PL': 175.31,
                      'passport-priority-ddp-zone-PT': 175.31,
                      'passport-priority-ddp-zone-RO': 175.31,
                      'passport-priority-ddp-zone-SK': 175.31,
                      'passport-priority-ddp-zone-SI': 175.31,
                      'passport-priority-ddp-zone-SE': 175.31,
                      'passport-priority-ddp-zone-IL': 261.73,
                      'passport-priority-ddp-zone-OM': 270.34,
                      'passport-priority-ddp-zone-QA': 261.24,
                      'passport-priority-ddp-zone-SA': 261.27,
                      'passport-priority-ddp-zone-AE': 261.64,
                      'passport-priority-ddp-zone-CN': 364.61,
                      'passport-priority-ddp-zone-HK': 237.29,
                      'passport-priority-ddp-zone-IN': 280.1,
                      'passport-priority-ddp-zone-JP': 328.13,
                      'passport-priority-ddp-zone-KR': 272.73,
                      'passport-priority-ddp-zone-NZ': 237.07,
                      'passport-priority-ddp-zone-SG': 237.29,
                      'passport-priority-ddp-zone-TH': 238.84,
                      'passport-priority-ddp-zone-GG': 318.96,
                      'passport-priority-ddp-zone-JE': 318.96,
                      'passport-priority-ddp-zone-NO': 234.61,
                      'passport-priority-ddp-zone-CH': 235.1,
                      'passport-priority-ddp-zone-IS': 204.78,
                      'passport-priority-ddp-zone-AI': 258.12,
                      'passport-priority-ddp-zone-AG': 258.12,
                      'passport-priority-ddp-zone-AR': 312.31,
                      'passport-priority-ddp-zone-AW': 258.12,
                      'passport-priority-ddp-zone-BS': 258.12,
                      'passport-priority-ddp-zone-BB': 277.81,
                      'passport-priority-ddp-zone-BZ': 307.96,
                      'passport-priority-ddp-zone-BM': 258.58,
                      'passport-priority-ddp-zone-BO': 314.95,
                      'passport-priority-ddp-zone-BR': 235.18,
                      'passport-priority-ddp-zone-KY': 258.12,
                      'passport-priority-ddp-zone-CL': 266.56,
                      'passport-priority-ddp-zone-CO': 235.18,
                      'passport-priority-ddp-zone-CR': 312.94,
                      'passport-priority-ddp-zone-DM': 258.12,
                      'passport-priority-ddp-zone-DO': 259.08,
                      'passport-priority-ddp-zone-EC': 313.26,
                      'passport-priority-ddp-zone-SV': 307.96,
                      'passport-priority-ddp-zone-GP': 302.31,
                      'passport-priority-ddp-zone-GT': 308.06,
                      'passport-priority-ddp-zone-GY': 307.96,
                      'passport-priority-ddp-zone-HT': 258.12,
                      'passport-priority-ddp-zone-JM': 284.72,
                      'passport-priority-ddp-zone-MQ': 272.85,
                      'passport-priority-ddp-zone-AN': 258.12,
                      'passport-priority-ddp-zone-NI': 312.13,
                      'passport-priority-ddp-zone-PA': 308.33,
                      'passport-priority-ddp-zone-PY': 307.96,
                      'passport-priority-ddp-zone-PE': 310.87,
                      'passport-priority-ddp-zone-SR': 307.96,
                      'passport-priority-ddp-zone-TT': 265.54,
                      'passport-priority-ddp-zone-UY': 307.96,
                      'passport-priority-ddp-zone-AF': 435.77,
                      'passport-priority-ddp-zone-DZ': 435.77,
                      'passport-priority-ddp-zone-BH': 423.6,
                      'passport-priority-ddp-zone-BD': 384.83,
                      'passport-priority-ddp-zone-BT': 384.83,
                      'passport-priority-ddp-zone-BA': 435.77,
                      'passport-priority-ddp-zone-BW': 435.77,
                      'passport-priority-ddp-zone-BN': 423.6,
                      'passport-priority-ddp-zone-BF': 435.77,
                      'passport-priority-ddp-zone-BI': 435.77,
                      'passport-priority-ddp-zone-KH': 435.77,
                      'passport-priority-ddp-zone-CM': 435.77,
                      'passport-priority-ddp-zone-CV': 435.77,
                      'passport-priority-ddp-zone-TD': 435.77,
                      'passport-priority-ddp-zone-CG': 435.77,
                      'passport-priority-ddp-zone-CI': 435.77,
                      'passport-priority-ddp-zone-EG': 423.6,
                      'passport-priority-ddp-zone-ET': 435.77,
                      'passport-priority-ddp-zone-GA': 435.77,
                      'passport-priority-ddp-zone-GM': 435.77,
                      'passport-priority-ddp-zone-GH': 435.77,
                      'passport-priority-ddp-zone-GN': 435.77,
                      'passport-priority-ddp-zone-ID': 386.45,
                      'passport-priority-ddp-zone-JO': 423.6,
                      'passport-priority-ddp-zone-KE': 435.77,
                      'passport-priority-ddp-zone-KW': 424.17,
                      'passport-priority-ddp-zone-LB': 423.6,
                      'passport-priority-ddp-zone-LI': 423.56,
                      'passport-priority-ddp-zone-MO': 385.78,
                      'passport-priority-ddp-zone-MG': 435.77,
                      'passport-priority-ddp-zone-MW': 435.77,
                      'passport-priority-ddp-zone-MY': 372.05,
                      'passport-priority-ddp-zone-MV': 384.83,
                      'passport-priority-ddp-zone-ML': 435.77,
                      'passport-priority-ddp-zone-MR': 435.77,
                      'passport-priority-ddp-zone-MU': 435.77,
                      'passport-priority-ddp-zone-MD': 435.77,
                      'passport-priority-ddp-zone-MA': 436.21,
                      'passport-priority-ddp-zone-MZ': 435.77,
                      'passport-priority-ddp-zone-NA': 435.77,
                      'passport-priority-ddp-zone-NP': 384.83,
                      'passport-priority-ddp-zone-NE': 435.77,
                      'passport-priority-ddp-zone-NG': 435.77,
                      'passport-priority-ddp-zone-PK': 384.83,
                      'passport-priority-ddp-zone-PH': 372.43,
                      'passport-priority-ddp-zone-RE': 435.77,
                      'passport-priority-ddp-zone-RW': 435.77,
                      'passport-priority-ddp-zone-SN': 435.77,
                      'passport-priority-ddp-zone-SC': 435.77,
                      'passport-priority-ddp-zone-ZA': 408.54,
                      'passport-priority-ddp-zone-LK': 384.83,
                      'passport-priority-ddp-zone-SZ': 435.77,
                      'passport-priority-ddp-zone-TW': 372.43,
                      'passport-priority-ddp-zone-TJ': 435.77,
                      'passport-priority-ddp-zone-TZ': 435.77,
                      'passport-priority-ddp-zone-TG': 435.77,
                      'passport-priority-ddp-zone-TN': 435.77,
                      'passport-priority-ddp-zone-TR': 423.63,
                      'passport-priority-ddp-zone-TM': 435.77,
                      'passport-priority-ddp-zone-UG': 435.77,
                      'passport-priority-ddp-zone-UA': 435.77,
                      'passport-priority-ddp-zone-VN': 372.51,
                      'passport-priority-ddp-zone-YE': 423.6,
                      'passport-priority-ddp-zone-ZM': 435.77,
                      'passport-priority-ddp-zone-ZW': 435.77,
                      'passport-priority-ddp-zone-MC': 171.42,
                      'passport-priority-ddp-zone-IM': 165.54,
                      'passport-priority-ddp-zone-SM': 171.42,
                    },
                    '38': {
                      'passport-priority-ddp-zone-CA': 86.47,
                      'passport-priority-ddp-zone-GB': 168.57,
                      'passport-priority-ddp-zone-AU': 241.03,
                      'passport-priority-ddp-zone-BE': 176.05,
                      'passport-priority-ddp-zone-DK': 176.05,
                      'passport-priority-ddp-zone-FR': 176.05,
                      'passport-priority-ddp-zone-DE': 176.05,
                      'passport-priority-ddp-zone-IT': 176.05,
                      'passport-priority-ddp-zone-NL': 176.05,
                      'passport-priority-ddp-zone-ES': 176.05,
                      'passport-priority-ddp-zone-MX': 220.4,
                      'passport-priority-ddp-zone-AM': 327.68,
                      'passport-priority-ddp-zone-AT': 180.05,
                      'passport-priority-ddp-zone-BG': 180.05,
                      'passport-priority-ddp-zone-HR': 180.05,
                      'passport-priority-ddp-zone-CY': 196.83,
                      'passport-priority-ddp-zone-CZ': 180.05,
                      'passport-priority-ddp-zone-EE': 180.05,
                      'passport-priority-ddp-zone-FI': 180.05,
                      'passport-priority-ddp-zone-GR': 194.62,
                      'passport-priority-ddp-zone-HU': 180.05,
                      'passport-priority-ddp-zone-IE': 180.05,
                      'passport-priority-ddp-zone-LV': 180.05,
                      'passport-priority-ddp-zone-LT': 180.05,
                      'passport-priority-ddp-zone-LU': 180.05,
                      'passport-priority-ddp-zone-MT': 196.83,
                      'passport-priority-ddp-zone-PL': 180.05,
                      'passport-priority-ddp-zone-PT': 180.05,
                      'passport-priority-ddp-zone-RO': 180.05,
                      'passport-priority-ddp-zone-SK': 180.05,
                      'passport-priority-ddp-zone-SI': 180.05,
                      'passport-priority-ddp-zone-SE': 180.05,
                      'passport-priority-ddp-zone-IL': 268.8,
                      'passport-priority-ddp-zone-OM': 277.65,
                      'passport-priority-ddp-zone-QA': 268.3,
                      'passport-priority-ddp-zone-SA': 268.33,
                      'passport-priority-ddp-zone-AE': 268.71,
                      'passport-priority-ddp-zone-CN': 374.47,
                      'passport-priority-ddp-zone-HK': 243.71,
                      'passport-priority-ddp-zone-IN': 287.67,
                      'passport-priority-ddp-zone-JP': 337.0,
                      'passport-priority-ddp-zone-KR': 280.1,
                      'passport-priority-ddp-zone-NZ': 243.48,
                      'passport-priority-ddp-zone-SG': 243.71,
                      'passport-priority-ddp-zone-TH': 245.3,
                      'passport-priority-ddp-zone-GG': 327.58,
                      'passport-priority-ddp-zone-JE': 327.58,
                      'passport-priority-ddp-zone-NO': 240.94,
                      'passport-priority-ddp-zone-CH': 241.44,
                      'passport-priority-ddp-zone-IS': 210.31,
                      'passport-priority-ddp-zone-AI': 265.1,
                      'passport-priority-ddp-zone-AG': 265.1,
                      'passport-priority-ddp-zone-AR': 320.75,
                      'passport-priority-ddp-zone-AW': 265.1,
                      'passport-priority-ddp-zone-BS': 265.1,
                      'passport-priority-ddp-zone-BB': 285.33,
                      'passport-priority-ddp-zone-BZ': 316.28,
                      'passport-priority-ddp-zone-BM': 265.58,
                      'passport-priority-ddp-zone-BO': 323.46,
                      'passport-priority-ddp-zone-BR': 241.54,
                      'passport-priority-ddp-zone-KY': 265.1,
                      'passport-priority-ddp-zone-CL': 273.76,
                      'passport-priority-ddp-zone-CO': 241.54,
                      'passport-priority-ddp-zone-CR': 321.4,
                      'passport-priority-ddp-zone-DM': 265.1,
                      'passport-priority-ddp-zone-DO': 266.08,
                      'passport-priority-ddp-zone-EC': 321.73,
                      'passport-priority-ddp-zone-SV': 316.28,
                      'passport-priority-ddp-zone-GP': 310.49,
                      'passport-priority-ddp-zone-GT': 316.38,
                      'passport-priority-ddp-zone-GY': 316.28,
                      'passport-priority-ddp-zone-HT': 265.1,
                      'passport-priority-ddp-zone-JM': 292.43,
                      'passport-priority-ddp-zone-MQ': 280.23,
                      'passport-priority-ddp-zone-AN': 265.1,
                      'passport-priority-ddp-zone-NI': 320.56,
                      'passport-priority-ddp-zone-PA': 316.66,
                      'passport-priority-ddp-zone-PY': 316.28,
                      'passport-priority-ddp-zone-PE': 319.27,
                      'passport-priority-ddp-zone-SR': 316.28,
                      'passport-priority-ddp-zone-TT': 272.73,
                      'passport-priority-ddp-zone-UY': 316.28,
                      'passport-priority-ddp-zone-AF': 447.55,
                      'passport-priority-ddp-zone-DZ': 447.55,
                      'passport-priority-ddp-zone-BH': 435.04,
                      'passport-priority-ddp-zone-BD': 395.24,
                      'passport-priority-ddp-zone-BT': 395.24,
                      'passport-priority-ddp-zone-BA': 447.55,
                      'passport-priority-ddp-zone-BW': 447.55,
                      'passport-priority-ddp-zone-BN': 435.04,
                      'passport-priority-ddp-zone-BF': 447.55,
                      'passport-priority-ddp-zone-BI': 447.55,
                      'passport-priority-ddp-zone-KH': 447.55,
                      'passport-priority-ddp-zone-CM': 447.55,
                      'passport-priority-ddp-zone-CV': 447.55,
                      'passport-priority-ddp-zone-TD': 447.55,
                      'passport-priority-ddp-zone-CG': 447.55,
                      'passport-priority-ddp-zone-CI': 447.55,
                      'passport-priority-ddp-zone-EG': 435.04,
                      'passport-priority-ddp-zone-ET': 447.55,
                      'passport-priority-ddp-zone-GA': 447.55,
                      'passport-priority-ddp-zone-GM': 447.55,
                      'passport-priority-ddp-zone-GH': 447.55,
                      'passport-priority-ddp-zone-GN': 447.55,
                      'passport-priority-ddp-zone-ID': 396.8,
                      'passport-priority-ddp-zone-JO': 435.04,
                      'passport-priority-ddp-zone-KE': 447.55,
                      'passport-priority-ddp-zone-KW': 435.64,
                      'passport-priority-ddp-zone-LB': 435.04,
                      'passport-priority-ddp-zone-LI': 434.99,
                      'passport-priority-ddp-zone-MO': 396.21,
                      'passport-priority-ddp-zone-MG': 447.55,
                      'passport-priority-ddp-zone-MW': 447.55,
                      'passport-priority-ddp-zone-MY': 382.1,
                      'passport-priority-ddp-zone-MV': 395.24,
                      'passport-priority-ddp-zone-ML': 447.55,
                      'passport-priority-ddp-zone-MR': 447.55,
                      'passport-priority-ddp-zone-MU': 447.55,
                      'passport-priority-ddp-zone-MD': 447.55,
                      'passport-priority-ddp-zone-MA': 448.01,
                      'passport-priority-ddp-zone-MZ': 447.55,
                      'passport-priority-ddp-zone-NA': 447.55,
                      'passport-priority-ddp-zone-NP': 395.24,
                      'passport-priority-ddp-zone-NE': 447.55,
                      'passport-priority-ddp-zone-NG': 447.55,
                      'passport-priority-ddp-zone-PK': 395.24,
                      'passport-priority-ddp-zone-PH': 382.51,
                      'passport-priority-ddp-zone-RE': 447.55,
                      'passport-priority-ddp-zone-RW': 447.55,
                      'passport-priority-ddp-zone-SN': 447.55,
                      'passport-priority-ddp-zone-SC': 447.55,
                      'passport-priority-ddp-zone-ZA': 419.58,
                      'passport-priority-ddp-zone-LK': 395.24,
                      'passport-priority-ddp-zone-SZ': 447.55,
                      'passport-priority-ddp-zone-TW': 382.51,
                      'passport-priority-ddp-zone-TJ': 447.55,
                      'passport-priority-ddp-zone-TZ': 447.55,
                      'passport-priority-ddp-zone-TG': 447.55,
                      'passport-priority-ddp-zone-TN': 447.55,
                      'passport-priority-ddp-zone-TR': 435.07,
                      'passport-priority-ddp-zone-TM': 447.55,
                      'passport-priority-ddp-zone-UG': 447.55,
                      'passport-priority-ddp-zone-UA': 447.55,
                      'passport-priority-ddp-zone-VN': 382.57,
                      'passport-priority-ddp-zone-YE': 435.04,
                      'passport-priority-ddp-zone-ZM': 447.55,
                      'passport-priority-ddp-zone-ZW': 447.55,
                      'passport-priority-ddp-zone-MC': 176.05,
                      'passport-priority-ddp-zone-IM': 170.17,
                      'passport-priority-ddp-zone-SM': 176.05,
                    },
                    '39': {
                      'passport-priority-ddp-zone-CA': 88.75,
                      'passport-priority-ddp-zone-GB': 173.0,
                      'passport-priority-ddp-zone-AU': 247.37,
                      'passport-priority-ddp-zone-BE': 180.68,
                      'passport-priority-ddp-zone-DK': 180.68,
                      'passport-priority-ddp-zone-FR': 180.68,
                      'passport-priority-ddp-zone-DE': 180.68,
                      'passport-priority-ddp-zone-IT': 180.68,
                      'passport-priority-ddp-zone-NL': 180.68,
                      'passport-priority-ddp-zone-ES': 180.68,
                      'passport-priority-ddp-zone-MX': 226.2,
                      'passport-priority-ddp-zone-AM': 336.3,
                      'passport-priority-ddp-zone-AT': 184.79,
                      'passport-priority-ddp-zone-BG': 184.79,
                      'passport-priority-ddp-zone-HR': 184.79,
                      'passport-priority-ddp-zone-CY': 202.01,
                      'passport-priority-ddp-zone-CZ': 184.79,
                      'passport-priority-ddp-zone-EE': 184.79,
                      'passport-priority-ddp-zone-FI': 184.79,
                      'passport-priority-ddp-zone-GR': 199.74,
                      'passport-priority-ddp-zone-HU': 184.79,
                      'passport-priority-ddp-zone-IE': 184.79,
                      'passport-priority-ddp-zone-LV': 184.79,
                      'passport-priority-ddp-zone-LT': 184.79,
                      'passport-priority-ddp-zone-LU': 184.79,
                      'passport-priority-ddp-zone-MT': 202.01,
                      'passport-priority-ddp-zone-PL': 184.79,
                      'passport-priority-ddp-zone-PT': 184.79,
                      'passport-priority-ddp-zone-RO': 184.79,
                      'passport-priority-ddp-zone-SK': 184.79,
                      'passport-priority-ddp-zone-SI': 184.79,
                      'passport-priority-ddp-zone-SE': 184.79,
                      'passport-priority-ddp-zone-IL': 275.87,
                      'passport-priority-ddp-zone-OM': 284.96,
                      'passport-priority-ddp-zone-QA': 275.36,
                      'passport-priority-ddp-zone-SA': 275.39,
                      'passport-priority-ddp-zone-AE': 275.78,
                      'passport-priority-ddp-zone-CN': 384.33,
                      'passport-priority-ddp-zone-HK': 250.13,
                      'passport-priority-ddp-zone-IN': 295.24,
                      'passport-priority-ddp-zone-JP': 345.87,
                      'passport-priority-ddp-zone-KR': 287.47,
                      'passport-priority-ddp-zone-NZ': 249.89,
                      'passport-priority-ddp-zone-SG': 250.13,
                      'passport-priority-ddp-zone-TH': 251.76,
                      'passport-priority-ddp-zone-GG': 336.2,
                      'passport-priority-ddp-zone-JE': 336.2,
                      'passport-priority-ddp-zone-NO': 247.27,
                      'passport-priority-ddp-zone-CH': 247.78,
                      'passport-priority-ddp-zone-IS': 215.84,
                      'passport-priority-ddp-zone-AI': 272.08,
                      'passport-priority-ddp-zone-AG': 272.08,
                      'passport-priority-ddp-zone-AR': 329.19,
                      'passport-priority-ddp-zone-AW': 272.08,
                      'passport-priority-ddp-zone-BS': 272.08,
                      'passport-priority-ddp-zone-BB': 292.85,
                      'passport-priority-ddp-zone-BZ': 324.6,
                      'passport-priority-ddp-zone-BM': 272.58,
                      'passport-priority-ddp-zone-BO': 331.97,
                      'passport-priority-ddp-zone-BR': 247.9,
                      'passport-priority-ddp-zone-KY': 272.08,
                      'passport-priority-ddp-zone-CL': 280.96,
                      'passport-priority-ddp-zone-CO': 247.9,
                      'passport-priority-ddp-zone-CR': 329.86,
                      'passport-priority-ddp-zone-DM': 272.08,
                      'passport-priority-ddp-zone-DO': 273.08,
                      'passport-priority-ddp-zone-EC': 330.2,
                      'passport-priority-ddp-zone-SV': 324.6,
                      'passport-priority-ddp-zone-GP': 318.67,
                      'passport-priority-ddp-zone-GT': 324.7,
                      'passport-priority-ddp-zone-GY': 324.6,
                      'passport-priority-ddp-zone-HT': 272.08,
                      'passport-priority-ddp-zone-JM': 300.14,
                      'passport-priority-ddp-zone-MQ': 287.61,
                      'passport-priority-ddp-zone-AN': 272.08,
                      'passport-priority-ddp-zone-NI': 328.99,
                      'passport-priority-ddp-zone-PA': 324.99,
                      'passport-priority-ddp-zone-PY': 324.6,
                      'passport-priority-ddp-zone-PE': 327.67,
                      'passport-priority-ddp-zone-SR': 324.6,
                      'passport-priority-ddp-zone-TT': 279.92,
                      'passport-priority-ddp-zone-UY': 324.6,
                      'passport-priority-ddp-zone-AF': 459.33,
                      'passport-priority-ddp-zone-DZ': 459.33,
                      'passport-priority-ddp-zone-BH': 446.48,
                      'passport-priority-ddp-zone-BD': 405.65,
                      'passport-priority-ddp-zone-BT': 405.65,
                      'passport-priority-ddp-zone-BA': 459.33,
                      'passport-priority-ddp-zone-BW': 459.33,
                      'passport-priority-ddp-zone-BN': 446.48,
                      'passport-priority-ddp-zone-BF': 459.33,
                      'passport-priority-ddp-zone-BI': 459.33,
                      'passport-priority-ddp-zone-KH': 459.33,
                      'passport-priority-ddp-zone-CM': 459.33,
                      'passport-priority-ddp-zone-CV': 459.33,
                      'passport-priority-ddp-zone-TD': 459.33,
                      'passport-priority-ddp-zone-CG': 459.33,
                      'passport-priority-ddp-zone-CI': 459.33,
                      'passport-priority-ddp-zone-EG': 446.48,
                      'passport-priority-ddp-zone-ET': 459.33,
                      'passport-priority-ddp-zone-GA': 459.33,
                      'passport-priority-ddp-zone-GM': 459.33,
                      'passport-priority-ddp-zone-GH': 459.33,
                      'passport-priority-ddp-zone-GN': 459.33,
                      'passport-priority-ddp-zone-ID': 407.15,
                      'passport-priority-ddp-zone-JO': 446.48,
                      'passport-priority-ddp-zone-KE': 459.33,
                      'passport-priority-ddp-zone-KW': 447.11,
                      'passport-priority-ddp-zone-LB': 446.48,
                      'passport-priority-ddp-zone-LI': 446.42,
                      'passport-priority-ddp-zone-MO': 406.64,
                      'passport-priority-ddp-zone-MG': 459.33,
                      'passport-priority-ddp-zone-MW': 459.33,
                      'passport-priority-ddp-zone-MY': 392.15,
                      'passport-priority-ddp-zone-MV': 405.65,
                      'passport-priority-ddp-zone-ML': 459.33,
                      'passport-priority-ddp-zone-MR': 459.33,
                      'passport-priority-ddp-zone-MU': 459.33,
                      'passport-priority-ddp-zone-MD': 459.33,
                      'passport-priority-ddp-zone-MA': 459.81,
                      'passport-priority-ddp-zone-MZ': 459.33,
                      'passport-priority-ddp-zone-NA': 459.33,
                      'passport-priority-ddp-zone-NP': 405.65,
                      'passport-priority-ddp-zone-NE': 459.33,
                      'passport-priority-ddp-zone-NG': 459.33,
                      'passport-priority-ddp-zone-PK': 405.65,
                      'passport-priority-ddp-zone-PH': 392.59,
                      'passport-priority-ddp-zone-RE': 459.33,
                      'passport-priority-ddp-zone-RW': 459.33,
                      'passport-priority-ddp-zone-SN': 459.33,
                      'passport-priority-ddp-zone-SC': 459.33,
                      'passport-priority-ddp-zone-ZA': 430.62,
                      'passport-priority-ddp-zone-LK': 405.65,
                      'passport-priority-ddp-zone-SZ': 459.33,
                      'passport-priority-ddp-zone-TW': 392.59,
                      'passport-priority-ddp-zone-TJ': 459.33,
                      'passport-priority-ddp-zone-TZ': 459.33,
                      'passport-priority-ddp-zone-TG': 459.33,
                      'passport-priority-ddp-zone-TN': 459.33,
                      'passport-priority-ddp-zone-TR': 446.51,
                      'passport-priority-ddp-zone-TM': 459.33,
                      'passport-priority-ddp-zone-UG': 459.33,
                      'passport-priority-ddp-zone-UA': 459.33,
                      'passport-priority-ddp-zone-VN': 392.63,
                      'passport-priority-ddp-zone-YE': 446.48,
                      'passport-priority-ddp-zone-ZM': 459.33,
                      'passport-priority-ddp-zone-ZW': 459.33,
                      'passport-priority-ddp-zone-MC': 180.68,
                      'passport-priority-ddp-zone-IM': 174.8,
                      'passport-priority-ddp-zone-SM': 180.68,
                    },
                    '40': {
                      'passport-priority-ddp-zone-CA': 91.03,
                      'passport-priority-ddp-zone-GB': 177.43,
                      'passport-priority-ddp-zone-AU': 253.71,
                      'passport-priority-ddp-zone-BE': 185.31,
                      'passport-priority-ddp-zone-DK': 185.31,
                      'passport-priority-ddp-zone-FR': 185.31,
                      'passport-priority-ddp-zone-DE': 185.31,
                      'passport-priority-ddp-zone-IT': 185.31,
                      'passport-priority-ddp-zone-NL': 185.31,
                      'passport-priority-ddp-zone-ES': 185.31,
                      'passport-priority-ddp-zone-MX': 232.0,
                      'passport-priority-ddp-zone-AM': 344.92,
                      'passport-priority-ddp-zone-AT': 189.53,
                      'passport-priority-ddp-zone-BG': 189.53,
                      'passport-priority-ddp-zone-HR': 189.53,
                      'passport-priority-ddp-zone-CY': 207.19,
                      'passport-priority-ddp-zone-CZ': 189.53,
                      'passport-priority-ddp-zone-EE': 189.53,
                      'passport-priority-ddp-zone-FI': 189.53,
                      'passport-priority-ddp-zone-GR': 204.86,
                      'passport-priority-ddp-zone-HU': 189.53,
                      'passport-priority-ddp-zone-IE': 189.53,
                      'passport-priority-ddp-zone-LV': 189.53,
                      'passport-priority-ddp-zone-LT': 189.53,
                      'passport-priority-ddp-zone-LU': 189.53,
                      'passport-priority-ddp-zone-MT': 207.19,
                      'passport-priority-ddp-zone-PL': 189.53,
                      'passport-priority-ddp-zone-PT': 189.53,
                      'passport-priority-ddp-zone-RO': 189.53,
                      'passport-priority-ddp-zone-SK': 189.53,
                      'passport-priority-ddp-zone-SI': 189.53,
                      'passport-priority-ddp-zone-SE': 189.53,
                      'passport-priority-ddp-zone-IL': 282.94,
                      'passport-priority-ddp-zone-OM': 292.27,
                      'passport-priority-ddp-zone-QA': 282.42,
                      'passport-priority-ddp-zone-SA': 282.45,
                      'passport-priority-ddp-zone-AE': 282.85,
                      'passport-priority-ddp-zone-CN': 394.19,
                      'passport-priority-ddp-zone-HK': 256.55,
                      'passport-priority-ddp-zone-IN': 302.81,
                      'passport-priority-ddp-zone-JP': 354.74,
                      'passport-priority-ddp-zone-KR': 294.84,
                      'passport-priority-ddp-zone-NZ': 256.3,
                      'passport-priority-ddp-zone-SG': 256.55,
                      'passport-priority-ddp-zone-TH': 258.22,
                      'passport-priority-ddp-zone-GG': 344.82,
                      'passport-priority-ddp-zone-JE': 344.82,
                      'passport-priority-ddp-zone-NO': 253.6,
                      'passport-priority-ddp-zone-CH': 254.12,
                      'passport-priority-ddp-zone-IS': 221.37,
                      'passport-priority-ddp-zone-AI': 279.06,
                      'passport-priority-ddp-zone-AG': 279.06,
                      'passport-priority-ddp-zone-AR': 337.63,
                      'passport-priority-ddp-zone-AW': 279.06,
                      'passport-priority-ddp-zone-BS': 279.06,
                      'passport-priority-ddp-zone-BB': 300.37,
                      'passport-priority-ddp-zone-BZ': 332.92,
                      'passport-priority-ddp-zone-BM': 279.58,
                      'passport-priority-ddp-zone-BO': 340.48,
                      'passport-priority-ddp-zone-BR': 254.26,
                      'passport-priority-ddp-zone-KY': 279.06,
                      'passport-priority-ddp-zone-CL': 288.16,
                      'passport-priority-ddp-zone-CO': 254.26,
                      'passport-priority-ddp-zone-CR': 338.32,
                      'passport-priority-ddp-zone-DM': 279.06,
                      'passport-priority-ddp-zone-DO': 280.08,
                      'passport-priority-ddp-zone-EC': 338.67,
                      'passport-priority-ddp-zone-SV': 332.92,
                      'passport-priority-ddp-zone-GP': 326.85,
                      'passport-priority-ddp-zone-GT': 333.02,
                      'passport-priority-ddp-zone-GY': 332.92,
                      'passport-priority-ddp-zone-HT': 279.06,
                      'passport-priority-ddp-zone-JM': 307.85,
                      'passport-priority-ddp-zone-MQ': 294.99,
                      'passport-priority-ddp-zone-AN': 279.06,
                      'passport-priority-ddp-zone-NI': 337.42,
                      'passport-priority-ddp-zone-PA': 333.32,
                      'passport-priority-ddp-zone-PY': 332.92,
                      'passport-priority-ddp-zone-PE': 336.07,
                      'passport-priority-ddp-zone-SR': 332.92,
                      'passport-priority-ddp-zone-TT': 287.11,
                      'passport-priority-ddp-zone-UY': 332.92,
                      'passport-priority-ddp-zone-AF': 471.11,
                      'passport-priority-ddp-zone-DZ': 471.11,
                      'passport-priority-ddp-zone-BH': 457.92,
                      'passport-priority-ddp-zone-BD': 416.06,
                      'passport-priority-ddp-zone-BT': 416.06,
                      'passport-priority-ddp-zone-BA': 471.11,
                      'passport-priority-ddp-zone-BW': 471.11,
                      'passport-priority-ddp-zone-BN': 457.92,
                      'passport-priority-ddp-zone-BF': 471.11,
                      'passport-priority-ddp-zone-BI': 471.11,
                      'passport-priority-ddp-zone-KH': 471.11,
                      'passport-priority-ddp-zone-CM': 471.11,
                      'passport-priority-ddp-zone-CV': 471.11,
                      'passport-priority-ddp-zone-TD': 471.11,
                      'passport-priority-ddp-zone-CG': 471.11,
                      'passport-priority-ddp-zone-CI': 471.11,
                      'passport-priority-ddp-zone-EG': 457.92,
                      'passport-priority-ddp-zone-ET': 471.11,
                      'passport-priority-ddp-zone-GA': 471.11,
                      'passport-priority-ddp-zone-GM': 471.11,
                      'passport-priority-ddp-zone-GH': 471.11,
                      'passport-priority-ddp-zone-GN': 471.11,
                      'passport-priority-ddp-zone-ID': 417.5,
                      'passport-priority-ddp-zone-JO': 457.92,
                      'passport-priority-ddp-zone-KE': 471.11,
                      'passport-priority-ddp-zone-KW': 458.58,
                      'passport-priority-ddp-zone-LB': 457.92,
                      'passport-priority-ddp-zone-LI': 457.85,
                      'passport-priority-ddp-zone-MO': 417.07,
                      'passport-priority-ddp-zone-MG': 471.11,
                      'passport-priority-ddp-zone-MW': 471.11,
                      'passport-priority-ddp-zone-MY': 402.2,
                      'passport-priority-ddp-zone-MV': 416.06,
                      'passport-priority-ddp-zone-ML': 471.11,
                      'passport-priority-ddp-zone-MR': 471.11,
                      'passport-priority-ddp-zone-MU': 471.11,
                      'passport-priority-ddp-zone-MD': 471.11,
                      'passport-priority-ddp-zone-MA': 471.61,
                      'passport-priority-ddp-zone-MZ': 471.11,
                      'passport-priority-ddp-zone-NA': 471.11,
                      'passport-priority-ddp-zone-NP': 416.06,
                      'passport-priority-ddp-zone-NE': 471.11,
                      'passport-priority-ddp-zone-NG': 471.11,
                      'passport-priority-ddp-zone-PK': 416.06,
                      'passport-priority-ddp-zone-PH': 402.67,
                      'passport-priority-ddp-zone-RE': 471.11,
                      'passport-priority-ddp-zone-RW': 471.11,
                      'passport-priority-ddp-zone-SN': 471.11,
                      'passport-priority-ddp-zone-SC': 471.11,
                      'passport-priority-ddp-zone-ZA': 441.66,
                      'passport-priority-ddp-zone-LK': 416.06,
                      'passport-priority-ddp-zone-SZ': 471.11,
                      'passport-priority-ddp-zone-TW': 402.67,
                      'passport-priority-ddp-zone-TJ': 471.11,
                      'passport-priority-ddp-zone-TZ': 471.11,
                      'passport-priority-ddp-zone-TG': 471.11,
                      'passport-priority-ddp-zone-TN': 471.11,
                      'passport-priority-ddp-zone-TR': 457.95,
                      'passport-priority-ddp-zone-TM': 471.11,
                      'passport-priority-ddp-zone-UG': 471.11,
                      'passport-priority-ddp-zone-UA': 471.11,
                      'passport-priority-ddp-zone-VN': 402.69,
                      'passport-priority-ddp-zone-YE': 457.92,
                      'passport-priority-ddp-zone-ZM': 471.11,
                      'passport-priority-ddp-zone-ZW': 471.11,
                      'passport-priority-ddp-zone-MC': 185.31,
                      'passport-priority-ddp-zone-IM': 179.43,
                      'passport-priority-ddp-zone-SM': 185.31,
                    },
                    '41': {
                      'passport-priority-ddp-zone-CA': 93.31,
                      'passport-priority-ddp-zone-GB': 181.86,
                      'passport-priority-ddp-zone-AU': 260.05,
                      'passport-priority-ddp-zone-BE': 189.94,
                      'passport-priority-ddp-zone-DK': 189.94,
                      'passport-priority-ddp-zone-FR': 189.94,
                      'passport-priority-ddp-zone-DE': 189.94,
                      'passport-priority-ddp-zone-IT': 189.94,
                      'passport-priority-ddp-zone-NL': 189.94,
                      'passport-priority-ddp-zone-ES': 189.94,
                      'passport-priority-ddp-zone-MX': 237.8,
                      'passport-priority-ddp-zone-AM': 353.54,
                      'passport-priority-ddp-zone-AT': 194.27,
                      'passport-priority-ddp-zone-BG': 194.27,
                      'passport-priority-ddp-zone-HR': 194.27,
                      'passport-priority-ddp-zone-CY': 212.37,
                      'passport-priority-ddp-zone-CZ': 194.27,
                      'passport-priority-ddp-zone-EE': 194.27,
                      'passport-priority-ddp-zone-FI': 194.27,
                      'passport-priority-ddp-zone-GR': 209.98,
                      'passport-priority-ddp-zone-HU': 194.27,
                      'passport-priority-ddp-zone-IE': 194.27,
                      'passport-priority-ddp-zone-LV': 194.27,
                      'passport-priority-ddp-zone-LT': 194.27,
                      'passport-priority-ddp-zone-LU': 194.27,
                      'passport-priority-ddp-zone-MT': 212.37,
                      'passport-priority-ddp-zone-PL': 194.27,
                      'passport-priority-ddp-zone-PT': 194.27,
                      'passport-priority-ddp-zone-RO': 194.27,
                      'passport-priority-ddp-zone-SK': 194.27,
                      'passport-priority-ddp-zone-SI': 194.27,
                      'passport-priority-ddp-zone-SE': 194.27,
                      'passport-priority-ddp-zone-IL': 290.01,
                      'passport-priority-ddp-zone-OM': 299.58,
                      'passport-priority-ddp-zone-QA': 289.48,
                      'passport-priority-ddp-zone-SA': 289.51,
                      'passport-priority-ddp-zone-AE': 289.92,
                      'passport-priority-ddp-zone-CN': 404.05,
                      'passport-priority-ddp-zone-HK': 262.97,
                      'passport-priority-ddp-zone-IN': 310.38,
                      'passport-priority-ddp-zone-JP': 363.61,
                      'passport-priority-ddp-zone-KR': 302.21,
                      'passport-priority-ddp-zone-NZ': 262.71,
                      'passport-priority-ddp-zone-SG': 262.97,
                      'passport-priority-ddp-zone-TH': 264.68,
                      'passport-priority-ddp-zone-GG': 353.44,
                      'passport-priority-ddp-zone-JE': 353.44,
                      'passport-priority-ddp-zone-NO': 259.93,
                      'passport-priority-ddp-zone-CH': 260.46,
                      'passport-priority-ddp-zone-IS': 226.9,
                      'passport-priority-ddp-zone-AI': 286.04,
                      'passport-priority-ddp-zone-AG': 286.04,
                      'passport-priority-ddp-zone-AR': 346.07,
                      'passport-priority-ddp-zone-AW': 286.04,
                      'passport-priority-ddp-zone-BS': 286.04,
                      'passport-priority-ddp-zone-BB': 307.89,
                      'passport-priority-ddp-zone-BZ': 341.24,
                      'passport-priority-ddp-zone-BM': 286.58,
                      'passport-priority-ddp-zone-BO': 348.99,
                      'passport-priority-ddp-zone-BR': 260.62,
                      'passport-priority-ddp-zone-KY': 286.04,
                      'passport-priority-ddp-zone-CL': 295.36,
                      'passport-priority-ddp-zone-CO': 260.62,
                      'passport-priority-ddp-zone-CR': 346.78,
                      'passport-priority-ddp-zone-DM': 286.04,
                      'passport-priority-ddp-zone-DO': 287.08,
                      'passport-priority-ddp-zone-EC': 347.14,
                      'passport-priority-ddp-zone-SV': 341.24,
                      'passport-priority-ddp-zone-GP': 335.03,
                      'passport-priority-ddp-zone-GT': 341.34,
                      'passport-priority-ddp-zone-GY': 341.24,
                      'passport-priority-ddp-zone-HT': 286.04,
                      'passport-priority-ddp-zone-JM': 315.56,
                      'passport-priority-ddp-zone-MQ': 302.37,
                      'passport-priority-ddp-zone-AN': 286.04,
                      'passport-priority-ddp-zone-NI': 345.85,
                      'passport-priority-ddp-zone-PA': 341.65,
                      'passport-priority-ddp-zone-PY': 341.24,
                      'passport-priority-ddp-zone-PE': 344.47,
                      'passport-priority-ddp-zone-SR': 341.24,
                      'passport-priority-ddp-zone-TT': 294.3,
                      'passport-priority-ddp-zone-UY': 341.24,
                      'passport-priority-ddp-zone-AF': 482.89,
                      'passport-priority-ddp-zone-DZ': 482.89,
                      'passport-priority-ddp-zone-BH': 469.36,
                      'passport-priority-ddp-zone-BD': 426.47,
                      'passport-priority-ddp-zone-BT': 426.47,
                      'passport-priority-ddp-zone-BA': 482.89,
                      'passport-priority-ddp-zone-BW': 482.89,
                      'passport-priority-ddp-zone-BN': 469.36,
                      'passport-priority-ddp-zone-BF': 482.89,
                      'passport-priority-ddp-zone-BI': 482.89,
                      'passport-priority-ddp-zone-KH': 482.89,
                      'passport-priority-ddp-zone-CM': 482.89,
                      'passport-priority-ddp-zone-CV': 482.89,
                      'passport-priority-ddp-zone-TD': 482.89,
                      'passport-priority-ddp-zone-CG': 482.89,
                      'passport-priority-ddp-zone-CI': 482.89,
                      'passport-priority-ddp-zone-EG': 469.36,
                      'passport-priority-ddp-zone-ET': 482.89,
                      'passport-priority-ddp-zone-GA': 482.89,
                      'passport-priority-ddp-zone-GM': 482.89,
                      'passport-priority-ddp-zone-GH': 482.89,
                      'passport-priority-ddp-zone-GN': 482.89,
                      'passport-priority-ddp-zone-ID': 427.85,
                      'passport-priority-ddp-zone-JO': 469.36,
                      'passport-priority-ddp-zone-KE': 482.89,
                      'passport-priority-ddp-zone-KW': 470.05,
                      'passport-priority-ddp-zone-LB': 469.36,
                      'passport-priority-ddp-zone-LI': 469.28,
                      'passport-priority-ddp-zone-MO': 427.5,
                      'passport-priority-ddp-zone-MG': 482.89,
                      'passport-priority-ddp-zone-MW': 482.89,
                      'passport-priority-ddp-zone-MY': 412.25,
                      'passport-priority-ddp-zone-MV': 426.47,
                      'passport-priority-ddp-zone-ML': 482.89,
                      'passport-priority-ddp-zone-MR': 482.89,
                      'passport-priority-ddp-zone-MU': 482.89,
                      'passport-priority-ddp-zone-MD': 482.89,
                      'passport-priority-ddp-zone-MA': 483.41,
                      'passport-priority-ddp-zone-MZ': 482.89,
                      'passport-priority-ddp-zone-NA': 482.89,
                      'passport-priority-ddp-zone-NP': 426.47,
                      'passport-priority-ddp-zone-NE': 482.89,
                      'passport-priority-ddp-zone-NG': 482.89,
                      'passport-priority-ddp-zone-PK': 426.47,
                      'passport-priority-ddp-zone-PH': 412.75,
                      'passport-priority-ddp-zone-RE': 482.89,
                      'passport-priority-ddp-zone-RW': 482.89,
                      'passport-priority-ddp-zone-SN': 482.89,
                      'passport-priority-ddp-zone-SC': 482.89,
                      'passport-priority-ddp-zone-ZA': 452.7,
                      'passport-priority-ddp-zone-LK': 426.47,
                      'passport-priority-ddp-zone-SZ': 482.89,
                      'passport-priority-ddp-zone-TW': 412.75,
                      'passport-priority-ddp-zone-TJ': 482.89,
                      'passport-priority-ddp-zone-TZ': 482.89,
                      'passport-priority-ddp-zone-TG': 482.89,
                      'passport-priority-ddp-zone-TN': 482.89,
                      'passport-priority-ddp-zone-TR': 469.39,
                      'passport-priority-ddp-zone-TM': 482.89,
                      'passport-priority-ddp-zone-UG': 482.89,
                      'passport-priority-ddp-zone-UA': 482.89,
                      'passport-priority-ddp-zone-VN': 412.75,
                      'passport-priority-ddp-zone-YE': 469.36,
                      'passport-priority-ddp-zone-ZM': 482.89,
                      'passport-priority-ddp-zone-ZW': 482.89,
                      'passport-priority-ddp-zone-MC': 189.94,
                      'passport-priority-ddp-zone-IM': 184.06,
                      'passport-priority-ddp-zone-SM': 189.94,
                    },
                    '42': {
                      'passport-priority-ddp-zone-CA': 95.59,
                      'passport-priority-ddp-zone-GB': 186.29,
                      'passport-priority-ddp-zone-AU': 266.39,
                      'passport-priority-ddp-zone-BE': 194.57,
                      'passport-priority-ddp-zone-DK': 194.57,
                      'passport-priority-ddp-zone-FR': 194.57,
                      'passport-priority-ddp-zone-DE': 194.57,
                      'passport-priority-ddp-zone-IT': 194.57,
                      'passport-priority-ddp-zone-NL': 194.57,
                      'passport-priority-ddp-zone-ES': 194.57,
                      'passport-priority-ddp-zone-MX': 243.6,
                      'passport-priority-ddp-zone-AM': 362.16,
                      'passport-priority-ddp-zone-AT': 199.01,
                      'passport-priority-ddp-zone-BG': 199.01,
                      'passport-priority-ddp-zone-HR': 199.01,
                      'passport-priority-ddp-zone-CY': 217.55,
                      'passport-priority-ddp-zone-CZ': 199.01,
                      'passport-priority-ddp-zone-EE': 199.01,
                      'passport-priority-ddp-zone-FI': 199.01,
                      'passport-priority-ddp-zone-GR': 215.1,
                      'passport-priority-ddp-zone-HU': 199.01,
                      'passport-priority-ddp-zone-IE': 199.01,
                      'passport-priority-ddp-zone-LV': 199.01,
                      'passport-priority-ddp-zone-LT': 199.01,
                      'passport-priority-ddp-zone-LU': 199.01,
                      'passport-priority-ddp-zone-MT': 217.55,
                      'passport-priority-ddp-zone-PL': 199.01,
                      'passport-priority-ddp-zone-PT': 199.01,
                      'passport-priority-ddp-zone-RO': 199.01,
                      'passport-priority-ddp-zone-SK': 199.01,
                      'passport-priority-ddp-zone-SI': 199.01,
                      'passport-priority-ddp-zone-SE': 199.01,
                      'passport-priority-ddp-zone-IL': 297.08,
                      'passport-priority-ddp-zone-OM': 306.89,
                      'passport-priority-ddp-zone-QA': 296.54,
                      'passport-priority-ddp-zone-SA': 296.57,
                      'passport-priority-ddp-zone-AE': 296.99,
                      'passport-priority-ddp-zone-CN': 413.91,
                      'passport-priority-ddp-zone-HK': 269.39,
                      'passport-priority-ddp-zone-IN': 317.95,
                      'passport-priority-ddp-zone-JP': 372.48,
                      'passport-priority-ddp-zone-KR': 309.58,
                      'passport-priority-ddp-zone-NZ': 269.12,
                      'passport-priority-ddp-zone-SG': 269.39,
                      'passport-priority-ddp-zone-TH': 271.14,
                      'passport-priority-ddp-zone-GG': 362.06,
                      'passport-priority-ddp-zone-JE': 362.06,
                      'passport-priority-ddp-zone-NO': 266.26,
                      'passport-priority-ddp-zone-CH': 266.8,
                      'passport-priority-ddp-zone-IS': 232.43,
                      'passport-priority-ddp-zone-AI': 293.02,
                      'passport-priority-ddp-zone-AG': 293.02,
                      'passport-priority-ddp-zone-AR': 354.51,
                      'passport-priority-ddp-zone-AW': 293.02,
                      'passport-priority-ddp-zone-BS': 293.02,
                      'passport-priority-ddp-zone-BB': 315.41,
                      'passport-priority-ddp-zone-BZ': 349.56,
                      'passport-priority-ddp-zone-BM': 293.58,
                      'passport-priority-ddp-zone-BO': 357.5,
                      'passport-priority-ddp-zone-BR': 266.98,
                      'passport-priority-ddp-zone-KY': 293.02,
                      'passport-priority-ddp-zone-CL': 302.56,
                      'passport-priority-ddp-zone-CO': 266.98,
                      'passport-priority-ddp-zone-CR': 355.24,
                      'passport-priority-ddp-zone-DM': 293.02,
                      'passport-priority-ddp-zone-DO': 294.08,
                      'passport-priority-ddp-zone-EC': 355.61,
                      'passport-priority-ddp-zone-SV': 349.56,
                      'passport-priority-ddp-zone-GP': 343.21,
                      'passport-priority-ddp-zone-GT': 349.66,
                      'passport-priority-ddp-zone-GY': 349.56,
                      'passport-priority-ddp-zone-HT': 293.02,
                      'passport-priority-ddp-zone-JM': 323.27,
                      'passport-priority-ddp-zone-MQ': 309.75,
                      'passport-priority-ddp-zone-AN': 293.02,
                      'passport-priority-ddp-zone-NI': 354.28,
                      'passport-priority-ddp-zone-PA': 349.98,
                      'passport-priority-ddp-zone-PY': 349.56,
                      'passport-priority-ddp-zone-PE': 352.87,
                      'passport-priority-ddp-zone-SR': 349.56,
                      'passport-priority-ddp-zone-TT': 301.49,
                      'passport-priority-ddp-zone-UY': 349.56,
                      'passport-priority-ddp-zone-AF': 494.67,
                      'passport-priority-ddp-zone-DZ': 494.67,
                      'passport-priority-ddp-zone-BH': 480.8,
                      'passport-priority-ddp-zone-BD': 436.88,
                      'passport-priority-ddp-zone-BT': 436.88,
                      'passport-priority-ddp-zone-BA': 494.67,
                      'passport-priority-ddp-zone-BW': 494.67,
                      'passport-priority-ddp-zone-BN': 480.8,
                      'passport-priority-ddp-zone-BF': 494.67,
                      'passport-priority-ddp-zone-BI': 494.67,
                      'passport-priority-ddp-zone-KH': 494.67,
                      'passport-priority-ddp-zone-CM': 494.67,
                      'passport-priority-ddp-zone-CV': 494.67,
                      'passport-priority-ddp-zone-TD': 494.67,
                      'passport-priority-ddp-zone-CG': 494.67,
                      'passport-priority-ddp-zone-CI': 494.67,
                      'passport-priority-ddp-zone-EG': 480.8,
                      'passport-priority-ddp-zone-ET': 494.67,
                      'passport-priority-ddp-zone-GA': 494.67,
                      'passport-priority-ddp-zone-GM': 494.67,
                      'passport-priority-ddp-zone-GH': 494.67,
                      'passport-priority-ddp-zone-GN': 494.67,
                      'passport-priority-ddp-zone-ID': 438.2,
                      'passport-priority-ddp-zone-JO': 480.8,
                      'passport-priority-ddp-zone-KE': 494.67,
                      'passport-priority-ddp-zone-KW': 481.52,
                      'passport-priority-ddp-zone-LB': 480.8,
                      'passport-priority-ddp-zone-LI': 480.71,
                      'passport-priority-ddp-zone-MO': 437.93,
                      'passport-priority-ddp-zone-MG': 494.67,
                      'passport-priority-ddp-zone-MW': 494.67,
                      'passport-priority-ddp-zone-MY': 422.3,
                      'passport-priority-ddp-zone-MV': 436.88,
                      'passport-priority-ddp-zone-ML': 494.67,
                      'passport-priority-ddp-zone-MR': 494.67,
                      'passport-priority-ddp-zone-MU': 494.67,
                      'passport-priority-ddp-zone-MD': 494.67,
                      'passport-priority-ddp-zone-MA': 495.21,
                      'passport-priority-ddp-zone-MZ': 494.67,
                      'passport-priority-ddp-zone-NA': 494.67,
                      'passport-priority-ddp-zone-NP': 436.88,
                      'passport-priority-ddp-zone-NE': 494.67,
                      'passport-priority-ddp-zone-NG': 494.67,
                      'passport-priority-ddp-zone-PK': 436.88,
                      'passport-priority-ddp-zone-PH': 422.83,
                      'passport-priority-ddp-zone-RE': 494.67,
                      'passport-priority-ddp-zone-RW': 494.67,
                      'passport-priority-ddp-zone-SN': 494.67,
                      'passport-priority-ddp-zone-SC': 494.67,
                      'passport-priority-ddp-zone-ZA': 463.74,
                      'passport-priority-ddp-zone-LK': 436.88,
                      'passport-priority-ddp-zone-SZ': 494.67,
                      'passport-priority-ddp-zone-TW': 422.83,
                      'passport-priority-ddp-zone-TJ': 494.67,
                      'passport-priority-ddp-zone-TZ': 494.67,
                      'passport-priority-ddp-zone-TG': 494.67,
                      'passport-priority-ddp-zone-TN': 494.67,
                      'passport-priority-ddp-zone-TR': 480.83,
                      'passport-priority-ddp-zone-TM': 494.67,
                      'passport-priority-ddp-zone-UG': 494.67,
                      'passport-priority-ddp-zone-UA': 494.67,
                      'passport-priority-ddp-zone-VN': 422.81,
                      'passport-priority-ddp-zone-YE': 480.8,
                      'passport-priority-ddp-zone-ZM': 494.67,
                      'passport-priority-ddp-zone-ZW': 494.67,
                      'passport-priority-ddp-zone-MC': 194.57,
                      'passport-priority-ddp-zone-IM': 188.69,
                      'passport-priority-ddp-zone-SM': 194.57,
                    },
                    '43': {
                      'passport-priority-ddp-zone-CA': 97.87,
                      'passport-priority-ddp-zone-GB': 190.72,
                      'passport-priority-ddp-zone-AU': 272.73,
                      'passport-priority-ddp-zone-BE': 199.2,
                      'passport-priority-ddp-zone-DK': 199.2,
                      'passport-priority-ddp-zone-FR': 199.2,
                      'passport-priority-ddp-zone-DE': 199.2,
                      'passport-priority-ddp-zone-IT': 199.2,
                      'passport-priority-ddp-zone-NL': 199.2,
                      'passport-priority-ddp-zone-ES': 199.2,
                      'passport-priority-ddp-zone-MX': 249.4,
                      'passport-priority-ddp-zone-AM': 370.78,
                      'passport-priority-ddp-zone-AT': 203.75,
                      'passport-priority-ddp-zone-BG': 203.75,
                      'passport-priority-ddp-zone-HR': 203.75,
                      'passport-priority-ddp-zone-CY': 222.73,
                      'passport-priority-ddp-zone-CZ': 203.75,
                      'passport-priority-ddp-zone-EE': 203.75,
                      'passport-priority-ddp-zone-FI': 203.75,
                      'passport-priority-ddp-zone-GR': 220.22,
                      'passport-priority-ddp-zone-HU': 203.75,
                      'passport-priority-ddp-zone-IE': 203.75,
                      'passport-priority-ddp-zone-LV': 203.75,
                      'passport-priority-ddp-zone-LT': 203.75,
                      'passport-priority-ddp-zone-LU': 203.75,
                      'passport-priority-ddp-zone-MT': 222.73,
                      'passport-priority-ddp-zone-PL': 203.75,
                      'passport-priority-ddp-zone-PT': 203.75,
                      'passport-priority-ddp-zone-RO': 203.75,
                      'passport-priority-ddp-zone-SK': 203.75,
                      'passport-priority-ddp-zone-SI': 203.75,
                      'passport-priority-ddp-zone-SE': 203.75,
                      'passport-priority-ddp-zone-IL': 304.15,
                      'passport-priority-ddp-zone-OM': 314.2,
                      'passport-priority-ddp-zone-QA': 303.6,
                      'passport-priority-ddp-zone-SA': 303.63,
                      'passport-priority-ddp-zone-AE': 304.06,
                      'passport-priority-ddp-zone-CN': 423.77,
                      'passport-priority-ddp-zone-HK': 275.81,
                      'passport-priority-ddp-zone-IN': 325.52,
                      'passport-priority-ddp-zone-JP': 381.35,
                      'passport-priority-ddp-zone-KR': 316.95,
                      'passport-priority-ddp-zone-NZ': 275.53,
                      'passport-priority-ddp-zone-SG': 275.81,
                      'passport-priority-ddp-zone-TH': 277.6,
                      'passport-priority-ddp-zone-GG': 370.68,
                      'passport-priority-ddp-zone-JE': 370.68,
                      'passport-priority-ddp-zone-NO': 272.59,
                      'passport-priority-ddp-zone-CH': 273.14,
                      'passport-priority-ddp-zone-IS': 237.96,
                      'passport-priority-ddp-zone-AI': 300.0,
                      'passport-priority-ddp-zone-AG': 300.0,
                      'passport-priority-ddp-zone-AR': 362.95,
                      'passport-priority-ddp-zone-AW': 300.0,
                      'passport-priority-ddp-zone-BS': 300.0,
                      'passport-priority-ddp-zone-BB': 322.93,
                      'passport-priority-ddp-zone-BZ': 357.88,
                      'passport-priority-ddp-zone-BM': 300.58,
                      'passport-priority-ddp-zone-BO': 366.01,
                      'passport-priority-ddp-zone-BR': 273.34,
                      'passport-priority-ddp-zone-KY': 300.0,
                      'passport-priority-ddp-zone-CL': 309.76,
                      'passport-priority-ddp-zone-CO': 273.34,
                      'passport-priority-ddp-zone-CR': 363.7,
                      'passport-priority-ddp-zone-DM': 300.0,
                      'passport-priority-ddp-zone-DO': 301.08,
                      'passport-priority-ddp-zone-EC': 364.08,
                      'passport-priority-ddp-zone-SV': 357.88,
                      'passport-priority-ddp-zone-GP': 351.39,
                      'passport-priority-ddp-zone-GT': 357.98,
                      'passport-priority-ddp-zone-GY': 357.88,
                      'passport-priority-ddp-zone-HT': 300.0,
                      'passport-priority-ddp-zone-JM': 330.98,
                      'passport-priority-ddp-zone-MQ': 317.13,
                      'passport-priority-ddp-zone-AN': 300.0,
                      'passport-priority-ddp-zone-NI': 362.71,
                      'passport-priority-ddp-zone-PA': 358.31,
                      'passport-priority-ddp-zone-PY': 357.88,
                      'passport-priority-ddp-zone-PE': 361.27,
                      'passport-priority-ddp-zone-SR': 357.88,
                      'passport-priority-ddp-zone-TT': 308.68,
                      'passport-priority-ddp-zone-UY': 357.88,
                      'passport-priority-ddp-zone-AF': 506.45,
                      'passport-priority-ddp-zone-DZ': 506.45,
                      'passport-priority-ddp-zone-BH': 492.24,
                      'passport-priority-ddp-zone-BD': 447.29,
                      'passport-priority-ddp-zone-BT': 447.29,
                      'passport-priority-ddp-zone-BA': 506.45,
                      'passport-priority-ddp-zone-BW': 506.45,
                      'passport-priority-ddp-zone-BN': 492.24,
                      'passport-priority-ddp-zone-BF': 506.45,
                      'passport-priority-ddp-zone-BI': 506.45,
                      'passport-priority-ddp-zone-KH': 506.45,
                      'passport-priority-ddp-zone-CM': 506.45,
                      'passport-priority-ddp-zone-CV': 506.45,
                      'passport-priority-ddp-zone-TD': 506.45,
                      'passport-priority-ddp-zone-CG': 506.45,
                      'passport-priority-ddp-zone-CI': 506.45,
                      'passport-priority-ddp-zone-EG': 492.24,
                      'passport-priority-ddp-zone-ET': 506.45,
                      'passport-priority-ddp-zone-GA': 506.45,
                      'passport-priority-ddp-zone-GM': 506.45,
                      'passport-priority-ddp-zone-GH': 506.45,
                      'passport-priority-ddp-zone-GN': 506.45,
                      'passport-priority-ddp-zone-ID': 448.55,
                      'passport-priority-ddp-zone-JO': 492.24,
                      'passport-priority-ddp-zone-KE': 506.45,
                      'passport-priority-ddp-zone-KW': 492.99,
                      'passport-priority-ddp-zone-LB': 492.24,
                      'passport-priority-ddp-zone-LI': 492.14,
                      'passport-priority-ddp-zone-MO': 448.36,
                      'passport-priority-ddp-zone-MG': 506.45,
                      'passport-priority-ddp-zone-MW': 506.45,
                      'passport-priority-ddp-zone-MY': 432.35,
                      'passport-priority-ddp-zone-MV': 447.29,
                      'passport-priority-ddp-zone-ML': 506.45,
                      'passport-priority-ddp-zone-MR': 506.45,
                      'passport-priority-ddp-zone-MU': 506.45,
                      'passport-priority-ddp-zone-MD': 506.45,
                      'passport-priority-ddp-zone-MA': 507.01,
                      'passport-priority-ddp-zone-MZ': 506.45,
                      'passport-priority-ddp-zone-NA': 506.45,
                      'passport-priority-ddp-zone-NP': 447.29,
                      'passport-priority-ddp-zone-NE': 506.45,
                      'passport-priority-ddp-zone-NG': 506.45,
                      'passport-priority-ddp-zone-PK': 447.29,
                      'passport-priority-ddp-zone-PH': 432.91,
                      'passport-priority-ddp-zone-RE': 506.45,
                      'passport-priority-ddp-zone-RW': 506.45,
                      'passport-priority-ddp-zone-SN': 506.45,
                      'passport-priority-ddp-zone-SC': 506.45,
                      'passport-priority-ddp-zone-ZA': 474.78,
                      'passport-priority-ddp-zone-LK': 447.29,
                      'passport-priority-ddp-zone-SZ': 506.45,
                      'passport-priority-ddp-zone-TW': 432.91,
                      'passport-priority-ddp-zone-TJ': 506.45,
                      'passport-priority-ddp-zone-TZ': 506.45,
                      'passport-priority-ddp-zone-TG': 506.45,
                      'passport-priority-ddp-zone-TN': 506.45,
                      'passport-priority-ddp-zone-TR': 492.27,
                      'passport-priority-ddp-zone-TM': 506.45,
                      'passport-priority-ddp-zone-UG': 506.45,
                      'passport-priority-ddp-zone-UA': 506.45,
                      'passport-priority-ddp-zone-VN': 432.87,
                      'passport-priority-ddp-zone-YE': 492.24,
                      'passport-priority-ddp-zone-ZM': 506.45,
                      'passport-priority-ddp-zone-ZW': 506.45,
                      'passport-priority-ddp-zone-MC': 199.2,
                      'passport-priority-ddp-zone-IM': 193.32,
                      'passport-priority-ddp-zone-SM': 199.2,
                    },
                    '44': {
                      'passport-priority-ddp-zone-CA': 100.15,
                      'passport-priority-ddp-zone-GB': 195.15,
                      'passport-priority-ddp-zone-AU': 279.07,
                      'passport-priority-ddp-zone-BE': 203.83,
                      'passport-priority-ddp-zone-DK': 203.83,
                      'passport-priority-ddp-zone-FR': 203.83,
                      'passport-priority-ddp-zone-DE': 203.83,
                      'passport-priority-ddp-zone-IT': 203.83,
                      'passport-priority-ddp-zone-NL': 203.83,
                      'passport-priority-ddp-zone-ES': 203.83,
                      'passport-priority-ddp-zone-MX': 255.2,
                      'passport-priority-ddp-zone-AM': 379.4,
                      'passport-priority-ddp-zone-AT': 208.49,
                      'passport-priority-ddp-zone-BG': 208.49,
                      'passport-priority-ddp-zone-HR': 208.49,
                      'passport-priority-ddp-zone-CY': 227.91,
                      'passport-priority-ddp-zone-CZ': 208.49,
                      'passport-priority-ddp-zone-EE': 208.49,
                      'passport-priority-ddp-zone-FI': 208.49,
                      'passport-priority-ddp-zone-GR': 225.34,
                      'passport-priority-ddp-zone-HU': 208.49,
                      'passport-priority-ddp-zone-IE': 208.49,
                      'passport-priority-ddp-zone-LV': 208.49,
                      'passport-priority-ddp-zone-LT': 208.49,
                      'passport-priority-ddp-zone-LU': 208.49,
                      'passport-priority-ddp-zone-MT': 227.91,
                      'passport-priority-ddp-zone-PL': 208.49,
                      'passport-priority-ddp-zone-PT': 208.49,
                      'passport-priority-ddp-zone-RO': 208.49,
                      'passport-priority-ddp-zone-SK': 208.49,
                      'passport-priority-ddp-zone-SI': 208.49,
                      'passport-priority-ddp-zone-SE': 208.49,
                      'passport-priority-ddp-zone-IL': 311.22,
                      'passport-priority-ddp-zone-OM': 321.51,
                      'passport-priority-ddp-zone-QA': 310.66,
                      'passport-priority-ddp-zone-SA': 310.69,
                      'passport-priority-ddp-zone-AE': 311.13,
                      'passport-priority-ddp-zone-CN': 433.63,
                      'passport-priority-ddp-zone-HK': 282.23,
                      'passport-priority-ddp-zone-IN': 333.09,
                      'passport-priority-ddp-zone-JP': 390.22,
                      'passport-priority-ddp-zone-KR': 324.32,
                      'passport-priority-ddp-zone-NZ': 281.94,
                      'passport-priority-ddp-zone-SG': 282.23,
                      'passport-priority-ddp-zone-TH': 284.06,
                      'passport-priority-ddp-zone-GG': 379.3,
                      'passport-priority-ddp-zone-JE': 379.3,
                      'passport-priority-ddp-zone-NO': 278.92,
                      'passport-priority-ddp-zone-CH': 279.48,
                      'passport-priority-ddp-zone-IS': 243.49,
                      'passport-priority-ddp-zone-AI': 306.98,
                      'passport-priority-ddp-zone-AG': 306.98,
                      'passport-priority-ddp-zone-AR': 371.39,
                      'passport-priority-ddp-zone-AW': 306.98,
                      'passport-priority-ddp-zone-BS': 306.98,
                      'passport-priority-ddp-zone-BB': 330.45,
                      'passport-priority-ddp-zone-BZ': 366.2,
                      'passport-priority-ddp-zone-BM': 307.58,
                      'passport-priority-ddp-zone-BO': 374.52,
                      'passport-priority-ddp-zone-BR': 279.7,
                      'passport-priority-ddp-zone-KY': 306.98,
                      'passport-priority-ddp-zone-CL': 316.96,
                      'passport-priority-ddp-zone-CO': 279.7,
                      'passport-priority-ddp-zone-CR': 372.16,
                      'passport-priority-ddp-zone-DM': 306.98,
                      'passport-priority-ddp-zone-DO': 308.08,
                      'passport-priority-ddp-zone-EC': 372.55,
                      'passport-priority-ddp-zone-SV': 366.2,
                      'passport-priority-ddp-zone-GP': 359.57,
                      'passport-priority-ddp-zone-GT': 366.3,
                      'passport-priority-ddp-zone-GY': 366.2,
                      'passport-priority-ddp-zone-HT': 306.98,
                      'passport-priority-ddp-zone-JM': 338.69,
                      'passport-priority-ddp-zone-MQ': 324.51,
                      'passport-priority-ddp-zone-AN': 306.98,
                      'passport-priority-ddp-zone-NI': 371.14,
                      'passport-priority-ddp-zone-PA': 366.64,
                      'passport-priority-ddp-zone-PY': 366.2,
                      'passport-priority-ddp-zone-PE': 369.67,
                      'passport-priority-ddp-zone-SR': 366.2,
                      'passport-priority-ddp-zone-TT': 315.87,
                      'passport-priority-ddp-zone-UY': 366.2,
                      'passport-priority-ddp-zone-AF': 518.23,
                      'passport-priority-ddp-zone-DZ': 518.23,
                      'passport-priority-ddp-zone-BH': 503.68,
                      'passport-priority-ddp-zone-BD': 457.7,
                      'passport-priority-ddp-zone-BT': 457.7,
                      'passport-priority-ddp-zone-BA': 518.23,
                      'passport-priority-ddp-zone-BW': 518.23,
                      'passport-priority-ddp-zone-BN': 503.68,
                      'passport-priority-ddp-zone-BF': 518.23,
                      'passport-priority-ddp-zone-BI': 518.23,
                      'passport-priority-ddp-zone-KH': 518.23,
                      'passport-priority-ddp-zone-CM': 518.23,
                      'passport-priority-ddp-zone-CV': 518.23,
                      'passport-priority-ddp-zone-TD': 518.23,
                      'passport-priority-ddp-zone-CG': 518.23,
                      'passport-priority-ddp-zone-CI': 518.23,
                      'passport-priority-ddp-zone-EG': 503.68,
                      'passport-priority-ddp-zone-ET': 518.23,
                      'passport-priority-ddp-zone-GA': 518.23,
                      'passport-priority-ddp-zone-GM': 518.23,
                      'passport-priority-ddp-zone-GH': 518.23,
                      'passport-priority-ddp-zone-GN': 518.23,
                      'passport-priority-ddp-zone-ID': 458.9,
                      'passport-priority-ddp-zone-JO': 503.68,
                      'passport-priority-ddp-zone-KE': 518.23,
                      'passport-priority-ddp-zone-KW': 504.46,
                      'passport-priority-ddp-zone-LB': 503.68,
                      'passport-priority-ddp-zone-LI': 503.57,
                      'passport-priority-ddp-zone-MO': 458.79,
                      'passport-priority-ddp-zone-MG': 518.23,
                      'passport-priority-ddp-zone-MW': 518.23,
                      'passport-priority-ddp-zone-MY': 442.4,
                      'passport-priority-ddp-zone-MV': 457.7,
                      'passport-priority-ddp-zone-ML': 518.23,
                      'passport-priority-ddp-zone-MR': 518.23,
                      'passport-priority-ddp-zone-MU': 518.23,
                      'passport-priority-ddp-zone-MD': 518.23,
                      'passport-priority-ddp-zone-MA': 518.81,
                      'passport-priority-ddp-zone-MZ': 518.23,
                      'passport-priority-ddp-zone-NA': 518.23,
                      'passport-priority-ddp-zone-NP': 457.7,
                      'passport-priority-ddp-zone-NE': 518.23,
                      'passport-priority-ddp-zone-NG': 518.23,
                      'passport-priority-ddp-zone-PK': 457.7,
                      'passport-priority-ddp-zone-PH': 442.99,
                      'passport-priority-ddp-zone-RE': 518.23,
                      'passport-priority-ddp-zone-RW': 518.23,
                      'passport-priority-ddp-zone-SN': 518.23,
                      'passport-priority-ddp-zone-SC': 518.23,
                      'passport-priority-ddp-zone-ZA': 485.82,
                      'passport-priority-ddp-zone-LK': 457.7,
                      'passport-priority-ddp-zone-SZ': 518.23,
                      'passport-priority-ddp-zone-TW': 442.99,
                      'passport-priority-ddp-zone-TJ': 518.23,
                      'passport-priority-ddp-zone-TZ': 518.23,
                      'passport-priority-ddp-zone-TG': 518.23,
                      'passport-priority-ddp-zone-TN': 518.23,
                      'passport-priority-ddp-zone-TR': 503.71,
                      'passport-priority-ddp-zone-TM': 518.23,
                      'passport-priority-ddp-zone-UG': 518.23,
                      'passport-priority-ddp-zone-UA': 518.23,
                      'passport-priority-ddp-zone-VN': 442.93,
                      'passport-priority-ddp-zone-YE': 503.68,
                      'passport-priority-ddp-zone-ZM': 518.23,
                      'passport-priority-ddp-zone-ZW': 518.23,
                      'passport-priority-ddp-zone-MC': 203.83,
                      'passport-priority-ddp-zone-IM': 197.95,
                      'passport-priority-ddp-zone-SM': 203.83,
                    },
                    '45': {
                      'passport-priority-ddp-zone-CA': 102.43,
                      'passport-priority-ddp-zone-GB': 199.58,
                      'passport-priority-ddp-zone-AU': 285.41,
                      'passport-priority-ddp-zone-BE': 208.46,
                      'passport-priority-ddp-zone-DK': 208.46,
                      'passport-priority-ddp-zone-FR': 208.46,
                      'passport-priority-ddp-zone-DE': 208.46,
                      'passport-priority-ddp-zone-IT': 208.46,
                      'passport-priority-ddp-zone-NL': 208.46,
                      'passport-priority-ddp-zone-ES': 208.46,
                      'passport-priority-ddp-zone-MX': 261.0,
                      'passport-priority-ddp-zone-AM': 388.02,
                      'passport-priority-ddp-zone-AT': 213.23,
                      'passport-priority-ddp-zone-BG': 213.23,
                      'passport-priority-ddp-zone-HR': 213.23,
                      'passport-priority-ddp-zone-CY': 233.09,
                      'passport-priority-ddp-zone-CZ': 213.23,
                      'passport-priority-ddp-zone-EE': 213.23,
                      'passport-priority-ddp-zone-FI': 213.23,
                      'passport-priority-ddp-zone-GR': 230.46,
                      'passport-priority-ddp-zone-HU': 213.23,
                      'passport-priority-ddp-zone-IE': 213.23,
                      'passport-priority-ddp-zone-LV': 213.23,
                      'passport-priority-ddp-zone-LT': 213.23,
                      'passport-priority-ddp-zone-LU': 213.23,
                      'passport-priority-ddp-zone-MT': 233.09,
                      'passport-priority-ddp-zone-PL': 213.23,
                      'passport-priority-ddp-zone-PT': 213.23,
                      'passport-priority-ddp-zone-RO': 213.23,
                      'passport-priority-ddp-zone-SK': 213.23,
                      'passport-priority-ddp-zone-SI': 213.23,
                      'passport-priority-ddp-zone-SE': 213.23,
                      'passport-priority-ddp-zone-IL': 318.29,
                      'passport-priority-ddp-zone-OM': 328.82,
                      'passport-priority-ddp-zone-QA': 317.72,
                      'passport-priority-ddp-zone-SA': 317.75,
                      'passport-priority-ddp-zone-AE': 318.2,
                      'passport-priority-ddp-zone-CN': 443.49,
                      'passport-priority-ddp-zone-HK': 288.65,
                      'passport-priority-ddp-zone-IN': 340.66,
                      'passport-priority-ddp-zone-JP': 399.09,
                      'passport-priority-ddp-zone-KR': 331.69,
                      'passport-priority-ddp-zone-NZ': 288.35,
                      'passport-priority-ddp-zone-SG': 288.65,
                      'passport-priority-ddp-zone-TH': 290.52,
                      'passport-priority-ddp-zone-GG': 387.92,
                      'passport-priority-ddp-zone-JE': 387.92,
                      'passport-priority-ddp-zone-NO': 285.25,
                      'passport-priority-ddp-zone-CH': 285.82,
                      'passport-priority-ddp-zone-IS': 249.02,
                      'passport-priority-ddp-zone-AI': 313.96,
                      'passport-priority-ddp-zone-AG': 313.96,
                      'passport-priority-ddp-zone-AR': 379.83,
                      'passport-priority-ddp-zone-AW': 313.96,
                      'passport-priority-ddp-zone-BS': 313.96,
                      'passport-priority-ddp-zone-BB': 337.97,
                      'passport-priority-ddp-zone-BZ': 374.52,
                      'passport-priority-ddp-zone-BM': 314.58,
                      'passport-priority-ddp-zone-BO': 383.03,
                      'passport-priority-ddp-zone-BR': 286.06,
                      'passport-priority-ddp-zone-KY': 313.96,
                      'passport-priority-ddp-zone-CL': 324.16,
                      'passport-priority-ddp-zone-CO': 286.06,
                      'passport-priority-ddp-zone-CR': 380.62,
                      'passport-priority-ddp-zone-DM': 313.96,
                      'passport-priority-ddp-zone-DO': 315.08,
                      'passport-priority-ddp-zone-EC': 381.02,
                      'passport-priority-ddp-zone-SV': 374.52,
                      'passport-priority-ddp-zone-GP': 367.75,
                      'passport-priority-ddp-zone-GT': 374.62,
                      'passport-priority-ddp-zone-GY': 374.52,
                      'passport-priority-ddp-zone-HT': 313.96,
                      'passport-priority-ddp-zone-JM': 346.4,
                      'passport-priority-ddp-zone-MQ': 331.89,
                      'passport-priority-ddp-zone-AN': 313.96,
                      'passport-priority-ddp-zone-NI': 379.57,
                      'passport-priority-ddp-zone-PA': 374.97,
                      'passport-priority-ddp-zone-PY': 374.52,
                      'passport-priority-ddp-zone-PE': 378.07,
                      'passport-priority-ddp-zone-SR': 374.52,
                      'passport-priority-ddp-zone-TT': 323.06,
                      'passport-priority-ddp-zone-UY': 374.52,
                      'passport-priority-ddp-zone-AF': 530.01,
                      'passport-priority-ddp-zone-DZ': 530.01,
                      'passport-priority-ddp-zone-BH': 515.12,
                      'passport-priority-ddp-zone-BD': 468.11,
                      'passport-priority-ddp-zone-BT': 468.11,
                      'passport-priority-ddp-zone-BA': 530.01,
                      'passport-priority-ddp-zone-BW': 530.01,
                      'passport-priority-ddp-zone-BN': 515.12,
                      'passport-priority-ddp-zone-BF': 530.01,
                      'passport-priority-ddp-zone-BI': 530.01,
                      'passport-priority-ddp-zone-KH': 530.01,
                      'passport-priority-ddp-zone-CM': 530.01,
                      'passport-priority-ddp-zone-CV': 530.01,
                      'passport-priority-ddp-zone-TD': 530.01,
                      'passport-priority-ddp-zone-CG': 530.01,
                      'passport-priority-ddp-zone-CI': 530.01,
                      'passport-priority-ddp-zone-EG': 515.12,
                      'passport-priority-ddp-zone-ET': 530.01,
                      'passport-priority-ddp-zone-GA': 530.01,
                      'passport-priority-ddp-zone-GM': 530.01,
                      'passport-priority-ddp-zone-GH': 530.01,
                      'passport-priority-ddp-zone-GN': 530.01,
                      'passport-priority-ddp-zone-ID': 469.25,
                      'passport-priority-ddp-zone-JO': 515.12,
                      'passport-priority-ddp-zone-KE': 530.01,
                      'passport-priority-ddp-zone-KW': 515.93,
                      'passport-priority-ddp-zone-LB': 515.12,
                      'passport-priority-ddp-zone-LI': 515.0,
                      'passport-priority-ddp-zone-MO': 469.22,
                      'passport-priority-ddp-zone-MG': 530.01,
                      'passport-priority-ddp-zone-MW': 530.01,
                      'passport-priority-ddp-zone-MY': 452.45,
                      'passport-priority-ddp-zone-MV': 468.11,
                      'passport-priority-ddp-zone-ML': 530.01,
                      'passport-priority-ddp-zone-MR': 530.01,
                      'passport-priority-ddp-zone-MU': 530.01,
                      'passport-priority-ddp-zone-MD': 530.01,
                      'passport-priority-ddp-zone-MA': 530.61,
                      'passport-priority-ddp-zone-MZ': 530.01,
                      'passport-priority-ddp-zone-NA': 530.01,
                      'passport-priority-ddp-zone-NP': 468.11,
                      'passport-priority-ddp-zone-NE': 530.01,
                      'passport-priority-ddp-zone-NG': 530.01,
                      'passport-priority-ddp-zone-PK': 468.11,
                      'passport-priority-ddp-zone-PH': 453.07,
                      'passport-priority-ddp-zone-RE': 530.01,
                      'passport-priority-ddp-zone-RW': 530.01,
                      'passport-priority-ddp-zone-SN': 530.01,
                      'passport-priority-ddp-zone-SC': 530.01,
                      'passport-priority-ddp-zone-ZA': 496.86,
                      'passport-priority-ddp-zone-LK': 468.11,
                      'passport-priority-ddp-zone-SZ': 530.01,
                      'passport-priority-ddp-zone-TW': 453.07,
                      'passport-priority-ddp-zone-TJ': 530.01,
                      'passport-priority-ddp-zone-TZ': 530.01,
                      'passport-priority-ddp-zone-TG': 530.01,
                      'passport-priority-ddp-zone-TN': 530.01,
                      'passport-priority-ddp-zone-TR': 515.15,
                      'passport-priority-ddp-zone-TM': 530.01,
                      'passport-priority-ddp-zone-UG': 530.01,
                      'passport-priority-ddp-zone-UA': 530.01,
                      'passport-priority-ddp-zone-VN': 452.99,
                      'passport-priority-ddp-zone-YE': 515.12,
                      'passport-priority-ddp-zone-ZM': 530.01,
                      'passport-priority-ddp-zone-ZW': 530.01,
                      'passport-priority-ddp-zone-MC': 208.46,
                      'passport-priority-ddp-zone-IM': 202.58,
                      'passport-priority-ddp-zone-SM': 208.46,
                    },
                    '46': {
                      'passport-priority-ddp-zone-CA': 104.71,
                      'passport-priority-ddp-zone-GB': 204.01,
                      'passport-priority-ddp-zone-AU': 291.75,
                      'passport-priority-ddp-zone-BE': 213.09,
                      'passport-priority-ddp-zone-DK': 213.09,
                      'passport-priority-ddp-zone-FR': 213.09,
                      'passport-priority-ddp-zone-DE': 213.09,
                      'passport-priority-ddp-zone-IT': 213.09,
                      'passport-priority-ddp-zone-NL': 213.09,
                      'passport-priority-ddp-zone-ES': 213.09,
                      'passport-priority-ddp-zone-MX': 266.8,
                      'passport-priority-ddp-zone-AM': 396.64,
                      'passport-priority-ddp-zone-AT': 217.97,
                      'passport-priority-ddp-zone-BG': 217.97,
                      'passport-priority-ddp-zone-HR': 217.97,
                      'passport-priority-ddp-zone-CY': 238.27,
                      'passport-priority-ddp-zone-CZ': 217.97,
                      'passport-priority-ddp-zone-EE': 217.97,
                      'passport-priority-ddp-zone-FI': 217.97,
                      'passport-priority-ddp-zone-GR': 235.58,
                      'passport-priority-ddp-zone-HU': 217.97,
                      'passport-priority-ddp-zone-IE': 217.97,
                      'passport-priority-ddp-zone-LV': 217.97,
                      'passport-priority-ddp-zone-LT': 217.97,
                      'passport-priority-ddp-zone-LU': 217.97,
                      'passport-priority-ddp-zone-MT': 238.27,
                      'passport-priority-ddp-zone-PL': 217.97,
                      'passport-priority-ddp-zone-PT': 217.97,
                      'passport-priority-ddp-zone-RO': 217.97,
                      'passport-priority-ddp-zone-SK': 217.97,
                      'passport-priority-ddp-zone-SI': 217.97,
                      'passport-priority-ddp-zone-SE': 217.97,
                      'passport-priority-ddp-zone-IL': 325.36,
                      'passport-priority-ddp-zone-OM': 336.13,
                      'passport-priority-ddp-zone-QA': 324.78,
                      'passport-priority-ddp-zone-SA': 324.81,
                      'passport-priority-ddp-zone-AE': 325.27,
                      'passport-priority-ddp-zone-CN': 453.35,
                      'passport-priority-ddp-zone-HK': 295.07,
                      'passport-priority-ddp-zone-IN': 348.23,
                      'passport-priority-ddp-zone-JP': 407.96,
                      'passport-priority-ddp-zone-KR': 339.06,
                      'passport-priority-ddp-zone-NZ': 294.76,
                      'passport-priority-ddp-zone-SG': 295.07,
                      'passport-priority-ddp-zone-TH': 296.98,
                      'passport-priority-ddp-zone-GG': 396.54,
                      'passport-priority-ddp-zone-JE': 396.54,
                      'passport-priority-ddp-zone-NO': 291.58,
                      'passport-priority-ddp-zone-CH': 292.16,
                      'passport-priority-ddp-zone-IS': 254.55,
                      'passport-priority-ddp-zone-AI': 320.94,
                      'passport-priority-ddp-zone-AG': 320.94,
                      'passport-priority-ddp-zone-AR': 388.27,
                      'passport-priority-ddp-zone-AW': 320.94,
                      'passport-priority-ddp-zone-BS': 320.94,
                      'passport-priority-ddp-zone-BB': 345.49,
                      'passport-priority-ddp-zone-BZ': 382.84,
                      'passport-priority-ddp-zone-BM': 321.58,
                      'passport-priority-ddp-zone-BO': 391.54,
                      'passport-priority-ddp-zone-BR': 292.42,
                      'passport-priority-ddp-zone-KY': 320.94,
                      'passport-priority-ddp-zone-CL': 331.36,
                      'passport-priority-ddp-zone-CO': 292.42,
                      'passport-priority-ddp-zone-CR': 389.08,
                      'passport-priority-ddp-zone-DM': 320.94,
                      'passport-priority-ddp-zone-DO': 322.08,
                      'passport-priority-ddp-zone-EC': 389.49,
                      'passport-priority-ddp-zone-SV': 382.84,
                      'passport-priority-ddp-zone-GP': 375.93,
                      'passport-priority-ddp-zone-GT': 382.94,
                      'passport-priority-ddp-zone-GY': 382.84,
                      'passport-priority-ddp-zone-HT': 320.94,
                      'passport-priority-ddp-zone-JM': 354.11,
                      'passport-priority-ddp-zone-MQ': 339.27,
                      'passport-priority-ddp-zone-AN': 320.94,
                      'passport-priority-ddp-zone-NI': 388.0,
                      'passport-priority-ddp-zone-PA': 383.3,
                      'passport-priority-ddp-zone-PY': 382.84,
                      'passport-priority-ddp-zone-PE': 386.47,
                      'passport-priority-ddp-zone-SR': 382.84,
                      'passport-priority-ddp-zone-TT': 330.25,
                      'passport-priority-ddp-zone-UY': 382.84,
                      'passport-priority-ddp-zone-AF': 541.79,
                      'passport-priority-ddp-zone-DZ': 541.79,
                      'passport-priority-ddp-zone-BH': 526.56,
                      'passport-priority-ddp-zone-BD': 478.52,
                      'passport-priority-ddp-zone-BT': 478.52,
                      'passport-priority-ddp-zone-BA': 541.79,
                      'passport-priority-ddp-zone-BW': 541.79,
                      'passport-priority-ddp-zone-BN': 526.56,
                      'passport-priority-ddp-zone-BF': 541.79,
                      'passport-priority-ddp-zone-BI': 541.79,
                      'passport-priority-ddp-zone-KH': 541.79,
                      'passport-priority-ddp-zone-CM': 541.79,
                      'passport-priority-ddp-zone-CV': 541.79,
                      'passport-priority-ddp-zone-TD': 541.79,
                      'passport-priority-ddp-zone-CG': 541.79,
                      'passport-priority-ddp-zone-CI': 541.79,
                      'passport-priority-ddp-zone-EG': 526.56,
                      'passport-priority-ddp-zone-ET': 541.79,
                      'passport-priority-ddp-zone-GA': 541.79,
                      'passport-priority-ddp-zone-GM': 541.79,
                      'passport-priority-ddp-zone-GH': 541.79,
                      'passport-priority-ddp-zone-GN': 541.79,
                      'passport-priority-ddp-zone-ID': 479.6,
                      'passport-priority-ddp-zone-JO': 526.56,
                      'passport-priority-ddp-zone-KE': 541.79,
                      'passport-priority-ddp-zone-KW': 527.4,
                      'passport-priority-ddp-zone-LB': 526.56,
                      'passport-priority-ddp-zone-LI': 526.43,
                      'passport-priority-ddp-zone-MO': 479.65,
                      'passport-priority-ddp-zone-MG': 541.79,
                      'passport-priority-ddp-zone-MW': 541.79,
                      'passport-priority-ddp-zone-MY': 462.5,
                      'passport-priority-ddp-zone-MV': 478.52,
                      'passport-priority-ddp-zone-ML': 541.79,
                      'passport-priority-ddp-zone-MR': 541.79,
                      'passport-priority-ddp-zone-MU': 541.79,
                      'passport-priority-ddp-zone-MD': 541.79,
                      'passport-priority-ddp-zone-MA': 542.41,
                      'passport-priority-ddp-zone-MZ': 541.79,
                      'passport-priority-ddp-zone-NA': 541.79,
                      'passport-priority-ddp-zone-NP': 478.52,
                      'passport-priority-ddp-zone-NE': 541.79,
                      'passport-priority-ddp-zone-NG': 541.79,
                      'passport-priority-ddp-zone-PK': 478.52,
                      'passport-priority-ddp-zone-PH': 463.15,
                      'passport-priority-ddp-zone-RE': 541.79,
                      'passport-priority-ddp-zone-RW': 541.79,
                      'passport-priority-ddp-zone-SN': 541.79,
                      'passport-priority-ddp-zone-SC': 541.79,
                      'passport-priority-ddp-zone-ZA': 507.9,
                      'passport-priority-ddp-zone-LK': 478.52,
                      'passport-priority-ddp-zone-SZ': 541.79,
                      'passport-priority-ddp-zone-TW': 463.15,
                      'passport-priority-ddp-zone-TJ': 541.79,
                      'passport-priority-ddp-zone-TZ': 541.79,
                      'passport-priority-ddp-zone-TG': 541.79,
                      'passport-priority-ddp-zone-TN': 541.79,
                      'passport-priority-ddp-zone-TR': 526.59,
                      'passport-priority-ddp-zone-TM': 541.79,
                      'passport-priority-ddp-zone-UG': 541.79,
                      'passport-priority-ddp-zone-UA': 541.79,
                      'passport-priority-ddp-zone-VN': 463.05,
                      'passport-priority-ddp-zone-YE': 526.56,
                      'passport-priority-ddp-zone-ZM': 541.79,
                      'passport-priority-ddp-zone-ZW': 541.79,
                      'passport-priority-ddp-zone-MC': 213.09,
                      'passport-priority-ddp-zone-IM': 207.21,
                      'passport-priority-ddp-zone-SM': 213.09,
                    },
                    '47': {
                      'passport-priority-ddp-zone-CA': 106.99,
                      'passport-priority-ddp-zone-GB': 208.44,
                      'passport-priority-ddp-zone-AU': 298.09,
                      'passport-priority-ddp-zone-BE': 217.72,
                      'passport-priority-ddp-zone-DK': 217.72,
                      'passport-priority-ddp-zone-FR': 217.72,
                      'passport-priority-ddp-zone-DE': 217.72,
                      'passport-priority-ddp-zone-IT': 217.72,
                      'passport-priority-ddp-zone-NL': 217.72,
                      'passport-priority-ddp-zone-ES': 217.72,
                      'passport-priority-ddp-zone-MX': 272.6,
                      'passport-priority-ddp-zone-AM': 405.26,
                      'passport-priority-ddp-zone-AT': 222.71,
                      'passport-priority-ddp-zone-BG': 222.71,
                      'passport-priority-ddp-zone-HR': 222.71,
                      'passport-priority-ddp-zone-CY': 243.45,
                      'passport-priority-ddp-zone-CZ': 222.71,
                      'passport-priority-ddp-zone-EE': 222.71,
                      'passport-priority-ddp-zone-FI': 222.71,
                      'passport-priority-ddp-zone-GR': 240.7,
                      'passport-priority-ddp-zone-HU': 222.71,
                      'passport-priority-ddp-zone-IE': 222.71,
                      'passport-priority-ddp-zone-LV': 222.71,
                      'passport-priority-ddp-zone-LT': 222.71,
                      'passport-priority-ddp-zone-LU': 222.71,
                      'passport-priority-ddp-zone-MT': 243.45,
                      'passport-priority-ddp-zone-PL': 222.71,
                      'passport-priority-ddp-zone-PT': 222.71,
                      'passport-priority-ddp-zone-RO': 222.71,
                      'passport-priority-ddp-zone-SK': 222.71,
                      'passport-priority-ddp-zone-SI': 222.71,
                      'passport-priority-ddp-zone-SE': 222.71,
                      'passport-priority-ddp-zone-IL': 332.43,
                      'passport-priority-ddp-zone-OM': 343.44,
                      'passport-priority-ddp-zone-QA': 331.84,
                      'passport-priority-ddp-zone-SA': 331.87,
                      'passport-priority-ddp-zone-AE': 332.34,
                      'passport-priority-ddp-zone-CN': 463.21,
                      'passport-priority-ddp-zone-HK': 301.49,
                      'passport-priority-ddp-zone-IN': 355.8,
                      'passport-priority-ddp-zone-JP': 416.83,
                      'passport-priority-ddp-zone-KR': 346.43,
                      'passport-priority-ddp-zone-NZ': 301.17,
                      'passport-priority-ddp-zone-SG': 301.49,
                      'passport-priority-ddp-zone-TH': 303.44,
                      'passport-priority-ddp-zone-GG': 405.16,
                      'passport-priority-ddp-zone-JE': 405.16,
                      'passport-priority-ddp-zone-NO': 297.91,
                      'passport-priority-ddp-zone-CH': 298.5,
                      'passport-priority-ddp-zone-IS': 260.08,
                      'passport-priority-ddp-zone-AI': 327.92,
                      'passport-priority-ddp-zone-AG': 327.92,
                      'passport-priority-ddp-zone-AR': 396.71,
                      'passport-priority-ddp-zone-AW': 327.92,
                      'passport-priority-ddp-zone-BS': 327.92,
                      'passport-priority-ddp-zone-BB': 353.01,
                      'passport-priority-ddp-zone-BZ': 391.16,
                      'passport-priority-ddp-zone-BM': 328.58,
                      'passport-priority-ddp-zone-BO': 400.05,
                      'passport-priority-ddp-zone-BR': 298.78,
                      'passport-priority-ddp-zone-KY': 327.92,
                      'passport-priority-ddp-zone-CL': 338.56,
                      'passport-priority-ddp-zone-CO': 298.78,
                      'passport-priority-ddp-zone-CR': 397.54,
                      'passport-priority-ddp-zone-DM': 327.92,
                      'passport-priority-ddp-zone-DO': 329.08,
                      'passport-priority-ddp-zone-EC': 397.96,
                      'passport-priority-ddp-zone-SV': 391.16,
                      'passport-priority-ddp-zone-GP': 384.11,
                      'passport-priority-ddp-zone-GT': 391.26,
                      'passport-priority-ddp-zone-GY': 391.16,
                      'passport-priority-ddp-zone-HT': 327.92,
                      'passport-priority-ddp-zone-JM': 361.82,
                      'passport-priority-ddp-zone-MQ': 346.65,
                      'passport-priority-ddp-zone-AN': 327.92,
                      'passport-priority-ddp-zone-NI': 396.43,
                      'passport-priority-ddp-zone-PA': 391.63,
                      'passport-priority-ddp-zone-PY': 391.16,
                      'passport-priority-ddp-zone-PE': 394.87,
                      'passport-priority-ddp-zone-SR': 391.16,
                      'passport-priority-ddp-zone-TT': 337.44,
                      'passport-priority-ddp-zone-UY': 391.16,
                      'passport-priority-ddp-zone-AF': 553.57,
                      'passport-priority-ddp-zone-DZ': 553.57,
                      'passport-priority-ddp-zone-BH': 538.0,
                      'passport-priority-ddp-zone-BD': 488.93,
                      'passport-priority-ddp-zone-BT': 488.93,
                      'passport-priority-ddp-zone-BA': 553.57,
                      'passport-priority-ddp-zone-BW': 553.57,
                      'passport-priority-ddp-zone-BN': 538.0,
                      'passport-priority-ddp-zone-BF': 553.57,
                      'passport-priority-ddp-zone-BI': 553.57,
                      'passport-priority-ddp-zone-KH': 553.57,
                      'passport-priority-ddp-zone-CM': 553.57,
                      'passport-priority-ddp-zone-CV': 553.57,
                      'passport-priority-ddp-zone-TD': 553.57,
                      'passport-priority-ddp-zone-CG': 553.57,
                      'passport-priority-ddp-zone-CI': 553.57,
                      'passport-priority-ddp-zone-EG': 538.0,
                      'passport-priority-ddp-zone-ET': 553.57,
                      'passport-priority-ddp-zone-GA': 553.57,
                      'passport-priority-ddp-zone-GM': 553.57,
                      'passport-priority-ddp-zone-GH': 553.57,
                      'passport-priority-ddp-zone-GN': 553.57,
                      'passport-priority-ddp-zone-ID': 489.95,
                      'passport-priority-ddp-zone-JO': 538.0,
                      'passport-priority-ddp-zone-KE': 553.57,
                      'passport-priority-ddp-zone-KW': 538.87,
                      'passport-priority-ddp-zone-LB': 538.0,
                      'passport-priority-ddp-zone-LI': 537.86,
                      'passport-priority-ddp-zone-MO': 490.08,
                      'passport-priority-ddp-zone-MG': 553.57,
                      'passport-priority-ddp-zone-MW': 553.57,
                      'passport-priority-ddp-zone-MY': 472.55,
                      'passport-priority-ddp-zone-MV': 488.93,
                      'passport-priority-ddp-zone-ML': 553.57,
                      'passport-priority-ddp-zone-MR': 553.57,
                      'passport-priority-ddp-zone-MU': 553.57,
                      'passport-priority-ddp-zone-MD': 553.57,
                      'passport-priority-ddp-zone-MA': 554.21,
                      'passport-priority-ddp-zone-MZ': 553.57,
                      'passport-priority-ddp-zone-NA': 553.57,
                      'passport-priority-ddp-zone-NP': 488.93,
                      'passport-priority-ddp-zone-NE': 553.57,
                      'passport-priority-ddp-zone-NG': 553.57,
                      'passport-priority-ddp-zone-PK': 488.93,
                      'passport-priority-ddp-zone-PH': 473.23,
                      'passport-priority-ddp-zone-RE': 553.57,
                      'passport-priority-ddp-zone-RW': 553.57,
                      'passport-priority-ddp-zone-SN': 553.57,
                      'passport-priority-ddp-zone-SC': 553.57,
                      'passport-priority-ddp-zone-ZA': 518.94,
                      'passport-priority-ddp-zone-LK': 488.93,
                      'passport-priority-ddp-zone-SZ': 553.57,
                      'passport-priority-ddp-zone-TW': 473.23,
                      'passport-priority-ddp-zone-TJ': 553.57,
                      'passport-priority-ddp-zone-TZ': 553.57,
                      'passport-priority-ddp-zone-TG': 553.57,
                      'passport-priority-ddp-zone-TN': 553.57,
                      'passport-priority-ddp-zone-TR': 538.03,
                      'passport-priority-ddp-zone-TM': 553.57,
                      'passport-priority-ddp-zone-UG': 553.57,
                      'passport-priority-ddp-zone-UA': 553.57,
                      'passport-priority-ddp-zone-VN': 473.11,
                      'passport-priority-ddp-zone-YE': 538.0,
                      'passport-priority-ddp-zone-ZM': 553.57,
                      'passport-priority-ddp-zone-ZW': 553.57,
                      'passport-priority-ddp-zone-MC': 217.72,
                      'passport-priority-ddp-zone-IM': 211.84,
                      'passport-priority-ddp-zone-SM': 217.72,
                    },
                    '48': {
                      'passport-priority-ddp-zone-CA': 109.27,
                      'passport-priority-ddp-zone-GB': 212.87,
                      'passport-priority-ddp-zone-AU': 304.43,
                      'passport-priority-ddp-zone-BE': 222.35,
                      'passport-priority-ddp-zone-DK': 222.35,
                      'passport-priority-ddp-zone-FR': 222.35,
                      'passport-priority-ddp-zone-DE': 222.35,
                      'passport-priority-ddp-zone-IT': 222.35,
                      'passport-priority-ddp-zone-NL': 222.35,
                      'passport-priority-ddp-zone-ES': 222.35,
                      'passport-priority-ddp-zone-MX': 278.4,
                      'passport-priority-ddp-zone-AM': 413.88,
                      'passport-priority-ddp-zone-AT': 227.45,
                      'passport-priority-ddp-zone-BG': 227.45,
                      'passport-priority-ddp-zone-HR': 227.45,
                      'passport-priority-ddp-zone-CY': 248.63,
                      'passport-priority-ddp-zone-CZ': 227.45,
                      'passport-priority-ddp-zone-EE': 227.45,
                      'passport-priority-ddp-zone-FI': 227.45,
                      'passport-priority-ddp-zone-GR': 245.82,
                      'passport-priority-ddp-zone-HU': 227.45,
                      'passport-priority-ddp-zone-IE': 227.45,
                      'passport-priority-ddp-zone-LV': 227.45,
                      'passport-priority-ddp-zone-LT': 227.45,
                      'passport-priority-ddp-zone-LU': 227.45,
                      'passport-priority-ddp-zone-MT': 248.63,
                      'passport-priority-ddp-zone-PL': 227.45,
                      'passport-priority-ddp-zone-PT': 227.45,
                      'passport-priority-ddp-zone-RO': 227.45,
                      'passport-priority-ddp-zone-SK': 227.45,
                      'passport-priority-ddp-zone-SI': 227.45,
                      'passport-priority-ddp-zone-SE': 227.45,
                      'passport-priority-ddp-zone-IL': 339.5,
                      'passport-priority-ddp-zone-OM': 350.75,
                      'passport-priority-ddp-zone-QA': 338.9,
                      'passport-priority-ddp-zone-SA': 338.93,
                      'passport-priority-ddp-zone-AE': 339.41,
                      'passport-priority-ddp-zone-CN': 473.07,
                      'passport-priority-ddp-zone-HK': 307.91,
                      'passport-priority-ddp-zone-IN': 363.37,
                      'passport-priority-ddp-zone-JP': 425.7,
                      'passport-priority-ddp-zone-KR': 353.8,
                      'passport-priority-ddp-zone-NZ': 307.58,
                      'passport-priority-ddp-zone-SG': 307.91,
                      'passport-priority-ddp-zone-TH': 309.9,
                      'passport-priority-ddp-zone-GG': 413.78,
                      'passport-priority-ddp-zone-JE': 413.78,
                      'passport-priority-ddp-zone-NO': 304.24,
                      'passport-priority-ddp-zone-CH': 304.84,
                      'passport-priority-ddp-zone-IS': 265.61,
                      'passport-priority-ddp-zone-AI': 334.9,
                      'passport-priority-ddp-zone-AG': 334.9,
                      'passport-priority-ddp-zone-AR': 405.15,
                      'passport-priority-ddp-zone-AW': 334.9,
                      'passport-priority-ddp-zone-BS': 334.9,
                      'passport-priority-ddp-zone-BB': 360.53,
                      'passport-priority-ddp-zone-BZ': 399.48,
                      'passport-priority-ddp-zone-BM': 335.58,
                      'passport-priority-ddp-zone-BO': 408.56,
                      'passport-priority-ddp-zone-BR': 305.14,
                      'passport-priority-ddp-zone-KY': 334.9,
                      'passport-priority-ddp-zone-CL': 345.76,
                      'passport-priority-ddp-zone-CO': 305.14,
                      'passport-priority-ddp-zone-CR': 406.0,
                      'passport-priority-ddp-zone-DM': 334.9,
                      'passport-priority-ddp-zone-DO': 336.08,
                      'passport-priority-ddp-zone-EC': 406.43,
                      'passport-priority-ddp-zone-SV': 399.48,
                      'passport-priority-ddp-zone-GP': 392.29,
                      'passport-priority-ddp-zone-GT': 399.58,
                      'passport-priority-ddp-zone-GY': 399.48,
                      'passport-priority-ddp-zone-HT': 334.9,
                      'passport-priority-ddp-zone-JM': 369.53,
                      'passport-priority-ddp-zone-MQ': 354.03,
                      'passport-priority-ddp-zone-AN': 334.9,
                      'passport-priority-ddp-zone-NI': 404.86,
                      'passport-priority-ddp-zone-PA': 399.96,
                      'passport-priority-ddp-zone-PY': 399.48,
                      'passport-priority-ddp-zone-PE': 403.27,
                      'passport-priority-ddp-zone-SR': 399.48,
                      'passport-priority-ddp-zone-TT': 344.63,
                      'passport-priority-ddp-zone-UY': 399.48,
                      'passport-priority-ddp-zone-AF': 565.35,
                      'passport-priority-ddp-zone-DZ': 565.35,
                      'passport-priority-ddp-zone-BH': 549.44,
                      'passport-priority-ddp-zone-BD': 499.34,
                      'passport-priority-ddp-zone-BT': 499.34,
                      'passport-priority-ddp-zone-BA': 565.35,
                      'passport-priority-ddp-zone-BW': 565.35,
                      'passport-priority-ddp-zone-BN': 549.44,
                      'passport-priority-ddp-zone-BF': 565.35,
                      'passport-priority-ddp-zone-BI': 565.35,
                      'passport-priority-ddp-zone-KH': 565.35,
                      'passport-priority-ddp-zone-CM': 565.35,
                      'passport-priority-ddp-zone-CV': 565.35,
                      'passport-priority-ddp-zone-TD': 565.35,
                      'passport-priority-ddp-zone-CG': 565.35,
                      'passport-priority-ddp-zone-CI': 565.35,
                      'passport-priority-ddp-zone-EG': 549.44,
                      'passport-priority-ddp-zone-ET': 565.35,
                      'passport-priority-ddp-zone-GA': 565.35,
                      'passport-priority-ddp-zone-GM': 565.35,
                      'passport-priority-ddp-zone-GH': 565.35,
                      'passport-priority-ddp-zone-GN': 565.35,
                      'passport-priority-ddp-zone-ID': 500.3,
                      'passport-priority-ddp-zone-JO': 549.44,
                      'passport-priority-ddp-zone-KE': 565.35,
                      'passport-priority-ddp-zone-KW': 550.34,
                      'passport-priority-ddp-zone-LB': 549.44,
                      'passport-priority-ddp-zone-LI': 549.29,
                      'passport-priority-ddp-zone-MO': 500.51,
                      'passport-priority-ddp-zone-MG': 565.35,
                      'passport-priority-ddp-zone-MW': 565.35,
                      'passport-priority-ddp-zone-MY': 482.6,
                      'passport-priority-ddp-zone-MV': 499.34,
                      'passport-priority-ddp-zone-ML': 565.35,
                      'passport-priority-ddp-zone-MR': 565.35,
                      'passport-priority-ddp-zone-MU': 565.35,
                      'passport-priority-ddp-zone-MD': 565.35,
                      'passport-priority-ddp-zone-MA': 566.01,
                      'passport-priority-ddp-zone-MZ': 565.35,
                      'passport-priority-ddp-zone-NA': 565.35,
                      'passport-priority-ddp-zone-NP': 499.34,
                      'passport-priority-ddp-zone-NE': 565.35,
                      'passport-priority-ddp-zone-NG': 565.35,
                      'passport-priority-ddp-zone-PK': 499.34,
                      'passport-priority-ddp-zone-PH': 483.31,
                      'passport-priority-ddp-zone-RE': 565.35,
                      'passport-priority-ddp-zone-RW': 565.35,
                      'passport-priority-ddp-zone-SN': 565.35,
                      'passport-priority-ddp-zone-SC': 565.35,
                      'passport-priority-ddp-zone-ZA': 529.98,
                      'passport-priority-ddp-zone-LK': 499.34,
                      'passport-priority-ddp-zone-SZ': 565.35,
                      'passport-priority-ddp-zone-TW': 483.31,
                      'passport-priority-ddp-zone-TJ': 565.35,
                      'passport-priority-ddp-zone-TZ': 565.35,
                      'passport-priority-ddp-zone-TG': 565.35,
                      'passport-priority-ddp-zone-TN': 565.35,
                      'passport-priority-ddp-zone-TR': 549.47,
                      'passport-priority-ddp-zone-TM': 565.35,
                      'passport-priority-ddp-zone-UG': 565.35,
                      'passport-priority-ddp-zone-UA': 565.35,
                      'passport-priority-ddp-zone-VN': 483.17,
                      'passport-priority-ddp-zone-YE': 549.44,
                      'passport-priority-ddp-zone-ZM': 565.35,
                      'passport-priority-ddp-zone-ZW': 565.35,
                      'passport-priority-ddp-zone-MC': 222.35,
                      'passport-priority-ddp-zone-IM': 216.47,
                      'passport-priority-ddp-zone-SM': 222.35,
                    },
                    '49': {
                      'passport-priority-ddp-zone-CA': 111.55,
                      'passport-priority-ddp-zone-GB': 217.3,
                      'passport-priority-ddp-zone-AU': 310.77,
                      'passport-priority-ddp-zone-BE': 226.98,
                      'passport-priority-ddp-zone-DK': 226.98,
                      'passport-priority-ddp-zone-FR': 226.98,
                      'passport-priority-ddp-zone-DE': 226.98,
                      'passport-priority-ddp-zone-IT': 226.98,
                      'passport-priority-ddp-zone-NL': 226.98,
                      'passport-priority-ddp-zone-ES': 226.98,
                      'passport-priority-ddp-zone-MX': 284.2,
                      'passport-priority-ddp-zone-AM': 422.5,
                      'passport-priority-ddp-zone-AT': 232.19,
                      'passport-priority-ddp-zone-BG': 232.19,
                      'passport-priority-ddp-zone-HR': 232.19,
                      'passport-priority-ddp-zone-CY': 253.81,
                      'passport-priority-ddp-zone-CZ': 232.19,
                      'passport-priority-ddp-zone-EE': 232.19,
                      'passport-priority-ddp-zone-FI': 232.19,
                      'passport-priority-ddp-zone-GR': 250.94,
                      'passport-priority-ddp-zone-HU': 232.19,
                      'passport-priority-ddp-zone-IE': 232.19,
                      'passport-priority-ddp-zone-LV': 232.19,
                      'passport-priority-ddp-zone-LT': 232.19,
                      'passport-priority-ddp-zone-LU': 232.19,
                      'passport-priority-ddp-zone-MT': 253.81,
                      'passport-priority-ddp-zone-PL': 232.19,
                      'passport-priority-ddp-zone-PT': 232.19,
                      'passport-priority-ddp-zone-RO': 232.19,
                      'passport-priority-ddp-zone-SK': 232.19,
                      'passport-priority-ddp-zone-SI': 232.19,
                      'passport-priority-ddp-zone-SE': 232.19,
                      'passport-priority-ddp-zone-IL': 346.57,
                      'passport-priority-ddp-zone-OM': 358.06,
                      'passport-priority-ddp-zone-QA': 345.96,
                      'passport-priority-ddp-zone-SA': 345.99,
                      'passport-priority-ddp-zone-AE': 346.48,
                      'passport-priority-ddp-zone-CN': 482.93,
                      'passport-priority-ddp-zone-HK': 314.33,
                      'passport-priority-ddp-zone-IN': 370.94,
                      'passport-priority-ddp-zone-JP': 434.57,
                      'passport-priority-ddp-zone-KR': 361.17,
                      'passport-priority-ddp-zone-NZ': 313.99,
                      'passport-priority-ddp-zone-SG': 314.33,
                      'passport-priority-ddp-zone-TH': 316.36,
                      'passport-priority-ddp-zone-GG': 422.4,
                      'passport-priority-ddp-zone-JE': 422.4,
                      'passport-priority-ddp-zone-NO': 310.57,
                      'passport-priority-ddp-zone-CH': 311.18,
                      'passport-priority-ddp-zone-IS': 271.14,
                      'passport-priority-ddp-zone-AI': 341.88,
                      'passport-priority-ddp-zone-AG': 341.88,
                      'passport-priority-ddp-zone-AR': 413.59,
                      'passport-priority-ddp-zone-AW': 341.88,
                      'passport-priority-ddp-zone-BS': 341.88,
                      'passport-priority-ddp-zone-BB': 368.05,
                      'passport-priority-ddp-zone-BZ': 407.8,
                      'passport-priority-ddp-zone-BM': 342.58,
                      'passport-priority-ddp-zone-BO': 417.07,
                      'passport-priority-ddp-zone-BR': 311.5,
                      'passport-priority-ddp-zone-KY': 341.88,
                      'passport-priority-ddp-zone-CL': 352.96,
                      'passport-priority-ddp-zone-CO': 311.5,
                      'passport-priority-ddp-zone-CR': 414.46,
                      'passport-priority-ddp-zone-DM': 341.88,
                      'passport-priority-ddp-zone-DO': 343.08,
                      'passport-priority-ddp-zone-EC': 414.9,
                      'passport-priority-ddp-zone-SV': 407.8,
                      'passport-priority-ddp-zone-GP': 400.47,
                      'passport-priority-ddp-zone-GT': 407.9,
                      'passport-priority-ddp-zone-GY': 407.8,
                      'passport-priority-ddp-zone-HT': 341.88,
                      'passport-priority-ddp-zone-JM': 377.24,
                      'passport-priority-ddp-zone-MQ': 361.41,
                      'passport-priority-ddp-zone-AN': 341.88,
                      'passport-priority-ddp-zone-NI': 413.29,
                      'passport-priority-ddp-zone-PA': 408.29,
                      'passport-priority-ddp-zone-PY': 407.8,
                      'passport-priority-ddp-zone-PE': 411.67,
                      'passport-priority-ddp-zone-SR': 407.8,
                      'passport-priority-ddp-zone-TT': 351.82,
                      'passport-priority-ddp-zone-UY': 407.8,
                      'passport-priority-ddp-zone-AF': 577.13,
                      'passport-priority-ddp-zone-DZ': 577.13,
                      'passport-priority-ddp-zone-BH': 560.88,
                      'passport-priority-ddp-zone-BD': 509.75,
                      'passport-priority-ddp-zone-BT': 509.75,
                      'passport-priority-ddp-zone-BA': 577.13,
                      'passport-priority-ddp-zone-BW': 577.13,
                      'passport-priority-ddp-zone-BN': 560.88,
                      'passport-priority-ddp-zone-BF': 577.13,
                      'passport-priority-ddp-zone-BI': 577.13,
                      'passport-priority-ddp-zone-KH': 577.13,
                      'passport-priority-ddp-zone-CM': 577.13,
                      'passport-priority-ddp-zone-CV': 577.13,
                      'passport-priority-ddp-zone-TD': 577.13,
                      'passport-priority-ddp-zone-CG': 577.13,
                      'passport-priority-ddp-zone-CI': 577.13,
                      'passport-priority-ddp-zone-EG': 560.88,
                      'passport-priority-ddp-zone-ET': 577.13,
                      'passport-priority-ddp-zone-GA': 577.13,
                      'passport-priority-ddp-zone-GM': 577.13,
                      'passport-priority-ddp-zone-GH': 577.13,
                      'passport-priority-ddp-zone-GN': 577.13,
                      'passport-priority-ddp-zone-ID': 510.65,
                      'passport-priority-ddp-zone-JO': 560.88,
                      'passport-priority-ddp-zone-KE': 577.13,
                      'passport-priority-ddp-zone-KW': 561.81,
                      'passport-priority-ddp-zone-LB': 560.88,
                      'passport-priority-ddp-zone-LI': 560.72,
                      'passport-priority-ddp-zone-MO': 510.94,
                      'passport-priority-ddp-zone-MG': 577.13,
                      'passport-priority-ddp-zone-MW': 577.13,
                      'passport-priority-ddp-zone-MY': 492.65,
                      'passport-priority-ddp-zone-MV': 509.75,
                      'passport-priority-ddp-zone-ML': 577.13,
                      'passport-priority-ddp-zone-MR': 577.13,
                      'passport-priority-ddp-zone-MU': 577.13,
                      'passport-priority-ddp-zone-MD': 577.13,
                      'passport-priority-ddp-zone-MA': 577.81,
                      'passport-priority-ddp-zone-MZ': 577.13,
                      'passport-priority-ddp-zone-NA': 577.13,
                      'passport-priority-ddp-zone-NP': 509.75,
                      'passport-priority-ddp-zone-NE': 577.13,
                      'passport-priority-ddp-zone-NG': 577.13,
                      'passport-priority-ddp-zone-PK': 509.75,
                      'passport-priority-ddp-zone-PH': 493.39,
                      'passport-priority-ddp-zone-RE': 577.13,
                      'passport-priority-ddp-zone-RW': 577.13,
                      'passport-priority-ddp-zone-SN': 577.13,
                      'passport-priority-ddp-zone-SC': 577.13,
                      'passport-priority-ddp-zone-ZA': 541.02,
                      'passport-priority-ddp-zone-LK': 509.75,
                      'passport-priority-ddp-zone-SZ': 577.13,
                      'passport-priority-ddp-zone-TW': 493.39,
                      'passport-priority-ddp-zone-TJ': 577.13,
                      'passport-priority-ddp-zone-TZ': 577.13,
                      'passport-priority-ddp-zone-TG': 577.13,
                      'passport-priority-ddp-zone-TN': 577.13,
                      'passport-priority-ddp-zone-TR': 560.91,
                      'passport-priority-ddp-zone-TM': 577.13,
                      'passport-priority-ddp-zone-UG': 577.13,
                      'passport-priority-ddp-zone-UA': 577.13,
                      'passport-priority-ddp-zone-VN': 493.23,
                      'passport-priority-ddp-zone-YE': 560.88,
                      'passport-priority-ddp-zone-ZM': 577.13,
                      'passport-priority-ddp-zone-ZW': 577.13,
                      'passport-priority-ddp-zone-MC': 226.98,
                      'passport-priority-ddp-zone-IM': 221.1,
                      'passport-priority-ddp-zone-SM': 226.98,
                    },
                    '50': {
                      'passport-priority-ddp-zone-CA': 113.83,
                      'passport-priority-ddp-zone-GB': 221.73,
                      'passport-priority-ddp-zone-AU': 317.11,
                      'passport-priority-ddp-zone-BE': 231.61,
                      'passport-priority-ddp-zone-DK': 231.61,
                      'passport-priority-ddp-zone-FR': 231.61,
                      'passport-priority-ddp-zone-DE': 231.61,
                      'passport-priority-ddp-zone-IT': 231.61,
                      'passport-priority-ddp-zone-NL': 231.61,
                      'passport-priority-ddp-zone-ES': 231.61,
                      'passport-priority-ddp-zone-MX': 290.0,
                      'passport-priority-ddp-zone-AM': 431.12,
                      'passport-priority-ddp-zone-AT': 236.93,
                      'passport-priority-ddp-zone-BG': 236.93,
                      'passport-priority-ddp-zone-HR': 236.93,
                      'passport-priority-ddp-zone-CY': 258.99,
                      'passport-priority-ddp-zone-CZ': 236.93,
                      'passport-priority-ddp-zone-EE': 236.93,
                      'passport-priority-ddp-zone-FI': 236.93,
                      'passport-priority-ddp-zone-GR': 256.06,
                      'passport-priority-ddp-zone-HU': 236.93,
                      'passport-priority-ddp-zone-IE': 236.93,
                      'passport-priority-ddp-zone-LV': 236.93,
                      'passport-priority-ddp-zone-LT': 236.93,
                      'passport-priority-ddp-zone-LU': 236.93,
                      'passport-priority-ddp-zone-MT': 258.99,
                      'passport-priority-ddp-zone-PL': 236.93,
                      'passport-priority-ddp-zone-PT': 236.93,
                      'passport-priority-ddp-zone-RO': 236.93,
                      'passport-priority-ddp-zone-SK': 236.93,
                      'passport-priority-ddp-zone-SI': 236.93,
                      'passport-priority-ddp-zone-SE': 236.93,
                      'passport-priority-ddp-zone-IL': 353.64,
                      'passport-priority-ddp-zone-OM': 365.37,
                      'passport-priority-ddp-zone-QA': 353.02,
                      'passport-priority-ddp-zone-SA': 353.05,
                      'passport-priority-ddp-zone-AE': 353.55,
                      'passport-priority-ddp-zone-CN': 492.79,
                      'passport-priority-ddp-zone-HK': 320.75,
                      'passport-priority-ddp-zone-IN': 378.51,
                      'passport-priority-ddp-zone-JP': 443.44,
                      'passport-priority-ddp-zone-KR': 368.54,
                      'passport-priority-ddp-zone-NZ': 320.4,
                      'passport-priority-ddp-zone-SG': 320.75,
                      'passport-priority-ddp-zone-TH': 322.82,
                      'passport-priority-ddp-zone-GG': 431.02,
                      'passport-priority-ddp-zone-JE': 431.02,
                      'passport-priority-ddp-zone-NO': 316.9,
                      'passport-priority-ddp-zone-CH': 317.52,
                      'passport-priority-ddp-zone-IS': 276.67,
                      'passport-priority-ddp-zone-AI': 348.86,
                      'passport-priority-ddp-zone-AG': 348.86,
                      'passport-priority-ddp-zone-AR': 422.03,
                      'passport-priority-ddp-zone-AW': 348.86,
                      'passport-priority-ddp-zone-BS': 348.86,
                      'passport-priority-ddp-zone-BB': 375.57,
                      'passport-priority-ddp-zone-BZ': 416.12,
                      'passport-priority-ddp-zone-BM': 349.58,
                      'passport-priority-ddp-zone-BO': 425.58,
                      'passport-priority-ddp-zone-BR': 317.86,
                      'passport-priority-ddp-zone-KY': 348.86,
                      'passport-priority-ddp-zone-CL': 360.16,
                      'passport-priority-ddp-zone-CO': 317.86,
                      'passport-priority-ddp-zone-CR': 422.92,
                      'passport-priority-ddp-zone-DM': 348.86,
                      'passport-priority-ddp-zone-DO': 350.08,
                      'passport-priority-ddp-zone-EC': 423.37,
                      'passport-priority-ddp-zone-SV': 416.12,
                      'passport-priority-ddp-zone-GP': 408.65,
                      'passport-priority-ddp-zone-GT': 416.22,
                      'passport-priority-ddp-zone-GY': 416.12,
                      'passport-priority-ddp-zone-HT': 348.86,
                      'passport-priority-ddp-zone-JM': 384.95,
                      'passport-priority-ddp-zone-MQ': 368.79,
                      'passport-priority-ddp-zone-AN': 348.86,
                      'passport-priority-ddp-zone-NI': 421.72,
                      'passport-priority-ddp-zone-PA': 416.62,
                      'passport-priority-ddp-zone-PY': 416.12,
                      'passport-priority-ddp-zone-PE': 420.07,
                      'passport-priority-ddp-zone-SR': 416.12,
                      'passport-priority-ddp-zone-TT': 359.01,
                      'passport-priority-ddp-zone-UY': 416.12,
                      'passport-priority-ddp-zone-AF': 588.91,
                      'passport-priority-ddp-zone-DZ': 588.91,
                      'passport-priority-ddp-zone-BH': 572.32,
                      'passport-priority-ddp-zone-BD': 520.16,
                      'passport-priority-ddp-zone-BT': 520.16,
                      'passport-priority-ddp-zone-BA': 588.91,
                      'passport-priority-ddp-zone-BW': 588.91,
                      'passport-priority-ddp-zone-BN': 572.32,
                      'passport-priority-ddp-zone-BF': 588.91,
                      'passport-priority-ddp-zone-BI': 588.91,
                      'passport-priority-ddp-zone-KH': 588.91,
                      'passport-priority-ddp-zone-CM': 588.91,
                      'passport-priority-ddp-zone-CV': 588.91,
                      'passport-priority-ddp-zone-TD': 588.91,
                      'passport-priority-ddp-zone-CG': 588.91,
                      'passport-priority-ddp-zone-CI': 588.91,
                      'passport-priority-ddp-zone-EG': 572.32,
                      'passport-priority-ddp-zone-ET': 588.91,
                      'passport-priority-ddp-zone-GA': 588.91,
                      'passport-priority-ddp-zone-GM': 588.91,
                      'passport-priority-ddp-zone-GH': 588.91,
                      'passport-priority-ddp-zone-GN': 588.91,
                      'passport-priority-ddp-zone-ID': 521.0,
                      'passport-priority-ddp-zone-JO': 572.32,
                      'passport-priority-ddp-zone-KE': 588.91,
                      'passport-priority-ddp-zone-KW': 573.28,
                      'passport-priority-ddp-zone-LB': 572.32,
                      'passport-priority-ddp-zone-LI': 572.15,
                      'passport-priority-ddp-zone-MO': 521.37,
                      'passport-priority-ddp-zone-MG': 588.91,
                      'passport-priority-ddp-zone-MW': 588.91,
                      'passport-priority-ddp-zone-MY': 502.7,
                      'passport-priority-ddp-zone-MV': 520.16,
                      'passport-priority-ddp-zone-ML': 588.91,
                      'passport-priority-ddp-zone-MR': 588.91,
                      'passport-priority-ddp-zone-MU': 588.91,
                      'passport-priority-ddp-zone-MD': 588.91,
                      'passport-priority-ddp-zone-MA': 589.61,
                      'passport-priority-ddp-zone-MZ': 588.91,
                      'passport-priority-ddp-zone-NA': 588.91,
                      'passport-priority-ddp-zone-NP': 520.16,
                      'passport-priority-ddp-zone-NE': 588.91,
                      'passport-priority-ddp-zone-NG': 588.91,
                      'passport-priority-ddp-zone-PK': 520.16,
                      'passport-priority-ddp-zone-PH': 503.47,
                      'passport-priority-ddp-zone-RE': 588.91,
                      'passport-priority-ddp-zone-RW': 588.91,
                      'passport-priority-ddp-zone-SN': 588.91,
                      'passport-priority-ddp-zone-SC': 588.91,
                      'passport-priority-ddp-zone-ZA': 552.06,
                      'passport-priority-ddp-zone-LK': 520.16,
                      'passport-priority-ddp-zone-SZ': 588.91,
                      'passport-priority-ddp-zone-TW': 503.47,
                      'passport-priority-ddp-zone-TJ': 588.91,
                      'passport-priority-ddp-zone-TZ': 588.91,
                      'passport-priority-ddp-zone-TG': 588.91,
                      'passport-priority-ddp-zone-TN': 588.91,
                      'passport-priority-ddp-zone-TR': 572.35,
                      'passport-priority-ddp-zone-TM': 588.91,
                      'passport-priority-ddp-zone-UG': 588.91,
                      'passport-priority-ddp-zone-UA': 588.91,
                      'passport-priority-ddp-zone-VN': 503.29,
                      'passport-priority-ddp-zone-YE': 572.32,
                      'passport-priority-ddp-zone-ZM': 588.91,
                      'passport-priority-ddp-zone-ZW': 588.91,
                      'passport-priority-ddp-zone-MC': 231.61,
                      'passport-priority-ddp-zone-IM': 225.73,
                      'passport-priority-ddp-zone-SM': 231.61,
                    },
                    '51': {
                      'passport-priority-ddp-zone-CA': 116.11,
                      'passport-priority-ddp-zone-GB': 226.16,
                      'passport-priority-ddp-zone-AU': 323.45,
                      'passport-priority-ddp-zone-BE': 236.24,
                      'passport-priority-ddp-zone-DK': 236.24,
                      'passport-priority-ddp-zone-FR': 236.24,
                      'passport-priority-ddp-zone-DE': 236.24,
                      'passport-priority-ddp-zone-IT': 236.24,
                      'passport-priority-ddp-zone-NL': 236.24,
                      'passport-priority-ddp-zone-ES': 236.24,
                      'passport-priority-ddp-zone-MX': 295.8,
                      'passport-priority-ddp-zone-AM': 439.74,
                      'passport-priority-ddp-zone-AT': 241.67,
                      'passport-priority-ddp-zone-BG': 241.67,
                      'passport-priority-ddp-zone-HR': 241.67,
                      'passport-priority-ddp-zone-CY': 264.17,
                      'passport-priority-ddp-zone-CZ': 241.67,
                      'passport-priority-ddp-zone-EE': 241.67,
                      'passport-priority-ddp-zone-FI': 241.67,
                      'passport-priority-ddp-zone-GR': 261.18,
                      'passport-priority-ddp-zone-HU': 241.67,
                      'passport-priority-ddp-zone-IE': 241.67,
                      'passport-priority-ddp-zone-LV': 241.67,
                      'passport-priority-ddp-zone-LT': 241.67,
                      'passport-priority-ddp-zone-LU': 241.67,
                      'passport-priority-ddp-zone-MT': 264.17,
                      'passport-priority-ddp-zone-PL': 241.67,
                      'passport-priority-ddp-zone-PT': 241.67,
                      'passport-priority-ddp-zone-RO': 241.67,
                      'passport-priority-ddp-zone-SK': 241.67,
                      'passport-priority-ddp-zone-SI': 241.67,
                      'passport-priority-ddp-zone-SE': 241.67,
                      'passport-priority-ddp-zone-IL': 360.71,
                      'passport-priority-ddp-zone-OM': 372.68,
                      'passport-priority-ddp-zone-QA': 360.08,
                      'passport-priority-ddp-zone-SA': 360.11,
                      'passport-priority-ddp-zone-AE': 360.62,
                      'passport-priority-ddp-zone-CN': 502.65,
                      'passport-priority-ddp-zone-HK': 327.17,
                      'passport-priority-ddp-zone-IN': 386.08,
                      'passport-priority-ddp-zone-JP': 452.31,
                      'passport-priority-ddp-zone-KR': 375.91,
                      'passport-priority-ddp-zone-NZ': 326.81,
                      'passport-priority-ddp-zone-SG': 327.17,
                      'passport-priority-ddp-zone-TH': 329.28,
                      'passport-priority-ddp-zone-GG': 439.64,
                      'passport-priority-ddp-zone-JE': 439.64,
                      'passport-priority-ddp-zone-NO': 323.23,
                      'passport-priority-ddp-zone-CH': 323.86,
                      'passport-priority-ddp-zone-IS': 282.2,
                      'passport-priority-ddp-zone-AI': 355.84,
                      'passport-priority-ddp-zone-AG': 355.84,
                      'passport-priority-ddp-zone-AR': 430.47,
                      'passport-priority-ddp-zone-AW': 355.84,
                      'passport-priority-ddp-zone-BS': 355.84,
                      'passport-priority-ddp-zone-BB': 383.09,
                      'passport-priority-ddp-zone-BZ': 424.44,
                      'passport-priority-ddp-zone-BM': 356.58,
                      'passport-priority-ddp-zone-BO': 434.09,
                      'passport-priority-ddp-zone-BR': 324.22,
                      'passport-priority-ddp-zone-KY': 355.84,
                      'passport-priority-ddp-zone-CL': 367.36,
                      'passport-priority-ddp-zone-CO': 324.22,
                      'passport-priority-ddp-zone-CR': 431.38,
                      'passport-priority-ddp-zone-DM': 355.84,
                      'passport-priority-ddp-zone-DO': 357.08,
                      'passport-priority-ddp-zone-EC': 431.84,
                      'passport-priority-ddp-zone-SV': 424.44,
                      'passport-priority-ddp-zone-GP': 416.83,
                      'passport-priority-ddp-zone-GT': 424.54,
                      'passport-priority-ddp-zone-GY': 424.44,
                      'passport-priority-ddp-zone-HT': 355.84,
                      'passport-priority-ddp-zone-JM': 392.66,
                      'passport-priority-ddp-zone-MQ': 376.17,
                      'passport-priority-ddp-zone-AN': 355.84,
                      'passport-priority-ddp-zone-NI': 430.15,
                      'passport-priority-ddp-zone-PA': 424.95,
                      'passport-priority-ddp-zone-PY': 424.44,
                      'passport-priority-ddp-zone-PE': 428.47,
                      'passport-priority-ddp-zone-SR': 424.44,
                      'passport-priority-ddp-zone-TT': 366.2,
                      'passport-priority-ddp-zone-UY': 424.44,
                      'passport-priority-ddp-zone-AF': 600.69,
                      'passport-priority-ddp-zone-DZ': 600.69,
                      'passport-priority-ddp-zone-BH': 583.76,
                      'passport-priority-ddp-zone-BD': 530.57,
                      'passport-priority-ddp-zone-BT': 530.57,
                      'passport-priority-ddp-zone-BA': 600.69,
                      'passport-priority-ddp-zone-BW': 600.69,
                      'passport-priority-ddp-zone-BN': 583.76,
                      'passport-priority-ddp-zone-BF': 600.69,
                      'passport-priority-ddp-zone-BI': 600.69,
                      'passport-priority-ddp-zone-KH': 600.69,
                      'passport-priority-ddp-zone-CM': 600.69,
                      'passport-priority-ddp-zone-CV': 600.69,
                      'passport-priority-ddp-zone-TD': 600.69,
                      'passport-priority-ddp-zone-CG': 600.69,
                      'passport-priority-ddp-zone-CI': 600.69,
                      'passport-priority-ddp-zone-EG': 583.76,
                      'passport-priority-ddp-zone-ET': 600.69,
                      'passport-priority-ddp-zone-GA': 600.69,
                      'passport-priority-ddp-zone-GM': 600.69,
                      'passport-priority-ddp-zone-GH': 600.69,
                      'passport-priority-ddp-zone-GN': 600.69,
                      'passport-priority-ddp-zone-ID': 531.35,
                      'passport-priority-ddp-zone-JO': 583.76,
                      'passport-priority-ddp-zone-KE': 600.69,
                      'passport-priority-ddp-zone-KW': 584.75,
                      'passport-priority-ddp-zone-LB': 583.76,
                      'passport-priority-ddp-zone-LI': 583.58,
                      'passport-priority-ddp-zone-MO': 531.8,
                      'passport-priority-ddp-zone-MG': 600.69,
                      'passport-priority-ddp-zone-MW': 600.69,
                      'passport-priority-ddp-zone-MY': 512.75,
                      'passport-priority-ddp-zone-MV': 530.57,
                      'passport-priority-ddp-zone-ML': 600.69,
                      'passport-priority-ddp-zone-MR': 600.69,
                      'passport-priority-ddp-zone-MU': 600.69,
                      'passport-priority-ddp-zone-MD': 600.69,
                      'passport-priority-ddp-zone-MA': 601.41,
                      'passport-priority-ddp-zone-MZ': 600.69,
                      'passport-priority-ddp-zone-NA': 600.69,
                      'passport-priority-ddp-zone-NP': 530.57,
                      'passport-priority-ddp-zone-NE': 600.69,
                      'passport-priority-ddp-zone-NG': 600.69,
                      'passport-priority-ddp-zone-PK': 530.57,
                      'passport-priority-ddp-zone-PH': 513.55,
                      'passport-priority-ddp-zone-RE': 600.69,
                      'passport-priority-ddp-zone-RW': 600.69,
                      'passport-priority-ddp-zone-SN': 600.69,
                      'passport-priority-ddp-zone-SC': 600.69,
                      'passport-priority-ddp-zone-ZA': 563.1,
                      'passport-priority-ddp-zone-LK': 530.57,
                      'passport-priority-ddp-zone-SZ': 600.69,
                      'passport-priority-ddp-zone-TW': 513.55,
                      'passport-priority-ddp-zone-TJ': 600.69,
                      'passport-priority-ddp-zone-TZ': 600.69,
                      'passport-priority-ddp-zone-TG': 600.69,
                      'passport-priority-ddp-zone-TN': 600.69,
                      'passport-priority-ddp-zone-TR': 583.79,
                      'passport-priority-ddp-zone-TM': 600.69,
                      'passport-priority-ddp-zone-UG': 600.69,
                      'passport-priority-ddp-zone-UA': 600.69,
                      'passport-priority-ddp-zone-VN': 513.35,
                      'passport-priority-ddp-zone-YE': 583.76,
                      'passport-priority-ddp-zone-ZM': 600.69,
                      'passport-priority-ddp-zone-ZW': 600.69,
                      'passport-priority-ddp-zone-MC': 236.24,
                      'passport-priority-ddp-zone-IM': 230.36,
                      'passport-priority-ddp-zone-SM': 236.24,
                    },
                    '52': {
                      'passport-priority-ddp-zone-CA': 118.39,
                      'passport-priority-ddp-zone-GB': 230.59,
                      'passport-priority-ddp-zone-AU': 329.79,
                      'passport-priority-ddp-zone-BE': 240.87,
                      'passport-priority-ddp-zone-DK': 240.87,
                      'passport-priority-ddp-zone-FR': 240.87,
                      'passport-priority-ddp-zone-DE': 240.87,
                      'passport-priority-ddp-zone-IT': 240.87,
                      'passport-priority-ddp-zone-NL': 240.87,
                      'passport-priority-ddp-zone-ES': 240.87,
                      'passport-priority-ddp-zone-MX': 301.6,
                      'passport-priority-ddp-zone-AM': 448.36,
                      'passport-priority-ddp-zone-AT': 246.41,
                      'passport-priority-ddp-zone-BG': 246.41,
                      'passport-priority-ddp-zone-HR': 246.41,
                      'passport-priority-ddp-zone-CY': 269.35,
                      'passport-priority-ddp-zone-CZ': 246.41,
                      'passport-priority-ddp-zone-EE': 246.41,
                      'passport-priority-ddp-zone-FI': 246.41,
                      'passport-priority-ddp-zone-GR': 266.3,
                      'passport-priority-ddp-zone-HU': 246.41,
                      'passport-priority-ddp-zone-IE': 246.41,
                      'passport-priority-ddp-zone-LV': 246.41,
                      'passport-priority-ddp-zone-LT': 246.41,
                      'passport-priority-ddp-zone-LU': 246.41,
                      'passport-priority-ddp-zone-MT': 269.35,
                      'passport-priority-ddp-zone-PL': 246.41,
                      'passport-priority-ddp-zone-PT': 246.41,
                      'passport-priority-ddp-zone-RO': 246.41,
                      'passport-priority-ddp-zone-SK': 246.41,
                      'passport-priority-ddp-zone-SI': 246.41,
                      'passport-priority-ddp-zone-SE': 246.41,
                      'passport-priority-ddp-zone-IL': 367.78,
                      'passport-priority-ddp-zone-OM': 379.99,
                      'passport-priority-ddp-zone-QA': 367.14,
                      'passport-priority-ddp-zone-SA': 367.17,
                      'passport-priority-ddp-zone-AE': 367.69,
                      'passport-priority-ddp-zone-CN': 512.51,
                      'passport-priority-ddp-zone-HK': 333.59,
                      'passport-priority-ddp-zone-IN': 393.65,
                      'passport-priority-ddp-zone-JP': 461.18,
                      'passport-priority-ddp-zone-KR': 383.28,
                      'passport-priority-ddp-zone-NZ': 333.22,
                      'passport-priority-ddp-zone-SG': 333.59,
                      'passport-priority-ddp-zone-TH': 335.74,
                      'passport-priority-ddp-zone-GG': 448.26,
                      'passport-priority-ddp-zone-JE': 448.26,
                      'passport-priority-ddp-zone-NO': 329.56,
                      'passport-priority-ddp-zone-CH': 330.2,
                      'passport-priority-ddp-zone-IS': 287.73,
                      'passport-priority-ddp-zone-AI': 362.82,
                      'passport-priority-ddp-zone-AG': 362.82,
                      'passport-priority-ddp-zone-AR': 438.91,
                      'passport-priority-ddp-zone-AW': 362.82,
                      'passport-priority-ddp-zone-BS': 362.82,
                      'passport-priority-ddp-zone-BB': 390.61,
                      'passport-priority-ddp-zone-BZ': 432.76,
                      'passport-priority-ddp-zone-BM': 363.58,
                      'passport-priority-ddp-zone-BO': 442.6,
                      'passport-priority-ddp-zone-BR': 330.58,
                      'passport-priority-ddp-zone-KY': 362.82,
                      'passport-priority-ddp-zone-CL': 374.56,
                      'passport-priority-ddp-zone-CO': 330.58,
                      'passport-priority-ddp-zone-CR': 439.84,
                      'passport-priority-ddp-zone-DM': 362.82,
                      'passport-priority-ddp-zone-DO': 364.08,
                      'passport-priority-ddp-zone-EC': 440.31,
                      'passport-priority-ddp-zone-SV': 432.76,
                      'passport-priority-ddp-zone-GP': 425.01,
                      'passport-priority-ddp-zone-GT': 432.86,
                      'passport-priority-ddp-zone-GY': 432.76,
                      'passport-priority-ddp-zone-HT': 362.82,
                      'passport-priority-ddp-zone-JM': 400.37,
                      'passport-priority-ddp-zone-MQ': 383.55,
                      'passport-priority-ddp-zone-AN': 362.82,
                      'passport-priority-ddp-zone-NI': 438.58,
                      'passport-priority-ddp-zone-PA': 433.28,
                      'passport-priority-ddp-zone-PY': 432.76,
                      'passport-priority-ddp-zone-PE': 436.87,
                      'passport-priority-ddp-zone-SR': 432.76,
                      'passport-priority-ddp-zone-TT': 373.39,
                      'passport-priority-ddp-zone-UY': 432.76,
                      'passport-priority-ddp-zone-AF': 612.47,
                      'passport-priority-ddp-zone-DZ': 612.47,
                      'passport-priority-ddp-zone-BH': 595.2,
                      'passport-priority-ddp-zone-BD': 540.98,
                      'passport-priority-ddp-zone-BT': 540.98,
                      'passport-priority-ddp-zone-BA': 612.47,
                      'passport-priority-ddp-zone-BW': 612.47,
                      'passport-priority-ddp-zone-BN': 595.2,
                      'passport-priority-ddp-zone-BF': 612.47,
                      'passport-priority-ddp-zone-BI': 612.47,
                      'passport-priority-ddp-zone-KH': 612.47,
                      'passport-priority-ddp-zone-CM': 612.47,
                      'passport-priority-ddp-zone-CV': 612.47,
                      'passport-priority-ddp-zone-TD': 612.47,
                      'passport-priority-ddp-zone-CG': 612.47,
                      'passport-priority-ddp-zone-CI': 612.47,
                      'passport-priority-ddp-zone-EG': 595.2,
                      'passport-priority-ddp-zone-ET': 612.47,
                      'passport-priority-ddp-zone-GA': 612.47,
                      'passport-priority-ddp-zone-GM': 612.47,
                      'passport-priority-ddp-zone-GH': 612.47,
                      'passport-priority-ddp-zone-GN': 612.47,
                      'passport-priority-ddp-zone-ID': 541.7,
                      'passport-priority-ddp-zone-JO': 595.2,
                      'passport-priority-ddp-zone-KE': 612.47,
                      'passport-priority-ddp-zone-KW': 596.22,
                      'passport-priority-ddp-zone-LB': 595.2,
                      'passport-priority-ddp-zone-LI': 595.01,
                      'passport-priority-ddp-zone-MO': 542.23,
                      'passport-priority-ddp-zone-MG': 612.47,
                      'passport-priority-ddp-zone-MW': 612.47,
                      'passport-priority-ddp-zone-MY': 522.8,
                      'passport-priority-ddp-zone-MV': 540.98,
                      'passport-priority-ddp-zone-ML': 612.47,
                      'passport-priority-ddp-zone-MR': 612.47,
                      'passport-priority-ddp-zone-MU': 612.47,
                      'passport-priority-ddp-zone-MD': 612.47,
                      'passport-priority-ddp-zone-MA': 613.21,
                      'passport-priority-ddp-zone-MZ': 612.47,
                      'passport-priority-ddp-zone-NA': 612.47,
                      'passport-priority-ddp-zone-NP': 540.98,
                      'passport-priority-ddp-zone-NE': 612.47,
                      'passport-priority-ddp-zone-NG': 612.47,
                      'passport-priority-ddp-zone-PK': 540.98,
                      'passport-priority-ddp-zone-PH': 523.63,
                      'passport-priority-ddp-zone-RE': 612.47,
                      'passport-priority-ddp-zone-RW': 612.47,
                      'passport-priority-ddp-zone-SN': 612.47,
                      'passport-priority-ddp-zone-SC': 612.47,
                      'passport-priority-ddp-zone-ZA': 574.14,
                      'passport-priority-ddp-zone-LK': 540.98,
                      'passport-priority-ddp-zone-SZ': 612.47,
                      'passport-priority-ddp-zone-TW': 523.63,
                      'passport-priority-ddp-zone-TJ': 612.47,
                      'passport-priority-ddp-zone-TZ': 612.47,
                      'passport-priority-ddp-zone-TG': 612.47,
                      'passport-priority-ddp-zone-TN': 612.47,
                      'passport-priority-ddp-zone-TR': 595.23,
                      'passport-priority-ddp-zone-TM': 612.47,
                      'passport-priority-ddp-zone-UG': 612.47,
                      'passport-priority-ddp-zone-UA': 612.47,
                      'passport-priority-ddp-zone-VN': 523.41,
                      'passport-priority-ddp-zone-YE': 595.2,
                      'passport-priority-ddp-zone-ZM': 612.47,
                      'passport-priority-ddp-zone-ZW': 612.47,
                      'passport-priority-ddp-zone-MC': 240.87,
                      'passport-priority-ddp-zone-IM': 234.99,
                      'passport-priority-ddp-zone-SM': 240.87,
                    },
                    '53': {
                      'passport-priority-ddp-zone-CA': 120.67,
                      'passport-priority-ddp-zone-GB': 235.02,
                      'passport-priority-ddp-zone-AU': 336.13,
                      'passport-priority-ddp-zone-BE': 245.5,
                      'passport-priority-ddp-zone-DK': 245.5,
                      'passport-priority-ddp-zone-FR': 245.5,
                      'passport-priority-ddp-zone-DE': 245.5,
                      'passport-priority-ddp-zone-IT': 245.5,
                      'passport-priority-ddp-zone-NL': 245.5,
                      'passport-priority-ddp-zone-ES': 245.5,
                      'passport-priority-ddp-zone-MX': 307.4,
                      'passport-priority-ddp-zone-AM': 456.98,
                      'passport-priority-ddp-zone-AT': 251.15,
                      'passport-priority-ddp-zone-BG': 251.15,
                      'passport-priority-ddp-zone-HR': 251.15,
                      'passport-priority-ddp-zone-CY': 274.53,
                      'passport-priority-ddp-zone-CZ': 251.15,
                      'passport-priority-ddp-zone-EE': 251.15,
                      'passport-priority-ddp-zone-FI': 251.15,
                      'passport-priority-ddp-zone-GR': 271.42,
                      'passport-priority-ddp-zone-HU': 251.15,
                      'passport-priority-ddp-zone-IE': 251.15,
                      'passport-priority-ddp-zone-LV': 251.15,
                      'passport-priority-ddp-zone-LT': 251.15,
                      'passport-priority-ddp-zone-LU': 251.15,
                      'passport-priority-ddp-zone-MT': 274.53,
                      'passport-priority-ddp-zone-PL': 251.15,
                      'passport-priority-ddp-zone-PT': 251.15,
                      'passport-priority-ddp-zone-RO': 251.15,
                      'passport-priority-ddp-zone-SK': 251.15,
                      'passport-priority-ddp-zone-SI': 251.15,
                      'passport-priority-ddp-zone-SE': 251.15,
                      'passport-priority-ddp-zone-IL': 374.85,
                      'passport-priority-ddp-zone-OM': 387.3,
                      'passport-priority-ddp-zone-QA': 374.2,
                      'passport-priority-ddp-zone-SA': 374.23,
                      'passport-priority-ddp-zone-AE': 374.76,
                      'passport-priority-ddp-zone-CN': 522.37,
                      'passport-priority-ddp-zone-HK': 340.01,
                      'passport-priority-ddp-zone-IN': 401.22,
                      'passport-priority-ddp-zone-JP': 470.05,
                      'passport-priority-ddp-zone-KR': 390.65,
                      'passport-priority-ddp-zone-NZ': 339.63,
                      'passport-priority-ddp-zone-SG': 340.01,
                      'passport-priority-ddp-zone-TH': 342.2,
                      'passport-priority-ddp-zone-GG': 456.88,
                      'passport-priority-ddp-zone-JE': 456.88,
                      'passport-priority-ddp-zone-NO': 335.89,
                      'passport-priority-ddp-zone-CH': 336.54,
                      'passport-priority-ddp-zone-IS': 293.26,
                      'passport-priority-ddp-zone-AI': 369.8,
                      'passport-priority-ddp-zone-AG': 369.8,
                      'passport-priority-ddp-zone-AR': 447.35,
                      'passport-priority-ddp-zone-AW': 369.8,
                      'passport-priority-ddp-zone-BS': 369.8,
                      'passport-priority-ddp-zone-BB': 398.13,
                      'passport-priority-ddp-zone-BZ': 441.08,
                      'passport-priority-ddp-zone-BM': 370.58,
                      'passport-priority-ddp-zone-BO': 451.11,
                      'passport-priority-ddp-zone-BR': 336.94,
                      'passport-priority-ddp-zone-KY': 369.8,
                      'passport-priority-ddp-zone-CL': 381.76,
                      'passport-priority-ddp-zone-CO': 336.94,
                      'passport-priority-ddp-zone-CR': 448.3,
                      'passport-priority-ddp-zone-DM': 369.8,
                      'passport-priority-ddp-zone-DO': 371.08,
                      'passport-priority-ddp-zone-EC': 448.78,
                      'passport-priority-ddp-zone-SV': 441.08,
                      'passport-priority-ddp-zone-GP': 433.19,
                      'passport-priority-ddp-zone-GT': 441.18,
                      'passport-priority-ddp-zone-GY': 441.08,
                      'passport-priority-ddp-zone-HT': 369.8,
                      'passport-priority-ddp-zone-JM': 408.08,
                      'passport-priority-ddp-zone-MQ': 390.93,
                      'passport-priority-ddp-zone-AN': 369.8,
                      'passport-priority-ddp-zone-NI': 447.01,
                      'passport-priority-ddp-zone-PA': 441.61,
                      'passport-priority-ddp-zone-PY': 441.08,
                      'passport-priority-ddp-zone-PE': 445.27,
                      'passport-priority-ddp-zone-SR': 441.08,
                      'passport-priority-ddp-zone-TT': 380.58,
                      'passport-priority-ddp-zone-UY': 441.08,
                      'passport-priority-ddp-zone-AF': 624.25,
                      'passport-priority-ddp-zone-DZ': 624.25,
                      'passport-priority-ddp-zone-BH': 606.64,
                      'passport-priority-ddp-zone-BD': 551.39,
                      'passport-priority-ddp-zone-BT': 551.39,
                      'passport-priority-ddp-zone-BA': 624.25,
                      'passport-priority-ddp-zone-BW': 624.25,
                      'passport-priority-ddp-zone-BN': 606.64,
                      'passport-priority-ddp-zone-BF': 624.25,
                      'passport-priority-ddp-zone-BI': 624.25,
                      'passport-priority-ddp-zone-KH': 624.25,
                      'passport-priority-ddp-zone-CM': 624.25,
                      'passport-priority-ddp-zone-CV': 624.25,
                      'passport-priority-ddp-zone-TD': 624.25,
                      'passport-priority-ddp-zone-CG': 624.25,
                      'passport-priority-ddp-zone-CI': 624.25,
                      'passport-priority-ddp-zone-EG': 606.64,
                      'passport-priority-ddp-zone-ET': 624.25,
                      'passport-priority-ddp-zone-GA': 624.25,
                      'passport-priority-ddp-zone-GM': 624.25,
                      'passport-priority-ddp-zone-GH': 624.25,
                      'passport-priority-ddp-zone-GN': 624.25,
                      'passport-priority-ddp-zone-ID': 552.05,
                      'passport-priority-ddp-zone-JO': 606.64,
                      'passport-priority-ddp-zone-KE': 624.25,
                      'passport-priority-ddp-zone-KW': 607.69,
                      'passport-priority-ddp-zone-LB': 606.64,
                      'passport-priority-ddp-zone-LI': 606.44,
                      'passport-priority-ddp-zone-MO': 552.66,
                      'passport-priority-ddp-zone-MG': 624.25,
                      'passport-priority-ddp-zone-MW': 624.25,
                      'passport-priority-ddp-zone-MY': 532.85,
                      'passport-priority-ddp-zone-MV': 551.39,
                      'passport-priority-ddp-zone-ML': 624.25,
                      'passport-priority-ddp-zone-MR': 624.25,
                      'passport-priority-ddp-zone-MU': 624.25,
                      'passport-priority-ddp-zone-MD': 624.25,
                      'passport-priority-ddp-zone-MA': 625.01,
                      'passport-priority-ddp-zone-MZ': 624.25,
                      'passport-priority-ddp-zone-NA': 624.25,
                      'passport-priority-ddp-zone-NP': 551.39,
                      'passport-priority-ddp-zone-NE': 624.25,
                      'passport-priority-ddp-zone-NG': 624.25,
                      'passport-priority-ddp-zone-PK': 551.39,
                      'passport-priority-ddp-zone-PH': 533.71,
                      'passport-priority-ddp-zone-RE': 624.25,
                      'passport-priority-ddp-zone-RW': 624.25,
                      'passport-priority-ddp-zone-SN': 624.25,
                      'passport-priority-ddp-zone-SC': 624.25,
                      'passport-priority-ddp-zone-ZA': 585.18,
                      'passport-priority-ddp-zone-LK': 551.39,
                      'passport-priority-ddp-zone-SZ': 624.25,
                      'passport-priority-ddp-zone-TW': 533.71,
                      'passport-priority-ddp-zone-TJ': 624.25,
                      'passport-priority-ddp-zone-TZ': 624.25,
                      'passport-priority-ddp-zone-TG': 624.25,
                      'passport-priority-ddp-zone-TN': 624.25,
                      'passport-priority-ddp-zone-TR': 606.67,
                      'passport-priority-ddp-zone-TM': 624.25,
                      'passport-priority-ddp-zone-UG': 624.25,
                      'passport-priority-ddp-zone-UA': 624.25,
                      'passport-priority-ddp-zone-VN': 533.47,
                      'passport-priority-ddp-zone-YE': 606.64,
                      'passport-priority-ddp-zone-ZM': 624.25,
                      'passport-priority-ddp-zone-ZW': 624.25,
                      'passport-priority-ddp-zone-MC': 245.5,
                      'passport-priority-ddp-zone-IM': 239.62,
                      'passport-priority-ddp-zone-SM': 245.5,
                    },
                    '54': {
                      'passport-priority-ddp-zone-CA': 122.95,
                      'passport-priority-ddp-zone-GB': 239.45,
                      'passport-priority-ddp-zone-AU': 342.47,
                      'passport-priority-ddp-zone-BE': 250.13,
                      'passport-priority-ddp-zone-DK': 250.13,
                      'passport-priority-ddp-zone-FR': 250.13,
                      'passport-priority-ddp-zone-DE': 250.13,
                      'passport-priority-ddp-zone-IT': 250.13,
                      'passport-priority-ddp-zone-NL': 250.13,
                      'passport-priority-ddp-zone-ES': 250.13,
                      'passport-priority-ddp-zone-MX': 313.2,
                      'passport-priority-ddp-zone-AM': 465.6,
                      'passport-priority-ddp-zone-AT': 255.89,
                      'passport-priority-ddp-zone-BG': 255.89,
                      'passport-priority-ddp-zone-HR': 255.89,
                      'passport-priority-ddp-zone-CY': 279.71,
                      'passport-priority-ddp-zone-CZ': 255.89,
                      'passport-priority-ddp-zone-EE': 255.89,
                      'passport-priority-ddp-zone-FI': 255.89,
                      'passport-priority-ddp-zone-GR': 276.54,
                      'passport-priority-ddp-zone-HU': 255.89,
                      'passport-priority-ddp-zone-IE': 255.89,
                      'passport-priority-ddp-zone-LV': 255.89,
                      'passport-priority-ddp-zone-LT': 255.89,
                      'passport-priority-ddp-zone-LU': 255.89,
                      'passport-priority-ddp-zone-MT': 279.71,
                      'passport-priority-ddp-zone-PL': 255.89,
                      'passport-priority-ddp-zone-PT': 255.89,
                      'passport-priority-ddp-zone-RO': 255.89,
                      'passport-priority-ddp-zone-SK': 255.89,
                      'passport-priority-ddp-zone-SI': 255.89,
                      'passport-priority-ddp-zone-SE': 255.89,
                      'passport-priority-ddp-zone-IL': 381.92,
                      'passport-priority-ddp-zone-OM': 394.61,
                      'passport-priority-ddp-zone-QA': 381.26,
                      'passport-priority-ddp-zone-SA': 381.29,
                      'passport-priority-ddp-zone-AE': 381.83,
                      'passport-priority-ddp-zone-CN': 532.23,
                      'passport-priority-ddp-zone-HK': 346.43,
                      'passport-priority-ddp-zone-IN': 408.79,
                      'passport-priority-ddp-zone-JP': 478.92,
                      'passport-priority-ddp-zone-KR': 398.02,
                      'passport-priority-ddp-zone-NZ': 346.04,
                      'passport-priority-ddp-zone-SG': 346.43,
                      'passport-priority-ddp-zone-TH': 348.66,
                      'passport-priority-ddp-zone-GG': 465.5,
                      'passport-priority-ddp-zone-JE': 465.5,
                      'passport-priority-ddp-zone-NO': 342.22,
                      'passport-priority-ddp-zone-CH': 342.88,
                      'passport-priority-ddp-zone-IS': 298.79,
                      'passport-priority-ddp-zone-AI': 376.78,
                      'passport-priority-ddp-zone-AG': 376.78,
                      'passport-priority-ddp-zone-AR': 455.79,
                      'passport-priority-ddp-zone-AW': 376.78,
                      'passport-priority-ddp-zone-BS': 376.78,
                      'passport-priority-ddp-zone-BB': 405.65,
                      'passport-priority-ddp-zone-BZ': 449.4,
                      'passport-priority-ddp-zone-BM': 377.58,
                      'passport-priority-ddp-zone-BO': 459.62,
                      'passport-priority-ddp-zone-BR': 343.3,
                      'passport-priority-ddp-zone-KY': 376.78,
                      'passport-priority-ddp-zone-CL': 388.96,
                      'passport-priority-ddp-zone-CO': 343.3,
                      'passport-priority-ddp-zone-CR': 456.76,
                      'passport-priority-ddp-zone-DM': 376.78,
                      'passport-priority-ddp-zone-DO': 378.08,
                      'passport-priority-ddp-zone-EC': 457.25,
                      'passport-priority-ddp-zone-SV': 449.4,
                      'passport-priority-ddp-zone-GP': 441.37,
                      'passport-priority-ddp-zone-GT': 449.5,
                      'passport-priority-ddp-zone-GY': 449.4,
                      'passport-priority-ddp-zone-HT': 376.78,
                      'passport-priority-ddp-zone-JM': 415.79,
                      'passport-priority-ddp-zone-MQ': 398.31,
                      'passport-priority-ddp-zone-AN': 376.78,
                      'passport-priority-ddp-zone-NI': 455.44,
                      'passport-priority-ddp-zone-PA': 449.94,
                      'passport-priority-ddp-zone-PY': 449.4,
                      'passport-priority-ddp-zone-PE': 453.67,
                      'passport-priority-ddp-zone-SR': 449.4,
                      'passport-priority-ddp-zone-TT': 387.77,
                      'passport-priority-ddp-zone-UY': 449.4,
                      'passport-priority-ddp-zone-AF': 636.03,
                      'passport-priority-ddp-zone-DZ': 636.03,
                      'passport-priority-ddp-zone-BH': 618.08,
                      'passport-priority-ddp-zone-BD': 561.8,
                      'passport-priority-ddp-zone-BT': 561.8,
                      'passport-priority-ddp-zone-BA': 636.03,
                      'passport-priority-ddp-zone-BW': 636.03,
                      'passport-priority-ddp-zone-BN': 618.08,
                      'passport-priority-ddp-zone-BF': 636.03,
                      'passport-priority-ddp-zone-BI': 636.03,
                      'passport-priority-ddp-zone-KH': 636.03,
                      'passport-priority-ddp-zone-CM': 636.03,
                      'passport-priority-ddp-zone-CV': 636.03,
                      'passport-priority-ddp-zone-TD': 636.03,
                      'passport-priority-ddp-zone-CG': 636.03,
                      'passport-priority-ddp-zone-CI': 636.03,
                      'passport-priority-ddp-zone-EG': 618.08,
                      'passport-priority-ddp-zone-ET': 636.03,
                      'passport-priority-ddp-zone-GA': 636.03,
                      'passport-priority-ddp-zone-GM': 636.03,
                      'passport-priority-ddp-zone-GH': 636.03,
                      'passport-priority-ddp-zone-GN': 636.03,
                      'passport-priority-ddp-zone-ID': 562.4,
                      'passport-priority-ddp-zone-JO': 618.08,
                      'passport-priority-ddp-zone-KE': 636.03,
                      'passport-priority-ddp-zone-KW': 619.16,
                      'passport-priority-ddp-zone-LB': 618.08,
                      'passport-priority-ddp-zone-LI': 617.87,
                      'passport-priority-ddp-zone-MO': 563.09,
                      'passport-priority-ddp-zone-MG': 636.03,
                      'passport-priority-ddp-zone-MW': 636.03,
                      'passport-priority-ddp-zone-MY': 542.9,
                      'passport-priority-ddp-zone-MV': 561.8,
                      'passport-priority-ddp-zone-ML': 636.03,
                      'passport-priority-ddp-zone-MR': 636.03,
                      'passport-priority-ddp-zone-MU': 636.03,
                      'passport-priority-ddp-zone-MD': 636.03,
                      'passport-priority-ddp-zone-MA': 636.81,
                      'passport-priority-ddp-zone-MZ': 636.03,
                      'passport-priority-ddp-zone-NA': 636.03,
                      'passport-priority-ddp-zone-NP': 561.8,
                      'passport-priority-ddp-zone-NE': 636.03,
                      'passport-priority-ddp-zone-NG': 636.03,
                      'passport-priority-ddp-zone-PK': 561.8,
                      'passport-priority-ddp-zone-PH': 543.79,
                      'passport-priority-ddp-zone-RE': 636.03,
                      'passport-priority-ddp-zone-RW': 636.03,
                      'passport-priority-ddp-zone-SN': 636.03,
                      'passport-priority-ddp-zone-SC': 636.03,
                      'passport-priority-ddp-zone-ZA': 596.22,
                      'passport-priority-ddp-zone-LK': 561.8,
                      'passport-priority-ddp-zone-SZ': 636.03,
                      'passport-priority-ddp-zone-TW': 543.79,
                      'passport-priority-ddp-zone-TJ': 636.03,
                      'passport-priority-ddp-zone-TZ': 636.03,
                      'passport-priority-ddp-zone-TG': 636.03,
                      'passport-priority-ddp-zone-TN': 636.03,
                      'passport-priority-ddp-zone-TR': 618.11,
                      'passport-priority-ddp-zone-TM': 636.03,
                      'passport-priority-ddp-zone-UG': 636.03,
                      'passport-priority-ddp-zone-UA': 636.03,
                      'passport-priority-ddp-zone-VN': 543.53,
                      'passport-priority-ddp-zone-YE': 618.08,
                      'passport-priority-ddp-zone-ZM': 636.03,
                      'passport-priority-ddp-zone-ZW': 636.03,
                      'passport-priority-ddp-zone-MC': 250.13,
                      'passport-priority-ddp-zone-IM': 244.25,
                      'passport-priority-ddp-zone-SM': 250.13,
                    },
                    '55': {
                      'passport-priority-ddp-zone-CA': 125.23,
                      'passport-priority-ddp-zone-GB': 243.88,
                      'passport-priority-ddp-zone-AU': 348.81,
                      'passport-priority-ddp-zone-BE': 254.76,
                      'passport-priority-ddp-zone-DK': 254.76,
                      'passport-priority-ddp-zone-FR': 254.76,
                      'passport-priority-ddp-zone-DE': 254.76,
                      'passport-priority-ddp-zone-IT': 254.76,
                      'passport-priority-ddp-zone-NL': 254.76,
                      'passport-priority-ddp-zone-ES': 254.76,
                      'passport-priority-ddp-zone-MX': 319.0,
                      'passport-priority-ddp-zone-AM': 474.22,
                      'passport-priority-ddp-zone-AT': 260.63,
                      'passport-priority-ddp-zone-BG': 260.63,
                      'passport-priority-ddp-zone-HR': 260.63,
                      'passport-priority-ddp-zone-CY': 284.89,
                      'passport-priority-ddp-zone-CZ': 260.63,
                      'passport-priority-ddp-zone-EE': 260.63,
                      'passport-priority-ddp-zone-FI': 260.63,
                      'passport-priority-ddp-zone-GR': 281.66,
                      'passport-priority-ddp-zone-HU': 260.63,
                      'passport-priority-ddp-zone-IE': 260.63,
                      'passport-priority-ddp-zone-LV': 260.63,
                      'passport-priority-ddp-zone-LT': 260.63,
                      'passport-priority-ddp-zone-LU': 260.63,
                      'passport-priority-ddp-zone-MT': 284.89,
                      'passport-priority-ddp-zone-PL': 260.63,
                      'passport-priority-ddp-zone-PT': 260.63,
                      'passport-priority-ddp-zone-RO': 260.63,
                      'passport-priority-ddp-zone-SK': 260.63,
                      'passport-priority-ddp-zone-SI': 260.63,
                      'passport-priority-ddp-zone-SE': 260.63,
                      'passport-priority-ddp-zone-IL': 388.99,
                      'passport-priority-ddp-zone-OM': 401.92,
                      'passport-priority-ddp-zone-QA': 388.32,
                      'passport-priority-ddp-zone-SA': 388.35,
                      'passport-priority-ddp-zone-AE': 388.9,
                      'passport-priority-ddp-zone-CN': 542.09,
                      'passport-priority-ddp-zone-HK': 352.85,
                      'passport-priority-ddp-zone-IN': 416.36,
                      'passport-priority-ddp-zone-JP': 487.79,
                      'passport-priority-ddp-zone-KR': 405.39,
                      'passport-priority-ddp-zone-NZ': 352.45,
                      'passport-priority-ddp-zone-SG': 352.85,
                      'passport-priority-ddp-zone-TH': 355.12,
                      'passport-priority-ddp-zone-GG': 474.12,
                      'passport-priority-ddp-zone-JE': 474.12,
                      'passport-priority-ddp-zone-NO': 348.55,
                      'passport-priority-ddp-zone-CH': 349.22,
                      'passport-priority-ddp-zone-IS': 304.32,
                      'passport-priority-ddp-zone-AI': 383.76,
                      'passport-priority-ddp-zone-AG': 383.76,
                      'passport-priority-ddp-zone-AR': 464.23,
                      'passport-priority-ddp-zone-AW': 383.76,
                      'passport-priority-ddp-zone-BS': 383.76,
                      'passport-priority-ddp-zone-BB': 413.17,
                      'passport-priority-ddp-zone-BZ': 457.72,
                      'passport-priority-ddp-zone-BM': 384.58,
                      'passport-priority-ddp-zone-BO': 468.13,
                      'passport-priority-ddp-zone-BR': 349.66,
                      'passport-priority-ddp-zone-KY': 383.76,
                      'passport-priority-ddp-zone-CL': 396.16,
                      'passport-priority-ddp-zone-CO': 349.66,
                      'passport-priority-ddp-zone-CR': 465.22,
                      'passport-priority-ddp-zone-DM': 383.76,
                      'passport-priority-ddp-zone-DO': 385.08,
                      'passport-priority-ddp-zone-EC': 465.72,
                      'passport-priority-ddp-zone-SV': 457.72,
                      'passport-priority-ddp-zone-GP': 449.55,
                      'passport-priority-ddp-zone-GT': 457.82,
                      'passport-priority-ddp-zone-GY': 457.72,
                      'passport-priority-ddp-zone-HT': 383.76,
                      'passport-priority-ddp-zone-JM': 423.5,
                      'passport-priority-ddp-zone-MQ': 405.69,
                      'passport-priority-ddp-zone-AN': 383.76,
                      'passport-priority-ddp-zone-NI': 463.87,
                      'passport-priority-ddp-zone-PA': 458.27,
                      'passport-priority-ddp-zone-PY': 457.72,
                      'passport-priority-ddp-zone-PE': 462.07,
                      'passport-priority-ddp-zone-SR': 457.72,
                      'passport-priority-ddp-zone-TT': 394.96,
                      'passport-priority-ddp-zone-UY': 457.72,
                      'passport-priority-ddp-zone-AF': 647.81,
                      'passport-priority-ddp-zone-DZ': 647.81,
                      'passport-priority-ddp-zone-BH': 629.52,
                      'passport-priority-ddp-zone-BD': 572.21,
                      'passport-priority-ddp-zone-BT': 572.21,
                      'passport-priority-ddp-zone-BA': 647.81,
                      'passport-priority-ddp-zone-BW': 647.81,
                      'passport-priority-ddp-zone-BN': 629.52,
                      'passport-priority-ddp-zone-BF': 647.81,
                      'passport-priority-ddp-zone-BI': 647.81,
                      'passport-priority-ddp-zone-KH': 647.81,
                      'passport-priority-ddp-zone-CM': 647.81,
                      'passport-priority-ddp-zone-CV': 647.81,
                      'passport-priority-ddp-zone-TD': 647.81,
                      'passport-priority-ddp-zone-CG': 647.81,
                      'passport-priority-ddp-zone-CI': 647.81,
                      'passport-priority-ddp-zone-EG': 629.52,
                      'passport-priority-ddp-zone-ET': 647.81,
                      'passport-priority-ddp-zone-GA': 647.81,
                      'passport-priority-ddp-zone-GM': 647.81,
                      'passport-priority-ddp-zone-GH': 647.81,
                      'passport-priority-ddp-zone-GN': 647.81,
                      'passport-priority-ddp-zone-ID': 572.75,
                      'passport-priority-ddp-zone-JO': 629.52,
                      'passport-priority-ddp-zone-KE': 647.81,
                      'passport-priority-ddp-zone-KW': 630.63,
                      'passport-priority-ddp-zone-LB': 629.52,
                      'passport-priority-ddp-zone-LI': 629.3,
                      'passport-priority-ddp-zone-MO': 573.52,
                      'passport-priority-ddp-zone-MG': 647.81,
                      'passport-priority-ddp-zone-MW': 647.81,
                      'passport-priority-ddp-zone-MY': 552.95,
                      'passport-priority-ddp-zone-MV': 572.21,
                      'passport-priority-ddp-zone-ML': 647.81,
                      'passport-priority-ddp-zone-MR': 647.81,
                      'passport-priority-ddp-zone-MU': 647.81,
                      'passport-priority-ddp-zone-MD': 647.81,
                      'passport-priority-ddp-zone-MA': 648.61,
                      'passport-priority-ddp-zone-MZ': 647.81,
                      'passport-priority-ddp-zone-NA': 647.81,
                      'passport-priority-ddp-zone-NP': 572.21,
                      'passport-priority-ddp-zone-NE': 647.81,
                      'passport-priority-ddp-zone-NG': 647.81,
                      'passport-priority-ddp-zone-PK': 572.21,
                      'passport-priority-ddp-zone-PH': 553.87,
                      'passport-priority-ddp-zone-RE': 647.81,
                      'passport-priority-ddp-zone-RW': 647.81,
                      'passport-priority-ddp-zone-SN': 647.81,
                      'passport-priority-ddp-zone-SC': 647.81,
                      'passport-priority-ddp-zone-ZA': 607.26,
                      'passport-priority-ddp-zone-LK': 572.21,
                      'passport-priority-ddp-zone-SZ': 647.81,
                      'passport-priority-ddp-zone-TW': 553.87,
                      'passport-priority-ddp-zone-TJ': 647.81,
                      'passport-priority-ddp-zone-TZ': 647.81,
                      'passport-priority-ddp-zone-TG': 647.81,
                      'passport-priority-ddp-zone-TN': 647.81,
                      'passport-priority-ddp-zone-TR': 629.55,
                      'passport-priority-ddp-zone-TM': 647.81,
                      'passport-priority-ddp-zone-UG': 647.81,
                      'passport-priority-ddp-zone-UA': 647.81,
                      'passport-priority-ddp-zone-VN': 553.59,
                      'passport-priority-ddp-zone-YE': 629.52,
                      'passport-priority-ddp-zone-ZM': 647.81,
                      'passport-priority-ddp-zone-ZW': 647.81,
                      'passport-priority-ddp-zone-MC': 254.76,
                      'passport-priority-ddp-zone-IM': 248.88,
                      'passport-priority-ddp-zone-SM': 254.76,
                    },
                    '56': {
                      'passport-priority-ddp-zone-CA': 127.51,
                      'passport-priority-ddp-zone-GB': 248.31,
                      'passport-priority-ddp-zone-AU': 355.15,
                      'passport-priority-ddp-zone-BE': 259.39,
                      'passport-priority-ddp-zone-DK': 259.39,
                      'passport-priority-ddp-zone-FR': 259.39,
                      'passport-priority-ddp-zone-DE': 259.39,
                      'passport-priority-ddp-zone-IT': 259.39,
                      'passport-priority-ddp-zone-NL': 259.39,
                      'passport-priority-ddp-zone-ES': 259.39,
                      'passport-priority-ddp-zone-MX': 324.8,
                      'passport-priority-ddp-zone-AM': 482.84,
                      'passport-priority-ddp-zone-AT': 265.37,
                      'passport-priority-ddp-zone-BG': 265.37,
                      'passport-priority-ddp-zone-HR': 265.37,
                      'passport-priority-ddp-zone-CY': 290.07,
                      'passport-priority-ddp-zone-CZ': 265.37,
                      'passport-priority-ddp-zone-EE': 265.37,
                      'passport-priority-ddp-zone-FI': 265.37,
                      'passport-priority-ddp-zone-GR': 286.78,
                      'passport-priority-ddp-zone-HU': 265.37,
                      'passport-priority-ddp-zone-IE': 265.37,
                      'passport-priority-ddp-zone-LV': 265.37,
                      'passport-priority-ddp-zone-LT': 265.37,
                      'passport-priority-ddp-zone-LU': 265.37,
                      'passport-priority-ddp-zone-MT': 290.07,
                      'passport-priority-ddp-zone-PL': 265.37,
                      'passport-priority-ddp-zone-PT': 265.37,
                      'passport-priority-ddp-zone-RO': 265.37,
                      'passport-priority-ddp-zone-SK': 265.37,
                      'passport-priority-ddp-zone-SI': 265.37,
                      'passport-priority-ddp-zone-SE': 265.37,
                      'passport-priority-ddp-zone-IL': 396.06,
                      'passport-priority-ddp-zone-OM': 409.23,
                      'passport-priority-ddp-zone-QA': 395.38,
                      'passport-priority-ddp-zone-SA': 395.41,
                      'passport-priority-ddp-zone-AE': 395.97,
                      'passport-priority-ddp-zone-CN': 551.95,
                      'passport-priority-ddp-zone-HK': 359.27,
                      'passport-priority-ddp-zone-IN': 423.93,
                      'passport-priority-ddp-zone-JP': 496.66,
                      'passport-priority-ddp-zone-KR': 412.76,
                      'passport-priority-ddp-zone-NZ': 358.86,
                      'passport-priority-ddp-zone-SG': 359.27,
                      'passport-priority-ddp-zone-TH': 361.58,
                      'passport-priority-ddp-zone-GG': 482.74,
                      'passport-priority-ddp-zone-JE': 482.74,
                      'passport-priority-ddp-zone-NO': 354.88,
                      'passport-priority-ddp-zone-CH': 355.56,
                      'passport-priority-ddp-zone-IS': 309.85,
                      'passport-priority-ddp-zone-AI': 390.74,
                      'passport-priority-ddp-zone-AG': 390.74,
                      'passport-priority-ddp-zone-AR': 472.67,
                      'passport-priority-ddp-zone-AW': 390.74,
                      'passport-priority-ddp-zone-BS': 390.74,
                      'passport-priority-ddp-zone-BB': 420.69,
                      'passport-priority-ddp-zone-BZ': 466.04,
                      'passport-priority-ddp-zone-BM': 391.58,
                      'passport-priority-ddp-zone-BO': 476.64,
                      'passport-priority-ddp-zone-BR': 356.02,
                      'passport-priority-ddp-zone-KY': 390.74,
                      'passport-priority-ddp-zone-CL': 403.36,
                      'passport-priority-ddp-zone-CO': 356.02,
                      'passport-priority-ddp-zone-CR': 473.68,
                      'passport-priority-ddp-zone-DM': 390.74,
                      'passport-priority-ddp-zone-DO': 392.08,
                      'passport-priority-ddp-zone-EC': 474.19,
                      'passport-priority-ddp-zone-SV': 466.04,
                      'passport-priority-ddp-zone-GP': 457.73,
                      'passport-priority-ddp-zone-GT': 466.14,
                      'passport-priority-ddp-zone-GY': 466.04,
                      'passport-priority-ddp-zone-HT': 390.74,
                      'passport-priority-ddp-zone-JM': 431.21,
                      'passport-priority-ddp-zone-MQ': 413.07,
                      'passport-priority-ddp-zone-AN': 390.74,
                      'passport-priority-ddp-zone-NI': 472.3,
                      'passport-priority-ddp-zone-PA': 466.6,
                      'passport-priority-ddp-zone-PY': 466.04,
                      'passport-priority-ddp-zone-PE': 470.47,
                      'passport-priority-ddp-zone-SR': 466.04,
                      'passport-priority-ddp-zone-TT': 402.15,
                      'passport-priority-ddp-zone-UY': 466.04,
                      'passport-priority-ddp-zone-AF': 659.59,
                      'passport-priority-ddp-zone-DZ': 659.59,
                      'passport-priority-ddp-zone-BH': 640.96,
                      'passport-priority-ddp-zone-BD': 582.62,
                      'passport-priority-ddp-zone-BT': 582.62,
                      'passport-priority-ddp-zone-BA': 659.59,
                      'passport-priority-ddp-zone-BW': 659.59,
                      'passport-priority-ddp-zone-BN': 640.96,
                      'passport-priority-ddp-zone-BF': 659.59,
                      'passport-priority-ddp-zone-BI': 659.59,
                      'passport-priority-ddp-zone-KH': 659.59,
                      'passport-priority-ddp-zone-CM': 659.59,
                      'passport-priority-ddp-zone-CV': 659.59,
                      'passport-priority-ddp-zone-TD': 659.59,
                      'passport-priority-ddp-zone-CG': 659.59,
                      'passport-priority-ddp-zone-CI': 659.59,
                      'passport-priority-ddp-zone-EG': 640.96,
                      'passport-priority-ddp-zone-ET': 659.59,
                      'passport-priority-ddp-zone-GA': 659.59,
                      'passport-priority-ddp-zone-GM': 659.59,
                      'passport-priority-ddp-zone-GH': 659.59,
                      'passport-priority-ddp-zone-GN': 659.59,
                      'passport-priority-ddp-zone-ID': 583.1,
                      'passport-priority-ddp-zone-JO': 640.96,
                      'passport-priority-ddp-zone-KE': 659.59,
                      'passport-priority-ddp-zone-KW': 642.1,
                      'passport-priority-ddp-zone-LB': 640.96,
                      'passport-priority-ddp-zone-LI': 640.73,
                      'passport-priority-ddp-zone-MO': 583.95,
                      'passport-priority-ddp-zone-MG': 659.59,
                      'passport-priority-ddp-zone-MW': 659.59,
                      'passport-priority-ddp-zone-MY': 563.0,
                      'passport-priority-ddp-zone-MV': 582.62,
                      'passport-priority-ddp-zone-ML': 659.59,
                      'passport-priority-ddp-zone-MR': 659.59,
                      'passport-priority-ddp-zone-MU': 659.59,
                      'passport-priority-ddp-zone-MD': 659.59,
                      'passport-priority-ddp-zone-MA': 660.41,
                      'passport-priority-ddp-zone-MZ': 659.59,
                      'passport-priority-ddp-zone-NA': 659.59,
                      'passport-priority-ddp-zone-NP': 582.62,
                      'passport-priority-ddp-zone-NE': 659.59,
                      'passport-priority-ddp-zone-NG': 659.59,
                      'passport-priority-ddp-zone-PK': 582.62,
                      'passport-priority-ddp-zone-PH': 563.95,
                      'passport-priority-ddp-zone-RE': 659.59,
                      'passport-priority-ddp-zone-RW': 659.59,
                      'passport-priority-ddp-zone-SN': 659.59,
                      'passport-priority-ddp-zone-SC': 659.59,
                      'passport-priority-ddp-zone-ZA': 618.3,
                      'passport-priority-ddp-zone-LK': 582.62,
                      'passport-priority-ddp-zone-SZ': 659.59,
                      'passport-priority-ddp-zone-TW': 563.95,
                      'passport-priority-ddp-zone-TJ': 659.59,
                      'passport-priority-ddp-zone-TZ': 659.59,
                      'passport-priority-ddp-zone-TG': 659.59,
                      'passport-priority-ddp-zone-TN': 659.59,
                      'passport-priority-ddp-zone-TR': 640.99,
                      'passport-priority-ddp-zone-TM': 659.59,
                      'passport-priority-ddp-zone-UG': 659.59,
                      'passport-priority-ddp-zone-UA': 659.59,
                      'passport-priority-ddp-zone-VN': 563.65,
                      'passport-priority-ddp-zone-YE': 640.96,
                      'passport-priority-ddp-zone-ZM': 659.59,
                      'passport-priority-ddp-zone-ZW': 659.59,
                      'passport-priority-ddp-zone-MC': 259.39,
                      'passport-priority-ddp-zone-IM': 253.51,
                      'passport-priority-ddp-zone-SM': 259.39,
                    },
                    '57': {
                      'passport-priority-ddp-zone-CA': 129.79,
                      'passport-priority-ddp-zone-GB': 252.74,
                      'passport-priority-ddp-zone-AU': 361.49,
                      'passport-priority-ddp-zone-BE': 264.02,
                      'passport-priority-ddp-zone-DK': 264.02,
                      'passport-priority-ddp-zone-FR': 264.02,
                      'passport-priority-ddp-zone-DE': 264.02,
                      'passport-priority-ddp-zone-IT': 264.02,
                      'passport-priority-ddp-zone-NL': 264.02,
                      'passport-priority-ddp-zone-ES': 264.02,
                      'passport-priority-ddp-zone-MX': 330.6,
                      'passport-priority-ddp-zone-AM': 491.46,
                      'passport-priority-ddp-zone-AT': 270.11,
                      'passport-priority-ddp-zone-BG': 270.11,
                      'passport-priority-ddp-zone-HR': 270.11,
                      'passport-priority-ddp-zone-CY': 295.25,
                      'passport-priority-ddp-zone-CZ': 270.11,
                      'passport-priority-ddp-zone-EE': 270.11,
                      'passport-priority-ddp-zone-FI': 270.11,
                      'passport-priority-ddp-zone-GR': 291.9,
                      'passport-priority-ddp-zone-HU': 270.11,
                      'passport-priority-ddp-zone-IE': 270.11,
                      'passport-priority-ddp-zone-LV': 270.11,
                      'passport-priority-ddp-zone-LT': 270.11,
                      'passport-priority-ddp-zone-LU': 270.11,
                      'passport-priority-ddp-zone-MT': 295.25,
                      'passport-priority-ddp-zone-PL': 270.11,
                      'passport-priority-ddp-zone-PT': 270.11,
                      'passport-priority-ddp-zone-RO': 270.11,
                      'passport-priority-ddp-zone-SK': 270.11,
                      'passport-priority-ddp-zone-SI': 270.11,
                      'passport-priority-ddp-zone-SE': 270.11,
                      'passport-priority-ddp-zone-IL': 403.13,
                      'passport-priority-ddp-zone-OM': 416.54,
                      'passport-priority-ddp-zone-QA': 402.44,
                      'passport-priority-ddp-zone-SA': 402.47,
                      'passport-priority-ddp-zone-AE': 403.04,
                      'passport-priority-ddp-zone-CN': 561.81,
                      'passport-priority-ddp-zone-HK': 365.69,
                      'passport-priority-ddp-zone-IN': 431.5,
                      'passport-priority-ddp-zone-JP': 505.53,
                      'passport-priority-ddp-zone-KR': 420.13,
                      'passport-priority-ddp-zone-NZ': 365.27,
                      'passport-priority-ddp-zone-SG': 365.69,
                      'passport-priority-ddp-zone-TH': 368.04,
                      'passport-priority-ddp-zone-GG': 491.36,
                      'passport-priority-ddp-zone-JE': 491.36,
                      'passport-priority-ddp-zone-NO': 361.21,
                      'passport-priority-ddp-zone-CH': 361.9,
                      'passport-priority-ddp-zone-IS': 315.38,
                      'passport-priority-ddp-zone-AI': 397.72,
                      'passport-priority-ddp-zone-AG': 397.72,
                      'passport-priority-ddp-zone-AR': 481.11,
                      'passport-priority-ddp-zone-AW': 397.72,
                      'passport-priority-ddp-zone-BS': 397.72,
                      'passport-priority-ddp-zone-BB': 428.21,
                      'passport-priority-ddp-zone-BZ': 474.36,
                      'passport-priority-ddp-zone-BM': 398.58,
                      'passport-priority-ddp-zone-BO': 485.15,
                      'passport-priority-ddp-zone-BR': 362.38,
                      'passport-priority-ddp-zone-KY': 397.72,
                      'passport-priority-ddp-zone-CL': 410.56,
                      'passport-priority-ddp-zone-CO': 362.38,
                      'passport-priority-ddp-zone-CR': 482.14,
                      'passport-priority-ddp-zone-DM': 397.72,
                      'passport-priority-ddp-zone-DO': 399.08,
                      'passport-priority-ddp-zone-EC': 482.66,
                      'passport-priority-ddp-zone-SV': 474.36,
                      'passport-priority-ddp-zone-GP': 465.91,
                      'passport-priority-ddp-zone-GT': 474.46,
                      'passport-priority-ddp-zone-GY': 474.36,
                      'passport-priority-ddp-zone-HT': 397.72,
                      'passport-priority-ddp-zone-JM': 438.92,
                      'passport-priority-ddp-zone-MQ': 420.45,
                      'passport-priority-ddp-zone-AN': 397.72,
                      'passport-priority-ddp-zone-NI': 480.73,
                      'passport-priority-ddp-zone-PA': 474.93,
                      'passport-priority-ddp-zone-PY': 474.36,
                      'passport-priority-ddp-zone-PE': 478.87,
                      'passport-priority-ddp-zone-SR': 474.36,
                      'passport-priority-ddp-zone-TT': 409.34,
                      'passport-priority-ddp-zone-UY': 474.36,
                      'passport-priority-ddp-zone-AF': 671.37,
                      'passport-priority-ddp-zone-DZ': 671.37,
                      'passport-priority-ddp-zone-BH': 652.4,
                      'passport-priority-ddp-zone-BD': 593.03,
                      'passport-priority-ddp-zone-BT': 593.03,
                      'passport-priority-ddp-zone-BA': 671.37,
                      'passport-priority-ddp-zone-BW': 671.37,
                      'passport-priority-ddp-zone-BN': 652.4,
                      'passport-priority-ddp-zone-BF': 671.37,
                      'passport-priority-ddp-zone-BI': 671.37,
                      'passport-priority-ddp-zone-KH': 671.37,
                      'passport-priority-ddp-zone-CM': 671.37,
                      'passport-priority-ddp-zone-CV': 671.37,
                      'passport-priority-ddp-zone-TD': 671.37,
                      'passport-priority-ddp-zone-CG': 671.37,
                      'passport-priority-ddp-zone-CI': 671.37,
                      'passport-priority-ddp-zone-EG': 652.4,
                      'passport-priority-ddp-zone-ET': 671.37,
                      'passport-priority-ddp-zone-GA': 671.37,
                      'passport-priority-ddp-zone-GM': 671.37,
                      'passport-priority-ddp-zone-GH': 671.37,
                      'passport-priority-ddp-zone-GN': 671.37,
                      'passport-priority-ddp-zone-ID': 593.45,
                      'passport-priority-ddp-zone-JO': 652.4,
                      'passport-priority-ddp-zone-KE': 671.37,
                      'passport-priority-ddp-zone-KW': 653.57,
                      'passport-priority-ddp-zone-LB': 652.4,
                      'passport-priority-ddp-zone-LI': 652.16,
                      'passport-priority-ddp-zone-MO': 594.38,
                      'passport-priority-ddp-zone-MG': 671.37,
                      'passport-priority-ddp-zone-MW': 671.37,
                      'passport-priority-ddp-zone-MY': 573.05,
                      'passport-priority-ddp-zone-MV': 593.03,
                      'passport-priority-ddp-zone-ML': 671.37,
                      'passport-priority-ddp-zone-MR': 671.37,
                      'passport-priority-ddp-zone-MU': 671.37,
                      'passport-priority-ddp-zone-MD': 671.37,
                      'passport-priority-ddp-zone-MA': 672.21,
                      'passport-priority-ddp-zone-MZ': 671.37,
                      'passport-priority-ddp-zone-NA': 671.37,
                      'passport-priority-ddp-zone-NP': 593.03,
                      'passport-priority-ddp-zone-NE': 671.37,
                      'passport-priority-ddp-zone-NG': 671.37,
                      'passport-priority-ddp-zone-PK': 593.03,
                      'passport-priority-ddp-zone-PH': 574.03,
                      'passport-priority-ddp-zone-RE': 671.37,
                      'passport-priority-ddp-zone-RW': 671.37,
                      'passport-priority-ddp-zone-SN': 671.37,
                      'passport-priority-ddp-zone-SC': 671.37,
                      'passport-priority-ddp-zone-ZA': 629.34,
                      'passport-priority-ddp-zone-LK': 593.03,
                      'passport-priority-ddp-zone-SZ': 671.37,
                      'passport-priority-ddp-zone-TW': 574.03,
                      'passport-priority-ddp-zone-TJ': 671.37,
                      'passport-priority-ddp-zone-TZ': 671.37,
                      'passport-priority-ddp-zone-TG': 671.37,
                      'passport-priority-ddp-zone-TN': 671.37,
                      'passport-priority-ddp-zone-TR': 652.43,
                      'passport-priority-ddp-zone-TM': 671.37,
                      'passport-priority-ddp-zone-UG': 671.37,
                      'passport-priority-ddp-zone-UA': 671.37,
                      'passport-priority-ddp-zone-VN': 573.71,
                      'passport-priority-ddp-zone-YE': 652.4,
                      'passport-priority-ddp-zone-ZM': 671.37,
                      'passport-priority-ddp-zone-ZW': 671.37,
                      'passport-priority-ddp-zone-MC': 264.02,
                      'passport-priority-ddp-zone-IM': 258.14,
                      'passport-priority-ddp-zone-SM': 264.02,
                    },
                    '58': {
                      'passport-priority-ddp-zone-CA': 132.07,
                      'passport-priority-ddp-zone-GB': 257.17,
                      'passport-priority-ddp-zone-AU': 367.83,
                      'passport-priority-ddp-zone-BE': 268.65,
                      'passport-priority-ddp-zone-DK': 268.65,
                      'passport-priority-ddp-zone-FR': 268.65,
                      'passport-priority-ddp-zone-DE': 268.65,
                      'passport-priority-ddp-zone-IT': 268.65,
                      'passport-priority-ddp-zone-NL': 268.65,
                      'passport-priority-ddp-zone-ES': 268.65,
                      'passport-priority-ddp-zone-MX': 336.4,
                      'passport-priority-ddp-zone-AM': 500.08,
                      'passport-priority-ddp-zone-AT': 274.85,
                      'passport-priority-ddp-zone-BG': 274.85,
                      'passport-priority-ddp-zone-HR': 274.85,
                      'passport-priority-ddp-zone-CY': 300.43,
                      'passport-priority-ddp-zone-CZ': 274.85,
                      'passport-priority-ddp-zone-EE': 274.85,
                      'passport-priority-ddp-zone-FI': 274.85,
                      'passport-priority-ddp-zone-GR': 297.02,
                      'passport-priority-ddp-zone-HU': 274.85,
                      'passport-priority-ddp-zone-IE': 274.85,
                      'passport-priority-ddp-zone-LV': 274.85,
                      'passport-priority-ddp-zone-LT': 274.85,
                      'passport-priority-ddp-zone-LU': 274.85,
                      'passport-priority-ddp-zone-MT': 300.43,
                      'passport-priority-ddp-zone-PL': 274.85,
                      'passport-priority-ddp-zone-PT': 274.85,
                      'passport-priority-ddp-zone-RO': 274.85,
                      'passport-priority-ddp-zone-SK': 274.85,
                      'passport-priority-ddp-zone-SI': 274.85,
                      'passport-priority-ddp-zone-SE': 274.85,
                      'passport-priority-ddp-zone-IL': 410.2,
                      'passport-priority-ddp-zone-OM': 423.85,
                      'passport-priority-ddp-zone-QA': 409.5,
                      'passport-priority-ddp-zone-SA': 409.53,
                      'passport-priority-ddp-zone-AE': 410.11,
                      'passport-priority-ddp-zone-CN': 571.67,
                      'passport-priority-ddp-zone-HK': 372.11,
                      'passport-priority-ddp-zone-IN': 439.07,
                      'passport-priority-ddp-zone-JP': 514.4,
                      'passport-priority-ddp-zone-KR': 427.5,
                      'passport-priority-ddp-zone-NZ': 371.68,
                      'passport-priority-ddp-zone-SG': 372.11,
                      'passport-priority-ddp-zone-TH': 374.5,
                      'passport-priority-ddp-zone-GG': 499.98,
                      'passport-priority-ddp-zone-JE': 499.98,
                      'passport-priority-ddp-zone-NO': 367.54,
                      'passport-priority-ddp-zone-CH': 368.24,
                      'passport-priority-ddp-zone-IS': 320.91,
                      'passport-priority-ddp-zone-AI': 404.7,
                      'passport-priority-ddp-zone-AG': 404.7,
                      'passport-priority-ddp-zone-AR': 489.55,
                      'passport-priority-ddp-zone-AW': 404.7,
                      'passport-priority-ddp-zone-BS': 404.7,
                      'passport-priority-ddp-zone-BB': 435.73,
                      'passport-priority-ddp-zone-BZ': 482.68,
                      'passport-priority-ddp-zone-BM': 405.58,
                      'passport-priority-ddp-zone-BO': 493.66,
                      'passport-priority-ddp-zone-BR': 368.74,
                      'passport-priority-ddp-zone-KY': 404.7,
                      'passport-priority-ddp-zone-CL': 417.76,
                      'passport-priority-ddp-zone-CO': 368.74,
                      'passport-priority-ddp-zone-CR': 490.6,
                      'passport-priority-ddp-zone-DM': 404.7,
                      'passport-priority-ddp-zone-DO': 406.08,
                      'passport-priority-ddp-zone-EC': 491.13,
                      'passport-priority-ddp-zone-SV': 482.68,
                      'passport-priority-ddp-zone-GP': 474.09,
                      'passport-priority-ddp-zone-GT': 482.78,
                      'passport-priority-ddp-zone-GY': 482.68,
                      'passport-priority-ddp-zone-HT': 404.7,
                      'passport-priority-ddp-zone-JM': 446.63,
                      'passport-priority-ddp-zone-MQ': 427.83,
                      'passport-priority-ddp-zone-AN': 404.7,
                      'passport-priority-ddp-zone-NI': 489.16,
                      'passport-priority-ddp-zone-PA': 483.26,
                      'passport-priority-ddp-zone-PY': 482.68,
                      'passport-priority-ddp-zone-PE': 487.27,
                      'passport-priority-ddp-zone-SR': 482.68,
                      'passport-priority-ddp-zone-TT': 416.53,
                      'passport-priority-ddp-zone-UY': 482.68,
                      'passport-priority-ddp-zone-AF': 683.15,
                      'passport-priority-ddp-zone-DZ': 683.15,
                      'passport-priority-ddp-zone-BH': 663.84,
                      'passport-priority-ddp-zone-BD': 603.44,
                      'passport-priority-ddp-zone-BT': 603.44,
                      'passport-priority-ddp-zone-BA': 683.15,
                      'passport-priority-ddp-zone-BW': 683.15,
                      'passport-priority-ddp-zone-BN': 663.84,
                      'passport-priority-ddp-zone-BF': 683.15,
                      'passport-priority-ddp-zone-BI': 683.15,
                      'passport-priority-ddp-zone-KH': 683.15,
                      'passport-priority-ddp-zone-CM': 683.15,
                      'passport-priority-ddp-zone-CV': 683.15,
                      'passport-priority-ddp-zone-TD': 683.15,
                      'passport-priority-ddp-zone-CG': 683.15,
                      'passport-priority-ddp-zone-CI': 683.15,
                      'passport-priority-ddp-zone-EG': 663.84,
                      'passport-priority-ddp-zone-ET': 683.15,
                      'passport-priority-ddp-zone-GA': 683.15,
                      'passport-priority-ddp-zone-GM': 683.15,
                      'passport-priority-ddp-zone-GH': 683.15,
                      'passport-priority-ddp-zone-GN': 683.15,
                      'passport-priority-ddp-zone-ID': 603.8,
                      'passport-priority-ddp-zone-JO': 663.84,
                      'passport-priority-ddp-zone-KE': 683.15,
                      'passport-priority-ddp-zone-KW': 665.04,
                      'passport-priority-ddp-zone-LB': 663.84,
                      'passport-priority-ddp-zone-LI': 663.59,
                      'passport-priority-ddp-zone-MO': 604.81,
                      'passport-priority-ddp-zone-MG': 683.15,
                      'passport-priority-ddp-zone-MW': 683.15,
                      'passport-priority-ddp-zone-MY': 583.1,
                      'passport-priority-ddp-zone-MV': 603.44,
                      'passport-priority-ddp-zone-ML': 683.15,
                      'passport-priority-ddp-zone-MR': 683.15,
                      'passport-priority-ddp-zone-MU': 683.15,
                      'passport-priority-ddp-zone-MD': 683.15,
                      'passport-priority-ddp-zone-MA': 684.01,
                      'passport-priority-ddp-zone-MZ': 683.15,
                      'passport-priority-ddp-zone-NA': 683.15,
                      'passport-priority-ddp-zone-NP': 603.44,
                      'passport-priority-ddp-zone-NE': 683.15,
                      'passport-priority-ddp-zone-NG': 683.15,
                      'passport-priority-ddp-zone-PK': 603.44,
                      'passport-priority-ddp-zone-PH': 584.11,
                      'passport-priority-ddp-zone-RE': 683.15,
                      'passport-priority-ddp-zone-RW': 683.15,
                      'passport-priority-ddp-zone-SN': 683.15,
                      'passport-priority-ddp-zone-SC': 683.15,
                      'passport-priority-ddp-zone-ZA': 640.38,
                      'passport-priority-ddp-zone-LK': 603.44,
                      'passport-priority-ddp-zone-SZ': 683.15,
                      'passport-priority-ddp-zone-TW': 584.11,
                      'passport-priority-ddp-zone-TJ': 683.15,
                      'passport-priority-ddp-zone-TZ': 683.15,
                      'passport-priority-ddp-zone-TG': 683.15,
                      'passport-priority-ddp-zone-TN': 683.15,
                      'passport-priority-ddp-zone-TR': 663.87,
                      'passport-priority-ddp-zone-TM': 683.15,
                      'passport-priority-ddp-zone-UG': 683.15,
                      'passport-priority-ddp-zone-UA': 683.15,
                      'passport-priority-ddp-zone-VN': 583.77,
                      'passport-priority-ddp-zone-YE': 663.84,
                      'passport-priority-ddp-zone-ZM': 683.15,
                      'passport-priority-ddp-zone-ZW': 683.15,
                      'passport-priority-ddp-zone-MC': 268.65,
                      'passport-priority-ddp-zone-IM': 262.77,
                      'passport-priority-ddp-zone-SM': 268.65,
                    },
                    '59': {
                      'passport-priority-ddp-zone-CA': 134.35,
                      'passport-priority-ddp-zone-GB': 261.6,
                      'passport-priority-ddp-zone-AU': 374.17,
                      'passport-priority-ddp-zone-BE': 273.28,
                      'passport-priority-ddp-zone-DK': 273.28,
                      'passport-priority-ddp-zone-FR': 273.28,
                      'passport-priority-ddp-zone-DE': 273.28,
                      'passport-priority-ddp-zone-IT': 273.28,
                      'passport-priority-ddp-zone-NL': 273.28,
                      'passport-priority-ddp-zone-ES': 273.28,
                      'passport-priority-ddp-zone-MX': 342.2,
                      'passport-priority-ddp-zone-AM': 508.7,
                      'passport-priority-ddp-zone-AT': 279.59,
                      'passport-priority-ddp-zone-BG': 279.59,
                      'passport-priority-ddp-zone-HR': 279.59,
                      'passport-priority-ddp-zone-CY': 305.61,
                      'passport-priority-ddp-zone-CZ': 279.59,
                      'passport-priority-ddp-zone-EE': 279.59,
                      'passport-priority-ddp-zone-FI': 279.59,
                      'passport-priority-ddp-zone-GR': 302.14,
                      'passport-priority-ddp-zone-HU': 279.59,
                      'passport-priority-ddp-zone-IE': 279.59,
                      'passport-priority-ddp-zone-LV': 279.59,
                      'passport-priority-ddp-zone-LT': 279.59,
                      'passport-priority-ddp-zone-LU': 279.59,
                      'passport-priority-ddp-zone-MT': 305.61,
                      'passport-priority-ddp-zone-PL': 279.59,
                      'passport-priority-ddp-zone-PT': 279.59,
                      'passport-priority-ddp-zone-RO': 279.59,
                      'passport-priority-ddp-zone-SK': 279.59,
                      'passport-priority-ddp-zone-SI': 279.59,
                      'passport-priority-ddp-zone-SE': 279.59,
                      'passport-priority-ddp-zone-IL': 417.27,
                      'passport-priority-ddp-zone-OM': 431.16,
                      'passport-priority-ddp-zone-QA': 416.56,
                      'passport-priority-ddp-zone-SA': 416.59,
                      'passport-priority-ddp-zone-AE': 417.18,
                      'passport-priority-ddp-zone-CN': 581.53,
                      'passport-priority-ddp-zone-HK': 378.53,
                      'passport-priority-ddp-zone-IN': 446.64,
                      'passport-priority-ddp-zone-JP': 523.27,
                      'passport-priority-ddp-zone-KR': 434.87,
                      'passport-priority-ddp-zone-NZ': 378.09,
                      'passport-priority-ddp-zone-SG': 378.53,
                      'passport-priority-ddp-zone-TH': 380.96,
                      'passport-priority-ddp-zone-GG': 508.6,
                      'passport-priority-ddp-zone-JE': 508.6,
                      'passport-priority-ddp-zone-NO': 373.87,
                      'passport-priority-ddp-zone-CH': 374.58,
                      'passport-priority-ddp-zone-IS': 326.44,
                      'passport-priority-ddp-zone-AI': 411.68,
                      'passport-priority-ddp-zone-AG': 411.68,
                      'passport-priority-ddp-zone-AR': 497.99,
                      'passport-priority-ddp-zone-AW': 411.68,
                      'passport-priority-ddp-zone-BS': 411.68,
                      'passport-priority-ddp-zone-BB': 443.25,
                      'passport-priority-ddp-zone-BZ': 491.0,
                      'passport-priority-ddp-zone-BM': 412.58,
                      'passport-priority-ddp-zone-BO': 502.17,
                      'passport-priority-ddp-zone-BR': 375.1,
                      'passport-priority-ddp-zone-KY': 411.68,
                      'passport-priority-ddp-zone-CL': 424.96,
                      'passport-priority-ddp-zone-CO': 375.1,
                      'passport-priority-ddp-zone-CR': 499.06,
                      'passport-priority-ddp-zone-DM': 411.68,
                      'passport-priority-ddp-zone-DO': 413.08,
                      'passport-priority-ddp-zone-EC': 499.6,
                      'passport-priority-ddp-zone-SV': 491.0,
                      'passport-priority-ddp-zone-GP': 482.27,
                      'passport-priority-ddp-zone-GT': 491.1,
                      'passport-priority-ddp-zone-GY': 491.0,
                      'passport-priority-ddp-zone-HT': 411.68,
                      'passport-priority-ddp-zone-JM': 454.34,
                      'passport-priority-ddp-zone-MQ': 435.21,
                      'passport-priority-ddp-zone-AN': 411.68,
                      'passport-priority-ddp-zone-NI': 497.59,
                      'passport-priority-ddp-zone-PA': 491.59,
                      'passport-priority-ddp-zone-PY': 491.0,
                      'passport-priority-ddp-zone-PE': 495.67,
                      'passport-priority-ddp-zone-SR': 491.0,
                      'passport-priority-ddp-zone-TT': 423.72,
                      'passport-priority-ddp-zone-UY': 491.0,
                      'passport-priority-ddp-zone-AF': 694.93,
                      'passport-priority-ddp-zone-DZ': 694.93,
                      'passport-priority-ddp-zone-BH': 675.28,
                      'passport-priority-ddp-zone-BD': 613.85,
                      'passport-priority-ddp-zone-BT': 613.85,
                      'passport-priority-ddp-zone-BA': 694.93,
                      'passport-priority-ddp-zone-BW': 694.93,
                      'passport-priority-ddp-zone-BN': 675.28,
                      'passport-priority-ddp-zone-BF': 694.93,
                      'passport-priority-ddp-zone-BI': 694.93,
                      'passport-priority-ddp-zone-KH': 694.93,
                      'passport-priority-ddp-zone-CM': 694.93,
                      'passport-priority-ddp-zone-CV': 694.93,
                      'passport-priority-ddp-zone-TD': 694.93,
                      'passport-priority-ddp-zone-CG': 694.93,
                      'passport-priority-ddp-zone-CI': 694.93,
                      'passport-priority-ddp-zone-EG': 675.28,
                      'passport-priority-ddp-zone-ET': 694.93,
                      'passport-priority-ddp-zone-GA': 694.93,
                      'passport-priority-ddp-zone-GM': 694.93,
                      'passport-priority-ddp-zone-GH': 694.93,
                      'passport-priority-ddp-zone-GN': 694.93,
                      'passport-priority-ddp-zone-ID': 614.15,
                      'passport-priority-ddp-zone-JO': 675.28,
                      'passport-priority-ddp-zone-KE': 694.93,
                      'passport-priority-ddp-zone-KW': 676.51,
                      'passport-priority-ddp-zone-LB': 675.28,
                      'passport-priority-ddp-zone-LI': 675.02,
                      'passport-priority-ddp-zone-MO': 615.24,
                      'passport-priority-ddp-zone-MG': 694.93,
                      'passport-priority-ddp-zone-MW': 694.93,
                      'passport-priority-ddp-zone-MY': 593.15,
                      'passport-priority-ddp-zone-MV': 613.85,
                      'passport-priority-ddp-zone-ML': 694.93,
                      'passport-priority-ddp-zone-MR': 694.93,
                      'passport-priority-ddp-zone-MU': 694.93,
                      'passport-priority-ddp-zone-MD': 694.93,
                      'passport-priority-ddp-zone-MA': 695.81,
                      'passport-priority-ddp-zone-MZ': 694.93,
                      'passport-priority-ddp-zone-NA': 694.93,
                      'passport-priority-ddp-zone-NP': 613.85,
                      'passport-priority-ddp-zone-NE': 694.93,
                      'passport-priority-ddp-zone-NG': 694.93,
                      'passport-priority-ddp-zone-PK': 613.85,
                      'passport-priority-ddp-zone-PH': 594.19,
                      'passport-priority-ddp-zone-RE': 694.93,
                      'passport-priority-ddp-zone-RW': 694.93,
                      'passport-priority-ddp-zone-SN': 694.93,
                      'passport-priority-ddp-zone-SC': 694.93,
                      'passport-priority-ddp-zone-ZA': 651.42,
                      'passport-priority-ddp-zone-LK': 613.85,
                      'passport-priority-ddp-zone-SZ': 694.93,
                      'passport-priority-ddp-zone-TW': 594.19,
                      'passport-priority-ddp-zone-TJ': 694.93,
                      'passport-priority-ddp-zone-TZ': 694.93,
                      'passport-priority-ddp-zone-TG': 694.93,
                      'passport-priority-ddp-zone-TN': 694.93,
                      'passport-priority-ddp-zone-TR': 675.31,
                      'passport-priority-ddp-zone-TM': 694.93,
                      'passport-priority-ddp-zone-UG': 694.93,
                      'passport-priority-ddp-zone-UA': 694.93,
                      'passport-priority-ddp-zone-VN': 593.83,
                      'passport-priority-ddp-zone-YE': 675.28,
                      'passport-priority-ddp-zone-ZM': 694.93,
                      'passport-priority-ddp-zone-ZW': 694.93,
                      'passport-priority-ddp-zone-MC': 273.28,
                      'passport-priority-ddp-zone-IM': 267.4,
                      'passport-priority-ddp-zone-SM': 273.28,
                    },
                    '60': {
                      'passport-priority-ddp-zone-CA': 136.63,
                      'passport-priority-ddp-zone-GB': 266.03,
                      'passport-priority-ddp-zone-AU': 380.51,
                      'passport-priority-ddp-zone-BE': 277.91,
                      'passport-priority-ddp-zone-DK': 277.91,
                      'passport-priority-ddp-zone-FR': 277.91,
                      'passport-priority-ddp-zone-DE': 277.91,
                      'passport-priority-ddp-zone-IT': 277.91,
                      'passport-priority-ddp-zone-NL': 277.91,
                      'passport-priority-ddp-zone-ES': 277.91,
                      'passport-priority-ddp-zone-MX': 348.0,
                      'passport-priority-ddp-zone-AM': 517.32,
                      'passport-priority-ddp-zone-AT': 284.33,
                      'passport-priority-ddp-zone-BG': 284.33,
                      'passport-priority-ddp-zone-HR': 284.33,
                      'passport-priority-ddp-zone-CY': 310.79,
                      'passport-priority-ddp-zone-CZ': 284.33,
                      'passport-priority-ddp-zone-EE': 284.33,
                      'passport-priority-ddp-zone-FI': 284.33,
                      'passport-priority-ddp-zone-GR': 307.26,
                      'passport-priority-ddp-zone-HU': 284.33,
                      'passport-priority-ddp-zone-IE': 284.33,
                      'passport-priority-ddp-zone-LV': 284.33,
                      'passport-priority-ddp-zone-LT': 284.33,
                      'passport-priority-ddp-zone-LU': 284.33,
                      'passport-priority-ddp-zone-MT': 310.79,
                      'passport-priority-ddp-zone-PL': 284.33,
                      'passport-priority-ddp-zone-PT': 284.33,
                      'passport-priority-ddp-zone-RO': 284.33,
                      'passport-priority-ddp-zone-SK': 284.33,
                      'passport-priority-ddp-zone-SI': 284.33,
                      'passport-priority-ddp-zone-SE': 284.33,
                      'passport-priority-ddp-zone-IL': 424.34,
                      'passport-priority-ddp-zone-OM': 438.47,
                      'passport-priority-ddp-zone-QA': 423.62,
                      'passport-priority-ddp-zone-SA': 423.65,
                      'passport-priority-ddp-zone-AE': 424.25,
                      'passport-priority-ddp-zone-CN': 591.39,
                      'passport-priority-ddp-zone-HK': 384.95,
                      'passport-priority-ddp-zone-IN': 454.21,
                      'passport-priority-ddp-zone-JP': 532.14,
                      'passport-priority-ddp-zone-KR': 442.24,
                      'passport-priority-ddp-zone-NZ': 384.5,
                      'passport-priority-ddp-zone-SG': 384.95,
                      'passport-priority-ddp-zone-TH': 387.42,
                      'passport-priority-ddp-zone-GG': 517.22,
                      'passport-priority-ddp-zone-JE': 517.22,
                      'passport-priority-ddp-zone-NO': 380.2,
                      'passport-priority-ddp-zone-CH': 380.92,
                      'passport-priority-ddp-zone-IS': 331.97,
                      'passport-priority-ddp-zone-AI': 418.66,
                      'passport-priority-ddp-zone-AG': 418.66,
                      'passport-priority-ddp-zone-AR': 506.43,
                      'passport-priority-ddp-zone-AW': 418.66,
                      'passport-priority-ddp-zone-BS': 418.66,
                      'passport-priority-ddp-zone-BB': 450.77,
                      'passport-priority-ddp-zone-BZ': 499.32,
                      'passport-priority-ddp-zone-BM': 419.58,
                      'passport-priority-ddp-zone-BO': 510.68,
                      'passport-priority-ddp-zone-BR': 381.46,
                      'passport-priority-ddp-zone-KY': 418.66,
                      'passport-priority-ddp-zone-CL': 432.16,
                      'passport-priority-ddp-zone-CO': 381.46,
                      'passport-priority-ddp-zone-CR': 507.52,
                      'passport-priority-ddp-zone-DM': 418.66,
                      'passport-priority-ddp-zone-DO': 420.08,
                      'passport-priority-ddp-zone-EC': 508.07,
                      'passport-priority-ddp-zone-SV': 499.32,
                      'passport-priority-ddp-zone-GP': 490.45,
                      'passport-priority-ddp-zone-GT': 499.42,
                      'passport-priority-ddp-zone-GY': 499.32,
                      'passport-priority-ddp-zone-HT': 418.66,
                      'passport-priority-ddp-zone-JM': 462.05,
                      'passport-priority-ddp-zone-MQ': 442.59,
                      'passport-priority-ddp-zone-AN': 418.66,
                      'passport-priority-ddp-zone-NI': 506.02,
                      'passport-priority-ddp-zone-PA': 499.92,
                      'passport-priority-ddp-zone-PY': 499.32,
                      'passport-priority-ddp-zone-PE': 504.07,
                      'passport-priority-ddp-zone-SR': 499.32,
                      'passport-priority-ddp-zone-TT': 430.91,
                      'passport-priority-ddp-zone-UY': 499.32,
                      'passport-priority-ddp-zone-AF': 706.71,
                      'passport-priority-ddp-zone-DZ': 706.71,
                      'passport-priority-ddp-zone-BH': 686.72,
                      'passport-priority-ddp-zone-BD': 624.26,
                      'passport-priority-ddp-zone-BT': 624.26,
                      'passport-priority-ddp-zone-BA': 706.71,
                      'passport-priority-ddp-zone-BW': 706.71,
                      'passport-priority-ddp-zone-BN': 686.72,
                      'passport-priority-ddp-zone-BF': 706.71,
                      'passport-priority-ddp-zone-BI': 706.71,
                      'passport-priority-ddp-zone-KH': 706.71,
                      'passport-priority-ddp-zone-CM': 706.71,
                      'passport-priority-ddp-zone-CV': 706.71,
                      'passport-priority-ddp-zone-TD': 706.71,
                      'passport-priority-ddp-zone-CG': 706.71,
                      'passport-priority-ddp-zone-CI': 706.71,
                      'passport-priority-ddp-zone-EG': 686.72,
                      'passport-priority-ddp-zone-ET': 706.71,
                      'passport-priority-ddp-zone-GA': 706.71,
                      'passport-priority-ddp-zone-GM': 706.71,
                      'passport-priority-ddp-zone-GH': 706.71,
                      'passport-priority-ddp-zone-GN': 706.71,
                      'passport-priority-ddp-zone-ID': 624.5,
                      'passport-priority-ddp-zone-JO': 686.72,
                      'passport-priority-ddp-zone-KE': 706.71,
                      'passport-priority-ddp-zone-KW': 687.98,
                      'passport-priority-ddp-zone-LB': 686.72,
                      'passport-priority-ddp-zone-LI': 686.45,
                      'passport-priority-ddp-zone-MO': 625.67,
                      'passport-priority-ddp-zone-MG': 706.71,
                      'passport-priority-ddp-zone-MW': 706.71,
                      'passport-priority-ddp-zone-MY': 603.2,
                      'passport-priority-ddp-zone-MV': 624.26,
                      'passport-priority-ddp-zone-ML': 706.71,
                      'passport-priority-ddp-zone-MR': 706.71,
                      'passport-priority-ddp-zone-MU': 706.71,
                      'passport-priority-ddp-zone-MD': 706.71,
                      'passport-priority-ddp-zone-MA': 707.61,
                      'passport-priority-ddp-zone-MZ': 706.71,
                      'passport-priority-ddp-zone-NA': 706.71,
                      'passport-priority-ddp-zone-NP': 624.26,
                      'passport-priority-ddp-zone-NE': 706.71,
                      'passport-priority-ddp-zone-NG': 706.71,
                      'passport-priority-ddp-zone-PK': 624.26,
                      'passport-priority-ddp-zone-PH': 604.27,
                      'passport-priority-ddp-zone-RE': 706.71,
                      'passport-priority-ddp-zone-RW': 706.71,
                      'passport-priority-ddp-zone-SN': 706.71,
                      'passport-priority-ddp-zone-SC': 706.71,
                      'passport-priority-ddp-zone-ZA': 662.46,
                      'passport-priority-ddp-zone-LK': 624.26,
                      'passport-priority-ddp-zone-SZ': 706.71,
                      'passport-priority-ddp-zone-TW': 604.27,
                      'passport-priority-ddp-zone-TJ': 706.71,
                      'passport-priority-ddp-zone-TZ': 706.71,
                      'passport-priority-ddp-zone-TG': 706.71,
                      'passport-priority-ddp-zone-TN': 706.71,
                      'passport-priority-ddp-zone-TR': 686.75,
                      'passport-priority-ddp-zone-TM': 706.71,
                      'passport-priority-ddp-zone-UG': 706.71,
                      'passport-priority-ddp-zone-UA': 706.71,
                      'passport-priority-ddp-zone-VN': 603.89,
                      'passport-priority-ddp-zone-YE': 686.72,
                      'passport-priority-ddp-zone-ZM': 706.71,
                      'passport-priority-ddp-zone-ZW': 706.71,
                      'passport-priority-ddp-zone-MC': 277.91,
                      'passport-priority-ddp-zone-IM': 272.03,
                      'passport-priority-ddp-zone-SM': 277.91,
                    },
                    '61': {
                      'passport-priority-ddp-zone-CA': 138.91,
                      'passport-priority-ddp-zone-GB': 270.46,
                      'passport-priority-ddp-zone-AU': 386.85,
                      'passport-priority-ddp-zone-BE': 282.54,
                      'passport-priority-ddp-zone-DK': 282.54,
                      'passport-priority-ddp-zone-FR': 282.54,
                      'passport-priority-ddp-zone-DE': 282.54,
                      'passport-priority-ddp-zone-IT': 282.54,
                      'passport-priority-ddp-zone-NL': 282.54,
                      'passport-priority-ddp-zone-ES': 282.54,
                      'passport-priority-ddp-zone-MX': 353.8,
                      'passport-priority-ddp-zone-AM': 525.94,
                      'passport-priority-ddp-zone-AT': 289.07,
                      'passport-priority-ddp-zone-BG': 289.07,
                      'passport-priority-ddp-zone-HR': 289.07,
                      'passport-priority-ddp-zone-CY': 315.97,
                      'passport-priority-ddp-zone-CZ': 289.07,
                      'passport-priority-ddp-zone-EE': 289.07,
                      'passport-priority-ddp-zone-FI': 289.07,
                      'passport-priority-ddp-zone-GR': 312.38,
                      'passport-priority-ddp-zone-HU': 289.07,
                      'passport-priority-ddp-zone-IE': 289.07,
                      'passport-priority-ddp-zone-LV': 289.07,
                      'passport-priority-ddp-zone-LT': 289.07,
                      'passport-priority-ddp-zone-LU': 289.07,
                      'passport-priority-ddp-zone-MT': 315.97,
                      'passport-priority-ddp-zone-PL': 289.07,
                      'passport-priority-ddp-zone-PT': 289.07,
                      'passport-priority-ddp-zone-RO': 289.07,
                      'passport-priority-ddp-zone-SK': 289.07,
                      'passport-priority-ddp-zone-SI': 289.07,
                      'passport-priority-ddp-zone-SE': 289.07,
                      'passport-priority-ddp-zone-IL': 431.41,
                      'passport-priority-ddp-zone-OM': 445.78,
                      'passport-priority-ddp-zone-QA': 430.68,
                      'passport-priority-ddp-zone-SA': 430.71,
                      'passport-priority-ddp-zone-AE': 431.32,
                      'passport-priority-ddp-zone-CN': 601.25,
                      'passport-priority-ddp-zone-HK': 391.37,
                      'passport-priority-ddp-zone-IN': 461.78,
                      'passport-priority-ddp-zone-JP': 541.01,
                      'passport-priority-ddp-zone-KR': 449.61,
                      'passport-priority-ddp-zone-NZ': 390.91,
                      'passport-priority-ddp-zone-SG': 391.37,
                      'passport-priority-ddp-zone-TH': 393.88,
                      'passport-priority-ddp-zone-GG': 525.84,
                      'passport-priority-ddp-zone-JE': 525.84,
                      'passport-priority-ddp-zone-NO': 386.53,
                      'passport-priority-ddp-zone-CH': 387.26,
                      'passport-priority-ddp-zone-IS': 337.5,
                      'passport-priority-ddp-zone-AI': 425.64,
                      'passport-priority-ddp-zone-AG': 425.64,
                      'passport-priority-ddp-zone-AR': 514.87,
                      'passport-priority-ddp-zone-AW': 425.64,
                      'passport-priority-ddp-zone-BS': 425.64,
                      'passport-priority-ddp-zone-BB': 458.29,
                      'passport-priority-ddp-zone-BZ': 507.64,
                      'passport-priority-ddp-zone-BM': 426.58,
                      'passport-priority-ddp-zone-BO': 519.19,
                      'passport-priority-ddp-zone-BR': 387.82,
                      'passport-priority-ddp-zone-KY': 425.64,
                      'passport-priority-ddp-zone-CL': 439.36,
                      'passport-priority-ddp-zone-CO': 387.82,
                      'passport-priority-ddp-zone-CR': 515.98,
                      'passport-priority-ddp-zone-DM': 425.64,
                      'passport-priority-ddp-zone-DO': 427.08,
                      'passport-priority-ddp-zone-EC': 516.54,
                      'passport-priority-ddp-zone-SV': 507.64,
                      'passport-priority-ddp-zone-GP': 498.63,
                      'passport-priority-ddp-zone-GT': 507.74,
                      'passport-priority-ddp-zone-GY': 507.64,
                      'passport-priority-ddp-zone-HT': 425.64,
                      'passport-priority-ddp-zone-JM': 469.76,
                      'passport-priority-ddp-zone-MQ': 449.97,
                      'passport-priority-ddp-zone-AN': 425.64,
                      'passport-priority-ddp-zone-NI': 514.45,
                      'passport-priority-ddp-zone-PA': 508.25,
                      'passport-priority-ddp-zone-PY': 507.64,
                      'passport-priority-ddp-zone-PE': 512.47,
                      'passport-priority-ddp-zone-SR': 507.64,
                      'passport-priority-ddp-zone-TT': 438.1,
                      'passport-priority-ddp-zone-UY': 507.64,
                      'passport-priority-ddp-zone-AF': 718.49,
                      'passport-priority-ddp-zone-DZ': 718.49,
                      'passport-priority-ddp-zone-BH': 698.16,
                      'passport-priority-ddp-zone-BD': 634.67,
                      'passport-priority-ddp-zone-BT': 634.67,
                      'passport-priority-ddp-zone-BA': 718.49,
                      'passport-priority-ddp-zone-BW': 718.49,
                      'passport-priority-ddp-zone-BN': 698.16,
                      'passport-priority-ddp-zone-BF': 718.49,
                      'passport-priority-ddp-zone-BI': 718.49,
                      'passport-priority-ddp-zone-KH': 718.49,
                      'passport-priority-ddp-zone-CM': 718.49,
                      'passport-priority-ddp-zone-CV': 718.49,
                      'passport-priority-ddp-zone-TD': 718.49,
                      'passport-priority-ddp-zone-CG': 718.49,
                      'passport-priority-ddp-zone-CI': 718.49,
                      'passport-priority-ddp-zone-EG': 698.16,
                      'passport-priority-ddp-zone-ET': 718.49,
                      'passport-priority-ddp-zone-GA': 718.49,
                      'passport-priority-ddp-zone-GM': 718.49,
                      'passport-priority-ddp-zone-GH': 718.49,
                      'passport-priority-ddp-zone-GN': 718.49,
                      'passport-priority-ddp-zone-ID': 634.85,
                      'passport-priority-ddp-zone-JO': 698.16,
                      'passport-priority-ddp-zone-KE': 718.49,
                      'passport-priority-ddp-zone-KW': 699.45,
                      'passport-priority-ddp-zone-LB': 698.16,
                      'passport-priority-ddp-zone-LI': 697.88,
                      'passport-priority-ddp-zone-MO': 636.1,
                      'passport-priority-ddp-zone-MG': 718.49,
                      'passport-priority-ddp-zone-MW': 718.49,
                      'passport-priority-ddp-zone-MY': 613.25,
                      'passport-priority-ddp-zone-MV': 634.67,
                      'passport-priority-ddp-zone-ML': 718.49,
                      'passport-priority-ddp-zone-MR': 718.49,
                      'passport-priority-ddp-zone-MU': 718.49,
                      'passport-priority-ddp-zone-MD': 718.49,
                      'passport-priority-ddp-zone-MA': 719.41,
                      'passport-priority-ddp-zone-MZ': 718.49,
                      'passport-priority-ddp-zone-NA': 718.49,
                      'passport-priority-ddp-zone-NP': 634.67,
                      'passport-priority-ddp-zone-NE': 718.49,
                      'passport-priority-ddp-zone-NG': 718.49,
                      'passport-priority-ddp-zone-PK': 634.67,
                      'passport-priority-ddp-zone-PH': 614.35,
                      'passport-priority-ddp-zone-RE': 718.49,
                      'passport-priority-ddp-zone-RW': 718.49,
                      'passport-priority-ddp-zone-SN': 718.49,
                      'passport-priority-ddp-zone-SC': 718.49,
                      'passport-priority-ddp-zone-ZA': 673.5,
                      'passport-priority-ddp-zone-LK': 634.67,
                      'passport-priority-ddp-zone-SZ': 718.49,
                      'passport-priority-ddp-zone-TW': 614.35,
                      'passport-priority-ddp-zone-TJ': 718.49,
                      'passport-priority-ddp-zone-TZ': 718.49,
                      'passport-priority-ddp-zone-TG': 718.49,
                      'passport-priority-ddp-zone-TN': 718.49,
                      'passport-priority-ddp-zone-TR': 698.19,
                      'passport-priority-ddp-zone-TM': 718.49,
                      'passport-priority-ddp-zone-UG': 718.49,
                      'passport-priority-ddp-zone-UA': 718.49,
                      'passport-priority-ddp-zone-VN': 613.95,
                      'passport-priority-ddp-zone-YE': 698.16,
                      'passport-priority-ddp-zone-ZM': 718.49,
                      'passport-priority-ddp-zone-ZW': 718.49,
                      'passport-priority-ddp-zone-MC': 282.54,
                      'passport-priority-ddp-zone-IM': 276.66,
                      'passport-priority-ddp-zone-SM': 282.54,
                    },
                    '62': {
                      'passport-priority-ddp-zone-CA': 141.19,
                      'passport-priority-ddp-zone-GB': 274.89,
                      'passport-priority-ddp-zone-AU': 393.19,
                      'passport-priority-ddp-zone-BE': 287.17,
                      'passport-priority-ddp-zone-DK': 287.17,
                      'passport-priority-ddp-zone-FR': 287.17,
                      'passport-priority-ddp-zone-DE': 287.17,
                      'passport-priority-ddp-zone-IT': 287.17,
                      'passport-priority-ddp-zone-NL': 287.17,
                      'passport-priority-ddp-zone-ES': 287.17,
                      'passport-priority-ddp-zone-MX': 359.6,
                      'passport-priority-ddp-zone-AM': 534.56,
                      'passport-priority-ddp-zone-AT': 293.81,
                      'passport-priority-ddp-zone-BG': 293.81,
                      'passport-priority-ddp-zone-HR': 293.81,
                      'passport-priority-ddp-zone-CY': 321.15,
                      'passport-priority-ddp-zone-CZ': 293.81,
                      'passport-priority-ddp-zone-EE': 293.81,
                      'passport-priority-ddp-zone-FI': 293.81,
                      'passport-priority-ddp-zone-GR': 317.5,
                      'passport-priority-ddp-zone-HU': 293.81,
                      'passport-priority-ddp-zone-IE': 293.81,
                      'passport-priority-ddp-zone-LV': 293.81,
                      'passport-priority-ddp-zone-LT': 293.81,
                      'passport-priority-ddp-zone-LU': 293.81,
                      'passport-priority-ddp-zone-MT': 321.15,
                      'passport-priority-ddp-zone-PL': 293.81,
                      'passport-priority-ddp-zone-PT': 293.81,
                      'passport-priority-ddp-zone-RO': 293.81,
                      'passport-priority-ddp-zone-SK': 293.81,
                      'passport-priority-ddp-zone-SI': 293.81,
                      'passport-priority-ddp-zone-SE': 293.81,
                      'passport-priority-ddp-zone-IL': 438.48,
                      'passport-priority-ddp-zone-OM': 453.09,
                      'passport-priority-ddp-zone-QA': 437.74,
                      'passport-priority-ddp-zone-SA': 437.77,
                      'passport-priority-ddp-zone-AE': 438.39,
                      'passport-priority-ddp-zone-CN': 611.11,
                      'passport-priority-ddp-zone-HK': 397.79,
                      'passport-priority-ddp-zone-IN': 469.35,
                      'passport-priority-ddp-zone-JP': 549.88,
                      'passport-priority-ddp-zone-KR': 456.98,
                      'passport-priority-ddp-zone-NZ': 397.32,
                      'passport-priority-ddp-zone-SG': 397.79,
                      'passport-priority-ddp-zone-TH': 400.34,
                      'passport-priority-ddp-zone-GG': 534.46,
                      'passport-priority-ddp-zone-JE': 534.46,
                      'passport-priority-ddp-zone-NO': 392.86,
                      'passport-priority-ddp-zone-CH': 393.6,
                      'passport-priority-ddp-zone-IS': 343.03,
                      'passport-priority-ddp-zone-AI': 432.62,
                      'passport-priority-ddp-zone-AG': 432.62,
                      'passport-priority-ddp-zone-AR': 523.31,
                      'passport-priority-ddp-zone-AW': 432.62,
                      'passport-priority-ddp-zone-BS': 432.62,
                      'passport-priority-ddp-zone-BB': 465.81,
                      'passport-priority-ddp-zone-BZ': 515.96,
                      'passport-priority-ddp-zone-BM': 433.58,
                      'passport-priority-ddp-zone-BO': 527.7,
                      'passport-priority-ddp-zone-BR': 394.18,
                      'passport-priority-ddp-zone-KY': 432.62,
                      'passport-priority-ddp-zone-CL': 446.56,
                      'passport-priority-ddp-zone-CO': 394.18,
                      'passport-priority-ddp-zone-CR': 524.44,
                      'passport-priority-ddp-zone-DM': 432.62,
                      'passport-priority-ddp-zone-DO': 434.08,
                      'passport-priority-ddp-zone-EC': 525.01,
                      'passport-priority-ddp-zone-SV': 515.96,
                      'passport-priority-ddp-zone-GP': 506.81,
                      'passport-priority-ddp-zone-GT': 516.06,
                      'passport-priority-ddp-zone-GY': 515.96,
                      'passport-priority-ddp-zone-HT': 432.62,
                      'passport-priority-ddp-zone-JM': 477.47,
                      'passport-priority-ddp-zone-MQ': 457.35,
                      'passport-priority-ddp-zone-AN': 432.62,
                      'passport-priority-ddp-zone-NI': 522.88,
                      'passport-priority-ddp-zone-PA': 516.58,
                      'passport-priority-ddp-zone-PY': 515.96,
                      'passport-priority-ddp-zone-PE': 520.87,
                      'passport-priority-ddp-zone-SR': 515.96,
                      'passport-priority-ddp-zone-TT': 445.29,
                      'passport-priority-ddp-zone-UY': 515.96,
                      'passport-priority-ddp-zone-AF': 730.27,
                      'passport-priority-ddp-zone-DZ': 730.27,
                      'passport-priority-ddp-zone-BH': 709.6,
                      'passport-priority-ddp-zone-BD': 645.08,
                      'passport-priority-ddp-zone-BT': 645.08,
                      'passport-priority-ddp-zone-BA': 730.27,
                      'passport-priority-ddp-zone-BW': 730.27,
                      'passport-priority-ddp-zone-BN': 709.6,
                      'passport-priority-ddp-zone-BF': 730.27,
                      'passport-priority-ddp-zone-BI': 730.27,
                      'passport-priority-ddp-zone-KH': 730.27,
                      'passport-priority-ddp-zone-CM': 730.27,
                      'passport-priority-ddp-zone-CV': 730.27,
                      'passport-priority-ddp-zone-TD': 730.27,
                      'passport-priority-ddp-zone-CG': 730.27,
                      'passport-priority-ddp-zone-CI': 730.27,
                      'passport-priority-ddp-zone-EG': 709.6,
                      'passport-priority-ddp-zone-ET': 730.27,
                      'passport-priority-ddp-zone-GA': 730.27,
                      'passport-priority-ddp-zone-GM': 730.27,
                      'passport-priority-ddp-zone-GH': 730.27,
                      'passport-priority-ddp-zone-GN': 730.27,
                      'passport-priority-ddp-zone-ID': 645.2,
                      'passport-priority-ddp-zone-JO': 709.6,
                      'passport-priority-ddp-zone-KE': 730.27,
                      'passport-priority-ddp-zone-KW': 710.92,
                      'passport-priority-ddp-zone-LB': 709.6,
                      'passport-priority-ddp-zone-LI': 709.31,
                      'passport-priority-ddp-zone-MO': 646.53,
                      'passport-priority-ddp-zone-MG': 730.27,
                      'passport-priority-ddp-zone-MW': 730.27,
                      'passport-priority-ddp-zone-MY': 623.3,
                      'passport-priority-ddp-zone-MV': 645.08,
                      'passport-priority-ddp-zone-ML': 730.27,
                      'passport-priority-ddp-zone-MR': 730.27,
                      'passport-priority-ddp-zone-MU': 730.27,
                      'passport-priority-ddp-zone-MD': 730.27,
                      'passport-priority-ddp-zone-MA': 731.21,
                      'passport-priority-ddp-zone-MZ': 730.27,
                      'passport-priority-ddp-zone-NA': 730.27,
                      'passport-priority-ddp-zone-NP': 645.08,
                      'passport-priority-ddp-zone-NE': 730.27,
                      'passport-priority-ddp-zone-NG': 730.27,
                      'passport-priority-ddp-zone-PK': 645.08,
                      'passport-priority-ddp-zone-PH': 624.43,
                      'passport-priority-ddp-zone-RE': 730.27,
                      'passport-priority-ddp-zone-RW': 730.27,
                      'passport-priority-ddp-zone-SN': 730.27,
                      'passport-priority-ddp-zone-SC': 730.27,
                      'passport-priority-ddp-zone-ZA': 684.54,
                      'passport-priority-ddp-zone-LK': 645.08,
                      'passport-priority-ddp-zone-SZ': 730.27,
                      'passport-priority-ddp-zone-TW': 624.43,
                      'passport-priority-ddp-zone-TJ': 730.27,
                      'passport-priority-ddp-zone-TZ': 730.27,
                      'passport-priority-ddp-zone-TG': 730.27,
                      'passport-priority-ddp-zone-TN': 730.27,
                      'passport-priority-ddp-zone-TR': 709.63,
                      'passport-priority-ddp-zone-TM': 730.27,
                      'passport-priority-ddp-zone-UG': 730.27,
                      'passport-priority-ddp-zone-UA': 730.27,
                      'passport-priority-ddp-zone-VN': 624.01,
                      'passport-priority-ddp-zone-YE': 709.6,
                      'passport-priority-ddp-zone-ZM': 730.27,
                      'passport-priority-ddp-zone-ZW': 730.27,
                      'passport-priority-ddp-zone-MC': 287.17,
                      'passport-priority-ddp-zone-IM': 281.29,
                      'passport-priority-ddp-zone-SM': 287.17,
                    },
                    '63': {
                      'passport-priority-ddp-zone-CA': 143.47,
                      'passport-priority-ddp-zone-GB': 279.32,
                      'passport-priority-ddp-zone-AU': 399.53,
                      'passport-priority-ddp-zone-BE': 291.8,
                      'passport-priority-ddp-zone-DK': 291.8,
                      'passport-priority-ddp-zone-FR': 291.8,
                      'passport-priority-ddp-zone-DE': 291.8,
                      'passport-priority-ddp-zone-IT': 291.8,
                      'passport-priority-ddp-zone-NL': 291.8,
                      'passport-priority-ddp-zone-ES': 291.8,
                      'passport-priority-ddp-zone-MX': 365.4,
                      'passport-priority-ddp-zone-AM': 543.18,
                      'passport-priority-ddp-zone-AT': 298.55,
                      'passport-priority-ddp-zone-BG': 298.55,
                      'passport-priority-ddp-zone-HR': 298.55,
                      'passport-priority-ddp-zone-CY': 326.33,
                      'passport-priority-ddp-zone-CZ': 298.55,
                      'passport-priority-ddp-zone-EE': 298.55,
                      'passport-priority-ddp-zone-FI': 298.55,
                      'passport-priority-ddp-zone-GR': 322.62,
                      'passport-priority-ddp-zone-HU': 298.55,
                      'passport-priority-ddp-zone-IE': 298.55,
                      'passport-priority-ddp-zone-LV': 298.55,
                      'passport-priority-ddp-zone-LT': 298.55,
                      'passport-priority-ddp-zone-LU': 298.55,
                      'passport-priority-ddp-zone-MT': 326.33,
                      'passport-priority-ddp-zone-PL': 298.55,
                      'passport-priority-ddp-zone-PT': 298.55,
                      'passport-priority-ddp-zone-RO': 298.55,
                      'passport-priority-ddp-zone-SK': 298.55,
                      'passport-priority-ddp-zone-SI': 298.55,
                      'passport-priority-ddp-zone-SE': 298.55,
                      'passport-priority-ddp-zone-IL': 445.55,
                      'passport-priority-ddp-zone-OM': 460.4,
                      'passport-priority-ddp-zone-QA': 444.8,
                      'passport-priority-ddp-zone-SA': 444.83,
                      'passport-priority-ddp-zone-AE': 445.46,
                      'passport-priority-ddp-zone-CN': 620.97,
                      'passport-priority-ddp-zone-HK': 404.21,
                      'passport-priority-ddp-zone-IN': 476.92,
                      'passport-priority-ddp-zone-JP': 558.75,
                      'passport-priority-ddp-zone-KR': 464.35,
                      'passport-priority-ddp-zone-NZ': 403.73,
                      'passport-priority-ddp-zone-SG': 404.21,
                      'passport-priority-ddp-zone-TH': 406.8,
                      'passport-priority-ddp-zone-GG': 543.08,
                      'passport-priority-ddp-zone-JE': 543.08,
                      'passport-priority-ddp-zone-NO': 399.19,
                      'passport-priority-ddp-zone-CH': 399.94,
                      'passport-priority-ddp-zone-IS': 348.56,
                      'passport-priority-ddp-zone-AI': 439.6,
                      'passport-priority-ddp-zone-AG': 439.6,
                      'passport-priority-ddp-zone-AR': 531.75,
                      'passport-priority-ddp-zone-AW': 439.6,
                      'passport-priority-ddp-zone-BS': 439.6,
                      'passport-priority-ddp-zone-BB': 473.33,
                      'passport-priority-ddp-zone-BZ': 524.28,
                      'passport-priority-ddp-zone-BM': 440.58,
                      'passport-priority-ddp-zone-BO': 536.21,
                      'passport-priority-ddp-zone-BR': 400.54,
                      'passport-priority-ddp-zone-KY': 439.6,
                      'passport-priority-ddp-zone-CL': 453.76,
                      'passport-priority-ddp-zone-CO': 400.54,
                      'passport-priority-ddp-zone-CR': 532.9,
                      'passport-priority-ddp-zone-DM': 439.6,
                      'passport-priority-ddp-zone-DO': 441.08,
                      'passport-priority-ddp-zone-EC': 533.48,
                      'passport-priority-ddp-zone-SV': 524.28,
                      'passport-priority-ddp-zone-GP': 514.99,
                      'passport-priority-ddp-zone-GT': 524.38,
                      'passport-priority-ddp-zone-GY': 524.28,
                      'passport-priority-ddp-zone-HT': 439.6,
                      'passport-priority-ddp-zone-JM': 485.18,
                      'passport-priority-ddp-zone-MQ': 464.73,
                      'passport-priority-ddp-zone-AN': 439.6,
                      'passport-priority-ddp-zone-NI': 531.31,
                      'passport-priority-ddp-zone-PA': 524.91,
                      'passport-priority-ddp-zone-PY': 524.28,
                      'passport-priority-ddp-zone-PE': 529.27,
                      'passport-priority-ddp-zone-SR': 524.28,
                      'passport-priority-ddp-zone-TT': 452.48,
                      'passport-priority-ddp-zone-UY': 524.28,
                      'passport-priority-ddp-zone-AF': 742.05,
                      'passport-priority-ddp-zone-DZ': 742.05,
                      'passport-priority-ddp-zone-BH': 721.04,
                      'passport-priority-ddp-zone-BD': 655.49,
                      'passport-priority-ddp-zone-BT': 655.49,
                      'passport-priority-ddp-zone-BA': 742.05,
                      'passport-priority-ddp-zone-BW': 742.05,
                      'passport-priority-ddp-zone-BN': 721.04,
                      'passport-priority-ddp-zone-BF': 742.05,
                      'passport-priority-ddp-zone-BI': 742.05,
                      'passport-priority-ddp-zone-KH': 742.05,
                      'passport-priority-ddp-zone-CM': 742.05,
                      'passport-priority-ddp-zone-CV': 742.05,
                      'passport-priority-ddp-zone-TD': 742.05,
                      'passport-priority-ddp-zone-CG': 742.05,
                      'passport-priority-ddp-zone-CI': 742.05,
                      'passport-priority-ddp-zone-EG': 721.04,
                      'passport-priority-ddp-zone-ET': 742.05,
                      'passport-priority-ddp-zone-GA': 742.05,
                      'passport-priority-ddp-zone-GM': 742.05,
                      'passport-priority-ddp-zone-GH': 742.05,
                      'passport-priority-ddp-zone-GN': 742.05,
                      'passport-priority-ddp-zone-ID': 655.55,
                      'passport-priority-ddp-zone-JO': 721.04,
                      'passport-priority-ddp-zone-KE': 742.05,
                      'passport-priority-ddp-zone-KW': 722.39,
                      'passport-priority-ddp-zone-LB': 721.04,
                      'passport-priority-ddp-zone-LI': 720.74,
                      'passport-priority-ddp-zone-MO': 656.96,
                      'passport-priority-ddp-zone-MG': 742.05,
                      'passport-priority-ddp-zone-MW': 742.05,
                      'passport-priority-ddp-zone-MY': 633.35,
                      'passport-priority-ddp-zone-MV': 655.49,
                      'passport-priority-ddp-zone-ML': 742.05,
                      'passport-priority-ddp-zone-MR': 742.05,
                      'passport-priority-ddp-zone-MU': 742.05,
                      'passport-priority-ddp-zone-MD': 742.05,
                      'passport-priority-ddp-zone-MA': 743.01,
                      'passport-priority-ddp-zone-MZ': 742.05,
                      'passport-priority-ddp-zone-NA': 742.05,
                      'passport-priority-ddp-zone-NP': 655.49,
                      'passport-priority-ddp-zone-NE': 742.05,
                      'passport-priority-ddp-zone-NG': 742.05,
                      'passport-priority-ddp-zone-PK': 655.49,
                      'passport-priority-ddp-zone-PH': 634.51,
                      'passport-priority-ddp-zone-RE': 742.05,
                      'passport-priority-ddp-zone-RW': 742.05,
                      'passport-priority-ddp-zone-SN': 742.05,
                      'passport-priority-ddp-zone-SC': 742.05,
                      'passport-priority-ddp-zone-ZA': 695.58,
                      'passport-priority-ddp-zone-LK': 655.49,
                      'passport-priority-ddp-zone-SZ': 742.05,
                      'passport-priority-ddp-zone-TW': 634.51,
                      'passport-priority-ddp-zone-TJ': 742.05,
                      'passport-priority-ddp-zone-TZ': 742.05,
                      'passport-priority-ddp-zone-TG': 742.05,
                      'passport-priority-ddp-zone-TN': 742.05,
                      'passport-priority-ddp-zone-TR': 721.07,
                      'passport-priority-ddp-zone-TM': 742.05,
                      'passport-priority-ddp-zone-UG': 742.05,
                      'passport-priority-ddp-zone-UA': 742.05,
                      'passport-priority-ddp-zone-VN': 634.07,
                      'passport-priority-ddp-zone-YE': 721.04,
                      'passport-priority-ddp-zone-ZM': 742.05,
                      'passport-priority-ddp-zone-ZW': 742.05,
                      'passport-priority-ddp-zone-MC': 291.8,
                      'passport-priority-ddp-zone-IM': 285.92,
                      'passport-priority-ddp-zone-SM': 291.8,
                    },
                    '64': {
                      'passport-priority-ddp-zone-CA': 145.75,
                      'passport-priority-ddp-zone-GB': 283.75,
                      'passport-priority-ddp-zone-AU': 405.87,
                      'passport-priority-ddp-zone-BE': 296.43,
                      'passport-priority-ddp-zone-DK': 296.43,
                      'passport-priority-ddp-zone-FR': 296.43,
                      'passport-priority-ddp-zone-DE': 296.43,
                      'passport-priority-ddp-zone-IT': 296.43,
                      'passport-priority-ddp-zone-NL': 296.43,
                      'passport-priority-ddp-zone-ES': 296.43,
                      'passport-priority-ddp-zone-MX': 371.2,
                      'passport-priority-ddp-zone-AM': 551.8,
                      'passport-priority-ddp-zone-AT': 303.29,
                      'passport-priority-ddp-zone-BG': 303.29,
                      'passport-priority-ddp-zone-HR': 303.29,
                      'passport-priority-ddp-zone-CY': 331.51,
                      'passport-priority-ddp-zone-CZ': 303.29,
                      'passport-priority-ddp-zone-EE': 303.29,
                      'passport-priority-ddp-zone-FI': 303.29,
                      'passport-priority-ddp-zone-GR': 327.74,
                      'passport-priority-ddp-zone-HU': 303.29,
                      'passport-priority-ddp-zone-IE': 303.29,
                      'passport-priority-ddp-zone-LV': 303.29,
                      'passport-priority-ddp-zone-LT': 303.29,
                      'passport-priority-ddp-zone-LU': 303.29,
                      'passport-priority-ddp-zone-MT': 331.51,
                      'passport-priority-ddp-zone-PL': 303.29,
                      'passport-priority-ddp-zone-PT': 303.29,
                      'passport-priority-ddp-zone-RO': 303.29,
                      'passport-priority-ddp-zone-SK': 303.29,
                      'passport-priority-ddp-zone-SI': 303.29,
                      'passport-priority-ddp-zone-SE': 303.29,
                      'passport-priority-ddp-zone-IL': 452.62,
                      'passport-priority-ddp-zone-OM': 467.71,
                      'passport-priority-ddp-zone-QA': 451.86,
                      'passport-priority-ddp-zone-SA': 451.89,
                      'passport-priority-ddp-zone-AE': 452.53,
                      'passport-priority-ddp-zone-CN': 630.83,
                      'passport-priority-ddp-zone-HK': 410.63,
                      'passport-priority-ddp-zone-IN': 484.49,
                      'passport-priority-ddp-zone-JP': 567.62,
                      'passport-priority-ddp-zone-KR': 471.72,
                      'passport-priority-ddp-zone-NZ': 410.14,
                      'passport-priority-ddp-zone-SG': 410.63,
                      'passport-priority-ddp-zone-TH': 413.26,
                      'passport-priority-ddp-zone-GG': 551.7,
                      'passport-priority-ddp-zone-JE': 551.7,
                      'passport-priority-ddp-zone-NO': 405.52,
                      'passport-priority-ddp-zone-CH': 406.28,
                      'passport-priority-ddp-zone-IS': 354.09,
                      'passport-priority-ddp-zone-AI': 446.58,
                      'passport-priority-ddp-zone-AG': 446.58,
                      'passport-priority-ddp-zone-AR': 540.19,
                      'passport-priority-ddp-zone-AW': 446.58,
                      'passport-priority-ddp-zone-BS': 446.58,
                      'passport-priority-ddp-zone-BB': 480.85,
                      'passport-priority-ddp-zone-BZ': 532.6,
                      'passport-priority-ddp-zone-BM': 447.58,
                      'passport-priority-ddp-zone-BO': 544.72,
                      'passport-priority-ddp-zone-BR': 406.9,
                      'passport-priority-ddp-zone-KY': 446.58,
                      'passport-priority-ddp-zone-CL': 460.96,
                      'passport-priority-ddp-zone-CO': 406.9,
                      'passport-priority-ddp-zone-CR': 541.36,
                      'passport-priority-ddp-zone-DM': 446.58,
                      'passport-priority-ddp-zone-DO': 448.08,
                      'passport-priority-ddp-zone-EC': 541.95,
                      'passport-priority-ddp-zone-SV': 532.6,
                      'passport-priority-ddp-zone-GP': 523.17,
                      'passport-priority-ddp-zone-GT': 532.7,
                      'passport-priority-ddp-zone-GY': 532.6,
                      'passport-priority-ddp-zone-HT': 446.58,
                      'passport-priority-ddp-zone-JM': 492.89,
                      'passport-priority-ddp-zone-MQ': 472.11,
                      'passport-priority-ddp-zone-AN': 446.58,
                      'passport-priority-ddp-zone-NI': 539.74,
                      'passport-priority-ddp-zone-PA': 533.24,
                      'passport-priority-ddp-zone-PY': 532.6,
                      'passport-priority-ddp-zone-PE': 537.67,
                      'passport-priority-ddp-zone-SR': 532.6,
                      'passport-priority-ddp-zone-TT': 459.67,
                      'passport-priority-ddp-zone-UY': 532.6,
                      'passport-priority-ddp-zone-AF': 753.83,
                      'passport-priority-ddp-zone-DZ': 753.83,
                      'passport-priority-ddp-zone-BH': 732.48,
                      'passport-priority-ddp-zone-BD': 665.9,
                      'passport-priority-ddp-zone-BT': 665.9,
                      'passport-priority-ddp-zone-BA': 753.83,
                      'passport-priority-ddp-zone-BW': 753.83,
                      'passport-priority-ddp-zone-BN': 732.48,
                      'passport-priority-ddp-zone-BF': 753.83,
                      'passport-priority-ddp-zone-BI': 753.83,
                      'passport-priority-ddp-zone-KH': 753.83,
                      'passport-priority-ddp-zone-CM': 753.83,
                      'passport-priority-ddp-zone-CV': 753.83,
                      'passport-priority-ddp-zone-TD': 753.83,
                      'passport-priority-ddp-zone-CG': 753.83,
                      'passport-priority-ddp-zone-CI': 753.83,
                      'passport-priority-ddp-zone-EG': 732.48,
                      'passport-priority-ddp-zone-ET': 753.83,
                      'passport-priority-ddp-zone-GA': 753.83,
                      'passport-priority-ddp-zone-GM': 753.83,
                      'passport-priority-ddp-zone-GH': 753.83,
                      'passport-priority-ddp-zone-GN': 753.83,
                      'passport-priority-ddp-zone-ID': 665.9,
                      'passport-priority-ddp-zone-JO': 732.48,
                      'passport-priority-ddp-zone-KE': 753.83,
                      'passport-priority-ddp-zone-KW': 733.86,
                      'passport-priority-ddp-zone-LB': 732.48,
                      'passport-priority-ddp-zone-LI': 732.17,
                      'passport-priority-ddp-zone-MO': 667.39,
                      'passport-priority-ddp-zone-MG': 753.83,
                      'passport-priority-ddp-zone-MW': 753.83,
                      'passport-priority-ddp-zone-MY': 643.4,
                      'passport-priority-ddp-zone-MV': 665.9,
                      'passport-priority-ddp-zone-ML': 753.83,
                      'passport-priority-ddp-zone-MR': 753.83,
                      'passport-priority-ddp-zone-MU': 753.83,
                      'passport-priority-ddp-zone-MD': 753.83,
                      'passport-priority-ddp-zone-MA': 754.81,
                      'passport-priority-ddp-zone-MZ': 753.83,
                      'passport-priority-ddp-zone-NA': 753.83,
                      'passport-priority-ddp-zone-NP': 665.9,
                      'passport-priority-ddp-zone-NE': 753.83,
                      'passport-priority-ddp-zone-NG': 753.83,
                      'passport-priority-ddp-zone-PK': 665.9,
                      'passport-priority-ddp-zone-PH': 644.59,
                      'passport-priority-ddp-zone-RE': 753.83,
                      'passport-priority-ddp-zone-RW': 753.83,
                      'passport-priority-ddp-zone-SN': 753.83,
                      'passport-priority-ddp-zone-SC': 753.83,
                      'passport-priority-ddp-zone-ZA': 706.62,
                      'passport-priority-ddp-zone-LK': 665.9,
                      'passport-priority-ddp-zone-SZ': 753.83,
                      'passport-priority-ddp-zone-TW': 644.59,
                      'passport-priority-ddp-zone-TJ': 753.83,
                      'passport-priority-ddp-zone-TZ': 753.83,
                      'passport-priority-ddp-zone-TG': 753.83,
                      'passport-priority-ddp-zone-TN': 753.83,
                      'passport-priority-ddp-zone-TR': 732.51,
                      'passport-priority-ddp-zone-TM': 753.83,
                      'passport-priority-ddp-zone-UG': 753.83,
                      'passport-priority-ddp-zone-UA': 753.83,
                      'passport-priority-ddp-zone-VN': 644.13,
                      'passport-priority-ddp-zone-YE': 732.48,
                      'passport-priority-ddp-zone-ZM': 753.83,
                      'passport-priority-ddp-zone-ZW': 753.83,
                      'passport-priority-ddp-zone-MC': 296.43,
                      'passport-priority-ddp-zone-IM': 290.55,
                      'passport-priority-ddp-zone-SM': 296.43,
                    },
                    '65': {
                      'passport-priority-ddp-zone-CA': 148.03,
                      'passport-priority-ddp-zone-GB': 288.18,
                      'passport-priority-ddp-zone-AU': 412.21,
                      'passport-priority-ddp-zone-BE': 301.06,
                      'passport-priority-ddp-zone-DK': 301.06,
                      'passport-priority-ddp-zone-FR': 301.06,
                      'passport-priority-ddp-zone-DE': 301.06,
                      'passport-priority-ddp-zone-IT': 301.06,
                      'passport-priority-ddp-zone-NL': 301.06,
                      'passport-priority-ddp-zone-ES': 301.06,
                      'passport-priority-ddp-zone-MX': 377.0,
                      'passport-priority-ddp-zone-AM': 560.42,
                      'passport-priority-ddp-zone-AT': 308.03,
                      'passport-priority-ddp-zone-BG': 308.03,
                      'passport-priority-ddp-zone-HR': 308.03,
                      'passport-priority-ddp-zone-CY': 336.69,
                      'passport-priority-ddp-zone-CZ': 308.03,
                      'passport-priority-ddp-zone-EE': 308.03,
                      'passport-priority-ddp-zone-FI': 308.03,
                      'passport-priority-ddp-zone-GR': 332.86,
                      'passport-priority-ddp-zone-HU': 308.03,
                      'passport-priority-ddp-zone-IE': 308.03,
                      'passport-priority-ddp-zone-LV': 308.03,
                      'passport-priority-ddp-zone-LT': 308.03,
                      'passport-priority-ddp-zone-LU': 308.03,
                      'passport-priority-ddp-zone-MT': 336.69,
                      'passport-priority-ddp-zone-PL': 308.03,
                      'passport-priority-ddp-zone-PT': 308.03,
                      'passport-priority-ddp-zone-RO': 308.03,
                      'passport-priority-ddp-zone-SK': 308.03,
                      'passport-priority-ddp-zone-SI': 308.03,
                      'passport-priority-ddp-zone-SE': 308.03,
                      'passport-priority-ddp-zone-IL': 459.69,
                      'passport-priority-ddp-zone-OM': 475.02,
                      'passport-priority-ddp-zone-QA': 458.92,
                      'passport-priority-ddp-zone-SA': 458.95,
                      'passport-priority-ddp-zone-AE': 459.6,
                      'passport-priority-ddp-zone-CN': 640.69,
                      'passport-priority-ddp-zone-HK': 417.05,
                      'passport-priority-ddp-zone-IN': 492.06,
                      'passport-priority-ddp-zone-JP': 576.49,
                      'passport-priority-ddp-zone-KR': 479.09,
                      'passport-priority-ddp-zone-NZ': 416.55,
                      'passport-priority-ddp-zone-SG': 417.05,
                      'passport-priority-ddp-zone-TH': 419.72,
                      'passport-priority-ddp-zone-GG': 560.32,
                      'passport-priority-ddp-zone-JE': 560.32,
                      'passport-priority-ddp-zone-NO': 411.85,
                      'passport-priority-ddp-zone-CH': 412.62,
                      'passport-priority-ddp-zone-IS': 359.62,
                      'passport-priority-ddp-zone-AI': 453.56,
                      'passport-priority-ddp-zone-AG': 453.56,
                      'passport-priority-ddp-zone-AR': 548.63,
                      'passport-priority-ddp-zone-AW': 453.56,
                      'passport-priority-ddp-zone-BS': 453.56,
                      'passport-priority-ddp-zone-BB': 488.37,
                      'passport-priority-ddp-zone-BZ': 540.92,
                      'passport-priority-ddp-zone-BM': 454.58,
                      'passport-priority-ddp-zone-BO': 553.23,
                      'passport-priority-ddp-zone-BR': 413.26,
                      'passport-priority-ddp-zone-KY': 453.56,
                      'passport-priority-ddp-zone-CL': 468.16,
                      'passport-priority-ddp-zone-CO': 413.26,
                      'passport-priority-ddp-zone-CR': 549.82,
                      'passport-priority-ddp-zone-DM': 453.56,
                      'passport-priority-ddp-zone-DO': 455.08,
                      'passport-priority-ddp-zone-EC': 550.42,
                      'passport-priority-ddp-zone-SV': 540.92,
                      'passport-priority-ddp-zone-GP': 531.35,
                      'passport-priority-ddp-zone-GT': 541.02,
                      'passport-priority-ddp-zone-GY': 540.92,
                      'passport-priority-ddp-zone-HT': 453.56,
                      'passport-priority-ddp-zone-JM': 500.6,
                      'passport-priority-ddp-zone-MQ': 479.49,
                      'passport-priority-ddp-zone-AN': 453.56,
                      'passport-priority-ddp-zone-NI': 548.17,
                      'passport-priority-ddp-zone-PA': 541.57,
                      'passport-priority-ddp-zone-PY': 540.92,
                      'passport-priority-ddp-zone-PE': 546.07,
                      'passport-priority-ddp-zone-SR': 540.92,
                      'passport-priority-ddp-zone-TT': 466.86,
                      'passport-priority-ddp-zone-UY': 540.92,
                      'passport-priority-ddp-zone-AF': 765.61,
                      'passport-priority-ddp-zone-DZ': 765.61,
                      'passport-priority-ddp-zone-BH': 743.92,
                      'passport-priority-ddp-zone-BD': 676.31,
                      'passport-priority-ddp-zone-BT': 676.31,
                      'passport-priority-ddp-zone-BA': 765.61,
                      'passport-priority-ddp-zone-BW': 765.61,
                      'passport-priority-ddp-zone-BN': 743.92,
                      'passport-priority-ddp-zone-BF': 765.61,
                      'passport-priority-ddp-zone-BI': 765.61,
                      'passport-priority-ddp-zone-KH': 765.61,
                      'passport-priority-ddp-zone-CM': 765.61,
                      'passport-priority-ddp-zone-CV': 765.61,
                      'passport-priority-ddp-zone-TD': 765.61,
                      'passport-priority-ddp-zone-CG': 765.61,
                      'passport-priority-ddp-zone-CI': 765.61,
                      'passport-priority-ddp-zone-EG': 743.92,
                      'passport-priority-ddp-zone-ET': 765.61,
                      'passport-priority-ddp-zone-GA': 765.61,
                      'passport-priority-ddp-zone-GM': 765.61,
                      'passport-priority-ddp-zone-GH': 765.61,
                      'passport-priority-ddp-zone-GN': 765.61,
                      'passport-priority-ddp-zone-ID': 676.25,
                      'passport-priority-ddp-zone-JO': 743.92,
                      'passport-priority-ddp-zone-KE': 765.61,
                      'passport-priority-ddp-zone-KW': 745.33,
                      'passport-priority-ddp-zone-LB': 743.92,
                      'passport-priority-ddp-zone-LI': 743.6,
                      'passport-priority-ddp-zone-MO': 677.82,
                      'passport-priority-ddp-zone-MG': 765.61,
                      'passport-priority-ddp-zone-MW': 765.61,
                      'passport-priority-ddp-zone-MY': 653.45,
                      'passport-priority-ddp-zone-MV': 676.31,
                      'passport-priority-ddp-zone-ML': 765.61,
                      'passport-priority-ddp-zone-MR': 765.61,
                      'passport-priority-ddp-zone-MU': 765.61,
                      'passport-priority-ddp-zone-MD': 765.61,
                      'passport-priority-ddp-zone-MA': 766.61,
                      'passport-priority-ddp-zone-MZ': 765.61,
                      'passport-priority-ddp-zone-NA': 765.61,
                      'passport-priority-ddp-zone-NP': 676.31,
                      'passport-priority-ddp-zone-NE': 765.61,
                      'passport-priority-ddp-zone-NG': 765.61,
                      'passport-priority-ddp-zone-PK': 676.31,
                      'passport-priority-ddp-zone-PH': 654.67,
                      'passport-priority-ddp-zone-RE': 765.61,
                      'passport-priority-ddp-zone-RW': 765.61,
                      'passport-priority-ddp-zone-SN': 765.61,
                      'passport-priority-ddp-zone-SC': 765.61,
                      'passport-priority-ddp-zone-ZA': 717.66,
                      'passport-priority-ddp-zone-LK': 676.31,
                      'passport-priority-ddp-zone-SZ': 765.61,
                      'passport-priority-ddp-zone-TW': 654.67,
                      'passport-priority-ddp-zone-TJ': 765.61,
                      'passport-priority-ddp-zone-TZ': 765.61,
                      'passport-priority-ddp-zone-TG': 765.61,
                      'passport-priority-ddp-zone-TN': 765.61,
                      'passport-priority-ddp-zone-TR': 743.95,
                      'passport-priority-ddp-zone-TM': 765.61,
                      'passport-priority-ddp-zone-UG': 765.61,
                      'passport-priority-ddp-zone-UA': 765.61,
                      'passport-priority-ddp-zone-VN': 654.19,
                      'passport-priority-ddp-zone-YE': 743.92,
                      'passport-priority-ddp-zone-ZM': 765.61,
                      'passport-priority-ddp-zone-ZW': 765.61,
                      'passport-priority-ddp-zone-MC': 301.06,
                      'passport-priority-ddp-zone-IM': 295.18,
                      'passport-priority-ddp-zone-SM': 301.06,
                    },
                    '66': {
                      'passport-priority-ddp-zone-CA': 150.31,
                      'passport-priority-ddp-zone-GB': 292.61,
                      'passport-priority-ddp-zone-AU': 418.55,
                      'passport-priority-ddp-zone-BE': 305.69,
                      'passport-priority-ddp-zone-DK': 305.69,
                      'passport-priority-ddp-zone-FR': 305.69,
                      'passport-priority-ddp-zone-DE': 305.69,
                      'passport-priority-ddp-zone-IT': 305.69,
                      'passport-priority-ddp-zone-NL': 305.69,
                      'passport-priority-ddp-zone-ES': 305.69,
                      'passport-priority-ddp-zone-MX': 382.8,
                      'passport-priority-ddp-zone-AM': 569.04,
                      'passport-priority-ddp-zone-AT': 312.77,
                      'passport-priority-ddp-zone-BG': 312.77,
                      'passport-priority-ddp-zone-HR': 312.77,
                      'passport-priority-ddp-zone-CY': 341.87,
                      'passport-priority-ddp-zone-CZ': 312.77,
                      'passport-priority-ddp-zone-EE': 312.77,
                      'passport-priority-ddp-zone-FI': 312.77,
                      'passport-priority-ddp-zone-GR': 337.98,
                      'passport-priority-ddp-zone-HU': 312.77,
                      'passport-priority-ddp-zone-IE': 312.77,
                      'passport-priority-ddp-zone-LV': 312.77,
                      'passport-priority-ddp-zone-LT': 312.77,
                      'passport-priority-ddp-zone-LU': 312.77,
                      'passport-priority-ddp-zone-MT': 341.87,
                      'passport-priority-ddp-zone-PL': 312.77,
                      'passport-priority-ddp-zone-PT': 312.77,
                      'passport-priority-ddp-zone-RO': 312.77,
                      'passport-priority-ddp-zone-SK': 312.77,
                      'passport-priority-ddp-zone-SI': 312.77,
                      'passport-priority-ddp-zone-SE': 312.77,
                      'passport-priority-ddp-zone-IL': 466.76,
                      'passport-priority-ddp-zone-OM': 482.33,
                      'passport-priority-ddp-zone-QA': 465.98,
                      'passport-priority-ddp-zone-SA': 466.01,
                      'passport-priority-ddp-zone-AE': 466.67,
                      'passport-priority-ddp-zone-CN': 650.55,
                      'passport-priority-ddp-zone-HK': 423.47,
                      'passport-priority-ddp-zone-IN': 499.63,
                      'passport-priority-ddp-zone-JP': 585.36,
                      'passport-priority-ddp-zone-KR': 486.46,
                      'passport-priority-ddp-zone-NZ': 422.96,
                      'passport-priority-ddp-zone-SG': 423.47,
                      'passport-priority-ddp-zone-TH': 426.18,
                      'passport-priority-ddp-zone-GG': 568.94,
                      'passport-priority-ddp-zone-JE': 568.94,
                      'passport-priority-ddp-zone-NO': 418.18,
                      'passport-priority-ddp-zone-CH': 418.96,
                      'passport-priority-ddp-zone-IS': 365.15,
                      'passport-priority-ddp-zone-AI': 460.54,
                      'passport-priority-ddp-zone-AG': 460.54,
                      'passport-priority-ddp-zone-AR': 557.07,
                      'passport-priority-ddp-zone-AW': 460.54,
                      'passport-priority-ddp-zone-BS': 460.54,
                      'passport-priority-ddp-zone-BB': 495.89,
                      'passport-priority-ddp-zone-BZ': 549.24,
                      'passport-priority-ddp-zone-BM': 461.58,
                      'passport-priority-ddp-zone-BO': 561.74,
                      'passport-priority-ddp-zone-BR': 419.62,
                      'passport-priority-ddp-zone-KY': 460.54,
                      'passport-priority-ddp-zone-CL': 475.36,
                      'passport-priority-ddp-zone-CO': 419.62,
                      'passport-priority-ddp-zone-CR': 558.28,
                      'passport-priority-ddp-zone-DM': 460.54,
                      'passport-priority-ddp-zone-DO': 462.08,
                      'passport-priority-ddp-zone-EC': 558.89,
                      'passport-priority-ddp-zone-SV': 549.24,
                      'passport-priority-ddp-zone-GP': 539.53,
                      'passport-priority-ddp-zone-GT': 549.34,
                      'passport-priority-ddp-zone-GY': 549.24,
                      'passport-priority-ddp-zone-HT': 460.54,
                      'passport-priority-ddp-zone-JM': 508.31,
                      'passport-priority-ddp-zone-MQ': 486.87,
                      'passport-priority-ddp-zone-AN': 460.54,
                      'passport-priority-ddp-zone-NI': 556.6,
                      'passport-priority-ddp-zone-PA': 549.9,
                      'passport-priority-ddp-zone-PY': 549.24,
                      'passport-priority-ddp-zone-PE': 554.47,
                      'passport-priority-ddp-zone-SR': 549.24,
                      'passport-priority-ddp-zone-TT': 474.05,
                      'passport-priority-ddp-zone-UY': 549.24,
                      'passport-priority-ddp-zone-AF': 777.39,
                      'passport-priority-ddp-zone-DZ': 777.39,
                      'passport-priority-ddp-zone-BH': 755.36,
                      'passport-priority-ddp-zone-BD': 686.72,
                      'passport-priority-ddp-zone-BT': 686.72,
                      'passport-priority-ddp-zone-BA': 777.39,
                      'passport-priority-ddp-zone-BW': 777.39,
                      'passport-priority-ddp-zone-BN': 755.36,
                      'passport-priority-ddp-zone-BF': 777.39,
                      'passport-priority-ddp-zone-BI': 777.39,
                      'passport-priority-ddp-zone-KH': 777.39,
                      'passport-priority-ddp-zone-CM': 777.39,
                      'passport-priority-ddp-zone-CV': 777.39,
                      'passport-priority-ddp-zone-TD': 777.39,
                      'passport-priority-ddp-zone-CG': 777.39,
                      'passport-priority-ddp-zone-CI': 777.39,
                      'passport-priority-ddp-zone-EG': 755.36,
                      'passport-priority-ddp-zone-ET': 777.39,
                      'passport-priority-ddp-zone-GA': 777.39,
                      'passport-priority-ddp-zone-GM': 777.39,
                      'passport-priority-ddp-zone-GH': 777.39,
                      'passport-priority-ddp-zone-GN': 777.39,
                      'passport-priority-ddp-zone-ID': 686.6,
                      'passport-priority-ddp-zone-JO': 755.36,
                      'passport-priority-ddp-zone-KE': 777.39,
                      'passport-priority-ddp-zone-KW': 756.8,
                      'passport-priority-ddp-zone-LB': 755.36,
                      'passport-priority-ddp-zone-LI': 755.03,
                      'passport-priority-ddp-zone-MO': 688.25,
                      'passport-priority-ddp-zone-MG': 777.39,
                      'passport-priority-ddp-zone-MW': 777.39,
                      'passport-priority-ddp-zone-MY': 663.5,
                      'passport-priority-ddp-zone-MV': 686.72,
                      'passport-priority-ddp-zone-ML': 777.39,
                      'passport-priority-ddp-zone-MR': 777.39,
                      'passport-priority-ddp-zone-MU': 777.39,
                      'passport-priority-ddp-zone-MD': 777.39,
                      'passport-priority-ddp-zone-MA': 778.41,
                      'passport-priority-ddp-zone-MZ': 777.39,
                      'passport-priority-ddp-zone-NA': 777.39,
                      'passport-priority-ddp-zone-NP': 686.72,
                      'passport-priority-ddp-zone-NE': 777.39,
                      'passport-priority-ddp-zone-NG': 777.39,
                      'passport-priority-ddp-zone-PK': 686.72,
                      'passport-priority-ddp-zone-PH': 664.75,
                      'passport-priority-ddp-zone-RE': 777.39,
                      'passport-priority-ddp-zone-RW': 777.39,
                      'passport-priority-ddp-zone-SN': 777.39,
                      'passport-priority-ddp-zone-SC': 777.39,
                      'passport-priority-ddp-zone-ZA': 728.7,
                      'passport-priority-ddp-zone-LK': 686.72,
                      'passport-priority-ddp-zone-SZ': 777.39,
                      'passport-priority-ddp-zone-TW': 664.75,
                      'passport-priority-ddp-zone-TJ': 777.39,
                      'passport-priority-ddp-zone-TZ': 777.39,
                      'passport-priority-ddp-zone-TG': 777.39,
                      'passport-priority-ddp-zone-TN': 777.39,
                      'passport-priority-ddp-zone-TR': 755.39,
                      'passport-priority-ddp-zone-TM': 777.39,
                      'passport-priority-ddp-zone-UG': 777.39,
                      'passport-priority-ddp-zone-UA': 777.39,
                      'passport-priority-ddp-zone-VN': 664.25,
                      'passport-priority-ddp-zone-YE': 755.36,
                      'passport-priority-ddp-zone-ZM': 777.39,
                      'passport-priority-ddp-zone-ZW': 777.39,
                      'passport-priority-ddp-zone-MC': 305.69,
                      'passport-priority-ddp-zone-IM': 299.81,
                      'passport-priority-ddp-zone-SM': 305.69,
                    },
                  },
                },
                startDateTime: '2022-08-10T01:44:38.422Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:44fbabea-64b1-453b-99b7-942da4aa20e1:3',
          },
          tags: [],
        },
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-08-10T01:43:52.631Z',
              lastUpdatedBy: '2f8f288d-bb47-45a1-88c4-9aec384de964',
              lastUpdatedTimeStamp: '2023-01-28T02:08:33.731Z',
              version: 2,
            },
            carrier: 'passport',
            carrierRateId: 'a6fe508b-b658-4131-9dea-5ed88f0cbba7',
            carrierServiceMethodId: 'passport-priorityddp-light-service-method',
            description: '',
            destinationType: 'all',
            dimWeightOverride: {},
            name: 'Stord - Passport Priority DDP Less Than 64oz',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2027-08-10T01:40:02.623Z',
                negotiatedSurcharges: [],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'passport-priority-ddp-zone-CA': 12.93,
                      'passport-priority-ddp-zone-GB': 11.75,
                      'passport-priority-ddp-zone-AU': 17.35,
                      'passport-priority-ddp-zone-BE': 15.91,
                      'passport-priority-ddp-zone-DK': 15.91,
                      'passport-priority-ddp-zone-FR': 15.91,
                      'passport-priority-ddp-zone-DE': 15.91,
                      'passport-priority-ddp-zone-IT': 15.91,
                      'passport-priority-ddp-zone-NL': 15.91,
                      'passport-priority-ddp-zone-ES': 15.91,
                      'passport-priority-ddp-zone-MX': 12.42,
                      'passport-priority-ddp-zone-AM': 47.49,
                      'passport-priority-ddp-zone-AT': 22.81,
                      'passport-priority-ddp-zone-BG': 26.38,
                      'passport-priority-ddp-zone-HR': 24.71,
                      'passport-priority-ddp-zone-CY': 22.81,
                      'passport-priority-ddp-zone-CZ': 22.81,
                      'passport-priority-ddp-zone-EE': 22.81,
                      'passport-priority-ddp-zone-FI': 22.81,
                      'passport-priority-ddp-zone-GR': 22.81,
                      'passport-priority-ddp-zone-HU': 22.81,
                      'passport-priority-ddp-zone-IE': 22.81,
                      'passport-priority-ddp-zone-LV': 22.81,
                      'passport-priority-ddp-zone-LT': 22.81,
                      'passport-priority-ddp-zone-LU': 22.81,
                      'passport-priority-ddp-zone-MT': 22.81,
                      'passport-priority-ddp-zone-PL': 22.81,
                      'passport-priority-ddp-zone-PT': 22.81,
                      'passport-priority-ddp-zone-RO': 22.81,
                      'passport-priority-ddp-zone-SK': 22.81,
                      'passport-priority-ddp-zone-SI': 22.81,
                      'passport-priority-ddp-zone-SE': 22.81,
                      'passport-priority-ddp-zone-IL': 41.32,
                      'passport-priority-ddp-zone-OM': 45.37,
                      'passport-priority-ddp-zone-QA': 41.32,
                      'passport-priority-ddp-zone-SA': 41.32,
                      'passport-priority-ddp-zone-AE': 41.32,
                      'passport-priority-ddp-zone-CN': 20.79,
                      'passport-priority-ddp-zone-HK': 22.33,
                      'passport-priority-ddp-zone-IN': 45.23,
                      'passport-priority-ddp-zone-JP': 22.18,
                      'passport-priority-ddp-zone-KR': 19.33,
                      'passport-priority-ddp-zone-NZ': 19.33,
                      'passport-priority-ddp-zone-SG': 22.33,
                      'passport-priority-ddp-zone-TH': 19.33,
                      'passport-priority-ddp-zone-GG': 48.32,
                      'passport-priority-ddp-zone-JE': 48.32,
                      'passport-priority-ddp-zone-NO': 45.56,
                      'passport-priority-ddp-zone-CH': 45.56,
                      'passport-priority-ddp-zone-IS': 45.56,
                      'passport-priority-ddp-zone-AI': 34.32,
                      'passport-priority-ddp-zone-AG': 34.32,
                      'passport-priority-ddp-zone-AR': 45.19,
                      'passport-priority-ddp-zone-AW': 34.32,
                      'passport-priority-ddp-zone-BS': 34.32,
                      'passport-priority-ddp-zone-BB': 41.86,
                      'passport-priority-ddp-zone-BZ': 41.69,
                      'passport-priority-ddp-zone-BM': 34.48,
                      'passport-priority-ddp-zone-BO': 47.34,
                      'passport-priority-ddp-zone-BR': 20.41,
                      'passport-priority-ddp-zone-KY': 34.32,
                      'passport-priority-ddp-zone-CL': 20.41,
                      'passport-priority-ddp-zone-CO': 20.41,
                      'passport-priority-ddp-zone-CR': 45.68,
                      'passport-priority-ddp-zone-DM': 34.32,
                      'passport-priority-ddp-zone-DO': 34.71,
                      'passport-priority-ddp-zone-EC': 45.93,
                      'passport-priority-ddp-zone-SV': 41.69,
                      'passport-priority-ddp-zone-GP': 51.28,
                      'passport-priority-ddp-zone-GT': 41.79,
                      'passport-priority-ddp-zone-GY': 41.69,
                      'passport-priority-ddp-zone-HT': 34.32,
                      'passport-priority-ddp-zone-JM': 44.5,
                      'passport-priority-ddp-zone-MQ': 39.98,
                      'passport-priority-ddp-zone-AN': 34.32,
                      'passport-priority-ddp-zone-NI': 45.08,
                      'passport-priority-ddp-zone-PA': 41.98,
                      'passport-priority-ddp-zone-PY': 41.69,
                      'passport-priority-ddp-zone-PE': 44.03,
                      'passport-priority-ddp-zone-SR': 41.69,
                      'passport-priority-ddp-zone-TT': 37.14,
                      'passport-priority-ddp-zone-UY': 41.69,
                      'passport-priority-ddp-zone-AF': 62.95,
                      'passport-priority-ddp-zone-DZ': 62.95,
                      'passport-priority-ddp-zone-BH': 50.25,
                      'passport-priority-ddp-zone-BD': 56.32,
                      'passport-priority-ddp-zone-BT': 56.32,
                      'passport-priority-ddp-zone-BA': 62.95,
                      'passport-priority-ddp-zone-BW': 62.95,
                      'passport-priority-ddp-zone-BN': 50.25,
                      'passport-priority-ddp-zone-BF': 62.95,
                      'passport-priority-ddp-zone-BI': 62.95,
                      'passport-priority-ddp-zone-KH': 62.95,
                      'passport-priority-ddp-zone-CM': 62.95,
                      'passport-priority-ddp-zone-CV': 62.95,
                      'passport-priority-ddp-zone-TD': 62.95,
                      'passport-priority-ddp-zone-CG': 62.95,
                      'passport-priority-ddp-zone-CI': 62.95,
                      'passport-priority-ddp-zone-EG': 50.25,
                      'passport-priority-ddp-zone-ET': 62.95,
                      'passport-priority-ddp-zone-GA': 62.95,
                      'passport-priority-ddp-zone-GM': 62.95,
                      'passport-priority-ddp-zone-GH': 62.95,
                      'passport-priority-ddp-zone-GN': 62.95,
                      'passport-priority-ddp-zone-ID': 51.76,
                      'passport-priority-ddp-zone-JO': 50.25,
                      'passport-priority-ddp-zone-KE': 62.95,
                      'passport-priority-ddp-zone-KW': 50.25,
                      'passport-priority-ddp-zone-LB': 50.25,
                      'passport-priority-ddp-zone-LI': 50.25,
                      'passport-priority-ddp-zone-MO': 50.31,
                      'passport-priority-ddp-zone-MG': 62.95,
                      'passport-priority-ddp-zone-MW': 62.95,
                      'passport-priority-ddp-zone-MY': 50.25,
                      'passport-priority-ddp-zone-MV': 56.32,
                      'passport-priority-ddp-zone-ML': 62.95,
                      'passport-priority-ddp-zone-MR': 62.95,
                      'passport-priority-ddp-zone-MU': 62.95,
                      'passport-priority-ddp-zone-MD': 62.95,
                      'passport-priority-ddp-zone-MA': 62.86,
                      'passport-priority-ddp-zone-MZ': 62.95,
                      'passport-priority-ddp-zone-NA': 62.95,
                      'passport-priority-ddp-zone-NP': 56.32,
                      'passport-priority-ddp-zone-NE': 62.95,
                      'passport-priority-ddp-zone-NG': 62.95,
                      'passport-priority-ddp-zone-PK': 56.32,
                      'passport-priority-ddp-zone-PH': 50.25,
                      'passport-priority-ddp-zone-RE': 62.95,
                      'passport-priority-ddp-zone-RW': 62.95,
                      'passport-priority-ddp-zone-SN': 62.95,
                      'passport-priority-ddp-zone-SC': 62.95,
                      'passport-priority-ddp-zone-ZA': 58.34,
                      'passport-priority-ddp-zone-LK': 56.32,
                      'passport-priority-ddp-zone-SZ': 62.95,
                      'passport-priority-ddp-zone-TW': 50.25,
                      'passport-priority-ddp-zone-TJ': 62.95,
                      'passport-priority-ddp-zone-TZ': 62.95,
                      'passport-priority-ddp-zone-TG': 62.95,
                      'passport-priority-ddp-zone-TN': 62.95,
                      'passport-priority-ddp-zone-TR': 50.25,
                      'passport-priority-ddp-zone-TM': 62.95,
                      'passport-priority-ddp-zone-UG': 62.95,
                      'passport-priority-ddp-zone-UA': 62.95,
                      'passport-priority-ddp-zone-VN': 50.25,
                      'passport-priority-ddp-zone-YE': 50.25,
                      'passport-priority-ddp-zone-ZM': 62.95,
                      'passport-priority-ddp-zone-ZW': 62.95,
                      'passport-priority-ddp-zone-MC': 15.91,
                      'passport-priority-ddp-zone-IM': 11.75,
                      'passport-priority-ddp-zone-SM': 15.91,
                    },
                    '2': {
                      'passport-priority-ddp-zone-CA': 15.27,
                      'passport-priority-ddp-zone-GB': 15.48,
                      'passport-priority-ddp-zone-AU': 22.48,
                      'passport-priority-ddp-zone-BE': 20.31,
                      'passport-priority-ddp-zone-DK': 20.31,
                      'passport-priority-ddp-zone-FR': 20.31,
                      'passport-priority-ddp-zone-DE': 20.31,
                      'passport-priority-ddp-zone-IT': 20.31,
                      'passport-priority-ddp-zone-NL': 20.31,
                      'passport-priority-ddp-zone-ES': 20.31,
                      'passport-priority-ddp-zone-MX': 17.25,
                      'passport-priority-ddp-zone-AM': 48.63,
                      'passport-priority-ddp-zone-AT': 26.86,
                      'passport-priority-ddp-zone-BG': 30.32,
                      'passport-priority-ddp-zone-HR': 28.78,
                      'passport-priority-ddp-zone-CY': 26.86,
                      'passport-priority-ddp-zone-CZ': 26.86,
                      'passport-priority-ddp-zone-EE': 26.86,
                      'passport-priority-ddp-zone-FI': 26.86,
                      'passport-priority-ddp-zone-GR': 26.86,
                      'passport-priority-ddp-zone-HU': 26.86,
                      'passport-priority-ddp-zone-IE': 26.86,
                      'passport-priority-ddp-zone-LV': 26.86,
                      'passport-priority-ddp-zone-LT': 26.86,
                      'passport-priority-ddp-zone-LU': 26.86,
                      'passport-priority-ddp-zone-MT': 26.86,
                      'passport-priority-ddp-zone-PL': 26.86,
                      'passport-priority-ddp-zone-PT': 26.86,
                      'passport-priority-ddp-zone-RO': 26.86,
                      'passport-priority-ddp-zone-SK': 26.86,
                      'passport-priority-ddp-zone-SI': 26.86,
                      'passport-priority-ddp-zone-SE': 26.86,
                      'passport-priority-ddp-zone-IL': 48.7,
                      'passport-priority-ddp-zone-OM': 55.87,
                      'passport-priority-ddp-zone-QA': 48.27,
                      'passport-priority-ddp-zone-SA': 48.3,
                      'passport-priority-ddp-zone-AE': 48.61,
                      'passport-priority-ddp-zone-CN': 30.47,
                      'passport-priority-ddp-zone-HK': 26.96,
                      'passport-priority-ddp-zone-IN': 48.21,
                      'passport-priority-ddp-zone-JP': 31.77,
                      'passport-priority-ddp-zone-KR': 27.12,
                      'passport-priority-ddp-zone-NZ': 25.04,
                      'passport-priority-ddp-zone-SG': 26.96,
                      'passport-priority-ddp-zone-TH': 25.04,
                      'passport-priority-ddp-zone-GG': 48.96,
                      'passport-priority-ddp-zone-JE': 48.96,
                      'passport-priority-ddp-zone-NO': 45.97,
                      'passport-priority-ddp-zone-CH': 46.39,
                      'passport-priority-ddp-zone-IS': 46.16,
                      'passport-priority-ddp-zone-AI': 35.47,
                      'passport-priority-ddp-zone-AG': 35.47,
                      'passport-priority-ddp-zone-AR': 51.8,
                      'passport-priority-ddp-zone-AW': 35.47,
                      'passport-priority-ddp-zone-BS': 35.47,
                      'passport-priority-ddp-zone-BB': 43.01,
                      'passport-priority-ddp-zone-BZ': 48.29,
                      'passport-priority-ddp-zone-BM': 35.62,
                      'passport-priority-ddp-zone-BO': 53.94,
                      'passport-priority-ddp-zone-BR': 26.48,
                      'passport-priority-ddp-zone-KY': 35.47,
                      'passport-priority-ddp-zone-CL': 26.62,
                      'passport-priority-ddp-zone-CO': 26.48,
                      'passport-priority-ddp-zone-CR': 52.29,
                      'passport-priority-ddp-zone-DM': 35.47,
                      'passport-priority-ddp-zone-DO': 35.87,
                      'passport-priority-ddp-zone-EC': 52.53,
                      'passport-priority-ddp-zone-SV': 48.29,
                      'passport-priority-ddp-zone-GP': 52.43,
                      'passport-priority-ddp-zone-GT': 48.39,
                      'passport-priority-ddp-zone-GY': 48.29,
                      'passport-priority-ddp-zone-HT': 35.47,
                      'passport-priority-ddp-zone-JM': 45.64,
                      'passport-priority-ddp-zone-MQ': 41.12,
                      'passport-priority-ddp-zone-AN': 35.47,
                      'passport-priority-ddp-zone-NI': 51.69,
                      'passport-priority-ddp-zone-PA': 48.59,
                      'passport-priority-ddp-zone-PY': 48.29,
                      'passport-priority-ddp-zone-PE': 50.63,
                      'passport-priority-ddp-zone-SR': 48.29,
                      'passport-priority-ddp-zone-TT': 38.3,
                      'passport-priority-ddp-zone-UY': 48.29,
                      'passport-priority-ddp-zone-AF': 63.9,
                      'passport-priority-ddp-zone-DZ': 63.9,
                      'passport-priority-ddp-zone-BH': 54.86,
                      'passport-priority-ddp-zone-BD': 57.08,
                      'passport-priority-ddp-zone-BT': 57.08,
                      'passport-priority-ddp-zone-BA': 63.9,
                      'passport-priority-ddp-zone-BW': 63.9,
                      'passport-priority-ddp-zone-BN': 54.86,
                      'passport-priority-ddp-zone-BF': 63.9,
                      'passport-priority-ddp-zone-BI': 63.9,
                      'passport-priority-ddp-zone-KH': 63.9,
                      'passport-priority-ddp-zone-CM': 63.9,
                      'passport-priority-ddp-zone-CV': 63.9,
                      'passport-priority-ddp-zone-TD': 63.9,
                      'passport-priority-ddp-zone-CG': 63.9,
                      'passport-priority-ddp-zone-CI': 63.9,
                      'passport-priority-ddp-zone-EG': 54.86,
                      'passport-priority-ddp-zone-ET': 63.9,
                      'passport-priority-ddp-zone-GA': 63.9,
                      'passport-priority-ddp-zone-GM': 63.9,
                      'passport-priority-ddp-zone-GH': 63.9,
                      'passport-priority-ddp-zone-GN': 63.9,
                      'passport-priority-ddp-zone-ID': 54.15,
                      'passport-priority-ddp-zone-JO': 54.86,
                      'passport-priority-ddp-zone-KE': 63.9,
                      'passport-priority-ddp-zone-KW': 55.14,
                      'passport-priority-ddp-zone-LB': 54.86,
                      'passport-priority-ddp-zone-LI': 52.62,
                      'passport-priority-ddp-zone-MO': 53.21,
                      'passport-priority-ddp-zone-MG': 63.9,
                      'passport-priority-ddp-zone-MW': 63.9,
                      'passport-priority-ddp-zone-MY': 51.41,
                      'passport-priority-ddp-zone-MV': 57.08,
                      'passport-priority-ddp-zone-ML': 63.9,
                      'passport-priority-ddp-zone-MR': 63.9,
                      'passport-priority-ddp-zone-MU': 63.9,
                      'passport-priority-ddp-zone-MD': 63.9,
                      'passport-priority-ddp-zone-MA': 64.19,
                      'passport-priority-ddp-zone-MZ': 63.9,
                      'passport-priority-ddp-zone-NA': 63.9,
                      'passport-priority-ddp-zone-NP': 57.08,
                      'passport-priority-ddp-zone-NE': 63.9,
                      'passport-priority-ddp-zone-NG': 63.9,
                      'passport-priority-ddp-zone-PK': 57.08,
                      'passport-priority-ddp-zone-PH': 51.41,
                      'passport-priority-ddp-zone-RE': 63.9,
                      'passport-priority-ddp-zone-RW': 63.9,
                      'passport-priority-ddp-zone-SN': 63.9,
                      'passport-priority-ddp-zone-SC': 63.9,
                      'passport-priority-ddp-zone-ZA': 59.1,
                      'passport-priority-ddp-zone-LK': 57.08,
                      'passport-priority-ddp-zone-SZ': 63.9,
                      'passport-priority-ddp-zone-TW': 51.41,
                      'passport-priority-ddp-zone-TJ': 63.9,
                      'passport-priority-ddp-zone-TZ': 63.9,
                      'passport-priority-ddp-zone-TG': 63.9,
                      'passport-priority-ddp-zone-TN': 63.9,
                      'passport-priority-ddp-zone-TR': 54.9,
                      'passport-priority-ddp-zone-TM': 63.9,
                      'passport-priority-ddp-zone-UG': 63.9,
                      'passport-priority-ddp-zone-UA': 63.9,
                      'passport-priority-ddp-zone-VN': 51.41,
                      'passport-priority-ddp-zone-YE': 54.86,
                      'passport-priority-ddp-zone-ZM': 63.9,
                      'passport-priority-ddp-zone-ZW': 63.9,
                      'passport-priority-ddp-zone-MC': 20.31,
                      'passport-priority-ddp-zone-IM': 15.48,
                      'passport-priority-ddp-zone-SM': 20.31,
                    },
                    '3': {
                      'passport-priority-ddp-zone-CA': 17.24,
                      'passport-priority-ddp-zone-GB': 19.68,
                      'passport-priority-ddp-zone-AU': 28.45,
                      'passport-priority-ddp-zone-BE': 24.87,
                      'passport-priority-ddp-zone-DK': 24.87,
                      'passport-priority-ddp-zone-FR': 24.87,
                      'passport-priority-ddp-zone-DE': 24.87,
                      'passport-priority-ddp-zone-IT': 24.87,
                      'passport-priority-ddp-zone-NL': 24.87,
                      'passport-priority-ddp-zone-ES': 24.87,
                      'passport-priority-ddp-zone-MX': 22.58,
                      'passport-priority-ddp-zone-AM': 52.78,
                      'passport-priority-ddp-zone-AT': 31.31,
                      'passport-priority-ddp-zone-BG': 34.29,
                      'passport-priority-ddp-zone-HR': 32.97,
                      'passport-priority-ddp-zone-CY': 31.57,
                      'passport-priority-ddp-zone-CZ': 31.31,
                      'passport-priority-ddp-zone-EE': 31.31,
                      'passport-priority-ddp-zone-FI': 31.31,
                      'passport-priority-ddp-zone-GR': 31.31,
                      'passport-priority-ddp-zone-HU': 31.31,
                      'passport-priority-ddp-zone-IE': 31.31,
                      'passport-priority-ddp-zone-LV': 31.31,
                      'passport-priority-ddp-zone-LT': 31.31,
                      'passport-priority-ddp-zone-LU': 31.31,
                      'passport-priority-ddp-zone-MT': 31.31,
                      'passport-priority-ddp-zone-PL': 31.31,
                      'passport-priority-ddp-zone-PT': 31.31,
                      'passport-priority-ddp-zone-RO': 31.31,
                      'passport-priority-ddp-zone-SK': 31.31,
                      'passport-priority-ddp-zone-SI': 31.31,
                      'passport-priority-ddp-zone-SE': 31.31,
                      'passport-priority-ddp-zone-IL': 60.92,
                      'passport-priority-ddp-zone-OM': 69.05,
                      'passport-priority-ddp-zone-QA': 60.42,
                      'passport-priority-ddp-zone-SA': 60.46,
                      'passport-priority-ddp-zone-AE': 60.82,
                      'passport-priority-ddp-zone-CN': 40.12,
                      'passport-priority-ddp-zone-HK': 33.18,
                      'passport-priority-ddp-zone-IN': 50.5,
                      'passport-priority-ddp-zone-JP': 41.37,
                      'passport-priority-ddp-zone-KR': 35.33,
                      'passport-priority-ddp-zone-NZ': 30.76,
                      'passport-priority-ddp-zone-SG': 33.18,
                      'passport-priority-ddp-zone-TH': 31.32,
                      'passport-priority-ddp-zone-GG': 52.16,
                      'passport-priority-ddp-zone-JE': 52.16,
                      'passport-priority-ddp-zone-NO': 50.58,
                      'passport-priority-ddp-zone-CH': 50.99,
                      'passport-priority-ddp-zone-IS': 47.09,
                      'passport-priority-ddp-zone-AI': 36.62,
                      'passport-priority-ddp-zone-AG': 36.62,
                      'passport-priority-ddp-zone-AR': 58.41,
                      'passport-priority-ddp-zone-AW': 36.62,
                      'passport-priority-ddp-zone-BS': 36.62,
                      'passport-priority-ddp-zone-BB': 44.16,
                      'passport-priority-ddp-zone-BZ': 54.91,
                      'passport-priority-ddp-zone-BM': 36.78,
                      'passport-priority-ddp-zone-BO': 60.57,
                      'passport-priority-ddp-zone-BR': 33.21,
                      'passport-priority-ddp-zone-KY': 36.62,
                      'passport-priority-ddp-zone-CL': 33.76,
                      'passport-priority-ddp-zone-CO': 33.21,
                      'passport-priority-ddp-zone-CR': 58.9,
                      'passport-priority-ddp-zone-DM': 36.62,
                      'passport-priority-ddp-zone-DO': 37.02,
                      'passport-priority-ddp-zone-EC': 59.16,
                      'passport-priority-ddp-zone-SV': 54.91,
                      'passport-priority-ddp-zone-GP': 53.59,
                      'passport-priority-ddp-zone-GT': 55.01,
                      'passport-priority-ddp-zone-GY': 54.91,
                      'passport-priority-ddp-zone-HT': 36.62,
                      'passport-priority-ddp-zone-JM': 46.8,
                      'passport-priority-ddp-zone-MQ': 42.28,
                      'passport-priority-ddp-zone-AN': 36.62,
                      'passport-priority-ddp-zone-NI': 58.31,
                      'passport-priority-ddp-zone-PA': 55.21,
                      'passport-priority-ddp-zone-PY': 54.91,
                      'passport-priority-ddp-zone-PE': 57.26,
                      'passport-priority-ddp-zone-SR': 54.91,
                      'passport-priority-ddp-zone-TT': 39.44,
                      'passport-priority-ddp-zone-UY': 54.91,
                      'passport-priority-ddp-zone-AF': 78.91,
                      'passport-priority-ddp-zone-DZ': 78.91,
                      'passport-priority-ddp-zone-BH': 70.2,
                      'passport-priority-ddp-zone-BD': 71.97,
                      'passport-priority-ddp-zone-BT': 71.97,
                      'passport-priority-ddp-zone-BA': 78.91,
                      'passport-priority-ddp-zone-BW': 78.91,
                      'passport-priority-ddp-zone-BN': 70.2,
                      'passport-priority-ddp-zone-BF': 78.91,
                      'passport-priority-ddp-zone-BI': 78.91,
                      'passport-priority-ddp-zone-KH': 78.91,
                      'passport-priority-ddp-zone-CM': 78.91,
                      'passport-priority-ddp-zone-CV': 78.91,
                      'passport-priority-ddp-zone-TD': 78.91,
                      'passport-priority-ddp-zone-CG': 78.91,
                      'passport-priority-ddp-zone-CI': 78.91,
                      'passport-priority-ddp-zone-EG': 70.2,
                      'passport-priority-ddp-zone-ET': 78.91,
                      'passport-priority-ddp-zone-GA': 78.91,
                      'passport-priority-ddp-zone-GM': 78.91,
                      'passport-priority-ddp-zone-GH': 78.91,
                      'passport-priority-ddp-zone-GN': 78.91,
                      'passport-priority-ddp-zone-ID': 66.9,
                      'passport-priority-ddp-zone-JO': 70.2,
                      'passport-priority-ddp-zone-KE': 78.91,
                      'passport-priority-ddp-zone-KW': 70.53,
                      'passport-priority-ddp-zone-LB': 70.2,
                      'passport-priority-ddp-zone-LI': 63.92,
                      'passport-priority-ddp-zone-MO': 65.85,
                      'passport-priority-ddp-zone-MG': 78.91,
                      'passport-priority-ddp-zone-MW': 78.91,
                      'passport-priority-ddp-zone-MY': 60.14,
                      'passport-priority-ddp-zone-MV': 71.97,
                      'passport-priority-ddp-zone-ML': 78.91,
                      'passport-priority-ddp-zone-MR': 78.91,
                      'passport-priority-ddp-zone-MU': 78.91,
                      'passport-priority-ddp-zone-MD': 78.91,
                      'passport-priority-ddp-zone-MA': 79.23,
                      'passport-priority-ddp-zone-MZ': 78.91,
                      'passport-priority-ddp-zone-NA': 78.91,
                      'passport-priority-ddp-zone-NP': 71.97,
                      'passport-priority-ddp-zone-NE': 78.91,
                      'passport-priority-ddp-zone-NG': 78.91,
                      'passport-priority-ddp-zone-PK': 71.97,
                      'passport-priority-ddp-zone-PH': 60.14,
                      'passport-priority-ddp-zone-RE': 78.91,
                      'passport-priority-ddp-zone-RW': 78.91,
                      'passport-priority-ddp-zone-SN': 78.91,
                      'passport-priority-ddp-zone-SC': 78.91,
                      'passport-priority-ddp-zone-ZA': 67.74,
                      'passport-priority-ddp-zone-LK': 71.97,
                      'passport-priority-ddp-zone-SZ': 78.91,
                      'passport-priority-ddp-zone-TW': 60.14,
                      'passport-priority-ddp-zone-TJ': 78.91,
                      'passport-priority-ddp-zone-TZ': 78.91,
                      'passport-priority-ddp-zone-TG': 78.91,
                      'passport-priority-ddp-zone-TN': 78.91,
                      'passport-priority-ddp-zone-TR': 70.24,
                      'passport-priority-ddp-zone-TM': 78.91,
                      'passport-priority-ddp-zone-UG': 78.91,
                      'passport-priority-ddp-zone-UA': 78.91,
                      'passport-priority-ddp-zone-VN': 60.14,
                      'passport-priority-ddp-zone-YE': 70.2,
                      'passport-priority-ddp-zone-ZM': 78.91,
                      'passport-priority-ddp-zone-ZW': 78.91,
                      'passport-priority-ddp-zone-MC': 24.87,
                      'passport-priority-ddp-zone-IM': 19.68,
                      'passport-priority-ddp-zone-SM': 24.87,
                    },
                    '4': {
                      'passport-priority-ddp-zone-CA': 18.97,
                      'passport-priority-ddp-zone-GB': 23.88,
                      'passport-priority-ddp-zone-AU': 34.43,
                      'passport-priority-ddp-zone-BE': 28.87,
                      'passport-priority-ddp-zone-DK': 28.87,
                      'passport-priority-ddp-zone-FR': 28.87,
                      'passport-priority-ddp-zone-DE': 28.87,
                      'passport-priority-ddp-zone-IT': 28.87,
                      'passport-priority-ddp-zone-NL': 28.87,
                      'passport-priority-ddp-zone-ES': 28.87,
                      'passport-priority-ddp-zone-MX': 27.9,
                      'passport-priority-ddp-zone-AM': 60.97,
                      'passport-priority-ddp-zone-AT': 35.74,
                      'passport-priority-ddp-zone-BG': 38.51,
                      'passport-priority-ddp-zone-HR': 36.97,
                      'passport-priority-ddp-zone-CY': 36.31,
                      'passport-priority-ddp-zone-CZ': 35.74,
                      'passport-priority-ddp-zone-EE': 35.74,
                      'passport-priority-ddp-zone-FI': 35.74,
                      'passport-priority-ddp-zone-GR': 35.74,
                      'passport-priority-ddp-zone-HU': 35.74,
                      'passport-priority-ddp-zone-IE': 35.74,
                      'passport-priority-ddp-zone-LV': 35.74,
                      'passport-priority-ddp-zone-LT': 35.74,
                      'passport-priority-ddp-zone-LU': 35.74,
                      'passport-priority-ddp-zone-MT': 35.74,
                      'passport-priority-ddp-zone-PL': 35.74,
                      'passport-priority-ddp-zone-PT': 35.74,
                      'passport-priority-ddp-zone-RO': 35.74,
                      'passport-priority-ddp-zone-SK': 35.74,
                      'passport-priority-ddp-zone-SI': 35.74,
                      'passport-priority-ddp-zone-SE': 35.74,
                      'passport-priority-ddp-zone-IL': 63.99,
                      'passport-priority-ddp-zone-OM': 71.65,
                      'passport-priority-ddp-zone-QA': 63.53,
                      'passport-priority-ddp-zone-SA': 63.56,
                      'passport-priority-ddp-zone-AE': 63.9,
                      'passport-priority-ddp-zone-CN': 49.79,
                      'passport-priority-ddp-zone-HK': 37.49,
                      'passport-priority-ddp-zone-IN': 53.58,
                      'passport-priority-ddp-zone-JP': 50.96,
                      'passport-priority-ddp-zone-KR': 43.56,
                      'passport-priority-ddp-zone-NZ': 36.47,
                      'passport-priority-ddp-zone-SG': 37.49,
                      'passport-priority-ddp-zone-TH': 38.43,
                      'passport-priority-ddp-zone-GG': 65.02,
                      'passport-priority-ddp-zone-JE': 65.02,
                      'passport-priority-ddp-zone-NO': 51.26,
                      'passport-priority-ddp-zone-CH': 51.64,
                      'passport-priority-ddp-zone-IS': 51.24,
                      'passport-priority-ddp-zone-AI': 38.83,
                      'passport-priority-ddp-zone-AG': 38.83,
                      'passport-priority-ddp-zone-AR': 67.54,
                      'passport-priority-ddp-zone-AW': 38.83,
                      'passport-priority-ddp-zone-BS': 38.83,
                      'passport-priority-ddp-zone-BB': 46.37,
                      'passport-priority-ddp-zone-BZ': 64.04,
                      'passport-priority-ddp-zone-BM': 38.99,
                      'passport-priority-ddp-zone-BO': 69.7,
                      'passport-priority-ddp-zone-BR': 38.67,
                      'passport-priority-ddp-zone-KY': 38.83,
                      'passport-priority-ddp-zone-CL': 40.87,
                      'passport-priority-ddp-zone-CO': 38.67,
                      'passport-priority-ddp-zone-CR': 68.03,
                      'passport-priority-ddp-zone-DM': 38.83,
                      'passport-priority-ddp-zone-DO': 39.22,
                      'passport-priority-ddp-zone-EC': 68.28,
                      'passport-priority-ddp-zone-SV': 64.04,
                      'passport-priority-ddp-zone-GP': 55.8,
                      'passport-priority-ddp-zone-GT': 64.14,
                      'passport-priority-ddp-zone-GY': 64.04,
                      'passport-priority-ddp-zone-HT': 38.83,
                      'passport-priority-ddp-zone-JM': 49.01,
                      'passport-priority-ddp-zone-MQ': 44.49,
                      'passport-priority-ddp-zone-AN': 38.83,
                      'passport-priority-ddp-zone-NI': 67.43,
                      'passport-priority-ddp-zone-PA': 64.33,
                      'passport-priority-ddp-zone-PY': 64.04,
                      'passport-priority-ddp-zone-PE': 66.39,
                      'passport-priority-ddp-zone-SR': 64.04,
                      'passport-priority-ddp-zone-TT': 41.66,
                      'passport-priority-ddp-zone-UY': 64.04,
                      'passport-priority-ddp-zone-AF': 92.7,
                      'passport-priority-ddp-zone-DZ': 92.7,
                      'passport-priority-ddp-zone-BH': 87.15,
                      'passport-priority-ddp-zone-BD': 86.55,
                      'passport-priority-ddp-zone-BT': 86.55,
                      'passport-priority-ddp-zone-BA': 92.7,
                      'passport-priority-ddp-zone-BW': 92.7,
                      'passport-priority-ddp-zone-BN': 87.15,
                      'passport-priority-ddp-zone-BF': 92.7,
                      'passport-priority-ddp-zone-BI': 92.7,
                      'passport-priority-ddp-zone-KH': 92.7,
                      'passport-priority-ddp-zone-CM': 92.7,
                      'passport-priority-ddp-zone-CV': 92.7,
                      'passport-priority-ddp-zone-TD': 92.7,
                      'passport-priority-ddp-zone-CG': 92.7,
                      'passport-priority-ddp-zone-CI': 92.7,
                      'passport-priority-ddp-zone-EG': 87.15,
                      'passport-priority-ddp-zone-ET': 92.7,
                      'passport-priority-ddp-zone-GA': 92.7,
                      'passport-priority-ddp-zone-GM': 92.7,
                      'passport-priority-ddp-zone-GH': 92.7,
                      'passport-priority-ddp-zone-GN': 92.7,
                      'passport-priority-ddp-zone-ID': 80.08,
                      'passport-priority-ddp-zone-JO': 87.15,
                      'passport-priority-ddp-zone-KE': 92.7,
                      'passport-priority-ddp-zone-KW': 87.51,
                      'passport-priority-ddp-zone-LB': 87.15,
                      'passport-priority-ddp-zone-LI': 74.83,
                      'passport-priority-ddp-zone-MO': 78.94,
                      'passport-priority-ddp-zone-MG': 92.7,
                      'passport-priority-ddp-zone-MW': 92.7,
                      'passport-priority-ddp-zone-MY': 74.83,
                      'passport-priority-ddp-zone-MV': 86.55,
                      'passport-priority-ddp-zone-ML': 92.7,
                      'passport-priority-ddp-zone-MR': 92.7,
                      'passport-priority-ddp-zone-MU': 92.7,
                      'passport-priority-ddp-zone-MD': 92.7,
                      'passport-priority-ddp-zone-MA': 93.04,
                      'passport-priority-ddp-zone-MZ': 92.7,
                      'passport-priority-ddp-zone-NA': 92.7,
                      'passport-priority-ddp-zone-NP': 86.55,
                      'passport-priority-ddp-zone-NE': 92.7,
                      'passport-priority-ddp-zone-NG': 92.7,
                      'passport-priority-ddp-zone-PK': 86.55,
                      'passport-priority-ddp-zone-PH': 74.83,
                      'passport-priority-ddp-zone-RE': 92.7,
                      'passport-priority-ddp-zone-RW': 92.7,
                      'passport-priority-ddp-zone-SN': 92.7,
                      'passport-priority-ddp-zone-SC': 92.7,
                      'passport-priority-ddp-zone-ZA': 74.83,
                      'passport-priority-ddp-zone-LK': 86.55,
                      'passport-priority-ddp-zone-SZ': 92.7,
                      'passport-priority-ddp-zone-TW': 74.83,
                      'passport-priority-ddp-zone-TJ': 92.7,
                      'passport-priority-ddp-zone-TZ': 92.7,
                      'passport-priority-ddp-zone-TG': 92.7,
                      'passport-priority-ddp-zone-TN': 92.7,
                      'passport-priority-ddp-zone-TR': 87.2,
                      'passport-priority-ddp-zone-TM': 92.7,
                      'passport-priority-ddp-zone-UG': 92.7,
                      'passport-priority-ddp-zone-UA': 92.7,
                      'passport-priority-ddp-zone-VN': 74.89,
                      'passport-priority-ddp-zone-YE': 87.15,
                      'passport-priority-ddp-zone-ZM': 92.7,
                      'passport-priority-ddp-zone-ZW': 92.7,
                      'passport-priority-ddp-zone-MC': 28.87,
                      'passport-priority-ddp-zone-IM': 23.88,
                      'passport-priority-ddp-zone-SM': 28.87,
                    },
                    '0.0625': {
                      'passport-priority-ddp-zone-CA': 11.79,
                      'passport-priority-ddp-zone-GB': 8.31,
                      'passport-priority-ddp-zone-AU': 8.13,
                      'passport-priority-ddp-zone-BE': 12.21,
                      'passport-priority-ddp-zone-DK': 12.21,
                      'passport-priority-ddp-zone-FR': 12.21,
                      'passport-priority-ddp-zone-DE': 12.21,
                      'passport-priority-ddp-zone-IT': 12.21,
                      'passport-priority-ddp-zone-NL': 12.21,
                      'passport-priority-ddp-zone-ES': 12.21,
                      'passport-priority-ddp-zone-MX': 11.54,
                      'passport-priority-ddp-zone-AM': 46.41,
                      'passport-priority-ddp-zone-AT': 19.23,
                      'passport-priority-ddp-zone-BG': 22.75,
                      'passport-priority-ddp-zone-HR': 20.87,
                      'passport-priority-ddp-zone-CY': 19.23,
                      'passport-priority-ddp-zone-CZ': 19.23,
                      'passport-priority-ddp-zone-EE': 19.23,
                      'passport-priority-ddp-zone-FI': 19.23,
                      'passport-priority-ddp-zone-GR': 19.23,
                      'passport-priority-ddp-zone-HU': 19.23,
                      'passport-priority-ddp-zone-IE': 19.23,
                      'passport-priority-ddp-zone-LV': 19.23,
                      'passport-priority-ddp-zone-LT': 19.23,
                      'passport-priority-ddp-zone-LU': 19.23,
                      'passport-priority-ddp-zone-MT': 19.23,
                      'passport-priority-ddp-zone-PL': 19.23,
                      'passport-priority-ddp-zone-PT': 19.23,
                      'passport-priority-ddp-zone-RO': 19.23,
                      'passport-priority-ddp-zone-SK': 19.23,
                      'passport-priority-ddp-zone-SI': 19.23,
                      'passport-priority-ddp-zone-SE': 19.23,
                      'passport-priority-ddp-zone-IL': 37.42,
                      'passport-priority-ddp-zone-OM': 41.12,
                      'passport-priority-ddp-zone-QA': 37.42,
                      'passport-priority-ddp-zone-SA': 37.42,
                      'passport-priority-ddp-zone-AE': 37.42,
                      'passport-priority-ddp-zone-CN': 19.57,
                      'passport-priority-ddp-zone-HK': 21.25,
                      'passport-priority-ddp-zone-IN': 44.15,
                      'passport-priority-ddp-zone-JP': 20.96,
                      'passport-priority-ddp-zone-KR': 17.68,
                      'passport-priority-ddp-zone-NZ': 16.22,
                      'passport-priority-ddp-zone-SG': 21.25,
                      'passport-priority-ddp-zone-TH': 16.22,
                      'passport-priority-ddp-zone-GG': 46.26,
                      'passport-priority-ddp-zone-JE': 46.26,
                      'passport-priority-ddp-zone-NO': 43.98,
                      'passport-priority-ddp-zone-CH': 43.98,
                      'passport-priority-ddp-zone-IS': 43.98,
                      'passport-priority-ddp-zone-AI': 33.24,
                      'passport-priority-ddp-zone-AG': 33.24,
                      'passport-priority-ddp-zone-AR': 44.12,
                      'passport-priority-ddp-zone-AW': 33.24,
                      'passport-priority-ddp-zone-BS': 33.24,
                      'passport-priority-ddp-zone-BB': 40.78,
                      'passport-priority-ddp-zone-BZ': 40.61,
                      'passport-priority-ddp-zone-BM': 33.4,
                      'passport-priority-ddp-zone-BO': 46.26,
                      'passport-priority-ddp-zone-BR': 18.79,
                      'passport-priority-ddp-zone-KY': 33.24,
                      'passport-priority-ddp-zone-CL': 18.79,
                      'passport-priority-ddp-zone-CO': 18.79,
                      'passport-priority-ddp-zone-CR': 44.61,
                      'passport-priority-ddp-zone-DM': 33.24,
                      'passport-priority-ddp-zone-DO': 33.64,
                      'passport-priority-ddp-zone-EC': 44.85,
                      'passport-priority-ddp-zone-SV': 40.61,
                      'passport-priority-ddp-zone-GP': 50.21,
                      'passport-priority-ddp-zone-GT': 40.71,
                      'passport-priority-ddp-zone-GY': 40.61,
                      'passport-priority-ddp-zone-HT': 33.24,
                      'passport-priority-ddp-zone-JM': 43.42,
                      'passport-priority-ddp-zone-MQ': 38.9,
                      'passport-priority-ddp-zone-AN': 33.24,
                      'passport-priority-ddp-zone-NI': 44.01,
                      'passport-priority-ddp-zone-PA': 40.91,
                      'passport-priority-ddp-zone-PY': 40.61,
                      'passport-priority-ddp-zone-PE': 42.95,
                      'passport-priority-ddp-zone-SR': 40.61,
                      'passport-priority-ddp-zone-TT': 36.06,
                      'passport-priority-ddp-zone-UY': 40.61,
                      'passport-priority-ddp-zone-AF': 60.48,
                      'passport-priority-ddp-zone-DZ': 60.48,
                      'passport-priority-ddp-zone-BH': 48.56,
                      'passport-priority-ddp-zone-BD': 54.09,
                      'passport-priority-ddp-zone-BT': 54.09,
                      'passport-priority-ddp-zone-BA': 60.48,
                      'passport-priority-ddp-zone-BW': 60.48,
                      'passport-priority-ddp-zone-BN': 48.56,
                      'passport-priority-ddp-zone-BF': 60.48,
                      'passport-priority-ddp-zone-BI': 60.48,
                      'passport-priority-ddp-zone-KH': 60.48,
                      'passport-priority-ddp-zone-CM': 60.48,
                      'passport-priority-ddp-zone-CV': 60.48,
                      'passport-priority-ddp-zone-TD': 60.48,
                      'passport-priority-ddp-zone-CG': 60.48,
                      'passport-priority-ddp-zone-CI': 60.48,
                      'passport-priority-ddp-zone-EG': 48.56,
                      'passport-priority-ddp-zone-ET': 60.48,
                      'passport-priority-ddp-zone-GA': 60.48,
                      'passport-priority-ddp-zone-GM': 60.48,
                      'passport-priority-ddp-zone-GH': 60.48,
                      'passport-priority-ddp-zone-GN': 60.48,
                      'passport-priority-ddp-zone-ID': 49.53,
                      'passport-priority-ddp-zone-JO': 48.56,
                      'passport-priority-ddp-zone-KE': 60.48,
                      'passport-priority-ddp-zone-KW': 48.56,
                      'passport-priority-ddp-zone-LB': 48.56,
                      'passport-priority-ddp-zone-LI': 48.56,
                      'passport-priority-ddp-zone-MO': 48.63,
                      'passport-priority-ddp-zone-MG': 60.48,
                      'passport-priority-ddp-zone-MW': 60.48,
                      'passport-priority-ddp-zone-MY': 48.56,
                      'passport-priority-ddp-zone-MV': 54.09,
                      'passport-priority-ddp-zone-ML': 60.48,
                      'passport-priority-ddp-zone-MR': 60.48,
                      'passport-priority-ddp-zone-MU': 60.48,
                      'passport-priority-ddp-zone-MD': 60.48,
                      'passport-priority-ddp-zone-MA': 60.74,
                      'passport-priority-ddp-zone-MZ': 60.48,
                      'passport-priority-ddp-zone-NA': 60.48,
                      'passport-priority-ddp-zone-NP': 54.09,
                      'passport-priority-ddp-zone-NE': 60.48,
                      'passport-priority-ddp-zone-NG': 60.48,
                      'passport-priority-ddp-zone-PK': 54.09,
                      'passport-priority-ddp-zone-PH': 48.56,
                      'passport-priority-ddp-zone-RE': 60.48,
                      'passport-priority-ddp-zone-RW': 60.48,
                      'passport-priority-ddp-zone-SN': 60.48,
                      'passport-priority-ddp-zone-SC': 60.48,
                      'passport-priority-ddp-zone-ZA': 56.17,
                      'passport-priority-ddp-zone-LK': 54.09,
                      'passport-priority-ddp-zone-SZ': 60.48,
                      'passport-priority-ddp-zone-TW': 48.56,
                      'passport-priority-ddp-zone-TJ': 60.48,
                      'passport-priority-ddp-zone-TZ': 60.48,
                      'passport-priority-ddp-zone-TG': 60.48,
                      'passport-priority-ddp-zone-TN': 60.48,
                      'passport-priority-ddp-zone-TR': 48.56,
                      'passport-priority-ddp-zone-TM': 60.48,
                      'passport-priority-ddp-zone-UG': 60.48,
                      'passport-priority-ddp-zone-UA': 60.48,
                      'passport-priority-ddp-zone-VN': 48.56,
                      'passport-priority-ddp-zone-YE': 48.56,
                      'passport-priority-ddp-zone-ZM': 60.48,
                      'passport-priority-ddp-zone-ZW': 60.48,
                      'passport-priority-ddp-zone-MC': 12.21,
                      'passport-priority-ddp-zone-IM': 8.31,
                      'passport-priority-ddp-zone-SM': 12.21,
                    },
                    '0.125': {
                      'passport-priority-ddp-zone-CA': 11.88,
                      'passport-priority-ddp-zone-GB': 8.6,
                      'passport-priority-ddp-zone-AU': 8.98,
                      'passport-priority-ddp-zone-BE': 12.43,
                      'passport-priority-ddp-zone-DK': 12.43,
                      'passport-priority-ddp-zone-FR': 12.43,
                      'passport-priority-ddp-zone-DE': 12.43,
                      'passport-priority-ddp-zone-IT': 12.43,
                      'passport-priority-ddp-zone-NL': 12.43,
                      'passport-priority-ddp-zone-ES': 12.43,
                      'passport-priority-ddp-zone-MX': 11.57,
                      'passport-priority-ddp-zone-AM': 46.48,
                      'passport-priority-ddp-zone-AT': 19.45,
                      'passport-priority-ddp-zone-BG': 22.99,
                      'passport-priority-ddp-zone-HR': 21.1,
                      'passport-priority-ddp-zone-CY': 19.45,
                      'passport-priority-ddp-zone-CZ': 19.45,
                      'passport-priority-ddp-zone-EE': 19.45,
                      'passport-priority-ddp-zone-FI': 19.45,
                      'passport-priority-ddp-zone-GR': 19.45,
                      'passport-priority-ddp-zone-HU': 19.45,
                      'passport-priority-ddp-zone-IE': 19.45,
                      'passport-priority-ddp-zone-LV': 19.45,
                      'passport-priority-ddp-zone-LT': 19.45,
                      'passport-priority-ddp-zone-LU': 19.45,
                      'passport-priority-ddp-zone-MT': 19.45,
                      'passport-priority-ddp-zone-PL': 19.45,
                      'passport-priority-ddp-zone-PT': 19.45,
                      'passport-priority-ddp-zone-RO': 19.45,
                      'passport-priority-ddp-zone-SK': 19.45,
                      'passport-priority-ddp-zone-SI': 19.45,
                      'passport-priority-ddp-zone-SE': 19.45,
                      'passport-priority-ddp-zone-IL': 37.45,
                      'passport-priority-ddp-zone-OM': 41.15,
                      'passport-priority-ddp-zone-QA': 37.45,
                      'passport-priority-ddp-zone-SA': 37.45,
                      'passport-priority-ddp-zone-AE': 37.45,
                      'passport-priority-ddp-zone-CN': 19.66,
                      'passport-priority-ddp-zone-HK': 21.32,
                      'passport-priority-ddp-zone-IN': 44.22,
                      'passport-priority-ddp-zone-JP': 21.04,
                      'passport-priority-ddp-zone-KR': 17.76,
                      'passport-priority-ddp-zone-NZ': 16.42,
                      'passport-priority-ddp-zone-SG': 21.32,
                      'passport-priority-ddp-zone-TH': 16.42,
                      'passport-priority-ddp-zone-GG': 46.28,
                      'passport-priority-ddp-zone-JE': 46.28,
                      'passport-priority-ddp-zone-NO': 44.0,
                      'passport-priority-ddp-zone-CH': 44.0,
                      'passport-priority-ddp-zone-IS': 44.0,
                      'passport-priority-ddp-zone-AI': 33.31,
                      'passport-priority-ddp-zone-AG': 33.31,
                      'passport-priority-ddp-zone-AR': 44.18,
                      'passport-priority-ddp-zone-AW': 33.31,
                      'passport-priority-ddp-zone-BS': 33.31,
                      'passport-priority-ddp-zone-BB': 40.85,
                      'passport-priority-ddp-zone-BZ': 40.68,
                      'passport-priority-ddp-zone-BM': 33.47,
                      'passport-priority-ddp-zone-BO': 46.34,
                      'passport-priority-ddp-zone-BR': 18.9,
                      'passport-priority-ddp-zone-KY': 33.31,
                      'passport-priority-ddp-zone-CL': 18.9,
                      'passport-priority-ddp-zone-CO': 18.9,
                      'passport-priority-ddp-zone-CR': 44.67,
                      'passport-priority-ddp-zone-DM': 33.31,
                      'passport-priority-ddp-zone-DO': 33.7,
                      'passport-priority-ddp-zone-EC': 44.92,
                      'passport-priority-ddp-zone-SV': 40.68,
                      'passport-priority-ddp-zone-GP': 50.28,
                      'passport-priority-ddp-zone-GT': 40.78,
                      'passport-priority-ddp-zone-GY': 40.68,
                      'passport-priority-ddp-zone-HT': 33.31,
                      'passport-priority-ddp-zone-JM': 43.49,
                      'passport-priority-ddp-zone-MQ': 38.97,
                      'passport-priority-ddp-zone-AN': 33.31,
                      'passport-priority-ddp-zone-NI': 44.07,
                      'passport-priority-ddp-zone-PA': 40.98,
                      'passport-priority-ddp-zone-PY': 40.68,
                      'passport-priority-ddp-zone-PE': 43.02,
                      'passport-priority-ddp-zone-SR': 40.68,
                      'passport-priority-ddp-zone-TT': 36.14,
                      'passport-priority-ddp-zone-UY': 40.68,
                      'passport-priority-ddp-zone-AF': 60.5,
                      'passport-priority-ddp-zone-DZ': 60.5,
                      'passport-priority-ddp-zone-BH': 48.58,
                      'passport-priority-ddp-zone-BD': 54.11,
                      'passport-priority-ddp-zone-BT': 54.11,
                      'passport-priority-ddp-zone-BA': 60.5,
                      'passport-priority-ddp-zone-BW': 60.5,
                      'passport-priority-ddp-zone-BN': 48.58,
                      'passport-priority-ddp-zone-BF': 60.5,
                      'passport-priority-ddp-zone-BI': 60.5,
                      'passport-priority-ddp-zone-KH': 60.5,
                      'passport-priority-ddp-zone-CM': 60.5,
                      'passport-priority-ddp-zone-CV': 60.5,
                      'passport-priority-ddp-zone-TD': 60.5,
                      'passport-priority-ddp-zone-CG': 60.5,
                      'passport-priority-ddp-zone-CI': 60.5,
                      'passport-priority-ddp-zone-EG': 48.58,
                      'passport-priority-ddp-zone-ET': 60.5,
                      'passport-priority-ddp-zone-GA': 60.5,
                      'passport-priority-ddp-zone-GM': 60.5,
                      'passport-priority-ddp-zone-GH': 60.5,
                      'passport-priority-ddp-zone-GN': 60.5,
                      'passport-priority-ddp-zone-ID': 49.54,
                      'passport-priority-ddp-zone-JO': 48.58,
                      'passport-priority-ddp-zone-KE': 60.5,
                      'passport-priority-ddp-zone-KW': 48.58,
                      'passport-priority-ddp-zone-LB': 48.58,
                      'passport-priority-ddp-zone-LI': 48.58,
                      'passport-priority-ddp-zone-MO': 48.65,
                      'passport-priority-ddp-zone-MG': 60.5,
                      'passport-priority-ddp-zone-MW': 60.5,
                      'passport-priority-ddp-zone-MY': 48.58,
                      'passport-priority-ddp-zone-MV': 54.11,
                      'passport-priority-ddp-zone-ML': 60.5,
                      'passport-priority-ddp-zone-MR': 60.5,
                      'passport-priority-ddp-zone-MU': 60.5,
                      'passport-priority-ddp-zone-MD': 60.5,
                      'passport-priority-ddp-zone-MA': 60.76,
                      'passport-priority-ddp-zone-MZ': 60.5,
                      'passport-priority-ddp-zone-NA': 60.5,
                      'passport-priority-ddp-zone-NP': 54.11,
                      'passport-priority-ddp-zone-NE': 60.5,
                      'passport-priority-ddp-zone-NG': 60.5,
                      'passport-priority-ddp-zone-PK': 54.11,
                      'passport-priority-ddp-zone-PH': 48.58,
                      'passport-priority-ddp-zone-RE': 60.5,
                      'passport-priority-ddp-zone-RW': 60.5,
                      'passport-priority-ddp-zone-SN': 60.5,
                      'passport-priority-ddp-zone-SC': 60.5,
                      'passport-priority-ddp-zone-ZA': 56.19,
                      'passport-priority-ddp-zone-LK': 54.11,
                      'passport-priority-ddp-zone-SZ': 60.5,
                      'passport-priority-ddp-zone-TW': 48.58,
                      'passport-priority-ddp-zone-TJ': 60.5,
                      'passport-priority-ddp-zone-TZ': 60.5,
                      'passport-priority-ddp-zone-TG': 60.5,
                      'passport-priority-ddp-zone-TN': 60.5,
                      'passport-priority-ddp-zone-TR': 48.58,
                      'passport-priority-ddp-zone-TM': 60.5,
                      'passport-priority-ddp-zone-UG': 60.5,
                      'passport-priority-ddp-zone-UA': 60.5,
                      'passport-priority-ddp-zone-VN': 48.58,
                      'passport-priority-ddp-zone-YE': 48.58,
                      'passport-priority-ddp-zone-ZM': 60.5,
                      'passport-priority-ddp-zone-ZW': 60.5,
                      'passport-priority-ddp-zone-MC': 12.43,
                      'passport-priority-ddp-zone-IM': 8.6,
                      'passport-priority-ddp-zone-SM': 12.43,
                    },
                    '0.1875': {
                      'passport-priority-ddp-zone-CA': 11.94,
                      'passport-priority-ddp-zone-GB': 8.9,
                      'passport-priority-ddp-zone-AU': 9.85,
                      'passport-priority-ddp-zone-BE': 12.62,
                      'passport-priority-ddp-zone-DK': 12.62,
                      'passport-priority-ddp-zone-FR': 12.62,
                      'passport-priority-ddp-zone-DE': 12.62,
                      'passport-priority-ddp-zone-IT': 12.62,
                      'passport-priority-ddp-zone-NL': 12.62,
                      'passport-priority-ddp-zone-ES': 12.62,
                      'passport-priority-ddp-zone-MX': 11.6,
                      'passport-priority-ddp-zone-AM': 46.55,
                      'passport-priority-ddp-zone-AT': 19.66,
                      'passport-priority-ddp-zone-BG': 23.22,
                      'passport-priority-ddp-zone-HR': 21.34,
                      'passport-priority-ddp-zone-CY': 19.66,
                      'passport-priority-ddp-zone-CZ': 19.66,
                      'passport-priority-ddp-zone-EE': 19.66,
                      'passport-priority-ddp-zone-FI': 19.66,
                      'passport-priority-ddp-zone-GR': 19.66,
                      'passport-priority-ddp-zone-HU': 19.66,
                      'passport-priority-ddp-zone-IE': 19.66,
                      'passport-priority-ddp-zone-LV': 19.66,
                      'passport-priority-ddp-zone-LT': 19.66,
                      'passport-priority-ddp-zone-LU': 19.66,
                      'passport-priority-ddp-zone-MT': 19.66,
                      'passport-priority-ddp-zone-PL': 19.66,
                      'passport-priority-ddp-zone-PT': 19.66,
                      'passport-priority-ddp-zone-RO': 19.66,
                      'passport-priority-ddp-zone-SK': 19.66,
                      'passport-priority-ddp-zone-SI': 19.66,
                      'passport-priority-ddp-zone-SE': 19.66,
                      'passport-priority-ddp-zone-IL': 37.46,
                      'passport-priority-ddp-zone-OM': 41.17,
                      'passport-priority-ddp-zone-QA': 37.46,
                      'passport-priority-ddp-zone-SA': 37.46,
                      'passport-priority-ddp-zone-AE': 37.46,
                      'passport-priority-ddp-zone-CN': 19.73,
                      'passport-priority-ddp-zone-HK': 21.4,
                      'passport-priority-ddp-zone-IN': 44.3,
                      'passport-priority-ddp-zone-JP': 21.12,
                      'passport-priority-ddp-zone-KR': 17.84,
                      'passport-priority-ddp-zone-NZ': 16.63,
                      'passport-priority-ddp-zone-SG': 21.4,
                      'passport-priority-ddp-zone-TH': 16.63,
                      'passport-priority-ddp-zone-GG': 46.29,
                      'passport-priority-ddp-zone-JE': 46.29,
                      'passport-priority-ddp-zone-NO': 44.01,
                      'passport-priority-ddp-zone-CH': 44.01,
                      'passport-priority-ddp-zone-IS': 44.01,
                      'passport-priority-ddp-zone-AI': 33.39,
                      'passport-priority-ddp-zone-AG': 33.39,
                      'passport-priority-ddp-zone-AR': 44.25,
                      'passport-priority-ddp-zone-AW': 33.39,
                      'passport-priority-ddp-zone-BS': 33.39,
                      'passport-priority-ddp-zone-BB': 40.92,
                      'passport-priority-ddp-zone-BZ': 40.75,
                      'passport-priority-ddp-zone-BM': 33.54,
                      'passport-priority-ddp-zone-BO': 46.41,
                      'passport-priority-ddp-zone-BR': 19.01,
                      'passport-priority-ddp-zone-KY': 33.39,
                      'passport-priority-ddp-zone-CL': 19.01,
                      'passport-priority-ddp-zone-CO': 19.01,
                      'passport-priority-ddp-zone-CR': 44.74,
                      'passport-priority-ddp-zone-DM': 33.39,
                      'passport-priority-ddp-zone-DO': 33.78,
                      'passport-priority-ddp-zone-EC': 45.0,
                      'passport-priority-ddp-zone-SV': 40.75,
                      'passport-priority-ddp-zone-GP': 50.34,
                      'passport-priority-ddp-zone-GT': 40.85,
                      'passport-priority-ddp-zone-GY': 40.75,
                      'passport-priority-ddp-zone-HT': 33.39,
                      'passport-priority-ddp-zone-JM': 43.57,
                      'passport-priority-ddp-zone-MQ': 39.04,
                      'passport-priority-ddp-zone-AN': 33.39,
                      'passport-priority-ddp-zone-NI': 44.14,
                      'passport-priority-ddp-zone-PA': 41.04,
                      'passport-priority-ddp-zone-PY': 40.75,
                      'passport-priority-ddp-zone-PE': 43.1,
                      'passport-priority-ddp-zone-SR': 40.75,
                      'passport-priority-ddp-zone-TT': 36.21,
                      'passport-priority-ddp-zone-UY': 40.75,
                      'passport-priority-ddp-zone-AF': 60.51,
                      'passport-priority-ddp-zone-DZ': 60.51,
                      'passport-priority-ddp-zone-BH': 48.59,
                      'passport-priority-ddp-zone-BD': 54.12,
                      'passport-priority-ddp-zone-BT': 54.12,
                      'passport-priority-ddp-zone-BA': 60.51,
                      'passport-priority-ddp-zone-BW': 60.51,
                      'passport-priority-ddp-zone-BN': 48.59,
                      'passport-priority-ddp-zone-BF': 60.51,
                      'passport-priority-ddp-zone-BI': 60.51,
                      'passport-priority-ddp-zone-KH': 60.51,
                      'passport-priority-ddp-zone-CM': 60.51,
                      'passport-priority-ddp-zone-CV': 60.51,
                      'passport-priority-ddp-zone-TD': 60.51,
                      'passport-priority-ddp-zone-CG': 60.51,
                      'passport-priority-ddp-zone-CI': 60.51,
                      'passport-priority-ddp-zone-EG': 48.59,
                      'passport-priority-ddp-zone-ET': 60.51,
                      'passport-priority-ddp-zone-GA': 60.51,
                      'passport-priority-ddp-zone-GM': 60.51,
                      'passport-priority-ddp-zone-GH': 60.51,
                      'passport-priority-ddp-zone-GN': 60.51,
                      'passport-priority-ddp-zone-ID': 49.58,
                      'passport-priority-ddp-zone-JO': 48.59,
                      'passport-priority-ddp-zone-KE': 60.51,
                      'passport-priority-ddp-zone-KW': 48.59,
                      'passport-priority-ddp-zone-LB': 48.59,
                      'passport-priority-ddp-zone-LI': 48.59,
                      'passport-priority-ddp-zone-MO': 48.66,
                      'passport-priority-ddp-zone-MG': 60.51,
                      'passport-priority-ddp-zone-MW': 60.51,
                      'passport-priority-ddp-zone-MY': 48.59,
                      'passport-priority-ddp-zone-MV': 54.12,
                      'passport-priority-ddp-zone-ML': 60.51,
                      'passport-priority-ddp-zone-MR': 60.51,
                      'passport-priority-ddp-zone-MU': 60.51,
                      'passport-priority-ddp-zone-MD': 60.51,
                      'passport-priority-ddp-zone-MA': 60.77,
                      'passport-priority-ddp-zone-MZ': 60.51,
                      'passport-priority-ddp-zone-NA': 60.51,
                      'passport-priority-ddp-zone-NP': 54.12,
                      'passport-priority-ddp-zone-NE': 60.51,
                      'passport-priority-ddp-zone-NG': 60.51,
                      'passport-priority-ddp-zone-PK': 54.12,
                      'passport-priority-ddp-zone-PH': 48.59,
                      'passport-priority-ddp-zone-RE': 60.51,
                      'passport-priority-ddp-zone-RW': 60.51,
                      'passport-priority-ddp-zone-SN': 60.51,
                      'passport-priority-ddp-zone-SC': 60.51,
                      'passport-priority-ddp-zone-ZA': 56.2,
                      'passport-priority-ddp-zone-LK': 54.12,
                      'passport-priority-ddp-zone-SZ': 60.51,
                      'passport-priority-ddp-zone-TW': 48.59,
                      'passport-priority-ddp-zone-TJ': 60.51,
                      'passport-priority-ddp-zone-TZ': 60.51,
                      'passport-priority-ddp-zone-TG': 60.51,
                      'passport-priority-ddp-zone-TN': 60.51,
                      'passport-priority-ddp-zone-TR': 48.59,
                      'passport-priority-ddp-zone-TM': 60.51,
                      'passport-priority-ddp-zone-UG': 60.51,
                      'passport-priority-ddp-zone-UA': 60.51,
                      'passport-priority-ddp-zone-VN': 48.59,
                      'passport-priority-ddp-zone-YE': 48.59,
                      'passport-priority-ddp-zone-ZM': 60.51,
                      'passport-priority-ddp-zone-ZW': 60.51,
                      'passport-priority-ddp-zone-MC': 12.62,
                      'passport-priority-ddp-zone-IM': 8.9,
                      'passport-priority-ddp-zone-SM': 12.62,
                    },
                    '0.25': {
                      'passport-priority-ddp-zone-CA': 12.02,
                      'passport-priority-ddp-zone-GB': 9.2,
                      'passport-priority-ddp-zone-AU': 10.69,
                      'passport-priority-ddp-zone-BE': 12.84,
                      'passport-priority-ddp-zone-DK': 12.84,
                      'passport-priority-ddp-zone-FR': 12.84,
                      'passport-priority-ddp-zone-DE': 12.84,
                      'passport-priority-ddp-zone-IT': 12.84,
                      'passport-priority-ddp-zone-NL': 12.84,
                      'passport-priority-ddp-zone-ES': 12.84,
                      'passport-priority-ddp-zone-MX': 11.62,
                      'passport-priority-ddp-zone-AM': 46.63,
                      'passport-priority-ddp-zone-AT': 19.86,
                      'passport-priority-ddp-zone-BG': 23.46,
                      'passport-priority-ddp-zone-HR': 21.58,
                      'passport-priority-ddp-zone-CY': 19.86,
                      'passport-priority-ddp-zone-CZ': 19.86,
                      'passport-priority-ddp-zone-EE': 19.86,
                      'passport-priority-ddp-zone-FI': 19.86,
                      'passport-priority-ddp-zone-GR': 19.86,
                      'passport-priority-ddp-zone-HU': 19.86,
                      'passport-priority-ddp-zone-IE': 19.86,
                      'passport-priority-ddp-zone-LV': 19.86,
                      'passport-priority-ddp-zone-LT': 19.86,
                      'passport-priority-ddp-zone-LU': 19.86,
                      'passport-priority-ddp-zone-MT': 19.86,
                      'passport-priority-ddp-zone-PL': 19.86,
                      'passport-priority-ddp-zone-PT': 19.86,
                      'passport-priority-ddp-zone-RO': 19.86,
                      'passport-priority-ddp-zone-SK': 19.86,
                      'passport-priority-ddp-zone-SI': 19.86,
                      'passport-priority-ddp-zone-SE': 19.86,
                      'passport-priority-ddp-zone-IL': 37.49,
                      'passport-priority-ddp-zone-OM': 41.2,
                      'passport-priority-ddp-zone-QA': 37.49,
                      'passport-priority-ddp-zone-SA': 37.49,
                      'passport-priority-ddp-zone-AE': 37.49,
                      'passport-priority-ddp-zone-CN': 19.82,
                      'passport-priority-ddp-zone-HK': 21.47,
                      'passport-priority-ddp-zone-IN': 44.37,
                      'passport-priority-ddp-zone-JP': 21.21,
                      'passport-priority-ddp-zone-KR': 17.93,
                      'passport-priority-ddp-zone-NZ': 16.83,
                      'passport-priority-ddp-zone-SG': 21.47,
                      'passport-priority-ddp-zone-TH': 16.83,
                      'passport-priority-ddp-zone-GG': 46.44,
                      'passport-priority-ddp-zone-JE': 46.44,
                      'passport-priority-ddp-zone-NO': 44.03,
                      'passport-priority-ddp-zone-CH': 44.03,
                      'passport-priority-ddp-zone-IS': 44.03,
                      'passport-priority-ddp-zone-AI': 33.46,
                      'passport-priority-ddp-zone-AG': 33.46,
                      'passport-priority-ddp-zone-AR': 44.33,
                      'passport-priority-ddp-zone-AW': 33.46,
                      'passport-priority-ddp-zone-BS': 33.46,
                      'passport-priority-ddp-zone-BB': 40.99,
                      'passport-priority-ddp-zone-BZ': 40.83,
                      'passport-priority-ddp-zone-BM': 33.61,
                      'passport-priority-ddp-zone-BO': 46.48,
                      'passport-priority-ddp-zone-BR': 19.11,
                      'passport-priority-ddp-zone-KY': 33.46,
                      'passport-priority-ddp-zone-CL': 19.11,
                      'passport-priority-ddp-zone-CO': 19.11,
                      'passport-priority-ddp-zone-CR': 44.82,
                      'passport-priority-ddp-zone-DM': 33.46,
                      'passport-priority-ddp-zone-DO': 33.85,
                      'passport-priority-ddp-zone-EC': 45.07,
                      'passport-priority-ddp-zone-SV': 40.83,
                      'passport-priority-ddp-zone-GP': 50.42,
                      'passport-priority-ddp-zone-GT': 40.93,
                      'passport-priority-ddp-zone-GY': 40.83,
                      'passport-priority-ddp-zone-HT': 33.46,
                      'passport-priority-ddp-zone-JM': 43.64,
                      'passport-priority-ddp-zone-MQ': 39.11,
                      'passport-priority-ddp-zone-AN': 33.46,
                      'passport-priority-ddp-zone-NI': 44.22,
                      'passport-priority-ddp-zone-PA': 41.12,
                      'passport-priority-ddp-zone-PY': 40.83,
                      'passport-priority-ddp-zone-PE': 43.17,
                      'passport-priority-ddp-zone-SR': 40.83,
                      'passport-priority-ddp-zone-TT': 36.28,
                      'passport-priority-ddp-zone-UY': 40.83,
                      'passport-priority-ddp-zone-AF': 60.52,
                      'passport-priority-ddp-zone-DZ': 60.52,
                      'passport-priority-ddp-zone-BH': 48.61,
                      'passport-priority-ddp-zone-BD': 54.15,
                      'passport-priority-ddp-zone-BT': 54.15,
                      'passport-priority-ddp-zone-BA': 60.52,
                      'passport-priority-ddp-zone-BW': 60.52,
                      'passport-priority-ddp-zone-BN': 48.61,
                      'passport-priority-ddp-zone-BF': 60.52,
                      'passport-priority-ddp-zone-BI': 60.52,
                      'passport-priority-ddp-zone-KH': 60.52,
                      'passport-priority-ddp-zone-CM': 60.52,
                      'passport-priority-ddp-zone-CV': 60.52,
                      'passport-priority-ddp-zone-TD': 60.52,
                      'passport-priority-ddp-zone-CG': 60.52,
                      'passport-priority-ddp-zone-CI': 60.52,
                      'passport-priority-ddp-zone-EG': 48.61,
                      'passport-priority-ddp-zone-ET': 60.52,
                      'passport-priority-ddp-zone-GA': 60.52,
                      'passport-priority-ddp-zone-GM': 60.52,
                      'passport-priority-ddp-zone-GH': 60.52,
                      'passport-priority-ddp-zone-GN': 60.52,
                      'passport-priority-ddp-zone-ID': 49.74,
                      'passport-priority-ddp-zone-JO': 48.61,
                      'passport-priority-ddp-zone-KE': 60.52,
                      'passport-priority-ddp-zone-KW': 48.61,
                      'passport-priority-ddp-zone-LB': 48.61,
                      'passport-priority-ddp-zone-LI': 48.61,
                      'passport-priority-ddp-zone-MO': 48.68,
                      'passport-priority-ddp-zone-MG': 60.52,
                      'passport-priority-ddp-zone-MW': 60.52,
                      'passport-priority-ddp-zone-MY': 48.61,
                      'passport-priority-ddp-zone-MV': 54.15,
                      'passport-priority-ddp-zone-ML': 60.52,
                      'passport-priority-ddp-zone-MR': 60.52,
                      'passport-priority-ddp-zone-MU': 60.52,
                      'passport-priority-ddp-zone-MD': 60.52,
                      'passport-priority-ddp-zone-MA': 60.79,
                      'passport-priority-ddp-zone-MZ': 60.52,
                      'passport-priority-ddp-zone-NA': 60.52,
                      'passport-priority-ddp-zone-NP': 54.15,
                      'passport-priority-ddp-zone-NE': 60.52,
                      'passport-priority-ddp-zone-NG': 60.52,
                      'passport-priority-ddp-zone-PK': 54.15,
                      'passport-priority-ddp-zone-PH': 48.61,
                      'passport-priority-ddp-zone-RE': 60.52,
                      'passport-priority-ddp-zone-RW': 60.52,
                      'passport-priority-ddp-zone-SN': 60.52,
                      'passport-priority-ddp-zone-SC': 60.52,
                      'passport-priority-ddp-zone-ZA': 56.22,
                      'passport-priority-ddp-zone-LK': 54.15,
                      'passport-priority-ddp-zone-SZ': 60.52,
                      'passport-priority-ddp-zone-TW': 48.61,
                      'passport-priority-ddp-zone-TJ': 60.52,
                      'passport-priority-ddp-zone-TZ': 60.52,
                      'passport-priority-ddp-zone-TG': 60.52,
                      'passport-priority-ddp-zone-TN': 60.52,
                      'passport-priority-ddp-zone-TR': 48.61,
                      'passport-priority-ddp-zone-TM': 60.52,
                      'passport-priority-ddp-zone-UG': 60.52,
                      'passport-priority-ddp-zone-UA': 60.52,
                      'passport-priority-ddp-zone-VN': 48.61,
                      'passport-priority-ddp-zone-YE': 48.61,
                      'passport-priority-ddp-zone-ZM': 60.52,
                      'passport-priority-ddp-zone-ZW': 60.52,
                      'passport-priority-ddp-zone-MC': 12.84,
                      'passport-priority-ddp-zone-IM': 9.2,
                      'passport-priority-ddp-zone-SM': 12.84,
                    },
                    '0.3125': {
                      'passport-priority-ddp-zone-CA': 12.09,
                      'passport-priority-ddp-zone-GB': 9.51,
                      'passport-priority-ddp-zone-AU': 11.54,
                      'passport-priority-ddp-zone-BE': 13.05,
                      'passport-priority-ddp-zone-DK': 13.05,
                      'passport-priority-ddp-zone-FR': 13.05,
                      'passport-priority-ddp-zone-DE': 13.05,
                      'passport-priority-ddp-zone-IT': 13.05,
                      'passport-priority-ddp-zone-NL': 13.05,
                      'passport-priority-ddp-zone-ES': 13.05,
                      'passport-priority-ddp-zone-MX': 11.65,
                      'passport-priority-ddp-zone-AM': 46.69,
                      'passport-priority-ddp-zone-AT': 20.07,
                      'passport-priority-ddp-zone-BG': 23.7,
                      'passport-priority-ddp-zone-HR': 21.81,
                      'passport-priority-ddp-zone-CY': 20.07,
                      'passport-priority-ddp-zone-CZ': 20.07,
                      'passport-priority-ddp-zone-EE': 20.07,
                      'passport-priority-ddp-zone-FI': 20.07,
                      'passport-priority-ddp-zone-GR': 20.07,
                      'passport-priority-ddp-zone-HU': 20.07,
                      'passport-priority-ddp-zone-IE': 20.07,
                      'passport-priority-ddp-zone-LV': 20.07,
                      'passport-priority-ddp-zone-LT': 20.07,
                      'passport-priority-ddp-zone-LU': 20.07,
                      'passport-priority-ddp-zone-MT': 20.07,
                      'passport-priority-ddp-zone-PL': 20.07,
                      'passport-priority-ddp-zone-PT': 20.07,
                      'passport-priority-ddp-zone-RO': 20.07,
                      'passport-priority-ddp-zone-SK': 20.07,
                      'passport-priority-ddp-zone-SI': 20.07,
                      'passport-priority-ddp-zone-SE': 20.07,
                      'passport-priority-ddp-zone-IL': 37.52,
                      'passport-priority-ddp-zone-OM': 41.22,
                      'passport-priority-ddp-zone-QA': 37.52,
                      'passport-priority-ddp-zone-SA': 37.52,
                      'passport-priority-ddp-zone-AE': 37.52,
                      'passport-priority-ddp-zone-CN': 19.9,
                      'passport-priority-ddp-zone-HK': 21.55,
                      'passport-priority-ddp-zone-IN': 44.43,
                      'passport-priority-ddp-zone-JP': 21.28,
                      'passport-priority-ddp-zone-KR': 18.0,
                      'passport-priority-ddp-zone-NZ': 17.04,
                      'passport-priority-ddp-zone-SG': 21.55,
                      'passport-priority-ddp-zone-TH': 17.04,
                      'passport-priority-ddp-zone-GG': 46.59,
                      'passport-priority-ddp-zone-JE': 46.59,
                      'passport-priority-ddp-zone-NO': 44.04,
                      'passport-priority-ddp-zone-CH': 44.04,
                      'passport-priority-ddp-zone-IS': 44.04,
                      'passport-priority-ddp-zone-AI': 33.52,
                      'passport-priority-ddp-zone-AG': 33.52,
                      'passport-priority-ddp-zone-AR': 44.4,
                      'passport-priority-ddp-zone-AW': 33.52,
                      'passport-priority-ddp-zone-BS': 33.52,
                      'passport-priority-ddp-zone-BB': 41.07,
                      'passport-priority-ddp-zone-BZ': 40.9,
                      'passport-priority-ddp-zone-BM': 33.68,
                      'passport-priority-ddp-zone-BO': 46.56,
                      'passport-priority-ddp-zone-BR': 19.22,
                      'passport-priority-ddp-zone-KY': 33.52,
                      'passport-priority-ddp-zone-CL': 19.22,
                      'passport-priority-ddp-zone-CO': 19.22,
                      'passport-priority-ddp-zone-CR': 44.89,
                      'passport-priority-ddp-zone-DM': 33.52,
                      'passport-priority-ddp-zone-DO': 33.92,
                      'passport-priority-ddp-zone-EC': 45.13,
                      'passport-priority-ddp-zone-SV': 40.9,
                      'passport-priority-ddp-zone-GP': 50.49,
                      'passport-priority-ddp-zone-GT': 41.0,
                      'passport-priority-ddp-zone-GY': 40.9,
                      'passport-priority-ddp-zone-HT': 33.52,
                      'passport-priority-ddp-zone-JM': 43.7,
                      'passport-priority-ddp-zone-MQ': 39.18,
                      'passport-priority-ddp-zone-AN': 33.52,
                      'passport-priority-ddp-zone-NI': 44.29,
                      'passport-priority-ddp-zone-PA': 41.19,
                      'passport-priority-ddp-zone-PY': 40.9,
                      'passport-priority-ddp-zone-PE': 43.23,
                      'passport-priority-ddp-zone-SR': 40.9,
                      'passport-priority-ddp-zone-TT': 36.36,
                      'passport-priority-ddp-zone-UY': 40.9,
                      'passport-priority-ddp-zone-AF': 60.72,
                      'passport-priority-ddp-zone-DZ': 60.72,
                      'passport-priority-ddp-zone-BH': 48.62,
                      'passport-priority-ddp-zone-BD': 54.33,
                      'passport-priority-ddp-zone-BT': 54.33,
                      'passport-priority-ddp-zone-BA': 60.72,
                      'passport-priority-ddp-zone-BW': 60.72,
                      'passport-priority-ddp-zone-BN': 48.62,
                      'passport-priority-ddp-zone-BF': 60.72,
                      'passport-priority-ddp-zone-BI': 60.72,
                      'passport-priority-ddp-zone-KH': 60.72,
                      'passport-priority-ddp-zone-CM': 60.72,
                      'passport-priority-ddp-zone-CV': 60.72,
                      'passport-priority-ddp-zone-TD': 60.72,
                      'passport-priority-ddp-zone-CG': 60.72,
                      'passport-priority-ddp-zone-CI': 60.72,
                      'passport-priority-ddp-zone-EG': 48.62,
                      'passport-priority-ddp-zone-ET': 60.72,
                      'passport-priority-ddp-zone-GA': 60.72,
                      'passport-priority-ddp-zone-GM': 60.72,
                      'passport-priority-ddp-zone-GH': 60.72,
                      'passport-priority-ddp-zone-GN': 60.72,
                      'passport-priority-ddp-zone-ID': 49.9,
                      'passport-priority-ddp-zone-JO': 48.62,
                      'passport-priority-ddp-zone-KE': 60.72,
                      'passport-priority-ddp-zone-KW': 48.62,
                      'passport-priority-ddp-zone-LB': 48.62,
                      'passport-priority-ddp-zone-LI': 48.62,
                      'passport-priority-ddp-zone-MO': 48.69,
                      'passport-priority-ddp-zone-MG': 60.72,
                      'passport-priority-ddp-zone-MW': 60.72,
                      'passport-priority-ddp-zone-MY': 48.62,
                      'passport-priority-ddp-zone-MV': 54.33,
                      'passport-priority-ddp-zone-ML': 60.72,
                      'passport-priority-ddp-zone-MR': 60.72,
                      'passport-priority-ddp-zone-MU': 60.72,
                      'passport-priority-ddp-zone-MD': 60.72,
                      'passport-priority-ddp-zone-MA': 60.8,
                      'passport-priority-ddp-zone-MZ': 60.72,
                      'passport-priority-ddp-zone-NA': 60.72,
                      'passport-priority-ddp-zone-NP': 54.33,
                      'passport-priority-ddp-zone-NE': 60.72,
                      'passport-priority-ddp-zone-NG': 60.72,
                      'passport-priority-ddp-zone-PK': 54.33,
                      'passport-priority-ddp-zone-PH': 48.62,
                      'passport-priority-ddp-zone-RE': 60.72,
                      'passport-priority-ddp-zone-RW': 60.72,
                      'passport-priority-ddp-zone-SN': 60.72,
                      'passport-priority-ddp-zone-SC': 60.72,
                      'passport-priority-ddp-zone-ZA': 56.25,
                      'passport-priority-ddp-zone-LK': 54.33,
                      'passport-priority-ddp-zone-SZ': 60.72,
                      'passport-priority-ddp-zone-TW': 48.62,
                      'passport-priority-ddp-zone-TJ': 60.72,
                      'passport-priority-ddp-zone-TZ': 60.72,
                      'passport-priority-ddp-zone-TG': 60.72,
                      'passport-priority-ddp-zone-TN': 60.72,
                      'passport-priority-ddp-zone-TR': 48.62,
                      'passport-priority-ddp-zone-TM': 60.72,
                      'passport-priority-ddp-zone-UG': 60.72,
                      'passport-priority-ddp-zone-UA': 60.72,
                      'passport-priority-ddp-zone-VN': 48.62,
                      'passport-priority-ddp-zone-YE': 48.62,
                      'passport-priority-ddp-zone-ZM': 60.72,
                      'passport-priority-ddp-zone-ZW': 60.72,
                      'passport-priority-ddp-zone-MC': 13.05,
                      'passport-priority-ddp-zone-IM': 9.51,
                      'passport-priority-ddp-zone-SM': 13.05,
                    },
                    '0.375': {
                      'passport-priority-ddp-zone-CA': 12.17,
                      'passport-priority-ddp-zone-GB': 9.79,
                      'passport-priority-ddp-zone-AU': 12.39,
                      'passport-priority-ddp-zone-BE': 13.26,
                      'passport-priority-ddp-zone-DK': 13.26,
                      'passport-priority-ddp-zone-FR': 13.26,
                      'passport-priority-ddp-zone-DE': 13.26,
                      'passport-priority-ddp-zone-IT': 13.26,
                      'passport-priority-ddp-zone-NL': 13.26,
                      'passport-priority-ddp-zone-ES': 13.26,
                      'passport-priority-ddp-zone-MX': 11.68,
                      'passport-priority-ddp-zone-AM': 46.76,
                      'passport-priority-ddp-zone-AT': 20.28,
                      'passport-priority-ddp-zone-BG': 23.93,
                      'passport-priority-ddp-zone-HR': 22.05,
                      'passport-priority-ddp-zone-CY': 20.28,
                      'passport-priority-ddp-zone-CZ': 20.28,
                      'passport-priority-ddp-zone-EE': 20.28,
                      'passport-priority-ddp-zone-FI': 20.28,
                      'passport-priority-ddp-zone-GR': 20.28,
                      'passport-priority-ddp-zone-HU': 20.28,
                      'passport-priority-ddp-zone-IE': 20.28,
                      'passport-priority-ddp-zone-LV': 20.28,
                      'passport-priority-ddp-zone-LT': 20.28,
                      'passport-priority-ddp-zone-LU': 20.28,
                      'passport-priority-ddp-zone-MT': 20.28,
                      'passport-priority-ddp-zone-PL': 20.28,
                      'passport-priority-ddp-zone-PT': 20.28,
                      'passport-priority-ddp-zone-RO': 20.28,
                      'passport-priority-ddp-zone-SK': 20.28,
                      'passport-priority-ddp-zone-SI': 20.28,
                      'passport-priority-ddp-zone-SE': 20.28,
                      'passport-priority-ddp-zone-IL': 37.54,
                      'passport-priority-ddp-zone-OM': 41.23,
                      'passport-priority-ddp-zone-QA': 37.54,
                      'passport-priority-ddp-zone-SA': 37.54,
                      'passport-priority-ddp-zone-AE': 37.54,
                      'passport-priority-ddp-zone-CN': 19.97,
                      'passport-priority-ddp-zone-HK': 21.61,
                      'passport-priority-ddp-zone-IN': 44.51,
                      'passport-priority-ddp-zone-JP': 21.36,
                      'passport-priority-ddp-zone-KR': 18.09,
                      'passport-priority-ddp-zone-NZ': 17.25,
                      'passport-priority-ddp-zone-SG': 21.61,
                      'passport-priority-ddp-zone-TH': 17.25,
                      'passport-priority-ddp-zone-GG': 46.74,
                      'passport-priority-ddp-zone-JE': 46.74,
                      'passport-priority-ddp-zone-NO': 44.06,
                      'passport-priority-ddp-zone-CH': 44.06,
                      'passport-priority-ddp-zone-IS': 44.06,
                      'passport-priority-ddp-zone-AI': 33.6,
                      'passport-priority-ddp-zone-AG': 33.6,
                      'passport-priority-ddp-zone-AR': 44.47,
                      'passport-priority-ddp-zone-AW': 33.6,
                      'passport-priority-ddp-zone-BS': 33.6,
                      'passport-priority-ddp-zone-BB': 41.14,
                      'passport-priority-ddp-zone-BZ': 40.97,
                      'passport-priority-ddp-zone-BM': 33.75,
                      'passport-priority-ddp-zone-BO': 46.62,
                      'passport-priority-ddp-zone-BR': 19.33,
                      'passport-priority-ddp-zone-KY': 33.6,
                      'passport-priority-ddp-zone-CL': 19.33,
                      'passport-priority-ddp-zone-CO': 19.33,
                      'passport-priority-ddp-zone-CR': 44.96,
                      'passport-priority-ddp-zone-DM': 33.6,
                      'passport-priority-ddp-zone-DO': 34.0,
                      'passport-priority-ddp-zone-EC': 45.21,
                      'passport-priority-ddp-zone-SV': 40.97,
                      'passport-priority-ddp-zone-GP': 50.56,
                      'passport-priority-ddp-zone-GT': 41.06,
                      'passport-priority-ddp-zone-GY': 40.97,
                      'passport-priority-ddp-zone-HT': 33.6,
                      'passport-priority-ddp-zone-JM': 43.77,
                      'passport-priority-ddp-zone-MQ': 39.25,
                      'passport-priority-ddp-zone-AN': 33.6,
                      'passport-priority-ddp-zone-NI': 44.36,
                      'passport-priority-ddp-zone-PA': 41.26,
                      'passport-priority-ddp-zone-PY': 40.97,
                      'passport-priority-ddp-zone-PE': 43.31,
                      'passport-priority-ddp-zone-SR': 40.97,
                      'passport-priority-ddp-zone-TT': 36.43,
                      'passport-priority-ddp-zone-UY': 40.97,
                      'passport-priority-ddp-zone-AF': 60.92,
                      'passport-priority-ddp-zone-DZ': 60.92,
                      'passport-priority-ddp-zone-BH': 48.64,
                      'passport-priority-ddp-zone-BD': 54.51,
                      'passport-priority-ddp-zone-BT': 54.51,
                      'passport-priority-ddp-zone-BA': 60.92,
                      'passport-priority-ddp-zone-BW': 60.92,
                      'passport-priority-ddp-zone-BN': 48.64,
                      'passport-priority-ddp-zone-BF': 60.92,
                      'passport-priority-ddp-zone-BI': 60.92,
                      'passport-priority-ddp-zone-KH': 60.92,
                      'passport-priority-ddp-zone-CM': 60.92,
                      'passport-priority-ddp-zone-CV': 60.92,
                      'passport-priority-ddp-zone-TD': 60.92,
                      'passport-priority-ddp-zone-CG': 60.92,
                      'passport-priority-ddp-zone-CI': 60.92,
                      'passport-priority-ddp-zone-EG': 48.64,
                      'passport-priority-ddp-zone-ET': 60.92,
                      'passport-priority-ddp-zone-GA': 60.92,
                      'passport-priority-ddp-zone-GM': 60.92,
                      'passport-priority-ddp-zone-GH': 60.92,
                      'passport-priority-ddp-zone-GN': 60.92,
                      'passport-priority-ddp-zone-ID': 50.06,
                      'passport-priority-ddp-zone-JO': 48.64,
                      'passport-priority-ddp-zone-KE': 60.92,
                      'passport-priority-ddp-zone-KW': 48.64,
                      'passport-priority-ddp-zone-LB': 48.64,
                      'passport-priority-ddp-zone-LI': 48.64,
                      'passport-priority-ddp-zone-MO': 48.7,
                      'passport-priority-ddp-zone-MG': 60.92,
                      'passport-priority-ddp-zone-MW': 60.92,
                      'passport-priority-ddp-zone-MY': 48.64,
                      'passport-priority-ddp-zone-MV': 54.51,
                      'passport-priority-ddp-zone-ML': 60.92,
                      'passport-priority-ddp-zone-MR': 60.92,
                      'passport-priority-ddp-zone-MU': 60.92,
                      'passport-priority-ddp-zone-MD': 60.92,
                      'passport-priority-ddp-zone-MA': 60.83,
                      'passport-priority-ddp-zone-MZ': 60.92,
                      'passport-priority-ddp-zone-NA': 60.92,
                      'passport-priority-ddp-zone-NP': 54.51,
                      'passport-priority-ddp-zone-NE': 60.92,
                      'passport-priority-ddp-zone-NG': 60.92,
                      'passport-priority-ddp-zone-PK': 54.51,
                      'passport-priority-ddp-zone-PH': 48.64,
                      'passport-priority-ddp-zone-RE': 60.92,
                      'passport-priority-ddp-zone-RW': 60.92,
                      'passport-priority-ddp-zone-SN': 60.92,
                      'passport-priority-ddp-zone-SC': 60.92,
                      'passport-priority-ddp-zone-ZA': 56.44,
                      'passport-priority-ddp-zone-LK': 54.51,
                      'passport-priority-ddp-zone-SZ': 60.92,
                      'passport-priority-ddp-zone-TW': 48.64,
                      'passport-priority-ddp-zone-TJ': 60.92,
                      'passport-priority-ddp-zone-TZ': 60.92,
                      'passport-priority-ddp-zone-TG': 60.92,
                      'passport-priority-ddp-zone-TN': 60.92,
                      'passport-priority-ddp-zone-TR': 48.64,
                      'passport-priority-ddp-zone-TM': 60.92,
                      'passport-priority-ddp-zone-UG': 60.92,
                      'passport-priority-ddp-zone-UA': 60.92,
                      'passport-priority-ddp-zone-VN': 48.64,
                      'passport-priority-ddp-zone-YE': 48.64,
                      'passport-priority-ddp-zone-ZM': 60.92,
                      'passport-priority-ddp-zone-ZW': 60.92,
                      'passport-priority-ddp-zone-MC': 13.26,
                      'passport-priority-ddp-zone-IM': 9.79,
                      'passport-priority-ddp-zone-SM': 13.26,
                    },
                    '0.4375': {
                      'passport-priority-ddp-zone-CA': 12.24,
                      'passport-priority-ddp-zone-GB': 10.09,
                      'passport-priority-ddp-zone-AU': 13.23,
                      'passport-priority-ddp-zone-BE': 13.46,
                      'passport-priority-ddp-zone-DK': 13.46,
                      'passport-priority-ddp-zone-FR': 13.46,
                      'passport-priority-ddp-zone-DE': 13.46,
                      'passport-priority-ddp-zone-IT': 13.46,
                      'passport-priority-ddp-zone-NL': 13.46,
                      'passport-priority-ddp-zone-ES': 13.46,
                      'passport-priority-ddp-zone-MX': 11.7,
                      'passport-priority-ddp-zone-AM': 46.84,
                      'passport-priority-ddp-zone-AT': 20.5,
                      'passport-priority-ddp-zone-BG': 24.17,
                      'passport-priority-ddp-zone-HR': 22.28,
                      'passport-priority-ddp-zone-CY': 20.5,
                      'passport-priority-ddp-zone-CZ': 20.5,
                      'passport-priority-ddp-zone-EE': 20.5,
                      'passport-priority-ddp-zone-FI': 20.5,
                      'passport-priority-ddp-zone-GR': 20.5,
                      'passport-priority-ddp-zone-HU': 20.5,
                      'passport-priority-ddp-zone-IE': 20.5,
                      'passport-priority-ddp-zone-LV': 20.5,
                      'passport-priority-ddp-zone-LT': 20.5,
                      'passport-priority-ddp-zone-LU': 20.5,
                      'passport-priority-ddp-zone-MT': 20.5,
                      'passport-priority-ddp-zone-PL': 20.5,
                      'passport-priority-ddp-zone-PT': 20.5,
                      'passport-priority-ddp-zone-RO': 20.5,
                      'passport-priority-ddp-zone-SK': 20.5,
                      'passport-priority-ddp-zone-SI': 20.5,
                      'passport-priority-ddp-zone-SE': 20.5,
                      'passport-priority-ddp-zone-IL': 37.57,
                      'passport-priority-ddp-zone-OM': 41.28,
                      'passport-priority-ddp-zone-QA': 37.57,
                      'passport-priority-ddp-zone-SA': 37.57,
                      'passport-priority-ddp-zone-AE': 37.57,
                      'passport-priority-ddp-zone-CN': 20.06,
                      'passport-priority-ddp-zone-HK': 21.68,
                      'passport-priority-ddp-zone-IN': 44.58,
                      'passport-priority-ddp-zone-JP': 21.45,
                      'passport-priority-ddp-zone-KR': 18.17,
                      'passport-priority-ddp-zone-NZ': 17.45,
                      'passport-priority-ddp-zone-SG': 21.68,
                      'passport-priority-ddp-zone-TH': 17.45,
                      'passport-priority-ddp-zone-GG': 46.89,
                      'passport-priority-ddp-zone-JE': 46.89,
                      'passport-priority-ddp-zone-NO': 44.21,
                      'passport-priority-ddp-zone-CH': 44.21,
                      'passport-priority-ddp-zone-IS': 44.21,
                      'passport-priority-ddp-zone-AI': 33.67,
                      'passport-priority-ddp-zone-AG': 33.67,
                      'passport-priority-ddp-zone-AR': 44.55,
                      'passport-priority-ddp-zone-AW': 33.67,
                      'passport-priority-ddp-zone-BS': 33.67,
                      'passport-priority-ddp-zone-BB': 41.22,
                      'passport-priority-ddp-zone-BZ': 41.04,
                      'passport-priority-ddp-zone-BM': 33.83,
                      'passport-priority-ddp-zone-BO': 46.69,
                      'passport-priority-ddp-zone-BR': 19.45,
                      'passport-priority-ddp-zone-KY': 33.67,
                      'passport-priority-ddp-zone-CL': 19.45,
                      'passport-priority-ddp-zone-CO': 19.45,
                      'passport-priority-ddp-zone-CR': 45.04,
                      'passport-priority-ddp-zone-DM': 33.67,
                      'passport-priority-ddp-zone-DO': 34.07,
                      'passport-priority-ddp-zone-EC': 45.28,
                      'passport-priority-ddp-zone-SV': 41.04,
                      'passport-priority-ddp-zone-GP': 50.64,
                      'passport-priority-ddp-zone-GT': 41.14,
                      'passport-priority-ddp-zone-GY': 41.04,
                      'passport-priority-ddp-zone-HT': 33.67,
                      'passport-priority-ddp-zone-JM': 43.85,
                      'passport-priority-ddp-zone-MQ': 39.33,
                      'passport-priority-ddp-zone-AN': 33.67,
                      'passport-priority-ddp-zone-NI': 44.44,
                      'passport-priority-ddp-zone-PA': 41.34,
                      'passport-priority-ddp-zone-PY': 41.04,
                      'passport-priority-ddp-zone-PE': 43.38,
                      'passport-priority-ddp-zone-SR': 41.04,
                      'passport-priority-ddp-zone-TT': 36.5,
                      'passport-priority-ddp-zone-UY': 41.04,
                      'passport-priority-ddp-zone-AF': 61.12,
                      'passport-priority-ddp-zone-DZ': 61.12,
                      'passport-priority-ddp-zone-BH': 48.8,
                      'passport-priority-ddp-zone-BD': 54.69,
                      'passport-priority-ddp-zone-BT': 54.69,
                      'passport-priority-ddp-zone-BA': 61.12,
                      'passport-priority-ddp-zone-BW': 61.12,
                      'passport-priority-ddp-zone-BN': 48.8,
                      'passport-priority-ddp-zone-BF': 61.12,
                      'passport-priority-ddp-zone-BI': 61.12,
                      'passport-priority-ddp-zone-KH': 61.12,
                      'passport-priority-ddp-zone-CM': 61.12,
                      'passport-priority-ddp-zone-CV': 61.12,
                      'passport-priority-ddp-zone-TD': 61.12,
                      'passport-priority-ddp-zone-CG': 61.12,
                      'passport-priority-ddp-zone-CI': 61.12,
                      'passport-priority-ddp-zone-EG': 48.8,
                      'passport-priority-ddp-zone-ET': 61.12,
                      'passport-priority-ddp-zone-GA': 61.12,
                      'passport-priority-ddp-zone-GM': 61.12,
                      'passport-priority-ddp-zone-GH': 61.12,
                      'passport-priority-ddp-zone-GN': 61.12,
                      'passport-priority-ddp-zone-ID': 50.23,
                      'passport-priority-ddp-zone-JO': 48.8,
                      'passport-priority-ddp-zone-KE': 61.12,
                      'passport-priority-ddp-zone-KW': 48.8,
                      'passport-priority-ddp-zone-LB': 48.8,
                      'passport-priority-ddp-zone-LI': 48.8,
                      'passport-priority-ddp-zone-MO': 48.86,
                      'passport-priority-ddp-zone-MG': 61.12,
                      'passport-priority-ddp-zone-MW': 61.12,
                      'passport-priority-ddp-zone-MY': 48.8,
                      'passport-priority-ddp-zone-MV': 54.69,
                      'passport-priority-ddp-zone-ML': 61.12,
                      'passport-priority-ddp-zone-MR': 61.12,
                      'passport-priority-ddp-zone-MU': 61.12,
                      'passport-priority-ddp-zone-MD': 61.12,
                      'passport-priority-ddp-zone-MA': 61.03,
                      'passport-priority-ddp-zone-MZ': 61.12,
                      'passport-priority-ddp-zone-NA': 61.12,
                      'passport-priority-ddp-zone-NP': 54.69,
                      'passport-priority-ddp-zone-NE': 61.12,
                      'passport-priority-ddp-zone-NG': 61.12,
                      'passport-priority-ddp-zone-PK': 54.69,
                      'passport-priority-ddp-zone-PH': 48.8,
                      'passport-priority-ddp-zone-RE': 61.12,
                      'passport-priority-ddp-zone-RW': 61.12,
                      'passport-priority-ddp-zone-SN': 61.12,
                      'passport-priority-ddp-zone-SC': 61.12,
                      'passport-priority-ddp-zone-ZA': 56.63,
                      'passport-priority-ddp-zone-LK': 54.69,
                      'passport-priority-ddp-zone-SZ': 61.12,
                      'passport-priority-ddp-zone-TW': 48.8,
                      'passport-priority-ddp-zone-TJ': 61.12,
                      'passport-priority-ddp-zone-TZ': 61.12,
                      'passport-priority-ddp-zone-TG': 61.12,
                      'passport-priority-ddp-zone-TN': 61.12,
                      'passport-priority-ddp-zone-TR': 48.8,
                      'passport-priority-ddp-zone-TM': 61.12,
                      'passport-priority-ddp-zone-UG': 61.12,
                      'passport-priority-ddp-zone-UA': 61.12,
                      'passport-priority-ddp-zone-VN': 48.8,
                      'passport-priority-ddp-zone-YE': 48.8,
                      'passport-priority-ddp-zone-ZM': 61.12,
                      'passport-priority-ddp-zone-ZW': 61.12,
                      'passport-priority-ddp-zone-MC': 13.46,
                      'passport-priority-ddp-zone-IM': 10.09,
                      'passport-priority-ddp-zone-SM': 13.46,
                    },
                    '0.5': {
                      'passport-priority-ddp-zone-CA': 12.32,
                      'passport-priority-ddp-zone-GB': 10.39,
                      'passport-priority-ddp-zone-AU': 14.0,
                      'passport-priority-ddp-zone-BE': 13.68,
                      'passport-priority-ddp-zone-DK': 13.68,
                      'passport-priority-ddp-zone-FR': 13.68,
                      'passport-priority-ddp-zone-DE': 13.68,
                      'passport-priority-ddp-zone-IT': 13.68,
                      'passport-priority-ddp-zone-NL': 13.68,
                      'passport-priority-ddp-zone-ES': 13.68,
                      'passport-priority-ddp-zone-MX': 11.73,
                      'passport-priority-ddp-zone-AM': 46.91,
                      'passport-priority-ddp-zone-AT': 20.7,
                      'passport-priority-ddp-zone-BG': 24.4,
                      'passport-priority-ddp-zone-HR': 22.52,
                      'passport-priority-ddp-zone-CY': 20.7,
                      'passport-priority-ddp-zone-CZ': 20.7,
                      'passport-priority-ddp-zone-EE': 20.7,
                      'passport-priority-ddp-zone-FI': 20.7,
                      'passport-priority-ddp-zone-GR': 20.7,
                      'passport-priority-ddp-zone-HU': 20.7,
                      'passport-priority-ddp-zone-IE': 20.7,
                      'passport-priority-ddp-zone-LV': 20.7,
                      'passport-priority-ddp-zone-LT': 20.7,
                      'passport-priority-ddp-zone-LU': 20.7,
                      'passport-priority-ddp-zone-MT': 20.7,
                      'passport-priority-ddp-zone-PL': 20.7,
                      'passport-priority-ddp-zone-PT': 20.7,
                      'passport-priority-ddp-zone-RO': 20.7,
                      'passport-priority-ddp-zone-SK': 20.7,
                      'passport-priority-ddp-zone-SI': 20.7,
                      'passport-priority-ddp-zone-SE': 20.7,
                      'passport-priority-ddp-zone-IL': 37.58,
                      'passport-priority-ddp-zone-OM': 41.29,
                      'passport-priority-ddp-zone-QA': 37.58,
                      'passport-priority-ddp-zone-SA': 37.58,
                      'passport-priority-ddp-zone-AE': 37.58,
                      'passport-priority-ddp-zone-CN': 20.14,
                      'passport-priority-ddp-zone-HK': 21.76,
                      'passport-priority-ddp-zone-IN': 44.66,
                      'passport-priority-ddp-zone-JP': 21.53,
                      'passport-priority-ddp-zone-KR': 18.24,
                      'passport-priority-ddp-zone-NZ': 17.67,
                      'passport-priority-ddp-zone-SG': 21.76,
                      'passport-priority-ddp-zone-TH': 17.67,
                      'passport-priority-ddp-zone-GG': 47.04,
                      'passport-priority-ddp-zone-JE': 47.04,
                      'passport-priority-ddp-zone-NO': 44.36,
                      'passport-priority-ddp-zone-CH': 44.36,
                      'passport-priority-ddp-zone-IS': 44.36,
                      'passport-priority-ddp-zone-AI': 33.74,
                      'passport-priority-ddp-zone-AG': 33.74,
                      'passport-priority-ddp-zone-AR': 44.62,
                      'passport-priority-ddp-zone-AW': 33.74,
                      'passport-priority-ddp-zone-BS': 33.74,
                      'passport-priority-ddp-zone-BB': 41.28,
                      'passport-priority-ddp-zone-BZ': 41.11,
                      'passport-priority-ddp-zone-BM': 33.9,
                      'passport-priority-ddp-zone-BO': 46.77,
                      'passport-priority-ddp-zone-BR': 19.55,
                      'passport-priority-ddp-zone-KY': 33.74,
                      'passport-priority-ddp-zone-CL': 19.55,
                      'passport-priority-ddp-zone-CO': 19.55,
                      'passport-priority-ddp-zone-CR': 45.11,
                      'passport-priority-ddp-zone-DM': 33.74,
                      'passport-priority-ddp-zone-DO': 34.14,
                      'passport-priority-ddp-zone-EC': 45.36,
                      'passport-priority-ddp-zone-SV': 41.11,
                      'passport-priority-ddp-zone-GP': 50.71,
                      'passport-priority-ddp-zone-GT': 41.21,
                      'passport-priority-ddp-zone-GY': 41.11,
                      'passport-priority-ddp-zone-HT': 33.74,
                      'passport-priority-ddp-zone-JM': 43.92,
                      'passport-priority-ddp-zone-MQ': 39.4,
                      'passport-priority-ddp-zone-AN': 33.74,
                      'passport-priority-ddp-zone-NI': 44.51,
                      'passport-priority-ddp-zone-PA': 41.41,
                      'passport-priority-ddp-zone-PY': 41.11,
                      'passport-priority-ddp-zone-PE': 43.46,
                      'passport-priority-ddp-zone-SR': 41.11,
                      'passport-priority-ddp-zone-TT': 36.57,
                      'passport-priority-ddp-zone-UY': 41.11,
                      'passport-priority-ddp-zone-AF': 61.32,
                      'passport-priority-ddp-zone-DZ': 61.32,
                      'passport-priority-ddp-zone-BH': 48.96,
                      'passport-priority-ddp-zone-BD': 54.87,
                      'passport-priority-ddp-zone-BT': 54.87,
                      'passport-priority-ddp-zone-BA': 61.32,
                      'passport-priority-ddp-zone-BW': 61.32,
                      'passport-priority-ddp-zone-BN': 48.96,
                      'passport-priority-ddp-zone-BF': 61.32,
                      'passport-priority-ddp-zone-BI': 61.32,
                      'passport-priority-ddp-zone-KH': 61.32,
                      'passport-priority-ddp-zone-CM': 61.32,
                      'passport-priority-ddp-zone-CV': 61.32,
                      'passport-priority-ddp-zone-TD': 61.32,
                      'passport-priority-ddp-zone-CG': 61.32,
                      'passport-priority-ddp-zone-CI': 61.32,
                      'passport-priority-ddp-zone-EG': 48.96,
                      'passport-priority-ddp-zone-ET': 61.32,
                      'passport-priority-ddp-zone-GA': 61.32,
                      'passport-priority-ddp-zone-GM': 61.32,
                      'passport-priority-ddp-zone-GH': 61.32,
                      'passport-priority-ddp-zone-GN': 61.32,
                      'passport-priority-ddp-zone-ID': 50.4,
                      'passport-priority-ddp-zone-JO': 48.96,
                      'passport-priority-ddp-zone-KE': 61.32,
                      'passport-priority-ddp-zone-KW': 48.96,
                      'passport-priority-ddp-zone-LB': 48.96,
                      'passport-priority-ddp-zone-LI': 48.96,
                      'passport-priority-ddp-zone-MO': 49.02,
                      'passport-priority-ddp-zone-MG': 61.32,
                      'passport-priority-ddp-zone-MW': 61.32,
                      'passport-priority-ddp-zone-MY': 48.96,
                      'passport-priority-ddp-zone-MV': 54.87,
                      'passport-priority-ddp-zone-ML': 61.32,
                      'passport-priority-ddp-zone-MR': 61.32,
                      'passport-priority-ddp-zone-MU': 61.32,
                      'passport-priority-ddp-zone-MD': 61.32,
                      'passport-priority-ddp-zone-MA': 61.23,
                      'passport-priority-ddp-zone-MZ': 61.32,
                      'passport-priority-ddp-zone-NA': 61.32,
                      'passport-priority-ddp-zone-NP': 54.87,
                      'passport-priority-ddp-zone-NE': 61.32,
                      'passport-priority-ddp-zone-NG': 61.32,
                      'passport-priority-ddp-zone-PK': 54.87,
                      'passport-priority-ddp-zone-PH': 48.96,
                      'passport-priority-ddp-zone-RE': 61.32,
                      'passport-priority-ddp-zone-RW': 61.32,
                      'passport-priority-ddp-zone-SN': 61.32,
                      'passport-priority-ddp-zone-SC': 61.32,
                      'passport-priority-ddp-zone-ZA': 56.82,
                      'passport-priority-ddp-zone-LK': 54.87,
                      'passport-priority-ddp-zone-SZ': 61.32,
                      'passport-priority-ddp-zone-TW': 48.96,
                      'passport-priority-ddp-zone-TJ': 61.32,
                      'passport-priority-ddp-zone-TZ': 61.32,
                      'passport-priority-ddp-zone-TG': 61.32,
                      'passport-priority-ddp-zone-TN': 61.32,
                      'passport-priority-ddp-zone-TR': 48.96,
                      'passport-priority-ddp-zone-TM': 61.32,
                      'passport-priority-ddp-zone-UG': 61.32,
                      'passport-priority-ddp-zone-UA': 61.32,
                      'passport-priority-ddp-zone-VN': 48.96,
                      'passport-priority-ddp-zone-YE': 48.96,
                      'passport-priority-ddp-zone-ZM': 61.32,
                      'passport-priority-ddp-zone-ZW': 61.32,
                      'passport-priority-ddp-zone-MC': 13.68,
                      'passport-priority-ddp-zone-IM': 10.39,
                      'passport-priority-ddp-zone-SM': 13.68,
                    },
                    '0.5625': {
                      'passport-priority-ddp-zone-CA': 12.4,
                      'passport-priority-ddp-zone-GB': 10.7,
                      'passport-priority-ddp-zone-AU': 14.66,
                      'passport-priority-ddp-zone-BE': 14.45,
                      'passport-priority-ddp-zone-DK': 14.45,
                      'passport-priority-ddp-zone-FR': 14.45,
                      'passport-priority-ddp-zone-DE': 14.45,
                      'passport-priority-ddp-zone-IT': 14.45,
                      'passport-priority-ddp-zone-NL': 14.45,
                      'passport-priority-ddp-zone-ES': 14.45,
                      'passport-priority-ddp-zone-MX': 11.76,
                      'passport-priority-ddp-zone-AM': 46.98,
                      'passport-priority-ddp-zone-AT': 21.35,
                      'passport-priority-ddp-zone-BG': 24.73,
                      'passport-priority-ddp-zone-HR': 23.06,
                      'passport-priority-ddp-zone-CY': 21.35,
                      'passport-priority-ddp-zone-CZ': 21.35,
                      'passport-priority-ddp-zone-EE': 21.35,
                      'passport-priority-ddp-zone-FI': 21.35,
                      'passport-priority-ddp-zone-GR': 21.35,
                      'passport-priority-ddp-zone-HU': 21.35,
                      'passport-priority-ddp-zone-IE': 21.35,
                      'passport-priority-ddp-zone-LV': 21.35,
                      'passport-priority-ddp-zone-LT': 21.35,
                      'passport-priority-ddp-zone-LU': 21.35,
                      'passport-priority-ddp-zone-MT': 21.35,
                      'passport-priority-ddp-zone-PL': 21.35,
                      'passport-priority-ddp-zone-PT': 21.35,
                      'passport-priority-ddp-zone-RO': 21.35,
                      'passport-priority-ddp-zone-SK': 21.35,
                      'passport-priority-ddp-zone-SI': 21.35,
                      'passport-priority-ddp-zone-SE': 21.35,
                      'passport-priority-ddp-zone-IL': 37.61,
                      'passport-priority-ddp-zone-OM': 41.32,
                      'passport-priority-ddp-zone-QA': 37.61,
                      'passport-priority-ddp-zone-SA': 37.61,
                      'passport-priority-ddp-zone-AE': 37.61,
                      'passport-priority-ddp-zone-CN': 20.22,
                      'passport-priority-ddp-zone-HK': 21.83,
                      'passport-priority-ddp-zone-IN': 44.73,
                      'passport-priority-ddp-zone-JP': 21.61,
                      'passport-priority-ddp-zone-KR': 18.33,
                      'passport-priority-ddp-zone-NZ': 17.86,
                      'passport-priority-ddp-zone-SG': 21.83,
                      'passport-priority-ddp-zone-TH': 17.86,
                      'passport-priority-ddp-zone-GG': 47.2,
                      'passport-priority-ddp-zone-JE': 47.2,
                      'passport-priority-ddp-zone-NO': 44.51,
                      'passport-priority-ddp-zone-CH': 44.51,
                      'passport-priority-ddp-zone-IS': 44.51,
                      'passport-priority-ddp-zone-AI': 33.82,
                      'passport-priority-ddp-zone-AG': 33.82,
                      'passport-priority-ddp-zone-AR': 44.68,
                      'passport-priority-ddp-zone-AW': 33.82,
                      'passport-priority-ddp-zone-BS': 33.82,
                      'passport-priority-ddp-zone-BB': 41.35,
                      'passport-priority-ddp-zone-BZ': 41.18,
                      'passport-priority-ddp-zone-BM': 33.97,
                      'passport-priority-ddp-zone-BO': 46.84,
                      'passport-priority-ddp-zone-BR': 19.66,
                      'passport-priority-ddp-zone-KY': 33.82,
                      'passport-priority-ddp-zone-CL': 19.66,
                      'passport-priority-ddp-zone-CO': 19.66,
                      'passport-priority-ddp-zone-CR': 45.17,
                      'passport-priority-ddp-zone-DM': 33.82,
                      'passport-priority-ddp-zone-DO': 34.21,
                      'passport-priority-ddp-zone-EC': 45.43,
                      'passport-priority-ddp-zone-SV': 41.18,
                      'passport-priority-ddp-zone-GP': 50.78,
                      'passport-priority-ddp-zone-GT': 41.28,
                      'passport-priority-ddp-zone-GY': 41.18,
                      'passport-priority-ddp-zone-HT': 33.82,
                      'passport-priority-ddp-zone-JM': 44.0,
                      'passport-priority-ddp-zone-MQ': 39.47,
                      'passport-priority-ddp-zone-AN': 33.82,
                      'passport-priority-ddp-zone-NI': 44.57,
                      'passport-priority-ddp-zone-PA': 41.47,
                      'passport-priority-ddp-zone-PY': 41.18,
                      'passport-priority-ddp-zone-PE': 43.53,
                      'passport-priority-ddp-zone-SR': 41.18,
                      'passport-priority-ddp-zone-TT': 36.64,
                      'passport-priority-ddp-zone-UY': 41.18,
                      'passport-priority-ddp-zone-AF': 61.52,
                      'passport-priority-ddp-zone-DZ': 61.52,
                      'passport-priority-ddp-zone-BH': 49.12,
                      'passport-priority-ddp-zone-BD': 55.05,
                      'passport-priority-ddp-zone-BT': 55.05,
                      'passport-priority-ddp-zone-BA': 61.52,
                      'passport-priority-ddp-zone-BW': 61.52,
                      'passport-priority-ddp-zone-BN': 49.12,
                      'passport-priority-ddp-zone-BF': 61.52,
                      'passport-priority-ddp-zone-BI': 61.52,
                      'passport-priority-ddp-zone-KH': 61.52,
                      'passport-priority-ddp-zone-CM': 61.52,
                      'passport-priority-ddp-zone-CV': 61.52,
                      'passport-priority-ddp-zone-TD': 61.52,
                      'passport-priority-ddp-zone-CG': 61.52,
                      'passport-priority-ddp-zone-CI': 61.52,
                      'passport-priority-ddp-zone-EG': 49.12,
                      'passport-priority-ddp-zone-ET': 61.52,
                      'passport-priority-ddp-zone-GA': 61.52,
                      'passport-priority-ddp-zone-GM': 61.52,
                      'passport-priority-ddp-zone-GH': 61.52,
                      'passport-priority-ddp-zone-GN': 61.52,
                      'passport-priority-ddp-zone-ID': 50.57,
                      'passport-priority-ddp-zone-JO': 49.12,
                      'passport-priority-ddp-zone-KE': 61.52,
                      'passport-priority-ddp-zone-KW': 49.12,
                      'passport-priority-ddp-zone-LB': 49.12,
                      'passport-priority-ddp-zone-LI': 49.12,
                      'passport-priority-ddp-zone-MO': 49.18,
                      'passport-priority-ddp-zone-MG': 61.52,
                      'passport-priority-ddp-zone-MW': 61.52,
                      'passport-priority-ddp-zone-MY': 49.12,
                      'passport-priority-ddp-zone-MV': 55.05,
                      'passport-priority-ddp-zone-ML': 61.52,
                      'passport-priority-ddp-zone-MR': 61.52,
                      'passport-priority-ddp-zone-MU': 61.52,
                      'passport-priority-ddp-zone-MD': 61.52,
                      'passport-priority-ddp-zone-MA': 61.43,
                      'passport-priority-ddp-zone-MZ': 61.52,
                      'passport-priority-ddp-zone-NA': 61.52,
                      'passport-priority-ddp-zone-NP': 55.05,
                      'passport-priority-ddp-zone-NE': 61.52,
                      'passport-priority-ddp-zone-NG': 61.52,
                      'passport-priority-ddp-zone-PK': 55.05,
                      'passport-priority-ddp-zone-PH': 49.12,
                      'passport-priority-ddp-zone-RE': 61.52,
                      'passport-priority-ddp-zone-RW': 61.52,
                      'passport-priority-ddp-zone-SN': 61.52,
                      'passport-priority-ddp-zone-SC': 61.52,
                      'passport-priority-ddp-zone-ZA': 57.01,
                      'passport-priority-ddp-zone-LK': 55.05,
                      'passport-priority-ddp-zone-SZ': 61.52,
                      'passport-priority-ddp-zone-TW': 49.12,
                      'passport-priority-ddp-zone-TJ': 61.52,
                      'passport-priority-ddp-zone-TZ': 61.52,
                      'passport-priority-ddp-zone-TG': 61.52,
                      'passport-priority-ddp-zone-TN': 61.52,
                      'passport-priority-ddp-zone-TR': 49.12,
                      'passport-priority-ddp-zone-TM': 61.52,
                      'passport-priority-ddp-zone-UG': 61.52,
                      'passport-priority-ddp-zone-UA': 61.52,
                      'passport-priority-ddp-zone-VN': 49.12,
                      'passport-priority-ddp-zone-YE': 49.12,
                      'passport-priority-ddp-zone-ZM': 61.52,
                      'passport-priority-ddp-zone-ZW': 61.52,
                      'passport-priority-ddp-zone-MC': 14.45,
                      'passport-priority-ddp-zone-IM': 10.7,
                      'passport-priority-ddp-zone-SM': 14.45,
                    },
                    '0.625': {
                      'passport-priority-ddp-zone-CA': 12.47,
                      'passport-priority-ddp-zone-GB': 10.83,
                      'passport-priority-ddp-zone-AU': 15.31,
                      'passport-priority-ddp-zone-BE': 14.67,
                      'passport-priority-ddp-zone-DK': 14.67,
                      'passport-priority-ddp-zone-FR': 14.67,
                      'passport-priority-ddp-zone-DE': 14.67,
                      'passport-priority-ddp-zone-IT': 14.67,
                      'passport-priority-ddp-zone-NL': 14.67,
                      'passport-priority-ddp-zone-ES': 14.67,
                      'passport-priority-ddp-zone-MX': 11.77,
                      'passport-priority-ddp-zone-AM': 47.06,
                      'passport-priority-ddp-zone-AT': 21.56,
                      'passport-priority-ddp-zone-BG': 24.96,
                      'passport-priority-ddp-zone-HR': 23.29,
                      'passport-priority-ddp-zone-CY': 21.56,
                      'passport-priority-ddp-zone-CZ': 21.56,
                      'passport-priority-ddp-zone-EE': 21.56,
                      'passport-priority-ddp-zone-FI': 21.56,
                      'passport-priority-ddp-zone-GR': 21.56,
                      'passport-priority-ddp-zone-HU': 21.56,
                      'passport-priority-ddp-zone-IE': 21.56,
                      'passport-priority-ddp-zone-LV': 21.56,
                      'passport-priority-ddp-zone-LT': 21.56,
                      'passport-priority-ddp-zone-LU': 21.56,
                      'passport-priority-ddp-zone-MT': 21.56,
                      'passport-priority-ddp-zone-PL': 21.56,
                      'passport-priority-ddp-zone-PT': 21.56,
                      'passport-priority-ddp-zone-RO': 21.56,
                      'passport-priority-ddp-zone-SK': 21.56,
                      'passport-priority-ddp-zone-SI': 21.56,
                      'passport-priority-ddp-zone-SE': 21.56,
                      'passport-priority-ddp-zone-IL': 37.63,
                      'passport-priority-ddp-zone-OM': 41.34,
                      'passport-priority-ddp-zone-QA': 37.63,
                      'passport-priority-ddp-zone-SA': 37.63,
                      'passport-priority-ddp-zone-AE': 37.63,
                      'passport-priority-ddp-zone-CN': 20.3,
                      'passport-priority-ddp-zone-HK': 21.9,
                      'passport-priority-ddp-zone-IN': 44.8,
                      'passport-priority-ddp-zone-JP': 21.69,
                      'passport-priority-ddp-zone-KR': 18.41,
                      'passport-priority-ddp-zone-NZ': 18.08,
                      'passport-priority-ddp-zone-SG': 21.9,
                      'passport-priority-ddp-zone-TH': 18.08,
                      'passport-priority-ddp-zone-GG': 47.36,
                      'passport-priority-ddp-zone-JE': 47.36,
                      'passport-priority-ddp-zone-NO': 44.66,
                      'passport-priority-ddp-zone-CH': 44.66,
                      'passport-priority-ddp-zone-IS': 44.66,
                      'passport-priority-ddp-zone-AI': 33.89,
                      'passport-priority-ddp-zone-AG': 33.89,
                      'passport-priority-ddp-zone-AR': 44.76,
                      'passport-priority-ddp-zone-AW': 33.89,
                      'passport-priority-ddp-zone-BS': 33.89,
                      'passport-priority-ddp-zone-BB': 41.42,
                      'passport-priority-ddp-zone-BZ': 41.26,
                      'passport-priority-ddp-zone-BM': 34.04,
                      'passport-priority-ddp-zone-BO': 46.91,
                      'passport-priority-ddp-zone-BR': 19.77,
                      'passport-priority-ddp-zone-KY': 33.89,
                      'passport-priority-ddp-zone-CL': 19.77,
                      'passport-priority-ddp-zone-CO': 19.77,
                      'passport-priority-ddp-zone-CR': 45.25,
                      'passport-priority-ddp-zone-DM': 33.89,
                      'passport-priority-ddp-zone-DO': 34.28,
                      'passport-priority-ddp-zone-EC': 45.5,
                      'passport-priority-ddp-zone-SV': 41.26,
                      'passport-priority-ddp-zone-GP': 50.85,
                      'passport-priority-ddp-zone-GT': 41.36,
                      'passport-priority-ddp-zone-GY': 41.26,
                      'passport-priority-ddp-zone-HT': 33.89,
                      'passport-priority-ddp-zone-JM': 44.07,
                      'passport-priority-ddp-zone-MQ': 39.55,
                      'passport-priority-ddp-zone-AN': 33.89,
                      'passport-priority-ddp-zone-NI': 44.65,
                      'passport-priority-ddp-zone-PA': 41.55,
                      'passport-priority-ddp-zone-PY': 41.26,
                      'passport-priority-ddp-zone-PE': 43.6,
                      'passport-priority-ddp-zone-SR': 41.26,
                      'passport-priority-ddp-zone-TT': 36.71,
                      'passport-priority-ddp-zone-UY': 41.26,
                      'passport-priority-ddp-zone-AF': 61.72,
                      'passport-priority-ddp-zone-DZ': 61.72,
                      'passport-priority-ddp-zone-BH': 49.28,
                      'passport-priority-ddp-zone-BD': 55.23,
                      'passport-priority-ddp-zone-BT': 55.23,
                      'passport-priority-ddp-zone-BA': 61.72,
                      'passport-priority-ddp-zone-BW': 61.72,
                      'passport-priority-ddp-zone-BN': 49.28,
                      'passport-priority-ddp-zone-BF': 61.72,
                      'passport-priority-ddp-zone-BI': 61.72,
                      'passport-priority-ddp-zone-KH': 61.72,
                      'passport-priority-ddp-zone-CM': 61.72,
                      'passport-priority-ddp-zone-CV': 61.72,
                      'passport-priority-ddp-zone-TD': 61.72,
                      'passport-priority-ddp-zone-CG': 61.72,
                      'passport-priority-ddp-zone-CI': 61.72,
                      'passport-priority-ddp-zone-EG': 49.28,
                      'passport-priority-ddp-zone-ET': 61.72,
                      'passport-priority-ddp-zone-GA': 61.72,
                      'passport-priority-ddp-zone-GM': 61.72,
                      'passport-priority-ddp-zone-GH': 61.72,
                      'passport-priority-ddp-zone-GN': 61.72,
                      'passport-priority-ddp-zone-ID': 50.74,
                      'passport-priority-ddp-zone-JO': 49.28,
                      'passport-priority-ddp-zone-KE': 61.72,
                      'passport-priority-ddp-zone-KW': 49.28,
                      'passport-priority-ddp-zone-LB': 49.28,
                      'passport-priority-ddp-zone-LI': 49.28,
                      'passport-priority-ddp-zone-MO': 49.34,
                      'passport-priority-ddp-zone-MG': 61.72,
                      'passport-priority-ddp-zone-MW': 61.72,
                      'passport-priority-ddp-zone-MY': 49.28,
                      'passport-priority-ddp-zone-MV': 55.23,
                      'passport-priority-ddp-zone-ML': 61.72,
                      'passport-priority-ddp-zone-MR': 61.72,
                      'passport-priority-ddp-zone-MU': 61.72,
                      'passport-priority-ddp-zone-MD': 61.72,
                      'passport-priority-ddp-zone-MA': 61.63,
                      'passport-priority-ddp-zone-MZ': 61.72,
                      'passport-priority-ddp-zone-NA': 61.72,
                      'passport-priority-ddp-zone-NP': 55.23,
                      'passport-priority-ddp-zone-NE': 61.72,
                      'passport-priority-ddp-zone-NG': 61.72,
                      'passport-priority-ddp-zone-PK': 55.23,
                      'passport-priority-ddp-zone-PH': 49.28,
                      'passport-priority-ddp-zone-RE': 61.72,
                      'passport-priority-ddp-zone-RW': 61.72,
                      'passport-priority-ddp-zone-SN': 61.72,
                      'passport-priority-ddp-zone-SC': 61.72,
                      'passport-priority-ddp-zone-ZA': 57.2,
                      'passport-priority-ddp-zone-LK': 55.23,
                      'passport-priority-ddp-zone-SZ': 61.72,
                      'passport-priority-ddp-zone-TW': 49.28,
                      'passport-priority-ddp-zone-TJ': 61.72,
                      'passport-priority-ddp-zone-TZ': 61.72,
                      'passport-priority-ddp-zone-TG': 61.72,
                      'passport-priority-ddp-zone-TN': 61.72,
                      'passport-priority-ddp-zone-TR': 49.28,
                      'passport-priority-ddp-zone-TM': 61.72,
                      'passport-priority-ddp-zone-UG': 61.72,
                      'passport-priority-ddp-zone-UA': 61.72,
                      'passport-priority-ddp-zone-VN': 49.28,
                      'passport-priority-ddp-zone-YE': 49.28,
                      'passport-priority-ddp-zone-ZM': 61.72,
                      'passport-priority-ddp-zone-ZW': 61.72,
                      'passport-priority-ddp-zone-MC': 14.67,
                      'passport-priority-ddp-zone-IM': 10.83,
                      'passport-priority-ddp-zone-SM': 14.67,
                    },
                    '0.6875': {
                      'passport-priority-ddp-zone-CA': 12.55,
                      'passport-priority-ddp-zone-GB': 10.98,
                      'passport-priority-ddp-zone-AU': 15.66,
                      'passport-priority-ddp-zone-BE': 14.86,
                      'passport-priority-ddp-zone-DK': 14.86,
                      'passport-priority-ddp-zone-FR': 14.86,
                      'passport-priority-ddp-zone-DE': 14.86,
                      'passport-priority-ddp-zone-IT': 14.86,
                      'passport-priority-ddp-zone-NL': 14.86,
                      'passport-priority-ddp-zone-ES': 14.86,
                      'passport-priority-ddp-zone-MX': 11.83,
                      'passport-priority-ddp-zone-AM': 47.12,
                      'passport-priority-ddp-zone-AT': 21.76,
                      'passport-priority-ddp-zone-BG': 25.2,
                      'passport-priority-ddp-zone-HR': 23.53,
                      'passport-priority-ddp-zone-CY': 21.76,
                      'passport-priority-ddp-zone-CZ': 21.76,
                      'passport-priority-ddp-zone-EE': 21.76,
                      'passport-priority-ddp-zone-FI': 21.76,
                      'passport-priority-ddp-zone-GR': 21.76,
                      'passport-priority-ddp-zone-HU': 21.76,
                      'passport-priority-ddp-zone-IE': 21.76,
                      'passport-priority-ddp-zone-LV': 21.76,
                      'passport-priority-ddp-zone-LT': 21.76,
                      'passport-priority-ddp-zone-LU': 21.76,
                      'passport-priority-ddp-zone-MT': 21.76,
                      'passport-priority-ddp-zone-PL': 21.76,
                      'passport-priority-ddp-zone-PT': 21.76,
                      'passport-priority-ddp-zone-RO': 21.76,
                      'passport-priority-ddp-zone-SK': 21.76,
                      'passport-priority-ddp-zone-SI': 21.76,
                      'passport-priority-ddp-zone-SE': 21.76,
                      'passport-priority-ddp-zone-IL': 41.19,
                      'passport-priority-ddp-zone-OM': 45.25,
                      'passport-priority-ddp-zone-QA': 41.19,
                      'passport-priority-ddp-zone-SA': 41.19,
                      'passport-priority-ddp-zone-AE': 41.19,
                      'passport-priority-ddp-zone-CN': 20.39,
                      'passport-priority-ddp-zone-HK': 21.98,
                      'passport-priority-ddp-zone-IN': 44.87,
                      'passport-priority-ddp-zone-JP': 21.78,
                      'passport-priority-ddp-zone-KR': 18.5,
                      'passport-priority-ddp-zone-NZ': 18.29,
                      'passport-priority-ddp-zone-SG': 21.98,
                      'passport-priority-ddp-zone-TH': 18.29,
                      'passport-priority-ddp-zone-GG': 47.52,
                      'passport-priority-ddp-zone-JE': 47.52,
                      'passport-priority-ddp-zone-NO': 44.81,
                      'passport-priority-ddp-zone-CH': 44.81,
                      'passport-priority-ddp-zone-IS': 44.81,
                      'passport-priority-ddp-zone-AI': 33.95,
                      'passport-priority-ddp-zone-AG': 33.95,
                      'passport-priority-ddp-zone-AR': 44.83,
                      'passport-priority-ddp-zone-AW': 33.95,
                      'passport-priority-ddp-zone-BS': 33.95,
                      'passport-priority-ddp-zone-BB': 41.5,
                      'passport-priority-ddp-zone-BZ': 41.33,
                      'passport-priority-ddp-zone-BM': 34.11,
                      'passport-priority-ddp-zone-BO': 46.99,
                      'passport-priority-ddp-zone-BR': 19.87,
                      'passport-priority-ddp-zone-KY': 33.95,
                      'passport-priority-ddp-zone-CL': 19.87,
                      'passport-priority-ddp-zone-CO': 19.87,
                      'passport-priority-ddp-zone-CR': 45.32,
                      'passport-priority-ddp-zone-DM': 33.95,
                      'passport-priority-ddp-zone-DO': 34.35,
                      'passport-priority-ddp-zone-EC': 45.57,
                      'passport-priority-ddp-zone-SV': 41.33,
                      'passport-priority-ddp-zone-GP': 50.92,
                      'passport-priority-ddp-zone-GT': 41.43,
                      'passport-priority-ddp-zone-GY': 41.33,
                      'passport-priority-ddp-zone-HT': 33.95,
                      'passport-priority-ddp-zone-JM': 44.14,
                      'passport-priority-ddp-zone-MQ': 39.61,
                      'passport-priority-ddp-zone-AN': 33.95,
                      'passport-priority-ddp-zone-NI': 44.72,
                      'passport-priority-ddp-zone-PA': 41.62,
                      'passport-priority-ddp-zone-PY': 41.33,
                      'passport-priority-ddp-zone-PE': 43.68,
                      'passport-priority-ddp-zone-SR': 41.33,
                      'passport-priority-ddp-zone-TT': 36.79,
                      'passport-priority-ddp-zone-UY': 41.33,
                      'passport-priority-ddp-zone-AF': 61.92,
                      'passport-priority-ddp-zone-DZ': 61.92,
                      'passport-priority-ddp-zone-BH': 49.44,
                      'passport-priority-ddp-zone-BD': 55.41,
                      'passport-priority-ddp-zone-BT': 55.41,
                      'passport-priority-ddp-zone-BA': 61.92,
                      'passport-priority-ddp-zone-BW': 61.92,
                      'passport-priority-ddp-zone-BN': 49.44,
                      'passport-priority-ddp-zone-BF': 61.92,
                      'passport-priority-ddp-zone-BI': 61.92,
                      'passport-priority-ddp-zone-KH': 61.92,
                      'passport-priority-ddp-zone-CM': 61.92,
                      'passport-priority-ddp-zone-CV': 61.92,
                      'passport-priority-ddp-zone-TD': 61.92,
                      'passport-priority-ddp-zone-CG': 61.92,
                      'passport-priority-ddp-zone-CI': 61.92,
                      'passport-priority-ddp-zone-EG': 49.44,
                      'passport-priority-ddp-zone-ET': 61.92,
                      'passport-priority-ddp-zone-GA': 61.92,
                      'passport-priority-ddp-zone-GM': 61.92,
                      'passport-priority-ddp-zone-GH': 61.92,
                      'passport-priority-ddp-zone-GN': 61.92,
                      'passport-priority-ddp-zone-ID': 50.91,
                      'passport-priority-ddp-zone-JO': 49.44,
                      'passport-priority-ddp-zone-KE': 61.92,
                      'passport-priority-ddp-zone-KW': 49.44,
                      'passport-priority-ddp-zone-LB': 49.44,
                      'passport-priority-ddp-zone-LI': 49.44,
                      'passport-priority-ddp-zone-MO': 49.5,
                      'passport-priority-ddp-zone-MG': 61.92,
                      'passport-priority-ddp-zone-MW': 61.92,
                      'passport-priority-ddp-zone-MY': 49.44,
                      'passport-priority-ddp-zone-MV': 55.41,
                      'passport-priority-ddp-zone-ML': 61.92,
                      'passport-priority-ddp-zone-MR': 61.92,
                      'passport-priority-ddp-zone-MU': 61.92,
                      'passport-priority-ddp-zone-MD': 61.92,
                      'passport-priority-ddp-zone-MA': 61.83,
                      'passport-priority-ddp-zone-MZ': 61.92,
                      'passport-priority-ddp-zone-NA': 61.92,
                      'passport-priority-ddp-zone-NP': 55.41,
                      'passport-priority-ddp-zone-NE': 61.92,
                      'passport-priority-ddp-zone-NG': 61.92,
                      'passport-priority-ddp-zone-PK': 55.41,
                      'passport-priority-ddp-zone-PH': 49.44,
                      'passport-priority-ddp-zone-RE': 61.92,
                      'passport-priority-ddp-zone-RW': 61.92,
                      'passport-priority-ddp-zone-SN': 61.92,
                      'passport-priority-ddp-zone-SC': 61.92,
                      'passport-priority-ddp-zone-ZA': 57.39,
                      'passport-priority-ddp-zone-LK': 55.41,
                      'passport-priority-ddp-zone-SZ': 61.92,
                      'passport-priority-ddp-zone-TW': 49.44,
                      'passport-priority-ddp-zone-TJ': 61.92,
                      'passport-priority-ddp-zone-TZ': 61.92,
                      'passport-priority-ddp-zone-TG': 61.92,
                      'passport-priority-ddp-zone-TN': 61.92,
                      'passport-priority-ddp-zone-TR': 49.44,
                      'passport-priority-ddp-zone-TM': 61.92,
                      'passport-priority-ddp-zone-UG': 61.92,
                      'passport-priority-ddp-zone-UA': 61.92,
                      'passport-priority-ddp-zone-VN': 49.44,
                      'passport-priority-ddp-zone-YE': 49.44,
                      'passport-priority-ddp-zone-ZM': 61.92,
                      'passport-priority-ddp-zone-ZW': 61.92,
                      'passport-priority-ddp-zone-MC': 14.86,
                      'passport-priority-ddp-zone-IM': 10.98,
                      'passport-priority-ddp-zone-SM': 14.86,
                    },
                    '0.75': {
                      'passport-priority-ddp-zone-CA': 12.62,
                      'passport-priority-ddp-zone-GB': 11.15,
                      'passport-priority-ddp-zone-AU': 16.25,
                      'passport-priority-ddp-zone-BE': 15.08,
                      'passport-priority-ddp-zone-DK': 15.08,
                      'passport-priority-ddp-zone-FR': 15.08,
                      'passport-priority-ddp-zone-DE': 15.08,
                      'passport-priority-ddp-zone-IT': 15.08,
                      'passport-priority-ddp-zone-NL': 15.08,
                      'passport-priority-ddp-zone-ES': 15.08,
                      'passport-priority-ddp-zone-MX': 11.95,
                      'passport-priority-ddp-zone-AM': 47.19,
                      'passport-priority-ddp-zone-AT': 21.97,
                      'passport-priority-ddp-zone-BG': 25.44,
                      'passport-priority-ddp-zone-HR': 23.76,
                      'passport-priority-ddp-zone-CY': 21.97,
                      'passport-priority-ddp-zone-CZ': 21.97,
                      'passport-priority-ddp-zone-EE': 21.97,
                      'passport-priority-ddp-zone-FI': 21.97,
                      'passport-priority-ddp-zone-GR': 21.97,
                      'passport-priority-ddp-zone-HU': 21.97,
                      'passport-priority-ddp-zone-IE': 21.97,
                      'passport-priority-ddp-zone-LV': 21.97,
                      'passport-priority-ddp-zone-LT': 21.97,
                      'passport-priority-ddp-zone-LU': 21.97,
                      'passport-priority-ddp-zone-MT': 21.97,
                      'passport-priority-ddp-zone-PL': 21.97,
                      'passport-priority-ddp-zone-PT': 21.97,
                      'passport-priority-ddp-zone-RO': 21.97,
                      'passport-priority-ddp-zone-SK': 21.97,
                      'passport-priority-ddp-zone-SI': 21.97,
                      'passport-priority-ddp-zone-SE': 21.97,
                      'passport-priority-ddp-zone-IL': 41.22,
                      'passport-priority-ddp-zone-OM': 45.27,
                      'passport-priority-ddp-zone-QA': 41.22,
                      'passport-priority-ddp-zone-SA': 41.22,
                      'passport-priority-ddp-zone-AE': 41.22,
                      'passport-priority-ddp-zone-CN': 20.47,
                      'passport-priority-ddp-zone-HK': 22.05,
                      'passport-priority-ddp-zone-IN': 44.94,
                      'passport-priority-ddp-zone-JP': 21.85,
                      'passport-priority-ddp-zone-KR': 18.57,
                      'passport-priority-ddp-zone-NZ': 18.49,
                      'passport-priority-ddp-zone-SG': 22.05,
                      'passport-priority-ddp-zone-TH': 18.49,
                      'passport-priority-ddp-zone-GG': 47.68,
                      'passport-priority-ddp-zone-JE': 47.68,
                      'passport-priority-ddp-zone-NO': 44.96,
                      'passport-priority-ddp-zone-CH': 44.96,
                      'passport-priority-ddp-zone-IS': 44.96,
                      'passport-priority-ddp-zone-AI': 34.03,
                      'passport-priority-ddp-zone-AG': 34.03,
                      'passport-priority-ddp-zone-AR': 44.91,
                      'passport-priority-ddp-zone-AW': 34.03,
                      'passport-priority-ddp-zone-BS': 34.03,
                      'passport-priority-ddp-zone-BB': 41.57,
                      'passport-priority-ddp-zone-BZ': 41.41,
                      'passport-priority-ddp-zone-BM': 34.18,
                      'passport-priority-ddp-zone-BO': 47.06,
                      'passport-priority-ddp-zone-BR': 19.98,
                      'passport-priority-ddp-zone-KY': 34.03,
                      'passport-priority-ddp-zone-CL': 19.98,
                      'passport-priority-ddp-zone-CO': 19.98,
                      'passport-priority-ddp-zone-CR': 45.39,
                      'passport-priority-ddp-zone-DM': 34.03,
                      'passport-priority-ddp-zone-DO': 34.43,
                      'passport-priority-ddp-zone-EC': 45.64,
                      'passport-priority-ddp-zone-SV': 41.41,
                      'passport-priority-ddp-zone-GP': 50.99,
                      'passport-priority-ddp-zone-GT': 41.51,
                      'passport-priority-ddp-zone-GY': 41.41,
                      'passport-priority-ddp-zone-HT': 34.03,
                      'passport-priority-ddp-zone-JM': 44.21,
                      'passport-priority-ddp-zone-MQ': 39.68,
                      'passport-priority-ddp-zone-AN': 34.03,
                      'passport-priority-ddp-zone-NI': 44.79,
                      'passport-priority-ddp-zone-PA': 41.69,
                      'passport-priority-ddp-zone-PY': 41.41,
                      'passport-priority-ddp-zone-PE': 43.74,
                      'passport-priority-ddp-zone-SR': 41.41,
                      'passport-priority-ddp-zone-TT': 36.86,
                      'passport-priority-ddp-zone-UY': 41.41,
                      'passport-priority-ddp-zone-AF': 62.12,
                      'passport-priority-ddp-zone-DZ': 62.12,
                      'passport-priority-ddp-zone-BH': 49.6,
                      'passport-priority-ddp-zone-BD': 55.59,
                      'passport-priority-ddp-zone-BT': 55.59,
                      'passport-priority-ddp-zone-BA': 62.12,
                      'passport-priority-ddp-zone-BW': 62.12,
                      'passport-priority-ddp-zone-BN': 49.6,
                      'passport-priority-ddp-zone-BF': 62.12,
                      'passport-priority-ddp-zone-BI': 62.12,
                      'passport-priority-ddp-zone-KH': 62.12,
                      'passport-priority-ddp-zone-CM': 62.12,
                      'passport-priority-ddp-zone-CV': 62.12,
                      'passport-priority-ddp-zone-TD': 62.12,
                      'passport-priority-ddp-zone-CG': 62.12,
                      'passport-priority-ddp-zone-CI': 62.12,
                      'passport-priority-ddp-zone-EG': 49.6,
                      'passport-priority-ddp-zone-ET': 62.12,
                      'passport-priority-ddp-zone-GA': 62.12,
                      'passport-priority-ddp-zone-GM': 62.12,
                      'passport-priority-ddp-zone-GH': 62.12,
                      'passport-priority-ddp-zone-GN': 62.12,
                      'passport-priority-ddp-zone-ID': 51.08,
                      'passport-priority-ddp-zone-JO': 49.6,
                      'passport-priority-ddp-zone-KE': 62.12,
                      'passport-priority-ddp-zone-KW': 49.6,
                      'passport-priority-ddp-zone-LB': 49.6,
                      'passport-priority-ddp-zone-LI': 49.6,
                      'passport-priority-ddp-zone-MO': 49.66,
                      'passport-priority-ddp-zone-MG': 62.12,
                      'passport-priority-ddp-zone-MW': 62.12,
                      'passport-priority-ddp-zone-MY': 49.6,
                      'passport-priority-ddp-zone-MV': 55.59,
                      'passport-priority-ddp-zone-ML': 62.12,
                      'passport-priority-ddp-zone-MR': 62.12,
                      'passport-priority-ddp-zone-MU': 62.12,
                      'passport-priority-ddp-zone-MD': 62.12,
                      'passport-priority-ddp-zone-MA': 62.03,
                      'passport-priority-ddp-zone-MZ': 62.12,
                      'passport-priority-ddp-zone-NA': 62.12,
                      'passport-priority-ddp-zone-NP': 55.59,
                      'passport-priority-ddp-zone-NE': 62.12,
                      'passport-priority-ddp-zone-NG': 62.12,
                      'passport-priority-ddp-zone-PK': 55.59,
                      'passport-priority-ddp-zone-PH': 49.6,
                      'passport-priority-ddp-zone-RE': 62.12,
                      'passport-priority-ddp-zone-RW': 62.12,
                      'passport-priority-ddp-zone-SN': 62.12,
                      'passport-priority-ddp-zone-SC': 62.12,
                      'passport-priority-ddp-zone-ZA': 57.58,
                      'passport-priority-ddp-zone-LK': 55.59,
                      'passport-priority-ddp-zone-SZ': 62.12,
                      'passport-priority-ddp-zone-TW': 49.6,
                      'passport-priority-ddp-zone-TJ': 62.12,
                      'passport-priority-ddp-zone-TZ': 62.12,
                      'passport-priority-ddp-zone-TG': 62.12,
                      'passport-priority-ddp-zone-TN': 62.12,
                      'passport-priority-ddp-zone-TR': 49.6,
                      'passport-priority-ddp-zone-TM': 62.12,
                      'passport-priority-ddp-zone-UG': 62.12,
                      'passport-priority-ddp-zone-UA': 62.12,
                      'passport-priority-ddp-zone-VN': 49.6,
                      'passport-priority-ddp-zone-YE': 49.6,
                      'passport-priority-ddp-zone-ZM': 62.12,
                      'passport-priority-ddp-zone-ZW': 62.12,
                      'passport-priority-ddp-zone-MC': 15.08,
                      'passport-priority-ddp-zone-IM': 11.15,
                      'passport-priority-ddp-zone-SM': 15.08,
                    },
                    '0.8125': {
                      'passport-priority-ddp-zone-CA': 12.7,
                      'passport-priority-ddp-zone-GB': 11.32,
                      'passport-priority-ddp-zone-AU': 16.72,
                      'passport-priority-ddp-zone-BE': 15.29,
                      'passport-priority-ddp-zone-DK': 15.29,
                      'passport-priority-ddp-zone-FR': 15.29,
                      'passport-priority-ddp-zone-DE': 15.29,
                      'passport-priority-ddp-zone-IT': 15.29,
                      'passport-priority-ddp-zone-NL': 15.29,
                      'passport-priority-ddp-zone-ES': 15.29,
                      'passport-priority-ddp-zone-MX': 12.07,
                      'passport-priority-ddp-zone-AM': 47.27,
                      'passport-priority-ddp-zone-AT': 22.19,
                      'passport-priority-ddp-zone-BG': 25.67,
                      'passport-priority-ddp-zone-HR': 24.0,
                      'passport-priority-ddp-zone-CY': 22.19,
                      'passport-priority-ddp-zone-CZ': 22.19,
                      'passport-priority-ddp-zone-EE': 22.19,
                      'passport-priority-ddp-zone-FI': 22.19,
                      'passport-priority-ddp-zone-GR': 22.19,
                      'passport-priority-ddp-zone-HU': 22.19,
                      'passport-priority-ddp-zone-IE': 22.19,
                      'passport-priority-ddp-zone-LV': 22.19,
                      'passport-priority-ddp-zone-LT': 22.19,
                      'passport-priority-ddp-zone-LU': 22.19,
                      'passport-priority-ddp-zone-MT': 22.19,
                      'passport-priority-ddp-zone-PL': 22.19,
                      'passport-priority-ddp-zone-PT': 22.19,
                      'passport-priority-ddp-zone-RO': 22.19,
                      'passport-priority-ddp-zone-SK': 22.19,
                      'passport-priority-ddp-zone-SI': 22.19,
                      'passport-priority-ddp-zone-SE': 22.19,
                      'passport-priority-ddp-zone-IL': 41.24,
                      'passport-priority-ddp-zone-OM': 45.3,
                      'passport-priority-ddp-zone-QA': 41.24,
                      'passport-priority-ddp-zone-SA': 41.24,
                      'passport-priority-ddp-zone-AE': 41.24,
                      'passport-priority-ddp-zone-CN': 20.55,
                      'passport-priority-ddp-zone-HK': 22.11,
                      'passport-priority-ddp-zone-IN': 45.01,
                      'passport-priority-ddp-zone-JP': 21.93,
                      'passport-priority-ddp-zone-KR': 18.7,
                      'passport-priority-ddp-zone-NZ': 18.7,
                      'passport-priority-ddp-zone-SG': 22.11,
                      'passport-priority-ddp-zone-TH': 18.7,
                      'passport-priority-ddp-zone-GG': 47.84,
                      'passport-priority-ddp-zone-JE': 47.84,
                      'passport-priority-ddp-zone-NO': 45.11,
                      'passport-priority-ddp-zone-CH': 45.11,
                      'passport-priority-ddp-zone-IS': 45.11,
                      'passport-priority-ddp-zone-AI': 34.1,
                      'passport-priority-ddp-zone-AG': 34.1,
                      'passport-priority-ddp-zone-AR': 44.98,
                      'passport-priority-ddp-zone-AW': 34.1,
                      'passport-priority-ddp-zone-BS': 34.1,
                      'passport-priority-ddp-zone-BB': 41.65,
                      'passport-priority-ddp-zone-BZ': 41.47,
                      'passport-priority-ddp-zone-BM': 34.26,
                      'passport-priority-ddp-zone-BO': 47.12,
                      'passport-priority-ddp-zone-BR': 20.09,
                      'passport-priority-ddp-zone-KY': 34.1,
                      'passport-priority-ddp-zone-CL': 20.09,
                      'passport-priority-ddp-zone-CO': 20.09,
                      'passport-priority-ddp-zone-CR': 45.47,
                      'passport-priority-ddp-zone-DM': 34.1,
                      'passport-priority-ddp-zone-DO': 34.5,
                      'passport-priority-ddp-zone-EC': 45.71,
                      'passport-priority-ddp-zone-SV': 41.47,
                      'passport-priority-ddp-zone-GP': 51.07,
                      'passport-priority-ddp-zone-GT': 41.57,
                      'passport-priority-ddp-zone-GY': 41.47,
                      'passport-priority-ddp-zone-HT': 34.1,
                      'passport-priority-ddp-zone-JM': 44.28,
                      'passport-priority-ddp-zone-MQ': 39.76,
                      'passport-priority-ddp-zone-AN': 34.1,
                      'passport-priority-ddp-zone-NI': 44.87,
                      'passport-priority-ddp-zone-PA': 41.77,
                      'passport-priority-ddp-zone-PY': 41.47,
                      'passport-priority-ddp-zone-PE': 43.81,
                      'passport-priority-ddp-zone-SR': 41.47,
                      'passport-priority-ddp-zone-TT': 36.93,
                      'passport-priority-ddp-zone-UY': 41.47,
                      'passport-priority-ddp-zone-AF': 62.32,
                      'passport-priority-ddp-zone-DZ': 62.32,
                      'passport-priority-ddp-zone-BH': 49.76,
                      'passport-priority-ddp-zone-BD': 55.77,
                      'passport-priority-ddp-zone-BT': 55.77,
                      'passport-priority-ddp-zone-BA': 62.32,
                      'passport-priority-ddp-zone-BW': 62.32,
                      'passport-priority-ddp-zone-BN': 49.76,
                      'passport-priority-ddp-zone-BF': 62.32,
                      'passport-priority-ddp-zone-BI': 62.32,
                      'passport-priority-ddp-zone-KH': 62.32,
                      'passport-priority-ddp-zone-CM': 62.32,
                      'passport-priority-ddp-zone-CV': 62.32,
                      'passport-priority-ddp-zone-TD': 62.32,
                      'passport-priority-ddp-zone-CG': 62.32,
                      'passport-priority-ddp-zone-CI': 62.32,
                      'passport-priority-ddp-zone-EG': 49.76,
                      'passport-priority-ddp-zone-ET': 62.32,
                      'passport-priority-ddp-zone-GA': 62.32,
                      'passport-priority-ddp-zone-GM': 62.32,
                      'passport-priority-ddp-zone-GH': 62.32,
                      'passport-priority-ddp-zone-GN': 62.32,
                      'passport-priority-ddp-zone-ID': 51.25,
                      'passport-priority-ddp-zone-JO': 49.76,
                      'passport-priority-ddp-zone-KE': 62.32,
                      'passport-priority-ddp-zone-KW': 49.76,
                      'passport-priority-ddp-zone-LB': 49.76,
                      'passport-priority-ddp-zone-LI': 49.76,
                      'passport-priority-ddp-zone-MO': 49.82,
                      'passport-priority-ddp-zone-MG': 62.32,
                      'passport-priority-ddp-zone-MW': 62.32,
                      'passport-priority-ddp-zone-MY': 49.76,
                      'passport-priority-ddp-zone-MV': 55.77,
                      'passport-priority-ddp-zone-ML': 62.32,
                      'passport-priority-ddp-zone-MR': 62.32,
                      'passport-priority-ddp-zone-MU': 62.32,
                      'passport-priority-ddp-zone-MD': 62.32,
                      'passport-priority-ddp-zone-MA': 62.23,
                      'passport-priority-ddp-zone-MZ': 62.32,
                      'passport-priority-ddp-zone-NA': 62.32,
                      'passport-priority-ddp-zone-NP': 55.77,
                      'passport-priority-ddp-zone-NE': 62.32,
                      'passport-priority-ddp-zone-NG': 62.32,
                      'passport-priority-ddp-zone-PK': 55.77,
                      'passport-priority-ddp-zone-PH': 49.76,
                      'passport-priority-ddp-zone-RE': 62.32,
                      'passport-priority-ddp-zone-RW': 62.32,
                      'passport-priority-ddp-zone-SN': 62.32,
                      'passport-priority-ddp-zone-SC': 62.32,
                      'passport-priority-ddp-zone-ZA': 57.77,
                      'passport-priority-ddp-zone-LK': 55.77,
                      'passport-priority-ddp-zone-SZ': 62.32,
                      'passport-priority-ddp-zone-TW': 49.76,
                      'passport-priority-ddp-zone-TJ': 62.32,
                      'passport-priority-ddp-zone-TZ': 62.32,
                      'passport-priority-ddp-zone-TG': 62.32,
                      'passport-priority-ddp-zone-TN': 62.32,
                      'passport-priority-ddp-zone-TR': 49.76,
                      'passport-priority-ddp-zone-TM': 62.32,
                      'passport-priority-ddp-zone-UG': 62.32,
                      'passport-priority-ddp-zone-UA': 62.32,
                      'passport-priority-ddp-zone-VN': 49.76,
                      'passport-priority-ddp-zone-YE': 49.76,
                      'passport-priority-ddp-zone-ZM': 62.32,
                      'passport-priority-ddp-zone-ZW': 62.32,
                      'passport-priority-ddp-zone-MC': 15.29,
                      'passport-priority-ddp-zone-IM': 11.32,
                      'passport-priority-ddp-zone-SM': 15.29,
                    },
                    '0.875': {
                      'passport-priority-ddp-zone-CA': 12.78,
                      'passport-priority-ddp-zone-GB': 11.45,
                      'passport-priority-ddp-zone-AU': 16.92,
                      'passport-priority-ddp-zone-BE': 15.5,
                      'passport-priority-ddp-zone-DK': 15.5,
                      'passport-priority-ddp-zone-FR': 15.5,
                      'passport-priority-ddp-zone-DE': 15.5,
                      'passport-priority-ddp-zone-IT': 15.5,
                      'passport-priority-ddp-zone-NL': 15.5,
                      'passport-priority-ddp-zone-ES': 15.5,
                      'passport-priority-ddp-zone-MX': 12.19,
                      'passport-priority-ddp-zone-AM': 47.34,
                      'passport-priority-ddp-zone-AT': 22.4,
                      'passport-priority-ddp-zone-BG': 25.91,
                      'passport-priority-ddp-zone-HR': 24.24,
                      'passport-priority-ddp-zone-CY': 22.4,
                      'passport-priority-ddp-zone-CZ': 22.4,
                      'passport-priority-ddp-zone-EE': 22.4,
                      'passport-priority-ddp-zone-FI': 22.4,
                      'passport-priority-ddp-zone-GR': 22.4,
                      'passport-priority-ddp-zone-HU': 22.4,
                      'passport-priority-ddp-zone-IE': 22.4,
                      'passport-priority-ddp-zone-LV': 22.4,
                      'passport-priority-ddp-zone-LT': 22.4,
                      'passport-priority-ddp-zone-LU': 22.4,
                      'passport-priority-ddp-zone-MT': 22.4,
                      'passport-priority-ddp-zone-PL': 22.4,
                      'passport-priority-ddp-zone-PT': 22.4,
                      'passport-priority-ddp-zone-RO': 22.4,
                      'passport-priority-ddp-zone-SK': 22.4,
                      'passport-priority-ddp-zone-SI': 22.4,
                      'passport-priority-ddp-zone-SE': 22.4,
                      'passport-priority-ddp-zone-IL': 41.27,
                      'passport-priority-ddp-zone-OM': 45.33,
                      'passport-priority-ddp-zone-QA': 41.27,
                      'passport-priority-ddp-zone-SA': 41.27,
                      'passport-priority-ddp-zone-AE': 41.27,
                      'passport-priority-ddp-zone-CN': 20.63,
                      'passport-priority-ddp-zone-HK': 22.19,
                      'passport-priority-ddp-zone-IN': 45.09,
                      'passport-priority-ddp-zone-JP': 22.02,
                      'passport-priority-ddp-zone-KR': 18.9,
                      'passport-priority-ddp-zone-NZ': 18.9,
                      'passport-priority-ddp-zone-SG': 22.19,
                      'passport-priority-ddp-zone-TH': 18.9,
                      'passport-priority-ddp-zone-GG': 48.0,
                      'passport-priority-ddp-zone-JE': 48.0,
                      'passport-priority-ddp-zone-NO': 45.26,
                      'passport-priority-ddp-zone-CH': 45.26,
                      'passport-priority-ddp-zone-IS': 45.26,
                      'passport-priority-ddp-zone-AI': 34.17,
                      'passport-priority-ddp-zone-AG': 34.17,
                      'passport-priority-ddp-zone-AR': 45.05,
                      'passport-priority-ddp-zone-AW': 34.17,
                      'passport-priority-ddp-zone-BS': 34.17,
                      'passport-priority-ddp-zone-BB': 41.72,
                      'passport-priority-ddp-zone-BZ': 41.54,
                      'passport-priority-ddp-zone-BM': 34.33,
                      'passport-priority-ddp-zone-BO': 47.2,
                      'passport-priority-ddp-zone-BR': 20.19,
                      'passport-priority-ddp-zone-KY': 34.17,
                      'passport-priority-ddp-zone-CL': 20.19,
                      'passport-priority-ddp-zone-CO': 20.19,
                      'passport-priority-ddp-zone-CR': 45.54,
                      'passport-priority-ddp-zone-DM': 34.17,
                      'passport-priority-ddp-zone-DO': 34.57,
                      'passport-priority-ddp-zone-EC': 45.79,
                      'passport-priority-ddp-zone-SV': 41.54,
                      'passport-priority-ddp-zone-GP': 51.14,
                      'passport-priority-ddp-zone-GT': 41.64,
                      'passport-priority-ddp-zone-GY': 41.54,
                      'passport-priority-ddp-zone-HT': 34.17,
                      'passport-priority-ddp-zone-JM': 44.35,
                      'passport-priority-ddp-zone-MQ': 39.83,
                      'passport-priority-ddp-zone-AN': 34.17,
                      'passport-priority-ddp-zone-NI': 44.94,
                      'passport-priority-ddp-zone-PA': 41.84,
                      'passport-priority-ddp-zone-PY': 41.54,
                      'passport-priority-ddp-zone-PE': 43.89,
                      'passport-priority-ddp-zone-SR': 41.54,
                      'passport-priority-ddp-zone-TT': 37.0,
                      'passport-priority-ddp-zone-UY': 41.54,
                      'passport-priority-ddp-zone-AF': 62.53,
                      'passport-priority-ddp-zone-DZ': 62.53,
                      'passport-priority-ddp-zone-BH': 49.92,
                      'passport-priority-ddp-zone-BD': 55.95,
                      'passport-priority-ddp-zone-BT': 55.95,
                      'passport-priority-ddp-zone-BA': 62.53,
                      'passport-priority-ddp-zone-BW': 62.53,
                      'passport-priority-ddp-zone-BN': 49.92,
                      'passport-priority-ddp-zone-BF': 62.53,
                      'passport-priority-ddp-zone-BI': 62.53,
                      'passport-priority-ddp-zone-KH': 62.53,
                      'passport-priority-ddp-zone-CM': 62.53,
                      'passport-priority-ddp-zone-CV': 62.53,
                      'passport-priority-ddp-zone-TD': 62.53,
                      'passport-priority-ddp-zone-CG': 62.53,
                      'passport-priority-ddp-zone-CI': 62.53,
                      'passport-priority-ddp-zone-EG': 49.92,
                      'passport-priority-ddp-zone-ET': 62.53,
                      'passport-priority-ddp-zone-GA': 62.53,
                      'passport-priority-ddp-zone-GM': 62.53,
                      'passport-priority-ddp-zone-GH': 62.53,
                      'passport-priority-ddp-zone-GN': 62.53,
                      'passport-priority-ddp-zone-ID': 51.42,
                      'passport-priority-ddp-zone-JO': 49.92,
                      'passport-priority-ddp-zone-KE': 62.53,
                      'passport-priority-ddp-zone-KW': 49.92,
                      'passport-priority-ddp-zone-LB': 49.92,
                      'passport-priority-ddp-zone-LI': 49.92,
                      'passport-priority-ddp-zone-MO': 49.98,
                      'passport-priority-ddp-zone-MG': 62.53,
                      'passport-priority-ddp-zone-MW': 62.53,
                      'passport-priority-ddp-zone-MY': 49.92,
                      'passport-priority-ddp-zone-MV': 55.95,
                      'passport-priority-ddp-zone-ML': 62.53,
                      'passport-priority-ddp-zone-MR': 62.53,
                      'passport-priority-ddp-zone-MU': 62.53,
                      'passport-priority-ddp-zone-MD': 62.53,
                      'passport-priority-ddp-zone-MA': 62.44,
                      'passport-priority-ddp-zone-MZ': 62.53,
                      'passport-priority-ddp-zone-NA': 62.53,
                      'passport-priority-ddp-zone-NP': 55.95,
                      'passport-priority-ddp-zone-NE': 62.53,
                      'passport-priority-ddp-zone-NG': 62.53,
                      'passport-priority-ddp-zone-PK': 55.95,
                      'passport-priority-ddp-zone-PH': 49.92,
                      'passport-priority-ddp-zone-RE': 62.53,
                      'passport-priority-ddp-zone-RW': 62.53,
                      'passport-priority-ddp-zone-SN': 62.53,
                      'passport-priority-ddp-zone-SC': 62.53,
                      'passport-priority-ddp-zone-ZA': 57.96,
                      'passport-priority-ddp-zone-LK': 55.95,
                      'passport-priority-ddp-zone-SZ': 62.53,
                      'passport-priority-ddp-zone-TW': 49.92,
                      'passport-priority-ddp-zone-TJ': 62.53,
                      'passport-priority-ddp-zone-TZ': 62.53,
                      'passport-priority-ddp-zone-TG': 62.53,
                      'passport-priority-ddp-zone-TN': 62.53,
                      'passport-priority-ddp-zone-TR': 49.92,
                      'passport-priority-ddp-zone-TM': 62.53,
                      'passport-priority-ddp-zone-UG': 62.53,
                      'passport-priority-ddp-zone-UA': 62.53,
                      'passport-priority-ddp-zone-VN': 49.92,
                      'passport-priority-ddp-zone-YE': 49.92,
                      'passport-priority-ddp-zone-ZM': 62.53,
                      'passport-priority-ddp-zone-ZW': 62.53,
                      'passport-priority-ddp-zone-MC': 15.5,
                      'passport-priority-ddp-zone-IM': 11.45,
                      'passport-priority-ddp-zone-SM': 15.5,
                    },
                    '0.9375': {
                      'passport-priority-ddp-zone-CA': 12.85,
                      'passport-priority-ddp-zone-GB': 11.61,
                      'passport-priority-ddp-zone-AU': 17.08,
                      'passport-priority-ddp-zone-BE': 15.7,
                      'passport-priority-ddp-zone-DK': 15.7,
                      'passport-priority-ddp-zone-FR': 15.7,
                      'passport-priority-ddp-zone-DE': 15.7,
                      'passport-priority-ddp-zone-IT': 15.7,
                      'passport-priority-ddp-zone-NL': 15.7,
                      'passport-priority-ddp-zone-ES': 15.7,
                      'passport-priority-ddp-zone-MX': 12.3,
                      'passport-priority-ddp-zone-AM': 47.42,
                      'passport-priority-ddp-zone-AT': 22.6,
                      'passport-priority-ddp-zone-BG': 26.14,
                      'passport-priority-ddp-zone-HR': 24.47,
                      'passport-priority-ddp-zone-CY': 22.6,
                      'passport-priority-ddp-zone-CZ': 22.6,
                      'passport-priority-ddp-zone-EE': 22.6,
                      'passport-priority-ddp-zone-FI': 22.6,
                      'passport-priority-ddp-zone-GR': 22.6,
                      'passport-priority-ddp-zone-HU': 22.6,
                      'passport-priority-ddp-zone-IE': 22.6,
                      'passport-priority-ddp-zone-LV': 22.6,
                      'passport-priority-ddp-zone-LT': 22.6,
                      'passport-priority-ddp-zone-LU': 22.6,
                      'passport-priority-ddp-zone-MT': 22.6,
                      'passport-priority-ddp-zone-PL': 22.6,
                      'passport-priority-ddp-zone-PT': 22.6,
                      'passport-priority-ddp-zone-RO': 22.6,
                      'passport-priority-ddp-zone-SK': 22.6,
                      'passport-priority-ddp-zone-SI': 22.6,
                      'passport-priority-ddp-zone-SE': 22.6,
                      'passport-priority-ddp-zone-IL': 41.28,
                      'passport-priority-ddp-zone-OM': 45.34,
                      'passport-priority-ddp-zone-QA': 41.28,
                      'passport-priority-ddp-zone-SA': 41.28,
                      'passport-priority-ddp-zone-AE': 41.28,
                      'passport-priority-ddp-zone-CN': 20.72,
                      'passport-priority-ddp-zone-HK': 22.26,
                      'passport-priority-ddp-zone-IN': 45.16,
                      'passport-priority-ddp-zone-JP': 22.09,
                      'passport-priority-ddp-zone-KR': 19.11,
                      'passport-priority-ddp-zone-NZ': 19.11,
                      'passport-priority-ddp-zone-SG': 22.26,
                      'passport-priority-ddp-zone-TH': 19.11,
                      'passport-priority-ddp-zone-GG': 48.16,
                      'passport-priority-ddp-zone-JE': 48.16,
                      'passport-priority-ddp-zone-NO': 45.41,
                      'passport-priority-ddp-zone-CH': 45.41,
                      'passport-priority-ddp-zone-IS': 45.41,
                      'passport-priority-ddp-zone-AI': 34.25,
                      'passport-priority-ddp-zone-AG': 34.25,
                      'passport-priority-ddp-zone-AR': 45.12,
                      'passport-priority-ddp-zone-AW': 34.25,
                      'passport-priority-ddp-zone-BS': 34.25,
                      'passport-priority-ddp-zone-BB': 41.78,
                      'passport-priority-ddp-zone-BZ': 41.62,
                      'passport-priority-ddp-zone-BM': 34.4,
                      'passport-priority-ddp-zone-BO': 47.27,
                      'passport-priority-ddp-zone-BR': 20.3,
                      'passport-priority-ddp-zone-KY': 34.25,
                      'passport-priority-ddp-zone-CL': 20.3,
                      'passport-priority-ddp-zone-CO': 20.3,
                      'passport-priority-ddp-zone-CR': 45.6,
                      'passport-priority-ddp-zone-DM': 34.25,
                      'passport-priority-ddp-zone-DO': 34.65,
                      'passport-priority-ddp-zone-EC': 45.86,
                      'passport-priority-ddp-zone-SV': 41.62,
                      'passport-priority-ddp-zone-GP': 51.22,
                      'passport-priority-ddp-zone-GT': 41.72,
                      'passport-priority-ddp-zone-GY': 41.62,
                      'passport-priority-ddp-zone-HT': 34.25,
                      'passport-priority-ddp-zone-JM': 44.43,
                      'passport-priority-ddp-zone-MQ': 39.9,
                      'passport-priority-ddp-zone-AN': 34.25,
                      'passport-priority-ddp-zone-NI': 45.02,
                      'passport-priority-ddp-zone-PA': 41.92,
                      'passport-priority-ddp-zone-PY': 41.62,
                      'passport-priority-ddp-zone-PE': 43.96,
                      'passport-priority-ddp-zone-SR': 41.62,
                      'passport-priority-ddp-zone-TT': 37.07,
                      'passport-priority-ddp-zone-UY': 41.62,
                      'passport-priority-ddp-zone-AF': 62.74,
                      'passport-priority-ddp-zone-DZ': 62.74,
                      'passport-priority-ddp-zone-BH': 50.08,
                      'passport-priority-ddp-zone-BD': 56.13,
                      'passport-priority-ddp-zone-BT': 56.13,
                      'passport-priority-ddp-zone-BA': 62.74,
                      'passport-priority-ddp-zone-BW': 62.74,
                      'passport-priority-ddp-zone-BN': 50.08,
                      'passport-priority-ddp-zone-BF': 62.74,
                      'passport-priority-ddp-zone-BI': 62.74,
                      'passport-priority-ddp-zone-KH': 62.74,
                      'passport-priority-ddp-zone-CM': 62.74,
                      'passport-priority-ddp-zone-CV': 62.74,
                      'passport-priority-ddp-zone-TD': 62.74,
                      'passport-priority-ddp-zone-CG': 62.74,
                      'passport-priority-ddp-zone-CI': 62.74,
                      'passport-priority-ddp-zone-EG': 50.08,
                      'passport-priority-ddp-zone-ET': 62.74,
                      'passport-priority-ddp-zone-GA': 62.74,
                      'passport-priority-ddp-zone-GM': 62.74,
                      'passport-priority-ddp-zone-GH': 62.74,
                      'passport-priority-ddp-zone-GN': 62.74,
                      'passport-priority-ddp-zone-ID': 51.59,
                      'passport-priority-ddp-zone-JO': 50.08,
                      'passport-priority-ddp-zone-KE': 62.74,
                      'passport-priority-ddp-zone-KW': 50.08,
                      'passport-priority-ddp-zone-LB': 50.08,
                      'passport-priority-ddp-zone-LI': 50.08,
                      'passport-priority-ddp-zone-MO': 50.14,
                      'passport-priority-ddp-zone-MG': 62.74,
                      'passport-priority-ddp-zone-MW': 62.74,
                      'passport-priority-ddp-zone-MY': 50.08,
                      'passport-priority-ddp-zone-MV': 56.13,
                      'passport-priority-ddp-zone-ML': 62.74,
                      'passport-priority-ddp-zone-MR': 62.74,
                      'passport-priority-ddp-zone-MU': 62.74,
                      'passport-priority-ddp-zone-MD': 62.74,
                      'passport-priority-ddp-zone-MA': 62.65,
                      'passport-priority-ddp-zone-MZ': 62.74,
                      'passport-priority-ddp-zone-NA': 62.74,
                      'passport-priority-ddp-zone-NP': 56.13,
                      'passport-priority-ddp-zone-NE': 62.74,
                      'passport-priority-ddp-zone-NG': 62.74,
                      'passport-priority-ddp-zone-PK': 56.13,
                      'passport-priority-ddp-zone-PH': 50.08,
                      'passport-priority-ddp-zone-RE': 62.74,
                      'passport-priority-ddp-zone-RW': 62.74,
                      'passport-priority-ddp-zone-SN': 62.74,
                      'passport-priority-ddp-zone-SC': 62.74,
                      'passport-priority-ddp-zone-ZA': 58.15,
                      'passport-priority-ddp-zone-LK': 56.13,
                      'passport-priority-ddp-zone-SZ': 62.74,
                      'passport-priority-ddp-zone-TW': 50.08,
                      'passport-priority-ddp-zone-TJ': 62.74,
                      'passport-priority-ddp-zone-TZ': 62.74,
                      'passport-priority-ddp-zone-TG': 62.74,
                      'passport-priority-ddp-zone-TN': 62.74,
                      'passport-priority-ddp-zone-TR': 50.08,
                      'passport-priority-ddp-zone-TM': 62.74,
                      'passport-priority-ddp-zone-UG': 62.74,
                      'passport-priority-ddp-zone-UA': 62.74,
                      'passport-priority-ddp-zone-VN': 50.08,
                      'passport-priority-ddp-zone-YE': 50.08,
                      'passport-priority-ddp-zone-ZM': 62.74,
                      'passport-priority-ddp-zone-ZW': 62.74,
                      'passport-priority-ddp-zone-MC': 15.7,
                      'passport-priority-ddp-zone-IM': 11.61,
                      'passport-priority-ddp-zone-SM': 15.7,
                    },
                    '1.25': {
                      'passport-priority-ddp-zone-CA': 13.22,
                      'passport-priority-ddp-zone-GB': 12.47,
                      'passport-priority-ddp-zone-AU': 18.28,
                      'passport-priority-ddp-zone-BE': 17.8,
                      'passport-priority-ddp-zone-DK': 17.8,
                      'passport-priority-ddp-zone-FR': 17.8,
                      'passport-priority-ddp-zone-DE': 17.8,
                      'passport-priority-ddp-zone-IT': 17.8,
                      'passport-priority-ddp-zone-NL': 17.8,
                      'passport-priority-ddp-zone-ES': 17.8,
                      'passport-priority-ddp-zone-MX': 13.26,
                      'passport-priority-ddp-zone-AM': 47.77,
                      'passport-priority-ddp-zone-AT': 24.37,
                      'passport-priority-ddp-zone-BG': 27.49,
                      'passport-priority-ddp-zone-HR': 25.95,
                      'passport-priority-ddp-zone-CY': 24.37,
                      'passport-priority-ddp-zone-CZ': 24.37,
                      'passport-priority-ddp-zone-EE': 24.37,
                      'passport-priority-ddp-zone-FI': 24.37,
                      'passport-priority-ddp-zone-GR': 24.37,
                      'passport-priority-ddp-zone-HU': 24.37,
                      'passport-priority-ddp-zone-IE': 24.37,
                      'passport-priority-ddp-zone-LV': 24.37,
                      'passport-priority-ddp-zone-LT': 24.37,
                      'passport-priority-ddp-zone-LU': 24.37,
                      'passport-priority-ddp-zone-MT': 24.37,
                      'passport-priority-ddp-zone-PL': 24.37,
                      'passport-priority-ddp-zone-PT': 24.37,
                      'passport-priority-ddp-zone-RO': 24.37,
                      'passport-priority-ddp-zone-SK': 24.37,
                      'passport-priority-ddp-zone-SI': 24.37,
                      'passport-priority-ddp-zone-SE': 24.37,
                      'passport-priority-ddp-zone-IL': 44.61,
                      'passport-priority-ddp-zone-OM': 51.19,
                      'passport-priority-ddp-zone-QA': 44.21,
                      'passport-priority-ddp-zone-SA': 44.23,
                      'passport-priority-ddp-zone-AE': 44.52,
                      'passport-priority-ddp-zone-CN': 29.48,
                      'passport-priority-ddp-zone-HK': 26.09,
                      'passport-priority-ddp-zone-IN': 47.35,
                      'passport-priority-ddp-zone-JP': 30.79,
                      'passport-priority-ddp-zone-KR': 26.14,
                      'passport-priority-ddp-zone-NZ': 22.55,
                      'passport-priority-ddp-zone-SG': 26.09,
                      'passport-priority-ddp-zone-TH': 23.23,
                      'passport-priority-ddp-zone-GG': 48.48,
                      'passport-priority-ddp-zone-JE': 48.48,
                      'passport-priority-ddp-zone-NO': 45.83,
                      'passport-priority-ddp-zone-CH': 46.23,
                      'passport-priority-ddp-zone-IS': 45.71,
                      'passport-priority-ddp-zone-AI': 34.61,
                      'passport-priority-ddp-zone-AG': 34.61,
                      'passport-priority-ddp-zone-AR': 50.94,
                      'passport-priority-ddp-zone-AW': 34.61,
                      'passport-priority-ddp-zone-BS': 34.61,
                      'passport-priority-ddp-zone-BB': 42.15,
                      'passport-priority-ddp-zone-BZ': 47.43,
                      'passport-priority-ddp-zone-BM': 34.76,
                      'passport-priority-ddp-zone-BO': 53.08,
                      'passport-priority-ddp-zone-BR': 25.19,
                      'passport-priority-ddp-zone-KY': 34.61,
                      'passport-priority-ddp-zone-CL': 25.19,
                      'passport-priority-ddp-zone-CO': 25.19,
                      'passport-priority-ddp-zone-CR': 51.43,
                      'passport-priority-ddp-zone-DM': 34.61,
                      'passport-priority-ddp-zone-DO': 35.01,
                      'passport-priority-ddp-zone-EC': 51.67,
                      'passport-priority-ddp-zone-SV': 47.43,
                      'passport-priority-ddp-zone-GP': 51.57,
                      'passport-priority-ddp-zone-GT': 47.53,
                      'passport-priority-ddp-zone-GY': 47.43,
                      'passport-priority-ddp-zone-HT': 34.61,
                      'passport-priority-ddp-zone-JM': 44.78,
                      'passport-priority-ddp-zone-MQ': 40.26,
                      'passport-priority-ddp-zone-AN': 34.61,
                      'passport-priority-ddp-zone-NI': 50.83,
                      'passport-priority-ddp-zone-PA': 47.73,
                      'passport-priority-ddp-zone-PY': 47.43,
                      'passport-priority-ddp-zone-PE': 49.77,
                      'passport-priority-ddp-zone-SR': 47.43,
                      'passport-priority-ddp-zone-TT': 37.44,
                      'passport-priority-ddp-zone-UY': 47.43,
                      'passport-priority-ddp-zone-AF': 63.76,
                      'passport-priority-ddp-zone-DZ': 63.76,
                      'passport-priority-ddp-zone-BH': 54.73,
                      'passport-priority-ddp-zone-BD': 56.51,
                      'passport-priority-ddp-zone-BT': 56.51,
                      'passport-priority-ddp-zone-BA': 63.76,
                      'passport-priority-ddp-zone-BW': 63.76,
                      'passport-priority-ddp-zone-BN': 54.73,
                      'passport-priority-ddp-zone-BF': 63.76,
                      'passport-priority-ddp-zone-BI': 63.76,
                      'passport-priority-ddp-zone-KH': 63.76,
                      'passport-priority-ddp-zone-CM': 63.76,
                      'passport-priority-ddp-zone-CV': 63.76,
                      'passport-priority-ddp-zone-TD': 63.76,
                      'passport-priority-ddp-zone-CG': 63.76,
                      'passport-priority-ddp-zone-CI': 63.76,
                      'passport-priority-ddp-zone-EG': 54.73,
                      'passport-priority-ddp-zone-ET': 63.76,
                      'passport-priority-ddp-zone-GA': 63.76,
                      'passport-priority-ddp-zone-GM': 63.76,
                      'passport-priority-ddp-zone-GH': 63.76,
                      'passport-priority-ddp-zone-GN': 63.76,
                      'passport-priority-ddp-zone-ID': 54.01,
                      'passport-priority-ddp-zone-JO': 54.73,
                      'passport-priority-ddp-zone-KE': 63.76,
                      'passport-priority-ddp-zone-KW': 54.99,
                      'passport-priority-ddp-zone-LB': 54.73,
                      'passport-priority-ddp-zone-LI': 52.47,
                      'passport-priority-ddp-zone-MO': 53.07,
                      'passport-priority-ddp-zone-MG': 63.76,
                      'passport-priority-ddp-zone-MW': 63.76,
                      'passport-priority-ddp-zone-MY': 51.26,
                      'passport-priority-ddp-zone-MV': 56.51,
                      'passport-priority-ddp-zone-ML': 63.76,
                      'passport-priority-ddp-zone-MR': 63.76,
                      'passport-priority-ddp-zone-MU': 63.76,
                      'passport-priority-ddp-zone-MD': 63.76,
                      'passport-priority-ddp-zone-MA': 64.03,
                      'passport-priority-ddp-zone-MZ': 63.76,
                      'passport-priority-ddp-zone-NA': 63.76,
                      'passport-priority-ddp-zone-NP': 56.51,
                      'passport-priority-ddp-zone-NE': 63.76,
                      'passport-priority-ddp-zone-NG': 63.76,
                      'passport-priority-ddp-zone-PK': 56.51,
                      'passport-priority-ddp-zone-PH': 51.26,
                      'passport-priority-ddp-zone-RE': 63.76,
                      'passport-priority-ddp-zone-RW': 63.76,
                      'passport-priority-ddp-zone-SN': 63.76,
                      'passport-priority-ddp-zone-SC': 63.76,
                      'passport-priority-ddp-zone-ZA': 58.53,
                      'passport-priority-ddp-zone-LK': 56.51,
                      'passport-priority-ddp-zone-SZ': 63.76,
                      'passport-priority-ddp-zone-TW': 51.26,
                      'passport-priority-ddp-zone-TJ': 63.76,
                      'passport-priority-ddp-zone-TZ': 63.76,
                      'passport-priority-ddp-zone-TG': 63.76,
                      'passport-priority-ddp-zone-TN': 63.76,
                      'passport-priority-ddp-zone-TR': 54.76,
                      'passport-priority-ddp-zone-TM': 63.76,
                      'passport-priority-ddp-zone-UG': 63.76,
                      'passport-priority-ddp-zone-UA': 63.76,
                      'passport-priority-ddp-zone-VN': 51.26,
                      'passport-priority-ddp-zone-YE': 54.73,
                      'passport-priority-ddp-zone-ZM': 63.76,
                      'passport-priority-ddp-zone-ZW': 63.76,
                      'passport-priority-ddp-zone-MC': 17.8,
                      'passport-priority-ddp-zone-IM': 12.47,
                      'passport-priority-ddp-zone-SM': 17.8,
                    },
                    '1.5': {
                      'passport-priority-ddp-zone-CA': 13.52,
                      'passport-priority-ddp-zone-GB': 13.37,
                      'passport-priority-ddp-zone-AU': 19.49,
                      'passport-priority-ddp-zone-BE': 18.64,
                      'passport-priority-ddp-zone-DK': 18.64,
                      'passport-priority-ddp-zone-FR': 18.64,
                      'passport-priority-ddp-zone-DE': 18.64,
                      'passport-priority-ddp-zone-IT': 18.64,
                      'passport-priority-ddp-zone-NL': 18.64,
                      'passport-priority-ddp-zone-ES': 18.64,
                      'passport-priority-ddp-zone-MX': 14.59,
                      'passport-priority-ddp-zone-AM': 48.06,
                      'passport-priority-ddp-zone-AT': 25.2,
                      'passport-priority-ddp-zone-BG': 28.44,
                      'passport-priority-ddp-zone-HR': 26.89,
                      'passport-priority-ddp-zone-CY': 25.2,
                      'passport-priority-ddp-zone-CZ': 25.2,
                      'passport-priority-ddp-zone-EE': 25.2,
                      'passport-priority-ddp-zone-FI': 25.2,
                      'passport-priority-ddp-zone-GR': 25.2,
                      'passport-priority-ddp-zone-HU': 25.2,
                      'passport-priority-ddp-zone-IE': 25.2,
                      'passport-priority-ddp-zone-LV': 25.2,
                      'passport-priority-ddp-zone-LT': 25.2,
                      'passport-priority-ddp-zone-LU': 25.2,
                      'passport-priority-ddp-zone-MT': 25.2,
                      'passport-priority-ddp-zone-PL': 25.2,
                      'passport-priority-ddp-zone-PT': 25.2,
                      'passport-priority-ddp-zone-RO': 25.2,
                      'passport-priority-ddp-zone-SK': 25.2,
                      'passport-priority-ddp-zone-SI': 25.2,
                      'passport-priority-ddp-zone-SE': 25.2,
                      'passport-priority-ddp-zone-IL': 48.49,
                      'passport-priority-ddp-zone-OM': 55.64,
                      'passport-priority-ddp-zone-QA': 48.06,
                      'passport-priority-ddp-zone-SA': 48.08,
                      'passport-priority-ddp-zone-AE': 48.4,
                      'passport-priority-ddp-zone-CN': 29.81,
                      'passport-priority-ddp-zone-HK': 26.38,
                      'passport-priority-ddp-zone-IN': 47.63,
                      'passport-priority-ddp-zone-JP': 31.12,
                      'passport-priority-ddp-zone-KR': 26.47,
                      'passport-priority-ddp-zone-NZ': 23.38,
                      'passport-priority-ddp-zone-SG': 26.38,
                      'passport-priority-ddp-zone-TH': 23.56,
                      'passport-priority-ddp-zone-GG': 48.64,
                      'passport-priority-ddp-zone-JE': 48.64,
                      'passport-priority-ddp-zone-NO': 45.89,
                      'passport-priority-ddp-zone-CH': 46.3,
                      'passport-priority-ddp-zone-IS': 45.86,
                      'passport-priority-ddp-zone-AI': 34.9,
                      'passport-priority-ddp-zone-AG': 34.9,
                      'passport-priority-ddp-zone-AR': 51.22,
                      'passport-priority-ddp-zone-AW': 34.9,
                      'passport-priority-ddp-zone-BS': 34.9,
                      'passport-priority-ddp-zone-BB': 42.43,
                      'passport-priority-ddp-zone-BZ': 47.72,
                      'passport-priority-ddp-zone-BM': 35.04,
                      'passport-priority-ddp-zone-BO': 53.38,
                      'passport-priority-ddp-zone-BR': 25.61,
                      'passport-priority-ddp-zone-KY': 34.9,
                      'passport-priority-ddp-zone-CL': 25.61,
                      'passport-priority-ddp-zone-CO': 25.61,
                      'passport-priority-ddp-zone-CR': 51.71,
                      'passport-priority-ddp-zone-DM': 34.9,
                      'passport-priority-ddp-zone-DO': 35.29,
                      'passport-priority-ddp-zone-EC': 51.96,
                      'passport-priority-ddp-zone-SV': 47.72,
                      'passport-priority-ddp-zone-GP': 51.86,
                      'passport-priority-ddp-zone-GT': 47.82,
                      'passport-priority-ddp-zone-GY': 47.72,
                      'passport-priority-ddp-zone-HT': 34.9,
                      'passport-priority-ddp-zone-JM': 45.08,
                      'passport-priority-ddp-zone-MQ': 40.54,
                      'passport-priority-ddp-zone-AN': 34.9,
                      'passport-priority-ddp-zone-NI': 51.11,
                      'passport-priority-ddp-zone-PA': 48.01,
                      'passport-priority-ddp-zone-PY': 47.72,
                      'passport-priority-ddp-zone-PE': 50.06,
                      'passport-priority-ddp-zone-SR': 47.72,
                      'passport-priority-ddp-zone-TT': 37.72,
                      'passport-priority-ddp-zone-UY': 47.72,
                      'passport-priority-ddp-zone-AF': 63.8,
                      'passport-priority-ddp-zone-DZ': 63.8,
                      'passport-priority-ddp-zone-BH': 54.77,
                      'passport-priority-ddp-zone-BD': 56.7,
                      'passport-priority-ddp-zone-BT': 56.7,
                      'passport-priority-ddp-zone-BA': 63.8,
                      'passport-priority-ddp-zone-BW': 63.8,
                      'passport-priority-ddp-zone-BN': 54.77,
                      'passport-priority-ddp-zone-BF': 63.8,
                      'passport-priority-ddp-zone-BI': 63.8,
                      'passport-priority-ddp-zone-KH': 63.8,
                      'passport-priority-ddp-zone-CM': 63.8,
                      'passport-priority-ddp-zone-CV': 63.8,
                      'passport-priority-ddp-zone-TD': 63.8,
                      'passport-priority-ddp-zone-CG': 63.8,
                      'passport-priority-ddp-zone-CI': 63.8,
                      'passport-priority-ddp-zone-EG': 54.77,
                      'passport-priority-ddp-zone-ET': 63.8,
                      'passport-priority-ddp-zone-GA': 63.8,
                      'passport-priority-ddp-zone-GM': 63.8,
                      'passport-priority-ddp-zone-GH': 63.8,
                      'passport-priority-ddp-zone-GN': 63.8,
                      'passport-priority-ddp-zone-ID': 54.07,
                      'passport-priority-ddp-zone-JO': 54.77,
                      'passport-priority-ddp-zone-KE': 63.8,
                      'passport-priority-ddp-zone-KW': 55.05,
                      'passport-priority-ddp-zone-LB': 54.77,
                      'passport-priority-ddp-zone-LI': 52.54,
                      'passport-priority-ddp-zone-MO': 53.13,
                      'passport-priority-ddp-zone-MG': 63.8,
                      'passport-priority-ddp-zone-MW': 63.8,
                      'passport-priority-ddp-zone-MY': 51.32,
                      'passport-priority-ddp-zone-MV': 56.7,
                      'passport-priority-ddp-zone-ML': 63.8,
                      'passport-priority-ddp-zone-MR': 63.8,
                      'passport-priority-ddp-zone-MU': 63.8,
                      'passport-priority-ddp-zone-MD': 63.8,
                      'passport-priority-ddp-zone-MA': 64.09,
                      'passport-priority-ddp-zone-MZ': 63.8,
                      'passport-priority-ddp-zone-NA': 63.8,
                      'passport-priority-ddp-zone-NP': 56.7,
                      'passport-priority-ddp-zone-NE': 63.8,
                      'passport-priority-ddp-zone-NG': 63.8,
                      'passport-priority-ddp-zone-PK': 56.7,
                      'passport-priority-ddp-zone-PH': 51.32,
                      'passport-priority-ddp-zone-RE': 63.8,
                      'passport-priority-ddp-zone-RW': 63.8,
                      'passport-priority-ddp-zone-SN': 63.8,
                      'passport-priority-ddp-zone-SC': 63.8,
                      'passport-priority-ddp-zone-ZA': 58.72,
                      'passport-priority-ddp-zone-LK': 56.7,
                      'passport-priority-ddp-zone-SZ': 63.8,
                      'passport-priority-ddp-zone-TW': 51.32,
                      'passport-priority-ddp-zone-TJ': 63.8,
                      'passport-priority-ddp-zone-TZ': 63.8,
                      'passport-priority-ddp-zone-TG': 63.8,
                      'passport-priority-ddp-zone-TN': 63.8,
                      'passport-priority-ddp-zone-TR': 54.8,
                      'passport-priority-ddp-zone-TM': 63.8,
                      'passport-priority-ddp-zone-UG': 63.8,
                      'passport-priority-ddp-zone-UA': 63.8,
                      'passport-priority-ddp-zone-VN': 51.32,
                      'passport-priority-ddp-zone-YE': 54.77,
                      'passport-priority-ddp-zone-ZM': 63.8,
                      'passport-priority-ddp-zone-ZW': 63.8,
                      'passport-priority-ddp-zone-MC': 18.64,
                      'passport-priority-ddp-zone-IM': 13.37,
                      'passport-priority-ddp-zone-SM': 18.64,
                    },
                    '1.75': {
                      'passport-priority-ddp-zone-CA': 14.98,
                      'passport-priority-ddp-zone-GB': 14.42,
                      'passport-priority-ddp-zone-AU': 20.98,
                      'passport-priority-ddp-zone-BE': 19.48,
                      'passport-priority-ddp-zone-DK': 19.48,
                      'passport-priority-ddp-zone-FR': 19.48,
                      'passport-priority-ddp-zone-DE': 19.48,
                      'passport-priority-ddp-zone-IT': 19.48,
                      'passport-priority-ddp-zone-NL': 19.48,
                      'passport-priority-ddp-zone-ES': 19.48,
                      'passport-priority-ddp-zone-MX': 15.93,
                      'passport-priority-ddp-zone-AM': 48.35,
                      'passport-priority-ddp-zone-AT': 26.04,
                      'passport-priority-ddp-zone-BG': 29.38,
                      'passport-priority-ddp-zone-HR': 27.84,
                      'passport-priority-ddp-zone-CY': 26.04,
                      'passport-priority-ddp-zone-CZ': 26.04,
                      'passport-priority-ddp-zone-EE': 26.04,
                      'passport-priority-ddp-zone-FI': 26.04,
                      'passport-priority-ddp-zone-GR': 26.04,
                      'passport-priority-ddp-zone-HU': 26.04,
                      'passport-priority-ddp-zone-IE': 26.04,
                      'passport-priority-ddp-zone-LV': 26.04,
                      'passport-priority-ddp-zone-LT': 26.04,
                      'passport-priority-ddp-zone-LU': 26.04,
                      'passport-priority-ddp-zone-MT': 26.04,
                      'passport-priority-ddp-zone-PL': 26.04,
                      'passport-priority-ddp-zone-PT': 26.04,
                      'passport-priority-ddp-zone-RO': 26.04,
                      'passport-priority-ddp-zone-SK': 26.04,
                      'passport-priority-ddp-zone-SI': 26.04,
                      'passport-priority-ddp-zone-SE': 26.04,
                      'passport-priority-ddp-zone-IL': 48.61,
                      'passport-priority-ddp-zone-OM': 55.77,
                      'passport-priority-ddp-zone-QA': 48.18,
                      'passport-priority-ddp-zone-SA': 48.2,
                      'passport-priority-ddp-zone-AE': 48.51,
                      'passport-priority-ddp-zone-CN': 30.14,
                      'passport-priority-ddp-zone-HK': 26.67,
                      'passport-priority-ddp-zone-IN': 47.93,
                      'passport-priority-ddp-zone-JP': 31.45,
                      'passport-priority-ddp-zone-KR': 26.79,
                      'passport-priority-ddp-zone-NZ': 24.21,
                      'passport-priority-ddp-zone-SG': 26.67,
                      'passport-priority-ddp-zone-TH': 24.21,
                      'passport-priority-ddp-zone-GG': 48.8,
                      'passport-priority-ddp-zone-JE': 48.8,
                      'passport-priority-ddp-zone-NO': 45.93,
                      'passport-priority-ddp-zone-CH': 46.33,
                      'passport-priority-ddp-zone-IS': 46.01,
                      'passport-priority-ddp-zone-AI': 35.18,
                      'passport-priority-ddp-zone-AG': 35.18,
                      'passport-priority-ddp-zone-AR': 51.51,
                      'passport-priority-ddp-zone-AW': 35.18,
                      'passport-priority-ddp-zone-BS': 35.18,
                      'passport-priority-ddp-zone-BB': 42.72,
                      'passport-priority-ddp-zone-BZ': 48.01,
                      'passport-priority-ddp-zone-BM': 35.34,
                      'passport-priority-ddp-zone-BO': 53.66,
                      'passport-priority-ddp-zone-BR': 26.06,
                      'passport-priority-ddp-zone-KY': 35.18,
                      'passport-priority-ddp-zone-CL': 26.06,
                      'passport-priority-ddp-zone-CO': 26.06,
                      'passport-priority-ddp-zone-CR': 51.99,
                      'passport-priority-ddp-zone-DM': 35.18,
                      'passport-priority-ddp-zone-DO': 35.58,
                      'passport-priority-ddp-zone-EC': 52.25,
                      'passport-priority-ddp-zone-SV': 48.01,
                      'passport-priority-ddp-zone-GP': 52.15,
                      'passport-priority-ddp-zone-GT': 48.11,
                      'passport-priority-ddp-zone-GY': 48.01,
                      'passport-priority-ddp-zone-HT': 35.18,
                      'passport-priority-ddp-zone-JM': 45.36,
                      'passport-priority-ddp-zone-MQ': 40.84,
                      'passport-priority-ddp-zone-AN': 35.18,
                      'passport-priority-ddp-zone-NI': 51.39,
                      'passport-priority-ddp-zone-PA': 48.29,
                      'passport-priority-ddp-zone-PY': 48.01,
                      'passport-priority-ddp-zone-PE': 50.35,
                      'passport-priority-ddp-zone-SR': 48.01,
                      'passport-priority-ddp-zone-TT': 38.01,
                      'passport-priority-ddp-zone-UY': 48.01,
                      'passport-priority-ddp-zone-AF': 63.85,
                      'passport-priority-ddp-zone-DZ': 63.85,
                      'passport-priority-ddp-zone-BH': 54.83,
                      'passport-priority-ddp-zone-BD': 56.89,
                      'passport-priority-ddp-zone-BT': 56.89,
                      'passport-priority-ddp-zone-BA': 63.85,
                      'passport-priority-ddp-zone-BW': 63.85,
                      'passport-priority-ddp-zone-BN': 54.83,
                      'passport-priority-ddp-zone-BF': 63.85,
                      'passport-priority-ddp-zone-BI': 63.85,
                      'passport-priority-ddp-zone-KH': 63.85,
                      'passport-priority-ddp-zone-CM': 63.85,
                      'passport-priority-ddp-zone-CV': 63.85,
                      'passport-priority-ddp-zone-TD': 63.85,
                      'passport-priority-ddp-zone-CG': 63.85,
                      'passport-priority-ddp-zone-CI': 63.85,
                      'passport-priority-ddp-zone-EG': 54.83,
                      'passport-priority-ddp-zone-ET': 63.85,
                      'passport-priority-ddp-zone-GA': 63.85,
                      'passport-priority-ddp-zone-GM': 63.85,
                      'passport-priority-ddp-zone-GH': 63.85,
                      'passport-priority-ddp-zone-GN': 63.85,
                      'passport-priority-ddp-zone-ID': 54.13,
                      'passport-priority-ddp-zone-JO': 54.83,
                      'passport-priority-ddp-zone-KE': 63.85,
                      'passport-priority-ddp-zone-KW': 55.09,
                      'passport-priority-ddp-zone-LB': 54.83,
                      'passport-priority-ddp-zone-LI': 52.56,
                      'passport-priority-ddp-zone-MO': 53.19,
                      'passport-priority-ddp-zone-MG': 63.85,
                      'passport-priority-ddp-zone-MW': 63.85,
                      'passport-priority-ddp-zone-MY': 51.37,
                      'passport-priority-ddp-zone-MV': 56.89,
                      'passport-priority-ddp-zone-ML': 63.85,
                      'passport-priority-ddp-zone-MR': 63.85,
                      'passport-priority-ddp-zone-MU': 63.85,
                      'passport-priority-ddp-zone-MD': 63.85,
                      'passport-priority-ddp-zone-MA': 64.13,
                      'passport-priority-ddp-zone-MZ': 63.85,
                      'passport-priority-ddp-zone-NA': 63.85,
                      'passport-priority-ddp-zone-NP': 56.89,
                      'passport-priority-ddp-zone-NE': 63.85,
                      'passport-priority-ddp-zone-NG': 63.85,
                      'passport-priority-ddp-zone-PK': 56.89,
                      'passport-priority-ddp-zone-PH': 51.37,
                      'passport-priority-ddp-zone-RE': 63.85,
                      'passport-priority-ddp-zone-RW': 63.85,
                      'passport-priority-ddp-zone-SN': 63.85,
                      'passport-priority-ddp-zone-SC': 63.85,
                      'passport-priority-ddp-zone-ZA': 58.91,
                      'passport-priority-ddp-zone-LK': 56.89,
                      'passport-priority-ddp-zone-SZ': 63.85,
                      'passport-priority-ddp-zone-TW': 51.37,
                      'passport-priority-ddp-zone-TJ': 63.85,
                      'passport-priority-ddp-zone-TZ': 63.85,
                      'passport-priority-ddp-zone-TG': 63.85,
                      'passport-priority-ddp-zone-TN': 63.85,
                      'passport-priority-ddp-zone-TR': 54.84,
                      'passport-priority-ddp-zone-TM': 63.85,
                      'passport-priority-ddp-zone-UG': 63.85,
                      'passport-priority-ddp-zone-UA': 63.85,
                      'passport-priority-ddp-zone-VN': 51.37,
                      'passport-priority-ddp-zone-YE': 54.83,
                      'passport-priority-ddp-zone-ZM': 63.85,
                      'passport-priority-ddp-zone-ZW': 63.85,
                      'passport-priority-ddp-zone-MC': 19.48,
                      'passport-priority-ddp-zone-IM': 14.42,
                      'passport-priority-ddp-zone-SM': 19.48,
                    },
                    '2.25': {
                      'passport-priority-ddp-zone-CA': 16.34,
                      'passport-priority-ddp-zone-GB': 16.53,
                      'passport-priority-ddp-zone-AU': 23.97,
                      'passport-priority-ddp-zone-BE': 22.36,
                      'passport-priority-ddp-zone-DK': 22.36,
                      'passport-priority-ddp-zone-FR': 22.36,
                      'passport-priority-ddp-zone-DE': 22.36,
                      'passport-priority-ddp-zone-IT': 22.36,
                      'passport-priority-ddp-zone-NL': 22.36,
                      'passport-priority-ddp-zone-ES': 22.36,
                      'passport-priority-ddp-zone-MX': 18.58,
                      'passport-priority-ddp-zone-AM': 51.92,
                      'passport-priority-ddp-zone-AT': 28.8,
                      'passport-priority-ddp-zone-BG': 31.46,
                      'passport-priority-ddp-zone-HR': 30.14,
                      'passport-priority-ddp-zone-CY': 28.8,
                      'passport-priority-ddp-zone-CZ': 28.8,
                      'passport-priority-ddp-zone-EE': 28.8,
                      'passport-priority-ddp-zone-FI': 28.8,
                      'passport-priority-ddp-zone-GR': 28.8,
                      'passport-priority-ddp-zone-HU': 28.8,
                      'passport-priority-ddp-zone-IE': 28.8,
                      'passport-priority-ddp-zone-LV': 28.8,
                      'passport-priority-ddp-zone-LT': 28.8,
                      'passport-priority-ddp-zone-LU': 28.8,
                      'passport-priority-ddp-zone-MT': 28.8,
                      'passport-priority-ddp-zone-PL': 28.8,
                      'passport-priority-ddp-zone-PT': 28.8,
                      'passport-priority-ddp-zone-RO': 28.8,
                      'passport-priority-ddp-zone-SK': 28.8,
                      'passport-priority-ddp-zone-SI': 28.8,
                      'passport-priority-ddp-zone-SE': 28.8,
                      'passport-priority-ddp-zone-IL': 57.2,
                      'passport-priority-ddp-zone-OM': 64.85,
                      'passport-priority-ddp-zone-QA': 56.73,
                      'passport-priority-ddp-zone-SA': 56.76,
                      'passport-priority-ddp-zone-AE': 57.1,
                      'passport-priority-ddp-zone-CN': 39.14,
                      'passport-priority-ddp-zone-HK': 31.52,
                      'passport-priority-ddp-zone-IN': 49.64,
                      'passport-priority-ddp-zone-JP': 40.38,
                      'passport-priority-ddp-zone-KR': 34.36,
                      'passport-priority-ddp-zone-NZ': 28.28,
                      'passport-priority-ddp-zone-SG': 31.52,
                      'passport-priority-ddp-zone-TH': 30.34,
                      'passport-priority-ddp-zone-GG': 51.29,
                      'passport-priority-ddp-zone-JE': 51.29,
                      'passport-priority-ddp-zone-NO': 50.44,
                      'passport-priority-ddp-zone-CH': 50.85,
                      'passport-priority-ddp-zone-IS': 46.93,
                      'passport-priority-ddp-zone-AI': 35.76,
                      'passport-priority-ddp-zone-AG': 35.76,
                      'passport-priority-ddp-zone-AR': 57.55,
                      'passport-priority-ddp-zone-AW': 35.76,
                      'passport-priority-ddp-zone-BS': 35.76,
                      'passport-priority-ddp-zone-BB': 43.29,
                      'passport-priority-ddp-zone-BZ': 54.05,
                      'passport-priority-ddp-zone-BM': 35.92,
                      'passport-priority-ddp-zone-BO': 59.71,
                      'passport-priority-ddp-zone-BR': 31.92,
                      'passport-priority-ddp-zone-KY': 35.76,
                      'passport-priority-ddp-zone-CL': 32.23,
                      'passport-priority-ddp-zone-CO': 31.92,
                      'passport-priority-ddp-zone-CR': 58.04,
                      'passport-priority-ddp-zone-DM': 35.76,
                      'passport-priority-ddp-zone-DO': 36.15,
                      'passport-priority-ddp-zone-EC': 58.29,
                      'passport-priority-ddp-zone-SV': 54.05,
                      'passport-priority-ddp-zone-GP': 52.72,
                      'passport-priority-ddp-zone-GT': 54.15,
                      'passport-priority-ddp-zone-GY': 54.05,
                      'passport-priority-ddp-zone-HT': 35.76,
                      'passport-priority-ddp-zone-JM': 45.94,
                      'passport-priority-ddp-zone-MQ': 41.42,
                      'passport-priority-ddp-zone-AN': 35.76,
                      'passport-priority-ddp-zone-NI': 57.44,
                      'passport-priority-ddp-zone-PA': 54.34,
                      'passport-priority-ddp-zone-PY': 54.05,
                      'passport-priority-ddp-zone-PE': 56.39,
                      'passport-priority-ddp-zone-SR': 54.05,
                      'passport-priority-ddp-zone-TT': 38.58,
                      'passport-priority-ddp-zone-UY': 54.05,
                      'passport-priority-ddp-zone-AF': 78.78,
                      'passport-priority-ddp-zone-DZ': 78.78,
                      'passport-priority-ddp-zone-BH': 70.07,
                      'passport-priority-ddp-zone-BD': 71.84,
                      'passport-priority-ddp-zone-BT': 71.84,
                      'passport-priority-ddp-zone-BA': 78.78,
                      'passport-priority-ddp-zone-BW': 78.78,
                      'passport-priority-ddp-zone-BN': 70.07,
                      'passport-priority-ddp-zone-BF': 78.78,
                      'passport-priority-ddp-zone-BI': 78.78,
                      'passport-priority-ddp-zone-KH': 78.78,
                      'passport-priority-ddp-zone-CM': 78.78,
                      'passport-priority-ddp-zone-CV': 78.78,
                      'passport-priority-ddp-zone-TD': 78.78,
                      'passport-priority-ddp-zone-CG': 78.78,
                      'passport-priority-ddp-zone-CI': 78.78,
                      'passport-priority-ddp-zone-EG': 70.07,
                      'passport-priority-ddp-zone-ET': 78.78,
                      'passport-priority-ddp-zone-GA': 78.78,
                      'passport-priority-ddp-zone-GM': 78.78,
                      'passport-priority-ddp-zone-GH': 78.78,
                      'passport-priority-ddp-zone-GN': 78.78,
                      'passport-priority-ddp-zone-ID': 66.76,
                      'passport-priority-ddp-zone-JO': 70.07,
                      'passport-priority-ddp-zone-KE': 78.78,
                      'passport-priority-ddp-zone-KW': 70.38,
                      'passport-priority-ddp-zone-LB': 70.07,
                      'passport-priority-ddp-zone-LI': 63.78,
                      'passport-priority-ddp-zone-MO': 65.72,
                      'passport-priority-ddp-zone-MG': 78.78,
                      'passport-priority-ddp-zone-MW': 78.78,
                      'passport-priority-ddp-zone-MY': 59.99,
                      'passport-priority-ddp-zone-MV': 71.84,
                      'passport-priority-ddp-zone-ML': 78.78,
                      'passport-priority-ddp-zone-MR': 78.78,
                      'passport-priority-ddp-zone-MU': 78.78,
                      'passport-priority-ddp-zone-MD': 78.78,
                      'passport-priority-ddp-zone-MA': 79.1,
                      'passport-priority-ddp-zone-MZ': 78.78,
                      'passport-priority-ddp-zone-NA': 78.78,
                      'passport-priority-ddp-zone-NP': 71.84,
                      'passport-priority-ddp-zone-NE': 78.78,
                      'passport-priority-ddp-zone-NG': 78.78,
                      'passport-priority-ddp-zone-PK': 71.84,
                      'passport-priority-ddp-zone-PH': 59.99,
                      'passport-priority-ddp-zone-RE': 78.78,
                      'passport-priority-ddp-zone-RW': 78.78,
                      'passport-priority-ddp-zone-SN': 78.78,
                      'passport-priority-ddp-zone-SC': 78.78,
                      'passport-priority-ddp-zone-ZA': 67.59,
                      'passport-priority-ddp-zone-LK': 71.84,
                      'passport-priority-ddp-zone-SZ': 78.78,
                      'passport-priority-ddp-zone-TW': 59.99,
                      'passport-priority-ddp-zone-TJ': 78.78,
                      'passport-priority-ddp-zone-TZ': 78.78,
                      'passport-priority-ddp-zone-TG': 78.78,
                      'passport-priority-ddp-zone-TN': 78.78,
                      'passport-priority-ddp-zone-TR': 70.11,
                      'passport-priority-ddp-zone-TM': 78.78,
                      'passport-priority-ddp-zone-UG': 78.78,
                      'passport-priority-ddp-zone-UA': 78.78,
                      'passport-priority-ddp-zone-VN': 59.99,
                      'passport-priority-ddp-zone-YE': 70.07,
                      'passport-priority-ddp-zone-ZM': 78.78,
                      'passport-priority-ddp-zone-ZW': 78.78,
                      'passport-priority-ddp-zone-MC': 22.36,
                      'passport-priority-ddp-zone-IM': 16.53,
                      'passport-priority-ddp-zone-SM': 22.36,
                    },
                    '2.5': {
                      'passport-priority-ddp-zone-CA': 16.63,
                      'passport-priority-ddp-zone-GB': 17.58,
                      'passport-priority-ddp-zone-AU': 25.46,
                      'passport-priority-ddp-zone-BE': 23.19,
                      'passport-priority-ddp-zone-DK': 23.19,
                      'passport-priority-ddp-zone-FR': 23.19,
                      'passport-priority-ddp-zone-DE': 23.19,
                      'passport-priority-ddp-zone-IT': 23.19,
                      'passport-priority-ddp-zone-NL': 23.19,
                      'passport-priority-ddp-zone-ES': 23.19,
                      'passport-priority-ddp-zone-MX': 19.92,
                      'passport-priority-ddp-zone-AM': 52.2,
                      'passport-priority-ddp-zone-AT': 29.63,
                      'passport-priority-ddp-zone-BG': 32.4,
                      'passport-priority-ddp-zone-HR': 31.09,
                      'passport-priority-ddp-zone-CY': 29.69,
                      'passport-priority-ddp-zone-CZ': 29.63,
                      'passport-priority-ddp-zone-EE': 29.63,
                      'passport-priority-ddp-zone-FI': 29.63,
                      'passport-priority-ddp-zone-GR': 29.63,
                      'passport-priority-ddp-zone-HU': 29.63,
                      'passport-priority-ddp-zone-IE': 29.63,
                      'passport-priority-ddp-zone-LV': 29.63,
                      'passport-priority-ddp-zone-LT': 29.63,
                      'passport-priority-ddp-zone-LU': 29.63,
                      'passport-priority-ddp-zone-MT': 29.63,
                      'passport-priority-ddp-zone-PL': 29.63,
                      'passport-priority-ddp-zone-PT': 29.63,
                      'passport-priority-ddp-zone-RO': 29.63,
                      'passport-priority-ddp-zone-SK': 29.63,
                      'passport-priority-ddp-zone-SI': 29.63,
                      'passport-priority-ddp-zone-SE': 29.63,
                      'passport-priority-ddp-zone-IL': 57.29,
                      'passport-priority-ddp-zone-OM': 64.95,
                      'passport-priority-ddp-zone-QA': 56.83,
                      'passport-priority-ddp-zone-SA': 56.86,
                      'passport-priority-ddp-zone-AE': 57.2,
                      'passport-priority-ddp-zone-CN': 39.47,
                      'passport-priority-ddp-zone-HK': 31.8,
                      'passport-priority-ddp-zone-IN': 49.93,
                      'passport-priority-ddp-zone-JP': 40.71,
                      'passport-priority-ddp-zone-KR': 34.69,
                      'passport-priority-ddp-zone-NZ': 29.1,
                      'passport-priority-ddp-zone-SG': 31.8,
                      'passport-priority-ddp-zone-TH': 30.67,
                      'passport-priority-ddp-zone-GG': 51.58,
                      'passport-priority-ddp-zone-JE': 51.58,
                      'passport-priority-ddp-zone-NO': 50.48,
                      'passport-priority-ddp-zone-CH': 50.89,
                      'passport-priority-ddp-zone-IS': 46.98,
                      'passport-priority-ddp-zone-AI': 36.04,
                      'passport-priority-ddp-zone-AG': 36.04,
                      'passport-priority-ddp-zone-AR': 57.84,
                      'passport-priority-ddp-zone-AW': 36.04,
                      'passport-priority-ddp-zone-BS': 36.04,
                      'passport-priority-ddp-zone-BB': 43.59,
                      'passport-priority-ddp-zone-BZ': 54.33,
                      'passport-priority-ddp-zone-BM': 36.2,
                      'passport-priority-ddp-zone-BO': 59.99,
                      'passport-priority-ddp-zone-BR': 32.36,
                      'passport-priority-ddp-zone-KY': 36.04,
                      'passport-priority-ddp-zone-CL': 32.73,
                      'passport-priority-ddp-zone-CO': 32.36,
                      'passport-priority-ddp-zone-CR': 58.33,
                      'passport-priority-ddp-zone-DM': 36.04,
                      'passport-priority-ddp-zone-DO': 36.44,
                      'passport-priority-ddp-zone-EC': 58.58,
                      'passport-priority-ddp-zone-SV': 54.33,
                      'passport-priority-ddp-zone-GP': 53.01,
                      'passport-priority-ddp-zone-GT': 54.43,
                      'passport-priority-ddp-zone-GY': 54.33,
                      'passport-priority-ddp-zone-HT': 36.04,
                      'passport-priority-ddp-zone-JM': 46.22,
                      'passport-priority-ddp-zone-MQ': 41.7,
                      'passport-priority-ddp-zone-AN': 36.04,
                      'passport-priority-ddp-zone-NI': 57.73,
                      'passport-priority-ddp-zone-PA': 54.63,
                      'passport-priority-ddp-zone-PY': 54.33,
                      'passport-priority-ddp-zone-PE': 56.68,
                      'passport-priority-ddp-zone-SR': 54.33,
                      'passport-priority-ddp-zone-TT': 38.88,
                      'passport-priority-ddp-zone-UY': 54.33,
                      'passport-priority-ddp-zone-AF': 78.82,
                      'passport-priority-ddp-zone-DZ': 78.82,
                      'passport-priority-ddp-zone-BH': 70.11,
                      'passport-priority-ddp-zone-BD': 71.87,
                      'passport-priority-ddp-zone-BT': 71.87,
                      'passport-priority-ddp-zone-BA': 78.82,
                      'passport-priority-ddp-zone-BW': 78.82,
                      'passport-priority-ddp-zone-BN': 70.11,
                      'passport-priority-ddp-zone-BF': 78.82,
                      'passport-priority-ddp-zone-BI': 78.82,
                      'passport-priority-ddp-zone-KH': 78.82,
                      'passport-priority-ddp-zone-CM': 78.82,
                      'passport-priority-ddp-zone-CV': 78.82,
                      'passport-priority-ddp-zone-TD': 78.82,
                      'passport-priority-ddp-zone-CG': 78.82,
                      'passport-priority-ddp-zone-CI': 78.82,
                      'passport-priority-ddp-zone-EG': 70.11,
                      'passport-priority-ddp-zone-ET': 78.82,
                      'passport-priority-ddp-zone-GA': 78.82,
                      'passport-priority-ddp-zone-GM': 78.82,
                      'passport-priority-ddp-zone-GH': 78.82,
                      'passport-priority-ddp-zone-GN': 78.82,
                      'passport-priority-ddp-zone-ID': 66.78,
                      'passport-priority-ddp-zone-JO': 70.11,
                      'passport-priority-ddp-zone-KE': 78.82,
                      'passport-priority-ddp-zone-KW': 70.44,
                      'passport-priority-ddp-zone-LB': 70.11,
                      'passport-priority-ddp-zone-LI': 63.82,
                      'passport-priority-ddp-zone-MO': 65.74,
                      'passport-priority-ddp-zone-MG': 78.82,
                      'passport-priority-ddp-zone-MW': 78.82,
                      'passport-priority-ddp-zone-MY': 60.03,
                      'passport-priority-ddp-zone-MV': 71.87,
                      'passport-priority-ddp-zone-ML': 78.82,
                      'passport-priority-ddp-zone-MR': 78.82,
                      'passport-priority-ddp-zone-MU': 78.82,
                      'passport-priority-ddp-zone-MD': 78.82,
                      'passport-priority-ddp-zone-MA': 79.15,
                      'passport-priority-ddp-zone-MZ': 78.82,
                      'passport-priority-ddp-zone-NA': 78.82,
                      'passport-priority-ddp-zone-NP': 71.87,
                      'passport-priority-ddp-zone-NE': 78.82,
                      'passport-priority-ddp-zone-NG': 78.82,
                      'passport-priority-ddp-zone-PK': 71.87,
                      'passport-priority-ddp-zone-PH': 60.03,
                      'passport-priority-ddp-zone-RE': 78.82,
                      'passport-priority-ddp-zone-RW': 78.82,
                      'passport-priority-ddp-zone-SN': 78.82,
                      'passport-priority-ddp-zone-SC': 78.82,
                      'passport-priority-ddp-zone-ZA': 67.65,
                      'passport-priority-ddp-zone-LK': 71.87,
                      'passport-priority-ddp-zone-SZ': 78.82,
                      'passport-priority-ddp-zone-TW': 60.03,
                      'passport-priority-ddp-zone-TJ': 78.82,
                      'passport-priority-ddp-zone-TZ': 78.82,
                      'passport-priority-ddp-zone-TG': 78.82,
                      'passport-priority-ddp-zone-TN': 78.82,
                      'passport-priority-ddp-zone-TR': 70.15,
                      'passport-priority-ddp-zone-TM': 78.82,
                      'passport-priority-ddp-zone-UG': 78.82,
                      'passport-priority-ddp-zone-UA': 78.82,
                      'passport-priority-ddp-zone-VN': 60.04,
                      'passport-priority-ddp-zone-YE': 70.11,
                      'passport-priority-ddp-zone-ZM': 78.82,
                      'passport-priority-ddp-zone-ZW': 78.82,
                      'passport-priority-ddp-zone-MC': 23.19,
                      'passport-priority-ddp-zone-IM': 17.58,
                      'passport-priority-ddp-zone-SM': 23.19,
                    },
                    '2.75': {
                      'passport-priority-ddp-zone-CA': 16.93,
                      'passport-priority-ddp-zone-GB': 18.63,
                      'passport-priority-ddp-zone-AU': 26.96,
                      'passport-priority-ddp-zone-BE': 24.03,
                      'passport-priority-ddp-zone-DK': 24.03,
                      'passport-priority-ddp-zone-FR': 24.03,
                      'passport-priority-ddp-zone-DE': 24.03,
                      'passport-priority-ddp-zone-IT': 24.03,
                      'passport-priority-ddp-zone-NL': 24.03,
                      'passport-priority-ddp-zone-ES': 24.03,
                      'passport-priority-ddp-zone-MX': 21.24,
                      'passport-priority-ddp-zone-AM': 52.49,
                      'passport-priority-ddp-zone-AT': 30.47,
                      'passport-priority-ddp-zone-BG': 33.35,
                      'passport-priority-ddp-zone-HR': 32.03,
                      'passport-priority-ddp-zone-CY': 30.63,
                      'passport-priority-ddp-zone-CZ': 30.47,
                      'passport-priority-ddp-zone-EE': 30.47,
                      'passport-priority-ddp-zone-FI': 30.47,
                      'passport-priority-ddp-zone-GR': 30.47,
                      'passport-priority-ddp-zone-HU': 30.47,
                      'passport-priority-ddp-zone-IE': 30.47,
                      'passport-priority-ddp-zone-LV': 30.47,
                      'passport-priority-ddp-zone-LT': 30.47,
                      'passport-priority-ddp-zone-LU': 30.47,
                      'passport-priority-ddp-zone-MT': 30.47,
                      'passport-priority-ddp-zone-PL': 30.47,
                      'passport-priority-ddp-zone-PT': 30.47,
                      'passport-priority-ddp-zone-RO': 30.47,
                      'passport-priority-ddp-zone-SK': 30.47,
                      'passport-priority-ddp-zone-SI': 30.47,
                      'passport-priority-ddp-zone-SE': 30.47,
                      'passport-priority-ddp-zone-IL': 60.83,
                      'passport-priority-ddp-zone-OM': 68.94,
                      'passport-priority-ddp-zone-QA': 60.33,
                      'passport-priority-ddp-zone-SA': 60.37,
                      'passport-priority-ddp-zone-AE': 60.71,
                      'passport-priority-ddp-zone-CN': 39.79,
                      'passport-priority-ddp-zone-HK': 32.3,
                      'passport-priority-ddp-zone-IN': 50.22,
                      'passport-priority-ddp-zone-JP': 41.04,
                      'passport-priority-ddp-zone-KR': 35.01,
                      'passport-priority-ddp-zone-NZ': 29.92,
                      'passport-priority-ddp-zone-SG': 32.3,
                      'passport-priority-ddp-zone-TH': 30.99,
                      'passport-priority-ddp-zone-GG': 51.87,
                      'passport-priority-ddp-zone-JE': 51.87,
                      'passport-priority-ddp-zone-NO': 50.54,
                      'passport-priority-ddp-zone-CH': 50.95,
                      'passport-priority-ddp-zone-IS': 47.03,
                      'passport-priority-ddp-zone-AI': 36.33,
                      'passport-priority-ddp-zone-AG': 36.33,
                      'passport-priority-ddp-zone-AR': 58.13,
                      'passport-priority-ddp-zone-AW': 36.33,
                      'passport-priority-ddp-zone-BS': 36.33,
                      'passport-priority-ddp-zone-BB': 43.87,
                      'passport-priority-ddp-zone-BZ': 54.63,
                      'passport-priority-ddp-zone-BM': 36.48,
                      'passport-priority-ddp-zone-BO': 60.28,
                      'passport-priority-ddp-zone-BR': 32.79,
                      'passport-priority-ddp-zone-KY': 36.33,
                      'passport-priority-ddp-zone-CL': 33.25,
                      'passport-priority-ddp-zone-CO': 32.79,
                      'passport-priority-ddp-zone-CR': 58.62,
                      'passport-priority-ddp-zone-DM': 36.33,
                      'passport-priority-ddp-zone-DO': 36.73,
                      'passport-priority-ddp-zone-EC': 58.86,
                      'passport-priority-ddp-zone-SV': 54.63,
                      'passport-priority-ddp-zone-GP': 53.29,
                      'passport-priority-ddp-zone-GT': 54.73,
                      'passport-priority-ddp-zone-GY': 54.63,
                      'passport-priority-ddp-zone-HT': 36.33,
                      'passport-priority-ddp-zone-JM': 46.52,
                      'passport-priority-ddp-zone-MQ': 41.98,
                      'passport-priority-ddp-zone-AN': 36.33,
                      'passport-priority-ddp-zone-NI': 58.02,
                      'passport-priority-ddp-zone-PA': 54.92,
                      'passport-priority-ddp-zone-PY': 54.63,
                      'passport-priority-ddp-zone-PE': 56.97,
                      'passport-priority-ddp-zone-SR': 54.63,
                      'passport-priority-ddp-zone-TT': 39.16,
                      'passport-priority-ddp-zone-UY': 54.63,
                      'passport-priority-ddp-zone-AF': 78.9,
                      'passport-priority-ddp-zone-DZ': 78.9,
                      'passport-priority-ddp-zone-BH': 70.17,
                      'passport-priority-ddp-zone-BD': 71.92,
                      'passport-priority-ddp-zone-BT': 71.92,
                      'passport-priority-ddp-zone-BA': 78.9,
                      'passport-priority-ddp-zone-BW': 78.9,
                      'passport-priority-ddp-zone-BN': 70.17,
                      'passport-priority-ddp-zone-BF': 78.9,
                      'passport-priority-ddp-zone-BI': 78.9,
                      'passport-priority-ddp-zone-KH': 78.9,
                      'passport-priority-ddp-zone-CM': 78.9,
                      'passport-priority-ddp-zone-CV': 78.9,
                      'passport-priority-ddp-zone-TD': 78.9,
                      'passport-priority-ddp-zone-CG': 78.9,
                      'passport-priority-ddp-zone-CI': 78.9,
                      'passport-priority-ddp-zone-EG': 70.17,
                      'passport-priority-ddp-zone-ET': 78.9,
                      'passport-priority-ddp-zone-GA': 78.9,
                      'passport-priority-ddp-zone-GM': 78.9,
                      'passport-priority-ddp-zone-GH': 78.9,
                      'passport-priority-ddp-zone-GN': 78.9,
                      'passport-priority-ddp-zone-ID': 66.86,
                      'passport-priority-ddp-zone-JO': 70.17,
                      'passport-priority-ddp-zone-KE': 78.9,
                      'passport-priority-ddp-zone-KW': 70.47,
                      'passport-priority-ddp-zone-LB': 70.17,
                      'passport-priority-ddp-zone-LI': 63.9,
                      'passport-priority-ddp-zone-MO': 65.81,
                      'passport-priority-ddp-zone-MG': 78.9,
                      'passport-priority-ddp-zone-MW': 78.9,
                      'passport-priority-ddp-zone-MY': 60.09,
                      'passport-priority-ddp-zone-MV': 71.92,
                      'passport-priority-ddp-zone-ML': 78.9,
                      'passport-priority-ddp-zone-MR': 78.9,
                      'passport-priority-ddp-zone-MU': 78.9,
                      'passport-priority-ddp-zone-MD': 78.9,
                      'passport-priority-ddp-zone-MA': 79.21,
                      'passport-priority-ddp-zone-MZ': 78.9,
                      'passport-priority-ddp-zone-NA': 78.9,
                      'passport-priority-ddp-zone-NP': 71.92,
                      'passport-priority-ddp-zone-NE': 78.9,
                      'passport-priority-ddp-zone-NG': 78.9,
                      'passport-priority-ddp-zone-PK': 71.92,
                      'passport-priority-ddp-zone-PH': 60.09,
                      'passport-priority-ddp-zone-RE': 78.9,
                      'passport-priority-ddp-zone-RW': 78.9,
                      'passport-priority-ddp-zone-SN': 78.9,
                      'passport-priority-ddp-zone-SC': 78.9,
                      'passport-priority-ddp-zone-ZA': 67.7,
                      'passport-priority-ddp-zone-LK': 71.92,
                      'passport-priority-ddp-zone-SZ': 78.9,
                      'passport-priority-ddp-zone-TW': 60.09,
                      'passport-priority-ddp-zone-TJ': 78.9,
                      'passport-priority-ddp-zone-TZ': 78.9,
                      'passport-priority-ddp-zone-TG': 78.9,
                      'passport-priority-ddp-zone-TN': 78.9,
                      'passport-priority-ddp-zone-TR': 70.18,
                      'passport-priority-ddp-zone-TM': 78.9,
                      'passport-priority-ddp-zone-UG': 78.9,
                      'passport-priority-ddp-zone-UA': 78.9,
                      'passport-priority-ddp-zone-VN': 60.09,
                      'passport-priority-ddp-zone-YE': 70.17,
                      'passport-priority-ddp-zone-ZM': 78.9,
                      'passport-priority-ddp-zone-ZW': 78.9,
                      'passport-priority-ddp-zone-MC': 24.03,
                      'passport-priority-ddp-zone-IM': 18.63,
                      'passport-priority-ddp-zone-SM': 24.03,
                    },
                    '3.25': {
                      'passport-priority-ddp-zone-CA': 17.54,
                      'passport-priority-ddp-zone-GB': 20.73,
                      'passport-priority-ddp-zone-AU': 29.95,
                      'passport-priority-ddp-zone-BE': 25.71,
                      'passport-priority-ddp-zone-DK': 25.71,
                      'passport-priority-ddp-zone-FR': 25.71,
                      'passport-priority-ddp-zone-DE': 25.71,
                      'passport-priority-ddp-zone-IT': 25.71,
                      'passport-priority-ddp-zone-NL': 25.71,
                      'passport-priority-ddp-zone-ES': 25.71,
                      'passport-priority-ddp-zone-MX': 23.91,
                      'passport-priority-ddp-zone-AM': 60.11,
                      'passport-priority-ddp-zone-AT': 32.15,
                      'passport-priority-ddp-zone-BG': 35.23,
                      'passport-priority-ddp-zone-HR': 33.91,
                      'passport-priority-ddp-zone-CY': 32.52,
                      'passport-priority-ddp-zone-CZ': 32.15,
                      'passport-priority-ddp-zone-EE': 32.15,
                      'passport-priority-ddp-zone-FI': 32.15,
                      'passport-priority-ddp-zone-GR': 32.15,
                      'passport-priority-ddp-zone-HU': 32.15,
                      'passport-priority-ddp-zone-IE': 32.15,
                      'passport-priority-ddp-zone-LV': 32.15,
                      'passport-priority-ddp-zone-LT': 32.15,
                      'passport-priority-ddp-zone-LU': 32.15,
                      'passport-priority-ddp-zone-MT': 32.15,
                      'passport-priority-ddp-zone-PL': 32.15,
                      'passport-priority-ddp-zone-PT': 32.15,
                      'passport-priority-ddp-zone-RO': 32.15,
                      'passport-priority-ddp-zone-SK': 32.15,
                      'passport-priority-ddp-zone-SI': 32.15,
                      'passport-priority-ddp-zone-SE': 32.15,
                      'passport-priority-ddp-zone-IL': 61.12,
                      'passport-priority-ddp-zone-OM': 69.28,
                      'passport-priority-ddp-zone-QA': 60.62,
                      'passport-priority-ddp-zone-SA': 60.66,
                      'passport-priority-ddp-zone-AE': 61.02,
                      'passport-priority-ddp-zone-CN': 40.45,
                      'passport-priority-ddp-zone-HK': 36.63,
                      'passport-priority-ddp-zone-IN': 52.72,
                      'passport-priority-ddp-zone-JP': 41.69,
                      'passport-priority-ddp-zone-KR': 35.66,
                      'passport-priority-ddp-zone-NZ': 33.99,
                      'passport-priority-ddp-zone-SG': 36.63,
                      'passport-priority-ddp-zone-TH': 33.99,
                      'passport-priority-ddp-zone-GG': 64.16,
                      'passport-priority-ddp-zone-JE': 64.16,
                      'passport-priority-ddp-zone-NO': 51.12,
                      'passport-priority-ddp-zone-CH': 51.48,
                      'passport-priority-ddp-zone-IS': 51.09,
                      'passport-priority-ddp-zone-AI': 37.97,
                      'passport-priority-ddp-zone-AG': 37.97,
                      'passport-priority-ddp-zone-AR': 66.68,
                      'passport-priority-ddp-zone-AW': 37.97,
                      'passport-priority-ddp-zone-BS': 37.97,
                      'passport-priority-ddp-zone-BB': 45.51,
                      'passport-priority-ddp-zone-BZ': 63.18,
                      'passport-priority-ddp-zone-BM': 38.12,
                      'passport-priority-ddp-zone-BO': 68.83,
                      'passport-priority-ddp-zone-BR': 37.37,
                      'passport-priority-ddp-zone-KY': 37.97,
                      'passport-priority-ddp-zone-CL': 39.34,
                      'passport-priority-ddp-zone-CO': 37.37,
                      'passport-priority-ddp-zone-CR': 67.17,
                      'passport-priority-ddp-zone-DM': 37.97,
                      'passport-priority-ddp-zone-DO': 38.36,
                      'passport-priority-ddp-zone-EC': 67.42,
                      'passport-priority-ddp-zone-SV': 63.18,
                      'passport-priority-ddp-zone-GP': 54.93,
                      'passport-priority-ddp-zone-GT': 63.27,
                      'passport-priority-ddp-zone-GY': 63.18,
                      'passport-priority-ddp-zone-HT': 37.97,
                      'passport-priority-ddp-zone-JM': 48.15,
                      'passport-priority-ddp-zone-MQ': 43.63,
                      'passport-priority-ddp-zone-AN': 37.97,
                      'passport-priority-ddp-zone-NI': 66.57,
                      'passport-priority-ddp-zone-PA': 63.47,
                      'passport-priority-ddp-zone-PY': 63.18,
                      'passport-priority-ddp-zone-PE': 65.52,
                      'passport-priority-ddp-zone-SR': 63.18,
                      'passport-priority-ddp-zone-TT': 40.79,
                      'passport-priority-ddp-zone-UY': 63.18,
                      'passport-priority-ddp-zone-AF': 92.57,
                      'passport-priority-ddp-zone-DZ': 92.57,
                      'passport-priority-ddp-zone-BH': 87.03,
                      'passport-priority-ddp-zone-BD': 86.42,
                      'passport-priority-ddp-zone-BT': 86.42,
                      'passport-priority-ddp-zone-BA': 92.57,
                      'passport-priority-ddp-zone-BW': 92.57,
                      'passport-priority-ddp-zone-BN': 87.03,
                      'passport-priority-ddp-zone-BF': 92.57,
                      'passport-priority-ddp-zone-BI': 92.57,
                      'passport-priority-ddp-zone-KH': 92.57,
                      'passport-priority-ddp-zone-CM': 92.57,
                      'passport-priority-ddp-zone-CV': 92.57,
                      'passport-priority-ddp-zone-TD': 92.57,
                      'passport-priority-ddp-zone-CG': 92.57,
                      'passport-priority-ddp-zone-CI': 92.57,
                      'passport-priority-ddp-zone-EG': 87.03,
                      'passport-priority-ddp-zone-ET': 92.57,
                      'passport-priority-ddp-zone-GA': 92.57,
                      'passport-priority-ddp-zone-GM': 92.57,
                      'passport-priority-ddp-zone-GH': 92.57,
                      'passport-priority-ddp-zone-GN': 92.57,
                      'passport-priority-ddp-zone-ID': 79.94,
                      'passport-priority-ddp-zone-JO': 87.03,
                      'passport-priority-ddp-zone-KE': 92.57,
                      'passport-priority-ddp-zone-KW': 87.39,
                      'passport-priority-ddp-zone-LB': 87.03,
                      'passport-priority-ddp-zone-LI': 74.68,
                      'passport-priority-ddp-zone-MO': 78.8,
                      'passport-priority-ddp-zone-MG': 92.57,
                      'passport-priority-ddp-zone-MW': 92.57,
                      'passport-priority-ddp-zone-MY': 74.68,
                      'passport-priority-ddp-zone-MV': 86.42,
                      'passport-priority-ddp-zone-ML': 92.57,
                      'passport-priority-ddp-zone-MR': 92.57,
                      'passport-priority-ddp-zone-MU': 92.57,
                      'passport-priority-ddp-zone-MD': 92.57,
                      'passport-priority-ddp-zone-MA': 92.91,
                      'passport-priority-ddp-zone-MZ': 92.57,
                      'passport-priority-ddp-zone-NA': 92.57,
                      'passport-priority-ddp-zone-NP': 86.42,
                      'passport-priority-ddp-zone-NE': 92.57,
                      'passport-priority-ddp-zone-NG': 92.57,
                      'passport-priority-ddp-zone-PK': 86.42,
                      'passport-priority-ddp-zone-PH': 74.68,
                      'passport-priority-ddp-zone-RE': 92.57,
                      'passport-priority-ddp-zone-RW': 92.57,
                      'passport-priority-ddp-zone-SN': 92.57,
                      'passport-priority-ddp-zone-SC': 92.57,
                      'passport-priority-ddp-zone-ZA': 74.68,
                      'passport-priority-ddp-zone-LK': 86.42,
                      'passport-priority-ddp-zone-SZ': 92.57,
                      'passport-priority-ddp-zone-TW': 74.68,
                      'passport-priority-ddp-zone-TJ': 92.57,
                      'passport-priority-ddp-zone-TZ': 92.57,
                      'passport-priority-ddp-zone-TG': 92.57,
                      'passport-priority-ddp-zone-TN': 92.57,
                      'passport-priority-ddp-zone-TR': 87.07,
                      'passport-priority-ddp-zone-TM': 92.57,
                      'passport-priority-ddp-zone-UG': 92.57,
                      'passport-priority-ddp-zone-UA': 92.57,
                      'passport-priority-ddp-zone-VN': 74.68,
                      'passport-priority-ddp-zone-YE': 87.03,
                      'passport-priority-ddp-zone-ZM': 92.57,
                      'passport-priority-ddp-zone-ZW': 92.57,
                      'passport-priority-ddp-zone-MC': 25.71,
                      'passport-priority-ddp-zone-IM': 20.73,
                      'passport-priority-ddp-zone-SM': 25.71,
                    },
                    '3.5': {
                      'passport-priority-ddp-zone-CA': 18.37,
                      'passport-priority-ddp-zone-GB': 21.78,
                      'passport-priority-ddp-zone-AU': 31.44,
                      'passport-priority-ddp-zone-BE': 27.2,
                      'passport-priority-ddp-zone-DK': 27.2,
                      'passport-priority-ddp-zone-FR': 27.2,
                      'passport-priority-ddp-zone-DE': 27.2,
                      'passport-priority-ddp-zone-IT': 27.2,
                      'passport-priority-ddp-zone-NL': 27.2,
                      'passport-priority-ddp-zone-ES': 27.2,
                      'passport-priority-ddp-zone-MX': 25.23,
                      'passport-priority-ddp-zone-AM': 60.4,
                      'passport-priority-ddp-zone-AT': 34.07,
                      'passport-priority-ddp-zone-BG': 36.62,
                      'passport-priority-ddp-zone-HR': 35.08,
                      'passport-priority-ddp-zone-CY': 34.42,
                      'passport-priority-ddp-zone-CZ': 34.07,
                      'passport-priority-ddp-zone-EE': 34.07,
                      'passport-priority-ddp-zone-FI': 34.07,
                      'passport-priority-ddp-zone-GR': 34.07,
                      'passport-priority-ddp-zone-HU': 34.07,
                      'passport-priority-ddp-zone-IE': 34.07,
                      'passport-priority-ddp-zone-LV': 34.07,
                      'passport-priority-ddp-zone-LT': 34.07,
                      'passport-priority-ddp-zone-LU': 34.07,
                      'passport-priority-ddp-zone-MT': 34.07,
                      'passport-priority-ddp-zone-PL': 34.07,
                      'passport-priority-ddp-zone-PT': 34.07,
                      'passport-priority-ddp-zone-RO': 34.07,
                      'passport-priority-ddp-zone-SK': 34.07,
                      'passport-priority-ddp-zone-SI': 34.07,
                      'passport-priority-ddp-zone-SE': 34.07,
                      'passport-priority-ddp-zone-IL': 63.8,
                      'passport-priority-ddp-zone-OM': 71.46,
                      'passport-priority-ddp-zone-QA': 63.34,
                      'passport-priority-ddp-zone-SA': 63.39,
                      'passport-priority-ddp-zone-AE': 63.71,
                      'passport-priority-ddp-zone-CN': 49.14,
                      'passport-priority-ddp-zone-HK': 36.91,
                      'passport-priority-ddp-zone-IN': 53.01,
                      'passport-priority-ddp-zone-JP': 50.3,
                      'passport-priority-ddp-zone-KR': 42.9,
                      'passport-priority-ddp-zone-NZ': 34.83,
                      'passport-priority-ddp-zone-SG': 36.91,
                      'passport-priority-ddp-zone-TH': 37.79,
                      'passport-priority-ddp-zone-GG': 64.44,
                      'passport-priority-ddp-zone-JE': 64.44,
                      'passport-priority-ddp-zone-NO': 51.18,
                      'passport-priority-ddp-zone-CH': 51.55,
                      'passport-priority-ddp-zone-IS': 51.15,
                      'passport-priority-ddp-zone-AI': 38.26,
                      'passport-priority-ddp-zone-AG': 38.26,
                      'passport-priority-ddp-zone-AR': 66.97,
                      'passport-priority-ddp-zone-AW': 38.26,
                      'passport-priority-ddp-zone-BS': 38.26,
                      'passport-priority-ddp-zone-BB': 45.8,
                      'passport-priority-ddp-zone-BZ': 63.47,
                      'passport-priority-ddp-zone-BM': 38.41,
                      'passport-priority-ddp-zone-BO': 69.12,
                      'passport-priority-ddp-zone-BR': 37.81,
                      'passport-priority-ddp-zone-KY': 38.26,
                      'passport-priority-ddp-zone-CL': 39.86,
                      'passport-priority-ddp-zone-CO': 37.81,
                      'passport-priority-ddp-zone-CR': 67.46,
                      'passport-priority-ddp-zone-DM': 38.26,
                      'passport-priority-ddp-zone-DO': 38.66,
                      'passport-priority-ddp-zone-EC': 67.71,
                      'passport-priority-ddp-zone-SV': 63.47,
                      'passport-priority-ddp-zone-GP': 55.22,
                      'passport-priority-ddp-zone-GT': 63.57,
                      'passport-priority-ddp-zone-GY': 63.47,
                      'passport-priority-ddp-zone-HT': 38.26,
                      'passport-priority-ddp-zone-JM': 48.43,
                      'passport-priority-ddp-zone-MQ': 43.91,
                      'passport-priority-ddp-zone-AN': 38.26,
                      'passport-priority-ddp-zone-NI': 66.86,
                      'passport-priority-ddp-zone-PA': 63.76,
                      'passport-priority-ddp-zone-PY': 63.47,
                      'passport-priority-ddp-zone-PE': 65.81,
                      'passport-priority-ddp-zone-SR': 63.47,
                      'passport-priority-ddp-zone-TT': 41.08,
                      'passport-priority-ddp-zone-UY': 63.47,
                      'passport-priority-ddp-zone-AF': 92.64,
                      'passport-priority-ddp-zone-DZ': 92.64,
                      'passport-priority-ddp-zone-BH': 87.05,
                      'passport-priority-ddp-zone-BD': 86.48,
                      'passport-priority-ddp-zone-BT': 86.48,
                      'passport-priority-ddp-zone-BA': 92.64,
                      'passport-priority-ddp-zone-BW': 92.64,
                      'passport-priority-ddp-zone-BN': 87.05,
                      'passport-priority-ddp-zone-BF': 92.64,
                      'passport-priority-ddp-zone-BI': 92.64,
                      'passport-priority-ddp-zone-KH': 92.64,
                      'passport-priority-ddp-zone-CM': 92.64,
                      'passport-priority-ddp-zone-CV': 92.64,
                      'passport-priority-ddp-zone-TD': 92.64,
                      'passport-priority-ddp-zone-CG': 92.64,
                      'passport-priority-ddp-zone-CI': 92.64,
                      'passport-priority-ddp-zone-EG': 87.05,
                      'passport-priority-ddp-zone-ET': 92.64,
                      'passport-priority-ddp-zone-GA': 92.64,
                      'passport-priority-ddp-zone-GM': 92.64,
                      'passport-priority-ddp-zone-GH': 92.64,
                      'passport-priority-ddp-zone-GN': 92.64,
                      'passport-priority-ddp-zone-ID': 79.97,
                      'passport-priority-ddp-zone-JO': 87.05,
                      'passport-priority-ddp-zone-KE': 92.64,
                      'passport-priority-ddp-zone-KW': 87.42,
                      'passport-priority-ddp-zone-LB': 87.05,
                      'passport-priority-ddp-zone-LI': 74.74,
                      'passport-priority-ddp-zone-MO': 78.83,
                      'passport-priority-ddp-zone-MG': 92.64,
                      'passport-priority-ddp-zone-MW': 92.64,
                      'passport-priority-ddp-zone-MY': 74.74,
                      'passport-priority-ddp-zone-MV': 86.48,
                      'passport-priority-ddp-zone-ML': 92.64,
                      'passport-priority-ddp-zone-MR': 92.64,
                      'passport-priority-ddp-zone-MU': 92.64,
                      'passport-priority-ddp-zone-MD': 92.64,
                      'passport-priority-ddp-zone-MA': 92.97,
                      'passport-priority-ddp-zone-MZ': 92.64,
                      'passport-priority-ddp-zone-NA': 92.64,
                      'passport-priority-ddp-zone-NP': 86.48,
                      'passport-priority-ddp-zone-NE': 92.64,
                      'passport-priority-ddp-zone-NG': 92.64,
                      'passport-priority-ddp-zone-PK': 86.48,
                      'passport-priority-ddp-zone-PH': 74.74,
                      'passport-priority-ddp-zone-RE': 92.64,
                      'passport-priority-ddp-zone-RW': 92.64,
                      'passport-priority-ddp-zone-SN': 92.64,
                      'passport-priority-ddp-zone-SC': 92.64,
                      'passport-priority-ddp-zone-ZA': 74.74,
                      'passport-priority-ddp-zone-LK': 86.48,
                      'passport-priority-ddp-zone-SZ': 92.64,
                      'passport-priority-ddp-zone-TW': 74.74,
                      'passport-priority-ddp-zone-TJ': 92.64,
                      'passport-priority-ddp-zone-TZ': 92.64,
                      'passport-priority-ddp-zone-TG': 92.64,
                      'passport-priority-ddp-zone-TN': 92.64,
                      'passport-priority-ddp-zone-TR': 87.1,
                      'passport-priority-ddp-zone-TM': 92.64,
                      'passport-priority-ddp-zone-UG': 92.64,
                      'passport-priority-ddp-zone-UA': 92.64,
                      'passport-priority-ddp-zone-VN': 74.82,
                      'passport-priority-ddp-zone-YE': 87.05,
                      'passport-priority-ddp-zone-ZM': 92.64,
                      'passport-priority-ddp-zone-ZW': 92.64,
                      'passport-priority-ddp-zone-MC': 27.2,
                      'passport-priority-ddp-zone-IM': 21.78,
                      'passport-priority-ddp-zone-SM': 27.2,
                    },
                    '3.75': {
                      'passport-priority-ddp-zone-CA': 18.67,
                      'passport-priority-ddp-zone-GB': 22.83,
                      'passport-priority-ddp-zone-AU': 32.93,
                      'passport-priority-ddp-zone-BE': 28.04,
                      'passport-priority-ddp-zone-DK': 28.04,
                      'passport-priority-ddp-zone-FR': 28.04,
                      'passport-priority-ddp-zone-DE': 28.04,
                      'passport-priority-ddp-zone-IT': 28.04,
                      'passport-priority-ddp-zone-NL': 28.04,
                      'passport-priority-ddp-zone-ES': 28.04,
                      'passport-priority-ddp-zone-MX': 26.57,
                      'passport-priority-ddp-zone-AM': 60.68,
                      'passport-priority-ddp-zone-AT': 34.9,
                      'passport-priority-ddp-zone-BG': 37.57,
                      'passport-priority-ddp-zone-HR': 36.02,
                      'passport-priority-ddp-zone-CY': 35.37,
                      'passport-priority-ddp-zone-CZ': 34.9,
                      'passport-priority-ddp-zone-EE': 34.9,
                      'passport-priority-ddp-zone-FI': 34.9,
                      'passport-priority-ddp-zone-GR': 34.9,
                      'passport-priority-ddp-zone-HU': 34.9,
                      'passport-priority-ddp-zone-IE': 34.9,
                      'passport-priority-ddp-zone-LV': 34.9,
                      'passport-priority-ddp-zone-LT': 34.9,
                      'passport-priority-ddp-zone-LU': 34.9,
                      'passport-priority-ddp-zone-MT': 34.9,
                      'passport-priority-ddp-zone-PL': 34.9,
                      'passport-priority-ddp-zone-PT': 34.9,
                      'passport-priority-ddp-zone-RO': 34.9,
                      'passport-priority-ddp-zone-SK': 34.9,
                      'passport-priority-ddp-zone-SI': 34.9,
                      'passport-priority-ddp-zone-SE': 34.9,
                      'passport-priority-ddp-zone-IL': 63.91,
                      'passport-priority-ddp-zone-OM': 71.57,
                      'passport-priority-ddp-zone-QA': 63.45,
                      'passport-priority-ddp-zone-SA': 63.48,
                      'passport-priority-ddp-zone-AE': 63.82,
                      'passport-priority-ddp-zone-CN': 49.46,
                      'passport-priority-ddp-zone-HK': 37.19,
                      'passport-priority-ddp-zone-IN': 53.29,
                      'passport-priority-ddp-zone-JP': 50.63,
                      'passport-priority-ddp-zone-KR': 43.23,
                      'passport-priority-ddp-zone-NZ': 35.65,
                      'passport-priority-ddp-zone-SG': 37.19,
                      'passport-priority-ddp-zone-TH': 38.11,
                      'passport-priority-ddp-zone-GG': 64.74,
                      'passport-priority-ddp-zone-JE': 64.74,
                      'passport-priority-ddp-zone-NO': 51.22,
                      'passport-priority-ddp-zone-CH': 51.58,
                      'passport-priority-ddp-zone-IS': 51.2,
                      'passport-priority-ddp-zone-AI': 38.54,
                      'passport-priority-ddp-zone-AG': 38.54,
                      'passport-priority-ddp-zone-AR': 67.26,
                      'passport-priority-ddp-zone-AW': 38.54,
                      'passport-priority-ddp-zone-BS': 38.54,
                      'passport-priority-ddp-zone-BB': 46.08,
                      'passport-priority-ddp-zone-BZ': 63.75,
                      'passport-priority-ddp-zone-BM': 38.69,
                      'passport-priority-ddp-zone-BO': 69.41,
                      'passport-priority-ddp-zone-BR': 38.24,
                      'passport-priority-ddp-zone-KY': 38.54,
                      'passport-priority-ddp-zone-CL': 40.36,
                      'passport-priority-ddp-zone-CO': 38.24,
                      'passport-priority-ddp-zone-CR': 67.75,
                      'passport-priority-ddp-zone-DM': 38.54,
                      'passport-priority-ddp-zone-DO': 38.94,
                      'passport-priority-ddp-zone-EC': 67.99,
                      'passport-priority-ddp-zone-SV': 63.75,
                      'passport-priority-ddp-zone-GP': 55.51,
                      'passport-priority-ddp-zone-GT': 63.85,
                      'passport-priority-ddp-zone-GY': 63.75,
                      'passport-priority-ddp-zone-HT': 38.54,
                      'passport-priority-ddp-zone-JM': 48.72,
                      'passport-priority-ddp-zone-MQ': 44.19,
                      'passport-priority-ddp-zone-AN': 38.54,
                      'passport-priority-ddp-zone-NI': 67.15,
                      'passport-priority-ddp-zone-PA': 64.05,
                      'passport-priority-ddp-zone-PY': 63.75,
                      'passport-priority-ddp-zone-PE': 66.09,
                      'passport-priority-ddp-zone-SR': 63.75,
                      'passport-priority-ddp-zone-TT': 41.37,
                      'passport-priority-ddp-zone-UY': 63.75,
                      'passport-priority-ddp-zone-AF': 92.66,
                      'passport-priority-ddp-zone-DZ': 92.66,
                      'passport-priority-ddp-zone-BH': 87.11,
                      'passport-priority-ddp-zone-BD': 86.54,
                      'passport-priority-ddp-zone-BT': 86.54,
                      'passport-priority-ddp-zone-BA': 92.66,
                      'passport-priority-ddp-zone-BW': 92.66,
                      'passport-priority-ddp-zone-BN': 87.11,
                      'passport-priority-ddp-zone-BF': 92.66,
                      'passport-priority-ddp-zone-BI': 92.66,
                      'passport-priority-ddp-zone-KH': 92.66,
                      'passport-priority-ddp-zone-CM': 92.66,
                      'passport-priority-ddp-zone-CV': 92.66,
                      'passport-priority-ddp-zone-TD': 92.66,
                      'passport-priority-ddp-zone-CG': 92.66,
                      'passport-priority-ddp-zone-CI': 92.66,
                      'passport-priority-ddp-zone-EG': 87.11,
                      'passport-priority-ddp-zone-ET': 92.66,
                      'passport-priority-ddp-zone-GA': 92.66,
                      'passport-priority-ddp-zone-GM': 92.66,
                      'passport-priority-ddp-zone-GH': 92.66,
                      'passport-priority-ddp-zone-GN': 92.66,
                      'passport-priority-ddp-zone-ID': 80.03,
                      'passport-priority-ddp-zone-JO': 87.11,
                      'passport-priority-ddp-zone-KE': 92.66,
                      'passport-priority-ddp-zone-KW': 87.45,
                      'passport-priority-ddp-zone-LB': 87.11,
                      'passport-priority-ddp-zone-LI': 74.79,
                      'passport-priority-ddp-zone-MO': 78.89,
                      'passport-priority-ddp-zone-MG': 92.66,
                      'passport-priority-ddp-zone-MW': 92.66,
                      'passport-priority-ddp-zone-MY': 74.79,
                      'passport-priority-ddp-zone-MV': 86.54,
                      'passport-priority-ddp-zone-ML': 92.66,
                      'passport-priority-ddp-zone-MR': 92.66,
                      'passport-priority-ddp-zone-MU': 92.66,
                      'passport-priority-ddp-zone-MD': 92.66,
                      'passport-priority-ddp-zone-MA': 92.98,
                      'passport-priority-ddp-zone-MZ': 92.66,
                      'passport-priority-ddp-zone-NA': 92.66,
                      'passport-priority-ddp-zone-NP': 86.54,
                      'passport-priority-ddp-zone-NE': 92.66,
                      'passport-priority-ddp-zone-NG': 92.66,
                      'passport-priority-ddp-zone-PK': 86.54,
                      'passport-priority-ddp-zone-PH': 74.79,
                      'passport-priority-ddp-zone-RE': 92.66,
                      'passport-priority-ddp-zone-RW': 92.66,
                      'passport-priority-ddp-zone-SN': 92.66,
                      'passport-priority-ddp-zone-SC': 92.66,
                      'passport-priority-ddp-zone-ZA': 74.79,
                      'passport-priority-ddp-zone-LK': 86.54,
                      'passport-priority-ddp-zone-SZ': 92.66,
                      'passport-priority-ddp-zone-TW': 74.79,
                      'passport-priority-ddp-zone-TJ': 92.66,
                      'passport-priority-ddp-zone-TZ': 92.66,
                      'passport-priority-ddp-zone-TG': 92.66,
                      'passport-priority-ddp-zone-TN': 92.66,
                      'passport-priority-ddp-zone-TR': 87.16,
                      'passport-priority-ddp-zone-TM': 92.66,
                      'passport-priority-ddp-zone-UG': 92.66,
                      'passport-priority-ddp-zone-UA': 92.66,
                      'passport-priority-ddp-zone-VN': 74.85,
                      'passport-priority-ddp-zone-YE': 87.11,
                      'passport-priority-ddp-zone-ZM': 92.66,
                      'passport-priority-ddp-zone-ZW': 92.66,
                      'passport-priority-ddp-zone-MC': 28.04,
                      'passport-priority-ddp-zone-IM': 22.83,
                      'passport-priority-ddp-zone-SM': 28.04,
                    },
                  },
                },
                startDateTime: '2022-08-10T01:40:02.623Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:a6fe508b-b658-4131-9dea-5ed88f0cbba7:2',
          },
          tags: [],
        },
      ],
      carrierSettings: {
        carrierSettings: {
          active: true,
          allowLabelGenerationFailover: false,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-08-08T21:24:25.049Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2022-08-09T01:26:57.144Z',
            version: 2,
          },
          carrierId: 'passport',
          carrierSettingsId: 'b412cea6-d4ff-4254-9c88-acfaa288ddee',
          description: '',
          expectedShippingVolumeOveragePercentage: 0.0,
          hazmatLimitedQuantityExempt: false,
          name: 'Passport Settings',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          peakSurchargeEligible: true,
          tagIds: [],
          urn: 'urn:carrierSettings:b412cea6-d4ff-4254-9c88-acfaa288ddee:2',
        },
        tags: [],
      },
      contract: {
        active: true,
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2022-09-19T16:37:03.41Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-09-19T16:37:03.982Z',
          version: 4,
        },
        carrierAccountId: '286b8784-5968-49f8-94c2-d5d6454021bd',
        carrierId: 'passport',
        carrierRateSetId: 'c9d4238a-de17-4e1d-9aab-7102a46f61bd',
        carrierSettingsId: 'b412cea6-d4ff-4254-9c88-acfaa288ddee',
        contractId: '9b3c05e1-f6c1-488c-9e41-4a27011f4789',
        description: '',
        name: 'Stord - Passport Contract (All FCs)',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        tagIds: [],
        urn: 'urn:contract:9b3c05e1-f6c1-488c-9e41-4a27011f4789:4',
      },
      tags: [],
    },
    {
      carrierAccount: {
        carrierAccount: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-07-27T20:56:28.658Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2022-08-04T19:07:47.121Z',
            version: 6,
          },
          carrierAccountId: '67fde367-2163-487c-a6da-4a0154fca495',
          carrierId: 'upsmi',
          credentials: {
            credentialStructureId: 'ups-standard-credentials',
            credentials: {
              'ups-account-number': 'V6143V ',
            },
          },
          description: '',
          name: 'UPS MI (CT)',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          returnToAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          returnToContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
          serviceMethodCredentials: [],
          shipperAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          shipperContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
          tagIds: [],
          urn: 'urn:carrierAccount:67fde367-2163-487c-a6da-4a0154fca495:6',
        },
        returnToAddress: {
          address: {
            active: true,
            addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-06-09T16:52:57.568Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
              version: 1,
            },
            description: ' ',
            location: {
              address1: '297 State Street',
              address2: 'Building 1',
              city: 'North Haven',
              companyName: 'Stord BDL1',
              country: 'US',
              postalCode: '06473',
              region: 'CT',
              validatedAddressMetadata: {
                latitude: 41.38069,
                longitude: -72.85601,
                timeZoneId: 'America/New_York',
              },
            },
            name: 'Stord BDL1',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            tagIds: [],
            urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
          },
          tags: [],
        },
        returnToContact: {
          contact: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              creationTimeStamp: '2022-05-10T01:13:39.191Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-09-14T23:44:14.372Z',
              version: 7,
            },
            contactId: '900ae450-da15-4588-8655-b427e62ccfb1',
            contactName: 'Shipping Department ',
            description: '',
            email: 'sales@stord.com',
            name: 'Shipping Department ',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            phoneNumber: '8337002025',
            tagIds: [],
            urn: 'urn:contact:900ae450-da15-4588-8655-b427e62ccfb1:7',
          },
          tags: [],
        },
        shipperAddress: {
          address: {
            active: true,
            addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-06-09T16:52:57.568Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
              version: 1,
            },
            description: ' ',
            location: {
              address1: '297 State Street',
              address2: 'Building 1',
              city: 'North Haven',
              companyName: 'Stord BDL1',
              country: 'US',
              postalCode: '06473',
              region: 'CT',
              validatedAddressMetadata: {
                latitude: 41.38069,
                longitude: -72.85601,
                timeZoneId: 'America/New_York',
              },
            },
            name: 'Stord BDL1',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            tagIds: [],
            urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
          },
          tags: [],
        },
        shipperContact: {
          contact: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              creationTimeStamp: '2022-05-10T01:13:39.191Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-09-14T23:44:14.372Z',
              version: 7,
            },
            contactId: '900ae450-da15-4588-8655-b427e62ccfb1',
            contactName: 'Shipping Department ',
            description: '',
            email: 'sales@stord.com',
            name: 'Shipping Department ',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            phoneNumber: '8337002025',
            tagIds: [],
            urn: 'urn:contact:900ae450-da15-4588-8655-b427e62ccfb1:7',
          },
          tags: [],
        },
        tags: [],
      },
      carrierRates: [
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '1e49a039-5266-499e-bb23-b8dd97dc07be',
              creationTimeStamp: '2022-07-26T14:53:03.774Z',
              lastUpdatedBy: '7c9f9cca-2cb1-4ae5-8eb8-f87643d4a043',
              lastUpdatedTimeStamp: '2022-08-03T18:12:28.178Z',
              version: 5,
            },
            carrier: 'upsmi',
            carrierRateId: '207302a1-833e-4299-ac58-539027d073aa',
            carrierServiceMethodId: 'upsmi-parcel-select-lightweight-service-method',
            description: '',
            destinationType: 'residential',
            dimWeightOverride: {},
            name: 'UPS Mail Innovations Parcel Select Lightweight',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2025-07-22T14:44:32.132Z',
                negotiatedSurcharges: [
                  {
                    modifierType: 'replacement_percentage',
                    modifierValue: 0.04,
                    name: 'Fuel ',
                    surchargeId: 'fuel_ground',
                  },
                ],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'ups-zone-0': 3.85,
                      'usps-zone-1': 3.85,
                      'usps-zone-2': 3.85,
                      'usps-zone-3': 3.97,
                      'usps-zone-4': 4.04,
                      'usps-zone-5': 4.11,
                      'usps-zone-6': 4.17,
                      'usps-zone-7': 4.3,
                      'usps-zone-8': 4.41,
                    },
                    '0.0625': {
                      'ups-zone-0': 3.06,
                      'usps-zone-1': 3.06,
                      'usps-zone-2': 3.06,
                      'usps-zone-3': 3.09,
                      'usps-zone-4': 3.12,
                      'usps-zone-5': 3.14,
                      'usps-zone-6': 3.16,
                      'usps-zone-7': 3.2,
                      'usps-zone-8': 3.24,
                    },
                    '0.125': {
                      'ups-zone-0': 3.07,
                      'usps-zone-1': 3.07,
                      'usps-zone-2': 3.07,
                      'usps-zone-3': 3.12,
                      'usps-zone-4': 3.14,
                      'usps-zone-5': 3.17,
                      'usps-zone-6': 3.19,
                      'usps-zone-7': 3.23,
                      'usps-zone-8': 3.28,
                    },
                    '0.1875': {
                      'ups-zone-0': 3.08,
                      'usps-zone-1': 3.08,
                      'usps-zone-2': 3.08,
                      'usps-zone-3': 3.13,
                      'usps-zone-4': 3.16,
                      'usps-zone-5': 3.19,
                      'usps-zone-6': 3.22,
                      'usps-zone-7': 3.26,
                      'usps-zone-8': 3.32,
                    },
                    '0.25': {
                      'ups-zone-0': 3.1,
                      'usps-zone-1': 3.1,
                      'usps-zone-2': 3.1,
                      'usps-zone-3': 3.15,
                      'usps-zone-4': 3.18,
                      'usps-zone-5': 3.22,
                      'usps-zone-6': 3.25,
                      'usps-zone-7': 3.3,
                      'usps-zone-8': 3.35,
                    },
                    '0.3125': {
                      'ups-zone-0': 3.14,
                      'usps-zone-1': 3.14,
                      'usps-zone-2': 3.14,
                      'usps-zone-3': 3.2,
                      'usps-zone-4': 3.23,
                      'usps-zone-5': 3.26,
                      'usps-zone-6': 3.3,
                      'usps-zone-7': 3.35,
                      'usps-zone-8': 3.42,
                    },
                    '0.375': {
                      'ups-zone-0': 3.15,
                      'usps-zone-1': 3.15,
                      'usps-zone-2': 3.15,
                      'usps-zone-3': 3.22,
                      'usps-zone-4': 3.25,
                      'usps-zone-5': 3.29,
                      'usps-zone-6': 3.33,
                      'usps-zone-7': 3.39,
                      'usps-zone-8': 3.46,
                    },
                    '0.4375': {
                      'ups-zone-0': 3.18,
                      'usps-zone-1': 3.18,
                      'usps-zone-2': 3.18,
                      'usps-zone-3': 3.25,
                      'usps-zone-4': 3.3,
                      'usps-zone-5': 3.34,
                      'usps-zone-6': 3.38,
                      'usps-zone-7': 3.45,
                      'usps-zone-8': 3.52,
                    },
                    '0.5': {
                      'ups-zone-0': 3.2,
                      'usps-zone-1': 3.2,
                      'usps-zone-2': 3.2,
                      'usps-zone-3': 3.28,
                      'usps-zone-4': 3.32,
                      'usps-zone-5': 3.36,
                      'usps-zone-6': 3.4,
                      'usps-zone-7': 3.48,
                      'usps-zone-8': 3.56,
                    },
                    '0.5625': {
                      'ups-zone-0': 3.45,
                      'usps-zone-1': 3.45,
                      'usps-zone-2': 3.45,
                      'usps-zone-3': 3.54,
                      'usps-zone-4': 3.58,
                      'usps-zone-5': 3.63,
                      'usps-zone-6': 3.68,
                      'usps-zone-7': 3.76,
                      'usps-zone-8': 3.84,
                    },
                    '0.625': {
                      'ups-zone-0': 3.47,
                      'usps-zone-1': 3.47,
                      'usps-zone-2': 3.47,
                      'usps-zone-3': 3.56,
                      'usps-zone-4': 3.61,
                      'usps-zone-5': 3.66,
                      'usps-zone-6': 3.71,
                      'usps-zone-7': 3.79,
                      'usps-zone-8': 3.88,
                    },
                    '0.6875': {
                      'ups-zone-0': 3.48,
                      'usps-zone-1': 3.48,
                      'usps-zone-2': 3.48,
                      'usps-zone-3': 3.58,
                      'usps-zone-4': 3.63,
                      'usps-zone-5': 3.68,
                      'usps-zone-6': 3.73,
                      'usps-zone-7': 3.83,
                      'usps-zone-8': 3.92,
                    },
                    '0.75': {
                      'ups-zone-0': 3.49,
                      'usps-zone-1': 3.49,
                      'usps-zone-2': 3.49,
                      'usps-zone-3': 3.6,
                      'usps-zone-4': 3.65,
                      'usps-zone-5': 3.71,
                      'usps-zone-6': 3.76,
                      'usps-zone-7': 3.86,
                      'usps-zone-8': 3.96,
                    },
                    '0.8125': {
                      'ups-zone-0': 3.81,
                      'usps-zone-1': 3.81,
                      'usps-zone-2': 3.81,
                      'usps-zone-3': 3.91,
                      'usps-zone-4': 3.97,
                      'usps-zone-5': 4.03,
                      'usps-zone-6': 4.09,
                      'usps-zone-7': 4.19,
                      'usps-zone-8': 4.3,
                    },
                    '0.875': {
                      'ups-zone-0': 3.82,
                      'usps-zone-1': 3.82,
                      'usps-zone-2': 3.82,
                      'usps-zone-3': 3.93,
                      'usps-zone-4': 3.99,
                      'usps-zone-5': 4.05,
                      'usps-zone-6': 4.12,
                      'usps-zone-7': 4.23,
                      'usps-zone-8': 4.33,
                    },
                    '0.9375': {
                      'ups-zone-0': 3.83,
                      'usps-zone-1': 3.83,
                      'usps-zone-2': 3.83,
                      'usps-zone-3': 3.95,
                      'usps-zone-4': 4.02,
                      'usps-zone-5': 4.08,
                      'usps-zone-6': 4.14,
                      'usps-zone-7': 4.26,
                      'usps-zone-8': 4.37,
                    },
                  },
                },
                startDateTime: '2022-07-26T14:44:32.132Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:207302a1-833e-4299-ac58-539027d073aa:5',
          },
          tags: [],
        },
      ],
      carrierSettings: {
        carrierSettings: {
          active: true,
          allowLabelGenerationFailover: false,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-07-27T14:21:39.575Z',
            lastUpdatedBy: 'd6bf88b3-3748-48c7-85f5-4a55ac15c54f',
            lastUpdatedTimeStamp: '2022-12-27T20:51:24.822Z',
            version: 2,
          },
          carrierId: 'upsmi',
          carrierSettingsId: '5bf96b7e-4f5d-498e-b43e-ed21c0b26947',
          description: '',
          expectedShippingVolumeOveragePercentage: 0.0,
          hazmatLimitedQuantityExempt: true,
          name: 'United Parcel Service Mail Innovations (UPS MI) Settings',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          peakSurchargeEligible: true,
          tagIds: [],
          urn: 'urn:carrierSettings:5bf96b7e-4f5d-498e-b43e-ed21c0b26947:2',
        },
        tags: [],
      },
      contract: {
        active: true,
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2022-10-25T15:47:12.024Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-10-25T15:47:12.559Z',
          version: 4,
        },
        carrierAccountId: '67fde367-2163-487c-a6da-4a0154fca495',
        carrierId: 'upsmi',
        carrierRateSetId: '86702025-761f-4ff1-8a02-8c877d3e7be3',
        carrierSettingsId: '5bf96b7e-4f5d-498e-b43e-ed21c0b26947',
        contractId: '5e3ea3e5-fe7c-46ed-9734-c8bfb7d4cfdc',
        description: '',
        name: 'Stord - UPS MI Contract (BDL1)',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        tagIds: [],
        urn: 'urn:contract:5e3ea3e5-fe7c-46ed-9734-c8bfb7d4cfdc:4',
      },
      tags: [],
    },
    {
      carrierAccount: {
        carrierAccount: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '05bab1c9-a047-450c-a964-d383372a3b27',
            creationTimeStamp: '2022-07-15T19:10:41.783Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2023-02-08T19:27:20.801Z',
            version: 5,
          },
          carrierAccountId: '26bd3fbe-47e2-461a-88b8-cb4e822f489a',
          carrierId: 'usps',
          credentials: {
            credentialStructureId: 'endicia-credentials',
            credentials: {
              'endicia-account-id': 'danny.robertso',
              'endicia-passphrase': 'Robcrull1!',
            },
          },
          description: '',
          name: 'United States Postal Service (USPS) Account (BDL1)',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          returnToAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          returnToContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
          serviceMethodCredentials: [],
          tagIds: [],
          urn: 'urn:carrierAccount:26bd3fbe-47e2-461a-88b8-cb4e822f489a:5',
        },
        returnToAddress: {
          address: {
            active: true,
            addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-06-09T16:52:57.568Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
              version: 1,
            },
            description: ' ',
            location: {
              address1: '297 State Street',
              address2: 'Building 1',
              city: 'North Haven',
              companyName: 'Stord BDL1',
              country: 'US',
              postalCode: '06473',
              region: 'CT',
              validatedAddressMetadata: {
                latitude: 41.38069,
                longitude: -72.85601,
                timeZoneId: 'America/New_York',
              },
            },
            name: 'Stord BDL1',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            tagIds: [],
            urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
          },
          tags: [],
        },
        returnToContact: {
          contact: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              creationTimeStamp: '2022-05-10T01:13:39.191Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-09-14T23:44:14.372Z',
              version: 7,
            },
            contactId: '900ae450-da15-4588-8655-b427e62ccfb1',
            contactName: 'Shipping Department ',
            description: '',
            email: 'sales@stord.com',
            name: 'Shipping Department ',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            phoneNumber: '8337002025',
            tagIds: [],
            urn: 'urn:contact:900ae450-da15-4588-8655-b427e62ccfb1:7',
          },
          tags: [],
        },
        tags: [],
      },
      carrierRates: [
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '05bab1c9-a047-450c-a964-d383372a3b27',
              creationTimeStamp: '2022-07-15T19:08:05.483Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-11-15T13:11:54.768Z',
              version: 3,
            },
            carrier: 'usps',
            carrierRateId: '170df5b7-c59b-458e-8e68-5be6dacd9dc9',
            carrierServiceMethodId: 'usps-first-class-package-service-method',
            description: '',
            destinationType: 'all',
            dimWeightOverride: {},
            name: 'USPS First-Class Package Service',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2023-07-31T19:05:20.645Z',
                negotiatedSurcharges: [],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'usps-zone-1': 5.49,
                      'usps-zone-2': 5.49,
                      'usps-zone-3': 5.53,
                      'usps-zone-4': 5.57,
                      'usps-zone-5': 5.72,
                      'usps-zone-6': 5.96,
                      'usps-zone-7': 6.11,
                      'usps-zone-8': 6.28,
                      'usps-zone-9': 6.28,
                    },
                    '0.0625': {
                      'usps-zone-1': 3.37,
                      'usps-zone-2': 3.37,
                      'usps-zone-3': 3.39,
                      'usps-zone-4': 3.42,
                      'usps-zone-5': 3.48,
                      'usps-zone-6': 3.58,
                      'usps-zone-7': 3.72,
                      'usps-zone-8': 3.86,
                      'usps-zone-9': 3.86,
                    },
                    '0.125': {
                      'usps-zone-1': 3.37,
                      'usps-zone-2': 3.37,
                      'usps-zone-3': 3.39,
                      'usps-zone-4': 3.42,
                      'usps-zone-5': 3.48,
                      'usps-zone-6': 3.58,
                      'usps-zone-7': 3.72,
                      'usps-zone-8': 3.86,
                      'usps-zone-9': 3.86,
                    },
                    '0.1875': {
                      'usps-zone-1': 3.37,
                      'usps-zone-2': 3.37,
                      'usps-zone-3': 3.39,
                      'usps-zone-4': 3.42,
                      'usps-zone-5': 3.48,
                      'usps-zone-6': 3.58,
                      'usps-zone-7': 3.72,
                      'usps-zone-8': 3.86,
                      'usps-zone-9': 3.86,
                    },
                    '0.25': {
                      'usps-zone-1': 3.37,
                      'usps-zone-2': 3.37,
                      'usps-zone-3': 3.39,
                      'usps-zone-4': 3.42,
                      'usps-zone-5': 3.48,
                      'usps-zone-6': 3.58,
                      'usps-zone-7': 3.72,
                      'usps-zone-8': 3.86,
                      'usps-zone-9': 3.86,
                    },
                    '0.3125': {
                      'usps-zone-1': 3.76,
                      'usps-zone-2': 3.76,
                      'usps-zone-3': 3.79,
                      'usps-zone-4': 3.81,
                      'usps-zone-5': 3.87,
                      'usps-zone-6': 3.88,
                      'usps-zone-7': 3.99,
                      'usps-zone-8': 4.15,
                      'usps-zone-9': 4.15,
                    },
                    '0.375': {
                      'usps-zone-1': 3.76,
                      'usps-zone-2': 3.76,
                      'usps-zone-3': 3.79,
                      'usps-zone-4': 3.81,
                      'usps-zone-5': 3.87,
                      'usps-zone-6': 3.88,
                      'usps-zone-7': 3.99,
                      'usps-zone-8': 4.15,
                      'usps-zone-9': 4.15,
                    },
                    '0.4375': {
                      'usps-zone-1': 3.76,
                      'usps-zone-2': 3.76,
                      'usps-zone-3': 3.79,
                      'usps-zone-4': 3.81,
                      'usps-zone-5': 3.87,
                      'usps-zone-6': 3.88,
                      'usps-zone-7': 3.99,
                      'usps-zone-8': 4.15,
                      'usps-zone-9': 4.15,
                    },
                    '0.5': {
                      'usps-zone-1': 3.76,
                      'usps-zone-2': 3.76,
                      'usps-zone-3': 3.79,
                      'usps-zone-4': 3.81,
                      'usps-zone-5': 3.87,
                      'usps-zone-6': 3.88,
                      'usps-zone-7': 3.99,
                      'usps-zone-8': 4.15,
                      'usps-zone-9': 4.15,
                    },
                    '0.5625': {
                      'usps-zone-1': 4.34,
                      'usps-zone-2': 4.34,
                      'usps-zone-3': 4.39,
                      'usps-zone-4': 4.42,
                      'usps-zone-5': 4.5,
                      'usps-zone-6': 4.68,
                      'usps-zone-7': 4.83,
                      'usps-zone-8': 4.98,
                      'usps-zone-9': 4.98,
                    },
                    '0.625': {
                      'usps-zone-1': 4.34,
                      'usps-zone-2': 4.34,
                      'usps-zone-3': 4.39,
                      'usps-zone-4': 4.42,
                      'usps-zone-5': 4.5,
                      'usps-zone-6': 4.68,
                      'usps-zone-7': 4.83,
                      'usps-zone-8': 4.98,
                      'usps-zone-9': 4.98,
                    },
                    '0.6875': {
                      'usps-zone-1': 4.34,
                      'usps-zone-2': 4.34,
                      'usps-zone-3': 4.39,
                      'usps-zone-4': 4.42,
                      'usps-zone-5': 4.5,
                      'usps-zone-6': 4.68,
                      'usps-zone-7': 4.83,
                      'usps-zone-8': 4.98,
                      'usps-zone-9': 4.98,
                    },
                    '0.75': {
                      'usps-zone-1': 4.34,
                      'usps-zone-2': 4.34,
                      'usps-zone-3': 4.39,
                      'usps-zone-4': 4.42,
                      'usps-zone-5': 4.5,
                      'usps-zone-6': 4.68,
                      'usps-zone-7': 4.83,
                      'usps-zone-8': 4.98,
                      'usps-zone-9': 4.98,
                    },
                    '0.8125': {
                      'usps-zone-1': 5.49,
                      'usps-zone-2': 5.49,
                      'usps-zone-3': 5.53,
                      'usps-zone-4': 5.57,
                      'usps-zone-5': 5.72,
                      'usps-zone-6': 5.96,
                      'usps-zone-7': 6.11,
                      'usps-zone-8': 6.28,
                      'usps-zone-9': 6.28,
                    },
                    '0.875': {
                      'usps-zone-1': 5.49,
                      'usps-zone-2': 5.49,
                      'usps-zone-3': 5.53,
                      'usps-zone-4': 5.57,
                      'usps-zone-5': 5.72,
                      'usps-zone-6': 5.96,
                      'usps-zone-7': 6.11,
                      'usps-zone-8': 6.28,
                      'usps-zone-9': 6.28,
                    },
                    '0.9375': {
                      'usps-zone-1': 5.49,
                      'usps-zone-2': 5.49,
                      'usps-zone-3': 5.53,
                      'usps-zone-4': 5.57,
                      'usps-zone-5': 5.72,
                      'usps-zone-6': 5.96,
                      'usps-zone-7': 6.11,
                      'usps-zone-8': 6.28,
                      'usps-zone-9': 6.28,
                    },
                  },
                },
                startDateTime: '2022-07-15T19:05:20.645Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:170df5b7-c59b-458e-8e68-5be6dacd9dc9:3',
          },
          tags: [],
        },
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '05bab1c9-a047-450c-a964-d383372a3b27',
              creationTimeStamp: '2022-07-15T19:04:51.257Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-08-05T15:45:42.155Z',
              version: 2,
            },
            carrier: 'usps',
            carrierRateId: 'c61e227d-5735-4c50-9171-bd4e0d91979b',
            carrierServiceMethodId: 'usps-priority-mail-service-method',
            description: '',
            destinationType: 'all',
            dimWeightOverride: {},
            name: 'USPS Priority Mail',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2023-07-31T18:58:39.053Z',
                negotiatedSurcharges: [],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'usps-zone-1': 7.37,
                      'usps-zone-2': 7.37,
                      'usps-zone-3': 7.68,
                      'usps-zone-4': 7.9,
                      'usps-zone-5': 8.12,
                      'usps-zone-6': 8.59,
                      'usps-zone-7': 9.16,
                      'usps-zone-8': 9.68,
                      'usps-zone-9': 16.39,
                    },
                    '2': {
                      'usps-zone-1': 8.02,
                      'usps-zone-2': 8.02,
                      'usps-zone-3': 8.2,
                      'usps-zone-4': 8.49,
                      'usps-zone-5': 9.12,
                      'usps-zone-6': 10.96,
                      'usps-zone-7': 11.62,
                      'usps-zone-8': 12.66,
                      'usps-zone-9': 25.08,
                    },
                    '3': {
                      'usps-zone-1': 8.24,
                      'usps-zone-2': 8.24,
                      'usps-zone-3': 8.6,
                      'usps-zone-4': 8.98,
                      'usps-zone-5': 9.93,
                      'usps-zone-6': 13.34,
                      'usps-zone-7': 15.03,
                      'usps-zone-8': 17.74,
                      'usps-zone-9': 34.03,
                    },
                    '4': {
                      'usps-zone-1': 8.34,
                      'usps-zone-2': 8.34,
                      'usps-zone-3': 8.84,
                      'usps-zone-4': 9.49,
                      'usps-zone-5': 11.54,
                      'usps-zone-6': 15.54,
                      'usps-zone-7': 18.03,
                      'usps-zone-8': 20.77,
                      'usps-zone-9': 40.97,
                    },
                    '5': {
                      'usps-zone-1': 8.45,
                      'usps-zone-2': 8.45,
                      'usps-zone-3': 8.89,
                      'usps-zone-4': 9.82,
                      'usps-zone-5': 12.71,
                      'usps-zone-6': 17.03,
                      'usps-zone-7': 20.81,
                      'usps-zone-8': 24.01,
                      'usps-zone-9': 47.68,
                    },
                    '6': {
                      'usps-zone-1': 8.56,
                      'usps-zone-2': 8.56,
                      'usps-zone-3': 9.25,
                      'usps-zone-4': 10.25,
                      'usps-zone-5': 13.63,
                      'usps-zone-6': 18.53,
                      'usps-zone-7': 23.78,
                      'usps-zone-8': 27.43,
                      'usps-zone-9': 54.64,
                    },
                    '7': {
                      'usps-zone-1': 9.04,
                      'usps-zone-2': 9.04,
                      'usps-zone-3': 10.21,
                      'usps-zone-4': 10.82,
                      'usps-zone-5': 14.5,
                      'usps-zone-6': 20.02,
                      'usps-zone-7': 25.8,
                      'usps-zone-8': 29.82,
                      'usps-zone-9': 61.35,
                    },
                    '8': {
                      'usps-zone-1': 9.18,
                      'usps-zone-2': 9.18,
                      'usps-zone-3': 10.71,
                      'usps-zone-4': 12.07,
                      'usps-zone-5': 15.38,
                      'usps-zone-6': 21.53,
                      'usps-zone-7': 27.81,
                      'usps-zone-8': 32.21,
                      'usps-zone-9': 68.87,
                    },
                    '9': {
                      'usps-zone-1': 9.79,
                      'usps-zone-2': 9.79,
                      'usps-zone-3': 11.08,
                      'usps-zone-4': 12.57,
                      'usps-zone-5': 16.64,
                      'usps-zone-6': 23.03,
                      'usps-zone-7': 29.83,
                      'usps-zone-8': 34.59,
                      'usps-zone-9': 76.59,
                    },
                    '10': {
                      'usps-zone-1': 10.29,
                      'usps-zone-2': 10.29,
                      'usps-zone-3': 11.55,
                      'usps-zone-4': 12.92,
                      'usps-zone-5': 17.74,
                      'usps-zone-6': 24.52,
                      'usps-zone-7': 31.84,
                      'usps-zone-8': 36.77,
                      'usps-zone-9': 83.29,
                    },
                    '11': {
                      'usps-zone-1': 11.75,
                      'usps-zone-2': 11.75,
                      'usps-zone-3': 12.46,
                      'usps-zone-4': 13.64,
                      'usps-zone-5': 18.84,
                      'usps-zone-6': 26.02,
                      'usps-zone-7': 33.8,
                      'usps-zone-8': 38.93,
                      'usps-zone-9': 91.0,
                    },
                    '12': {
                      'usps-zone-1': 12.21,
                      'usps-zone-2': 12.21,
                      'usps-zone-3': 12.99,
                      'usps-zone-4': 14.32,
                      'usps-zone-5': 19.92,
                      'usps-zone-6': 27.51,
                      'usps-zone-7': 35.63,
                      'usps-zone-8': 41.1,
                      'usps-zone-9': 97.55,
                    },
                    '13': {
                      'usps-zone-1': 12.46,
                      'usps-zone-2': 12.46,
                      'usps-zone-3': 13.36,
                      'usps-zone-4': 15.02,
                      'usps-zone-5': 21.0,
                      'usps-zone-6': 28.99,
                      'usps-zone-7': 37.46,
                      'usps-zone-8': 43.27,
                      'usps-zone-9': 101.04,
                    },
                    '14': {
                      'usps-zone-1': 12.77,
                      'usps-zone-2': 12.77,
                      'usps-zone-3': 13.95,
                      'usps-zone-4': 15.71,
                      'usps-zone-5': 22.07,
                      'usps-zone-6': 30.36,
                      'usps-zone-7': 39.29,
                      'usps-zone-8': 45.44,
                      'usps-zone-9': 106.04,
                    },
                    '15': {
                      'usps-zone-1': 12.89,
                      'usps-zone-2': 12.89,
                      'usps-zone-3': 14.55,
                      'usps-zone-4': 16.4,
                      'usps-zone-5': 23.14,
                      'usps-zone-6': 31.71,
                      'usps-zone-7': 41.13,
                      'usps-zone-8': 47.62,
                      'usps-zone-9': 108.85,
                    },
                    '16': {
                      'usps-zone-1': 13.4,
                      'usps-zone-2': 13.4,
                      'usps-zone-3': 15.14,
                      'usps-zone-4': 17.09,
                      'usps-zone-5': 24.21,
                      'usps-zone-6': 33.08,
                      'usps-zone-7': 42.96,
                      'usps-zone-8': 49.78,
                      'usps-zone-9': 114.83,
                    },
                    '17': {
                      'usps-zone-1': 13.91,
                      'usps-zone-2': 13.91,
                      'usps-zone-3': 15.73,
                      'usps-zone-4': 17.78,
                      'usps-zone-5': 25.27,
                      'usps-zone-6': 34.43,
                      'usps-zone-7': 44.8,
                      'usps-zone-8': 51.95,
                      'usps-zone-9': 120.88,
                    },
                    '18': {
                      'usps-zone-1': 14.43,
                      'usps-zone-2': 14.43,
                      'usps-zone-3': 16.32,
                      'usps-zone-4': 18.47,
                      'usps-zone-5': 26.34,
                      'usps-zone-6': 35.79,
                      'usps-zone-7': 46.62,
                      'usps-zone-8': 54.12,
                      'usps-zone-9': 126.97,
                    },
                    '19': {
                      'usps-zone-1': 14.94,
                      'usps-zone-2': 14.94,
                      'usps-zone-3': 16.92,
                      'usps-zone-4': 19.15,
                      'usps-zone-5': 27.4,
                      'usps-zone-6': 37.16,
                      'usps-zone-7': 48.46,
                      'usps-zone-8': 56.28,
                      'usps-zone-9': 133.0,
                    },
                    '20': {
                      'usps-zone-1': 15.45,
                      'usps-zone-2': 15.45,
                      'usps-zone-3': 17.51,
                      'usps-zone-4': 19.84,
                      'usps-zone-5': 28.46,
                      'usps-zone-6': 38.51,
                      'usps-zone-7': 50.29,
                      'usps-zone-8': 58.46,
                      'usps-zone-9': 139.13,
                    },
                    '21': {
                      'usps-zone-1': 16.39,
                      'usps-zone-2': 16.39,
                      'usps-zone-3': 18.76,
                      'usps-zone-4': 21.44,
                      'usps-zone-5': 30.04,
                      'usps-zone-6': 40.58,
                      'usps-zone-7': 52.14,
                      'usps-zone-8': 60.31,
                      'usps-zone-9': 142.09,
                    },
                    '22': {
                      'usps-zone-1': 17.39,
                      'usps-zone-2': 17.39,
                      'usps-zone-3': 20.11,
                      'usps-zone-4': 23.16,
                      'usps-zone-5': 31.71,
                      'usps-zone-6': 42.76,
                      'usps-zone-7': 54.06,
                      'usps-zone-8': 62.21,
                      'usps-zone-9': 143.75,
                    },
                    '23': {
                      'usps-zone-1': 18.44,
                      'usps-zone-2': 18.44,
                      'usps-zone-3': 21.56,
                      'usps-zone-4': 25.03,
                      'usps-zone-5': 33.48,
                      'usps-zone-6': 45.06,
                      'usps-zone-7': 56.04,
                      'usps-zone-8': 64.17,
                      'usps-zone-9': 144.6,
                    },
                    '24': {
                      'usps-zone-1': 19.56,
                      'usps-zone-2': 19.56,
                      'usps-zone-3': 23.1,
                      'usps-zone-4': 27.04,
                      'usps-zone-5': 35.34,
                      'usps-zone-6': 47.48,
                      'usps-zone-7': 58.1,
                      'usps-zone-8': 66.19,
                      'usps-zone-9': 148.13,
                    },
                    '25': {
                      'usps-zone-1': 20.75,
                      'usps-zone-2': 20.75,
                      'usps-zone-3': 24.76,
                      'usps-zone-4': 29.22,
                      'usps-zone-5': 37.3,
                      'usps-zone-6': 50.03,
                      'usps-zone-7': 60.24,
                      'usps-zone-8': 68.28,
                      'usps-zone-9': 150.68,
                    },
                    '26': {
                      'usps-zone-1': 23.72,
                      'usps-zone-2': 23.72,
                      'usps-zone-3': 29.46,
                      'usps-zone-4': 37.96,
                      'usps-zone-5': 49.42,
                      'usps-zone-6': 62.94,
                      'usps-zone-7': 74.61,
                      'usps-zone-8': 85.9,
                      'usps-zone-9': 155.4,
                    },
                    '27': {
                      'usps-zone-1': 25.16,
                      'usps-zone-2': 25.16,
                      'usps-zone-3': 30.81,
                      'usps-zone-4': 40.31,
                      'usps-zone-5': 53.92,
                      'usps-zone-6': 63.81,
                      'usps-zone-7': 76.51,
                      'usps-zone-8': 89.1,
                      'usps-zone-9': 161.28,
                    },
                    '28': {
                      'usps-zone-1': 25.95,
                      'usps-zone-2': 25.95,
                      'usps-zone-3': 31.23,
                      'usps-zone-4': 41.47,
                      'usps-zone-5': 55.35,
                      'usps-zone-6': 64.7,
                      'usps-zone-7': 78.34,
                      'usps-zone-8': 92.66,
                      'usps-zone-9': 167.33,
                    },
                    '29': {
                      'usps-zone-1': 26.75,
                      'usps-zone-2': 26.75,
                      'usps-zone-3': 31.56,
                      'usps-zone-4': 42.61,
                      'usps-zone-5': 56.1,
                      'usps-zone-6': 65.81,
                      'usps-zone-7': 80.19,
                      'usps-zone-8': 95.28,
                      'usps-zone-9': 171.8,
                    },
                    '30': {
                      'usps-zone-1': 27.56,
                      'usps-zone-2': 27.56,
                      'usps-zone-3': 32.02,
                      'usps-zone-4': 43.61,
                      'usps-zone-5': 56.87,
                      'usps-zone-6': 67.7,
                      'usps-zone-7': 82.01,
                      'usps-zone-8': 97.32,
                      'usps-zone-9': 175.52,
                    },
                    '31': {
                      'usps-zone-1': 28.36,
                      'usps-zone-2': 28.36,
                      'usps-zone-3': 32.34,
                      'usps-zone-4': 44.31,
                      'usps-zone-5': 57.61,
                      'usps-zone-6': 68.7,
                      'usps-zone-7': 83.86,
                      'usps-zone-8': 99.59,
                      'usps-zone-9': 180.55,
                    },
                    '32': {
                      'usps-zone-1': 28.69,
                      'usps-zone-2': 28.69,
                      'usps-zone-3': 33.04,
                      'usps-zone-4': 45.06,
                      'usps-zone-5': 58.29,
                      'usps-zone-6': 69.62,
                      'usps-zone-7': 85.72,
                      'usps-zone-8': 101.4,
                      'usps-zone-9': 184.23,
                    },
                    '33': {
                      'usps-zone-1': 29.14,
                      'usps-zone-2': 29.14,
                      'usps-zone-3': 33.97,
                      'usps-zone-4': 46.19,
                      'usps-zone-5': 59.07,
                      'usps-zone-6': 71.0,
                      'usps-zone-7': 87.54,
                      'usps-zone-8': 103.5,
                      'usps-zone-9': 187.63,
                    },
                    '34': {
                      'usps-zone-1': 29.41,
                      'usps-zone-2': 29.41,
                      'usps-zone-3': 34.87,
                      'usps-zone-4': 47.38,
                      'usps-zone-5': 60.36,
                      'usps-zone-6': 72.74,
                      'usps-zone-7': 89.39,
                      'usps-zone-8': 105.54,
                      'usps-zone-9': 191.19,
                    },
                    '35': {
                      'usps-zone-1': 29.75,
                      'usps-zone-2': 29.75,
                      'usps-zone-3': 35.7,
                      'usps-zone-4': 48.06,
                      'usps-zone-5': 61.66,
                      'usps-zone-6': 74.72,
                      'usps-zone-7': 91.22,
                      'usps-zone-8': 107.17,
                      'usps-zone-9': 194.44,
                    },
                    '36': {
                      'usps-zone-1': 30.12,
                      'usps-zone-2': 30.12,
                      'usps-zone-3': 36.76,
                      'usps-zone-4': 48.71,
                      'usps-zone-5': 63.01,
                      'usps-zone-6': 76.65,
                      'usps-zone-7': 92.49,
                      'usps-zone-8': 109.09,
                      'usps-zone-9': 197.75,
                    },
                    '37': {
                      'usps-zone-1': 30.44,
                      'usps-zone-2': 30.44,
                      'usps-zone-3': 37.45,
                      'usps-zone-4': 49.41,
                      'usps-zone-5': 64.14,
                      'usps-zone-6': 78.7,
                      'usps-zone-7': 93.71,
                      'usps-zone-8': 110.96,
                      'usps-zone-9': 201.02,
                    },
                    '38': {
                      'usps-zone-1': 30.74,
                      'usps-zone-2': 30.74,
                      'usps-zone-3': 38.37,
                      'usps-zone-4': 50.04,
                      'usps-zone-5': 65.44,
                      'usps-zone-6': 80.93,
                      'usps-zone-7': 94.8,
                      'usps-zone-8': 112.82,
                      'usps-zone-9': 204.23,
                    },
                    '39': {
                      'usps-zone-1': 31.05,
                      'usps-zone-2': 31.05,
                      'usps-zone-3': 39.29,
                      'usps-zone-4': 50.62,
                      'usps-zone-5': 66.81,
                      'usps-zone-6': 82.88,
                      'usps-zone-7': 97.37,
                      'usps-zone-8': 114.57,
                      'usps-zone-9': 207.39,
                    },
                    '40': {
                      'usps-zone-1': 31.37,
                      'usps-zone-2': 31.37,
                      'usps-zone-3': 40.12,
                      'usps-zone-4': 51.29,
                      'usps-zone-5': 68.21,
                      'usps-zone-6': 84.24,
                      'usps-zone-7': 99.59,
                      'usps-zone-8': 116.21,
                      'usps-zone-9': 210.2,
                    },
                    '41': {
                      'usps-zone-1': 31.72,
                      'usps-zone-2': 31.72,
                      'usps-zone-3': 40.8,
                      'usps-zone-4': 51.84,
                      'usps-zone-5': 68.82,
                      'usps-zone-6': 85.68,
                      'usps-zone-7': 101.77,
                      'usps-zone-8': 118.07,
                      'usps-zone-9': 214.92,
                    },
                    '42': {
                      'usps-zone-1': 31.96,
                      'usps-zone-2': 31.96,
                      'usps-zone-3': 41.12,
                      'usps-zone-4': 52.3,
                      'usps-zone-5': 69.99,
                      'usps-zone-6': 87.22,
                      'usps-zone-7': 103.19,
                      'usps-zone-8': 119.58,
                      'usps-zone-9': 217.86,
                    },
                    '43': {
                      'usps-zone-1': 32.34,
                      'usps-zone-2': 32.34,
                      'usps-zone-3': 41.42,
                      'usps-zone-4': 52.77,
                      'usps-zone-5': 71.16,
                      'usps-zone-6': 89.35,
                      'usps-zone-7': 104.5,
                      'usps-zone-8': 120.87,
                      'usps-zone-9': 220.64,
                    },
                    '44': {
                      'usps-zone-1': 32.57,
                      'usps-zone-2': 32.57,
                      'usps-zone-3': 41.72,
                      'usps-zone-4': 53.23,
                      'usps-zone-5': 72.32,
                      'usps-zone-6': 90.8,
                      'usps-zone-7': 105.78,
                      'usps-zone-8': 122.61,
                      'usps-zone-9': 223.19,
                    },
                    '45': {
                      'usps-zone-1': 32.78,
                      'usps-zone-2': 32.78,
                      'usps-zone-3': 42.03,
                      'usps-zone-4': 53.71,
                      'usps-zone-5': 73.49,
                      'usps-zone-6': 91.82,
                      'usps-zone-7': 106.94,
                      'usps-zone-8': 124.13,
                      'usps-zone-9': 226.01,
                    },
                    '46': {
                      'usps-zone-1': 33.08,
                      'usps-zone-2': 33.08,
                      'usps-zone-3': 42.34,
                      'usps-zone-4': 54.18,
                      'usps-zone-5': 74.66,
                      'usps-zone-6': 92.87,
                      'usps-zone-7': 108.12,
                      'usps-zone-8': 125.59,
                      'usps-zone-9': 228.69,
                    },
                    '47': {
                      'usps-zone-1': 33.32,
                      'usps-zone-2': 33.32,
                      'usps-zone-3': 42.64,
                      'usps-zone-4': 54.64,
                      'usps-zone-5': 75.83,
                      'usps-zone-6': 93.85,
                      'usps-zone-7': 109.38,
                      'usps-zone-8': 127.1,
                      'usps-zone-9': 231.25,
                    },
                    '48': {
                      'usps-zone-1': 33.6,
                      'usps-zone-2': 33.6,
                      'usps-zone-3': 42.95,
                      'usps-zone-4': 55.12,
                      'usps-zone-5': 76.98,
                      'usps-zone-6': 95.07,
                      'usps-zone-7': 110.45,
                      'usps-zone-8': 128.38,
                      'usps-zone-9': 233.77,
                    },
                    '49': {
                      'usps-zone-1': 33.87,
                      'usps-zone-2': 33.87,
                      'usps-zone-3': 43.24,
                      'usps-zone-4': 55.59,
                      'usps-zone-5': 78.16,
                      'usps-zone-6': 96.4,
                      'usps-zone-7': 111.63,
                      'usps-zone-8': 129.66,
                      'usps-zone-9': 236.05,
                    },
                    '50': {
                      'usps-zone-1': 34.01,
                      'usps-zone-2': 34.01,
                      'usps-zone-3': 43.54,
                      'usps-zone-4': 56.07,
                      'usps-zone-5': 79.34,
                      'usps-zone-6': 97.77,
                      'usps-zone-7': 113.08,
                      'usps-zone-8': 131.06,
                      'usps-zone-9': 238.58,
                    },
                    '51': {
                      'usps-zone-1': 34.52,
                      'usps-zone-2': 34.52,
                      'usps-zone-3': 43.85,
                      'usps-zone-4': 56.5,
                      'usps-zone-5': 80.7,
                      'usps-zone-6': 99.14,
                      'usps-zone-7': 114.73,
                      'usps-zone-8': 132.35,
                      'usps-zone-9': 242.72,
                    },
                    '52': {
                      'usps-zone-1': 35.04,
                      'usps-zone-2': 35.04,
                      'usps-zone-3': 44.16,
                      'usps-zone-4': 56.98,
                      'usps-zone-5': 81.27,
                      'usps-zone-6': 100.11,
                      'usps-zone-7': 116.49,
                      'usps-zone-8': 133.85,
                      'usps-zone-9': 245.56,
                    },
                    '53': {
                      'usps-zone-1': 35.7,
                      'usps-zone-2': 35.7,
                      'usps-zone-3': 44.46,
                      'usps-zone-4': 57.45,
                      'usps-zone-5': 81.94,
                      'usps-zone-6': 100.97,
                      'usps-zone-7': 118.44,
                      'usps-zone-8': 135.61,
                      'usps-zone-9': 248.7,
                    },
                    '54': {
                      'usps-zone-1': 36.23,
                      'usps-zone-2': 36.23,
                      'usps-zone-3': 44.77,
                      'usps-zone-4': 57.91,
                      'usps-zone-5': 82.65,
                      'usps-zone-6': 101.7,
                      'usps-zone-7': 120.16,
                      'usps-zone-8': 137.58,
                      'usps-zone-9': 252.18,
                    },
                    '55': {
                      'usps-zone-1': 36.8,
                      'usps-zone-2': 36.8,
                      'usps-zone-3': 45.06,
                      'usps-zone-4': 58.38,
                      'usps-zone-5': 83.18,
                      'usps-zone-6': 102.56,
                      'usps-zone-7': 122.11,
                      'usps-zone-8': 139.39,
                      'usps-zone-9': 255.58,
                    },
                    '56': {
                      'usps-zone-1': 37.32,
                      'usps-zone-2': 37.32,
                      'usps-zone-3': 45.38,
                      'usps-zone-4': 58.85,
                      'usps-zone-5': 83.82,
                      'usps-zone-6': 103.24,
                      'usps-zone-7': 123.82,
                      'usps-zone-8': 140.85,
                      'usps-zone-9': 258.22,
                    },
                    '57': {
                      'usps-zone-1': 37.92,
                      'usps-zone-2': 37.92,
                      'usps-zone-3': 45.68,
                      'usps-zone-4': 59.32,
                      'usps-zone-5': 84.32,
                      'usps-zone-6': 104.05,
                      'usps-zone-7': 124.63,
                      'usps-zone-8': 141.85,
                      'usps-zone-9': 260.53,
                    },
                    '58': {
                      'usps-zone-1': 38.5,
                      'usps-zone-2': 38.5,
                      'usps-zone-3': 45.98,
                      'usps-zone-4': 59.78,
                      'usps-zone-5': 84.86,
                      'usps-zone-6': 104.67,
                      'usps-zone-7': 125.79,
                      'usps-zone-8': 143.07,
                      'usps-zone-9': 262.64,
                    },
                    '59': {
                      'usps-zone-1': 39.06,
                      'usps-zone-2': 39.06,
                      'usps-zone-3': 46.29,
                      'usps-zone-4': 60.24,
                      'usps-zone-5': 85.37,
                      'usps-zone-6': 105.27,
                      'usps-zone-7': 126.59,
                      'usps-zone-8': 144.11,
                      'usps-zone-9': 264.6,
                    },
                    '60': {
                      'usps-zone-1': 39.55,
                      'usps-zone-2': 39.55,
                      'usps-zone-3': 46.59,
                      'usps-zone-4': 60.7,
                      'usps-zone-5': 85.86,
                      'usps-zone-6': 105.81,
                      'usps-zone-7': 127.4,
                      'usps-zone-8': 145.04,
                      'usps-zone-9': 266.46,
                    },
                    '61': {
                      'usps-zone-1': 40.2,
                      'usps-zone-2': 40.2,
                      'usps-zone-3': 46.88,
                      'usps-zone-4': 61.17,
                      'usps-zone-5': 86.28,
                      'usps-zone-6': 106.41,
                      'usps-zone-7': 128.9,
                      'usps-zone-8': 147.09,
                      'usps-zone-9': 270.08,
                    },
                    '62': {
                      'usps-zone-1': 40.71,
                      'usps-zone-2': 40.71,
                      'usps-zone-3': 47.19,
                      'usps-zone-4': 61.63,
                      'usps-zone-5': 86.67,
                      'usps-zone-6': 106.91,
                      'usps-zone-7': 130.47,
                      'usps-zone-8': 149.54,
                      'usps-zone-9': 274.33,
                    },
                    '63': {
                      'usps-zone-1': 41.45,
                      'usps-zone-2': 41.45,
                      'usps-zone-3': 47.5,
                      'usps-zone-4': 62.11,
                      'usps-zone-5': 87.13,
                      'usps-zone-6': 107.53,
                      'usps-zone-7': 131.11,
                      'usps-zone-8': 151.98,
                      'usps-zone-9': 278.74,
                    },
                    '64': {
                      'usps-zone-1': 41.82,
                      'usps-zone-2': 41.82,
                      'usps-zone-3': 47.8,
                      'usps-zone-4': 62.58,
                      'usps-zone-5': 87.52,
                      'usps-zone-6': 108.02,
                      'usps-zone-7': 131.71,
                      'usps-zone-8': 154.37,
                      'usps-zone-9': 283.03,
                    },
                    '65': {
                      'usps-zone-1': 42.43,
                      'usps-zone-2': 42.43,
                      'usps-zone-3': 48.1,
                      'usps-zone-4': 63.07,
                      'usps-zone-5': 87.79,
                      'usps-zone-6': 108.34,
                      'usps-zone-7': 132.39,
                      'usps-zone-8': 156.7,
                      'usps-zone-9': 287.45,
                    },
                    '66': {
                      'usps-zone-1': 43.0,
                      'usps-zone-2': 43.0,
                      'usps-zone-3': 48.42,
                      'usps-zone-4': 63.52,
                      'usps-zone-5': 88.19,
                      'usps-zone-6': 108.89,
                      'usps-zone-7': 132.79,
                      'usps-zone-8': 159.21,
                      'usps-zone-9': 291.63,
                    },
                    '67': {
                      'usps-zone-1': 43.65,
                      'usps-zone-2': 43.65,
                      'usps-zone-3': 48.72,
                      'usps-zone-4': 64.61,
                      'usps-zone-5': 88.51,
                      'usps-zone-6': 109.24,
                      'usps-zone-7': 133.33,
                      'usps-zone-8': 161.25,
                      'usps-zone-9': 295.47,
                    },
                    '68': {
                      'usps-zone-1': 44.16,
                      'usps-zone-2': 44.16,
                      'usps-zone-3': 49.01,
                      'usps-zone-4': 65.42,
                      'usps-zone-5': 88.75,
                      'usps-zone-6': 110.64,
                      'usps-zone-7': 134.04,
                      'usps-zone-8': 162.99,
                      'usps-zone-9': 298.6,
                    },
                    '69': {
                      'usps-zone-1': 44.77,
                      'usps-zone-2': 44.77,
                      'usps-zone-3': 49.33,
                      'usps-zone-4': 66.27,
                      'usps-zone-5': 89.02,
                      'usps-zone-6': 111.99,
                      'usps-zone-7': 134.67,
                      'usps-zone-8': 164.75,
                      'usps-zone-9': 301.79,
                    },
                    '70': {
                      'usps-zone-1': 45.24,
                      'usps-zone-2': 45.24,
                      'usps-zone-3': 49.63,
                      'usps-zone-4': 67.32,
                      'usps-zone-5': 89.31,
                      'usps-zone-6': 113.36,
                      'usps-zone-7': 135.17,
                      'usps-zone-8': 166.61,
                      'usps-zone-9': 305.03,
                    },
                  },
                },
                startDateTime: '2022-07-15T18:58:39.053Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:c61e227d-5735-4c50-9171-bd4e0d91979b:2',
          },
          tags: [],
        },
      ],
      carrierSettings: {
        carrierSettings: {
          active: true,
          allowLabelGenerationFailover: false,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-07-27T13:38:01.986Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2022-07-27T13:38:01.986Z',
            version: 1,
          },
          carrierId: 'usps',
          carrierSettingsId: '304e6c50-ecc6-43ac-ae00-cbff3a48073b',
          description: '',
          expectedShippingVolumeOveragePercentage: 0.0,
          hazmatLimitedQuantityExempt: false,
          name: 'United States Postal Service (USPS) Settings',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          peakSurchargeEligible: true,
          tagIds: [],
          urn: 'urn:carrierSettings:304e6c50-ecc6-43ac-ae00-cbff3a48073b:1',
        },
        tags: [],
      },
      contract: {
        active: true,
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2022-07-27T18:21:56.966Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-07-27T18:22:43.892Z',
          version: 5,
        },
        carrierAccountId: '26bd3fbe-47e2-461a-88b8-cb4e822f489a',
        carrierId: 'usps',
        carrierRateSetId: '835f1f16-a294-44d4-afdd-ce0ae3ec5f08',
        carrierSettingsId: '304e6c50-ecc6-43ac-ae00-cbff3a48073b',
        contractId: '7287c628-b240-4ac7-ae03-3e9410c9a529',
        description: '',
        name: 'USPS Contract (New Haven)',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        tagIds: [],
        urn: 'urn:contract:7287c628-b240-4ac7-ae03-3e9410c9a529:5',
      },
      tags: [],
    },
    {
      carrierAccount: {
        carrierAccount: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2023-01-13T23:36:21.939Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2023-01-13T23:51:17.466Z',
            version: 7,
          },
          carrierAccountId: 'aba032c9-16ac-4b6b-8223-ea2738b29502',
          carrierId: 'fedex',
          credentials: {
            credentialStructureId: 'fedex-standard-credentials',
            credentials: {
              'fedex-account-number': '752674060',
            },
          },
          description: '',
          name: 'Stord - FedEx Account (BDL1)',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          serviceMethodCredentials: [
            {
              carrierServiceMethodId: 'fedex-smartpost-service-method',
              credentialId: 'fedex-smartpost-hub-id',
              credentialStructureId: 'fedex-standard-credentials',
              credentialValue: '5015',
            },
          ],
          shipiumCredentials: {
            credentialStructureId: 'fedex-shipium-credentials',
            credentials: {
              'fedex-shipium-api-key': 'A52VIloqmrOib5hB',
              'fedex-shipium-api-password': 'aXavpha4By8XUVYaC1XiZp08M',
              'fedex-shipium-account-number': '752674060',
              'fedex-shipium-meter-number': '255637393',
            },
          },
          shipperAddressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          shipperContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
          tagIds: [],
          urn: 'urn:carrierAccount:aba032c9-16ac-4b6b-8223-ea2738b29502:7',
        },
        shipperAddress: {
          address: {
            active: true,
            addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
            archived: false,
            auditInfo: {
              createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              creationTimeStamp: '2022-06-09T16:52:57.568Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
              version: 1,
            },
            description: ' ',
            location: {
              address1: '297 State Street',
              address2: 'Building 1',
              city: 'North Haven',
              companyName: 'Stord BDL1',
              country: 'US',
              postalCode: '06473',
              region: 'CT',
              validatedAddressMetadata: {
                latitude: 41.38069,
                longitude: -72.85601,
                timeZoneId: 'America/New_York',
              },
            },
            name: 'Stord BDL1',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            tagIds: [],
            urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
          },
          tags: [],
        },
        shipperContact: {
          contact: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              creationTimeStamp: '2022-05-10T01:13:39.191Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-09-14T23:44:14.372Z',
              version: 7,
            },
            contactId: '900ae450-da15-4588-8655-b427e62ccfb1',
            contactName: 'Shipping Department ',
            description: '',
            email: 'sales@stord.com',
            name: 'Shipping Department ',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            phoneNumber: '8337002025',
            tagIds: [],
            urn: 'urn:contact:900ae450-da15-4588-8655-b427e62ccfb1:7',
          },
          tags: [],
        },
        tags: [],
      },
      carrierRates: [
        {
          carrierRate: {
            active: true,
            archived: false,
            auditInfo: {
              createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
              creationTimeStamp: '2022-05-06T19:19:40.499Z',
              lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
              lastUpdatedTimeStamp: '2022-09-19T23:57:39.904Z',
              version: 3,
            },
            carrier: 'fedex',
            carrierRateId: 'b6d3564c-5895-4e3a-ae67-35552b395aa6',
            carrierServiceMethodId: 'fedex-ground-service-method',
            description: '',
            destinationType: 'commercial',
            dimWeightOverride: {},
            name: 'FedEx Ground',
            partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
            rateCalendar: [
              {
                endDateTime: '2050-05-06T19:11:58.801Z',
                negotiatedSurcharges: [],
                rateTable: {
                  currency: 'usd',
                  minimumCosts: [],
                  rates: {
                    '1': {
                      'fedex-zone-2': 9.36,
                      'fedex-zone-3': 9.77,
                      'fedex-zone-4': 10.65,
                      'fedex-zone-5': 11.13,
                      'fedex-zone-6': 11.51,
                      'fedex-zone-7': 11.64,
                      'fedex-zone-8': 11.84,
                      'fedex-zone-9': 34.35,
                      'fedex-zone-14': 7.8,
                      'fedex-zone-17': 34.35,
                      'fedex-zone-22': 8.0,
                      'fedex-zone-23': 11.91,
                      'fedex-zone-25': 12.29,
                      'fedex-zone-51': 22.61,
                      'fedex-zone-54': 35.93,
                      'fedex-zone-92': 11.91,
                      'fedex-zone-96': 12.29,
                    },
                    '2': {
                      'fedex-zone-2': 10.13,
                      'fedex-zone-3': 11.27,
                      'fedex-zone-4': 12.18,
                      'fedex-zone-5': 12.45,
                      'fedex-zone-6': 12.99,
                      'fedex-zone-7': 13.48,
                      'fedex-zone-8': 13.71,
                      'fedex-zone-9': 38.21,
                      'fedex-zone-14': 7.91,
                      'fedex-zone-17': 38.21,
                      'fedex-zone-22': 8.12,
                      'fedex-zone-23': 13.81,
                      'fedex-zone-25': 14.0,
                      'fedex-zone-51': 24.44,
                      'fedex-zone-54': 37.79,
                      'fedex-zone-92': 13.81,
                      'fedex-zone-96': 14.0,
                    },
                    '3': {
                      'fedex-zone-2': 10.64,
                      'fedex-zone-3': 11.87,
                      'fedex-zone-4': 12.84,
                      'fedex-zone-5': 13.36,
                      'fedex-zone-6': 13.91,
                      'fedex-zone-7': 14.38,
                      'fedex-zone-8': 15.08,
                      'fedex-zone-9': 41.52,
                      'fedex-zone-14': 7.93,
                      'fedex-zone-17': 41.52,
                      'fedex-zone-22': 8.16,
                      'fedex-zone-23': 15.11,
                      'fedex-zone-25': 15.54,
                      'fedex-zone-51': 25.2,
                      'fedex-zone-54': 39.62,
                      'fedex-zone-92': 15.11,
                      'fedex-zone-96': 15.54,
                    },
                    '4': {
                      'fedex-zone-2': 10.95,
                      'fedex-zone-3': 11.94,
                      'fedex-zone-4': 13.24,
                      'fedex-zone-5': 14.1,
                      'fedex-zone-6': 14.49,
                      'fedex-zone-7': 15.44,
                      'fedex-zone-8': 16.16,
                      'fedex-zone-9': 45.59,
                      'fedex-zone-14': 7.99,
                      'fedex-zone-17': 45.59,
                      'fedex-zone-22': 8.23,
                      'fedex-zone-23': 17.01,
                      'fedex-zone-25': 17.94,
                      'fedex-zone-51': 27.0,
                      'fedex-zone-54': 41.76,
                      'fedex-zone-92': 17.01,
                      'fedex-zone-96': 17.94,
                    },
                    '5': {
                      'fedex-zone-2': 11.24,
                      'fedex-zone-3': 12.49,
                      'fedex-zone-4': 13.7,
                      'fedex-zone-5': 14.73,
                      'fedex-zone-6': 15.34,
                      'fedex-zone-7': 16.15,
                      'fedex-zone-8': 17.13,
                      'fedex-zone-9': 49.42,
                      'fedex-zone-14': 8.09,
                      'fedex-zone-17': 49.42,
                      'fedex-zone-22': 8.34,
                      'fedex-zone-23': 19.35,
                      'fedex-zone-25': 20.39,
                      'fedex-zone-51': 28.64,
                      'fedex-zone-54': 42.26,
                      'fedex-zone-92': 19.35,
                      'fedex-zone-96': 20.39,
                    },
                    '6': {
                      'fedex-zone-2': 11.34,
                      'fedex-zone-3': 12.54,
                      'fedex-zone-4': 13.71,
                      'fedex-zone-5': 14.8,
                      'fedex-zone-6': 15.35,
                      'fedex-zone-7': 16.18,
                      'fedex-zone-8': 17.14,
                      'fedex-zone-9': 53.33,
                      'fedex-zone-14': 8.1,
                      'fedex-zone-17': 53.33,
                      'fedex-zone-22': 8.58,
                      'fedex-zone-23': 21.8,
                      'fedex-zone-25': 22.92,
                      'fedex-zone-51': 30.09,
                      'fedex-zone-54': 44.36,
                      'fedex-zone-92': 21.8,
                      'fedex-zone-96': 22.92,
                    },
                    '7': {
                      'fedex-zone-2': 11.98,
                      'fedex-zone-3': 12.83,
                      'fedex-zone-4': 14.07,
                      'fedex-zone-5': 15.27,
                      'fedex-zone-6': 15.63,
                      'fedex-zone-7': 16.61,
                      'fedex-zone-8': 17.79,
                      'fedex-zone-9': 56.94,
                      'fedex-zone-14': 8.18,
                      'fedex-zone-17': 56.94,
                      'fedex-zone-22': 8.91,
                      'fedex-zone-23': 24.15,
                      'fedex-zone-25': 25.43,
                      'fedex-zone-51': 31.47,
                      'fedex-zone-54': 45.06,
                      'fedex-zone-92': 24.15,
                      'fedex-zone-96': 25.43,
                    },
                    '8': {
                      'fedex-zone-2': 12.33,
                      'fedex-zone-3': 13.3,
                      'fedex-zone-4': 14.57,
                      'fedex-zone-5': 15.71,
                      'fedex-zone-6': 16.26,
                      'fedex-zone-7': 17.28,
                      'fedex-zone-8': 18.56,
                      'fedex-zone-9': 59.0,
                      'fedex-zone-14': 8.31,
                      'fedex-zone-17': 59.0,
                      'fedex-zone-22': 9.23,
                      'fedex-zone-23': 26.53,
                      'fedex-zone-25': 28.01,
                      'fedex-zone-51': 32.92,
                      'fedex-zone-54': 46.67,
                      'fedex-zone-92': 26.53,
                      'fedex-zone-96': 28.01,
                    },
                    '9': {
                      'fedex-zone-2': 12.52,
                      'fedex-zone-3': 13.48,
                      'fedex-zone-4': 14.76,
                      'fedex-zone-5': 15.85,
                      'fedex-zone-6': 16.6,
                      'fedex-zone-7': 18.0,
                      'fedex-zone-8': 19.55,
                      'fedex-zone-9': 63.16,
                      'fedex-zone-14': 8.47,
                      'fedex-zone-17': 63.16,
                      'fedex-zone-22': 9.53,
                      'fedex-zone-23': 28.89,
                      'fedex-zone-25': 30.54,
                      'fedex-zone-51': 34.27,
                      'fedex-zone-54': 47.29,
                      'fedex-zone-92': 28.89,
                      'fedex-zone-96': 30.54,
                    },
                    '10': {
                      'fedex-zone-2': 12.69,
                      'fedex-zone-3': 13.62,
                      'fedex-zone-4': 14.91,
                      'fedex-zone-5': 16.28,
                      'fedex-zone-6': 16.8,
                      'fedex-zone-7': 18.86,
                      'fedex-zone-8': 20.84,
                      'fedex-zone-9': 67.1,
                      'fedex-zone-14': 8.57,
                      'fedex-zone-17': 67.1,
                      'fedex-zone-22': 9.88,
                      'fedex-zone-23': 31.25,
                      'fedex-zone-25': 33.14,
                      'fedex-zone-51': 35.7,
                      'fedex-zone-54': 48.82,
                      'fedex-zone-92': 31.25,
                      'fedex-zone-96': 33.14,
                    },
                    '11': {
                      'fedex-zone-2': 13.33,
                      'fedex-zone-3': 13.87,
                      'fedex-zone-4': 15.18,
                      'fedex-zone-5': 16.32,
                      'fedex-zone-6': 17.31,
                      'fedex-zone-7': 20.37,
                      'fedex-zone-8': 22.14,
                      'fedex-zone-9': 70.67,
                      'fedex-zone-14': 8.75,
                      'fedex-zone-17': 70.67,
                      'fedex-zone-22': 10.18,
                      'fedex-zone-23': 33.61,
                      'fedex-zone-25': 35.65,
                      'fedex-zone-51': 37.88,
                      'fedex-zone-54': 52.69,
                      'fedex-zone-92': 33.61,
                      'fedex-zone-96': 35.65,
                    },
                    '12': {
                      'fedex-zone-2': 13.55,
                      'fedex-zone-3': 14.45,
                      'fedex-zone-4': 15.33,
                      'fedex-zone-5': 16.55,
                      'fedex-zone-6': 17.91,
                      'fedex-zone-7': 21.19,
                      'fedex-zone-8': 23.17,
                      'fedex-zone-9': 73.7,
                      'fedex-zone-14': 8.91,
                      'fedex-zone-17': 73.7,
                      'fedex-zone-22': 10.61,
                      'fedex-zone-23': 35.89,
                      'fedex-zone-25': 38.1,
                      'fedex-zone-51': 39.17,
                      'fedex-zone-54': 54.14,
                      'fedex-zone-92': 35.89,
                      'fedex-zone-96': 38.1,
                    },
                    '13': {
                      'fedex-zone-2': 13.56,
                      'fedex-zone-3': 14.52,
                      'fedex-zone-4': 15.51,
                      'fedex-zone-5': 16.87,
                      'fedex-zone-6': 18.47,
                      'fedex-zone-7': 22.49,
                      'fedex-zone-8': 24.22,
                      'fedex-zone-9': 76.75,
                      'fedex-zone-14': 8.99,
                      'fedex-zone-17': 76.75,
                      'fedex-zone-22': 10.93,
                      'fedex-zone-23': 38.02,
                      'fedex-zone-25': 40.44,
                      'fedex-zone-51': 40.75,
                      'fedex-zone-54': 55.89,
                      'fedex-zone-92': 38.02,
                      'fedex-zone-96': 40.44,
                    },
                    '14': {
                      'fedex-zone-2': 14.11,
                      'fedex-zone-3': 14.91,
                      'fedex-zone-4': 15.67,
                      'fedex-zone-5': 17.28,
                      'fedex-zone-6': 19.55,
                      'fedex-zone-7': 24.1,
                      'fedex-zone-8': 26.34,
                      'fedex-zone-9': 79.93,
                      'fedex-zone-14': 9.09,
                      'fedex-zone-17': 79.93,
                      'fedex-zone-22': 11.29,
                      'fedex-zone-23': 39.97,
                      'fedex-zone-25': 42.8,
                      'fedex-zone-51': 40.76,
                      'fedex-zone-54': 55.9,
                      'fedex-zone-92': 39.97,
                      'fedex-zone-96': 42.8,
                    },
                    '15': {
                      'fedex-zone-2': 14.12,
                      'fedex-zone-3': 15.24,
                      'fedex-zone-4': 15.89,
                      'fedex-zone-5': 17.89,
                      'fedex-zone-6': 20.63,
                      'fedex-zone-7': 24.85,
                      'fedex-zone-8': 27.42,
                      'fedex-zone-9': 82.87,
                      'fedex-zone-14': 9.18,
                      'fedex-zone-17': 82.87,
                      'fedex-zone-22': 11.64,
                      'fedex-zone-23': 41.99,
                      'fedex-zone-25': 45.13,
                      'fedex-zone-51': 41.92,
                      'fedex-zone-54': 56.94,
                      'fedex-zone-92': 41.99,
                      'fedex-zone-96': 45.13,
                    },
                    '16': {
                      'fedex-zone-2': 14.48,
                      'fedex-zone-3': 15.68,
                      'fedex-zone-4': 16.18,
                      'fedex-zone-5': 18.2,
                      'fedex-zone-6': 21.3,
                      'fedex-zone-7': 26.16,
                      'fedex-zone-8': 28.78,
                      'fedex-zone-9': 86.58,
                      'fedex-zone-14': 9.27,
                      'fedex-zone-17': 86.58,
                      'fedex-zone-22': 11.92,
                      'fedex-zone-23': 43.86,
                      'fedex-zone-25': 47.26,
                      'fedex-zone-51': 43.33,
                      'fedex-zone-54': 58.9,
                      'fedex-zone-92': 43.86,
                      'fedex-zone-96': 47.26,
                    },
                    '17': {
                      'fedex-zone-2': 14.59,
                      'fedex-zone-3': 16.01,
                      'fedex-zone-4': 16.36,
                      'fedex-zone-5': 18.71,
                      'fedex-zone-6': 22.2,
                      'fedex-zone-7': 27.5,
                      'fedex-zone-8': 29.04,
                      'fedex-zone-9': 90.27,
                      'fedex-zone-14': 9.35,
                      'fedex-zone-17': 90.27,
                      'fedex-zone-22': 12.29,
                      'fedex-zone-23': 45.96,
                      'fedex-zone-25': 49.72,
                      'fedex-zone-51': 44.48,
                      'fedex-zone-54': 60.55,
                      'fedex-zone-92': 45.96,
                      'fedex-zone-96': 49.72,
                    },
                    '18': {
                      'fedex-zone-2': 14.74,
                      'fedex-zone-3': 16.22,
                      'fedex-zone-4': 16.53,
                      'fedex-zone-5': 19.61,
                      'fedex-zone-6': 23.36,
                      'fedex-zone-7': 28.32,
                      'fedex-zone-8': 31.03,
                      'fedex-zone-9': 94.0,
                      'fedex-zone-14': 9.47,
                      'fedex-zone-17': 94.0,
                      'fedex-zone-22': 12.63,
                      'fedex-zone-23': 48.1,
                      'fedex-zone-25': 52.17,
                      'fedex-zone-51': 46.06,
                      'fedex-zone-54': 62.37,
                      'fedex-zone-92': 48.1,
                      'fedex-zone-96': 52.17,
                    },
                    '19': {
                      'fedex-zone-2': 15.14,
                      'fedex-zone-3': 17.01,
                      'fedex-zone-4': 17.42,
                      'fedex-zone-5': 20.54,
                      'fedex-zone-6': 24.05,
                      'fedex-zone-7': 29.18,
                      'fedex-zone-8': 32.53,
                      'fedex-zone-9': 97.71,
                      'fedex-zone-14': 9.59,
                      'fedex-zone-17': 97.71,
                      'fedex-zone-22': 13.03,
                      'fedex-zone-23': 50.18,
                      'fedex-zone-25': 54.61,
                      'fedex-zone-51': 47.5,
                      'fedex-zone-54': 64.18,
                      'fedex-zone-92': 50.18,
                      'fedex-zone-96': 54.61,
                    },
                    '20': {
                      'fedex-zone-2': 15.25,
                      'fedex-zone-3': 17.15,
                      'fedex-zone-4': 17.52,
                      'fedex-zone-5': 21.35,
                      'fedex-zone-6': 24.87,
                      'fedex-zone-7': 30.26,
                      'fedex-zone-8': 33.71,
                      'fedex-zone-9': 100.98,
                      'fedex-zone-14': 9.66,
                      'fedex-zone-17': 100.98,
                      'fedex-zone-22': 13.36,
                      'fedex-zone-23': 52.2,
                      'fedex-zone-25': 57.09,
                      'fedex-zone-51': 48.68,
                      'fedex-zone-54': 65.92,
                      'fedex-zone-92': 52.2,
                      'fedex-zone-96': 57.09,
                    },
                    '21': {
                      'fedex-zone-2': 15.8,
                      'fedex-zone-3': 17.82,
                      'fedex-zone-4': 18.45,
                      'fedex-zone-5': 21.6,
                      'fedex-zone-6': 25.65,
                      'fedex-zone-7': 31.11,
                      'fedex-zone-8': 34.74,
                      'fedex-zone-9': 103.29,
                      'fedex-zone-14': 9.78,
                      'fedex-zone-17': 103.29,
                      'fedex-zone-22': 13.78,
                      'fedex-zone-23': 54.03,
                      'fedex-zone-25': 59.55,
                      'fedex-zone-51': 49.85,
                      'fedex-zone-54': 67.73,
                      'fedex-zone-92': 54.03,
                      'fedex-zone-96': 59.55,
                    },
                    '22': {
                      'fedex-zone-2': 15.85,
                      'fedex-zone-3': 18.0,
                      'fedex-zone-4': 18.95,
                      'fedex-zone-5': 22.19,
                      'fedex-zone-6': 26.69,
                      'fedex-zone-7': 32.26,
                      'fedex-zone-8': 36.26,
                      'fedex-zone-9': 106.53,
                      'fedex-zone-14': 9.79,
                      'fedex-zone-17': 106.53,
                      'fedex-zone-22': 14.09,
                      'fedex-zone-23': 55.78,
                      'fedex-zone-25': 61.9,
                      'fedex-zone-51': 51.36,
                      'fedex-zone-54': 69.7,
                      'fedex-zone-92': 55.78,
                      'fedex-zone-96': 61.9,
                    },
                    '23': {
                      'fedex-zone-2': 15.91,
                      'fedex-zone-3': 18.34,
                      'fedex-zone-4': 19.37,
                      'fedex-zone-5': 22.82,
                      'fedex-zone-6': 27.97,
                      'fedex-zone-7': 33.34,
                      'fedex-zone-8': 37.7,
                      'fedex-zone-9': 109.74,
                      'fedex-zone-14': 9.94,
                      'fedex-zone-17': 109.74,
                      'fedex-zone-22': 14.46,
                      'fedex-zone-23': 57.54,
                      'fedex-zone-25': 64.23,
                      'fedex-zone-51': 52.63,
                      'fedex-zone-54': 71.43,
                      'fedex-zone-92': 57.54,
                      'fedex-zone-96': 64.23,
                    },
                    '24': {
                      'fedex-zone-2': 16.34,
                      'fedex-zone-3': 19.08,
                      'fedex-zone-4': 20.37,
                      'fedex-zone-5': 23.81,
                      'fedex-zone-6': 29.02,
                      'fedex-zone-7': 34.14,
                      'fedex-zone-8': 39.86,
                      'fedex-zone-9': 113.34,
                      'fedex-zone-14': 9.95,
                      'fedex-zone-17': 113.34,
                      'fedex-zone-22': 14.83,
                      'fedex-zone-23': 59.27,
                      'fedex-zone-25': 66.57,
                      'fedex-zone-51': 53.98,
                      'fedex-zone-54': 73.17,
                      'fedex-zone-92': 59.27,
                      'fedex-zone-96': 66.57,
                    },
                    '25': {
                      'fedex-zone-2': 16.53,
                      'fedex-zone-3': 19.3,
                      'fedex-zone-4': 20.62,
                      'fedex-zone-5': 24.46,
                      'fedex-zone-6': 29.53,
                      'fedex-zone-7': 35.62,
                      'fedex-zone-8': 40.64,
                      'fedex-zone-9': 116.85,
                      'fedex-zone-14': 10.06,
                      'fedex-zone-17': 116.85,
                      'fedex-zone-22': 15.24,
                      'fedex-zone-23': 61.17,
                      'fedex-zone-25': 68.86,
                      'fedex-zone-51': 55.03,
                      'fedex-zone-54': 74.92,
                      'fedex-zone-92': 61.17,
                      'fedex-zone-96': 68.86,
                    },
                    '26': {
                      'fedex-zone-2': 17.32,
                      'fedex-zone-3': 19.96,
                      'fedex-zone-4': 21.48,
                      'fedex-zone-5': 25.46,
                      'fedex-zone-6': 30.61,
                      'fedex-zone-7': 37.08,
                      'fedex-zone-8': 42.31,
                      'fedex-zone-9': 120.55,
                      'fedex-zone-14': 10.16,
                      'fedex-zone-17': 120.55,
                      'fedex-zone-22': 15.64,
                      'fedex-zone-23': 63.05,
                      'fedex-zone-25': 71.11,
                      'fedex-zone-51': 56.33,
                      'fedex-zone-54': 77.0,
                      'fedex-zone-92': 63.05,
                      'fedex-zone-96': 71.11,
                    },
                    '27': {
                      'fedex-zone-2': 17.74,
                      'fedex-zone-3': 20.44,
                      'fedex-zone-4': 21.7,
                      'fedex-zone-5': 25.88,
                      'fedex-zone-6': 31.84,
                      'fedex-zone-7': 37.76,
                      'fedex-zone-8': 43.02,
                      'fedex-zone-9': 123.89,
                      'fedex-zone-14': 10.3,
                      'fedex-zone-17': 123.89,
                      'fedex-zone-22': 16.04,
                      'fedex-zone-23': 64.86,
                      'fedex-zone-25': 73.31,
                      'fedex-zone-51': 57.91,
                      'fedex-zone-54': 78.88,
                      'fedex-zone-92': 64.86,
                      'fedex-zone-96': 73.31,
                    },
                    '28': {
                      'fedex-zone-2': 18.22,
                      'fedex-zone-3': 20.93,
                      'fedex-zone-4': 22.92,
                      'fedex-zone-5': 27.4,
                      'fedex-zone-6': 33.39,
                      'fedex-zone-7': 39.46,
                      'fedex-zone-8': 45.09,
                      'fedex-zone-9': 127.22,
                      'fedex-zone-14': 10.35,
                      'fedex-zone-17': 127.22,
                      'fedex-zone-22': 16.41,
                      'fedex-zone-23': 66.74,
                      'fedex-zone-25': 75.55,
                      'fedex-zone-51': 59.3,
                      'fedex-zone-54': 80.83,
                      'fedex-zone-92': 66.74,
                      'fedex-zone-96': 75.55,
                    },
                    '29': {
                      'fedex-zone-2': 18.26,
                      'fedex-zone-3': 21.33,
                      'fedex-zone-4': 23.13,
                      'fedex-zone-5': 27.41,
                      'fedex-zone-6': 34.35,
                      'fedex-zone-7': 40.73,
                      'fedex-zone-8': 45.86,
                      'fedex-zone-9': 130.35,
                      'fedex-zone-14': 10.46,
                      'fedex-zone-17': 130.35,
                      'fedex-zone-22': 16.82,
                      'fedex-zone-23': 68.64,
                      'fedex-zone-25': 77.71,
                      'fedex-zone-51': 60.68,
                      'fedex-zone-54': 82.7,
                      'fedex-zone-92': 68.64,
                      'fedex-zone-96': 77.71,
                    },
                    '30': {
                      'fedex-zone-2': 18.44,
                      'fedex-zone-3': 21.84,
                      'fedex-zone-4': 24.01,
                      'fedex-zone-5': 28.49,
                      'fedex-zone-6': 34.9,
                      'fedex-zone-7': 40.93,
                      'fedex-zone-8': 47.77,
                      'fedex-zone-9': 133.47,
                      'fedex-zone-14': 10.51,
                      'fedex-zone-17': 133.47,
                      'fedex-zone-22': 17.15,
                      'fedex-zone-23': 70.5,
                      'fedex-zone-25': 79.94,
                      'fedex-zone-51': 62.05,
                      'fedex-zone-54': 84.6,
                      'fedex-zone-92': 70.5,
                      'fedex-zone-96': 79.94,
                    },
                    '31': {
                      'fedex-zone-2': 19.23,
                      'fedex-zone-3': 22.32,
                      'fedex-zone-4': 24.49,
                      'fedex-zone-5': 28.85,
                      'fedex-zone-6': 35.92,
                      'fedex-zone-7': 42.06,
                      'fedex-zone-8': 49.29,
                      'fedex-zone-9': 133.48,
                      'fedex-zone-14': 10.65,
                      'fedex-zone-17': 133.48,
                      'fedex-zone-22': 17.52,
                      'fedex-zone-23': 72.39,
                      'fedex-zone-25': 82.06,
                      'fedex-zone-51': 63.21,
                      'fedex-zone-54': 86.63,
                      'fedex-zone-92': 72.39,
                      'fedex-zone-96': 82.06,
                    },
                    '32': {
                      'fedex-zone-2': 19.24,
                      'fedex-zone-3': 22.33,
                      'fedex-zone-4': 24.5,
                      'fedex-zone-5': 28.86,
                      'fedex-zone-6': 35.93,
                      'fedex-zone-7': 42.07,
                      'fedex-zone-8': 50.3,
                      'fedex-zone-9': 134.07,
                      'fedex-zone-14': 10.72,
                      'fedex-zone-17': 134.07,
                      'fedex-zone-22': 17.79,
                      'fedex-zone-23': 74.11,
                      'fedex-zone-25': 84.02,
                      'fedex-zone-51': 64.58,
                      'fedex-zone-54': 88.56,
                      'fedex-zone-92': 74.11,
                      'fedex-zone-96': 84.02,
                    },
                    '33': {
                      'fedex-zone-2': 19.36,
                      'fedex-zone-3': 22.66,
                      'fedex-zone-4': 25.6,
                      'fedex-zone-5': 30.22,
                      'fedex-zone-6': 38.18,
                      'fedex-zone-7': 43.46,
                      'fedex-zone-8': 51.18,
                      'fedex-zone-9': 136.87,
                      'fedex-zone-14': 10.8,
                      'fedex-zone-17': 136.87,
                      'fedex-zone-22': 18.08,
                      'fedex-zone-23': 75.83,
                      'fedex-zone-25': 85.82,
                      'fedex-zone-51': 66.19,
                      'fedex-zone-54': 90.47,
                      'fedex-zone-92': 75.83,
                      'fedex-zone-96': 85.82,
                    },
                    '34': {
                      'fedex-zone-2': 19.47,
                      'fedex-zone-3': 23.17,
                      'fedex-zone-4': 26.42,
                      'fedex-zone-5': 31.27,
                      'fedex-zone-6': 38.28,
                      'fedex-zone-7': 44.76,
                      'fedex-zone-8': 53.63,
                      'fedex-zone-9': 139.94,
                      'fedex-zone-14': 10.95,
                      'fedex-zone-17': 139.94,
                      'fedex-zone-22': 18.43,
                      'fedex-zone-23': 77.49,
                      'fedex-zone-25': 87.53,
                      'fedex-zone-51': 67.44,
                      'fedex-zone-54': 92.35,
                      'fedex-zone-92': 77.49,
                      'fedex-zone-96': 87.53,
                    },
                    '35': {
                      'fedex-zone-2': 19.84,
                      'fedex-zone-3': 24.4,
                      'fedex-zone-4': 27.03,
                      'fedex-zone-5': 32.03,
                      'fedex-zone-6': 38.85,
                      'fedex-zone-7': 45.91,
                      'fedex-zone-8': 54.52,
                      'fedex-zone-9': 143.41,
                      'fedex-zone-14': 11.05,
                      'fedex-zone-17': 143.41,
                      'fedex-zone-22': 18.8,
                      'fedex-zone-23': 79.0,
                      'fedex-zone-25': 89.12,
                      'fedex-zone-51': 68.73,
                      'fedex-zone-54': 93.58,
                      'fedex-zone-92': 79.0,
                      'fedex-zone-96': 89.12,
                    },
                    '36': {
                      'fedex-zone-2': 20.13,
                      'fedex-zone-3': 24.41,
                      'fedex-zone-4': 27.51,
                      'fedex-zone-5': 32.82,
                      'fedex-zone-6': 40.48,
                      'fedex-zone-7': 47.47,
                      'fedex-zone-8': 56.14,
                      'fedex-zone-9': 146.47,
                      'fedex-zone-14': 11.12,
                      'fedex-zone-17': 146.47,
                      'fedex-zone-22': 19.09,
                      'fedex-zone-23': 80.36,
                      'fedex-zone-25': 90.63,
                      'fedex-zone-51': 69.99,
                      'fedex-zone-54': 95.75,
                      'fedex-zone-92': 80.36,
                      'fedex-zone-96': 90.63,
                    },
                    '37': {
                      'fedex-zone-2': 20.43,
                      'fedex-zone-3': 24.73,
                      'fedex-zone-4': 27.79,
                      'fedex-zone-5': 33.54,
                      'fedex-zone-6': 40.66,
                      'fedex-zone-7': 49.0,
                      'fedex-zone-8': 56.68,
                      'fedex-zone-9': 149.83,
                      'fedex-zone-14': 11.24,
                      'fedex-zone-17': 149.83,
                      'fedex-zone-22': 19.39,
                      'fedex-zone-23': 81.72,
                      'fedex-zone-25': 92.06,
                      'fedex-zone-51': 71.57,
                      'fedex-zone-54': 97.7,
                      'fedex-zone-92': 81.72,
                      'fedex-zone-96': 92.06,
                    },
                    '38': {
                      'fedex-zone-2': 20.75,
                      'fedex-zone-3': 25.11,
                      'fedex-zone-4': 28.68,
                      'fedex-zone-5': 34.35,
                      'fedex-zone-6': 41.58,
                      'fedex-zone-7': 49.66,
                      'fedex-zone-8': 57.74,
                      'fedex-zone-9': 153.42,
                      'fedex-zone-14': 11.37,
                      'fedex-zone-17': 153.42,
                      'fedex-zone-22': 19.69,
                      'fedex-zone-23': 83.03,
                      'fedex-zone-25': 93.57,
                      'fedex-zone-51': 72.87,
                      'fedex-zone-54': 99.38,
                      'fedex-zone-92': 83.03,
                      'fedex-zone-96': 93.57,
                    },
                    '39': {
                      'fedex-zone-2': 21.44,
                      'fedex-zone-3': 26.09,
                      'fedex-zone-4': 29.62,
                      'fedex-zone-5': 35.41,
                      'fedex-zone-6': 43.47,
                      'fedex-zone-7': 51.13,
                      'fedex-zone-8': 58.93,
                      'fedex-zone-9': 156.72,
                      'fedex-zone-14': 11.44,
                      'fedex-zone-17': 156.72,
                      'fedex-zone-22': 19.96,
                      'fedex-zone-23': 84.45,
                      'fedex-zone-25': 95.0,
                      'fedex-zone-51': 74.53,
                      'fedex-zone-54': 100.97,
                      'fedex-zone-92': 84.45,
                      'fedex-zone-96': 95.0,
                    },
                    '40': {
                      'fedex-zone-2': 21.46,
                      'fedex-zone-3': 26.19,
                      'fedex-zone-4': 29.71,
                      'fedex-zone-5': 35.42,
                      'fedex-zone-6': 43.53,
                      'fedex-zone-7': 51.14,
                      'fedex-zone-8': 59.34,
                      'fedex-zone-9': 160.08,
                      'fedex-zone-14': 11.54,
                      'fedex-zone-17': 160.08,
                      'fedex-zone-22': 20.28,
                      'fedex-zone-23': 85.82,
                      'fedex-zone-25': 96.65,
                      'fedex-zone-51': 75.78,
                      'fedex-zone-54': 102.91,
                      'fedex-zone-92': 85.82,
                      'fedex-zone-96': 96.65,
                    },
                    '41': {
                      'fedex-zone-2': 21.74,
                      'fedex-zone-3': 27.06,
                      'fedex-zone-4': 30.5,
                      'fedex-zone-5': 36.68,
                      'fedex-zone-6': 45.34,
                      'fedex-zone-7': 52.72,
                      'fedex-zone-8': 61.17,
                      'fedex-zone-9': 162.84,
                      'fedex-zone-14': 11.67,
                      'fedex-zone-17': 162.84,
                      'fedex-zone-22': 20.55,
                      'fedex-zone-23': 87.23,
                      'fedex-zone-25': 98.33,
                      'fedex-zone-51': 77.09,
                      'fedex-zone-54': 104.66,
                      'fedex-zone-92': 87.23,
                      'fedex-zone-96': 98.33,
                    },
                    '42': {
                      'fedex-zone-2': 21.87,
                      'fedex-zone-3': 27.41,
                      'fedex-zone-4': 31.68,
                      'fedex-zone-5': 36.8,
                      'fedex-zone-6': 45.54,
                      'fedex-zone-7': 53.61,
                      'fedex-zone-8': 61.48,
                      'fedex-zone-9': 165.91,
                      'fedex-zone-14': 11.79,
                      'fedex-zone-17': 165.91,
                      'fedex-zone-22': 20.89,
                      'fedex-zone-23': 88.56,
                      'fedex-zone-25': 100.07,
                      'fedex-zone-51': 78.32,
                      'fedex-zone-54': 106.21,
                      'fedex-zone-92': 88.56,
                      'fedex-zone-96': 100.07,
                    },
                    '43': {
                      'fedex-zone-2': 22.37,
                      'fedex-zone-3': 27.81,
                      'fedex-zone-4': 31.73,
                      'fedex-zone-5': 38.67,
                      'fedex-zone-6': 48.01,
                      'fedex-zone-7': 55.56,
                      'fedex-zone-8': 63.15,
                      'fedex-zone-9': 169.29,
                      'fedex-zone-14': 12.03,
                      'fedex-zone-17': 169.29,
                      'fedex-zone-22': 21.14,
                      'fedex-zone-23': 89.88,
                      'fedex-zone-25': 101.84,
                      'fedex-zone-51': 79.77,
                      'fedex-zone-54': 108.01,
                      'fedex-zone-92': 89.88,
                      'fedex-zone-96': 101.84,
                    },
                    '44': {
                      'fedex-zone-2': 22.68,
                      'fedex-zone-3': 28.23,
                      'fedex-zone-4': 32.54,
                      'fedex-zone-5': 39.36,
                      'fedex-zone-6': 48.29,
                      'fedex-zone-7': 57.29,
                      'fedex-zone-8': 63.81,
                      'fedex-zone-9': 171.72,
                      'fedex-zone-14': 12.09,
                      'fedex-zone-17': 171.72,
                      'fedex-zone-22': 21.47,
                      'fedex-zone-23': 91.3,
                      'fedex-zone-25': 103.52,
                      'fedex-zone-51': 80.8,
                      'fedex-zone-54': 109.4,
                      'fedex-zone-92': 91.3,
                      'fedex-zone-96': 103.52,
                    },
                    '45': {
                      'fedex-zone-2': 22.71,
                      'fedex-zone-3': 28.24,
                      'fedex-zone-4': 32.55,
                      'fedex-zone-5': 39.37,
                      'fedex-zone-6': 48.3,
                      'fedex-zone-7': 58.41,
                      'fedex-zone-8': 64.26,
                      'fedex-zone-9': 175.03,
                      'fedex-zone-14': 12.33,
                      'fedex-zone-17': 175.03,
                      'fedex-zone-22': 21.74,
                      'fedex-zone-23': 92.66,
                      'fedex-zone-25': 105.25,
                      'fedex-zone-51': 82.32,
                      'fedex-zone-54': 111.44,
                      'fedex-zone-92': 92.66,
                      'fedex-zone-96': 105.25,
                    },
                    '46': {
                      'fedex-zone-2': 23.21,
                      'fedex-zone-3': 28.53,
                      'fedex-zone-4': 33.59,
                      'fedex-zone-5': 40.11,
                      'fedex-zone-6': 49.58,
                      'fedex-zone-7': 59.03,
                      'fedex-zone-8': 65.96,
                      'fedex-zone-9': 178.4,
                      'fedex-zone-14': 12.44,
                      'fedex-zone-17': 178.4,
                      'fedex-zone-22': 22.05,
                      'fedex-zone-23': 94.03,
                      'fedex-zone-25': 106.94,
                      'fedex-zone-51': 83.65,
                      'fedex-zone-54': 113.02,
                      'fedex-zone-92': 94.03,
                      'fedex-zone-96': 106.94,
                    },
                    '47': {
                      'fedex-zone-2': 23.29,
                      'fedex-zone-3': 28.9,
                      'fedex-zone-4': 34.13,
                      'fedex-zone-5': 40.4,
                      'fedex-zone-6': 50.25,
                      'fedex-zone-7': 60.18,
                      'fedex-zone-8': 67.02,
                      'fedex-zone-9': 181.82,
                      'fedex-zone-14': 12.63,
                      'fedex-zone-17': 181.82,
                      'fedex-zone-22': 22.32,
                      'fedex-zone-23': 95.45,
                      'fedex-zone-25': 108.68,
                      'fedex-zone-51': 84.94,
                      'fedex-zone-54': 114.78,
                      'fedex-zone-92': 95.45,
                      'fedex-zone-96': 108.68,
                    },
                    '48': {
                      'fedex-zone-2': 23.3,
                      'fedex-zone-3': 29.15,
                      'fedex-zone-4': 34.52,
                      'fedex-zone-5': 41.87,
                      'fedex-zone-6': 51.0,
                      'fedex-zone-7': 60.73,
                      'fedex-zone-8': 68.09,
                      'fedex-zone-9': 184.93,
                      'fedex-zone-14': 12.82,
                      'fedex-zone-17': 184.93,
                      'fedex-zone-22': 22.71,
                      'fedex-zone-23': 96.77,
                      'fedex-zone-25': 110.41,
                      'fedex-zone-51': 86.05,
                      'fedex-zone-54': 116.5,
                      'fedex-zone-92': 96.77,
                      'fedex-zone-96': 110.41,
                    },
                    '49': {
                      'fedex-zone-2': 23.31,
                      'fedex-zone-3': 29.16,
                      'fedex-zone-4': 34.53,
                      'fedex-zone-5': 41.88,
                      'fedex-zone-6': 51.38,
                      'fedex-zone-7': 61.95,
                      'fedex-zone-8': 68.49,
                      'fedex-zone-9': 188.1,
                      'fedex-zone-14': 13.06,
                      'fedex-zone-17': 188.1,
                      'fedex-zone-22': 23.06,
                      'fedex-zone-23': 98.13,
                      'fedex-zone-25': 111.96,
                      'fedex-zone-51': 87.49,
                      'fedex-zone-54': 118.11,
                      'fedex-zone-92': 98.13,
                      'fedex-zone-96': 111.96,
                    },
                    '50': {
                      'fedex-zone-2': 23.32,
                      'fedex-zone-3': 29.17,
                      'fedex-zone-4': 34.54,
                      'fedex-zone-5': 41.91,
                      'fedex-zone-6': 51.39,
                      'fedex-zone-7': 61.96,
                      'fedex-zone-8': 68.87,
                      'fedex-zone-9': 191.26,
                      'fedex-zone-14': 13.43,
                      'fedex-zone-17': 191.26,
                      'fedex-zone-22': 23.42,
                      'fedex-zone-23': 99.54,
                      'fedex-zone-25': 113.45,
                      'fedex-zone-51': 88.94,
                      'fedex-zone-54': 119.99,
                      'fedex-zone-92': 99.54,
                      'fedex-zone-96': 113.45,
                    },
                    '51': {
                      'fedex-zone-2': 23.33,
                      'fedex-zone-3': 29.18,
                      'fedex-zone-4': 34.55,
                      'fedex-zone-5': 41.92,
                      'fedex-zone-6': 51.79,
                      'fedex-zone-7': 62.44,
                      'fedex-zone-8': 70.13,
                      'fedex-zone-9': 195.15,
                      'fedex-zone-14': 13.56,
                      'fedex-zone-17': 195.15,
                      'fedex-zone-22': 23.73,
                      'fedex-zone-23': 100.78,
                      'fedex-zone-25': 114.92,
                      'fedex-zone-51': 91.65,
                      'fedex-zone-54': 122.5,
                      'fedex-zone-92': 100.78,
                      'fedex-zone-96': 114.92,
                    },
                    '52': {
                      'fedex-zone-2': 23.34,
                      'fedex-zone-3': 29.19,
                      'fedex-zone-4': 34.57,
                      'fedex-zone-5': 41.93,
                      'fedex-zone-6': 51.8,
                      'fedex-zone-7': 62.46,
                      'fedex-zone-8': 70.14,
                      'fedex-zone-9': 195.55,
                      'fedex-zone-14': 13.87,
                      'fedex-zone-17': 195.55,
                      'fedex-zone-22': 24.16,
                      'fedex-zone-23': 101.9,
                      'fedex-zone-25': 116.37,
                      'fedex-zone-51': 91.66,
                      'fedex-zone-54': 122.52,
                      'fedex-zone-92': 101.9,
                      'fedex-zone-96': 116.37,
                    },
                    '53': {
                      'fedex-zone-2': 23.35,
                      'fedex-zone-3': 29.2,
                      'fedex-zone-4': 34.58,
                      'fedex-zone-5': 42.35,
                      'fedex-zone-6': 51.81,
                      'fedex-zone-7': 62.47,
                      'fedex-zone-8': 70.82,
                      'fedex-zone-9': 198.5,
                      'fedex-zone-14': 14.0,
                      'fedex-zone-17': 198.5,
                      'fedex-zone-22': 24.7,
                      'fedex-zone-23': 103.04,
                      'fedex-zone-25': 117.88,
                      'fedex-zone-51': 94.19,
                      'fedex-zone-54': 124.86,
                      'fedex-zone-92': 103.04,
                      'fedex-zone-96': 117.88,
                    },
                    '54': {
                      'fedex-zone-2': 23.36,
                      'fedex-zone-3': 29.22,
                      'fedex-zone-4': 34.64,
                      'fedex-zone-5': 42.42,
                      'fedex-zone-6': 51.82,
                      'fedex-zone-7': 62.48,
                      'fedex-zone-8': 70.83,
                      'fedex-zone-9': 201.31,
                      'fedex-zone-14': 14.27,
                      'fedex-zone-17': 201.31,
                      'fedex-zone-22': 24.89,
                      'fedex-zone-23': 104.12,
                      'fedex-zone-25': 119.31,
                      'fedex-zone-51': 94.21,
                      'fedex-zone-54': 124.89,
                      'fedex-zone-92': 104.12,
                      'fedex-zone-96': 119.31,
                    },
                    '55': {
                      'fedex-zone-2': 23.37,
                      'fedex-zone-3': 29.23,
                      'fedex-zone-4': 34.65,
                      'fedex-zone-5': 42.43,
                      'fedex-zone-6': 51.83,
                      'fedex-zone-7': 62.49,
                      'fedex-zone-8': 70.84,
                      'fedex-zone-9': 204.02,
                      'fedex-zone-14': 14.54,
                      'fedex-zone-17': 204.02,
                      'fedex-zone-22': 25.26,
                      'fedex-zone-23': 105.28,
                      'fedex-zone-25': 120.86,
                      'fedex-zone-51': 96.39,
                      'fedex-zone-54': 127.45,
                      'fedex-zone-92': 105.28,
                      'fedex-zone-96': 120.86,
                    },
                    '56': {
                      'fedex-zone-2': 23.38,
                      'fedex-zone-3': 29.25,
                      'fedex-zone-4': 34.66,
                      'fedex-zone-5': 42.44,
                      'fedex-zone-6': 51.84,
                      'fedex-zone-7': 62.5,
                      'fedex-zone-8': 71.72,
                      'fedex-zone-9': 206.77,
                      'fedex-zone-14': 14.95,
                      'fedex-zone-17': 206.77,
                      'fedex-zone-22': 25.62,
                      'fedex-zone-23': 106.27,
                      'fedex-zone-25': 122.18,
                      'fedex-zone-51': 96.4,
                      'fedex-zone-54': 127.46,
                      'fedex-zone-92': 106.27,
                      'fedex-zone-96': 122.18,
                    },
                    '57': {
                      'fedex-zone-2': 23.8,
                      'fedex-zone-3': 29.38,
                      'fedex-zone-4': 34.67,
                      'fedex-zone-5': 43.72,
                      'fedex-zone-6': 51.86,
                      'fedex-zone-7': 62.51,
                      'fedex-zone-8': 72.45,
                      'fedex-zone-9': 209.62,
                      'fedex-zone-14': 15.04,
                      'fedex-zone-17': 209.62,
                      'fedex-zone-22': 25.96,
                      'fedex-zone-23': 107.23,
                      'fedex-zone-25': 123.38,
                      'fedex-zone-51': 98.18,
                      'fedex-zone-54': 130.03,
                      'fedex-zone-92': 107.23,
                      'fedex-zone-96': 123.38,
                    },
                    '58': {
                      'fedex-zone-2': 23.81,
                      'fedex-zone-3': 29.39,
                      'fedex-zone-4': 34.68,
                      'fedex-zone-5': 43.73,
                      'fedex-zone-6': 51.87,
                      'fedex-zone-7': 62.52,
                      'fedex-zone-8': 73.77,
                      'fedex-zone-9': 212.37,
                      'fedex-zone-14': 15.31,
                      'fedex-zone-17': 212.37,
                      'fedex-zone-22': 26.35,
                      'fedex-zone-23': 108.2,
                      'fedex-zone-25': 124.64,
                      'fedex-zone-51': 106.27,
                      'fedex-zone-54': 130.04,
                      'fedex-zone-92': 108.2,
                      'fedex-zone-96': 124.64,
                    },
                    '59': {
                      'fedex-zone-2': 23.82,
                      'fedex-zone-3': 29.42,
                      'fedex-zone-4': 34.92,
                      'fedex-zone-5': 43.75,
                      'fedex-zone-6': 52.72,
                      'fedex-zone-7': 62.64,
                      'fedex-zone-8': 74.3,
                      'fedex-zone-9': 215.6,
                      'fedex-zone-14': 15.74,
                      'fedex-zone-17': 215.6,
                      'fedex-zone-22': 26.7,
                      'fedex-zone-23': 109.25,
                      'fedex-zone-25': 125.85,
                      'fedex-zone-51': 106.28,
                      'fedex-zone-54': 132.33,
                      'fedex-zone-92': 109.25,
                      'fedex-zone-96': 125.85,
                    },
                    '60': {
                      'fedex-zone-2': 24.49,
                      'fedex-zone-3': 30.55,
                      'fedex-zone-4': 35.51,
                      'fedex-zone-5': 45.3,
                      'fedex-zone-6': 53.2,
                      'fedex-zone-7': 62.99,
                      'fedex-zone-8': 74.76,
                      'fedex-zone-9': 218.96,
                      'fedex-zone-14': 15.93,
                      'fedex-zone-17': 218.96,
                      'fedex-zone-22': 27.06,
                      'fedex-zone-23': 110.21,
                      'fedex-zone-25': 127.09,
                      'fedex-zone-51': 106.29,
                      'fedex-zone-54': 132.34,
                      'fedex-zone-92': 110.21,
                      'fedex-zone-96': 127.09,
                    },
                    '61': {
                      'fedex-zone-2': 24.5,
                      'fedex-zone-3': 30.64,
                      'fedex-zone-4': 35.86,
                      'fedex-zone-5': 45.4,
                      'fedex-zone-6': 53.68,
                      'fedex-zone-7': 63.35,
                      'fedex-zone-8': 75.22,
                      'fedex-zone-9': 221.66,
                      'fedex-zone-14': 16.19,
                      'fedex-zone-17': 221.66,
                      'fedex-zone-22': 27.4,
                      'fedex-zone-23': 111.23,
                      'fedex-zone-25': 128.21,
                      'fedex-zone-51': 106.3,
                      'fedex-zone-54': 135.18,
                      'fedex-zone-92': 111.23,
                      'fedex-zone-96': 128.21,
                    },
                    '62': {
                      'fedex-zone-2': 25.5,
                      'fedex-zone-3': 32.82,
                      'fedex-zone-4': 36.45,
                      'fedex-zone-5': 46.69,
                      'fedex-zone-6': 54.03,
                      'fedex-zone-7': 64.32,
                      'fedex-zone-8': 75.68,
                      'fedex-zone-9': 225.3,
                      'fedex-zone-14': 16.33,
                      'fedex-zone-17': 225.3,
                      'fedex-zone-22': 27.76,
                      'fedex-zone-23': 112.25,
                      'fedex-zone-25': 129.29,
                      'fedex-zone-51': 106.31,
                      'fedex-zone-54': 135.19,
                      'fedex-zone-92': 112.25,
                      'fedex-zone-96': 129.29,
                    },
                    '63': {
                      'fedex-zone-2': 25.51,
                      'fedex-zone-3': 32.83,
                      'fedex-zone-4': 36.8,
                      'fedex-zone-5': 46.7,
                      'fedex-zone-6': 54.4,
                      'fedex-zone-7': 64.44,
                      'fedex-zone-8': 76.14,
                      'fedex-zone-9': 228.99,
                      'fedex-zone-14': 16.67,
                      'fedex-zone-17': 228.99,
                      'fedex-zone-22': 28.13,
                      'fedex-zone-23': 113.25,
                      'fedex-zone-25': 130.42,
                      'fedex-zone-51': 106.33,
                      'fedex-zone-54': 137.7,
                      'fedex-zone-92': 113.25,
                      'fedex-zone-96': 130.42,
                    },
                    '64': {
                      'fedex-zone-2': 26.19,
                      'fedex-zone-3': 33.16,
                      'fedex-zone-4': 37.4,
                      'fedex-zone-5': 46.74,
                      'fedex-zone-6': 55.29,
                      'fedex-zone-7': 64.86,
                      'fedex-zone-8': 77.31,
                      'fedex-zone-9': 232.8,
                      'fedex-zone-14': 16.78,
                      'fedex-zone-17': 232.8,
                      'fedex-zone-22': 28.49,
                      'fedex-zone-23': 114.19,
                      'fedex-zone-25': 131.47,
                      'fedex-zone-51': 106.34,
                      'fedex-zone-54': 137.71,
                      'fedex-zone-92': 114.19,
                      'fedex-zone-96': 131.47,
                    },
                    '65': {
                      'fedex-zone-2': 26.48,
                      'fedex-zone-3': 34.05,
                      'fedex-zone-4': 37.41,
                      'fedex-zone-5': 46.81,
                      'fedex-zone-6': 55.78,
                      'fedex-zone-7': 65.01,
                      'fedex-zone-8': 77.44,
                      'fedex-zone-9': 236.6,
                      'fedex-zone-14': 17.24,
                      'fedex-zone-17': 236.6,
                      'fedex-zone-22': 28.88,
                      'fedex-zone-23': 115.15,
                      'fedex-zone-25': 132.63,
                      'fedex-zone-51': 106.35,
                      'fedex-zone-54': 139.93,
                      'fedex-zone-92': 115.15,
                      'fedex-zone-96': 132.63,
                    },
                    '66': {
                      'fedex-zone-2': 26.86,
                      'fedex-zone-3': 34.06,
                      'fedex-zone-4': 37.42,
                      'fedex-zone-5': 46.82,
                      'fedex-zone-6': 55.81,
                      'fedex-zone-7': 65.21,
                      'fedex-zone-8': 77.77,
                      'fedex-zone-9': 240.26,
                      'fedex-zone-14': 17.58,
                      'fedex-zone-17': 240.26,
                      'fedex-zone-22': 29.23,
                      'fedex-zone-23': 115.97,
                      'fedex-zone-25': 133.72,
                      'fedex-zone-51': 106.37,
                      'fedex-zone-54': 139.94,
                      'fedex-zone-92': 115.97,
                      'fedex-zone-96': 133.72,
                    },
                    '67': {
                      'fedex-zone-2': 26.87,
                      'fedex-zone-3': 34.07,
                      'fedex-zone-4': 37.43,
                      'fedex-zone-5': 46.83,
                      'fedex-zone-6': 56.25,
                      'fedex-zone-7': 65.53,
                      'fedex-zone-8': 77.78,
                      'fedex-zone-9': 243.91,
                      'fedex-zone-14': 17.71,
                      'fedex-zone-17': 243.91,
                      'fedex-zone-22': 29.58,
                      'fedex-zone-23': 116.88,
                      'fedex-zone-25': 134.81,
                      'fedex-zone-51': 106.38,
                      'fedex-zone-54': 142.44,
                      'fedex-zone-92': 116.88,
                      'fedex-zone-96': 134.81,
                    },
                    '68': {
                      'fedex-zone-2': 27.18,
                      'fedex-zone-3': 35.02,
                      'fedex-zone-4': 39.69,
                      'fedex-zone-5': 47.89,
                      'fedex-zone-6': 56.55,
                      'fedex-zone-7': 65.91,
                      'fedex-zone-8': 77.79,
                      'fedex-zone-9': 247.42,
                      'fedex-zone-14': 18.09,
                      'fedex-zone-17': 247.42,
                      'fedex-zone-22': 29.96,
                      'fedex-zone-23': 117.67,
                      'fedex-zone-25': 135.94,
                      'fedex-zone-51': 106.39,
                      'fedex-zone-54': 142.45,
                      'fedex-zone-92': 117.67,
                      'fedex-zone-96': 135.94,
                    },
                    '69': {
                      'fedex-zone-2': 27.48,
                      'fedex-zone-3': 35.03,
                      'fedex-zone-4': 40.08,
                      'fedex-zone-5': 48.23,
                      'fedex-zone-6': 56.86,
                      'fedex-zone-7': 65.92,
                      'fedex-zone-8': 78.2,
                      'fedex-zone-9': 251.02,
                      'fedex-zone-14': 18.21,
                      'fedex-zone-17': 251.02,
                      'fedex-zone-22': 30.33,
                      'fedex-zone-23': 118.58,
                      'fedex-zone-25': 137.03,
                      'fedex-zone-51': 107.96,
                      'fedex-zone-54': 145.3,
                      'fedex-zone-92': 118.58,
                      'fedex-zone-96': 137.03,
                    },
                    '70': {
                      'fedex-zone-2': 27.61,
                      'fedex-zone-3': 35.51,
                      'fedex-zone-4': 40.95,
                      'fedex-zone-5': 50.55,
                      'fedex-zone-6': 57.99,
                      'fedex-zone-7': 65.93,
                      'fedex-zone-8': 78.87,
                      'fedex-zone-9': 256.3,
                      'fedex-zone-14': 18.45,
                      'fedex-zone-17': 256.3,
                      'fedex-zone-22': 30.68,
                      'fedex-zone-23': 119.49,
                      'fedex-zone-25': 138.11,
                      'fedex-zone-51': 107.97,
                      'fedex-zone-54': 145.31,
                      'fedex-zone-92': 119.49,
                      'fedex-zone-96': 138.11,
                    },
                    '71': {
                      'fedex-zone-2': 27.62,
                      'fedex-zone-3': 35.52,
                      'fedex-zone-4': 41.59,
                      'fedex-zone-5': 50.56,
                      'fedex-zone-6': 58.91,
                      'fedex-zone-7': 67.62,
                      'fedex-zone-8': 78.89,
                      'fedex-zone-9': 260.24,
                      'fedex-zone-14': 19.05,
                      'fedex-zone-17': 260.24,
                      'fedex-zone-22': 31.0,
                      'fedex-zone-23': 120.31,
                      'fedex-zone-25': 139.21,
                      'fedex-zone-51': 110.54,
                      'fedex-zone-54': 147.67,
                      'fedex-zone-92': 120.31,
                      'fedex-zone-96': 139.21,
                    },
                    '72': {
                      'fedex-zone-2': 28.41,
                      'fedex-zone-3': 35.53,
                      'fedex-zone-4': 42.46,
                      'fedex-zone-5': 50.57,
                      'fedex-zone-6': 59.34,
                      'fedex-zone-7': 69.85,
                      'fedex-zone-8': 79.44,
                      'fedex-zone-9': 264.11,
                      'fedex-zone-14': 19.93,
                      'fedex-zone-17': 264.11,
                      'fedex-zone-22': 32.39,
                      'fedex-zone-23': 121.23,
                      'fedex-zone-25': 140.31,
                      'fedex-zone-51': 110.55,
                      'fedex-zone-54': 147.69,
                      'fedex-zone-92': 121.23,
                      'fedex-zone-96': 140.31,
                    },
                    '73': {
                      'fedex-zone-2': 28.59,
                      'fedex-zone-3': 35.88,
                      'fedex-zone-4': 42.47,
                      'fedex-zone-5': 51.32,
                      'fedex-zone-6': 59.97,
                      'fedex-zone-7': 70.52,
                      'fedex-zone-8': 79.58,
                      'fedex-zone-9': 267.98,
                      'fedex-zone-14': 20.52,
                      'fedex-zone-17': 267.98,
                      'fedex-zone-22': 33.42,
                      'fedex-zone-23': 122.07,
                      'fedex-zone-25': 141.44,
                      'fedex-zone-51': 112.26,
                      'fedex-zone-54': 150.47,
                      'fedex-zone-92': 122.07,
                      'fedex-zone-96': 141.44,
                    },
                    '74': {
                      'fedex-zone-2': 29.63,
                      'fedex-zone-3': 35.89,
                      'fedex-zone-4': 42.48,
                      'fedex-zone-5': 51.33,
                      'fedex-zone-6': 60.9,
                      'fedex-zone-7': 70.63,
                      'fedex-zone-8': 79.75,
                      'fedex-zone-9': 270.56,
                      'fedex-zone-14': 21.78,
                      'fedex-zone-17': 270.56,
                      'fedex-zone-22': 34.48,
                      'fedex-zone-23': 123.07,
                      'fedex-zone-25': 142.52,
                      'fedex-zone-51': 112.27,
                      'fedex-zone-54': 150.48,
                      'fedex-zone-92': 123.07,
                      'fedex-zone-96': 142.52,
                    },
                    '75': {
                      'fedex-zone-2': 30.72,
                      'fedex-zone-3': 35.91,
                      'fedex-zone-4': 42.49,
                      'fedex-zone-5': 51.74,
                      'fedex-zone-6': 61.47,
                      'fedex-zone-7': 71.35,
                      'fedex-zone-8': 79.78,
                      'fedex-zone-9': 273.62,
                      'fedex-zone-14': 23.0,
                      'fedex-zone-17': 273.62,
                      'fedex-zone-22': 35.23,
                      'fedex-zone-23': 124.19,
                      'fedex-zone-25': 143.67,
                      'fedex-zone-51': 113.84,
                      'fedex-zone-54': 153.94,
                      'fedex-zone-92': 124.19,
                      'fedex-zone-96': 143.67,
                    },
                    '76': {
                      'fedex-zone-2': 32.78,
                      'fedex-zone-3': 37.91,
                      'fedex-zone-4': 42.76,
                      'fedex-zone-5': 52.53,
                      'fedex-zone-6': 62.25,
                      'fedex-zone-7': 72.51,
                      'fedex-zone-8': 79.79,
                      'fedex-zone-9': 277.0,
                      'fedex-zone-14': 23.83,
                      'fedex-zone-17': 277.0,
                      'fedex-zone-22': 36.27,
                      'fedex-zone-23': 125.32,
                      'fedex-zone-25': 144.75,
                      'fedex-zone-51': 113.85,
                      'fedex-zone-54': 153.96,
                      'fedex-zone-92': 125.32,
                      'fedex-zone-96': 144.75,
                    },
                    '77': {
                      'fedex-zone-2': 34.07,
                      'fedex-zone-3': 38.46,
                      'fedex-zone-4': 43.25,
                      'fedex-zone-5': 52.77,
                      'fedex-zone-6': 62.61,
                      'fedex-zone-7': 73.89,
                      'fedex-zone-8': 79.8,
                      'fedex-zone-9': 279.28,
                      'fedex-zone-14': 24.81,
                      'fedex-zone-17': 279.28,
                      'fedex-zone-22': 37.3,
                      'fedex-zone-23': 126.41,
                      'fedex-zone-25': 145.91,
                      'fedex-zone-51': 114.12,
                      'fedex-zone-54': 154.83,
                      'fedex-zone-92': 126.41,
                      'fedex-zone-96': 145.91,
                    },
                    '78': {
                      'fedex-zone-2': 34.1,
                      'fedex-zone-3': 39.91,
                      'fedex-zone-4': 44.53,
                      'fedex-zone-5': 53.33,
                      'fedex-zone-6': 63.0,
                      'fedex-zone-7': 75.13,
                      'fedex-zone-8': 79.81,
                      'fedex-zone-9': 280.78,
                      'fedex-zone-14': 25.83,
                      'fedex-zone-17': 280.78,
                      'fedex-zone-22': 38.72,
                      'fedex-zone-23': 127.68,
                      'fedex-zone-25': 146.96,
                      'fedex-zone-51': 114.13,
                      'fedex-zone-54': 154.84,
                      'fedex-zone-92': 127.68,
                      'fedex-zone-96': 146.96,
                    },
                    '79': {
                      'fedex-zone-2': 35.97,
                      'fedex-zone-3': 41.57,
                      'fedex-zone-4': 45.63,
                      'fedex-zone-5': 54.17,
                      'fedex-zone-6': 64.31,
                      'fedex-zone-7': 76.3,
                      'fedex-zone-8': 81.11,
                      'fedex-zone-9': 280.84,
                      'fedex-zone-14': 27.12,
                      'fedex-zone-17': 280.84,
                      'fedex-zone-22': 39.4,
                      'fedex-zone-23': 128.95,
                      'fedex-zone-25': 148.11,
                      'fedex-zone-51': 115.56,
                      'fedex-zone-54': 158.52,
                      'fedex-zone-92': 128.95,
                      'fedex-zone-96': 148.11,
                    },
                    '80': {
                      'fedex-zone-2': 36.61,
                      'fedex-zone-3': 42.36,
                      'fedex-zone-4': 45.84,
                      'fedex-zone-5': 55.46,
                      'fedex-zone-6': 65.39,
                      'fedex-zone-7': 76.63,
                      'fedex-zone-8': 81.73,
                      'fedex-zone-9': 283.76,
                      'fedex-zone-14': 28.14,
                      'fedex-zone-17': 283.76,
                      'fedex-zone-22': 40.47,
                      'fedex-zone-23': 130.17,
                      'fedex-zone-25': 149.16,
                      'fedex-zone-51': 115.57,
                      'fedex-zone-54': 158.54,
                      'fedex-zone-92': 130.17,
                      'fedex-zone-96': 149.16,
                    },
                    '81': {
                      'fedex-zone-2': 37.5,
                      'fedex-zone-3': 42.7,
                      'fedex-zone-4': 46.95,
                      'fedex-zone-5': 55.83,
                      'fedex-zone-6': 66.24,
                      'fedex-zone-7': 77.8,
                      'fedex-zone-8': 82.76,
                      'fedex-zone-9': 286.13,
                      'fedex-zone-14': 28.61,
                      'fedex-zone-17': 286.13,
                      'fedex-zone-22': 42.28,
                      'fedex-zone-23': 131.4,
                      'fedex-zone-25': 150.31,
                      'fedex-zone-51': 116.12,
                      'fedex-zone-54': 161.47,
                      'fedex-zone-92': 131.4,
                      'fedex-zone-96': 150.31,
                    },
                    '82': {
                      'fedex-zone-2': 39.08,
                      'fedex-zone-3': 44.15,
                      'fedex-zone-4': 49.07,
                      'fedex-zone-5': 57.26,
                      'fedex-zone-6': 66.41,
                      'fedex-zone-7': 79.81,
                      'fedex-zone-8': 82.78,
                      'fedex-zone-9': 287.56,
                      'fedex-zone-14': 30.79,
                      'fedex-zone-17': 287.56,
                      'fedex-zone-22': 42.94,
                      'fedex-zone-23': 132.53,
                      'fedex-zone-25': 151.39,
                      'fedex-zone-51': 116.13,
                      'fedex-zone-54': 161.48,
                      'fedex-zone-92': 132.53,
                      'fedex-zone-96': 151.39,
                    },
                    '83': {
                      'fedex-zone-2': 39.1,
                      'fedex-zone-3': 44.16,
                      'fedex-zone-4': 49.08,
                      'fedex-zone-5': 57.27,
                      'fedex-zone-6': 67.23,
                      'fedex-zone-7': 79.83,
                      'fedex-zone-8': 82.79,
                      'fedex-zone-9': 290.71,
                      'fedex-zone-14': 31.53,
                      'fedex-zone-17': 290.71,
                      'fedex-zone-22': 44.0,
                      'fedex-zone-23': 133.65,
                      'fedex-zone-25': 152.54,
                      'fedex-zone-51': 117.15,
                      'fedex-zone-54': 164.34,
                      'fedex-zone-92': 133.65,
                      'fedex-zone-96': 152.54,
                    },
                    '84': {
                      'fedex-zone-2': 40.65,
                      'fedex-zone-3': 45.61,
                      'fedex-zone-4': 50.51,
                      'fedex-zone-5': 57.82,
                      'fedex-zone-6': 68.24,
                      'fedex-zone-7': 80.78,
                      'fedex-zone-8': 83.42,
                      'fedex-zone-9': 294.06,
                      'fedex-zone-14': 31.95,
                      'fedex-zone-17': 294.06,
                      'fedex-zone-22': 45.1,
                      'fedex-zone-23': 134.79,
                      'fedex-zone-25': 153.63,
                      'fedex-zone-51': 117.18,
                      'fedex-zone-54': 164.35,
                      'fedex-zone-92': 134.79,
                      'fedex-zone-96': 153.63,
                    },
                    '85': {
                      'fedex-zone-2': 41.35,
                      'fedex-zone-3': 45.92,
                      'fedex-zone-4': 50.54,
                      'fedex-zone-5': 58.75,
                      'fedex-zone-6': 69.29,
                      'fedex-zone-7': 81.66,
                      'fedex-zone-8': 84.33,
                      'fedex-zone-9': 297.48,
                      'fedex-zone-14': 33.29,
                      'fedex-zone-17': 297.48,
                      'fedex-zone-22': 46.58,
                      'fedex-zone-23': 135.91,
                      'fedex-zone-25': 154.75,
                      'fedex-zone-51': 117.56,
                      'fedex-zone-54': 168.02,
                      'fedex-zone-92': 135.91,
                      'fedex-zone-96': 154.75,
                    },
                    '86': {
                      'fedex-zone-2': 43.27,
                      'fedex-zone-3': 48.02,
                      'fedex-zone-4': 52.52,
                      'fedex-zone-5': 59.86,
                      'fedex-zone-6': 70.13,
                      'fedex-zone-7': 83.18,
                      'fedex-zone-8': 86.1,
                      'fedex-zone-9': 300.61,
                      'fedex-zone-14': 34.29,
                      'fedex-zone-17': 300.61,
                      'fedex-zone-22': 46.73,
                      'fedex-zone-23': 137.14,
                      'fedex-zone-25': 155.79,
                      'fedex-zone-51': 117.57,
                      'fedex-zone-54': 168.03,
                      'fedex-zone-92': 137.14,
                      'fedex-zone-96': 155.79,
                    },
                    '87': {
                      'fedex-zone-2': 43.74,
                      'fedex-zone-3': 48.04,
                      'fedex-zone-4': 52.53,
                      'fedex-zone-5': 59.87,
                      'fedex-zone-6': 71.05,
                      'fedex-zone-7': 83.25,
                      'fedex-zone-8': 86.24,
                      'fedex-zone-9': 303.99,
                      'fedex-zone-14': 35.0,
                      'fedex-zone-17': 303.99,
                      'fedex-zone-22': 48.21,
                      'fedex-zone-23': 138.38,
                      'fedex-zone-25': 156.96,
                      'fedex-zone-51': 118.96,
                      'fedex-zone-54': 170.79,
                      'fedex-zone-92': 138.38,
                      'fedex-zone-96': 156.96,
                    },
                    '88': {
                      'fedex-zone-2': 45.99,
                      'fedex-zone-3': 49.58,
                      'fedex-zone-4': 54.69,
                      'fedex-zone-5': 61.8,
                      'fedex-zone-6': 71.97,
                      'fedex-zone-7': 84.11,
                      'fedex-zone-8': 88.01,
                      'fedex-zone-9': 307.35,
                      'fedex-zone-14': 36.34,
                      'fedex-zone-17': 307.35,
                      'fedex-zone-22': 48.85,
                      'fedex-zone-23': 139.62,
                      'fedex-zone-25': 157.98,
                      'fedex-zone-51': 118.97,
                      'fedex-zone-54': 170.81,
                      'fedex-zone-92': 139.62,
                      'fedex-zone-96': 157.98,
                    },
                    '89': {
                      'fedex-zone-2': 47.6,
                      'fedex-zone-3': 50.49,
                      'fedex-zone-4': 55.25,
                      'fedex-zone-5': 62.0,
                      'fedex-zone-6': 72.86,
                      'fedex-zone-7': 84.98,
                      'fedex-zone-8': 89.85,
                      'fedex-zone-9': 310.56,
                      'fedex-zone-14': 36.7,
                      'fedex-zone-17': 310.56,
                      'fedex-zone-22': 49.88,
                      'fedex-zone-23': 140.76,
                      'fedex-zone-25': 159.12,
                      'fedex-zone-51': 119.77,
                      'fedex-zone-54': 173.52,
                      'fedex-zone-92': 140.76,
                      'fedex-zone-96': 159.12,
                    },
                    '90': {
                      'fedex-zone-2': 50.51,
                      'fedex-zone-3': 52.68,
                      'fedex-zone-4': 57.63,
                      'fedex-zone-5': 63.82,
                      'fedex-zone-6': 73.9,
                      'fedex-zone-7': 86.15,
                      'fedex-zone-8': 90.77,
                      'fedex-zone-9': 313.7,
                      'fedex-zone-14': 38.77,
                      'fedex-zone-17': 313.7,
                      'fedex-zone-22': 50.97,
                      'fedex-zone-23': 141.9,
                      'fedex-zone-25': 160.23,
                      'fedex-zone-51': 119.78,
                      'fedex-zone-54': 173.53,
                      'fedex-zone-92': 141.9,
                      'fedex-zone-96': 160.23,
                    },
                    '91': {
                      'fedex-zone-2': 50.52,
                      'fedex-zone-3': 52.69,
                      'fedex-zone-4': 57.64,
                      'fedex-zone-5': 63.83,
                      'fedex-zone-6': 73.98,
                      'fedex-zone-7': 86.16,
                      'fedex-zone-8': 90.78,
                      'fedex-zone-9': 317.06,
                      'fedex-zone-14': 39.48,
                      'fedex-zone-17': 317.06,
                      'fedex-zone-22': 51.97,
                      'fedex-zone-23': 143.01,
                      'fedex-zone-25': 161.34,
                      'fedex-zone-51': 120.53,
                      'fedex-zone-54': 176.78,
                      'fedex-zone-92': 143.01,
                      'fedex-zone-96': 161.34,
                    },
                    '92': {
                      'fedex-zone-2': 52.13,
                      'fedex-zone-3': 53.68,
                      'fedex-zone-4': 57.94,
                      'fedex-zone-5': 64.44,
                      'fedex-zone-6': 75.5,
                      'fedex-zone-7': 86.17,
                      'fedex-zone-8': 91.84,
                      'fedex-zone-9': 320.08,
                      'fedex-zone-14': 40.86,
                      'fedex-zone-17': 320.08,
                      'fedex-zone-22': 53.04,
                      'fedex-zone-23': 144.11,
                      'fedex-zone-25': 162.45,
                      'fedex-zone-51': 120.56,
                      'fedex-zone-54': 176.79,
                      'fedex-zone-92': 144.11,
                      'fedex-zone-96': 162.45,
                    },
                    '93': {
                      'fedex-zone-2': 52.31,
                      'fedex-zone-3': 54.2,
                      'fedex-zone-4': 59.05,
                      'fedex-zone-5': 64.45,
                      'fedex-zone-6': 75.51,
                      'fedex-zone-7': 86.18,
                      'fedex-zone-8': 91.91,
                      'fedex-zone-9': 323.19,
                      'fedex-zone-14': 41.13,
                      'fedex-zone-17': 323.19,
                      'fedex-zone-22': 54.59,
                      'fedex-zone-23': 145.27,
                      'fedex-zone-25': 163.55,
                      'fedex-zone-51': 121.36,
                      'fedex-zone-54': 179.57,
                      'fedex-zone-92': 145.27,
                      'fedex-zone-96': 163.55,
                    },
                    '94': {
                      'fedex-zone-2': 52.57,
                      'fedex-zone-3': 55.1,
                      'fedex-zone-4': 59.33,
                      'fedex-zone-5': 65.29,
                      'fedex-zone-6': 76.4,
                      'fedex-zone-7': 86.19,
                      'fedex-zone-8': 92.87,
                      'fedex-zone-9': 326.25,
                      'fedex-zone-14': 42.53,
                      'fedex-zone-17': 326.25,
                      'fedex-zone-22': 56.2,
                      'fedex-zone-23': 146.38,
                      'fedex-zone-25': 164.67,
                      'fedex-zone-51': 121.37,
                      'fedex-zone-54': 179.59,
                      'fedex-zone-92': 146.38,
                      'fedex-zone-96': 164.67,
                    },
                    '95': {
                      'fedex-zone-2': 53.8,
                      'fedex-zone-3': 56.12,
                      'fedex-zone-4': 59.73,
                      'fedex-zone-5': 66.17,
                      'fedex-zone-6': 76.91,
                      'fedex-zone-7': 86.5,
                      'fedex-zone-8': 93.86,
                      'fedex-zone-9': 329.42,
                      'fedex-zone-14': 43.17,
                      'fedex-zone-17': 329.42,
                      'fedex-zone-22': 56.22,
                      'fedex-zone-23': 147.62,
                      'fedex-zone-25': 165.72,
                      'fedex-zone-51': 122.32,
                      'fedex-zone-54': 182.59,
                      'fedex-zone-92': 147.62,
                      'fedex-zone-96': 165.72,
                    },
                    '96': {
                      'fedex-zone-2': 55.52,
                      'fedex-zone-3': 56.49,
                      'fedex-zone-4': 61.92,
                      'fedex-zone-5': 67.54,
                      'fedex-zone-6': 77.35,
                      'fedex-zone-7': 87.09,
                      'fedex-zone-8': 95.67,
                      'fedex-zone-9': 332.43,
                      'fedex-zone-14': 44.15,
                      'fedex-zone-17': 332.43,
                      'fedex-zone-22': 57.79,
                      'fedex-zone-23': 148.84,
                      'fedex-zone-25': 166.83,
                      'fedex-zone-51': 122.33,
                      'fedex-zone-54': 182.6,
                      'fedex-zone-92': 148.84,
                      'fedex-zone-96': 166.83,
                    },
                    '97': {
                      'fedex-zone-2': 56.81,
                      'fedex-zone-3': 58.15,
                      'fedex-zone-4': 62.82,
                      'fedex-zone-5': 67.97,
                      'fedex-zone-6': 78.28,
                      'fedex-zone-7': 87.74,
                      'fedex-zone-8': 96.66,
                      'fedex-zone-9': 335.6,
                      'fedex-zone-14': 46.05,
                      'fedex-zone-17': 335.6,
                      'fedex-zone-22': 58.92,
                      'fedex-zone-23': 150.12,
                      'fedex-zone-25': 167.96,
                      'fedex-zone-51': 123.09,
                      'fedex-zone-54': 185.78,
                      'fedex-zone-92': 150.12,
                      'fedex-zone-96': 167.96,
                    },
                    '98': {
                      'fedex-zone-2': 57.56,
                      'fedex-zone-3': 58.53,
                      'fedex-zone-4': 62.83,
                      'fedex-zone-5': 68.77,
                      'fedex-zone-6': 79.16,
                      'fedex-zone-7': 87.75,
                      'fedex-zone-8': 96.7,
                      'fedex-zone-9': 338.58,
                      'fedex-zone-14': 46.64,
                      'fedex-zone-17': 338.58,
                      'fedex-zone-22': 60.38,
                      'fedex-zone-23': 151.36,
                      'fedex-zone-25': 169.1,
                      'fedex-zone-51': 123.1,
                      'fedex-zone-54': 185.79,
                      'fedex-zone-92': 151.36,
                      'fedex-zone-96': 169.1,
                    },
                    '99': {
                      'fedex-zone-2': 58.82,
                      'fedex-zone-3': 59.45,
                      'fedex-zone-4': 65.19,
                      'fedex-zone-5': 69.63,
                      'fedex-zone-6': 80.08,
                      'fedex-zone-7': 88.63,
                      'fedex-zone-8': 97.65,
                      'fedex-zone-9': 341.75,
                      'fedex-zone-14': 47.67,
                      'fedex-zone-17': 341.75,
                      'fedex-zone-22': 60.96,
                      'fedex-zone-23': 152.45,
                      'fedex-zone-25': 170.19,
                      'fedex-zone-51': 123.7,
                      'fedex-zone-54': 188.44,
                      'fedex-zone-92': 152.45,
                      'fedex-zone-96': 170.19,
                    },
                    '100': {
                      'fedex-zone-2': 59.9,
                      'fedex-zone-3': 60.44,
                      'fedex-zone-4': 65.21,
                      'fedex-zone-5': 70.67,
                      'fedex-zone-6': 80.96,
                      'fedex-zone-7': 89.52,
                      'fedex-zone-8': 98.61,
                      'fedex-zone-9': 344.92,
                      'fedex-zone-14': 48.26,
                      'fedex-zone-17': 344.92,
                      'fedex-zone-22': 62.0,
                      'fedex-zone-23': 153.6,
                      'fedex-zone-25': 171.28,
                      'fedex-zone-51': 123.72,
                      'fedex-zone-54': 188.45,
                      'fedex-zone-92': 153.6,
                      'fedex-zone-96': 171.28,
                    },
                    '101': {
                      'fedex-zone-2': 60.31,
                      'fedex-zone-3': 60.45,
                      'fedex-zone-4': 65.22,
                      'fedex-zone-5': 70.68,
                      'fedex-zone-6': 80.97,
                      'fedex-zone-7': 89.53,
                      'fedex-zone-8': 98.62,
                      'fedex-zone-9': 344.93,
                      'fedex-zone-14': 49.26,
                      'fedex-zone-17': 344.93,
                      'fedex-zone-22': 63.65,
                      'fedex-zone-23': 154.75,
                      'fedex-zone-25': 172.42,
                      'fedex-zone-51': 123.73,
                      'fedex-zone-54': 188.46,
                      'fedex-zone-92': 154.75,
                      'fedex-zone-96': 172.42,
                    },
                    '102': {
                      'fedex-zone-2': 60.32,
                      'fedex-zone-3': 60.46,
                      'fedex-zone-4': 65.23,
                      'fedex-zone-5': 70.69,
                      'fedex-zone-6': 80.98,
                      'fedex-zone-7': 89.54,
                      'fedex-zone-8': 98.63,
                      'fedex-zone-9': 344.94,
                      'fedex-zone-14': 50.75,
                      'fedex-zone-17': 344.94,
                      'fedex-zone-22': 63.66,
                      'fedex-zone-23': 155.84,
                      'fedex-zone-25': 173.48,
                      'fedex-zone-51': 123.74,
                      'fedex-zone-54': 188.47,
                      'fedex-zone-92': 155.84,
                      'fedex-zone-96': 173.48,
                    },
                    '103': {
                      'fedex-zone-2': 61.69,
                      'fedex-zone-3': 61.95,
                      'fedex-zone-4': 66.57,
                      'fedex-zone-5': 71.1,
                      'fedex-zone-6': 81.69,
                      'fedex-zone-7': 89.98,
                      'fedex-zone-8': 98.64,
                      'fedex-zone-9': 344.95,
                      'fedex-zone-14': 51.79,
                      'fedex-zone-17': 344.95,
                      'fedex-zone-22': 65.61,
                      'fedex-zone-23': 157.08,
                      'fedex-zone-25': 174.64,
                      'fedex-zone-51': 123.76,
                      'fedex-zone-54': 188.48,
                      'fedex-zone-92': 157.08,
                      'fedex-zone-96': 174.64,
                    },
                    '104': {
                      'fedex-zone-2': 61.7,
                      'fedex-zone-3': 62.25,
                      'fedex-zone-4': 66.74,
                      'fedex-zone-5': 71.86,
                      'fedex-zone-6': 81.95,
                      'fedex-zone-7': 90.25,
                      'fedex-zone-8': 99.24,
                      'fedex-zone-9': 345.3,
                      'fedex-zone-14': 53.32,
                      'fedex-zone-17': 345.3,
                      'fedex-zone-22': 65.62,
                      'fedex-zone-23': 158.34,
                      'fedex-zone-25': 175.72,
                      'fedex-zone-51': 123.77,
                      'fedex-zone-54': 188.5,
                      'fedex-zone-92': 158.34,
                      'fedex-zone-96': 175.72,
                    },
                    '105': {
                      'fedex-zone-2': 63.3,
                      'fedex-zone-3': 63.79,
                      'fedex-zone-4': 68.15,
                      'fedex-zone-5': 73.34,
                      'fedex-zone-6': 83.2,
                      'fedex-zone-7': 91.64,
                      'fedex-zone-8': 101.06,
                      'fedex-zone-9': 348.38,
                      'fedex-zone-14': 53.84,
                      'fedex-zone-17': 348.38,
                      'fedex-zone-22': 67.29,
                      'fedex-zone-23': 159.56,
                      'fedex-zone-25': 176.84,
                      'fedex-zone-51': 123.78,
                      'fedex-zone-54': 188.51,
                      'fedex-zone-92': 159.56,
                      'fedex-zone-96': 176.84,
                    },
                    '106': {
                      'fedex-zone-2': 63.74,
                      'fedex-zone-3': 64.13,
                      'fedex-zone-4': 68.26,
                      'fedex-zone-5': 73.35,
                      'fedex-zone-6': 83.22,
                      'fedex-zone-7': 91.65,
                      'fedex-zone-8': 101.07,
                      'fedex-zone-9': 351.61,
                      'fedex-zone-14': 53.85,
                      'fedex-zone-17': 351.61,
                      'fedex-zone-22': 68.37,
                      'fedex-zone-23': 160.71,
                      'fedex-zone-25': 177.93,
                      'fedex-zone-51': 126.02,
                      'fedex-zone-54': 192.95,
                      'fedex-zone-92': 160.71,
                      'fedex-zone-96': 177.93,
                    },
                    '107': {
                      'fedex-zone-2': 64.68,
                      'fedex-zone-3': 65.09,
                      'fedex-zone-4': 69.73,
                      'fedex-zone-5': 74.8,
                      'fedex-zone-6': 83.96,
                      'fedex-zone-7': 92.38,
                      'fedex-zone-8': 102.82,
                      'fedex-zone-9': 354.86,
                      'fedex-zone-14': 55.34,
                      'fedex-zone-17': 354.86,
                      'fedex-zone-22': 69.79,
                      'fedex-zone-23': 161.82,
                      'fedex-zone-25': 178.99,
                      'fedex-zone-51': 126.03,
                      'fedex-zone-54': 192.96,
                      'fedex-zone-92': 161.82,
                      'fedex-zone-96': 178.99,
                    },
                    '108': {
                      'fedex-zone-2': 65.6,
                      'fedex-zone-3': 66.02,
                      'fedex-zone-4': 69.84,
                      'fedex-zone-5': 74.85,
                      'fedex-zone-6': 84.74,
                      'fedex-zone-7': 93.2,
                      'fedex-zone-8': 102.83,
                      'fedex-zone-9': 358.09,
                      'fedex-zone-14': 56.39,
                      'fedex-zone-17': 358.09,
                      'fedex-zone-22': 71.15,
                      'fedex-zone-23': 162.95,
                      'fedex-zone-25': 180.1,
                      'fedex-zone-51': 126.05,
                      'fedex-zone-54': 192.97,
                      'fedex-zone-92': 162.95,
                      'fedex-zone-96': 180.1,
                    },
                    '109': {
                      'fedex-zone-2': 66.95,
                      'fedex-zone-3': 66.97,
                      'fedex-zone-4': 70.6,
                      'fedex-zone-5': 75.58,
                      'fedex-zone-6': 85.48,
                      'fedex-zone-7': 93.99,
                      'fedex-zone-8': 103.73,
                      'fedex-zone-9': 361.16,
                      'fedex-zone-14': 57.42,
                      'fedex-zone-17': 361.16,
                      'fedex-zone-22': 72.26,
                      'fedex-zone-23': 164.01,
                      'fedex-zone-25': 181.21,
                      'fedex-zone-51': 126.06,
                      'fedex-zone-54': 192.98,
                      'fedex-zone-92': 164.01,
                      'fedex-zone-96': 181.21,
                    },
                    '110': {
                      'fedex-zone-2': 68.1,
                      'fedex-zone-3': 68.57,
                      'fedex-zone-4': 72.09,
                      'fedex-zone-5': 77.03,
                      'fedex-zone-6': 87.04,
                      'fedex-zone-7': 95.75,
                      'fedex-zone-8': 105.65,
                      'fedex-zone-9': 364.2,
                      'fedex-zone-14': 58.44,
                      'fedex-zone-17': 364.2,
                      'fedex-zone-22': 72.61,
                      'fedex-zone-23': 165.33,
                      'fedex-zone-25': 182.34,
                      'fedex-zone-51': 126.07,
                      'fedex-zone-54': 192.99,
                      'fedex-zone-92': 165.33,
                      'fedex-zone-96': 182.34,
                    },
                    '111': {
                      'fedex-zone-2': 68.11,
                      'fedex-zone-3': 68.68,
                      'fedex-zone-4': 73.68,
                      'fedex-zone-5': 77.78,
                      'fedex-zone-6': 87.05,
                      'fedex-zone-7': 96.43,
                      'fedex-zone-8': 106.9,
                      'fedex-zone-9': 368.35,
                      'fedex-zone-14': 59.42,
                      'fedex-zone-17': 368.35,
                      'fedex-zone-22': 74.34,
                      'fedex-zone-23': 166.56,
                      'fedex-zone-25': 183.41,
                      'fedex-zone-51': 129.83,
                      'fedex-zone-54': 200.55,
                      'fedex-zone-92': 166.56,
                      'fedex-zone-96': 183.41,
                    },
                    '112': {
                      'fedex-zone-2': 69.51,
                      'fedex-zone-3': 70.09,
                      'fedex-zone-4': 73.69,
                      'fedex-zone-5': 77.79,
                      'fedex-zone-6': 87.79,
                      'fedex-zone-7': 96.44,
                      'fedex-zone-8': 106.91,
                      'fedex-zone-9': 372.51,
                      'fedex-zone-14': 61.04,
                      'fedex-zone-17': 372.51,
                      'fedex-zone-22': 75.45,
                      'fedex-zone-23': 167.79,
                      'fedex-zone-25': 184.6,
                      'fedex-zone-51': 129.84,
                      'fedex-zone-54': 200.56,
                      'fedex-zone-92': 167.79,
                      'fedex-zone-96': 184.6,
                    },
                    '113': {
                      'fedex-zone-2': 69.57,
                      'fedex-zone-3': 70.15,
                      'fedex-zone-4': 74.51,
                      'fedex-zone-5': 78.51,
                      'fedex-zone-6': 88.57,
                      'fedex-zone-7': 97.23,
                      'fedex-zone-8': 108.85,
                      'fedex-zone-9': 375.73,
                      'fedex-zone-14': 61.46,
                      'fedex-zone-17': 375.73,
                      'fedex-zone-22': 75.46,
                      'fedex-zone-23': 168.89,
                      'fedex-zone-25': 185.91,
                      'fedex-zone-51': 129.85,
                      'fedex-zone-54': 200.58,
                      'fedex-zone-92': 168.89,
                      'fedex-zone-96': 185.91,
                    },
                    '114': {
                      'fedex-zone-2': 70.31,
                      'fedex-zone-3': 71.61,
                      'fedex-zone-4': 76.06,
                      'fedex-zone-5': 80.04,
                      'fedex-zone-6': 90.07,
                      'fedex-zone-7': 98.87,
                      'fedex-zone-8': 109.56,
                      'fedex-zone-9': 379.0,
                      'fedex-zone-14': 61.86,
                      'fedex-zone-17': 379.0,
                      'fedex-zone-22': 77.89,
                      'fedex-zone-23': 170.06,
                      'fedex-zone-25': 187.11,
                      'fedex-zone-51': 129.86,
                      'fedex-zone-54': 200.59,
                      'fedex-zone-92': 170.06,
                      'fedex-zone-96': 187.11,
                    },
                    '115': {
                      'fedex-zone-2': 71.76,
                      'fedex-zone-3': 73.11,
                      'fedex-zone-4': 76.8,
                      'fedex-zone-5': 81.01,
                      'fedex-zone-6': 90.93,
                      'fedex-zone-7': 99.81,
                      'fedex-zone-8': 110.61,
                      'fedex-zone-9': 382.23,
                      'fedex-zone-14': 63.46,
                      'fedex-zone-17': 382.23,
                      'fedex-zone-22': 77.9,
                      'fedex-zone-23': 171.17,
                      'fedex-zone-25': 188.31,
                      'fedex-zone-51': 129.88,
                      'fedex-zone-54': 200.61,
                      'fedex-zone-92': 171.17,
                      'fedex-zone-96': 188.31,
                    },
                    '116': {
                      'fedex-zone-2': 72.5,
                      'fedex-zone-3': 73.38,
                      'fedex-zone-4': 77.74,
                      'fedex-zone-5': 81.38,
                      'fedex-zone-6': 91.4,
                      'fedex-zone-7': 101.05,
                      'fedex-zone-8': 111.3,
                      'fedex-zone-9': 384.62,
                      'fedex-zone-14': 64.53,
                      'fedex-zone-17': 384.62,
                      'fedex-zone-22': 79.75,
                      'fedex-zone-23': 173.49,
                      'fedex-zone-25': 189.61,
                      'fedex-zone-51': 133.28,
                      'fedex-zone-54': 208.15,
                      'fedex-zone-92': 173.49,
                      'fedex-zone-96': 189.61,
                    },
                    '117': {
                      'fedex-zone-2': 72.53,
                      'fedex-zone-3': 73.46,
                      'fedex-zone-4': 77.75,
                      'fedex-zone-5': 82.11,
                      'fedex-zone-6': 91.41,
                      'fedex-zone-7': 101.06,
                      'fedex-zone-8': 112.03,
                      'fedex-zone-9': 387.68,
                      'fedex-zone-14': 64.94,
                      'fedex-zone-17': 387.68,
                      'fedex-zone-22': 80.0,
                      'fedex-zone-23': 173.5,
                      'fedex-zone-25': 190.83,
                      'fedex-zone-51': 133.29,
                      'fedex-zone-54': 208.16,
                      'fedex-zone-92': 173.5,
                      'fedex-zone-96': 190.83,
                    },
                    '118': {
                      'fedex-zone-2': 73.3,
                      'fedex-zone-3': 74.96,
                      'fedex-zone-4': 77.83,
                      'fedex-zone-5': 82.35,
                      'fedex-zone-6': 92.16,
                      'fedex-zone-7': 101.07,
                      'fedex-zone-8': 114.09,
                      'fedex-zone-9': 390.74,
                      'fedex-zone-14': 66.58,
                      'fedex-zone-17': 390.74,
                      'fedex-zone-22': 82.66,
                      'fedex-zone-23': 174.77,
                      'fedex-zone-25': 192.0,
                      'fedex-zone-51': 133.3,
                      'fedex-zone-54': 208.17,
                      'fedex-zone-92': 174.77,
                      'fedex-zone-96': 192.0,
                    },
                    '119': {
                      'fedex-zone-2': 75.48,
                      'fedex-zone-3': 75.77,
                      'fedex-zone-4': 80.14,
                      'fedex-zone-5': 83.6,
                      'fedex-zone-6': 92.95,
                      'fedex-zone-7': 101.87,
                      'fedex-zone-8': 115.01,
                      'fedex-zone-9': 396.39,
                      'fedex-zone-14': 66.93,
                      'fedex-zone-17': 396.39,
                      'fedex-zone-22': 82.67,
                      'fedex-zone-23': 176.03,
                      'fedex-zone-25': 193.16,
                      'fedex-zone-51': 133.31,
                      'fedex-zone-54': 208.18,
                      'fedex-zone-92': 176.03,
                      'fedex-zone-96': 193.16,
                    },
                    '120': {
                      'fedex-zone-2': 76.8,
                      'fedex-zone-3': 76.86,
                      'fedex-zone-4': 80.25,
                      'fedex-zone-5': 84.17,
                      'fedex-zone-6': 93.7,
                      'fedex-zone-7': 103.21,
                      'fedex-zone-8': 115.02,
                      'fedex-zone-9': 399.65,
                      'fedex-zone-14': 69.29,
                      'fedex-zone-17': 399.65,
                      'fedex-zone-22': 85.34,
                      'fedex-zone-23': 177.22,
                      'fedex-zone-25': 194.27,
                      'fedex-zone-51': 133.32,
                      'fedex-zone-54': 208.19,
                      'fedex-zone-92': 177.22,
                      'fedex-zone-96': 194.27,
                    },
                    '121': {
                      'fedex-zone-2': 76.81,
                      'fedex-zone-3': 76.87,
                      'fedex-zone-4': 80.26,
                      'fedex-zone-5': 84.19,
                      'fedex-zone-6': 94.3,
                      'fedex-zone-7': 103.22,
                      'fedex-zone-8': 115.03,
                      'fedex-zone-9': 402.32,
                      'fedex-zone-14': 69.3,
                      'fedex-zone-17': 402.32,
                      'fedex-zone-22': 85.36,
                      'fedex-zone-23': 178.52,
                      'fedex-zone-25': 195.36,
                      'fedex-zone-51': 136.39,
                      'fedex-zone-54': 215.72,
                      'fedex-zone-92': 178.52,
                      'fedex-zone-96': 195.36,
                    },
                    '122': {
                      'fedex-zone-2': 76.82,
                      'fedex-zone-3': 78.35,
                      'fedex-zone-4': 81.04,
                      'fedex-zone-5': 84.94,
                      'fedex-zone-6': 95.03,
                      'fedex-zone-7': 104.84,
                      'fedex-zone-8': 115.97,
                      'fedex-zone-9': 405.73,
                      'fedex-zone-14': 71.35,
                      'fedex-zone-17': 405.73,
                      'fedex-zone-22': 86.18,
                      'fedex-zone-23': 179.76,
                      'fedex-zone-25': 196.43,
                      'fedex-zone-51': 136.4,
                      'fedex-zone-54': 215.73,
                      'fedex-zone-92': 179.76,
                      'fedex-zone-96': 196.43,
                    },
                    '123': {
                      'fedex-zone-2': 78.95,
                      'fedex-zone-3': 79.17,
                      'fedex-zone-4': 84.26,
                      'fedex-zone-5': 87.25,
                      'fedex-zone-6': 95.78,
                      'fedex-zone-7': 107.12,
                      'fedex-zone-8': 118.64,
                      'fedex-zone-9': 409.18,
                      'fedex-zone-14': 71.36,
                      'fedex-zone-17': 409.18,
                      'fedex-zone-22': 87.03,
                      'fedex-zone-23': 180.97,
                      'fedex-zone-25': 197.57,
                      'fedex-zone-51': 136.41,
                      'fedex-zone-54': 215.74,
                      'fedex-zone-92': 180.97,
                      'fedex-zone-96': 197.57,
                    },
                    '124': {
                      'fedex-zone-2': 78.96,
                      'fedex-zone-3': 79.2,
                      'fedex-zone-4': 84.35,
                      'fedex-zone-5': 87.26,
                      'fedex-zone-6': 97.3,
                      'fedex-zone-7': 107.13,
                      'fedex-zone-8': 118.65,
                      'fedex-zone-9': 412.59,
                      'fedex-zone-14': 71.96,
                      'fedex-zone-17': 412.59,
                      'fedex-zone-22': 89.13,
                      'fedex-zone-23': 182.21,
                      'fedex-zone-25': 198.65,
                      'fedex-zone-51': 136.42,
                      'fedex-zone-54': 215.78,
                      'fedex-zone-92': 182.21,
                      'fedex-zone-96': 198.65,
                    },
                    '125': {
                      'fedex-zone-2': 79.0,
                      'fedex-zone-3': 79.21,
                      'fedex-zone-4': 84.36,
                      'fedex-zone-5': 87.27,
                      'fedex-zone-6': 97.31,
                      'fedex-zone-7': 107.14,
                      'fedex-zone-8': 118.66,
                      'fedex-zone-9': 416.04,
                      'fedex-zone-14': 73.02,
                      'fedex-zone-17': 416.04,
                      'fedex-zone-22': 89.14,
                      'fedex-zone-23': 183.45,
                      'fedex-zone-25': 199.79,
                      'fedex-zone-51': 136.43,
                      'fedex-zone-54': 215.79,
                      'fedex-zone-92': 183.45,
                      'fedex-zone-96': 199.79,
                    },
                    '126': {
                      'fedex-zone-2': 80.59,
                      'fedex-zone-3': 80.75,
                      'fedex-zone-4': 86.03,
                      'fedex-zone-5': 87.77,
                      'fedex-zone-6': 97.89,
                      'fedex-zone-7': 107.79,
                      'fedex-zone-8': 122.84,
                      'fedex-zone-9': 418.62,
                      'fedex-zone-14': 74.02,
                      'fedex-zone-17': 418.62,
                      'fedex-zone-22': 90.41,
                      'fedex-zone-23': 184.78,
                      'fedex-zone-25': 200.84,
                      'fedex-zone-51': 139.18,
                      'fedex-zone-54': 223.4,
                      'fedex-zone-92': 184.78,
                      'fedex-zone-96': 200.84,
                    },
                    '127': {
                      'fedex-zone-2': 80.6,
                      'fedex-zone-3': 81.37,
                      'fedex-zone-4': 86.87,
                      'fedex-zone-5': 89.27,
                      'fedex-zone-6': 99.55,
                      'fedex-zone-7': 108.82,
                      'fedex-zone-8': 122.85,
                      'fedex-zone-9': 422.02,
                      'fedex-zone-14': 75.71,
                      'fedex-zone-17': 422.02,
                      'fedex-zone-22': 91.47,
                      'fedex-zone-23': 185.97,
                      'fedex-zone-25': 201.99,
                      'fedex-zone-51': 139.19,
                      'fedex-zone-54': 223.44,
                      'fedex-zone-92': 185.97,
                      'fedex-zone-96': 201.99,
                    },
                    '128': {
                      'fedex-zone-2': 81.34,
                      'fedex-zone-3': 81.38,
                      'fedex-zone-4': 86.89,
                      'fedex-zone-5': 89.28,
                      'fedex-zone-6': 100.13,
                      'fedex-zone-7': 109.74,
                      'fedex-zone-8': 123.52,
                      'fedex-zone-9': 425.45,
                      'fedex-zone-14': 77.49,
                      'fedex-zone-17': 425.45,
                      'fedex-zone-22': 92.35,
                      'fedex-zone-23': 187.24,
                      'fedex-zone-25': 203.22,
                      'fedex-zone-51': 139.21,
                      'fedex-zone-54': 223.45,
                      'fedex-zone-92': 187.24,
                      'fedex-zone-96': 203.22,
                    },
                    '129': {
                      'fedex-zone-2': 82.89,
                      'fedex-zone-3': 83.2,
                      'fedex-zone-4': 87.73,
                      'fedex-zone-5': 90.74,
                      'fedex-zone-6': 100.14,
                      'fedex-zone-7': 109.75,
                      'fedex-zone-8': 124.7,
                      'fedex-zone-9': 428.89,
                      'fedex-zone-14': 77.5,
                      'fedex-zone-17': 428.89,
                      'fedex-zone-22': 92.7,
                      'fedex-zone-23': 188.48,
                      'fedex-zone-25': 204.4,
                      'fedex-zone-51': 139.22,
                      'fedex-zone-54': 223.46,
                      'fedex-zone-92': 188.48,
                      'fedex-zone-96': 204.4,
                    },
                    '130': {
                      'fedex-zone-2': 83.21,
                      'fedex-zone-3': 83.23,
                      'fedex-zone-4': 88.53,
                      'fedex-zone-5': 90.75,
                      'fedex-zone-6': 100.86,
                      'fedex-zone-7': 111.18,
                      'fedex-zone-8': 126.39,
                      'fedex-zone-9': 440.64,
                      'fedex-zone-14': 80.29,
                      'fedex-zone-17': 440.64,
                      'fedex-zone-22': 94.72,
                      'fedex-zone-23': 189.7,
                      'fedex-zone-25': 205.62,
                      'fedex-zone-51': 139.24,
                      'fedex-zone-54': 223.47,
                      'fedex-zone-92': 189.7,
                      'fedex-zone-96': 205.62,
                    },
                    '131': {
                      'fedex-zone-2': 83.67,
                      'fedex-zone-3': 83.74,
                      'fedex-zone-4': 89.64,
                      'fedex-zone-5': 91.36,
                      'fedex-zone-6': 101.4,
                      'fedex-zone-7': 112.23,
                      'fedex-zone-8': 127.6,
                      'fedex-zone-9': 440.65,
                      'fedex-zone-14': 80.53,
                      'fedex-zone-17': 440.65,
                      'fedex-zone-22': 94.84,
                      'fedex-zone-23': 190.95,
                      'fedex-zone-25': 208.12,
                      'fedex-zone-51': 142.21,
                      'fedex-zone-54': 229.5,
                      'fedex-zone-92': 190.95,
                      'fedex-zone-96': 208.12,
                    },
                    '132': {
                      'fedex-zone-2': 84.49,
                      'fedex-zone-3': 85.37,
                      'fedex-zone-4': 90.22,
                      'fedex-zone-5': 92.1,
                      'fedex-zone-6': 102.16,
                      'fedex-zone-7': 112.24,
                      'fedex-zone-8': 127.61,
                      'fedex-zone-9': 444.6,
                      'fedex-zone-14': 81.32,
                      'fedex-zone-17': 444.6,
                      'fedex-zone-22': 95.01,
                      'fedex-zone-23': 192.22,
                      'fedex-zone-25': 208.13,
                      'fedex-zone-51': 142.22,
                      'fedex-zone-54': 229.52,
                      'fedex-zone-92': 192.22,
                      'fedex-zone-96': 208.13,
                    },
                    '133': {
                      'fedex-zone-2': 85.27,
                      'fedex-zone-3': 85.5,
                      'fedex-zone-4': 90.23,
                      'fedex-zone-5': 92.85,
                      'fedex-zone-6': 102.88,
                      'fedex-zone-7': 112.25,
                      'fedex-zone-8': 127.62,
                      'fedex-zone-9': 447.27,
                      'fedex-zone-14': 81.33,
                      'fedex-zone-17': 447.27,
                      'fedex-zone-22': 97.89,
                      'fedex-zone-23': 193.43,
                      'fedex-zone-25': 209.34,
                      'fedex-zone-51': 142.23,
                      'fedex-zone-54': 229.53,
                      'fedex-zone-92': 193.43,
                      'fedex-zone-96': 209.34,
                    },
                    '134': {
                      'fedex-zone-2': 86.86,
                      'fedex-zone-3': 86.97,
                      'fedex-zone-4': 92.01,
                      'fedex-zone-5': 94.52,
                      'fedex-zone-6': 104.65,
                      'fedex-zone-7': 114.09,
                      'fedex-zone-8': 128.18,
                      'fedex-zone-9': 447.29,
                      'fedex-zone-14': 82.09,
                      'fedex-zone-17': 447.29,
                      'fedex-zone-22': 97.9,
                      'fedex-zone-23': 194.69,
                      'fedex-zone-25': 210.58,
                      'fedex-zone-51': 142.24,
                      'fedex-zone-54': 229.54,
                      'fedex-zone-92': 194.69,
                      'fedex-zone-96': 210.58,
                    },
                    '135': {
                      'fedex-zone-2': 87.53,
                      'fedex-zone-3': 87.85,
                      'fedex-zone-4': 92.81,
                      'fedex-zone-5': 95.3,
                      'fedex-zone-6': 105.34,
                      'fedex-zone-7': 114.69,
                      'fedex-zone-8': 128.8,
                      'fedex-zone-9': 450.68,
                      'fedex-zone-14': 83.09,
                      'fedex-zone-17': 450.68,
                      'fedex-zone-22': 99.07,
                      'fedex-zone-23': 195.95,
                      'fedex-zone-25': 211.69,
                      'fedex-zone-51': 142.25,
                      'fedex-zone-54': 229.55,
                      'fedex-zone-92': 195.95,
                      'fedex-zone-96': 211.69,
                    },
                    '136': {
                      'fedex-zone-2': 87.54,
                      'fedex-zone-3': 88.9,
                      'fedex-zone-4': 94.31,
                      'fedex-zone-5': 96.12,
                      'fedex-zone-6': 105.95,
                      'fedex-zone-7': 115.4,
                      'fedex-zone-8': 129.68,
                      'fedex-zone-9': 454.11,
                      'fedex-zone-14': 84.09,
                      'fedex-zone-17': 454.11,
                      'fedex-zone-22': 100.0,
                      'fedex-zone-23': 197.23,
                      'fedex-zone-25': 212.81,
                      'fedex-zone-51': 145.14,
                      'fedex-zone-54': 236.88,
                      'fedex-zone-92': 197.23,
                      'fedex-zone-96': 212.81,
                    },
                    '137': {
                      'fedex-zone-2': 88.18,
                      'fedex-zone-3': 88.91,
                      'fedex-zone-4': 95.91,
                      'fedex-zone-5': 96.83,
                      'fedex-zone-6': 105.96,
                      'fedex-zone-7': 115.41,
                      'fedex-zone-8': 129.69,
                      'fedex-zone-9': 461.94,
                      'fedex-zone-14': 85.1,
                      'fedex-zone-17': 461.94,
                      'fedex-zone-22': 100.26,
                      'fedex-zone-23': 199.68,
                      'fedex-zone-25': 213.91,
                      'fedex-zone-51': 145.15,
                      'fedex-zone-54': 236.89,
                      'fedex-zone-92': 199.68,
                      'fedex-zone-96': 213.91,
                    },
                    '138': {
                      'fedex-zone-2': 88.98,
                      'fedex-zone-3': 90.31,
                      'fedex-zone-4': 96.38,
                      'fedex-zone-5': 97.62,
                      'fedex-zone-6': 107.83,
                      'fedex-zone-7': 117.47,
                      'fedex-zone-8': 132.03,
                      'fedex-zone-9': 464.4,
                      'fedex-zone-14': 86.11,
                      'fedex-zone-17': 464.4,
                      'fedex-zone-22': 101.3,
                      'fedex-zone-23': 199.69,
                      'fedex-zone-25': 214.98,
                      'fedex-zone-51': 145.17,
                      'fedex-zone-54': 236.9,
                      'fedex-zone-92': 199.69,
                      'fedex-zone-96': 214.98,
                    },
                    '139': {
                      'fedex-zone-2': 90.64,
                      'fedex-zone-3': 91.22,
                      'fedex-zone-4': 96.39,
                      'fedex-zone-5': 97.64,
                      'fedex-zone-6': 108.15,
                      'fedex-zone-7': 118.55,
                      'fedex-zone-8': 133.29,
                      'fedex-zone-9': 464.41,
                      'fedex-zone-14': 87.11,
                      'fedex-zone-17': 464.41,
                      'fedex-zone-22': 103.31,
                      'fedex-zone-23': 200.93,
                      'fedex-zone-25': 216.05,
                      'fedex-zone-51': 145.18,
                      'fedex-zone-54': 236.91,
                      'fedex-zone-92': 200.93,
                      'fedex-zone-96': 216.05,
                    },
                    '140': {
                      'fedex-zone-2': 91.38,
                      'fedex-zone-3': 92.08,
                      'fedex-zone-4': 97.34,
                      'fedex-zone-5': 99.17,
                      'fedex-zone-6': 109.3,
                      'fedex-zone-7': 118.56,
                      'fedex-zone-8': 134.34,
                      'fedex-zone-9': 467.67,
                      'fedex-zone-14': 88.15,
                      'fedex-zone-17': 467.67,
                      'fedex-zone-22': 104.39,
                      'fedex-zone-23': 203.37,
                      'fedex-zone-25': 217.2,
                      'fedex-zone-51': 145.19,
                      'fedex-zone-54': 236.92,
                      'fedex-zone-92': 203.37,
                      'fedex-zone-96': 217.2,
                    },
                    '141': {
                      'fedex-zone-2': 91.39,
                      'fedex-zone-3': 92.09,
                      'fedex-zone-4': 98.2,
                      'fedex-zone-5': 99.18,
                      'fedex-zone-6': 109.31,
                      'fedex-zone-7': 118.57,
                      'fedex-zone-8': 134.35,
                      'fedex-zone-9': 469.99,
                      'fedex-zone-14': 89.98,
                      'fedex-zone-17': 469.99,
                      'fedex-zone-22': 105.42,
                      'fedex-zone-23': 203.39,
                      'fedex-zone-25': 218.27,
                      'fedex-zone-51': 147.91,
                      'fedex-zone-54': 244.86,
                      'fedex-zone-92': 203.39,
                      'fedex-zone-96': 218.27,
                    },
                    '142': {
                      'fedex-zone-2': 92.56,
                      'fedex-zone-3': 93.79,
                      'fedex-zone-4': 99.07,
                      'fedex-zone-5': 100.77,
                      'fedex-zone-6': 110.95,
                      'fedex-zone-7': 120.22,
                      'fedex-zone-8': 134.86,
                      'fedex-zone-9': 477.83,
                      'fedex-zone-14': 90.12,
                      'fedex-zone-17': 477.83,
                      'fedex-zone-22': 106.44,
                      'fedex-zone-23': 204.66,
                      'fedex-zone-25': 219.43,
                      'fedex-zone-51': 147.92,
                      'fedex-zone-54': 244.87,
                      'fedex-zone-92': 204.66,
                      'fedex-zone-96': 219.43,
                    },
                    '143': {
                      'fedex-zone-2': 92.57,
                      'fedex-zone-3': 93.8,
                      'fedex-zone-4': 99.08,
                      'fedex-zone-5': 100.78,
                      'fedex-zone-6': 110.96,
                      'fedex-zone-7': 120.23,
                      'fedex-zone-8': 134.87,
                      'fedex-zone-9': 481.07,
                      'fedex-zone-14': 92.04,
                      'fedex-zone-17': 481.07,
                      'fedex-zone-22': 106.53,
                      'fedex-zone-23': 205.91,
                      'fedex-zone-25': 220.51,
                      'fedex-zone-51': 147.93,
                      'fedex-zone-54': 244.89,
                      'fedex-zone-92': 205.91,
                      'fedex-zone-96': 220.51,
                    },
                    '144': {
                      'fedex-zone-2': 95.18,
                      'fedex-zone-3': 96.47,
                      'fedex-zone-4': 102.94,
                      'fedex-zone-5': 103.93,
                      'fedex-zone-6': 112.86,
                      'fedex-zone-7': 123.35,
                      'fedex-zone-8': 137.98,
                      'fedex-zone-9': 484.37,
                      'fedex-zone-14': 93.91,
                      'fedex-zone-17': 484.37,
                      'fedex-zone-22': 109.64,
                      'fedex-zone-23': 208.34,
                      'fedex-zone-25': 221.75,
                      'fedex-zone-51': 147.94,
                      'fedex-zone-54': 244.9,
                      'fedex-zone-92': 208.34,
                      'fedex-zone-96': 221.75,
                    },
                    '145': {
                      'fedex-zone-2': 95.5,
                      'fedex-zone-3': 98.36,
                      'fedex-zone-4': 102.95,
                      'fedex-zone-5': 104.15,
                      'fedex-zone-6': 114.54,
                      'fedex-zone-7': 124.64,
                      'fedex-zone-8': 138.86,
                      'fedex-zone-9': 484.38,
                      'fedex-zone-14': 93.92,
                      'fedex-zone-17': 484.38,
                      'fedex-zone-22': 109.67,
                      'fedex-zone-23': 208.35,
                      'fedex-zone-25': 222.96,
                      'fedex-zone-51': 147.97,
                      'fedex-zone-54': 247.28,
                      'fedex-zone-92': 208.35,
                      'fedex-zone-96': 222.96,
                    },
                    '146': {
                      'fedex-zone-2': 95.51,
                      'fedex-zone-3': 98.37,
                      'fedex-zone-4': 102.96,
                      'fedex-zone-5': 104.16,
                      'fedex-zone-6': 114.55,
                      'fedex-zone-7': 124.65,
                      'fedex-zone-8': 138.87,
                      'fedex-zone-9': 486.63,
                      'fedex-zone-14': 94.18,
                      'fedex-zone-17': 486.63,
                      'fedex-zone-22': 111.79,
                      'fedex-zone-23': 209.62,
                      'fedex-zone-25': 224.2,
                      'fedex-zone-51': 150.98,
                      'fedex-zone-54': 252.32,
                      'fedex-zone-92': 209.62,
                      'fedex-zone-96': 224.2,
                    },
                    '147': {
                      'fedex-zone-2': 96.83,
                      'fedex-zone-3': 98.4,
                      'fedex-zone-4': 103.78,
                      'fedex-zone-5': 105.0,
                      'fedex-zone-6': 115.37,
                      'fedex-zone-7': 124.67,
                      'fedex-zone-8': 139.82,
                      'fedex-zone-9': 494.7,
                      'fedex-zone-14': 95.18,
                      'fedex-zone-17': 494.7,
                      'fedex-zone-22': 111.8,
                      'fedex-zone-23': 210.87,
                      'fedex-zone-25': 225.44,
                      'fedex-zone-51': 150.99,
                      'fedex-zone-54': 252.34,
                      'fedex-zone-92': 210.87,
                      'fedex-zone-96': 225.44,
                    },
                    '148': {
                      'fedex-zone-2': 97.27,
                      'fedex-zone-3': 99.12,
                      'fedex-zone-4': 104.89,
                      'fedex-zone-5': 105.89,
                      'fedex-zone-6': 116.83,
                      'fedex-zone-7': 125.49,
                      'fedex-zone-8': 141.9,
                      'fedex-zone-9': 498.23,
                      'fedex-zone-14': 96.15,
                      'fedex-zone-17': 498.23,
                      'fedex-zone-22': 112.87,
                      'fedex-zone-23': 213.39,
                      'fedex-zone-25': 226.63,
                      'fedex-zone-51': 151.0,
                      'fedex-zone-54': 252.35,
                      'fedex-zone-92': 213.39,
                      'fedex-zone-96': 226.63,
                    },
                    '149': {
                      'fedex-zone-2': 97.28,
                      'fedex-zone-3': 99.93,
                      'fedex-zone-4': 105.64,
                      'fedex-zone-5': 106.66,
                      'fedex-zone-6': 116.84,
                      'fedex-zone-7': 125.97,
                      'fedex-zone-8': 141.91,
                      'fedex-zone-9': 499.29,
                      'fedex-zone-14': 98.18,
                      'fedex-zone-17': 499.29,
                      'fedex-zone-22': 113.86,
                      'fedex-zone-23': 213.4,
                      'fedex-zone-25': 227.9,
                      'fedex-zone-51': 151.01,
                      'fedex-zone-54': 252.37,
                      'fedex-zone-92': 213.4,
                      'fedex-zone-96': 227.9,
                    },
                    '150': {
                      'fedex-zone-2': 97.29,
                      'fedex-zone-3': 99.94,
                      'fedex-zone-4': 106.35,
                      'fedex-zone-5': 109.19,
                      'fedex-zone-6': 116.85,
                      'fedex-zone-7': 125.98,
                      'fedex-zone-8': 141.92,
                      'fedex-zone-9': 502.71,
                      'fedex-zone-14': 98.19,
                      'fedex-zone-17': 502.71,
                      'fedex-zone-22': 113.87,
                      'fedex-zone-23': 214.63,
                      'fedex-zone-25': 229.11,
                      'fedex-zone-51': 151.02,
                      'fedex-zone-54': 252.38,
                      'fedex-zone-92': 214.63,
                      'fedex-zone-96': 229.11,
                    },
                  },
                },
                startDateTime: '2022-05-06T19:11:58.801Z',
              },
            ],
            tagIds: [],
            urn: 'urn:carrierrate:b6d3564c-5895-4e3a-ae67-35552b395aa6:3',
          },
          tags: [],
        },
      ],
      carrierSettings: {
        carrierSettings: {
          active: true,
          allowLabelGenerationFailover: false,
          archived: false,
          auditInfo: {
            createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
            creationTimeStamp: '2022-05-06T19:07:42.64Z',
            lastUpdatedBy: '08baad8e-db11-4932-918d-99c74a8e5639',
            lastUpdatedTimeStamp: '2022-05-10T01:30:17.684Z',
            version: 2,
          },
          carrierId: 'fedex',
          carrierSettingsId: '56f8a51a-8339-4a3a-9dd2-a6ab01490db8',
          description: 'Andy Test Account',
          expectedShippingVolumeOveragePercentage: 0.0,
          hazmatLimitedQuantityExempt: false,
          name: 'FedEx Settings',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          peakSurchargeEligible: true,
          tagIds: [],
          urn: 'urn:carrierSettings:56f8a51a-8339-4a3a-9dd2-a6ab01490db8:2',
        },
        tags: [],
      },
      contract: {
        active: true,
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2023-01-24T14:21:46.877Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2023-01-24T14:21:47.441Z',
          version: 4,
        },
        carrierAccountId: 'aba032c9-16ac-4b6b-8223-ea2738b29502',
        carrierId: 'fedex',
        carrierRateSetId: '2d41764f-8893-46f7-a2c3-2278a232d826',
        carrierSettingsId: '56f8a51a-8339-4a3a-9dd2-a6ab01490db8',
        contractId: '493ae0c8-6fa7-4398-ac1b-22d4ea16e0c6',
        description: '',
        name: 'Stord/Fur - FedEx Contract (BDL1)',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        tagIds: [],
        urn: 'urn:contract:493ae0c8-6fa7-4398-ac1b-22d4ea16e0c6:4',
      },
      tags: [],
    },
  ],
  fulfillmentContext: {
    active: true,
    archived: false,
    auditInfo: {
      createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      creationTimeStamp: '2022-10-25T21:49:14.039Z',
      lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
      lastUpdatedTimeStamp: '2023-03-01T21:23:58.012Z',
      version: 15,
    },
    contractIds: [
      '9b3c05e1-f6c1-488c-9e41-4a27011f4789',
      '5e3ea3e5-fe7c-46ed-9734-c8bfb7d4cfdc',
      'eed81b0d-99cc-4db9-8695-dac2c8a45bf6',
      '7287c628-b240-4ac7-ae03-3e9410c9a529',
      '9879fda6-5ab2-486e-809e-c963e11f7d1f',
      '493ae0c8-6fa7-4398-ac1b-22d4ea16e0c6',
    ],
    description: '',
    fulfillmentContextId: '1b28d2ad-c572-4715-93bd-c3e98578b64f',
    fulfillmentType: 'customer',
    injectionMethodIds: [],
    labelPropertiesId: '6d83783b-093c-450b-afb9-1371c16bbdbe',
    name: 'Fur (BDL1)',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    tagIds: ['8eb4d3d1-c295-4011-9e03-de948ddfa6a4'],
    urn: 'urn:fulfillmentContext:1b28d2ad-c572-4715-93bd-c3e98578b64f:15',
  },
  injectionMethods: [],
  labelProperties: {
    labelProperties: {
      active: true,
      archived: false,
      auditInfo: {
        createdBy: '806f3730-0025-45b7-a02e-f774e9400de0',
        creationTimeStamp: '2022-08-30T18:17:22.013Z',
        lastUpdatedBy: '806f3730-0025-45b7-a02e-f774e9400de0',
        lastUpdatedTimeStamp: '2022-08-30T18:17:22.013Z',
        version: 1,
      },
      description: '',
      dpi: 203,
      height: 6.0,
      labelOrientation: 'rotate_0',
      labelPropertiesId: '6d83783b-093c-450b-afb9-1371c16bbdbe',
      linearUnits: 'in',
      name: '203 DPI Resolution Labels',
      partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
      tagIds: [],
      urn: 'urn:labelProperties:6d83783b-093c-450b-afb9-1371c16bbdbe:1',
      width: 4.0,
    },
    tags: [],
  },
  matchInfo: {
    fulfillmentContextId: '1b28d2ad-c572-4715-93bd-c3e98578b64f',
    matchInformation: [
      'direct match on partnerId:fulfillmentContextId -> a4080bc4-5ab4-46f2-b2b2-f7a64379d09f:1b28d2ad-c572-4715-93bd-c3e98578b64f',
      'asOfDateTime used for fctx detail hydration: 2023-03-06T23:47:10.948Z',
    ],
    matchParams: {
      asOfDateTime: '2023-03-06T23:47:10.948Z',
      fulfillmentContextId: '1b28d2ad-c572-4715-93bd-c3e98578b64f',
      partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
      tags: [],
      tenantId: '11c7cb50-5b4f-4920-8821-a82883573ea6',
    },
    matchTenantId: '11c7cb50-5b4f-4920-8821-a82883573ea6',
    matchTenantPartnerProvidedId: '7c2bedc6-d011-47a3-a3bd-ddd434a284e2',
    matchType: 'direct_request',
    name: 'Fur (BDL1)',
    partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
    urn: 'urn:fulfillmentContext:1b28d2ad-c572-4715-93bd-c3e98578b64f:15',
  },
  origins: [
    {
      address: {
        address: {
          active: true,
          addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-06-09T16:52:57.568Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2022-06-09T16:52:57.568Z',
            version: 1,
          },
          description: ' ',
          location: {
            address1: '297 State Street',
            address2: 'Building 1',
            city: 'North Haven',
            companyName: 'Stord BDL1',
            country: 'US',
            postalCode: '06473',
            region: 'CT',
            validatedAddressMetadata: {
              latitude: 41.38069,
              longitude: -72.85601,
              timeZoneId: 'America/New_York',
            },
          },
          name: 'Stord BDL1',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          tagIds: [],
          urn: 'urn:address:d317a578-99d6-429a-b26d-cac286f9ae95:1',
        },
        tags: [],
      },
      contact: {
        contact: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-08-18T21:27:15.945Z',
            lastUpdatedBy: '08baad8e-db11-4932-918d-99c74a8e5639',
            lastUpdatedTimeStamp: '2022-09-14T22:42:38.857Z',
            version: 2,
          },
          contactId: 'd13e3ebb-aa48-41a0-9980-b0cc2dca23d7',
          contactName: 'Shipping Department',
          description: 'configured for the return address',
          email: 'operations@stord.com',
          name: 'Shipping Department',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          phoneNumber: '8337002025',
          tagIds: [],
          urn: 'urn:contact:d13e3ebb-aa48-41a0-9980-b0cc2dca23d7:2',
        },
        tags: [],
      },
      origin: {
        active: true,
        addressId: 'd317a578-99d6-429a-b26d-cac286f9ae95',
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2022-06-09T16:53:59.868Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-08-18T21:27:27.58Z',
          version: 6,
        },
        contactId: 'd13e3ebb-aa48-41a0-9980-b0cc2dca23d7',
        description: ' ',
        name: 'Stord BDL1',
        originId: '4f011f79-8478-40bb-b2d3-f860c8a10512',
        originType: 'fc',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        scheduleId: '2e871fc5-856d-41da-9a77-7ae1fdfc18b1',
        tagIds: [],
        urn: 'urn:origin:4f011f79-8478-40bb-b2d3-f860c8a10512:6',
      },
      schedule: {
        schedule: {
          active: true,
          archived: false,
          auditInfo: {
            createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            creationTimeStamp: '2022-06-09T16:50:19.632Z',
            lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
            lastUpdatedTimeStamp: '2022-06-09T16:50:19.632Z',
            version: 1,
          },
          description: '',
          entries: [
            {
              carrierSchedules: [],
              from: '2022-06-09T16:48:35.964Z',
              holidays: [
                {
                  date: '2022-01-01',
                  metadata: {
                    name: "New Year's Day",
                  },
                },
                {
                  date: '2022-01-17',
                  metadata: {
                    name: 'Martin Luther King Jr. Day',
                  },
                },
                {
                  date: '2022-04-17',
                  metadata: {
                    name: 'Easter Sunday',
                  },
                },
                {
                  date: '2022-10-10',
                  metadata: {
                    name: 'Columbus Day',
                  },
                },
                {
                  date: '2022-11-11',
                  metadata: {
                    name: 'Veterans Day',
                  },
                },
                {
                  date: '2023-02-20',
                  metadata: {
                    name: "President's Day",
                  },
                },
              ],
              processingCutoff: {
                expectedDaysToShip: 0,
                expectedDaysAndTimeToShip: 0,
                shippingCutoffHour: 14,
                weekendCutoffHour: 12,
              },
              scheduleEntryId: '7e36a89d-141c-45fb-85fc-247725015f60',
              shippingDays: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
              to: '2041-06-09T16:48:35.964Z',
            },
          ],
          name: 'Stord ALT1',
          partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
          scheduleId: '2e871fc5-856d-41da-9a77-7ae1fdfc18b1',
          tagIds: [],
          urn: 'urn:schedule:2e871fc5-856d-41da-9a77-7ae1fdfc18b1:1',
        },
        tags: [],
      },
      tags: [],
    },
  ],
  packaging: [],
  tags: [
    {
      active: true,
      archived: false,
      auditInfo: {
        createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
        creationTimeStamp: '2022-10-07T15:33:47.992Z',
        lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
        lastUpdatedTimeStamp: '2022-10-07T15:33:47.992Z',
        version: 1,
      },
      description: 'Fur Tenant ID/Stord Network ID',
      name: 'Fur ',
      partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
      tag: '7c2bedc6-d011-47a3-a3bd-ddd434a284e2',
      tagId: '8eb4d3d1-c295-4011-9e03-de948ddfa6a4',
      urn: 'urn:tag:8eb4d3d1-c295-4011-9e03-de948ddfa6a4:1',
    },
  ],
  tenant: {
    originInfoDetailMap: {},
    tags: [],
    tenant: {
      active: true,
      archived: false,
      auditInfo: {
        createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
        creationTimeStamp: '2022-10-07T15:35:42.503Z',
        lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
        lastUpdatedTimeStamp: '2023-03-01T21:24:46.603Z',
        version: 7,
      },
      description: 'n/a',
      links: {
        fulfillmentContexts: [
          {
            shipiumId: '588cd660-e340-4946-a770-19e6a9533055',
          },
          {
            shipiumId: '1b28d2ad-c572-4715-93bd-c3e98578b64f',
          },
        ],
      },
      name: 'Fur',
      originInfoMap: {},
      partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
      partnerProvidedId: '7c2bedc6-d011-47a3-a3bd-ddd434a284e2',
      tagIds: [],
      taxIdentificationNumber: '46-5356866',
      tenantId: '11c7cb50-5b4f-4920-8821-a82883573ea6',
      unitedStatesPrincipalPartyInInterestAddressId: 'a2c7663d-fe3e-488f-8847-fd6f9489b46a',
      unitedStatesPrincipalPartyInInterestContactId: '900ae450-da15-4588-8655-b427e62ccfb1',
      urn: 'urn:tenant:11c7cb50-5b4f-4920-8821-a82883573ea6:7',
    },
    unitedStatesPrincipalPartyInInterestAddress: {
      address: {
        active: true,
        addressId: 'a2c7663d-fe3e-488f-8847-fd6f9489b46a',
        archived: false,
        auditInfo: {
          createdBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          creationTimeStamp: '2022-10-07T16:45:56.211Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-10-07T16:45:56.211Z',
          version: 1,
        },
        description: 'Fur Main Office address',
        location: {
          address1: '5 West 19th Street',
          address2: '3rd Floor, Suite C',
          city: 'New York',
          companyName: 'Fur',
          country: 'US',
          postalCode: '10011',
          region: 'NY',
          validatedAddressMetadata: {
            latitude: 40.74187,
            longitude: -74.00052,
            timeZoneId: 'America/New_York',
          },
        },
        name: 'Fur',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        tagIds: [],
        urn: 'urn:address:a2c7663d-fe3e-488f-8847-fd6f9489b46a:1',
      },
      tags: [],
    },
    unitedStatesPrincipalPartyInInterestContact: {
      contact: {
        active: true,
        archived: false,
        auditInfo: {
          createdBy: '08baad8e-db11-4932-918d-99c74a8e5639',
          creationTimeStamp: '2022-05-10T01:13:39.191Z',
          lastUpdatedBy: '7ad512fe-6d76-42b7-8d6f-3424154a073c',
          lastUpdatedTimeStamp: '2022-09-14T23:44:14.372Z',
          version: 7,
        },
        contactId: '900ae450-da15-4588-8655-b427e62ccfb1',
        contactName: 'Shipping Department ',
        description: '',
        email: 'sales@stord.com',
        name: 'Shipping Department ',
        partnerId: 'a4080bc4-5ab4-46f2-b2b2-f7a64379d09f',
        phoneNumber: '8337002025',
        tagIds: [],
        urn: 'urn:contact:900ae450-da15-4588-8655-b427e62ccfb1:7',
      },
      tags: [],
    },
  },
};
